import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import styled, { css, keyframes } from 'styled-components';
import React__default, { createContext, forwardRef, useRef, useState, useCallback, useMemo, useEffect, useContext, useLayoutEffect, createElement } from 'react';
import $k7QOs$reactdom from 'react-dom';
import { Link as Link$1 } from 'react-router-dom';
import require$$0 from 'crypto';

var Colors;
(function (Colors) {
    Colors["Electric100"] = "#ECEEFF";
    Colors["Electric200"] = "#DCE0FF";
    Colors["Electric300"] = "#C4C9FF";
    Colors["Electric400"] = "#A1A8FF";
    Colors["Electric500"] = "#808AFF";
    Colors["Electric600"] = "#6673FF";
    Colors["Electric700"] = "#4C48EF";
    Colors["ElectricBrand"] = "#3B2FC9";
    Colors["Electric900"] = "#0C009D";
    Colors["Midnight100"] = "#C2C3E9";
    Colors["Midnight200"] = "#9698D0";
    Colors["Midnight300"] = "#6668A1";
    Colors["Midnight400"] = "#54568F";
    Colors["Midnight500"] = "#3D3F7A";
    Colors["Midnight600"] = "#2E3168";
    Colors["Midnight700"] = "#1D1F4A";
    Colors["Midnight800"] = "#111338";
    Colors["MidnightBrand"] = "#090B2B";
    Colors["Pigeon100"] = "#F6F8FC";
    Colors["Pigeon200"] = "#E8EDF4";
    Colors["Pigeon300"] = "#D7DEE8";
    Colors["Pigeon400"] = "#CAD0DC";
    Colors["Pigeon500"] = "#B4BCCC";
    Colors["Pigeon600"] = "#8B93A4";
    Colors["Pigeon700"] = "#616A7D";
    Colors["Pigeon800"] = "#404857";
    Colors["Pigeon900"] = "#303744";
    Colors["Sky100"] = "#D4EAFF";
    Colors["Sky200"] = "#B9DCFF";
    Colors["Sky300"] = "#94C9FF";
    Colors["Sky400"] = "#73B2F0";
    Colors["Sky500"] = "#54A0EA";
    Colors["Sky600"] = "#2473D1";
    Colors["Sky700"] = "#034EB9";
    Colors["Sky800"] = "#003D95";
    Colors["Sky900"] = "#002E70";
    Colors["Pinata100"] = "#FFE9E8";
    Colors["Pinata200"] = "#FFDDDB";
    Colors["Pinata300"] = "#FFD1CF";
    Colors["Pinata400"] = "#FFBEBB";
    Colors["Pinata500"] = "#FFB1A9";
    Colors["Pinata600"] = "#FFA197";
    Colors["Pinata700"] = "#FF8D77";
    Colors["Pinata800"] = "#FD7F67";
    Colors["Pinata900"] = "#D64B32";
    Colors["Sunflower100"] = "#FFFAED";
    Colors["Sunflower200"] = "#FFF5D9";
    Colors["Sunflower300"] = "#FFEFC2";
    Colors["Sunflower400"] = "#FFE9AD";
    Colors["Sunflower500"] = "#FFE396";
    Colors["Sunflower600"] = "#FFDD81";
    Colors["Sunflower700"] = "#FFD86E";
    Colors["Sunflower800"] = "#FFD152";
    Colors["Sunflower900"] = "#D96A00";
    Colors["Nectar100"] = "#FFF9F5";
    Colors["Nectar200"] = "#FFF5ED";
    Colors["Nectar300"] = "#FFF0E3";
    Colors["Nectar400"] = "#FFE4CC";
    Colors["Nectar500"] = "#FFDCBD";
    Colors["Nectar600"] = "#FFD9B7";
    Colors["Nectar700"] = "#FBCCA2";
    Colors["Nectar800"] = "#F9C493";
    Colors["Nectar900"] = "#F6BA83";
    Colors["Jade100"] = "#E9F5EE";
    Colors["Jade200"] = "#C7F1DF";
    Colors["Jade300"] = "#B6E7D2";
    Colors["Jade400"] = "#A2E4C7";
    Colors["Jade500"] = "#80DDB4";
    Colors["Jade600"] = "#6FD0A6";
    Colors["Jade700"] = "#6FD0A6";
    Colors["Jade800"] = "#3DB983";
    Colors["Jade900"] = "#32A673";
    Colors["White"] = "#FFFFFF";
    Colors["SuccessStrong"] = "#009F42";
    Colors["DarkBlue"] = "#08415C";
    Colors["LightBlue"] = "#E7EDEF";
    Colors["Pink"] = "#C04ABC";
    Colors["LightPink"] = "#F9EDF9";
    Colors["Brown"] = "#6D435A";
    Colors["LightBrown"] = "rgba(109, 67, 90, 0.10)";
    Colors["Indigo"] = "#414073";
    Colors["LightIndigo"] = "#EEF8F7";
    Colors["Purple"] = "#642CA9";
    Colors["LightPurple"] = "#F0EAF7";
    Colors["Transparent"] = "transparent";
})(Colors || (Colors = {}));
var Colors$1 = Colors;

const baseSvgProps = {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '24',
    height: '24',
    fill: 'none',
    viewBox: '0 0 24 24',
    role: 'img',
};
const Icons = {
    add: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.799 3.276c-.212.043-.39.165-.468.322-.066.132-.072.4-.082 3.891l-.011 3.749-3.749.011-3.749.011-.169.097c-.221.126-.308.308-.31.643-.001.332.101.542.322.657.155.082.206.083 3.906.094l3.749.011.011 3.749c.011 3.7.012 3.751.094 3.906.115.22.325.323.657.323s.542-.103.657-.323c.082-.155.083-.206.094-3.906l.011-3.749 3.749-.011c3.7-.011 3.751-.012 3.906-.094.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643l-.169-.097-3.749-.011-3.749-.011-.011-3.749c-.01-3.507-.016-3.758-.082-3.892-.123-.246-.516-.391-.87-.321' }) })),
    alertCircle: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.32 2.28A9.74 9.74 0 003.258 7.7c-.46.94-.762 1.914-.924 2.98-.097.636-.097 2.004 0 2.64.446 2.941 2.052 5.409 4.533 6.968 1.075.676 2.441 1.17 3.813 1.378.636.097 2.004.097 2.64 0 2.1-.319 3.932-1.206 5.405-2.618 1.601-1.534 2.6-3.479 2.941-5.728.097-.636.097-2.004 0-2.64-.443-2.919-2.04-5.389-4.49-6.941-.824-.522-2.118-1.053-3.056-1.253a10.872 10.872 0 00-2.8-.206m2 1.578a8.277 8.277 0 014.628 2.435c1.176 1.231 1.913 2.713 2.2 4.423.1.593.1 1.975 0 2.568-.612 3.649-3.463 6.426-7.08 6.895-3.771.489-7.369-1.653-8.767-5.219a9.164 9.164 0 01-.449-1.676c-.1-.593-.1-1.975 0-2.568.299-1.783 1.066-3.282 2.324-4.54 1.389-1.388 2.977-2.138 5.064-2.391.313-.038 1.715.011 2.08.073m-1.521 3.418c-.212.043-.39.165-.468.322-.065.131-.071.322-.071 2.402 0 2.206.002 2.264.083 2.417.115.22.325.323.657.323s.542-.103.657-.323c.081-.153.083-.211.083-2.417 0-2.09-.005-2.271-.071-2.403-.123-.246-.516-.391-.87-.321m0 8c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298' }) })),
    alertTriangle: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.623 2.287c-.736.083-1.504.565-1.92 1.204-.226.349-7.029 12.154-7.13 12.374a2.748 2.748 0 00.965 3.408c.349.234.647.355 1.062.43.444.08 14.356.08 14.8 0a2.74 2.74 0 002.146-1.882 2.738 2.738 0 00-.119-1.956c-.121-.263-6.946-12.086-7.161-12.405-.584-.866-1.553-1.296-2.643-1.173m.903 1.582c.102.046.255.153.34.239.101.102 1.36 2.246 3.664 6.238 1.93 3.345 3.536 6.147 3.57 6.227.035.084.06.267.06.439 0 .486-.242.878-.691 1.118l-.169.09H4.7l-.169-.09a1.242 1.242 0 01-.569-.579c-.104-.208-.122-.288-.121-.547 0-.207.024-.355.074-.464.075-.165 6.677-11.618 6.989-12.125.197-.321.382-.48.676-.586.259-.092.687-.074.946.04m-.727 4.407c-.212.043-.39.165-.468.322-.063.127-.071.278-.071 1.402 0 1.196.004 1.268.083 1.417.115.22.325.323.657.323s.542-.103.657-.323c.079-.149.083-.221.083-1.417 0-1.13-.007-1.275-.071-1.403-.123-.246-.516-.391-.87-.321m0 6c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298' }) })),
    arrowLeft: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M9.76 4.263c-.09.039-1.403 1.319-3.681 3.589a720.538 720.538 0 01-3.643 3.615.872.872 0 00-.177.31c-.074.219-.074.227.001.449a.865.865 0 00.195.33 709.79 709.79 0 013.662 3.631c3.888 3.869 3.681 3.686 4.048 3.576.218-.065.533-.38.598-.598.11-.365.239-.216-2.995-3.455l-2.946-2.949 8.219-.011c8.217-.01 8.219-.01 8.376-.093.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643l-.169-.097-8.219-.011-8.219-.01 2.946-2.95c3.218-3.222 3.104-3.091 2.999-3.441-.091-.305-.503-.651-.77-.646a.766.766 0 00-.237.061' }) })),
    arrowRight: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M13.729 4.285c-.209.103-.435.36-.496.563-.105.35-.219.219 2.999 3.441l2.946 2.95-8.219.01-8.219.011-.169.097c-.221.126-.308.308-.31.643-.001.332.101.542.322.657.157.083.159.083 8.376.093l8.219.011-2.946 2.949c-3.234 3.239-3.105 3.09-2.995 3.455.065.218.38.533.598.598.367.11.16.293 4.048-3.576a709.79 709.79 0 013.662-3.631.865.865 0 00.195-.33c.075-.222.075-.23.001-.449a.872.872 0 00-.177-.31 720.538 720.538 0 01-3.643-3.615c-2.478-2.47-3.586-3.547-3.69-3.59-.198-.083-.298-.078-.502.023' }) })),
    arrowRotateLeft: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5.25 11C4.8125 11 4.5 10.6875 4.5 10.25V5.75C4.5 5.34375 4.8125 5 5.25 5C5.65625 5 6 5.34375 6 5.75V8.28125L6.625 7.53125C7.90625 6 9.8125 5 12 5C15.8438 5 19 8.15625 19 12C19 15.875 15.8438 19 12 19C10.4062 19 8.96875 18.5 7.78125 17.625C7.46875 17.375 7.375 16.9062 7.625 16.5625C7.875 16.2188 8.34375 16.1562 8.6875 16.4062C9.59375 17.0938 10.75 17.5 12 17.5C15.0312 17.5 17.5 15.0625 17.5 12C17.5 8.96875 15.0312 6.5 12 6.5C10.2812 6.5 8.78125 7.28125 7.75 8.5L6.90625 9.5H9.75C10.1562 9.5 10.5 9.84375 10.5 10.25C10.5 10.6875 10.1562 11 9.75 11H5.25Z' }) })),
    arrowProgress: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M18.75 6C18.75 5.59375 18.4062 5.25 18 5.25C17.5625 5.25 17.25 5.59375 17.25 6C17.25 6.4375 17.5625 6.75 18 6.75C18.4062 6.75 18.75 6.4375 18.75 6ZM16 6C16 5.3125 16.375 4.65625 17 4.28125C17.5938 3.9375 18.375 3.9375 19 4.28125C19.5938 4.65625 20 5.3125 20 6C20 6.71875 19.5938 7.375 19 7.75C18.375 8.09375 17.5938 8.09375 17 7.75C16.375 7.375 16 6.71875 16 6ZM4 9C4 6.9375 5.65625 5.25 7.75 5.25H12V4.5625C12 4.25 12.25 4 12.5312 4C12.6562 4 12.7812 4.0625 12.875 4.125L14.7812 5.625C14.9062 5.71875 15 5.84375 15 6C15 6.15625 14.9062 6.3125 14.7812 6.40625L12.875 7.90625C12.7812 7.96875 12.6562 8 12.5312 8C12.25 8 12 7.75 12 7.46875V6.75H7.75C6.5 6.75 5.5 7.78125 5.5 9C5.5 10.25 6.5 11.25 7.75 11.25H16.25C18.3125 11.25 20 12.9375 20 15C20 16.875 18.625 18.4062 16.875 18.7188C16.5625 19.4688 15.8438 20 15 20C13.875 20 13 19.125 13 18C13 16.9062 13.875 16 15 16C15.7812 16 16.5 16.5 16.8125 17.1875C17.7812 16.9375 18.5 16.0625 18.5 15C18.5 13.7812 17.4688 12.75 16.25 12.75H7.75C5.65625 12.75 4 11.0938 4 9ZM7.84375 17.25H9V16.5625C9 16.25 9.25 16 9.53125 16C9.65625 16 9.78125 16.0625 9.875 16.125L11.7812 17.625C11.9062 17.7188 12 17.8438 12 18C12 18.1562 11.9062 18.3125 11.7812 18.4062L9.875 19.9062C9.78125 19.9688 9.65625 20 9.53125 20C9.25 20 9 19.75 9 19.4688V18.75H7.84375C7.53125 19.5 6.8125 20 6 20C4.875 20 4 19.125 4 18C4 16.9062 4.875 16 6 16C6.8125 16 7.53125 16.5312 7.84375 17.25ZM6.75 18C6.75 17.5938 6.40625 17.25 6 17.25C5.5625 17.25 5.25 17.5938 5.25 18C5.25 18.4375 5.5625 18.75 6 18.75C6.40625 18.75 6.75 18.4375 6.75 18ZM15 18.75C15.4062 18.75 15.75 18.4375 15.75 18C15.75 17.5938 15.4062 17.25 15 17.25C14.5625 17.25 14.25 17.5938 14.25 18C14.25 18.4375 14.5625 18.75 15 18.75Z' }) })),
    arrowUpRight: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M14.62 4.239l-4.28.021-.169.097c-.221.126-.308.308-.31.643-.001.332.101.542.322.657.155.082.21.083 3.576.094l3.419.011-6.446 6.449c-7.071 7.075-6.608 6.579-6.495 6.954.065.218.38.533.598.598.375.113-.121.576 6.955-6.496l6.45-6.446v3.332c0 2.349.013 3.385.045 3.512.063.248.225.398.495.459.455.101.841-.087.934-.455.03-.122.045-1.493.047-4.518l.004-4.342-.086-.183c-.073-.154-.126-.203-.329-.305-.134-.066-.289-.117-.346-.112-.057.005-2.03.019-4.384.03' }) })),
    arrowsMaximize: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M3.634 3.331c-.188.093-.241.143-.315.299-.087.187-.088.198-.081 2.329.004 1.382.021 2.202.049 2.313.092.365.48.553.933.452.27-.061.432-.211.495-.459.028-.113.045-.602.045-1.312V5.822l1.95 1.945c2.145 2.14 2.099 2.103 2.455 1.996.218-.065.533-.38.598-.598.107-.356.144-.311-1.993-2.453L5.826 4.764l1.217-.012c1.139-.011 1.227-.017 1.374-.095.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643-.187-.108.074-.098-3.369-.127l-1.2-.01-.226.111m14.186-.092-2.08.021-.169.097c-.221.126-.308.308-.31.643-.001.332.101.542.322.657.147.078.235.084 1.374.095l1.217.012-1.944 1.948c-2.137 2.142-2.1 2.097-1.993 2.453.065.218.38.533.598.598.356.107.31.144 2.455-1.996l1.95-1.945v1.131c0 .71.017 1.199.045 1.312.063.248.225.398.495.459.453.101.841-.087.933-.452.028-.111.045-.931.049-2.313.007-2.131.006-2.142-.081-2.329-.075-.158-.127-.207-.331-.309-.134-.066-.289-.117-.346-.112-.057.004-1.04.018-2.184.03M8.76 14.263c-.088.038-.855.775-2.068 1.986l-1.928 1.925-.012-1.217c-.014-1.384-.023-1.43-.319-1.596-.232-.13-.634-.13-.866 0-.314.177-.304.099-.327 2.559-.022 2.379-.019 2.413.204 2.636.223.223.257.226 2.636.204 2.105-.019 2.185-.023 2.337-.103.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643-.167-.096-.184-.097-1.385-.11l-1.216-.013 1.942-1.947c2.124-2.129 2.099-2.098 1.997-2.439-.091-.305-.503-.651-.77-.646a.766.766 0 0 0-.237.061m5.969.022c-.209.103-.435.36-.496.563-.102.341-.127.31 1.997 2.439l1.942 1.947-1.216.013c-1.201.013-1.218.014-1.385.11-.221.126-.308.308-.31.643-.001.332.101.542.322.657.152.08.232.084 2.337.103 2.379.022 2.413.019 2.636-.204.223-.223.226-.257.204-2.636-.023-2.46-.013-2.382-.327-2.559-.232-.13-.634-.13-.866 0-.296.166-.305.212-.319 1.596l-.012 1.217-1.928-1.925c-1.913-1.911-2.07-2.049-2.317-2.049a.8.8 0 0 0-.262.085' }) })),
    at: (domProps) => (jsx("svg", { ...baseSvgProps, viewBox: '0 0 16 16', ...domProps, children: jsx("path", { d: 'M8 1.5C4.40625 1.5 1.5 4.4375 1.5 8C1.5 11.5938 4.40625 14.5 8 14.5C8.40625 14.5 8.75 14.8438 8.75 15.25C8.75 15.6875 8.40625 16 8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 8 0C12.4062 0 16 3.59375 16 8V8.875C16 10.4688 14.6875 11.75 13.125 11.75C12.125 11.75 11.2812 11.2812 10.75 10.5312C10.0625 11.2812 9.09375 11.75 8 11.75C5.90625 11.75 4.25 10.0938 4.25 8C4.25 5.9375 5.90625 4.25 8 4.25C8.875 4.25 9.71875 4.59375 10.3438 5.09375C10.5 4.90625 10.7188 4.75 11 4.75C11.4062 4.75 11.75 5.09375 11.75 5.5V8V8.875C11.75 9.65625 12.3438 10.25 13.125 10.25C13.875 10.25 14.5 9.65625 14.5 8.875V8C14.5 4.4375 11.5625 1.5 8 1.5ZM10.25 8C10.25 7.21875 9.8125 6.46875 9.125 6.0625C8.40625 5.65625 7.5625 5.65625 6.875 6.0625C6.15625 6.46875 5.75 7.21875 5.75 8C5.75 8.8125 6.15625 9.5625 6.875 9.96875C7.5625 10.375 8.40625 10.375 9.125 9.96875C9.8125 9.5625 10.25 8.8125 10.25 8Z', fill: '#616A7D' }) })),
    ban: (domProps) => (jsx("svg", { color: 'white', stroke: 'var(--color-danger)', ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604M18.364 18.364C14.8492 21.8787 9.15076 21.8787 5.63604 18.364C2.12132 14.8492 2.12132 9.15076 5.63604 5.63604M18.364 18.364L5.63604 5.63604', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })),
    boxLogo: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, viewBox: '0 0 64 64', height: '24', width: '24', children: jsx("path", { d: 'M32.898 43.9c-3.92.02-7.118-3.133-7.138-7.052-.03-3.92 3.127-7.113 7.05-7.137 3.92-.03 7.116 3.127 7.143 7.046s-3.13 7.12-7.053 7.143m-20.9.133c-3.922.027-7.12-3.13-7.142-7.046-.027-3.922 3.13-7.12 7.053-7.143a7.1 7.1 0 0 1 7.141 7.046 7.1 7.1 0 0 1-7.052 7.143m20.78-19.06c-4.533.032-8.447 2.605-10.41 6.353-2.013-3.727-5.96-6.25-10.488-6.218-2.56.01-5.047.856-7.084 2.408l-.064-9.962a2.37 2.37 0 0 0-2.384-2.304 2.36 2.36 0 0 0-2.346 2.333L.118 37.2h.006a11.83 11.83 0 0 0 11.9 11.56c4.528-.03 8.443-2.603 10.413-6.354 2.008 3.725 5.962 6.248 10.49 6.22 6.533-.04 11.795-5.373 11.755-11.907S39.3 24.92 32.774 24.962m30.73 19.747l-6.642-8.06 6.536-8.144c.8-1.045.563-2.502-.56-3.27-1.134-.765-2.718-.56-3.572.457v-.004l-5.648 7.03-5.733-6.95c-.87-1.008-2.46-1.196-3.575-.414-1.12.783-1.346 2.24-.52 3.282l6.636 8.055-6.537 8.14c-.81 1.05-.564 2.503.568 3.27 1.123.77 2.712.563 3.566-.455l5.643-7.026 5.74 6.954c.867 1.01 2.456 1.193 3.58.412 1.117-.79 1.34-2.24.52-3.28', fill: '#22a7f0' }) })),
    boxOpen: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M2.53125 7.9375L3.8125 5.34375C3.90625 5.15625 4.125 5.03125 4.34375 5.0625L12 6L9.375 10.3438C9.15625 10.75 8.6875 10.9375 8.25 10.8125L3.15625 9.34375C2.53125 9.1875 2.25 8.5 2.53125 7.9375ZM12 6L19.625 5.0625C19.8438 5.03125 20.0625 5.125 20.1562 5.34375L21.4375 7.9375C21.7188 8.5 21.4375 9.1875 20.8125 9.34375L15.7188 10.8125C15.2812 10.9375 14.8125 10.75 14.5938 10.3438L12 6ZM11.9375 8H12.0312H11.9375ZM18.5 11.0625L20 10.625V15.8438C20 16.5312 19.5312 17.125 18.8438 17.3125L12.4688 18.9062C12.1562 18.9688 11.8125 18.9688 11.5 18.9062L5.125 17.3125C4.46875 17.125 4 16.5312 4 15.8438V10.625L5.5 11.0625V15.8438L11.25 17.2812V9.75C11.25 9.34375 11.5625 9 12 9C12.4062 9 12.75 9.34375 12.75 9.75V17.2812L18.5 15.8438V11.0625Z' }) })),
    building: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M6.617 2.283c-.583.068-1.098.327-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32-.011 7.866-.01 7.865-.75.015c-.702.014-.76.021-.918.111-.221.126-.308.307-.31.643-.001.332.101.542.322.657l.157.083h18.52l.157-.083c.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.643-.158-.09-.216-.097-.918-.111l-.75-.015-.01-7.865L19.74 4.5l-.109-.32a2.742 2.742 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.424-.049-10.294-.046-10.712.002m10.911 1.59c.239.118.481.36.599.599l.093.188.01 7.79.011 7.79H14.76l-.001-2.17c0-2.317-.014-2.507-.202-2.875-.122-.24-.533-.634-.797-.765-.31-.153-.641-.188-1.76-.188s-1.45.035-1.76.188c-.264.131-.675.525-.797.765-.188.368-.202.558-.202 2.875l-.001 2.17H5.76v-7.735c0-8.483-.017-7.888.236-8.233.14-.19.38-.373.59-.45.13-.048.973-.056 5.454-.049l5.3.007.188.093M8.799 6.275c-.371.078-.536.3-.538.725-.001.332.101.542.322.657.143.075.227.083.917.083.69 0 .774-.008.917-.083.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.642-.157-.089-.216-.096-.829-.104-.363-.005-.723.004-.801.021m5 0c-.371.078-.536.3-.538.725-.001.332.101.542.322.657.143.075.227.083.917.083.69 0 .774-.008.917-.083.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.642-.157-.089-.216-.096-.829-.104-.363-.005-.723.004-.801.021m-5 4c-.371.078-.536.3-.538.725-.001.332.101.542.322.657.143.075.227.083.917.083.69 0 .774-.008.917-.083.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.642-.157-.089-.216-.096-.829-.104-.363-.005-.723.004-.801.021m5 0c-.371.078-.536.3-.538.725-.001.332.101.542.322.657.143.075.227.083.917.083.69 0 .774-.008.917-.083.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.642-.157-.089-.216-.096-.829-.104-.363-.005-.723.004-.801.021m-.632 5.551c.069.063.073.185.073 2.24v2.174h-2.48v-2.167c0-1.96.006-2.174.066-2.24.061-.067.152-.073 1.167-.073.968 0 1.11.008 1.174.066' }) })),
    chat: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.617 3.283c-.583.068-1.098.327-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32v9l.109.32c.151.445.362.783.695 1.116.334.334.673.545 1.116.694l.32.108 1.87.013 1.87.014v2.147c0 1.437.015 2.201.044 2.308.056.203.337.479.555.544.357.107.26.189 2.981-2.526l2.48-2.475 2.6-.012 2.6-.012.32-.108a2.743 2.743 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-9l-.109-.32a2.742 2.742 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.426-.049-14.293-.047-14.712.002m14.911 1.59c.239.118.481.36.599.599l.093.188v8.68l-.093.188a1.452 1.452 0 01-.607.608c-.176.082-.243.084-2.96.104-2.509.018-2.792.027-2.9.087-.066.037-.966.915-2 1.951L9.78 19.16l-.02-1.71c-.023-1.936-.019-1.915-.331-2.093l-.169-.097-2.3-.02c-2.229-.019-2.306-.023-2.48-.104a1.452 1.452 0 01-.607-.608l-.093-.188-.011-4.26c-.009-3.158 0-4.304.035-4.43.093-.34.433-.7.782-.828.131-.048 1.254-.056 7.454-.049l7.3.007.188.093M7.799 9.276c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.224 0 .31-.019.431-.094.219-.136.287-.289.287-.646 0-.349-.068-.511-.267-.632-.15-.091-.465-.135-.672-.092m4 0c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298m4 0c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298' }) })),
    checkmark: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M18.76 6.261c-.089.039-1.9 1.822-4.95 4.87l-4.809 4.808-1.831-1.826c-2.013-2.009-1.981-1.982-2.335-1.876-.218.065-.533.38-.598.598-.108.36-.168.288 2.236 2.692 1.899 1.898 2.209 2.193 2.357 2.236.38.111.004.457 5.661-5.196 3.697-3.694 5.175-5.196 5.235-5.32.104-.214.081-.401-.076-.625-.239-.34-.604-.488-.89-.361' }) })),
    checkmarkCircle: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.32 2.28A9.74 9.74 0 003.258 7.7c-.46.94-.762 1.914-.924 2.98-.097.636-.097 2.004 0 2.64.446 2.941 2.052 5.409 4.533 6.968 1.075.676 2.441 1.17 3.813 1.378.636.097 2.004.097 2.64 0 2.1-.319 3.932-1.206 5.405-2.618 1.601-1.534 2.6-3.479 2.941-5.728.097-.636.097-2.004 0-2.64-.443-2.919-2.04-5.389-4.49-6.941-.824-.522-2.118-1.053-3.056-1.253a10.872 10.872 0 00-2.8-.206m2 1.578a8.277 8.277 0 014.628 2.435c1.176 1.231 1.913 2.713 2.2 4.423.1.593.1 1.975 0 2.568-.612 3.649-3.463 6.426-7.08 6.895-3.771.489-7.369-1.653-8.767-5.219a9.164 9.164 0 01-.449-1.676c-.1-.593-.1-1.975 0-2.568.299-1.783 1.066-3.282 2.324-4.54 1.389-1.388 2.977-2.138 5.064-2.391.313-.038 1.715.011 2.08.073m1.44 5.403c-.085.038-.851.773-1.949 1.869l-1.81 1.807-.83-.824c-.924-.917-1.011-.974-1.336-.876-.218.065-.533.38-.598.598-.103.342-.075.38 1.236 1.692 1.007 1.006 1.213 1.194 1.357 1.236.365.107.293.166 2.661-2.197 1.505-1.501 2.176-2.198 2.235-2.319.104-.214.081-.402-.076-.625-.239-.34-.604-.488-.89-.361' }) })),
    checkmarkShield: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.764 2.222c-.074.032-.281.181-.46.33-.801.67-1.454 1.099-2.324 1.528-1.63.803-3.182 1.16-5.043 1.16-1.087 0-1.143.035-1.34.833-.439 1.779-.458 3.769-.055 5.64.257 1.195.786 2.583 1.368 3.587 1.673 2.891 4.423 5.062 7.525 5.941.543.154.657.149 1.325-.058a12.597 12.597 0 005.112-3.039 12.69 12.69 0 003.584-6.424c.405-1.841.386-3.866-.053-5.647-.197-.798-.253-.833-1.34-.833-1.861 0-3.413-.357-5.043-1.16a10.864 10.864 0 01-2.325-1.527c-.461-.387-.648-.454-.931-.331m.527 1.932c.322.251 1.002.701 1.409.933 1.732.988 3.711 1.555 5.786 1.657l.546.027.062.405c.217 1.399.184 2.872-.094 4.164a11.278 11.278 0 01-2.225 4.7c-.378.478-1.4 1.483-1.875 1.844a11.464 11.464 0 01-3.55 1.857l-.35.108-.35-.108c-1.245-.387-2.434-1.008-3.55-1.856-.472-.358-1.493-1.363-1.874-1.845-2.008-2.535-2.829-5.67-2.32-8.864l.064-.405.545-.027c2.402-.118 4.653-.855 6.573-2.152.257-.174.554-.386.66-.472.105-.087.215-.158.243-.159.028 0 .163.086.3.193m2.469 5.107c-.085.038-.851.773-1.949 1.869l-1.81 1.807-.83-.824c-.924-.917-1.011-.974-1.336-.876-.218.065-.533.38-.598.598-.103.342-.075.38 1.236 1.692 1.007 1.006 1.213 1.194 1.357 1.236.365.107.293.166 2.661-2.197 1.505-1.501 2.176-2.198 2.235-2.319.104-.214.081-.402-.076-.625-.239-.34-.604-.488-.89-.361' }) })),
    chevronDown: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.729 8.285c-.209.103-.435.36-.496.563-.106.354-.289.15 3.74 4.179 3.236 3.236 3.708 3.693 3.857 3.736.376.11.145.316 4.197-3.736 4.047-4.047 3.847-3.823 3.736-4.192-.065-.218-.38-.533-.598-.598-.367-.11-.179-.275-3.835 3.376L12 14.939l-3.31-3.308C6.368 9.31 5.336 8.305 5.231 8.262c-.198-.083-.298-.078-.502.023' }) })),
    chevronDoubleDown: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.729 4.285c-.209.103-.435.36-.496.563-.106.354-.289.15 3.74 4.179 3.236 3.236 3.708 3.693 3.857 3.736.376.11.145.316 4.197-3.736 4.047-4.047 3.847-3.823 3.736-4.192-.065-.218-.38-.533-.598-.598-.367-.11-.179-.275-3.835 3.376L12 10.939 8.69 7.631C6.368 5.31 5.336 4.305 5.231 4.262c-.198-.083-.298-.078-.502.023m0 8c-.209.103-.435.36-.496.563-.106.354-.289.15 3.74 4.179 3.236 3.236 3.708 3.693 3.857 3.736.376.11.145.316 4.197-3.736 4.047-4.047 3.847-3.823 3.736-4.192-.065-.218-.38-.533-.598-.598-.367-.11-.179-.275-3.835 3.376L12 18.939l-3.31-3.308c-2.322-2.321-3.354-3.326-3.459-3.369-.198-.083-.298-.078-.502.023' }) })),
    chevronRight: (domProps) => (jsx("svg", { ...domProps, children: jsx("path", { d: 'M4.5 2.5L8 6L4.5 9.5', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })),
    clipboardCheck: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M10.656 2.28a2.434 2.434 0 00-.867.263 2.734 2.734 0 00-1.351 1.463l-.085.224-.887.022c-.99.024-1.216.063-1.67.287A2.799 2.799 0 004.333 6.32c-.069.246-.073.598-.073 6.68s.004 6.434.073 6.68a2.823 2.823 0 001.987 1.987c.245.069.564.073 5.68.073 5.132 0 5.434-.004 5.68-.073a2.83 2.83 0 001.987-1.987c.069-.247.073-.579.073-6.68s-.004-6.433-.073-6.68a2.792 2.792 0 00-1.465-1.782c-.452-.223-.679-.262-1.669-.286l-.886-.022-.068-.185a2.803 2.803 0 00-1.377-1.507c-.5-.247-.642-.266-2.042-.28-.693-.006-1.37.003-1.504.022m2.881 1.597c.251.123.463.335.586.586.14.284.139.791-.001 1.076a1.306 1.306 0 01-.665.619c-.205.076-.306.082-1.457.082s-1.252-.006-1.457-.082a1.301 1.301 0 01-.664-.619c-.115-.236-.152-.655-.079-.885.079-.248.277-.528.466-.658.334-.23.358-.233 1.774-.224 1.287.008 1.302.009 1.497.105M8.419 5.95c.257.697.877 1.333 1.565 1.604.447.176.744.206 2.016.206 1.293 0 1.583-.031 2.047-.22.66-.268 1.27-.891 1.516-1.547l.088-.237.845.012c.799.011.854.017 1.041.109.251.123.463.335.586.586l.097.197v12.68l-.098.199a1.306 1.306 0 01-.665.619c-.218.081-.266.082-5.457.082s-5.239-.001-5.457-.082c-.267-.1-.53-.345-.665-.619l-.098-.199-.012-6.26c-.008-4.578.001-6.303.034-6.42a1.31 1.31 0 01.789-.839c.107-.04.377-.056.954-.058l.804-.003.07.19m6.301 5.353c-.088.038-.804.723-1.93 1.848L11 14.939l-.77-.768c-.49-.489-.824-.79-.919-.83a.755.755 0 00-.896.243.768.768 0 00-.062.759c.045.088.564.637 1.174 1.243.908.903 1.12 1.094 1.253 1.13.199.054.241.054.44 0 .137-.036.469-.35 2.273-2.149 1.162-1.159 2.147-2.174 2.19-2.255.14-.27.07-.685-.149-.877a.781.781 0 00-.814-.132' }) })),
    code: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M13.604 3.326a1.043 1.043 0 00-.209.194c-.085.117-4.155 16.361-4.155 16.582 0 .374.372.657.864.658.217 0 .411-.133.527-.361.11-.218 4.129-16.289 4.129-16.513 0-.331-.329-.6-.773-.635-.212-.016-.266-.006-.383.075M5.74 7.279c-.103.051-.934.855-2.307 2.23-2.362 2.368-2.303 2.296-2.196 2.661.043.148.338.458 2.236 2.357 2.404 2.404 2.332 2.344 2.692 2.236.218-.065.533-.38.598-.598.106-.354.133-.322-1.876-2.335L3.062 12l1.825-1.83c1.996-2.001 1.982-1.983 1.88-2.322-.091-.304-.499-.648-.77-.648a.775.775 0 00-.257.079m11.989.006c-.209.103-.435.36-.496.563-.102.339-.116.321 1.88 2.322L20.938 12l-1.825 1.83c-2.009 2.013-1.982 1.981-1.876 2.335.065.218.38.533.598.598.36.108.288.168 2.692-2.236 1.898-1.899 2.193-2.209 2.236-2.357.107-.365.166-.293-2.197-2.661-1.422-1.426-2.201-2.178-2.309-2.23-.207-.101-.316-.099-.528.006' }) })),
    columns: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.617 4.281c-.589.073-1.099.331-1.552.783a2.742 2.742 0 00-.696 1.116l-.109.32v11l.109.32c.151.445.362.783.695 1.116.333.333.672.544 1.116.695l.32.109h3l.32-.109a2.95 2.95 0 00.978-.553L9 18.907l.202.171c.296.25.616.431.978.553l.32.109h3l.32-.109a2.95 2.95 0 00.978-.553l.202-.171.202.171c.296.25.616.431.978.553l.32.109h3l.32-.109a2.743 2.743 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-11l-.109-.32a2.742 2.742 0 00-.696-1.116c-.487-.486-.967-.713-1.667-.789-.608-.066-2.656-.024-2.968.061a3.06 3.06 0 00-1.05.547l-.25.206-.25-.206a3.058 3.058 0 00-1.07-.553c-.225-.061-.45-.07-1.68-.07s-1.455.009-1.68.07c-.367.1-.778.312-1.07.553L9 5.089l-.25-.206a3.355 3.355 0 00-.53-.344c-.515-.253-.623-.268-2.04-.281-.704-.007-1.408.004-1.563.023m2.911 1.592c.239.118.481.36.599.599l.093.188v10.68l-.093.189c-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.06-.221.261-.501.466-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101m6 0c.239.118.481.36.599.599l.093.188v10.68l-.093.189c-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.06-.221.261-.501.466-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101m6 0c.239.118.481.36.599.599l.093.188v10.68l-.093.189c-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.06-.221.261-.501.466-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101' }) })),
    connection: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M6.09375 6.1875C6.4375 6.4375 6.46875 6.90625 6.21875 7.25C5.125 8.53125 4.5 10.1875 4.5 12C4.5 13.8438 5.125 15.5 6.21875 16.7812C6.46875 17.0938 6.4375 17.5938 6.09375 17.8438C5.78125 18.125 5.3125 18.0625 5.0625 17.75C3.75 16.1875 3 14.1875 3 12C3 9.84375 3.75 7.84375 5.0625 6.28125C5.3125 5.96875 5.78125 5.90625 6.09375 6.1875ZM17.875 6.1875C18.1875 5.90625 18.6562 5.96875 18.9375 6.28125C20.2188 7.84375 21 9.84375 21 12C21 14.1875 20.2188 16.1875 18.9375 17.75C18.6562 18.0625 18.1875 18.0938 17.875 17.8438C17.5625 17.5938 17.5 17.0938 17.7812 16.7812C18.8438 15.5 19.5 13.8438 19.5 12C19.5 10.1875 18.8438 8.53125 17.7812 7.25C17.5 6.90625 17.5625 6.4375 17.875 6.1875ZM10.75 12C10.75 11.5625 10.9688 11.1562 11.375 10.9375C11.75 10.7188 12.2188 10.7188 12.625 10.9375C13 11.1562 13.25 11.5625 13.25 12C13.25 12.4688 13 12.875 12.625 13.0938C12.2188 13.3125 11.75 13.3125 11.375 13.0938C10.9688 12.875 10.75 12.4688 10.75 12ZM8.8125 9.5625C8.3125 10.25 8 11.0938 8 12C8 12.9375 8.3125 13.7812 8.8125 14.4688C9.09375 14.7812 9.03125 15.25 8.6875 15.5312C8.375 15.7812 7.90625 15.7188 7.65625 15.375C6.90625 14.4688 6.5 13.2812 6.5 12C6.5 10.75 6.90625 9.5625 7.65625 8.625C7.90625 8.3125 8.375 8.25 8.6875 8.5C9.03125 8.75 9.09375 9.21875 8.8125 9.5625ZM16.3438 8.625C17.0625 9.5625 17.5 10.75 17.5 12C17.5 13.2812 17.0625 14.4688 16.3438 15.375C16.0625 15.7188 15.5938 15.7812 15.2812 15.5312C14.9375 15.2812 14.9062 14.7812 15.1562 14.4688C15.6875 13.7812 16 12.9375 16 12C16 11.0938 15.6875 10.25 15.1562 9.5625C14.9062 9.21875 14.9375 8.75 15.2812 8.5C15.5938 8.25 16.0625 8.3125 16.3438 8.625Z' }) })),
    connectionSlash: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M3.1875 4.1875L14.7812 13.25C14.9062 12.875 15 12.4375 15 12C15 11.0938 14.6875 10.25 14.1562 9.5625C13.9062 9.21875 13.9375 8.75 14.2812 8.5C14.5938 8.25 15.0625 8.3125 15.3438 8.625C16.0625 9.5625 16.5 10.75 16.5 12C16.5 12.8125 16.3125 13.5625 16.0312 14.2188L17.625 15.5C18.1875 14.4375 18.5 13.2812 18.5 12C18.5 10.1875 17.8438 8.53125 16.7812 7.25C16.5 6.90625 16.5625 6.4375 16.875 6.1875C17.1875 5.90625 17.6562 5.96875 17.9375 6.28125C19.2188 7.84375 20 9.84375 20 12C20 13.625 19.5625 15.125 18.8438 16.4375L21.6875 18.6875C22.0312 18.9375 22.0938 19.4062 21.8125 19.7188C21.5625 20.0625 21.0938 20.125 20.7812 19.8438L2.28125 5.34375C1.9375 5.09375 1.875 4.625 2.15625 4.3125C2.40625 3.96875 2.875 3.90625 3.1875 4.1875ZM5.84375 10.0625L7.09375 11.0312C7.03125 11.3438 7 11.6875 7 12C7 12.9375 7.3125 13.7812 7.8125 14.4688C8.09375 14.7812 8.03125 15.2812 7.6875 15.5312C7.375 15.7812 6.90625 15.7188 6.65625 15.375C5.90625 14.4688 5.5 13.2812 5.5 12C5.5 11.3125 5.625 10.6562 5.84375 10.0625ZM3.03125 7.8125L4.21875 8.78125C3.75 9.75 3.5 10.8438 3.5 12C3.5 13.8438 4.125 15.5 5.21875 16.7812C5.46875 17.0938 5.4375 17.5938 5.09375 17.8438C4.78125 18.0938 4.3125 18.0625 4.0625 17.75C2.75 16.1875 2 14.1875 2 12C2 10.5 2.34375 9.0625 3.03125 7.8125Z' }) })),
    cross: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5.695 5.316c-.332.194-.551.564-.476.802.058.181.521.668 3.076 3.232L10.936 12l-2.641 2.65c-1.452 1.458-2.734 2.763-2.847 2.902-.299.363-.315.512-.088.82.213.291.526.465.738.412.188-.047.616-.452 3.252-3.079L12 13.064l2.65 2.641c2.636 2.627 3.064 3.032 3.252 3.079.212.053.525-.121.738-.412.227-.308.211-.457-.088-.82-.113-.139-1.395-1.445-2.848-2.903l-2.642-2.651 2.502-2.509c3.167-3.177 3.235-3.251 3.236-3.483 0-.314-.497-.806-.814-.806-.053 0-.212.084-.352.186-.14.103-1.464 1.393-2.944 2.867l-2.689 2.681L9.33 8.277C7.862 6.815 6.557 5.532 6.431 5.426c-.299-.253-.451-.276-.736-.11' }) })),
    cubeTransparent: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.78 2.295c-.309.1-2.254 1.105-2.376 1.227a.578.578 0 00-.147.616c.078.258.236.486.393.567.27.14.413.099 1.419-.401L12 3.842l.931.462c1.006.5 1.149.541 1.419.401.157-.081.315-.309.393-.567a.58.58 0 00-.149-.618c-.15-.15-2.31-1.231-2.514-1.258a.794.794 0 00-.3.033M4.843 5.74c-.554.275-1.03.5-1.057.5-.106 0-.383.221-.468.373-.089.158-.09.175-.082 1.583.004.783.025 1.491.047 1.572a.642.642 0 00.382.434c.216.071.669.033.804-.067.245-.183.27-.281.284-1.125.007-.424.02-.77.027-.77.008 0 .256.119.551.264.586.287.779.325 1.019.201.264-.136.485-.628.409-.909-.058-.215-.222-.361-.658-.583-.21-.106-.381-.203-.381-.215 0-.012.164-.102.364-.2.2-.098.424-.237.498-.308.246-.239.256-.534.032-.923-.133-.228-.301-.327-.558-.327-.182 0-.319.056-1.213.5m12.77-.422c-.144.087-.306.344-.369.583-.096.364.09.612.672.897.2.098.364.188.364.2 0 .012-.171.109-.381.215-.436.222-.6.368-.658.583-.076.281.145.773.409.909.24.124.433.086 1.019-.201.295-.145.543-.264.551-.264.007 0 .02.347.027.77.014.844.039.942.284 1.125.135.1.588.138.804.067a.642.642 0 00.382-.434c.022-.081.043-.789.047-1.572.008-1.408.007-1.425-.082-1.583-.085-.152-.362-.373-.468-.373-.027 0-.503-.225-1.057-.5-.894-.444-1.031-.5-1.213-.5a.65.65 0 00-.331.078m-8 4c-.248.151-.445.625-.37.893.067.245.263.385 1.151.827l.842.418.012 1.162c.011 1.078.018 1.172.092 1.298.148.251.262.304.66.304s.512-.053.66-.304c.074-.126.081-.22.092-1.298l.012-1.162.842-.418c.479-.238.899-.474.976-.549.246-.238.256-.532.031-.922-.132-.228-.299-.327-.557-.327-.18 0-.314.055-1.13.459l-.926.458-.926-.458c-.816-.404-.95-.459-1.13-.459a.65.65 0 00-.331.078m-5.968 4.497a.612.612 0 00-.363.415c-.055.2-.056 2.779 0 2.979.081.291.188.365 1.413.977 1.257.627 1.374.664 1.655.519.157-.081.315-.309.393-.567a.578.578 0 00-.147-.616c-.067-.067-.508-.315-.979-.552l-.857-.43v-1.08c0-1.138-.02-1.303-.179-1.492-.163-.193-.619-.268-.936-.153m16 0a.612.612 0 00-.363.415c-.024.087-.042.606-.042 1.23v1.08l-.857.43c-.471.237-.912.485-.979.552a.578.578 0 00-.147.616c.078.258.236.486.393.567.281.145.398.108 1.655-.519 1.225-.612 1.332-.686 1.413-.977.025-.089.042-.69.042-1.489 0-.799-.017-1.4-.042-1.489-.088-.318-.336-.474-.743-.468a1.247 1.247 0 00-.33.052m-8 4a.612.612 0 00-.363.415c-.023.083-.042.461-.042.84 0 .38-.007.69-.016.69-.009 0-.256-.117-.55-.26-.599-.292-.82-.33-1.061-.182-.247.151-.445.625-.371.892.068.247.247.374 1.174.837.486.243.989.506 1.116.585.197.121.268.142.468.142s.271-.021.468-.142c.127-.079.63-.342 1.116-.585.93-.464 1.107-.591 1.174-.84.072-.268-.124-.739-.371-.889-.241-.148-.462-.11-1.061.182-.294.143-.541.26-.55.26-.009 0-.016-.31-.016-.69 0-.743-.03-.924-.179-1.102-.163-.193-.619-.268-.936-.153' }) })),
    database: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.149 2.283C8.3 2.412 5.673 3.331 4.332 4.668a3.778 3.778 0 00-.978 1.574l-.094.298v10.92l.094.298c.433 1.381 1.673 2.444 3.714 3.184 2.96 1.074 6.904 1.074 9.864 0 1.794-.651 2.988-1.567 3.526-2.706.303-.641.282-.184.282-6.236 0-5.069-.005-5.437-.071-5.68-.543-1.987-3.007-3.45-6.629-3.938-.378-.051-2.038-.154-2.18-.135-.022.003-.342.019-.711.036m2.611 1.574c2.219.288 3.953.964 4.847 1.888.308.317.377.412.504.683.092.195.109.286.109.572 0 .464-.134.749-.564 1.199-.925.969-2.528 1.611-4.856 1.948-.72.104-2.88.104-3.6 0-2.536-.367-4.249-1.115-5.119-2.235a2.303 2.303 0 01-.192-.34C4.797 7.377 4.78 7.286 4.78 7s.017-.377.109-.572c.127-.271.196-.366.504-.683.919-.95 2.864-1.686 5.027-1.902.242-.024.503-.051.58-.06.347-.039 2.289.013 2.76.074M5.5 10.222c2.343 1.384 6.122 1.885 9.46 1.255 1.584-.299 3.166-.922 4.072-1.603l.212-.16-.012 1.313-.012 1.313-.126.267c-.255.537-.993 1.17-1.836 1.575-.988.474-1.982.752-3.458.965-.72.104-2.88.104-3.6 0-2.536-.367-4.249-1.115-5.119-2.235a2.303 2.303 0 01-.192-.34l-.109-.232-.012-1.313-.012-1.313.212.16c.117.087.356.244.532.348m0 5c2.343 1.384 6.122 1.885 9.46 1.255 1.584-.299 3.166-.922 4.072-1.603l.212-.16-.012 1.313-.012 1.313-.126.267c-.255.537-.993 1.17-1.836 1.575-.988.474-1.982.752-3.458.965-.72.104-2.88.104-3.6 0-2.536-.367-4.249-1.115-5.119-2.235a2.303 2.303 0 01-.192-.34l-.109-.232-.012-1.313-.012-1.313.212.16c.117.087.356.244.532.348' }) })),
    documentAdd: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M6.617 2.283c-.583.068-1.098.327-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32v15l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h11l.32-.109a2.736 2.736 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-5.18c0-5.604.01-5.346-.213-5.759-.065-.12-1.079-1.163-3.003-3.089-2.728-2.732-2.92-2.916-3.174-3.034a2.145 2.145 0 00-.54-.161c-.341-.043-5.811-.038-6.193.006m8.853 4.248l2.771 2.771-.011 5.019-.01 5.019-.093.189c-.132.268-.416.534-.674.63-.213.08-.3.081-5.453.081-5.153 0-5.24-.001-5.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-7.26c-.009-5.436 0-7.303.035-7.43.093-.34.433-.7.782-.828.127-.046.677-.057 3.134-.059l2.979-.003 2.771 2.771m-3.671 2.745c-.212.043-.39.165-.468.322-.062.125-.072.293-.083 1.389l-.012 1.247-1.248.013c-1.235.013-1.25.014-1.417.11-.221.126-.308.308-.31.643-.001.332.101.542.322.657.147.078.235.084 1.405.095l1.248.012.012 1.248c.011 1.17.017 1.258.095 1.405.115.22.325.323.657.323s.542-.103.657-.323c.078-.147.084-.235.095-1.405l.012-1.248 1.248-.012c1.17-.011 1.258-.017 1.405-.095.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643-.167-.096-.182-.097-1.417-.11l-1.248-.013-.012-1.247c-.011-1.102-.02-1.264-.083-1.39-.123-.246-.516-.391-.87-.321' }) })),
    documentCopy: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M9.617 2.283c-.583.068-1.098.327-1.552.781a2.681 2.681 0 00-.692 1.116c-.098.296-.107.385-.124 1.19l-.018.87h-.605c-1.362.001-1.915.179-2.561.824a2.742 2.742 0 00-.696 1.116l-.109.32v11l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h9l.32-.109a2.736 2.736 0 001.116-.695c.336-.336.547-.676.691-1.116.098-.296.107-.385.124-1.186l.018-.865.865-.018c.801-.017.89-.026 1.186-.124.44-.144.78-.355 1.116-.691.333-.333.544-.671.695-1.116l.109-.32v-3.68c0-3.974.006-3.853-.213-4.259-.064-.118-.927-1.011-2.503-2.589-2.245-2.249-2.422-2.416-2.674-2.534a2.145 2.145 0 00-.54-.161c-.34-.043-4.811-.038-5.193.006m7.353 3.748l2.271 2.271-.01 3.519-.011 3.519-.093.189c-.132.268-.416.534-.674.63-.212.079-.302.081-4.453.081-4.151 0-4.241-.002-4.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.093-.34.433-.7.782-.828.126-.046.607-.057 2.634-.059l2.479-.003 2.271 2.271M7.249 11.63l.011 3.87.109.32c.151.445.362.783.695 1.116.333.333.672.544 1.116.695l.32.109 2.872.012 2.873.011-.013.789c-.011.731-.019.802-.105.977-.132.268-.416.534-.674.63-.212.079-.302.081-4.453.081-4.151 0-4.241-.002-4.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.093-.34.433-.7.782-.828.111-.041.364-.057.903-.059l.748-.003.012 3.87' }) })),
    dotsVertical: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.701 3.285c-.334.048-.639.213-.932.502a1.65 1.65 0 00-.491 1.483c.069.401.204.66.498.954.294.294.553.429.954.498.326.056.699.004 1.023-.143.279-.127.699-.547.826-.826.295-.651.189-1.388-.275-1.902-.417-.46-.975-.658-1.603-.566m0 7c-.334.048-.639.213-.932.502a1.65 1.65 0 00-.491 1.483c.069.401.204.66.498.954.294.294.553.429.954.498.326.056.699.004 1.023-.143.279-.127.699-.547.826-.826.295-.651.189-1.388-.275-1.902-.417-.46-.975-.658-1.603-.566m0 7c-.334.048-.639.213-.932.502a1.65 1.65 0 00-.491 1.483c.069.401.204.66.498.954.294.294.553.429.954.498.326.056.699.004 1.023-.143.279-.127.699-.547.826-.826.295-.651.189-1.388-.275-1.902-.417-.46-.975-.658-1.603-.566' }) })),
    calendar: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M7.375 2.75C7.73047 2.75 8.03125 3.05078 8.03125 3.40625V4.5H11.9688V3.40625C11.9688 3.05078 12.2422 2.75 12.625 2.75C12.9805 2.75 13.2812 3.05078 13.2812 3.40625V4.5H14.375C15.332 4.5 16.125 5.29297 16.125 6.25V6.6875V8V15C16.125 15.9844 15.332 16.75 14.375 16.75H5.625C4.64062 16.75 3.875 15.9844 3.875 15V8V6.6875V6.25C3.875 5.29297 4.64062 4.5 5.625 4.5H6.71875V3.40625C6.71875 3.05078 6.99219 2.75 7.375 2.75ZM14.8125 8H5.1875V15C5.1875 15.2461 5.37891 15.4375 5.625 15.4375H14.375C14.5938 15.4375 14.8125 15.2461 14.8125 15V8ZM6.9375 9.75H13.0625C13.2812 9.75 13.5 9.96875 13.5 10.1875V11.9375C13.5 12.1836 13.2812 12.375 13.0625 12.375H6.9375C6.69141 12.375 6.5 12.1836 6.5 11.9375V10.1875C6.5 9.96875 6.69141 9.75 6.9375 9.75Z' }) })),
    calendarLight: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M4.33333 3.66667V1M9.66667 3.66667V1M3.66667 6.33333H10.3333M2.33333 13H11.6667C12.403 13 13 12.403 13 11.6667V3.66667C13 2.93029 12.403 2.33333 11.6667 2.33333H2.33333C1.59695 2.33333 1 2.93029 1 3.66667V11.6667C1 12.403 1.59695 13 2.33333 13Z', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })),
    diff: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none', children: jsx("path", { d: 'M4.625 13C4.625 13.2109 4.78906 13.375 5 13.375H11C11.1875 13.375 11.375 13.2109 11.375 13V6.25H9.5C9.07812 6.25 8.75 5.92188 8.75 5.5V3.625H5C4.78906 3.625 4.625 3.8125 4.625 4V13ZM5 2.5H8.86719C9.26562 2.5 9.64062 2.66406 9.92188 2.94531L12.0547 5.07812C12.3359 5.35938 12.5 5.73438 12.5 6.13281V13C12.5 13.8438 11.8203 14.5 11 14.5H5C4.15625 14.5 3.5 13.8438 3.5 13V4C3.5 3.17969 4.15625 2.5 5 2.5ZM8.5625 7.1875V8.125H9.5C9.80469 8.125 10.0625 8.38281 10.0625 8.6875C10.0625 9.01562 9.80469 9.25 9.5 9.25H8.5625V10.1875C8.5625 10.5156 8.30469 10.75 8 10.75C7.67188 10.75 7.4375 10.5156 7.4375 10.1875V9.25H6.5C6.17188 9.25 5.9375 9.01562 5.9375 8.6875C5.9375 8.38281 6.17188 8.125 6.5 8.125H7.4375V7.1875C7.4375 6.88281 7.67188 6.625 8 6.625C8.30469 6.625 8.5625 6.88281 8.5625 7.1875ZM6.5 11.5H9.5C9.80469 11.5 10.0625 11.7578 10.0625 12.0625C10.0625 12.3906 9.80469 12.625 9.5 12.625H6.5C6.17188 12.625 5.9375 12.3906 5.9375 12.0625C5.9375 11.7578 6.17188 11.5 6.5 11.5Z' }) })),
    download: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.799 3.276c-.212.043-.39.165-.468.322-.067.133-.072.465-.082 5.36l-.01 5.218-1.45-1.444c-1.597-1.592-1.607-1.599-1.954-1.495-.218.065-.533.38-.598.598-.107.356-.15.303 2.077 2.549a281.982 281.982 0 012.13 2.161c.061.069.199.15.33.195.223.075.229.075.452 0a.873.873 0 00.33-.195c.057-.065 1.016-1.037 2.13-2.161 2.227-2.246 2.184-2.193 2.077-2.549-.065-.218-.38-.533-.598-.598-.347-.104-.357-.097-1.954 1.495l-1.45 1.444-.01-5.218c-.01-4.917-.015-5.226-.082-5.361-.123-.246-.516-.391-.87-.321m-8 12c-.212.043-.39.165-.468.322-.061.123-.071.26-.071 1.002 0 .962.042 1.233.281 1.83a3.802 3.802 0 002.029 2.029c.746.299.333.281 6.43.281 6.097 0 5.684.018 6.43-.281a3.802 3.802 0 002.029-2.029c.239-.597.281-.868.281-1.83 0-.989-.022-1.079-.307-1.239-.232-.13-.634-.13-.866 0-.276.155-.301.251-.331 1.259-.015.502-.047.949-.075 1.04-.151.495-.64 1.084-1.101 1.327-.507.267-.177.253-6.06.253s-5.553.014-6.06-.253c-.461-.243-.95-.832-1.101-1.327-.028-.091-.06-.538-.075-1.04-.029-.996-.057-1.106-.315-1.249a1.077 1.077 0 00-.65-.095' }) })),
    edit: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M18.617 2.283c-.336.04-.728.175-1.047.361-.173.101-1.338 1.241-4.737 4.635-4.063 4.057-4.512 4.518-4.552 4.672-.03.115-.041.681-.033 1.74.011 1.496.016 1.576.095 1.726a.59.59 0 00.24.24c.15.079.23.084 1.726.095 1.062.008 1.625-.003 1.74-.033.154-.04.617-.491 4.673-4.552 4.879-4.885 4.683-4.671 4.906-5.347.091-.277.105-.387.105-.82 0-.432-.014-.543-.105-.82-.425-1.294-1.642-2.06-3.011-1.897m.911 1.59c.239.117.481.359.599.599.134.272.133.785-.003 1.068-.076.161-.93 1.036-4.339 4.45l-4.244 4.25H9.76V12.459l4.21-4.203c2.316-2.313 4.268-4.244 4.338-4.292.226-.153.414-.203.732-.193.217.008.352.036.488.102m-13.911.41c-.585.07-1.098.328-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32v12l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h12l.32-.109a2.736 2.736 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-2.88c0-3.251.016-3.077-.307-3.259-.232-.13-.634-.13-.866 0-.321.18-.304.023-.327 3.179l-.02 2.8-.093.189c-.132.268-.416.534-.674.63-.213.08-.298.081-5.953.081s-5.74-.001-5.953-.081c-.258-.096-.542-.362-.674-.63l-.093-.189V6.66l.093-.188a1.43 1.43 0 01.599-.599l.188-.093 2.8-.02c2.732-.02 2.804-.022 2.957-.103.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643l-.169-.097-2.68-.006c-1.474-.003-2.808.01-2.963.029' }) })),
    enter: (domProps) => (jsx("svg", { ...baseSvgProps, viewBox: '-2 -2 16 16', ...domProps, children: jsx("path", { d: 'M11.25 1.125C11.25 0.91875 11.4188 0.75 11.625 0.75C11.8313 0.75 12 0.91875 12 1.125V5.25C12 6.28594 11.161 7.125 10.125 7.125H1.27974L3.63989 9.48516C3.78521 9.63047 3.78521 9.86953 3.63989 10.0148C3.49458 10.1602 3.25552 10.1602 3.11021 10.0148L0.110205 7.01484C-0.0351074 6.86953 -0.0351074 6.63047 0.110205 6.48516L3.11021 3.48516C3.25552 3.33984 3.49458 3.33984 3.63989 3.48516C3.78521 3.63047 3.78521 3.86953 3.63989 4.01484L1.27974 6.375H10.125C10.7461 6.375 11.25 5.87109 11.25 5.25V1.125Z', fill: '#303744' }) })),
    eye: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.36 4.282c-.968.056-1.812.218-2.724.519A10.771 10.771 0 003.009 9.12C2.436 9.986 1.72 11.585 1.72 12c0 .386.66 1.901 1.187 2.724 1.623 2.535 4.11 4.243 7.006 4.812.809.159 1.213.197 2.087.197.874 0 1.278-.038 2.087-.197a10.729 10.729 0 007.549-5.792c.332-.674.644-1.519.644-1.744 0-.225-.312-1.07-.644-1.744A10.839 10.839 0 0017.22 5.61c-1.729-.971-3.829-1.448-5.86-1.328m2.02 1.576c2.648.417 4.892 1.866 6.375 4.117.31.471.793 1.425.908 1.795.069.221.069.239 0 .46-.115.37-.598 1.324-.908 1.795-1.758 2.668-4.604 4.215-7.755 4.215-3.125 0-5.954-1.524-7.721-4.16-.299-.446-.78-1.384-.918-1.79-.097-.284-.097-.285-.025-.517.116-.373.598-1.326.909-1.798A9.915 9.915 0 016.18 7.816c.677-.555 1.791-1.188 2.62-1.491a9.982 9.982 0 012.24-.523c.48-.052 1.861-.02 2.34.056m-1.785 2.424c-.46.05-.773.142-1.215.357-1.06.514-1.74 1.36-2.03 2.521a4.03 4.03 0 000 1.68c.183.733.493 1.287 1.008 1.802.73.73 1.606 1.092 2.642 1.092 1.036 0 1.912-.362 2.642-1.092.73-.73 1.092-1.606 1.092-2.642 0-1.589-.926-2.924-2.441-3.515-.441-.173-1.171-.26-1.698-.203m.961 1.54c.378.089.707.281 1.024.598.454.454.659.945.659 1.58 0 .635-.205 1.126-.659 1.58-.456.456-.944.66-1.58.66-.636 0-1.124-.204-1.58-.66-.454-.454-.659-.945-.659-1.58 0-.635.205-1.126.659-1.58.31-.31.646-.509 1.005-.597a2.87 2.87 0 011.131-.001' }) })),
    eyeSlash: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M2.729 2.285c-.209.103-.435.36-.496.563-.109.363-.802-.363 9.24 9.679 10.078 10.078 9.314 9.35 9.692 9.236.218-.065.533-.38.598-.598.105-.35.108-.346-1.617-2.078l-1.566-1.572.199-.168c1.263-1.063 2.183-2.222 2.859-3.603.352-.718.642-1.507.642-1.747 0-.222-.314-1.072-.644-1.741a10.75 10.75 0 00-6.272-5.455c-1.11-.367-2.123-.527-3.344-.528-1.835-.002-3.376.362-4.931 1.165l-.389.2-1.66-1.657c-1.903-1.9-1.901-1.899-2.311-1.696m10.308 3.536c2.757.308 5.165 1.796 6.717 4.152.315.478.757 1.35.903 1.78l.094.276-.193.468a9.291 9.291 0 01-2.676 3.63l-.379.316-1.188-1.188-1.187-1.187.113-.184c.45-.735.62-1.869.408-2.724-.287-1.16-.969-2.007-2.029-2.521a3.21 3.21 0 00-1.255-.356 3.597 3.597 0 00-2.029.376l-.411.206-1.051-1.051c-.578-.578-1.042-1.058-1.032-1.068.094-.086.9-.419 1.403-.579 1.126-.36 2.525-.488 3.792-.346M3.7 8.275c-.184.115-.305.261-.679.821-.591.887-1.301 2.473-1.301 2.907 0 .383.663 1.902 1.187 2.721 1.789 2.795 4.549 4.529 7.893 4.961.644.083 2.042.062 2.72-.04.899-.136 1.1-.274 1.1-.759a.864.864 0 00-.1-.462c-.176-.342-.405-.402-1.08-.282-.478.084-1.891.121-2.385.062-2.848-.342-5.201-1.774-6.776-4.124-.3-.447-.78-1.384-.92-1.794l-.098-.288.094-.269c.172-.497.605-1.322 1.01-1.927.518-.772.551-.949.247-1.286-.274-.303-.652-.403-.912-.241m8.856 1.547c.378.089.707.281 1.024.598.454.454.659.945.659 1.58 0 .299-.08.732-.164.889-.04.075-.168-.042-1.538-1.412-.948-.948-1.481-1.509-1.457-1.533.076-.076.588-.179.9-.181.176-.001.435.025.576.059' }) })),
    fileCircleInfo: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5 18.5H11.875C12.25 19.0938 12.7188 19.5938 13.2812 20C13.1875 20 13.0938 20 13 20H5C3.875 20 3 19.125 3 18V6C3 4.90625 3.875 4 5 4H10.1562C10.6875 4 11.1875 4.21875 11.5625 4.59375L14.4062 7.4375C14.7812 7.8125 15 8.3125 15 8.84375V10.2188C14.4375 10.375 13.9375 10.5938 13.5 10.9062V9H11C10.4375 9 10 8.5625 10 8V5.5H5C4.71875 5.5 4.5 5.75 4.5 6V18C4.5 18.2812 4.71875 18.5 5 18.5ZM16.5 11C18.0938 11 19.5625 11.875 20.375 13.25C21.1875 14.6562 21.1875 16.375 20.375 17.75C19.5625 19.1562 18.0938 20 16.5 20C14.875 20 13.4062 19.1562 12.5938 17.75C11.7812 16.375 11.7812 14.6562 12.5938 13.25C13.4062 11.875 14.875 11 16.5 11ZM16.5 14C16.9062 14 17.25 13.6875 17.25 13.25C17.25 12.8438 16.9062 12.5 16.5 12.5C16.0625 12.5 15.75 12.8438 15.75 13.25C15.75 13.6875 16.0625 14 16.5 14ZM15.5 15.5C15.5 15.7812 15.7188 16 16 16V17.5C15.7188 17.5 15.5 17.75 15.5 18C15.5 18.2812 15.7188 18.5 16 18.5H16.5H17C17.25 18.5 17.5 18.2812 17.5 18C17.5 17.75 17.25 17.5 17 17.5V15.5C17 15.25 16.75 15 16.5 15H16C15.7188 15 15.5 15.25 15.5 15.5Z' }) })),
    fileCode: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M8 18.5H16C16.25 18.5 16.5 18.2812 16.5 18V9H14C13.4375 9 13 8.5625 13 8V5.5H8C7.71875 5.5 7.5 5.75 7.5 6V18C7.5 18.2812 7.71875 18.5 8 18.5ZM8 4H13.1562C13.6875 4 14.1875 4.21875 14.5625 4.59375L17.4062 7.4375C17.7812 7.8125 18 8.3125 18 8.84375V18C18 19.125 17.0938 20 16 20H8C6.875 20 6 19.125 6 18V6C6 4.90625 6.875 4 8 4ZM11.0312 13.0312H11L10.0312 14L11 14.9688C11.3125 15.2812 11.3125 15.75 11 16.0312C10.7188 16.3438 10.25 16.3438 9.96875 16.0312L8.46875 14.5312C8.15625 14.25 8.15625 13.7812 8.46875 13.4688L9.96875 12C10.25 11.6875 10.7188 11.6875 11.0312 12C11.3125 12.2812 11.3125 12.75 11.0312 13.0312ZM14.0312 11.9688L15.5312 13.4688C15.8125 13.7812 15.8125 14.25 15.5312 14.5312L14.0312 16.0312C13.7188 16.3438 13.25 16.3438 12.9688 16.0312C12.6562 15.75 12.6562 15.2812 12.9688 14.9688L13.9375 14L12.9688 13.0312C12.6562 12.75 12.6562 12.2812 12.9688 11.9688C13.25 11.6875 13.7188 11.6875 14.0312 11.9688Z' }) })),
    filterList: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5.28125 6H13.6875C14.4062 6 15 6.59375 15 7.3125C15 7.625 14.875 7.9375 14.6562 8.1875L11.75 11.3125V17C11.75 17.5625 11.2812 18 10.7188 18C10.5312 18 10.3125 17.9688 10.1562 17.8438L7.8125 16.2812C7.4375 16.0625 7.25 15.6562 7.25 15.25V11.3125L4.34375 8.1875C4.09375 7.9375 4 7.625 4 7.3125C4 6.59375 4.5625 6 5.28125 6ZM8.53125 10.5C8.65625 10.6562 8.75 10.8125 8.75 11V15.125L10.25 16.0938V11C10.25 10.8125 10.3125 10.6562 10.4375 10.5L13.2188 7.5H5.75L8.53125 10.5ZM14.75 16.25H19.25C19.6562 16.25 20 16.5938 20 17C20 17.4375 19.6562 17.75 19.25 17.75H14.75C14.3125 17.75 14 17.4375 14 17C14 16.5938 14.3125 16.25 14.75 16.25ZM14 12C14 11.5938 14.3125 11.25 14.75 11.25H19.25C19.6562 11.25 20 11.5938 20 12C20 12.4375 19.6562 12.75 19.25 12.75H14.75C14.3125 12.75 14 12.4375 14 12ZM16.75 6.25H19.25C19.6562 6.25 20 6.59375 20 7C20 7.4375 19.6562 7.75 19.25 7.75H16.75C16.3125 7.75 16 7.4375 16 7C16 6.59375 16.3125 6.25 16.75 6.25Z' }) })),
    folder: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.617 4.283c-.584.069-1.098.328-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32v11l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h15l.32-.109a2.736 2.736 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-9l-.109-.32a2.742 2.742 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.2-.023-1.558-.04-3.189-.041h-2.841l-.919-.923c-.506-.507-.974-.953-1.04-.99-.109-.061-.398-.067-3.28-.072-1.738-.003-3.288.009-3.443.028m7.003 2.4c.506.507.974.953 1.04.99.109.061.423.069 3.4.087l3.28.02.188.093c.239.118.481.36.599.599l.093.188v8.68l-.093.189c-.132.268-.416.534-.674.63-.214.08-.294.081-7.453.081-7.159 0-7.239-.001-7.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.093-.34.433-.7.782-.828.127-.046.677-.057 3.134-.059l2.981-.003.919.923' }) })),
    gear: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.7 2.281c-.347.04-.563.107-.877.271-.57.299-.963.779-1.186 1.451-.154.465-.29.649-.574.782-.312.145-.589.131-.93-.048-.402-.212-.64-.292-.995-.338-.905-.115-1.833.324-2.35 1.112-.207.317-.29.518-.37.896-.115.551-.045.982.267 1.643.192.406.204.451.185.666-.042.458-.279.733-.764.885-1.051.329-1.676 1.038-1.827 2.071a2.503 2.503 0 00.395 1.717c.332.484.728.774 1.328.973.603.201.824.435.868.922.019.215.007.26-.185.666-.312.661-.382 1.092-.267 1.643.08.378.163.579.37.896.435.664 1.303 1.151 2.051 1.151.329 0 .78-.12 1.159-.308.473-.235.722-.266 1.036-.131.301.13.445.32.603.795.073.22.195.496.271.612a2.487 2.487 0 003.452.731c.501-.326.798-.723 1.003-1.343.158-.475.302-.665.603-.795.31-.133.558-.102 1.039.133.384.187.833.306 1.156.306.287 0 .738-.12 1.078-.286a2.576 2.576 0 001.341-1.747c.117-.569.049-.992-.265-1.657-.192-.406-.204-.451-.185-.666.044-.487.265-.721.868-.922.618-.204 1.016-.502 1.341-1.002a2.483 2.483 0 00-.385-3.179c-.268-.248-.626-.444-1.06-.58-.485-.152-.722-.427-.764-.885-.019-.215-.007-.26.185-.666.413-.873.423-1.504.039-2.289-.302-.615-.935-1.135-1.574-1.294-.389-.096-.581-.111-.918-.068-.355.046-.593.126-.995.338-.341.179-.618.193-.93.048-.284-.133-.42-.317-.574-.782a3.404 3.404 0 00-.288-.637c-.503-.769-1.435-1.195-2.375-1.085m.624 1.525a.977.977 0 01.476.364c.041.067.128.276.194.465.171.49.303.705.628 1.028.213.21.372.324.622.446.428.208.687.269 1.136.267.428-.002.698-.074 1.197-.32.546-.269.886-.236 1.244.123.359.358.392.698.123 1.244-.252.51-.319.768-.32 1.217-.002 1.089.653 1.987 1.721 2.359.438.153.574.232.705.408.129.173.19.362.19.584 0 .477-.26.806-.76.963-1.161.366-1.858 1.268-1.856 2.406.001.449.068.707.32 1.217.139.281.176.4.176.56-.001.398-.31.827-.674.937-.295.088-.485.059-.88-.133-.49-.239-.78-.31-1.246-.307a2.375 2.375 0 00-1.698.7c-.321.316-.44.51-.623 1.015-.172.473-.228.569-.408.703-.438.325-1.125.215-1.391-.222a3.673 3.673 0 01-.201-.485c-.369-1.06-1.243-1.705-2.319-1.711-.466-.003-.756.068-1.246.307-.56.272-.895.24-1.255-.12-.359-.358-.392-.698-.123-1.244.252-.51.319-.768.32-1.217.002-1.134-.699-2.042-1.856-2.406-.5-.157-.76-.486-.76-.963 0-.222.061-.411.19-.584.131-.176.267-.255.705-.408 1.068-.372 1.723-1.27 1.721-2.359-.001-.449-.068-.707-.32-1.217-.269-.546-.236-.886.123-1.244.358-.359.698-.392 1.244-.123.51.252.768.319 1.217.32 1.082.002 1.984-.651 2.354-1.705.068-.193.151-.403.185-.469.074-.144.293-.324.471-.389.169-.061.502-.065.674-.007m-.729 4.476c-.46.05-.773.142-1.215.357-1.06.514-1.74 1.36-2.03 2.521a4.03 4.03 0 000 1.68c.183.733.493 1.287 1.008 1.802.73.73 1.606 1.092 2.642 1.092 1.036 0 1.912-.362 2.642-1.092.73-.73 1.092-1.606 1.092-2.642 0-1.589-.926-2.924-2.441-3.515-.441-.173-1.171-.26-1.698-.203m.961 1.54c.378.089.707.281 1.024.598.454.454.659.945.659 1.58 0 .635-.205 1.126-.659 1.58-.456.456-.944.66-1.58.66-.636 0-1.124-.204-1.58-.66-.454-.454-.659-.945-.659-1.58 0-.635.205-1.126.659-1.58.31-.31.646-.509 1.005-.597a2.87 2.87 0 011.131-.001' }) })),
    github: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M9.40625 16.4375C9.40625 16.5 9.34375 16.5312 9.25 16.5312C9.15625 16.5625 9.09375 16.5 9.09375 16.4375C9.09375 16.375 9.15625 16.3125 9.25 16.3125C9.34375 16.3125 9.40625 16.375 9.40625 16.4375ZM8.4375 16.2812C8.46875 16.2188 8.5625 16.1875 8.65625 16.2188C8.75 16.25 8.78125 16.3125 8.78125 16.375C8.75 16.4375 8.65625 16.4688 8.59375 16.4375C8.5 16.4375 8.4375 16.3438 8.4375 16.2812ZM9.84375 16.25C9.90625 16.2188 10 16.2812 10 16.3438C10.0312 16.4062 9.96875 16.4375 9.875 16.4688C9.78125 16.5 9.6875 16.4688 9.6875 16.4062C9.6875 16.3125 9.75 16.25 9.84375 16.25ZM11.875 4.25C16.2188 4.25 19.75 7.5625 19.75 11.875C19.75 15.3438 17.625 18.3125 14.5 19.3438C14.0938 19.4375 13.9375 19.1875 13.9375 18.9688C13.9375 18.7188 13.9688 17.4062 13.9688 16.375C13.9688 15.625 13.7188 15.1562 13.4375 14.9062C15.1875 14.7188 17.0312 14.4688 17.0312 11.4688C17.0312 10.5938 16.7188 10.1875 16.2188 9.625C16.2812 9.40625 16.5625 8.59375 16.125 7.5C15.4688 7.28125 13.9688 8.34375 13.9688 8.34375C13.3438 8.15625 12.6875 8.09375 12 8.09375C11.3438 8.09375 10.6875 8.15625 10.0625 8.34375C10.0625 8.34375 8.53125 7.3125 7.90625 7.5C7.46875 8.59375 7.71875 9.40625 7.8125 9.625C7.3125 10.1875 7.0625 10.5938 7.0625 11.4688C7.0625 14.4688 8.84375 14.7188 10.5938 14.9062C10.3438 15.125 10.1562 15.4688 10.0938 15.9688C9.625 16.1875 8.5 16.5312 7.8125 15.3125C7.375 14.5625 6.59375 14.5 6.59375 14.5C5.84375 14.5 6.5625 15 6.5625 15C7.0625 15.2188 7.40625 16.125 7.40625 16.125C7.875 17.5312 10.0625 17.0625 10.0625 17.0625C10.0625 17.7188 10.0625 18.7812 10.0625 19C10.0625 19.1875 9.9375 19.4375 9.53125 19.375C6.40625 18.3125 4.25 15.3438 4.25 11.875C4.25 7.5625 7.5625 4.25 11.875 4.25ZM7.28125 15.0312C7.3125 15 7.375 15.0312 7.4375 15.0625C7.5 15.125 7.5 15.2188 7.46875 15.25C7.40625 15.2812 7.34375 15.25 7.28125 15.2188C7.25 15.1562 7.21875 15.0625 7.28125 15.0312ZM6.9375 14.7812C6.96875 14.75 7 14.75 7.0625 14.7812C7.125 14.8125 7.15625 14.8438 7.15625 14.875C7.125 14.9375 7.0625 14.9375 7 14.9062C6.9375 14.875 6.90625 14.8438 6.9375 14.7812ZM7.9375 15.9062C8 15.8438 8.09375 15.875 8.15625 15.9375C8.21875 16 8.21875 16.0938 8.1875 16.125C8.15625 16.1875 8.0625 16.1562 8 16.0938C7.90625 16.0312 7.90625 15.9375 7.9375 15.9062ZM7.59375 15.4375C7.65625 15.4062 7.71875 15.4375 7.78125 15.5C7.8125 15.5625 7.8125 15.6562 7.78125 15.6875C7.71875 15.7188 7.65625 15.6875 7.59375 15.625C7.53125 15.5625 7.53125 15.4688 7.59375 15.4375Z' }) })),
    googleDrive: (domProps) => (jsxs("svg", { ...baseSvgProps, ...domProps, height: '2168', preserveAspectRatio: 'xMidYMid', width: '2500', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 256 221.4', children: [jsxs("linearGradient", { id: 'a', x1: '0%', y1: '0%', y2: '100%', children: [jsx("stop", { offset: '0', stopColor: '#f6c338' }), jsx("stop", { offset: '.523', stopColor: '#ffd351' }), jsx("stop", { offset: '1', stopColor: '#f6c338' })] }), jsxs("linearGradient", { id: 'b', x1: '100%', x2: '0%', y1: '0%', y2: '100%', children: [jsx("stop", { offset: '0', stopColor: '#286ee6' }), jsx("stop", { offset: '.521', stopColor: '#4286fb' }), jsx("stop", { offset: '1', stopColor: '#286ee6' })] }), jsxs("linearGradient", { id: 'c', x1: '65.289%', x2: '35.995%', y1: '0%', y2: '100%', children: [jsx("stop", { offset: '0', stopColor: '#069b5a' }), jsx("stop", { offset: '.531', stopColor: '#11aa62' }), jsx("stop", { offset: '1', stopColor: '#069b5a' })] }), jsx("path", { d: 'M83.3 0h89L256 144.3h-89.2z', fill: 'url(#a)' }), jsx("path", { d: 'M256 144.3l-44.6 77.1h-167l44.7-77.1z', fill: 'url(#b)' }), jsx("path", { d: 'M44.4 221.4L0 144.3 83.3 0 128 77.3z', fill: 'url(#c)' }), jsx("path", { d: 'M44.4 221.4l83.1-77.1H89.1zM256 144.3h-89.1l-19.6-33.8zM83.3 0L109 110l19-32.7z', opacity: '.1' })] })),
    grid: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M5.617 3.283c-.583.068-1.098.327-1.552.781a2.721 2.721 0 00-.696 1.116l-.109.32v3l.109.32c.151.444.362.783.695 1.116.333.333.672.544 1.116.695l.32.109h3l.32-.109a2.743 2.743 0 001.116-.695c.333-.333.544-.672.695-1.116l.109-.32v-3l-.109-.32a2.721 2.721 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.41-.047-2.303-.045-2.712.002m10 0c-.583.068-1.098.327-1.552.781a2.721 2.721 0 00-.696 1.116l-.109.32v3l.109.32c.151.444.362.783.695 1.116.333.333.672.544 1.116.695l.32.109h3l.32-.109a2.743 2.743 0 001.116-.695c.333-.333.544-.672.695-1.116l.109-.32v-3l-.109-.32a2.721 2.721 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.41-.047-2.303-.045-2.712.002m-7.089 1.59c.239.118.481.36.599.599.092.185.093.208.093 1.528 0 1.322-.001 1.342-.093 1.529-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63-.091-.184-.093-.223-.105-1.449-.008-.882.002-1.311.035-1.43.062-.221.262-.501.467-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101m10 0c.239.118.481.36.599.599.092.185.093.208.093 1.528 0 1.322-.001 1.342-.093 1.529-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63-.091-.184-.093-.223-.105-1.449-.008-.882.002-1.311.035-1.43.062-.221.262-.501.467-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101m-12.911 8.41c-.583.068-1.098.327-1.552.781a2.721 2.721 0 00-.696 1.116l-.109.32v3l.109.32c.151.444.362.783.695 1.116.333.333.672.544 1.116.695l.32.109h3l.32-.109a2.743 2.743 0 001.116-.695c.333-.333.544-.672.695-1.116l.109-.32v-3l-.109-.32a2.721 2.721 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.41-.047-2.303-.045-2.712.002m10 0c-.583.068-1.098.327-1.552.781a2.721 2.721 0 00-.696 1.116l-.109.32v3l.109.32c.151.444.362.783.695 1.116.333.333.672.544 1.116.695l.32.109h3l.32-.109a2.743 2.743 0 001.116-.695c.333-.333.544-.672.695-1.116l.109-.32v-3l-.109-.32a2.721 2.721 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.41-.047-2.303-.045-2.712.002m-7.089 1.59c.239.118.481.36.599.599.092.185.093.208.093 1.528 0 1.322-.001 1.342-.093 1.529-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63-.091-.184-.093-.223-.105-1.449-.008-.882.002-1.311.035-1.43.062-.221.262-.501.467-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101m10 0c.239.118.481.36.599.599.092.185.093.208.093 1.528 0 1.322-.001 1.342-.093 1.529-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63-.091-.184-.093-.223-.105-1.449-.008-.882.002-1.311.035-1.43.062-.221.262-.501.467-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101' }) })),
    history: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5.5 7.34375C6.9375 5.34375 9.3125 4 12 4C16.4062 4 20 7.59375 20 12C20 16.4375 16.4062 20 12 20C10.3438 20 8.84375 19.5312 7.5625 18.6875C7.21875 18.4688 7.125 18 7.375 17.6562C7.59375 17.3125 8.0625 17.2188 8.40625 17.4375C9.4375 18.125 10.6562 18.5 12 18.5C15.5625 18.5 18.5 15.5938 18.5 12C18.5 8.4375 15.5625 5.5 12 5.5C9.6875 5.5 7.65625 6.71875 6.5 8.5H8.25C8.65625 8.5 9 8.84375 9 9.25C9 9.6875 8.65625 10 8.25 10H4.75C4.3125 10 4 9.6875 4 9.25V5.75C4 5.34375 4.3125 5 4.75 5C5.15625 5 5.5 5.34375 5.5 5.75V7.34375ZM12 8H11.9688C12.4062 8 12.7188 8.34375 12.7188 8.75V11.7188L14.75 13.75C15.0625 14.0312 15.0625 14.5 14.75 14.7812C14.4688 15.0938 14 15.0938 13.7188 14.7812L11.4688 12.5312C11.3125 12.4062 11.25 12.2188 11.25 12V8.75C11.25 8.34375 11.5625 8 12 8Z' }) })),
    hourglass: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M6.75 4H17.25C17.6562 4 18 4.34375 18 4.75C18 5.1875 17.6562 5.5 17.25 5.5H17V6.09375C17 7.375 16.5 8.5625 15.5938 9.46875L13.0312 12L15.5938 14.5625C16.5 15.4375 17 16.6562 17 17.9062V18.5H17.25C17.6562 18.5 18 18.8438 18 19.25C18 19.6875 17.6562 20 17.25 20H6.75C6.3125 20 6 19.6875 6 19.25C6 18.8438 6.3125 18.5 6.75 18.5H7V17.9062C7 16.6562 7.5 15.4375 8.375 14.5625L10.9375 12L8.375 9.46875C7.5 8.5625 7 7.375 7 6.09375V5.5H6.75C6.3125 5.5 6 5.1875 6 4.75C6 4.34375 6.3125 4 6.75 4ZM12 13.0625L9.4375 15.625C8.84375 16.2188 8.5 17.0625 8.5 17.9062V18.5H15.5V17.9062C15.5 17.0625 15.1562 16.2188 14.5312 15.625L12 13.0625ZM12 10.9375V10.9688L14.5312 8.40625C15.1562 7.78125 15.5 6.96875 15.5 6.09375V5.5H8.5V6.09375C8.5 6.96875 8.84375 7.78125 9.4375 8.40625L12 10.9375Z' }) })),
    info: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.32 2.28A9.74 9.74 0 003.258 7.7c-.46.94-.762 1.914-.924 2.98-.097.636-.097 2.004 0 2.64.446 2.941 2.052 5.409 4.533 6.968 1.075.676 2.441 1.17 3.813 1.378.636.097 2.004.097 2.64 0 2.1-.319 3.932-1.206 5.405-2.618 1.601-1.534 2.6-3.479 2.941-5.728.097-.636.097-2.004 0-2.64-.443-2.919-2.04-5.389-4.49-6.941-.824-.522-2.118-1.053-3.056-1.253a10.872 10.872 0 00-2.8-.206m2 1.578a8.277 8.277 0 014.628 2.435c1.176 1.231 1.913 2.713 2.2 4.423.1.593.1 1.975 0 2.568-.612 3.649-3.463 6.426-7.08 6.895-3.771.489-7.369-1.653-8.767-5.219a9.164 9.164 0 01-.449-1.676c-.1-.593-.1-1.975 0-2.568.299-1.783 1.066-3.282 2.324-4.54 1.389-1.388 2.977-2.138 5.064-2.391.313-.038 1.715.011 2.08.073m-1.521 3.418c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298m-1 3.999c-.371.078-.536.3-.538.725-.002.486.213.709.719.75l.257.021.011 1.744c.012 1.674.015 1.751.095 1.902.15.287.278.323 1.157.323.69 0 .774-.008.917-.083.221-.115.323-.325.322-.657-.002-.482-.202-.691-.709-.743l-.267-.028-.011-1.744c-.014-1.978-.009-1.95-.323-2.127-.157-.089-.216-.096-.829-.104-.363-.005-.723.004-.801.021' }) })),
    key: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, xmlns: 'http://www.w3.org/2000/svg', children: jsx("path", { d: 'M10.5 9.5C10.5 9.84375 10.5312 10.1562 10.5938 10.4688C10.6562 10.7188 10.5938 10.9688 10.4062 11.1562L5.5 16.0625V18.5H7.5V17.25C7.5 16.8438 7.8125 16.5 8.25 16.5H9.5V15.25C9.5 14.8438 9.8125 14.5 10.25 14.5H11.9375L12.8438 13.5938C13.0312 13.4062 13.2812 13.3438 13.5312 13.4062C13.8438 13.4688 14.1562 13.5 14.5 13.5C16.6875 13.5 18.5 11.7188 18.5 9.5C18.5 7.3125 16.6875 5.5 14.5 5.5C12.2812 5.5 10.5 7.3125 10.5 9.5ZM14.5 4C17.5312 4 20 6.46875 20 9.5C20 12.5625 17.5312 15 14.5 15C14.1875 15 13.9062 15 13.625 14.9375L12.7812 15.7812C12.625 15.9375 12.4375 16 12.25 16H11V17.25C11 17.6875 10.6562 18 10.25 18H9V19.25C9 19.6875 8.65625 20 8.25 20H4.75C4.3125 20 4 19.6875 4 19.25V15.75C4 15.5625 4.0625 15.375 4.21875 15.2188L9.0625 10.375C9 10.0938 9 9.8125 9 9.5C9 6.46875 11.4375 4 14.5 4ZM15.5 9.5C14.9375 9.5 14.5 9.0625 14.5 8.5C14.5 7.96875 14.9375 7.5 15.5 7.5C16.0312 7.5 16.5 7.96875 16.5 8.5C16.5 9.0625 16.0312 9.5 15.5 9.5Z' }) })),
    lightningBolt: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M12.807 2.279a.822.822 0 00-.27.147c-.075.063-2.189 2.624-4.697 5.693-3.505 4.286-4.572 5.616-4.605 5.738-.062.231.013.444.227.651a.98.98 0 00.326.209c.101.028 1.218.043 3.301.043h3.149l.011 3.25c.011 3.196.012 3.253.094 3.407.112.215.326.323.637.321a.874.874 0 00.37-.071c.085-.045 1.711-2.002 4.745-5.71 3.718-4.544 4.625-5.675 4.665-5.816.081-.292-.064-.585-.392-.789l-.148-.092-3.229-.011-3.229-.011-.011-3.249c-.01-3.026-.016-3.259-.082-3.392-.123-.247-.531-.397-.862-.318m-.464 8.138a.59.59 0 00.24.24c.153.081.225.083 2.983.103l2.827.02-3.315 4.052-3.316 4.052-.011-2.572c-.012-2.906.002-2.769-.322-2.955l-.169-.097-2.826-.02-2.827-.02 3.307-4.041 3.306-4.041.02 2.561c.019 2.49.022 2.565.103 2.718' }) })),
    link: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M16.527 2.284c-.729.065-1.519.349-2.18.782-.335.22-1.911 1.757-2.005 1.956a.57.57 0 00.017.535c.102.202.376.433.575.487.299.08.438-.011 1.306-.864.975-.958 1.205-1.118 1.868-1.309.45-.129 1.334-.129 1.784 0a3.325 3.325 0 012.237 2.237c.129.45.129 1.334 0 1.784a2.929 2.929 0 01-.47.968c-.095.132-1.204 1.266-2.466 2.521-2.372 2.358-2.447 2.425-2.995 2.646-.552.223-1.462.274-2.058.116a3.512 3.512 0 01-1.1-.561c-.552-.455-.639-.512-.813-.531-.449-.051-.94.503-.822.928.087.315.796.925 1.46 1.256.713.356 1.32.497 2.135.497 1.04 0 1.942-.286 2.76-.875.387-.278 4.876-4.773 5.131-5.137.562-.803.841-1.705.841-2.72 0-1.34-.488-2.488-1.45-3.413A4.65 4.65 0 0017.4 2.281a9.017 9.017 0 00-.48-.035c-.011.003-.188.02-.393.038m-6 6c-.727.065-1.515.347-2.18.781-.375.245-4.88 4.725-5.204 5.175-.589.818-.876 1.723-.876 2.76 0 1.292.439 2.372 1.343 3.306.914.943 2.062 1.426 3.39 1.426 1.016 0 1.92-.28 2.72-.842.324-.227 1.857-1.74 1.939-1.914.152-.32-.014-.693-.427-.954-.144-.091-.418-.092-.592-.002-.076.039-.5.425-.94.856-.812.794-1.028.96-1.5 1.15-.7.283-1.7.283-2.4 0a3.064 3.064 0 01-.988-.642c-.483-.45-.774-.91-.941-1.492-.129-.45-.129-1.334 0-1.784.108-.375.239-.646.471-.968.21-.293 4.606-4.681 4.858-4.849.287-.192.572-.323.908-.42.259-.074.411-.089.892-.089.481 0 .633.015.892.089.509.146.854.344 1.316.754.392.347.611.409.909.256.34-.173.559-.567.479-.859-.137-.495-1.389-1.345-2.356-1.6-.299-.079-1.22-.202-1.32-.176-.011.003-.188.02-.393.038' }) })),
    list: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M4.77419 5H6.32258C6.74194 5 7.09677 5.35484 7.09677 5.77419V7.32258C7.09677 7.77419 6.74194 8.09677 6.32258 8.09677H4.77419C4.32259 8.09677 4 7.77419 4 7.32258V5.77419C4 5.35484 4.32259 5 4.77419 5ZM9.41935 5.77419H19.2258C19.6452 5.77419 20 6.12903 20 6.54839C20 6.99999 19.6452 7.32258 19.2258 7.32258H9.41935C8.96775 7.32258 8.64516 6.99999 8.64516 6.54839C8.64516 6.12903 8.96775 5.77419 9.41935 5.77419ZM9.41935 10.9355H19.2258C19.6452 10.9355 20 11.2903 20 11.7097C20 12.1613 19.6452 12.4839 19.2258 12.4839H9.41935C8.96775 12.4839 8.64516 12.1613 8.64516 11.7097C8.64516 11.2903 8.96775 10.9355 9.41935 10.9355ZM9.41935 16.0968H19.2258C19.6452 16.0968 20 16.4516 20 16.871C20 17.3225 19.6452 17.6452 19.2258 17.6452H9.41935C8.96775 17.6452 8.64516 17.3225 8.64516 16.871C8.64516 16.4516 8.96775 16.0968 9.41935 16.0968ZM4 10.9355C4 10.5161 4.32259 10.1613 4.77419 10.1613H6.32258C6.74194 10.1613 7.09677 10.5161 7.09677 10.9355V12.4839C7.09677 12.9355 6.74194 13.2581 6.32258 13.2581H4.77419C4.32259 13.2581 4 12.9355 4 12.4839V10.9355ZM4.77419 15.3226H6.32258C6.74194 15.3226 7.09677 15.6774 7.09677 16.0968V17.6452C7.09677 18.0967 6.74194 18.4194 6.32258 18.4194H4.77419C4.32259 18.4194 4 18.0967 4 17.6452V16.0968C4 15.6774 4.32259 15.3226 4.77419 15.3226Z' }) })),
    listTimeline: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M10.8438 7.5H16.5V6.5H10.8438L10.3438 7L10.8438 7.5ZM8.59375 7.375C8.40625 7.1875 8.40625 6.84375 8.59375 6.65625L9.9375 5.3125C10.125 5.125 10.375 5 10.6562 5H17C17.5312 5 18 5.46875 18 6V8C18 8.5625 17.5312 9 17 9H10.6562C10.375 9 10.125 8.90625 9.9375 8.71875L8.59375 7.375ZM6 8C5.4375 8 5 7.5625 5 7C5 6.46875 5.4375 6 6 6C6.53125 6 7 6.46875 7 7C7 7.5625 6.53125 8 6 8ZM6 13C5.4375 13 5 12.5625 5 12C5 11.4688 5.4375 11 6 11C6.53125 11 7 11.4688 7 12C7 12.5625 6.53125 13 6 13ZM5 17C5 16.4688 5.4375 16 6 16C6.53125 16 7 16.4688 7 17C7 17.5625 6.53125 18 6 18C5.4375 18 5 17.5625 5 17ZM10.8438 17.5H16.5V16.5H10.8438L10.3438 17L10.8438 17.5ZM8.59375 17.375C8.40625 17.1875 8.40625 16.8438 8.59375 16.6562L9.9375 15.3125C10.125 15.125 10.375 15 10.6562 15H17C17.5312 15 18 15.4688 18 16V18C18 18.5625 17.5312 19 17 19H10.6562C10.375 19 10.125 18.9062 9.9375 18.7188L8.59375 17.375ZM10.3438 12L10.8438 12.5H18.5V11.5H10.8438L10.3438 12ZM9.9375 13.7188L8.59375 12.375C8.40625 12.1875 8.40625 11.8438 8.59375 11.6562L9.9375 10.3125C10.125 10.125 10.375 10 10.6562 10H19C19.5312 10 20 10.4688 20 11V13C20 13.5625 19.5312 14 19 14H10.6562C10.375 14 10.125 13.9062 9.9375 13.7188Z' }) })),
    lock: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.544 2.283c-1.955.173-3.655 1.626-4.14 3.538-.137.543-.163.977-.164 2.729v1.69h-.61c-1.366.001-1.918.178-2.565.824a2.742 2.742 0 00-.696 1.116l-.109.32v7l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h13l.32-.109a2.736 2.736 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-7l-.109-.32a2.742 2.742 0 00-.696-1.116c-.647-.646-1.199-.823-2.565-.824h-.61V8.55c-.001-.93-.019-1.852-.041-2.05a4.774 4.774 0 00-3.563-4.101c-.244-.062-1.152-.175-1.236-.153-.011.003-.18.019-.376.037m1.37 1.595c.508.146.893.372 1.321.78.436.416.725.877.892 1.428.085.283.089.366.103 2.224l.015 1.93h-6.49l.015-1.93c.014-1.858.018-1.941.103-2.224.158-.52.382-.898.785-1.321a3.113 3.113 0 011.775-.967c.321-.058 1.152-.013 1.481.08m5.614 7.995c.239.118.481.36.599.599l.093.188v6.68l-.093.189c-.132.268-.416.534-.674.63-.213.08-.297.081-6.453.081-6.156 0-6.24-.001-6.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.012-3.26c-.008-2.399.001-3.305.036-3.43.093-.34.433-.7.782-.828.131-.048 1.114-.056 6.454-.049l6.3.007.188.093m-6.729 2.403c-.212.043-.39.165-.468.322-.063.127-.071.278-.071 1.402 0 1.196.004 1.268.083 1.417.115.22.325.323.657.323s.542-.103.657-.323c.079-.149.083-.221.083-1.417 0-1.13-.007-1.275-.071-1.403-.123-.246-.516-.391-.87-.321' }) })),
    mail: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5.7 4.276c-1.295.024-1.326.026-1.607.129-.382.14-.785.414-1.101.749a2.573 2.573 0 0 0-.619 1.026l-.113.32-.011 5.48-.011 5.48.152.4c.19.499.372.776.744 1.129.343.326.597.478 1.079.647l.353.124H19.437l.383-.137c.467-.167.716-.32 1.069-.657.35-.334.563-.667.735-1.148l.139-.389-.012-5.464L21.74 6.5l-.117-.334a2.913 2.913 0 0 0-1.456-1.645c-.518-.258-.17-.245-6.967-.258a706.793 706.793 0 0 0-7.5.013m13.828 1.608c.228.117.442.325.565.55.095.175.111.259.133.694l.025.494-3.368 2.233c-4.172 2.765-4.433 2.931-4.688 2.966-.385.053-.54.001-1.16-.388a398.554 398.554 0 0 1-3.929-2.587L3.752 7.62l.018-.46c.02-.531.098-.761.342-1.013.303-.312.334-.321 1.226-.352.441-.015 3.779-.019 7.418-.009 6.506.018 6.618.02 6.772.098M7.094 11.633c3.723 2.47 3.643 2.42 4.01 2.546.778.269 1.616.18 2.312-.244.134-.081 1.708-1.12 3.498-2.307 2.568-1.704 3.263-2.147 3.293-2.104.025.036.032 1.471.02 3.939-.018 3.876-.019 3.884-.104 4.052a1.46 1.46 0 0 1-.58.598l-.203.107H4.66l-.188-.094c-.219-.108-.469-.365-.594-.61l-.088-.172-.021-3.826c-.019-3.513-.012-4.038.056-4.038.013 0 1.484.969 3.269 2.153' }) })),
    objectGroup: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M4.5 7.625C4.1875 7.34375 4 6.96875 4 6.5C4 5.6875 4.65625 5 5.5 5C5.9375 5 6.34375 5.21875 6.59375 5.5H17.375C17.6562 5.21875 18.0312 5 18.5 5C19.3125 5 20 5.6875 20 6.5C20 6.96875 19.7812 7.34375 19.5 7.625V16.4062C19.7812 16.6562 20 17.0625 20 17.5C20 18.3438 19.3125 19 18.5 19C18.0312 19 17.6562 18.8125 17.375 18.5H6.59375C6.34375 18.8125 5.9375 19 5.5 19C4.65625 19 4 18.3438 4 17.5C4 17.0625 4.1875 16.6562 4.5 16.4062V7.625ZM6.90625 7C6.75 7.4375 6.40625 7.78125 6 7.9375V16.0938C6.40625 16.25 6.75 16.5938 6.90625 17H17.0625C17.2188 16.5938 17.5625 16.25 18 16.0938V7.9375C17.5625 7.78125 17.2188 7.4375 17.0625 7H6.90625ZM7 9C7 8.46875 7.4375 8 8 8H12C12.5312 8 13 8.46875 13 9V12C13 12.5625 12.5312 13 12 13H8C7.4375 13 7 12.5625 7 12V9ZM11 14H12C13.0938 14 14 13.125 14 12V11H16C16.5312 11 17 11.4688 17 12V15C17 15.5625 16.5312 16 16 16H12C11.4375 16 11 15.5625 11 15V14Z' }) })),
    palette: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M18.5 12.0938C18.5 12.0625 18.5 12.0312 18.5 12C18.5 8.4375 15.5625 5.5 12 5.5C8.40625 5.5 5.5 8.4375 5.5 12C5.5 15.5938 8.40625 18.5 12 18.5C12.0625 18.5 12.1562 18.5 12.25 18.5C12.2812 18.5 12.2812 18.5 12.3125 18.5C12.3125 18.5 12.3438 18.4688 12.375 18.4375C12.4375 18.375 12.5 18.25 12.5 18.0625C12.5 18.0312 12.4688 17.9062 12.3125 17.5312C12.2812 17.5 12.2812 17.4375 12.25 17.4062C12.125 17.0938 11.9062 16.625 11.8125 16.125C11.75 15.9375 11.75 15.7188 11.75 15.5C11.75 13.8438 13.0938 12.5 14.75 12.5H17.8125C18.0312 12.5 18.25 12.4375 18.3438 12.3438C18.4688 12.25 18.5 12.1562 18.5 12.0938ZM20 12.0938C19.9688 13.25 18.9375 14 17.8125 14H14.75C13.9062 14 13.25 14.6875 13.25 15.5C13.25 15.625 13.25 15.7188 13.2812 15.8125C13.3438 16.1562 13.4688 16.4375 13.5938 16.75C13.7812 17.1875 14 17.625 14 18.0625C14 19.0625 13.3125 19.9688 12.3125 20C12.2188 20 12.0938 20 12 20C7.5625 20 4 16.4375 4 12C4 7.59375 7.5625 4 12 4C16.4062 4 20 7.59375 20 12C20 12.0312 20 12.0625 20 12.0938ZM9 12C9 12.5625 8.53125 13 8 13C7.4375 13 7 12.5625 7 12C7 11.4688 7.4375 11 8 11C8.53125 11 9 11.4688 9 12ZM9 10C8.4375 10 8 9.5625 8 9C8 8.46875 8.4375 8 9 8C9.53125 8 10 8.46875 10 9C10 9.5625 9.53125 10 9 10ZM13 8C13 8.5625 12.5312 9 12 9C11.4375 9 11 8.5625 11 8C11 7.46875 11.4375 7 12 7C12.5312 7 13 7.46875 13 8ZM15 10C14.4375 10 14 9.5625 14 9C14 8.46875 14.4375 8 15 8C15.5312 8 16 8.46875 16 9C16 9.5625 15.5312 10 15 10Z' }) })),
    pen: (domProps) => (jsxs("svg", { ...baseSvgProps, ...domProps, children: [jsx("path", { d: 'M5.125 15.2812C5.25 14.8438 5.5 14.4375 5.8125 14.125L15.3125 4.625C16.0938 3.84375 17.375 3.84375 18.1562 4.625L19.375 5.84375C19.4688 5.9375 19.5625 6.0625 19.625 6.15625C20.1562 6.9375 20.0625 8 19.375 8.6875L9.875 18.1875C9.84375 18.2188 9.78125 18.25 9.75 18.3125C9.4375 18.5625 9.09375 18.75 8.71875 18.875L6.28125 19.5938L4.9375 20C4.6875 20.0625 4.40625 20 4.21875 19.7812C4 19.5938 3.9375 19.3125 4.03125 19.0625L4.40625 17.7188L5.125 15.2812ZM6.5625 15.7188L6.34375 16.4375L5.84375 18.1562L7.5625 17.6562L8.28125 17.4375C8.5 17.375 8.65625 17.2812 8.8125 17.125L15.9688 9.96875L14.0312 8.03125L6.875 15.1875C6.84375 15.1875 6.84375 15.2188 6.8125 15.25C6.6875 15.375 6.625 15.5312 6.5625 15.7188Z' }), ' '] })),
    penSlash: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M1.39062 2.64062L6.6875 6.76562L10.4844 2.96875C11.0703 2.38281 12.0312 2.38281 12.6172 2.96875L13.5312 3.88281C13.6016 3.95312 13.6719 4.04688 13.7188 4.11719C14.1172 4.70312 14.0469 5.5 13.5312 6.01562L10.0859 9.4375L15.2656 13.5156C15.5234 13.7031 15.5703 14.0547 15.3594 14.2891C15.1719 14.5469 14.8203 14.5938 14.5859 14.3828L0.710938 3.50781C0.453125 3.32031 0.40625 2.96875 0.617188 2.73438C0.804688 2.47656 1.15625 2.42969 1.39062 2.64062ZM7.57812 7.46875L9.19531 8.75781L10.9766 6.97656L9.52344 5.52344L7.57812 7.46875ZM4.15625 10.8906C4.13281 10.8906 4.13281 10.9141 4.10938 10.9375C4.01562 11.0312 3.96875 11.1484 3.92188 11.2891L3.75781 11.8281L3.38281 13.1172L4.67188 12.7422L5.21094 12.5781C5.35156 12.5312 5.49219 12.4609 5.60938 12.3438L7.60156 10.3516L8.49219 11.0547L6.40625 13.1406C6.38281 13.1641 6.33594 13.1875 6.3125 13.2344C6.07812 13.4219 5.82031 13.5625 5.53906 13.6562L3.71094 14.1953L2.70312 14.4766C2.51562 14.5469 2.30469 14.5 2.16406 14.3359C2 14.1953 1.95312 13.9844 2.02344 13.7969L2.30469 12.7891L2.84375 10.9609C2.9375 10.6328 3.125 10.3281 3.35938 10.0938L5.07031 8.38281L5.96094 9.08594L4.15625 10.8906Z' }) })),
    planetRinged: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M18.5 5C18.5 4.96875 18.4688 4.96875 18.4688 4.96875H18.4375V5C18.4375 5.03125 18.4375 5.03125 18.4375 5.03125C18.4688 5.03125 18.4688 5.03125 18.5 5.03125C18.5 5 18.5 5 18.5 5ZM18.3125 5.6875C17.9375 5.8125 17.4688 6.03125 16.9062 6.375C16.5 6 16.0312 5.6875 15.5625 5.4375C17.5625 4.15625 19.125 3.65625 19.7188 4.28125C20.4375 4.96875 19.6562 6.9375 17.9375 9.375C18.2812 10.1875 18.5 11.0625 18.5 12C18.5 15.5938 15.5625 18.5 12 18.5C11.0625 18.5 10.1562 18.3125 9.34375 17.9688C6.90625 19.6875 4.9375 20.4375 4.25 19.75C3.625 19.1562 4.125 17.5938 5.40625 15.5938C5.65625 16.0625 5.96875 16.5312 6.34375 16.9375C6 17.5 5.78125 17.9688 5.65625 18.3438C6.03125 18.2188 6.53125 17.9688 7.15625 17.5938C7.40625 17.4688 7.6875 17.2812 7.9375 17.0938C6.4375 15.9062 5.5 14.0625 5.5 12C5.5 8.4375 8.40625 5.5 12 5.5C14.0625 5.5 15.875 6.46875 17.0938 7.96875C17.25 7.6875 17.4375 7.4375 17.5938 7.1875C17.9375 6.5625 18.1875 6.0625 18.3125 5.6875ZM16.1562 9.25C15.2812 7.90625 13.7188 7 12 7C9.21875 7 7 9.25 7 12C7 13.75 7.875 15.2812 9.21875 16.1875C10.4062 15.3125 11.6562 14.2188 12.9062 12.9375C14.1875 11.6875 15.2812 10.4062 16.1562 9.25ZM10.7812 16.875C11.1875 16.9688 11.5625 17 12 17C14.75 17 17 14.7812 17 12C17 11.5938 16.9375 11.2188 16.8438 10.8125C16 11.8438 15.0625 12.9375 13.9688 14C12.9062 15.0625 11.8125 16.0312 10.7812 16.875ZM4.96875 18.5C4.96875 18.5312 4.96875 18.5312 5 18.5312C5 18.5 5 18.5 5 18.4688C5 18.4688 5 18.4688 4.96875 18.4688H4.9375V18.5C4.9375 18.5 4.9375 18.5312 4.96875 18.5ZM5.46875 19C5.46875 19.0312 5.46875 19.0312 5.46875 19.0625H5.5C5.53125 19.0625 5.53125 19.0625 5.53125 19.0625C5.5625 19.0312 5.5625 19.0312 5.53125 19C5.53125 19 5.53125 19 5.5 19C5.5 19 5.5 19 5.46875 19ZM19 5.5C18.9688 5.53125 18.9688 5.53125 18.9688 5.53125C18.9688 5.5625 18.9688 5.5625 18.9688 5.5625C19 5.59375 19 5.59375 19.0312 5.5625C19.0312 5.5625 19.0312 5.5625 19.0312 5.53125V5.5C19 5.5 19 5.5 19 5.5Z' }) })),
    pin: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M15.58 3.076c-.317.148-.812.79-1.016 1.321-.157.408-.21.729-.2 1.216l.008.407-2.776 2.191c-1.527 1.206-2.87 2.265-2.984 2.354l-.209.162-.402-.143c-1.007-.358-2.011-.411-2.918-.155-.544.153-1.225.556-1.653.978-.354.349-.418.608-.24.973.032.066.925.988 1.983 2.05l1.925 1.929-1.586 1.591c-1.727 1.732-1.669 1.657-1.622 2.072.052.459.572.742 1.021.557.101-.042.645-.557 1.699-1.61l1.55-1.548 1.81 1.808c1.237 1.235 1.857 1.827 1.959 1.869.183.076.432.08.602.008.255-.107.798-.767 1.058-1.286.319-.636.432-1.209.399-2.03-.021-.543-.114-1.045-.266-1.445-.035-.091-.032-.134.013-.2.031-.047 1.082-1.442 2.335-3.1l2.277-3.015.537-.01c.556-.01.729-.045 1.206-.245.317-.133.619-.332.909-.601.353-.327.444-.543.36-.861-.04-.155-.301-.43-2.532-2.667-1.69-1.695-2.538-2.518-2.647-2.569a.67.67 0 00-.6-.001m3.86 5.332c0 .054-.34.121-.606.119-.616-.006-1.236-.331-1.918-1.007-.727-.722-1.045-1.322-1.049-1.98-.001-.176.022-.39.051-.475l.052-.155 1.735 1.735c.954.954 1.735 1.748 1.735 1.763m-4.193-.492c.287.386.841.935 1.253 1.244.176.132.334.24.35.24.017 0 .03.018.03.04 0 .022-.889 1.218-1.975 2.657l-1.974 2.617-.381-.507a12.308 12.308 0 00-2.351-2.385c-.186-.143-.339-.276-.339-.296 0-.02 1.143-.938 2.54-2.04 2.139-1.687 2.546-1.993 2.58-1.939.022.036.142.202.267.369m-8.464 3.886c1.095.193 2.35.94 3.512 2.091 1.688 1.672 2.481 3.448 2.129 4.77-.062.232-.223.617-.259.617-.037 0-7.165-7.135-7.165-7.172 0-.054.42-.229.688-.287a3.27 3.27 0 011.095-.019' }) })),
    plus: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M11.614 3.344c-.28.138-.31.208-.34.789-.015.29-.028 2.005-.03 3.811l-.004 3.284-3.758.021c-3.583.02-3.763.024-3.885.096-.265.155-.388.477-.32.84a.646.646 0 0 0 .327.475c.133.078.221.08 3.883.093l3.746.014.014 3.746c.013 3.696.014 3.749.095 3.887a.708.708 0 0 0 .496.335c.353.057.664-.071.82-.335.081-.138.082-.192.095-3.887l.014-3.746 3.746-.014c3.662-.013 3.75-.015 3.883-.093a.646.646 0 0 0 .327-.475c.068-.363-.055-.685-.32-.84-.122-.072-.302-.076-3.882-.096l-3.754-.021-.013-3.744c-.014-3.673-.016-3.747-.095-3.884-.163-.282-.717-.418-1.045-.256' }) })),
    questionCircle: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.32 2.28A9.74 9.74 0 003.258 7.7c-.46.94-.762 1.914-.924 2.98-.097.636-.097 2.004 0 2.64.446 2.941 2.052 5.409 4.533 6.968 1.075.676 2.441 1.17 3.813 1.378.636.097 2.004.097 2.64 0 2.1-.319 3.932-1.206 5.405-2.618 1.601-1.534 2.6-3.479 2.941-5.728.097-.636.097-2.004 0-2.64-.443-2.919-2.04-5.389-4.49-6.941-.824-.522-2.118-1.053-3.056-1.253a10.872 10.872 0 00-2.8-.206m2 1.578a8.277 8.277 0 014.628 2.435c1.176 1.231 1.913 2.713 2.2 4.423.1.593.1 1.975 0 2.568-.612 3.649-3.463 6.426-7.08 6.895-3.771.489-7.369-1.653-8.767-5.219a9.164 9.164 0 01-.449-1.676c-.1-.593-.1-1.975 0-2.568.299-1.783 1.066-3.282 2.324-4.54 1.389-1.388 2.977-2.138 5.064-2.391.313-.038 1.715.011 2.08.073m-1.88 2.425c-1.257.107-2.4.619-3.2 1.433-.512.52-.843 1.141-.783 1.465.064.338.494.602.952.583.155-.006.356-.2.554-.534.429-.727 1.275-1.244 2.31-1.415a5.172 5.172 0 011.85.078c.89.229 1.646.774 1.963 1.415.165.332.198.795.084 1.156-.194.61-.77 1.164-1.533 1.474a6.26 6.26 0 01-.665.203c-.52.131-.891.315-1.146.57-.395.393-.558.761-.563 1.269-.005.521.226.76.737.76.46 0 .687-.196.745-.642.036-.283.158-.399.499-.476 1.042-.237 1.827-.649 2.479-1.299.708-.708 1.017-1.417 1.009-2.323-.005-.73-.218-1.348-.67-1.949-.589-.784-1.696-1.444-2.797-1.669-.287-.059-1.173-.147-1.365-.135-.044.002-.251.019-.46.036m.359 9.993c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298' }) })),
    search: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M9.369 2.283A7.858 7.858 0 005.1 4c-.382.314-1.038.996-1.307 1.361-1.118 1.512-1.669 3.403-1.52 5.209.06.726.164 1.233.391 1.905a7.348 7.348 0 001.773 2.898c.688.706 1.238 1.115 2.079 1.543a7.763 7.763 0 004.054.811 7.259 7.259 0 001.905-.391 7.634 7.634 0 002.158-1.128l.294-.22 2.866 2.863c3.148 3.143 3.007 3.021 3.372 2.912.218-.065.533-.38.598-.598.109-.365.231-.224-2.912-3.372l-2.863-2.866.22-.294c1.104-1.468 1.671-3.412 1.518-5.203a7.384 7.384 0 00-.39-1.905 7.37 7.37 0 00-1.754-2.88c-.702-.724-1.295-1.159-2.162-1.587a7.541 7.541 0 00-2.869-.777c-.577-.044-.579-.044-1.182.002m1.771 1.575c.198.036.575.137.838.225a6.283 6.283 0 014.168 4.802c.098.521.098 1.709 0 2.23a6.723 6.723 0 01-.853 2.195c-.514.808-1.278 1.566-2.04 2.024a6.854 6.854 0 01-2.019.793c-.355.078-.531.091-1.234.091s-.879-.013-1.234-.091a6.842 6.842 0 01-2.019-.793c-.629-.376-1.388-1.088-1.839-1.723a6.706 6.706 0 01-1.055-2.491c-.097-.523-.097-1.713-.001-2.232.488-2.633 2.625-4.69 5.268-5.07.481-.07 1.529-.049 2.02.04' }) })),
    selector: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.74 4.279c-.103.051-.934.855-2.307 2.23-2.359 2.364-2.304 2.298-2.196 2.656.065.218.38.533.598.598.354.106.322.133 2.335-1.876L12 6.062l1.83 1.825c2.013 2.009 1.981 1.982 2.335 1.876.218-.065.533-.38.598-.598.108-.358.163-.292-2.197-2.656-1.422-1.426-2.201-2.178-2.309-2.23-.205-.1-.316-.099-.517 0M7.729 14.285c-.209.103-.435.36-.496.563-.103.344-.151.288 2.24 2.679 2.408 2.407 2.33 2.343 2.697 2.236.148-.043.458-.338 2.357-2.236 2.404-2.404 2.344-2.332 2.236-2.692-.065-.218-.38-.533-.598-.598-.354-.106-.322-.133-2.335 1.876L12 17.938l-1.81-1.807C8.396 14.339 8.237 14.2 7.991 14.2a.8.8 0 00-.262.085' }) })),
    sidebar: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M11 6.5V17.5H18C18.25 17.5 18.5 17.2812 18.5 17V7C18.5 6.75 18.25 6.5 18 6.5H11ZM4 7C4 5.90625 4.875 5 6 5H18C19.0938 5 20 5.90625 20 7V17C20 18.125 19.0938 19 18 19H6C4.875 19 4 18.125 4 17V7ZM6 7.75C6 8.1875 6.3125 8.5 6.75 8.5H8.25C8.65625 8.5 9 8.1875 9 7.75C9 7.34375 8.65625 7 8.25 7H6.75C6.3125 7 6 7.34375 6 7.75ZM6.75 10C6.3125 10 6 10.3438 6 10.75C6 11.1875 6.3125 11.5 6.75 11.5H8.25C8.65625 11.5 9 11.1875 9 10.75C9 10.3438 8.65625 10 8.25 10H6.75ZM6 13.75C6 14.1875 6.3125 14.5 6.75 14.5H8.25C8.65625 14.5 9 14.1875 9 13.75C9 13.3438 8.65625 13 8.25 13H6.75C6.3125 13 6 13.3438 6 13.75Z' }) })),
    sink: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M12.75 6.75V13H15V12.25C15 11.3125 15.7812 10.5 16.75 10.5H18.5C18.9062 10.5 19.25 10.8438 19.25 11.25C19.25 11.6875 18.9062 12 18.5 12H16.75C16.5938 12 16.5 12.125 16.5 12.25V13H19.25C19.6562 13 20 13.3438 20 13.75C20 14.1875 19.6562 14.5 19.25 14.5H12H4.75C4.3125 14.5 4 14.1875 4 13.75C4 13.3438 4.3125 13 4.75 13H7.5V12.25C7.5 12.125 7.375 12 7.25 12H5.75C5.3125 12 5 11.6875 5 11.25C5 10.8438 5.3125 10.5 5.75 10.5H7.25C8.1875 10.5 9 11.3125 9 12.25V13H11.25V6.75C11.25 5.25 12.4688 4 14 4C15.5 4 16.75 5.25 16.75 6.75V7.5C16.75 7.9375 16.4062 8.25 16 8.25C15.5625 8.25 15.25 7.9375 15.25 7.5V6.75C15.25 6.0625 14.6875 5.5 14 5.5C13.2812 5.5 12.75 6.0625 12.75 6.75ZM5 15.5H6.5V16.25C6.5 17.5 7.5 18.5 8.75 18.5H15.25C16.4688 18.5 17.5 17.5 17.5 16.25V15.5H19V16.25C19 18.3438 17.3125 20 15.25 20H8.75C6.65625 20 5 18.3438 5 16.25V15.5Z' }) })),
    spaceShip: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M6.39551 9.50391L5.93066 9.94141C5.82129 9.83203 5.7666 9.69531 5.73926 9.55859C5.73926 9.39453 5.71191 9.23047 5.73926 9.09375C4.8916 9.3125 4.23535 9.61328 3.74316 9.94141C3.08691 10.4062 2.89551 10.7891 2.89551 11.0898C2.89551 11.3086 2.97754 11.582 3.30566 11.8828C3.63379 12.2109 4.15332 12.5117 4.83691 12.7852C6.2041 13.332 8.14551 13.6875 10.333 13.6875C12.4932 13.6875 14.4346 13.332 15.8018 12.7852C16.4854 12.5117 16.9775 12.2109 17.3057 11.8828C17.6338 11.582 17.7432 11.3086 17.7432 11.0898C17.7432 10.7891 17.5518 10.4062 16.8955 9.94141C16.4033 9.61328 15.7197 9.3125 14.8994 9.09375C14.8994 9.23047 14.8994 9.39453 14.8994 9.55859C14.8721 9.69531 14.8174 9.83203 14.708 9.94141L14.2432 9.50391C14.708 9.94141 14.708 9.94141 14.708 9.94141V9.96875H14.6807C14.6807 9.99609 14.6533 10.0234 14.626 10.0508C14.5713 10.0781 14.5166 10.1328 14.4072 10.2148C14.2432 10.3516 13.9697 10.5156 13.6143 10.6797C12.9033 10.9805 11.8369 11.3086 10.3057 11.3086C8.80176 11.3086 7.73535 10.9805 7.02441 10.6797C6.66895 10.5156 6.39551 10.3516 6.23145 10.2148C6.12207 10.1328 6.06738 10.0781 6.0127 10.0508C5.98535 10.0234 5.95801 9.99609 5.95801 9.96875C5.93066 9.96875 5.93066 9.96875 5.93066 9.96875V9.94141C5.93066 9.94141 5.93066 9.94141 6.39551 9.50391ZM14.6807 7.67188C15.8564 7.94531 16.8682 8.35547 17.6338 8.875C18.4268 9.39453 19.083 10.1602 19.083 11.0898C19.083 11.7734 18.7275 12.375 18.2354 12.8398C17.7432 13.3047 17.0596 13.6875 16.2939 14.0156C14.7354 14.6445 12.6299 15 10.333 15C8.03613 15 5.90332 14.6445 4.34473 14.0156C3.5791 13.6875 2.89551 13.3047 2.40332 12.8398C1.91113 12.375 1.58301 11.7734 1.58301 11.0898C1.58301 10.1602 2.21191 9.39453 3.00488 8.875C3.77051 8.35547 4.78223 7.94531 5.95801 7.67188C6.58691 5.78516 8.33691 4.5 10.333 4.5C12.3018 4.5 14.0518 5.78516 14.6807 7.67188ZM13.6143 9.17578C13.6143 7.26172 12.1104 5.8125 10.333 5.8125C8.55566 5.8125 7.02441 7.26172 7.05176 9.17578C7.16113 9.25781 7.3252 9.36719 7.57129 9.47656C8.09082 9.72266 8.99316 9.99609 10.333 9.99609C11.6455 9.99609 12.5479 9.72266 13.0674 9.47656C13.3135 9.36719 13.4775 9.25781 13.6143 9.17578ZM5.73926 11.2812C5.73926 11.6641 5.43848 11.9375 5.08301 11.9375C4.7002 11.9375 4.42676 11.6641 4.42676 11.2812C4.42676 10.9258 4.7002 10.625 5.08301 10.625C5.43848 10.625 5.73926 10.9258 5.73926 11.2812ZM10.9893 12.375C10.9893 12.7578 10.6885 13.0312 10.333 13.0312C9.9502 13.0312 9.67676 12.7578 9.67676 12.375C9.67676 12.0195 9.9502 11.7188 10.333 11.7188C10.6885 11.7188 10.9893 12.0195 10.9893 12.375ZM15.583 11.9375C15.2002 11.9375 14.9268 11.6641 14.9268 11.2812C14.9268 10.9258 15.2002 10.625 15.583 10.625C15.9385 10.625 16.2393 10.9258 16.2393 11.2812C16.2393 11.6641 15.9385 11.9375 15.583 11.9375Z' }) })),
    sparkles: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.799 2.276c-.212.043-.39.165-.468.322-.059.117-.073.273-.084.888l-.013.745-.747.015c-.7.014-.758.021-.916.111-.221.126-.308.307-.31.643-.001.332.101.542.322.657.139.074.242.084.904.096l.747.013.013.747c.015.863.054.997.336 1.144.216.114.618.114.834 0 .282-.147.321-.281.336-1.144l.013-.747.747-.013c.662-.012.765-.022.904-.096.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.643-.158-.09-.216-.097-.916-.111l-.747-.015-.013-.745c-.015-.85-.049-.974-.304-1.115a1.077 1.077 0 00-.65-.095m7.813.042a.765.765 0 00-.2.187c-.04.059-.576 1.611-1.192 3.447L10.1 9.291l-2.754 1.031c-1.759.658-2.79 1.065-2.855 1.124-.335.309-.33.915.008 1.137.057.037 1.34.531 2.852 1.097l2.749 1.029 1.122 3.351c1.071 3.197 1.129 3.356 1.267 3.482.336.308.878.285 1.099-.047.04-.059.576-1.611 1.192-3.447l1.12-3.339 2.76-1.033c2.481-.928 2.773-1.047 2.887-1.171.204-.221.276-.627.154-.864a.717.717 0 00-.187-.205c-.07-.05-1.362-.553-2.871-1.118L15.9 9.291l-1.12-3.343c-1.225-3.656-1.169-3.522-1.533-3.646-.246-.084-.48-.078-.635.016m1.203 5.507c.692 2.078.812 2.405.928 2.533.121.134.296.208 2.094.881 1.08.404 1.963.747 1.963.761 0 .014-.832.337-1.85.718a72.392 72.392 0 00-1.995.766.915.915 0 00-.246.193c-.073.086-.33.805-.895 2.502-.436 1.309-.803 2.381-.814 2.381-.011 0-.378-1.072-.814-2.381-.565-1.697-.822-2.416-.895-2.502a.915.915 0 00-.246-.193c-.08-.041-.977-.385-1.995-.766-1.017-.381-1.85-.704-1.85-.718 0-.014.883-.357 1.963-.761 1.798-.673 1.973-.747 2.094-.881.116-.128.236-.455.928-2.533.437-1.312.804-2.385.815-2.385.011 0 .378 1.073.815 2.385m-8.016 8.451c-.212.043-.39.165-.468.322-.059.117-.073.273-.084.888l-.013.745-.747.015c-.7.014-.758.021-.916.111-.221.126-.308.307-.31.643-.001.332.101.542.322.657.139.074.242.084.904.096l.747.013.013.747c.012.662.022.765.096.904.115.22.325.323.657.323s.542-.103.657-.323c.074-.139.084-.242.096-.904l.013-.747.747-.013c.662-.012.765-.022.904-.096.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.643-.158-.09-.216-.097-.916-.111l-.747-.015-.013-.745c-.015-.85-.049-.974-.304-1.115a1.077 1.077 0 00-.65-.095' }) })),
    table: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.617 5.283c-.583.068-1.098.327-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32v9l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h15l.32-.109a2.736 2.736 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-9l-.109-.32a2.742 2.742 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.426-.049-14.293-.047-14.712.002m14.911 1.59c.239.118.481.36.599.599.086.174.094.247.105.978l.013.79H3.76v-.735c0-.806.027-.948.236-1.233.14-.19.38-.373.59-.45.131-.048 1.254-.056 7.454-.049l7.3.007.188.093M11.24 12v1.24H3.76v-2.48h7.48V12m9 0v1.24h-7.48v-2.48h7.48V12m-9 4v1.24H8.002c-3.15 0-3.245-.002-3.455-.081-.258-.096-.542-.362-.674-.63-.086-.175-.094-.246-.105-.979l-.013-.79H11.24V16m8.992-.45c-.011.733-.019.804-.105.979-.132.268-.416.534-.674.63-.21.079-.305.081-3.455.081H12.76v-2.48H20.245l-.013.79' }) })),
    tableDot: (domProps) => (jsxs("svg", { ...baseSvgProps, ...domProps, children: [jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M16.0558 5.25049C16.019 5.49498 16 5.74526 16 6C16 6.2642 16.0205 6.52361 16.06 6.77674L12.04 6.77288C5.84001 6.76588 4.71701 6.77388 4.58601 6.82188C4.37601 6.89888 4.13601 7.08188 3.99601 7.27188C3.78701 7.55688 3.76001 7.69888 3.76001 8.50488V9.23988H17.1916C17.7867 9.93874 18.5707 10.4717 19.4647 10.7599H12.76V13.2399H20.24V11.9999V10.9426C20.4878 10.9804 20.7416 11 21 11C21.2514 11 21.4985 10.9814 21.74 10.9456V16.4999L21.631 16.8199C21.48 17.2649 21.269 17.6029 20.936 17.9359C20.626 18.2548 20.243 18.4934 19.82 18.6309L19.5 18.7399H4.50001L4.18001 18.6309C3.73501 18.4799 3.39701 18.2689 3.06401 17.9359C2.73101 17.6029 2.52001 17.2649 2.36901 16.8199L2.26001 16.4999V7.49988L2.36901 7.17988C2.50703 6.75693 2.74591 6.37391 3.06501 6.06388C3.51901 5.60988 4.03401 5.35088 4.61701 5.28288C4.91062 5.24855 11.8075 5.23729 16.0558 5.25049ZM11.24 13.2399V11.9999V10.7599H3.76001V13.2399H11.24ZM11.24 17.2399V15.9999V14.7599H3.75501L3.76801 15.5499C3.77901 16.2829 3.78701 16.3539 3.87301 16.5289C4.00501 16.7969 4.28901 17.0629 4.54701 17.1589C4.75701 17.2379 4.85201 17.2399 8.00201 17.2399H11.24ZM20.127 16.5289C20.213 16.3539 20.221 16.2829 20.232 15.5499L20.245 14.7599H12.76V17.2399H15.998C19.148 17.2399 19.243 17.2379 19.453 17.1589C19.711 17.0629 19.995 16.7969 20.127 16.5289Z' }), jsx("path", { d: 'M18 6C18 4.34315 19.3431 3 21 3V3C22.6569 3 24 4.34315 24 6V6C24 7.65685 22.6569 9 21 9V9C19.3431 9 18 7.65685 18 6V6Z', className: 'table-dot-dot' })] })),
    trash: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M9.701 2.285c-.332.048-.638.212-.925.495-.483.477-.534.695-.535 2.288L8.24 6.236l-2.25.012-2.25.012-.169.097c-.221.126-.308.308-.31.643-.002.495.208.706.749.754l.289.026.406 5.72c.251 3.543.431 5.849.473 6.06.196 1 .967 1.818 1.983 2.106.245.07.514.074 4.819.074 3.731 0 4.6-.01 4.78-.055 1.031-.257 1.826-1.056 2.053-2.065.041-.178.213-2.382.475-6.065l.412-5.786.285-.018c.537-.035.756-.252.754-.751-.002-.335-.089-.517-.31-.643l-.169-.097-2.25-.012-2.25-.012-.001-1.168c-.001-1.593-.052-1.811-.535-2.288-.296-.292-.592-.445-.964-.498-.342-.049-4.22-.047-4.559.003m4.466 1.541c.068.061.073.154.073 1.24V6.24H9.76V5.073c0-1.029.008-1.175.066-1.24.063-.069.183-.073 2.167-.073 1.899 0 2.108.006 2.174.066m4.009 4.124c-.01.105-.198 2.706-.417 5.78l-.397 5.59-.108.222c-.12.245-.32.446-.582.586l-.172.092h-9l-.172-.092a1.327 1.327 0 01-.583-.589l-.111-.226-.394-5.546c-.217-3.051-.405-5.65-.417-5.777l-.022-.23h12.395l-.02.19m-8.377 2.326c-.212.043-.39.165-.468.322-.066.132-.071.366-.071 3.402 0 3.216.001 3.262.083 3.417.115.22.325.323.657.323s.542-.103.657-.323c.082-.155.083-.201.083-3.417 0-3.05-.005-3.269-.071-3.403-.123-.246-.516-.391-.87-.321m4 0c-.212.043-.39.165-.468.322-.066.132-.071.366-.071 3.402 0 3.216.001 3.262.083 3.417.115.22.325.323.657.323s.542-.103.657-.323c.082-.155.083-.201.083-3.417 0-3.05-.005-3.269-.071-3.403-.123-.246-.516-.391-.87-.321' }) })),
    truck: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M13 5.5H6C5.71875 5.5 5.5 5.75 5.5 6V7H9.5C9.75 7 10 7.25 10 7.5C10 7.78125 9.75 8 9.5 8H2.5C2.21875 8 2 7.78125 2 7.5C2 7.25 2.21875 7 2.5 7H4V6C4 4.90625 4.875 4 6 4H13C14.0938 4 15 4.90625 15 6V7H16.3125C16.7812 7 17.2188 7.1875 17.5625 7.53125L20.4688 10.4375C20.8125 10.7812 21 11.2188 21 11.6875V15.5H21.25C21.6562 15.5 22 15.8438 22 16.25C22 16.6875 21.6562 17 21.25 17H20C20 18.6562 18.6562 20 17 20C15.3438 20 14 18.6562 14 17H13.75H13H12H10C10 18.6562 8.65625 20 7 20C5.34375 20 4 18.6562 4 17V15.5V13H5.5V14.4062C5.9375 14.1562 6.4375 14 7 14C8.09375 14 9.0625 14.625 9.59375 15.5H12H13C13.25 15.5 13.5 15.2812 13.5 15V6C13.5 5.75 13.25 5.5 13 5.5ZM19.4062 11.5L16.5 8.59375C16.4375 8.53125 16.375 8.5 16.3125 8.5H15V11.5H19.4375H19.4062ZM8.5 17C8.5 16.4688 8.1875 16 7.75 15.7188C7.28125 15.4375 6.6875 15.4375 6.25 15.7188C5.78125 16 5.5 16.4688 5.5 17C5.5 17.5625 5.78125 18.0312 6.25 18.3125C6.6875 18.5938 7.28125 18.5938 7.75 18.3125C8.1875 18.0312 8.5 17.5625 8.5 17ZM17 18.5C17.5312 18.5 18 18.2188 18.2812 17.75C18.5625 17.3125 18.5625 16.7188 18.2812 16.25C18 15.8125 17.5312 15.5 17 15.5C16.4375 15.5 15.9688 15.8125 15.6875 16.25C15.4062 16.7188 15.4062 17.3125 15.6875 17.75C15.9688 18.2188 16.4375 18.5 17 18.5ZM3.5 9H10.5C10.75 9 11 9.25 11 9.5C11 9.78125 10.75 10 10.5 10H3.5C3.21875 10 3 9.78125 3 9.5C3 9.25 3.21875 9 3.5 9ZM2.5 11H9.5C9.75 11 10 11.25 10 11.5C10 11.7812 9.75 12 9.5 12H2.5C2.21875 12 2 11.7812 2 11.5C2 11.25 2.21875 11 2.5 11Z' }) })),
    ufo: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M7.5 11.7188L6.96875 12.2188C6.84375 12.0938 6.78125 11.9375 6.75 11.7812C6.75 11.5938 6.71875 11.4062 6.75 11.25C5.78125 11.5 5.03125 11.8438 4.46875 12.2188C3.71875 12.75 3.5 13.1875 3.5 13.5312C3.5 13.7812 3.59375 14.0938 3.96875 14.4375C4.34375 14.8125 4.9375 15.1562 5.71875 15.4688C7.28125 16.0938 9.5 16.5 12 16.5C14.4688 16.5 16.6875 16.0938 18.25 15.4688C19.0312 15.1562 19.5938 14.8125 19.9688 14.4375C20.3438 14.0938 20.4688 13.7812 20.4688 13.5312C20.4688 13.1875 20.25 12.75 19.5 12.2188C18.9375 11.8438 18.1562 11.5 17.2188 11.25C17.2188 11.4062 17.2188 11.5938 17.2188 11.7812C17.1875 11.9375 17.125 12.0938 17 12.2188L16.4688 11.7188C17 12.2188 17 12.2188 17 12.2188V12.25H16.9688C16.9688 12.2812 16.9375 12.3125 16.9062 12.3438C16.8438 12.375 16.7812 12.4375 16.6562 12.5312C16.4688 12.6875 16.1562 12.875 15.75 13.0625C14.9375 13.4062 13.7188 13.7812 11.9688 13.7812C10.25 13.7812 9.03125 13.4062 8.21875 13.0625C7.8125 12.875 7.5 12.6875 7.3125 12.5312C7.1875 12.4375 7.125 12.375 7.0625 12.3438C7.03125 12.3125 7 12.2812 7 12.25C6.96875 12.25 6.96875 12.25 6.96875 12.25V12.2188C6.96875 12.2188 6.96875 12.2188 7.5 11.7188ZM16.9688 9.625C18.3125 9.9375 19.4688 10.4062 20.3438 11C21.25 11.5938 22 12.4688 22 13.5312C22 14.3125 21.5938 15 21.0312 15.5312C20.4688 16.0625 19.6875 16.5 18.8125 16.875C17.0312 17.5938 14.625 18 12 18C9.375 18 6.9375 17.5938 5.15625 16.875C4.28125 16.5 3.5 16.0625 2.9375 15.5312C2.375 15 2 14.3125 2 13.5312C2 12.4688 2.71875 11.5938 3.625 11C4.5 10.4062 5.65625 9.9375 7 9.625C7.71875 7.46875 9.71875 6 12 6C14.25 6 16.25 7.46875 16.9688 9.625ZM15.75 11.3438C15.75 9.15625 14.0312 7.5 12 7.5C9.96875 7.5 8.21875 9.15625 8.25 11.3438C8.375 11.4375 8.5625 11.5625 8.84375 11.6875C9.4375 11.9688 10.4688 12.2812 12 12.2812C13.5 12.2812 14.5312 11.9688 15.125 11.6875C15.4062 11.5625 15.5938 11.4375 15.75 11.3438ZM6.75 13.75C6.75 14.1875 6.40625 14.5 6 14.5C5.5625 14.5 5.25 14.1875 5.25 13.75C5.25 13.3438 5.5625 13 6 13C6.40625 13 6.75 13.3438 6.75 13.75ZM12.75 15C12.75 15.4375 12.4062 15.75 12 15.75C11.5625 15.75 11.25 15.4375 11.25 15C11.25 14.5938 11.5625 14.25 12 14.25C12.4062 14.25 12.75 14.5938 12.75 15ZM18 14.5C17.5625 14.5 17.25 14.1875 17.25 13.75C17.25 13.3438 17.5625 13 18 13C18.4062 13 18.75 13.3438 18.75 13.75C18.75 14.1875 18.4062 14.5 18 14.5Z' }) })),
    upload: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.646 3.323c-.135.068-.246.143-.246.168 0 .024-.925.972-2.056 2.107-2.26 2.267-2.214 2.21-2.107 2.567.065.218.38.533.598.598.347.104.357.097 1.954-1.495l1.45-1.444.01 5.218c.011 5.185.012 5.219.094 5.375.115.22.325.323.657.323s.542-.103.657-.323c.082-.156.083-.19.094-5.375l.01-5.218 1.45 1.444c1.597 1.592 1.607 1.599 1.954 1.495.218-.065.533-.38.598-.598.107-.357.153-.3-2.107-2.567C13.525 4.463 12.6 3.515 12.6 3.491c0-.063-.471-.291-.6-.291-.059 0-.218.055-.354.123M3.799 15.276c-.212.043-.39.165-.468.322-.061.123-.071.26-.071 1.002 0 .962.042 1.233.281 1.83a3.802 3.802 0 002.029 2.029c.746.299.333.281 6.43.281 6.097 0 5.684.018 6.43-.281a3.802 3.802 0 002.029-2.029c.239-.597.281-.868.281-1.83 0-.989-.022-1.079-.307-1.239-.232-.13-.634-.13-.866 0-.276.155-.301.251-.331 1.259-.015.502-.047.949-.075 1.04-.151.495-.64 1.084-1.101 1.327-.507.267-.177.253-6.06.253s-5.553.014-6.06-.253c-.461-.243-.95-.832-1.101-1.327-.028-.091-.06-.538-.075-1.04-.029-.996-.057-1.106-.315-1.249a1.077 1.077 0 00-.65-.095' }) })),
    user: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.544 2.283C9.6 2.455 7.927 3.872 7.417 5.779A4.736 4.736 0 008.034 9.6c.286.441.925 1.08 1.366 1.366a4.73 4.73 0 005.2 0c.441-.286 1.08-.925 1.366-1.366 1.211-1.871.99-4.275-.541-5.871a4.626 4.626 0 00-3.029-1.448 8.87 8.87 0 00-.476-.035c-.011.003-.18.019-.376.037m1.37 1.595c.508.146.893.372 1.321.78.446.425.733.89.894 1.45.129.45.129 1.334 0 1.784-.167.582-.458 1.042-.941 1.492-.633.588-1.319.856-2.188.856-.869 0-1.555-.268-2.188-.856-.483-.45-.774-.91-.941-1.492-.129-.45-.129-1.334 0-1.784.152-.53.375-.91.787-1.343a3.113 3.113 0 011.775-.967c.321-.058 1.152-.013 1.481.08m-1.545 9.405A7.858 7.858 0 007.1 15a8.533 8.533 0 00-1.695 1.932 8.499 8.499 0 00-1.003 2.528c-.125.611-.187 1.484-.126 1.758.061.273.21.434.459.497.131.033 2.121.045 7.265.045s7.134-.012 7.265-.045c.428-.108.536-.409.461-1.289a7.38 7.38 0 00-.39-1.901 7.37 7.37 0 00-1.754-2.88c-.702-.724-1.295-1.159-2.162-1.587a7.541 7.541 0 00-2.869-.777c-.577-.044-.579-.044-1.182.002m1.771 1.575c1.892.343 3.574 1.62 4.465 3.391.192.382.448 1.138.513 1.512.024.142.054.309.066.369l.022.11H5.796l.024-.15c.407-2.527 2.207-4.513 4.67-5.153.702-.182 1.884-.217 2.65-.079' }) })),
    userAdd: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M9.22 2.286a4.566 4.566 0 0 0-2.467 1.048c-.748.641-1.22 1.401-1.481 2.385-.099.375-.141 1.298-.078 1.704.42 2.689 3.032 4.41 5.64 3.716a4.404 4.404 0 0 0 1.956-1.113c.754-.724 1.164-1.51 1.346-2.583.115-.679.059-1.315-.185-2.083a3.946 3.946 0 0 0-.979-1.645c-.772-.812-1.675-1.273-2.766-1.412-.538-.069-.523-.068-.986-.017m1.22 1.571c.331.09.912.394 1.16.606.45.385.776.892.966 1.499.121.388.131 1.191.018 1.598-.244.889-.985 1.714-1.834 2.041-.636.246-1.537.25-2.154.01A3.14 3.14 0 0 1 6.734 7.52c-.099-.373-.089-1.118.021-1.531a2.7 2.7 0 0 1 .749-1.283c.53-.532.942-.762 1.596-.89.338-.066 1.023-.045 1.34.041m7.425 4.104c-.139.042-.289.176-.378.339-.056.102-.068.299-.08 1.287l-.014 1.168-1.167.012c-1.081.012-1.176.019-1.302.093-.248.146-.304.264-.304.64 0 .362.045.465.275.638.105.078.172.083 1.308.095l1.197.012.003 1.008c.003 1.124.027 1.379.142 1.538.293.402 1.064.372 1.275-.051.073-.147.081-.255.093-1.326l.013-1.166 1.214-.014c1.151-.013 1.22-.018 1.324-.096.383-.286.366-1.046-.028-1.278-.126-.074-.222-.081-1.326-.094l-1.19-.014-.003-1.026c-.004-1.296-.019-1.418-.207-1.589a.893.893 0 0 0-.845-.176m-8.824 4.722a6.436 6.436 0 0 0-4.185 2.147c-1.137 1.292-1.66 2.853-1.608 4.79.021.772.061.888.346 1.028l.186.091 4.9.012c2.695.007 5.381-.001 5.968-.019l1.068-.032.136-.132c.197-.191.228-.346.228-1.124 0-1.125-.115-1.844-.426-2.66a6.488 6.488 0 0 0-3.302-3.541 6.518 6.518 0 0 0-3.311-.56m1.105 1.517c1.14.087 2.137.556 2.974 1.398.877.882 1.37 1.971 1.428 3.152l.024.49H4.76v-.178c0-.355.091-1.009.187-1.342a5.934 5.934 0 0 1 .7-1.469c.742-1.081 2.115-1.92 3.353-2.049.442-.046.567-.046 1.146-.002' }) })),
    userGroup: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.595 3.282c-.46.05-.773.142-1.215.357-1.06.514-1.74 1.36-2.03 2.521a4.03 4.03 0 000 1.68c.183.733.493 1.287 1.008 1.802.73.73 1.606 1.092 2.642 1.092 1.036 0 1.912-.362 2.642-1.092.73-.73 1.092-1.606 1.092-2.642 0-1.589-.926-2.924-2.441-3.515-.441-.173-1.171-.26-1.698-.203m.961 1.54c.378.089.707.281 1.024.598.454.454.659.945.659 1.58 0 .635-.205 1.126-.659 1.58-.456.456-.944.66-1.58.66-.636 0-1.124-.204-1.58-.66-.454-.454-.659-.945-.659-1.58 0-.635.205-1.126.659-1.58.31-.31.646-.509 1.005-.597a2.87 2.87 0 011.131-.001M4.617 7.283c-.585.069-1.098.328-1.552.781a2.687 2.687 0 00-.693 1.116c-.091.277-.105.387-.105.82 0 .433.014.543.105.82.146.44.357.781.692 1.116.335.335.676.546 1.116.692.277.091.387.105.82.105.433 0 .543-.014.82-.105.44-.146.781-.357 1.116-.692.335-.335.546-.676.692-1.116.091-.277.105-.387.105-.82 0-.432-.014-.543-.105-.82-.425-1.294-1.642-2.06-3.011-1.897m14 0c-.585.069-1.098.328-1.552.781a2.687 2.687 0 00-.693 1.116c-.091.277-.105.387-.105.82 0 .433.014.543.105.82.146.44.357.781.692 1.116.335.335.676.546 1.116.692.277.091.387.105.82.105.433 0 .543-.014.82-.105.44-.146.781-.357 1.116-.692.335-.335.546-.676.692-1.116.091-.277.105-.387.105-.82 0-.432-.014-.543-.105-.82-.425-1.294-1.642-2.06-3.011-1.897M5.528 8.873c.239.117.481.359.599.599.133.27.133.787 0 1.057-.464.943-1.795.943-2.252 0a1.425 1.425 0 01-.074-.871c.097-.348.43-.703.785-.838.232-.088.708-.061.942.053m14 0c.239.117.481.359.599.599.133.27.133.787 0 1.057-.464.943-1.795.943-2.252 0a1.425 1.425 0 01-.074-.871c.097-.348.43-.703.785-.838.232-.088.708-.061.942.053M11.5 12.281a5.396 5.396 0 00-2 .547 5.898 5.898 0 00-2.207 1.864l-.147.208-.446-.223c-.685-.344-1.343-.469-2.065-.394a3.21 3.21 0 00-1.255.356c-1.073.52-1.771 1.402-2.046 2.581-.064.279-.074.495-.074 1.68 0 1.297.004 1.367.083 1.517a.59.59 0 00.24.24l.157.083h20.52l.157-.083a.59.59 0 00.24-.24c.079-.15.083-.22.083-1.517 0-1.185-.01-1.401-.074-1.68-.275-1.179-.973-2.061-2.046-2.581a3.21 3.21 0 00-1.255-.356c-.722-.075-1.38.05-2.065.394l-.446.223-.147-.208c-.872-1.23-2.299-2.131-3.718-2.349-.5-.076-1.055-.1-1.489-.062m1.52 1.593c.867.218 1.714.755 2.26 1.433.244.304.56.814.56.904 0 .023.046.138.102.257.224.473.268.753.288 1.802l.018.97H7.752l.018-.97c.02-1.049.064-1.329.288-1.802.056-.119.102-.235.102-.258 0-.078.284-.547.511-.845.589-.771 1.555-1.354 2.559-1.544.433-.082 1.36-.055 1.79.053m-7.249 2.02c.3.114.709.368.709.44 0 .025-.035.192-.078.37-.111.462-.162 1.041-.162 1.84v.696H2.76l.001-.77c0-1.146.117-1.508.659-2.05.492-.493.947-.669 1.66-.644.329.012.479.037.691.118m13.785-.072c.378.089.707.281 1.024.598.542.542.659.904.659 2.05l.001.77h-3.48v-.696c0-.808-.052-1.398-.162-1.831a3.09 3.09 0 01-.078-.366c0-.128.639-.47 1.02-.546a2.943 2.943 0 011.016.021' }) })),
    userRemove: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M8.72 2.266c-.785.083-1.392.258-1.951.56-2.065 1.117-3.011 3.531-2.244 5.725.254.728.57 1.215 1.18 1.822A4.526 4.526 0 0 0 9 11.733c1.3 0 2.394-.459 3.334-1.399.935-.936 1.397-2.036 1.398-3.334 0-1.282-.473-2.421-1.391-3.342a4.599 4.599 0 0 0-1.991-1.194c-.466-.135-1.287-.235-1.63-.198m.999 1.579c1.081.163 2.238 1.314 2.44 2.429.064.351.057 1.177-.013 1.509-.208.994-1.106 1.96-2.14 2.304-.368.122-.415.128-1.006.128s-.638-.006-1.006-.128c-1.024-.34-1.907-1.28-2.138-2.277-.082-.355-.08-1.273.004-1.634.224-.97 1.125-1.934 2.101-2.252.496-.161 1.048-.186 1.758-.079m5.834 7.431c-.839.022-.916.03-1.02.108-.191.142-.26.306-.262.613-.002.318.075.49.28.628.117.079.202.089.99.115a118.1 118.1 0 0 0 3.292.013c2.326-.015 2.437-.02 2.565-.095a.85.85 0 0 0 .212-.183c.168-.226.168-.724 0-.95-.182-.244-.084-.235-2.73-.255a151.486 151.486 0 0 0-3.327.006m-7.567 2.067a6.746 6.746 0 0 0-2.793 1.104C3.685 15.49 2.71 17 2.36 18.832c-.073.379-.088.613-.093 1.44-.007.923-.002.997.073 1.124.176.299.183.3 1.393.336.598.017 3.427.026 6.287.019 5.088-.012 5.203-.014 5.359-.092.259-.128.329-.274.36-.749.034-.527-.037-1.842-.121-2.23-.319-1.476-1.106-2.829-2.175-3.74-1.069-.911-2.247-1.438-3.616-1.619-.429-.056-1.412-.045-1.841.022m2.094 1.536c1.515.309 2.875 1.357 3.594 2.77.336.66.507 1.317.552 2.121l.026.47H3.76v-.271c0-.854.257-1.807.688-2.549a5.282 5.282 0 0 1 3.892-2.617c.426-.059 1.257-.022 1.74.076' }) })),
    userSecret: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M12 4.5C12.1875 4.5 12.3125 4.4375 12.4688 4.3125C12.6875 4.1875 12.9375 4 13.5 4C14.4375 4 15.125 5.375 15.5625 6.8125C17.0312 7.09375 18 7.53125 18 8C18 8.4375 17.2812 8.8125 16.1875 9.09375C16.2188 9.3125 16.25 9.53125 16.25 9.75C16.25 10.1875 16.1562 10.625 16.0625 11H17.5625C17.8125 11 18 11.1875 18 11.4375C18 11.5 17.9688 11.5312 17.9688 11.5938L16.75 14.625C18.0938 15.625 19 17.25 19 19.0938C19 19.5938 18.5625 20 18.0625 20H13.75H10.25H5.90625C5.40625 20 5 19.5938 5 19.0938C5 17.25 5.875 15.625 7.21875 14.625L6.03125 11.5938C6 11.5312 6 11.5 6 11.4375C6 11.1875 6.1875 11 6.40625 11H7.9375C7.8125 10.625 7.75 10.1875 7.75 9.75C7.75 9.53125 7.75 9.3125 7.78125 9.09375C6.6875 8.8125 6 8.4375 6 8C6 7.53125 6.9375 7.09375 8.4375 6.8125C8.875 5.375 9.53125 4 10.5 4C11.0625 4 11.2812 4.1875 11.5 4.3125C11.6562 4.4375 11.7812 4.5 12 4.5ZM13.375 18.5H17.4375C17.2812 17.4062 16.6875 16.4688 15.8438 15.8125C15.3125 15.4062 15.0938 14.6875 15.3438 14.0625L15.9688 12.5H15.2188C14.6875 13.125 14 13.5938 13.1875 13.8438L12.6875 14.6562C12.5625 14.875 12.5312 15.1562 12.5938 15.4062L13.375 18.5ZM10.7812 13.8438C9.96875 13.5938 9.28125 13.125 8.75 12.5H8L8.625 14.0625C8.875 14.6875 8.65625 15.4062 8.125 15.8125C7.28125 16.4688 6.6875 17.4062 6.53125 18.5H10.625L11.375 15.4062C11.4375 15.1562 11.4062 14.875 11.2812 14.6562L10.7812 13.8438ZM12 12.5C13.1875 12.5 14.1875 11.75 14.5625 10.6875C14.3438 10.9062 14.0625 11 13.75 11H13.3438C12.8438 11 12.375 10.6875 12.2188 10.1875C12.125 9.96875 11.8438 9.96875 11.75 10.1875C11.5938 10.6875 11.125 11 10.625 11H10.25C9.90625 11 9.625 10.9062 9.40625 10.6875C9.78125 11.75 10.7812 12.5 12 12.5Z' }) })),
    wandSparkles: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M18.2188 5.5625L5.625 16.9688C5.53125 17.0625 5.5 17.1562 5.5 17.2812C5.5 17.4062 5.53125 17.5 5.59375 17.5625L6.4375 18.4062C6.5 18.4688 6.59375 18.5 6.71875 18.5C6.84375 18.5 6.9375 18.4688 7.03125 18.375L18.4375 5.78125C18.4688 5.75 18.5 5.71875 18.5 5.65625C18.5 5.59375 18.4062 5.5 18.3438 5.5C18.3125 5.5 18.25 5.53125 18.2188 5.5625ZM18.3438 4C19.25 4 20 4.75 20 5.65625C20 6.0625 19.8438 6.46875 19.5625 6.78125L18.125 8.375C18.0312 8.46875 18 8.59375 18 8.71875V9.5C18 9.78125 17.75 10 17.5 10H16.8438C16.7188 10 16.5625 10.0625 16.4688 10.1875L8.125 19.375C7.78125 19.7812 7.25 20 6.71875 20C6.21875 20 5.71875 19.8125 5.375 19.4375L4.5625 18.625C4.1875 18.2812 4 17.7812 4 17.2812C4 16.75 4.21875 16.2188 4.625 15.875L6.8125 13.875C6.9375 13.7812 7 13.625 7 13.5V12.5C7 12.25 7.21875 12 7.5 12H8.65625C8.78125 12 8.90625 11.9688 9 11.875L17.2188 4.4375C17.5312 4.15625 17.9375 4 18.3438 4ZM17.5 13C17.5938 13 17.6875 13.0938 17.7188 13.1875L18.1875 14.8125L19.8125 15.2812C19.9062 15.3125 20 15.4062 20 15.5C20 15.625 19.9062 15.7188 19.8125 15.75L18.1875 16.2188L17.7188 17.8438C17.6875 17.9375 17.5938 18 17.5 18C17.375 18 17.2812 17.9375 17.25 17.8438L16.7812 16.2188L15.1562 15.75C15.0625 15.7188 15 15.625 15 15.5C15 15.4062 15.0625 15.3125 15.1562 15.2812L16.7812 14.8125L17.25 13.1875C17.2812 13.0938 17.375 13 17.5 13ZM6.71875 6.1875L7.1875 7.8125L8.8125 8.28125C8.90625 8.3125 9 8.40625 9 8.5C9 8.625 8.90625 8.71875 8.8125 8.75L7.1875 9.21875L6.71875 10.8438C6.6875 10.9375 6.59375 11 6.5 11C6.375 11 6.28125 10.9375 6.25 10.8438L5.78125 9.21875L4.15625 8.75C4.0625 8.71875 4 8.625 4 8.5C4 8.40625 4.0625 8.3125 4.15625 8.28125L5.78125 7.8125L6.25 6.1875C6.28125 6.09375 6.375 6 6.5 6C6.59375 6 6.6875 6.09375 6.71875 6.1875ZM10.5 4C10.5938 4 10.6875 4.09375 10.7188 4.21875L10.9375 5.0625L11.7812 5.28125C11.9062 5.3125 12 5.40625 12 5.5C12 5.625 11.9062 5.71875 11.7812 5.75L10.9375 5.96875L10.7188 6.8125C10.6875 6.9375 10.5938 7 10.5 7C10.375 7 10.2812 6.9375 10.25 6.8125L10.0312 5.96875L9.1875 5.75C9.0625 5.71875 9 5.625 9 5.5C9 5.40625 9.0625 5.3125 9.1875 5.28125L10.0312 5.0625L10.25 4.21875C10.2812 4.09375 10.375 4 10.5 4Z' }) })),
    xCircle: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.32 2.28A9.74 9.74 0 003.258 7.7c-.46.94-.762 1.914-.924 2.98-.097.636-.097 2.004 0 2.64.446 2.941 2.052 5.409 4.533 6.968 1.075.676 2.441 1.17 3.813 1.378.636.097 2.004.097 2.64 0 2.1-.319 3.932-1.206 5.405-2.618 1.601-1.534 2.6-3.479 2.941-5.728.097-.636.097-2.004 0-2.64-.443-2.919-2.04-5.389-4.49-6.941-.824-.522-2.118-1.053-3.056-1.253a10.872 10.872 0 00-2.8-.206m2 1.578a8.277 8.277 0 014.628 2.435c1.176 1.231 1.913 2.713 2.2 4.423.1.593.1 1.975 0 2.568-.612 3.649-3.463 6.426-7.08 6.895-3.771.489-7.369-1.653-8.767-5.219a9.164 9.164 0 01-.449-1.676c-.1-.593-.1-1.975 0-2.568.299-1.783 1.066-3.282 2.324-4.54 1.389-1.388 2.977-2.138 5.064-2.391.313-.038 1.715.011 2.08.073M9.729 9.285c-.209.103-.435.36-.496.563-.093.31-.028.407.879 1.322l.824.83-.824.83c-.916.923-.973 1.01-.875 1.335.065.218.38.533.598.598.325.098.412.041 1.335-.875l.83-.824.83.824c.923.916 1.01.973 1.335.875.218-.065.533-.38.598-.598.098-.325.041-.412-.875-1.335l-.824-.83.824-.83c.916-.923.973-1.01.875-1.335-.065-.218-.38-.533-.598-.598-.325-.098-.412-.041-1.335.876l-.831.824-.81-.807c-.973-.969-1.082-1.032-1.46-.845' }) })),
};

const UnstyledIcon = (props) => {
    const _Icon = Icons[props.name];
    return jsx(_Icon, { ...props });
};
const Icon = styled(UnstyledIcon) `
  fill: ${({ color }) => color || 'currentColor'};
  flex-shrink: 0;
  font-size: ${({ size = 24 }) => size}px;
  height: 1em;
  width: 1em;
`;

const useIsTruncated = (refs) => {
    const [isTruncated, setIsTruncated] = useState([]);
    useEffect(() => {
        const truncations = refs.map((ref) => {
            return ref.current
                ? ref.current.scrollWidth > ref.current.clientWidth ||
                    ref.current.scrollHeight > ref.current.clientHeight
                : false;
        });
        if (isTruncated !== truncations)
            setIsTruncated(truncations);
    }, [...refs]);
    return isTruncated;
};

const proxima = css `
  font-family: 'Proxima Nova', 'Helvetica', sans-serif;
  -webkit-font-smoothing: antialiased;
`;
const ptSerif = css `
  font-family: 'PT Serif', Georgia, serif;
`;
const ptMono = css `
  font-family: 'PT Mono', serif !important;
  -webkit-font-smoothing: antialiased;
`;
const truncated = css `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const getFont = (type, important) => {
    switch (type) {
        case 'h1':
            return css `
        ${proxima};

        font-size: 56px;
        font-weight: 600;
        line-height: 80px;
      `;
        case 'h2':
            return css `
        ${proxima};

        font-size: 40px;
        font-weight: 600;
        line-height: 56px;
      `;
        case 'h3':
            return css `
        ${proxima};

        font-size: 32px;
        font-weight: 600;
        line-height: 48px;
      `;
        case 'h4':
            return css `
        ${proxima};

        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
      `;
        case 'h5':
            return css `
        ${proxima};

        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
      `;
        case 'b0':
            return css `
        ${proxima};

        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      `;
        case 'b1':
            return css `
        ${proxima};

        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      `;
        case 'b2':
            return css `
        ${proxima};

        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
      `;
        case 'b3':
            return css `
        ${proxima};

        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
      `;
        case 'actionSm':
            return css `
        ${proxima};

        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.01em;
        line-height: 16px;
      `;
        case 'actionMd':
            return css `
        ${proxima};

        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.01em;
        line-height: 24px;
      `;
        case 'actionLg':
            return css `
        ${proxima};

        font-size: 16px ${important && ' !important'};
        font-weight: 600 ${important && ' !important'};
        line-height: 24px ${important && ' !important'};
      `;
        case 'it1':
            return css `
        ${proxima};

        font-size: 14px;
        font-style: italic;
        font-weight: 400;
        line-height: 24px;
      `;
        case 'it2':
            return css `
        ${proxima};

        font-size: 12px;
        font-style: italic;
        font-weight: 400;
        line-height: 16px;
      `;
        case 'it3':
            return css `
        ${proxima};

        font-size: 11px;
        font-style: italic;
        font-weight: 400;
        line-height: 16px;
      `;
        case 'h1Serif':
            return css `
        ${ptSerif};

        font-size: 56px;
        font-weight: 700;
        letter-spacing: -0.015em;
        line-height: 80px;
      `;
        case 'h2Serif':
            return css `
        ${ptSerif};

        font-size: 40px;
        font-weight: 700;
        letter-spacing: -0.015em;
        line-height: 56px;
      `;
        case 'h3Serif':
            return css `
        ${ptSerif};

        font-size: 32px;
        font-weight: 700;
        line-height: 36px;
      `;
        case 'h4Serif':
            return css `
        ${ptSerif};

        font-size: 24px;
        font-weight: 700;
        line-height: 32px;
      `;
        case 'h5Serif':
            return css `
        ${ptSerif};

        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
      `;
        case 'b0Serif':
            return css `
        ${ptSerif};

        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
      `;
        case 'b0Mono':
            return css `
        ${ptMono};

        font-size: 15px;
        font-weight: 400;
        line-height: 24px;
      `;
        case 'b1Mono':
            return css `
        ${ptMono};

        font-size: 13px;
        font-weight: 400;
        line-height: 24px;
      `;
        case 'b2Mono':
            return css `
        ${ptMono};

        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
      `;
        case 'b3Mono':
            return css `
        ${ptMono};

        font-size: 10px;
        font-weight: 400;
        line-height: 16px;
      `;
        default:
            return;
    }
};

const Container$5 = styled.div `
  ${({ type }) => getFont(type)}
  ${({ truncate }) => (truncate ? truncated : '')}
  color: ${({ color }) => color};
  overflow-wrap: break-word;
`;
const TruncatedContainer = (props) => {
    const textRef = useRef(null);
    const [textTruncated] = useIsTruncated([textRef]);
    return (jsx(Container$5, { ref: textRef, title: textTruncated ? props.children?.toString() : undefined, ...props }));
};
const Typography = ({ children, color = Colors$1.MidnightBrand, truncate = false, type = 'b0', ...otherProps }) => {
    const ContainerComponent = truncate ? TruncatedContainer : Container$5;
    return (jsx(ContainerComponent, { type: type, color: color, truncate: truncate, className: 'ff-ds', ...otherProps, children: children }));
};

var BadgeVariant;
(function (BadgeVariant) {
    BadgeVariant[BadgeVariant["Jade"] = 0] = "Jade";
    BadgeVariant[BadgeVariant["Pigeon"] = 1] = "Pigeon";
    BadgeVariant[BadgeVariant["Electric"] = 2] = "Electric";
    BadgeVariant[BadgeVariant["Sky"] = 3] = "Sky";
    BadgeVariant[BadgeVariant["Blue"] = 4] = "Blue";
    BadgeVariant[BadgeVariant["Brown"] = 5] = "Brown";
    BadgeVariant[BadgeVariant["Pink"] = 6] = "Pink";
    BadgeVariant[BadgeVariant["Indigo"] = 7] = "Indigo";
    BadgeVariant[BadgeVariant["Purple"] = 8] = "Purple";
    BadgeVariant[BadgeVariant["Pinata"] = 9] = "Pinata";
})(BadgeVariant || (BadgeVariant = {}));
var BadgeRadiusSize;
(function (BadgeRadiusSize) {
    BadgeRadiusSize[BadgeRadiusSize["Small"] = 0] = "Small";
})(BadgeRadiusSize || (BadgeRadiusSize = {}));
const getBadgeStyles = (variant) => {
    switch (variant) {
        case BadgeVariant.Electric: {
            return `
        background-color: ${Colors$1.Electric100};
        color: ${Colors$1.Electric900};
      `;
        }
        case BadgeVariant.Brown: {
            return `
        background-color: ${Colors$1.LightBrown};
        color: ${Colors$1.Brown};
      `;
        }
        case BadgeVariant.Pink: {
            return `
        background-color: ${Colors$1.LightPink};
        color: ${Colors$1.Pink};
      `;
        }
        case BadgeVariant.Blue: {
            return `
        background-color: ${Colors$1.LightBlue};
        color: ${Colors$1.DarkBlue};
      `;
        }
        case BadgeVariant.Indigo: {
            return `
        background-color: ${Colors$1.LightIndigo};
        color: ${Colors$1.Indigo};
      `;
        }
        case BadgeVariant.Purple: {
            return `
        background-color: ${Colors$1.LightPurple};
        color: ${Colors$1.Purple};
      `;
        }
        case BadgeVariant.Sky: {
            return `
        background-color: ${Colors$1.Sky100};
        color: ${Colors$1.Sky900};
      `;
        }
        case BadgeVariant.Jade: {
            return `
        background-color: ${Colors$1.Jade100};
        color: ${Colors$1.Jade900};
      `;
        }
        case BadgeVariant.Pinata: {
            return `
        background-color: ${Colors$1.Pinata100};
        color: ${Colors$1.Pinata900};
      `;
        }
        default: {
            return `
        background-color: ${Colors$1.Pigeon100};
        color: ${Colors$1.MidnightBrand};
      `;
        }
    }
};
styled.span `
  display: inline-flex;
  align-items: center;
  padding: ${({ customPadding }) => customPadding ?? '2px 10px'};
  border-radius: ${({ radiusSize }) => radiusSize === BadgeRadiusSize.Small ? '4px' : '10px'};
  gap: 8px;
  ${getFont('actionSm')}
  ${({ variant }) => getBadgeStyles(variant)}
`;

const getVariantStyles = (variant) => {
    switch (variant) {
        case 'warning':
            return css `
        background-color: ${Colors$1.Sunflower200};
        border: 1px solid ${Colors$1.Sunflower900};
      `;
        case 'error':
            return css `
        background-color: ${Colors$1.Pinata100};
        border: 1px solid ${Colors$1.Pinata900};
      `;
        case 'success':
            return css `
        background-color: ${Colors$1.Jade100};
        border: 1px solid ${Colors$1.Jade900};
      `;
        case 'info':
            return css `
        background-color: ${Colors$1.Electric100};
        border: 1px solid ${Colors$1.Electric700};
      `;
    }
};
styled.div `
  ${({ variant }) => getVariantStyles(variant)}

  border-radius: 2px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  width: 100%;
`;
styled.div `
  align-items: center;
  display: flex;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`;

styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  color: ${Colors$1.Pigeon600};
  margin-right: 4px;

  svg {
    margin-right: 4px;
    stroke: ${Colors$1.Pigeon600};
    fill: none;
  }
`;
styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 4px;
`;

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (useState)(value || defaultValue);
    let ref = (useRef)(value !== undefined);
    let wasControlled = ref.current;
    let isControlled = value !== undefined;
    // Internal state reference for useCallback
    let stateRef = (useRef)(stateValue);
    if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
    ref.current = isControlled;
    let setValue = (useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(stateRef.current, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) stateRef.current = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? stateRef.current : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        onChange
    ]);
    // If a controlled component's value prop changes, we need to update stateRef
    if (isControlled) stateRef.current = value;
    else value = stateValue;
    return [
        value,
        setValue
    ];
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule

// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $704cf1d3b684cc5c$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $704cf1d3b684cc5c$var$SSRContext = /*#__PURE__*/ (React__default).createContext($704cf1d3b684cc5c$var$defaultContext);
let $704cf1d3b684cc5c$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
function $704cf1d3b684cc5c$export$619500959fc48b26(defaultId) {
    let ctx = (useContext)($704cf1d3b684cc5c$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $704cf1d3b684cc5c$var$defaultContext && !$704cf1d3b684cc5c$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (useMemo)(()=>defaultId || `react-aria${ctx.prefix}-${++ctx.current}`, [
        defaultId
    ]);
}
function $704cf1d3b684cc5c$export$535bd6ca7f90a273() {
    let cur = (useContext)($704cf1d3b684cc5c$var$SSRContext);
    let isInSSRContext = cur !== $704cf1d3b684cc5c$var$defaultContext;
    let [isSSR, setIsSSR] = (useState)(isInSSRContext);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof window !== "undefined" && isInSSRContext) // This if statement technically breaks the rules of hooks, but is safe
    // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return isSSR;
}

function r$1(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r$1(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx$1(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r$1(e))&&(n&&(n+=" "),n+=t);return n}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof window !== "undefined" ? (React__default).useLayoutEffect : ()=>{};



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (useState)(defaultValue);
    let valueRef = (useRef)(value);
    let effect = (useRef)(null);
    valueRef.current = value;
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (useRef)(null);
    nextRef.current = ()=>{
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef.current();
        else setValue(newValue.value);
    };
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef.current();
    });
    let queue = (useCallback)((fn)=>{
        effect.current = fn(valueRef.current);
        nextRef.current();
    }, [
        effect,
        nextRef
    ]);
    return [
        value,
        queue
    ];
}


let $bdb11010cef70236$var$idsUpdaterMap = new Map();
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (useState)(defaultId);
    let nextId = (useRef)(null);
    let res = ($704cf1d3b684cc5c$export$619500959fc48b26)(value);
    let updateValue = (useCallback)((val)=>{
        nextId.current = val;
    }, []);
    $bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        let r = res;
        return ()=>{
            $bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    // This cannot cause an infinite loop because the ref is updated first.
    // eslint-disable-next-line
    (useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $bdb11010cef70236$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = ($1dbecbe27a04f9af$export$14d238f342723f25)(id);
    let updateId = (useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $ff5963eb1fccf552$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $3ef42575df84b30b$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = ($ff5963eb1fccf552$export$e08e3b67e392101e)(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (clsx$1)(a, b);
            else if (key === "id" && a && b) result.id = ($bdb11010cef70236$export$cd8c9cb68f842629)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
const $65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
const $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable , propNames: propNames  } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
    if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
    if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            var focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element) {
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element , scrollTop: scrollTop , scrollLeft: scrollLeft  } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    let onTransitionStart = (e)=>{
        // Add the transitioning property to the list for this element.
        let transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd);
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        // Remove property from list of transitioning properties.
        let properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
    let globalListeners = (useRef)(new Map());
    let addGlobalListener = (useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    // eslint-disable-next-line arrow-body-style
    (useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $313b98861ee5dd6c$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id , "aria-label": label , "aria-labelledby": labelledBy  } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = ($bdb11010cef70236$export$f680877a34711e37)(id);
    if (labelledBy && label) {
        let ids = new Set([
            ...labelledBy.trim().split(/\s+/),
            id
        ]);
        labelledBy = [
            ...ids
        ].join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}




function $9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function $9daab02d461809db$export$683480f191c0e3ea(options) {
    const { ref: ref , onResize: onResize  } = options;
    (useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return ()=>{
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref) {
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                context.ref.current = null;
            };
        }
    }, [
        context,
        ref
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $62d8ded9296f3872$export$cfa2225e87938781(node) {
    while(node && !$62d8ded9296f3872$var$isScrollable(node))node = node.parentElement;
    return node || document.scrollingElement || document.documentElement;
}
function $62d8ded9296f3872$var$isScrollable(node) {
    let style = window.getComputedStyle(node);
    return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

let $ef06256079686ba0$var$descriptionId = 0;
const $ef06256079686ba0$var$descriptionNodes = new Map();
function $ef06256079686ba0$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (useState)(undefined);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (!description) return;
        let desc = $ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (--desc.refCount === 0) {
                desc.element.remove();
                $ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id : undefined
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$export$9ac100e40613ea10() {
    return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $c87311424ea30a05$export$186c6964ca17d99() {
    return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $c87311424ea30a05$export$7bef049ce92e4224() {
    return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $c87311424ea30a05$export$fedb369cb70207f1() {
    return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}
function $c87311424ea30a05$export$e1865c3bedcd822b() {
    return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
}
function $c87311424ea30a05$export$a11b0059900ceec8() {
    return $c87311424ea30a05$var$testUserAgent(/Android/i);
}


/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $e9faafb641e167db$export$90fc3a17d93f704c(ref, event, handler, options) {
    let handlerRef = (useRef)(handler);
    handlerRef.current = handler;
    let isDisabled = handler == null;
    (useEffect)(()=>{
        if (isDisabled) return;
        let element = ref.current;
        let handler = (e)=>handlerRef.current.call(this, e);
        element.addEventListener(event, handler, options);
        return ()=>{
            element.removeEventListener(event, handler, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled
    ]);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Scrolls `scrollView` so that `element` is visible.
 * Similar to `element.scrollIntoView({block: 'nearest'})` (not supported in Edge),
 * but doesn't affect parents above `scrollView`.
 */ function $2f04cbc44ee30ce0$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    let offsetY = $2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    let maxX = x + scrollView.offsetWidth;
    let maxY = y + scrollView.offsetHeight;
    if (offsetX <= x) x = offsetX;
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= y) y = offsetY;
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === "left" ? "offsetLeft" : "offsetTop";
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $6a7db85432448f7f$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if (($c87311424ea30a05$export$a11b0059900ceec8)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $6a7db85432448f7f$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
// Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $14c0b72509d70225$var$state = "default";
let $14c0b72509d70225$var$savedUserSelect = "";
let $14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(target) {
    if (($c87311424ea30a05$export$fedb369cb70207f1)()) {
        if ($14c0b72509d70225$var$state === "default") {
            $14c0b72509d70225$var$savedUserSelect = document.documentElement.style.webkitUserSelect;
            document.documentElement.style.webkitUserSelect = "none";
        }
        $14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
    if (($c87311424ea30a05$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($14c0b72509d70225$var$state !== "disabled") return;
        $14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            // Wait for any CSS transitions to complete so we don't recompute style
            // for the whole page in the middle of the animation and cause jank.
            ($bbed8b41f857bcc0$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($14c0b72509d70225$var$state === "restoring") {
                    if (document.documentElement.style.webkitUserSelect === "none") document.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || "";
                    $14c0b72509d70225$var$savedUserSelect = "";
                    $14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) // If not iOS, restore the target's original user-select if any
    // Ignore state since it doesn't apply for non iOS
    {
        if (target && $14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (React__default).createContext(null);
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";



function $f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (useContext)(($ae1eeba8b9eafd08$export$5165eccb35aaadb5));
    if (context) {
        let { register: register , ...contextProps } = context;
        props = ($3ef42575df84b30b$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    ($e7801be82b4b2a53$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
function $f6c31cce2adf654f$export$45712eceda6fad21(props) {
    let { onPress: onPress , onPressChange: onPressChange , onPressStart: onPressStart , onPressEnd: onPressEnd , onPressUp: onPressUp , isDisabled: isDisabled , isPressed: isPressedProp , preventFocusOnPress: preventFocusOnPress , shouldCancelOnPointerExit: shouldCancelOnPointerExit , allowTextSelectionOnPress: allowTextSelectionOnPress , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: _ , ...domProps } = $f6c31cce2adf654f$var$usePressResponderContext(props);
    let propsRef = (useRef)(null);
    propsRef.current = {
        onPress: onPress,
        onPressChange: onPressChange,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressUp: onPressUp,
        isDisabled: isDisabled,
        shouldCancelOnPointerExit: shouldCancelOnPointerExit
    };
    let [isPressed, setPressed] = (useState)(false);
    let ref = (useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener , removeAllGlobalListeners: removeAllGlobalListeners  } = ($03deb23ff14920c4$export$4eaf04e54aa8eed6)();
    let pressProps = (useMemo)(()=>{
        let state = ref.current;
        let triggerPressStart = (originalEvent, pointerType)=>{
            let { onPressStart: onPressStart , onPressChange: onPressChange , isDisabled: isDisabled  } = propsRef.current;
            if (isDisabled || state.didFirePressStart) return;
            if (onPressStart) onPressStart({
                type: "pressstart",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
            if (onPressChange) onPressChange(true);
            state.didFirePressStart = true;
            setPressed(true);
        };
        let triggerPressEnd = (originalEvent, pointerType, wasPressed = true)=>{
            let { onPressEnd: onPressEnd , onPressChange: onPressChange , onPress: onPress , isDisabled: isDisabled  } = propsRef.current;
            if (!state.didFirePressStart) return;
            state.ignoreClickAfterPress = true;
            state.didFirePressStart = false;
            if (onPressEnd) onPressEnd({
                type: "pressend",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
            if (onPressChange) onPressChange(false);
            setPressed(false);
            if (onPress && wasPressed && !isDisabled) onPress({
                type: "press",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let triggerPressUp = (originalEvent, pointerType)=>{
            let { onPressUp: onPressUp , isDisabled: isDisabled  } = propsRef.current;
            if (isDisabled) return;
            if (onPressUp) onPressUp({
                type: "pressup",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let cancel = (e)=>{
            if (state.isPressed) {
                if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isPressed = false;
                state.isOverTarget = false;
                state.activePointerId = null;
                state.pointerType = null;
                removeAllGlobalListeners();
                if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$b0d6fa1ab32e3295)(state.target);
            }
        };
        let pressProps = {
            onKeyDown (e) {
                if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    e.stopPropagation();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred.
                        addGlobalListener(document, "keyup", onKeyUp, false);
                    }
                } else if (e.key === "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(e.currentTarget)) // If the target is a link, we won't have handled this above because we want the default
                // browser behavior to open the link when pressing Enter. But we still need to prevent
                // default so that elements above do not also handle it (e.g. table row).
                e.stopPropagation();
            },
            onKeyUp (e) {
                if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && !e.repeat && e.currentTarget.contains(e.target)) triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0) {
                    e.stopPropagation();
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && (state.pointerType === "virtual" || ($6a7db85432448f7f$export$60278871457622de)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
                        triggerPressStart(e, "virtual");
                        triggerPressUp(e, "virtual");
                        triggerPressEnd(e, "virtual");
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                }
            }
        };
        let onKeyUp = (e)=>{
            if (state.isPressed && $f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                e.stopPropagation();
                state.isPressed = false;
                let target = e.target;
                triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If the target is a link, trigger the click method to open the URL,
                // but defer triggering pressEnd until onClick event handler.
                if (state.target instanceof HTMLElement && state.target.contains(target) && ($f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) || state.target.getAttribute("role") === "link")) state.target.click();
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if (($6a7db85432448f7f$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                e.stopPropagation();
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
                    if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$16a4697467175487)(state.target);
                    triggerPressStart(e, state.pointerType);
                    addGlobalListener(document, "pointermove", onPointerMove, false);
                    addGlobalListener(document, "pointerup", onPointerUp, false);
                    addGlobalListener(document, "pointercancel", onPointerCancel, false);
                }
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0) {
                    if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$b0d6fa1ab32e3295)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                e.stopPropagation();
                if (state.ignoreEmulatedMouseEvents) return;
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = ($6a7db85432448f7f$export$60278871457622de)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
                triggerPressStart(e, state.pointerType);
                addGlobalListener(document, "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = true;
                    triggerPressStart(e, state.pointerType);
                }
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = false;
                    triggerPressEnd(e, state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType);
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                let touch = $f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
                if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$16a4697467175487)(state.target);
                triggerPressStart(e, state.pointerType);
                addGlobalListener(window, "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (!state.isPressed) return;
                let touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd(e, state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (!state.isPressed) return;
                let touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    triggerPressUp(e, state.pointerType);
                    triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget) triggerPressEnd(e, state.pointerType, false);
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$b0d6fa1ab32e3295)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress
    ]);
    // Remove user-select: none in case component unmounts immediately after pressStart
    // eslint-disable-next-line arrow-body-style
    (useEffect)(()=>{
        return ()=>{
            if (!allowTextSelectionOnPress) // eslint-disable-next-line react-hooks/exhaustive-deps
            ($14c0b72509d70225$export$b0d6fa1ab32e3295)(ref.current.target);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, pressProps)
    };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key , code: code  } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof HTMLTextAreaElement || element.isContentEditable) && // A link with a valid href should be handled natively,
    // unless it also has role='button' and was triggered using Space.
    (!$f6c31cce2adf654f$var$isHTMLAnchorLink(element) || role === "button" && key !== "Enter") && // An element with role='link' should only trigger with Enter key
    !(role === "link" && key !== "Enter");
}
function $f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches  } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = point.width / 2 || point.radiusX || 0;
    let offsetY = point.height / 2 || point.radiusY || 0;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $f6c31cce2adf654f$var$getPointClientRect(point);
    return $f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.draggable;
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit";
    return true;
}
const $f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

class $8a9cb279dc87e130$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
    let stateRef = (useRef)({
        isFocused: false,
        onBlur: onBlur,
        observer: null
    });
    stateRef.current.onBlur = onBlur;
    // Clean up MutationObserver on unmount. See below.
    // eslint-disable-next-line arrow-body-style
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    // This function is called during a React onFocus event.
    return (useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                var // For backward compatibility, dispatch a (fake) React synthetic event.
                _stateRef_current, _stateRef_current_onBlur;
                stateRef.current.isFocused = false;
                if (target.disabled) (_stateRef_current_onBlur = (_stateRef_current = stateRef.current).onBlur) === null || _stateRef_current_onBlur === void 0 ? void 0 : _stateRef_current_onBlur.call(_stateRef_current, new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    stateRef.current.observer.disconnect();
                    target.dispatchEvent(new FocusEvent("blur"));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, []);
}


function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled , onFocus: onFocusProp , onBlur: onBlurProp , onFocusChange: onFocusChange  } = props;
    const onBlur = (useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = ($8a9cb279dc87e130$export$715c682d09d639cc)(onBlur);
    const onFocus = (useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : null
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions


let $507fabe10e71c6fb$var$currentModality = null;
let $507fabe10e71c6fb$var$changeHandlers = new Set();
let $507fabe10e71c6fb$var$hasSetupGlobalListeners = false;
let $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !($c87311424ea30a05$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($507fabe10e71c6fb$var$isValidKey(e)) {
        $507fabe10e71c6fb$var$currentModality = "keyboard";
        $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e) {
    $507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $507fabe10e71c6fb$var$handleClickEvent(e) {
    if (($6a7db85432448f7f$export$60278871457622de)(e)) {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $507fabe10e71c6fb$var$currentModality = "virtual";
        $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $507fabe10e71c6fb$var$setupGlobalFocusEvents() {
    if (typeof window === "undefined" || $507fabe10e71c6fb$var$hasSetupGlobalListeners) return;
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function() {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    document.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    window.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
    window.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        document.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        document.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $507fabe10e71c6fb$var$hasSetupGlobalListeners = true;
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    else document.addEventListener("DOMContentLoaded", $507fabe10e71c6fb$var$setupGlobalFocusEvents);
}
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
    return $507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
    return $507fabe10e71c6fb$var$currentModality;
}
function $507fabe10e71c6fb$export$8397ddfc504fdb9a(modality) {
    $507fabe10e71c6fb$var$currentModality = modality;
    $507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $507fabe10e71c6fb$export$98e20ec92f614cfe() {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (useState)($507fabe10e71c6fb$var$currentModality);
    (useEffect)(()=>{
        let handler = ()=>{
            setModality($507fabe10e71c6fb$var$currentModality);
        };
        $507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return modality;
}
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    return !(isTextInput && modality === "keyboard" && e instanceof KeyboardEvent && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$507fabe10e71c6fb$var$isKeyboardFocusEvent(opts === null || opts === void 0 ? void 0 : opts.isTextInput, modality, e)) return;
            fn($507fabe10e71c6fb$export$b9b3dfddab17db27());
        };
        $507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions


function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled , onBlurWithin: onBlurWithin , onFocusWithin: onFocusWithin , onFocusWithinChange: onFocusWithinChange  } = props;
    let state = (useRef)({
        isFocusWithin: false
    });
    let onBlur = (useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = ($8a9cb279dc87e130$export$715c682d09d639cc)(onBlur);
    let onFocus = (useCallback)((e)=>{
        if (!state.current.isFocusWithin) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            onFocus: null,
            onBlur: null
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $6179b936705e76d3$var$hoverCount--;
        if ($6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $6179b936705e76d3$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart , onHoverChange: onHoverChange , onHoverEnd: onHoverEnd , isDisabled: isDisabled  } = props;
    let [isHovered, setHovered] = (useState)(false);
    let state = (useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (useEffect)($6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps , triggerHoverEnd: triggerHoverEnd  } = (useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(props) {
    let { ref: ref , onInteractOutside: onInteractOutside , isDisabled: isDisabled , onInteractOutsideStart: onInteractOutsideStart  } = props;
    let stateRef = (useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false,
        onInteractOutside: onInteractOutside,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let state = stateRef.current;
    state.onInteractOutside = onInteractOutside;
    state.onInteractOutsideStart = onInteractOutsideStart;
    (useEffect)(()=>{
        if (isDisabled) return;
        let onPointerDown = (e)=>{
            if ($e0b6e0b68ec7f50f$var$isValidEvent(e, ref) && state.onInteractOutside) {
                if (state.onInteractOutsideStart) state.onInteractOutsideStart(e);
                state.isPointerDown = true;
            }
        };
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && state.onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            // changing these to capture phase fixed combobox
            document.addEventListener("pointerdown", onPointerDown, true);
            document.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                document.removeEventListener("pointerdown", onPointerDown, true);
                document.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && state.onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.onInteractOutside && state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            document.addEventListener("mousedown", onPointerDown, true);
            document.addEventListener("mouseup", onMouseUp, true);
            document.addEventListener("touchstart", onPointerDown, true);
            document.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                document.removeEventListener("mousedown", onPointerDown, true);
                document.removeEventListener("mouseup", onMouseUp, true);
                document.removeEventListener("touchstart", onPointerDown, true);
                document.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        state,
        isDisabled
    ]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    // if the event target is no longer in the document
    if (event.target) {
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $93925083ecbb358c$export$48d1ea6320830260(handler) {
    if (!handler) return;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


function $46d819fcbaf35654$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: ($93925083ecbb358c$export$48d1ea6320830260)(props.onKeyDown),
            onKeyUp: ($93925083ecbb358c$export$48d1ea6320830260)(props.onKeyUp)
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $8a26561d2877236e$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled , onLongPressStart: onLongPressStart , onLongPressEnd: onLongPressEnd , onLongPress: onLongPress , threshold: threshold = $8a26561d2877236e$var$DEFAULT_THRESHOLD , accessibilityDescription: accessibilityDescription  } = props;
    const timeRef = (useRef)(null);
    let { addGlobalListener: addGlobalListener , removeGlobalListener: removeGlobalListener  } = ($03deb23ff14920c4$export$4eaf04e54aa8eed6)();
    let { pressProps: pressProps  } = ($f6c31cce2adf654f$export$45712eceda6fad21)({
        isDisabled: isDisabled,
        onPressStart (e) {
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = null;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = ($ef06256079686ba0$export$f8aeda7b10753fa1)(onLongPress && !isDisabled ? accessibilityDescription : null);
    return {
        longPressProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(pressProps, descriptionProps)
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $6a99195332edec8b$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    if (($507fabe10e71c6fb$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = document.activeElement;
        ($bbed8b41f857bcc0$export$24490316f764c430)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (document.activeElement === lastFocusedElement && document.contains(element)) ($7215afc6de606d6b$export$de79e2c695e052f3)(element);
        });
    } else ($7215afc6de606d6b$export$de79e2c695e052f3)(element);
}


/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $645f2e67b85a24c9$var$isStyleVisible(element) {
    if (!(element instanceof HTMLElement) && !(element instanceof SVGElement)) return false;
    let { display: display , visibility: visibility  } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle  } = element.ownerDocument.defaultView;
        let { display: computedDisplay , visibility: computedVisibility  } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(element) && $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}




const $9bf71ea28793e738$var$FocusContext = /*#__PURE__*/ (React__default).createContext(null);
let $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(props) {
    let { children: children , contain: contain , restoreFocus: restoreFocus , autoFocus: autoFocus  } = props;
    let startRef = (useRef)();
    let endRef = (useRef)();
    let scopeRef = (useRef)([]);
    let ctx = (useContext)($9bf71ea28793e738$var$FocusContext);
    var _ctx_scopeRef;
    // The parent scope is based on the JSX tree, using context.
    // However, if a new scope mounts outside the active scope (e.g. DialogContainer launched from a menu),
    // we want the parent scope to be the active scope instead.
    let ctxParent = (_ctx_scopeRef = ctx === null || ctx === void 0 ? void 0 : ctx.scopeRef) !== null && _ctx_scopeRef !== void 0 ? _ctx_scopeRef : null;
    let parentScope = (useMemo)(()=>$9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope) && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, ctxParent) ? $9bf71ea28793e738$var$activeScope : ctxParent, [
        ctxParent
    ]);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = startRef.current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children,
        parentScope
    ]);
    // add to the focus scope tree in render order because useEffects/useLayoutEffects run children first whereas render runs parent first
    // which matters when constructing a tree
    if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope) && !$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $9bf71ea28793e738$export$d06fae2ee68b101e.addTreeNode(scopeRef, parentScope);
    let node = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
    node.contain = contain;
    $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    // this layout effect needs to run last so that focusScopeTree cleanup happens at the last moment possible
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (scopeRef) return ()=>{
            // Scope may have been re-parented.
            let parentScope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef).parent.scopeRef;
            // Restore the active scope on unmount if this scope or a descendant scope is active.
            // Parent effect cleanups run before children, so we need to check if the
            // parent scope actually still exists before restoring the active scope to it.
            if ((scopeRef === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(scopeRef, $9bf71ea28793e738$var$activeScope)) && (!parentScope || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope))) $9bf71ea28793e738$var$activeScope = parentScope;
            $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef,
        parentScope
    ]);
    let focusManager = $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef);
    return /*#__PURE__*/ (React__default).createElement($9bf71ea28793e738$var$FocusContext.Provider, {
        value: {
            scopeRef: scopeRef,
            focusManager: focusManager
        }
    }, /*#__PURE__*/ (React__default).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, /*#__PURE__*/ (React__default).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from , tabbable: tabbable , wrap: wrap , accept: accept  } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[0].previousElementSibling;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from , tabbable: tabbable , wrap: wrap , accept: accept  } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable , accept: accept  } = opts;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable , accept: accept  } = opts;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (useRef)();
    let raf = (useRef)(null);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = null;
            }
            return;
        }
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            let focusedElement = document.activeElement;
            let scope = scopeRef.current;
            if (!$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: true
            }, scope);
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($9bf71ea28793e738$var$activeScope) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
            } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(document.activeElement, scopeRef)) {
                    $9bf71ea28793e738$var$activeScope = scopeRef;
                    if (document.body.contains(e.target)) {
                        focusedNode.current = e.target;
                        focusedNode.current.focus();
                    } else if ($9bf71ea28793e738$var$activeScope) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        document.addEventListener("keydown", onKeyDown, false);
        document.addEventListener("focusin", onFocus, false);
        scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            document.removeEventListener("keydown", onKeyDown, false);
            document.removeEventListener("focusin", onFocus, false);
            scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    // eslint-disable-next-line arrow-body-style
    (useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $9bf71ea28793e738$var$isElementInChildScope(element);
}
function $9bf71ea28793e738$var$isElementInScope(element, scope) {
    return scope.some((node)=>node.contains(element));
}
function $9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s  } of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))){
        if ($9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $9bf71ea28793e738$export$1258395f99bf9cbf(element) {
    return $9bf71ea28793e738$var$isElementInChildScope(element, $9bf71ea28793e738$var$activeScope);
}
function $9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $6a99195332edec8b$export$80f3e147d781571c)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err1) {
    // ignore
    }
}
function $9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $9bf71ea28793e738$var$focusElement(nextNode);
}
function $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (React__default).useRef(autoFocus);
    (useEffect)(()=>{
        if (autoFocusRef.current) {
            $9bf71ea28793e738$var$activeScope = scopeRef;
            if (!$9bf71ea28793e738$var$isElementInScope(document.activeElement, $9bf71ea28793e738$var$activeScope.current)) $9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    // tracks the active scope, in case restore and contain are both false.
    // if either are true, this is tracked in useRestoreFocus or useFocusContainment.
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        let onFocus = (e)=>{
            let target = e.target;
            if ($9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$9bf71ea28793e738$var$isElementInAnyScope(target)) $9bf71ea28793e738$var$activeScope = null;
        };
        document.addEventListener("focusin", onFocus, false);
        scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            document.removeEventListener("focusin", onFocus, false);
            scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    const nodeToRestoreRef = (useRef)(typeof document !== "undefined" ? document.activeElement : null);
    // restoring scopes should all track if they are active regardless of contain, but contain already tracks it plus logic to contain the focus
    // restoring-non-containing scopes should only care if they become active so they can perform the restore
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if (!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) $9bf71ea28793e738$var$activeScope = scopeRef;
        };
        document.addEventListener("focusin", onFocus, false);
        scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            document.removeEventListener("focusin", onFocus, false);
            scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    // useLayoutEffect instead of useEffect so the active element is saved synchronously instead of asynchronously.
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (!restoreFocus) return;
        $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef).nodeToRestore = nodeToRestoreRef.current;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey) return;
            let focusedElement = document.activeElement;
            if (!$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let nodeToRestore = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef).nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(document.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!document.body.contains(nodeToRestore) || nodeToRestore === document.body) {
                nodeToRestore = null;
                $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef).nodeToRestore = null;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
                else // If there is no next element and the nodeToRestore isn't within a FocusScope (i.e. we are leaving the top level focus scope)
                // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) document.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) document.removeEventListener("keydown", onKeyDown, true);
            let nodeToRestore = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef).nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($9bf71ea28793e738$var$isElementInScope(document.activeElement, scopeRef.current) || document.activeElement === document.body && $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (document.activeElement === document.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && document.body.contains(treeNode.nodeToRestore)) {
                                $9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && ($645f2e67b85a24c9$export$e989c0fffaa6b27a)(node) && (!scope || $9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
class $9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        let node = new $9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        parentNode.removeChild(node);
        if (children.length > 0) children.forEach((child)=>parentNode.addChild(child));
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.length > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        let newTree = new $9bf71ea28793e738$var$Tree();
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, node.parent.scopeRef, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        (_defineProperty)(this, "fastMap", new Map());
        this.root = new $9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.push(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.splice(this.children.indexOf(node), 1);
        node.parent = undefined;
    }
    constructor(props){
        (_defineProperty)(this, "children", []);
        (_defineProperty)(this, "contain", false);
        this.scopeRef = props.scopeRef;
    }
}
let $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





function $f7dceffc5ad7768b$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false , isTextInput: isTextInput , within: within  } = props;
    let state = (useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || ($507fabe10e71c6fb$export$b9b3dfddab17db27)()
    });
    let [isFocused, setFocused] = (useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    ($507fabe10e71c6fb$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps  } = ($a1ea59d68270f0dd$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: state.current.isFocused && isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



let $e6afbd83fe6ebbd2$var$FocusableContext = /*#__PURE__*/ (React__default).createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (useContext)($e6afbd83fe6ebbd2$var$FocusableContext) || {};
    ($e7801be82b4b2a53$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    let { ref: _ , ...otherProps } = context;
    return otherProps;
}
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps  } = ($a1ea59d68270f0dd$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps  } = ($46d819fcbaf35654$export$8f71654801c2f7cd)(props);
    let interactions = ($3ef42575df84b30b$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    let domProps = $e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (useRef)(props.autoFocus);
    (useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) ($6a99195332edec8b$export$80f3e147d781571c)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $5b160d28a433310d$export$c17fa47878dc55b6 {
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    constructor(messages, defaultLocale = "en-US"){
        // Clone messages so we don't modify the original object.
        this.strings = {
            ...messages
        };
        this.defaultLocale = defaultLocale;
    }
}
function $5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = "en-US") {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) // @ts-ignore
    return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6db58dc88e78b024$var$pluralRulesCache = new Map();
const $6db58dc88e78b024$var$numberFormatCache = new Map();
class $6db58dc88e78b024$export$2f817fcdc4b89ae0 {
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === "function" ? message(variables, this) : message;
    }
    plural(count, options, type = "cardinal") {
        let opt = options["=" + count];
        if (opt) return typeof opt === "function" ? opt() : opt;
        let key = this.locale + ":" + type;
        let pluralRules = $6db58dc88e78b024$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    number(value) {
        let numberFormat = $6db58dc88e78b024$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
}
let $488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    // @ts-ignore
    $488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
let $488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    // @ts-ignore
    $488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e1) {}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $148a7a147e38ea7f$export$702d680b21cbd764(locale) {
    // If the Intl.Locale API is available, use it to get the script for the locale.
    // This is more accurate than guessing by language, since languages can be written in multiple scripts.
    // @ts-ignore
    if (Intl.Locale) {
        // @ts-ignore
        let script = new Intl.Locale(locale).maximize().script;
        return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = locale.split("-")[0];
    return $148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
    // @ts-ignore
    let locale = typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: ($148a7a147e38ea7f$export$702d680b21cbd764)(locale) ? "rtl" : "ltr"
    };
}
let $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $1e5a04cdaf7d1af8$var$listeners = new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
    $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
    for (let listener of $1e5a04cdaf7d1af8$var$listeners)listener($1e5a04cdaf7d1af8$var$currentLocale);
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
    let isSSR = ($704cf1d3b684cc5c$export$535bd6ca7f90a273)();
    let [defaultLocale, setDefaultLocale] = (useState)($1e5a04cdaf7d1af8$var$currentLocale);
    (useEffect)(()=>{
        if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
        $1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}



const $18f2051aff69b9bf$var$I18nContext = /*#__PURE__*/ (React__default).createContext(null);
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
    let defaultLocale = ($1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a)();
    let context = (useContext)($18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $fca6afa0e843324b$var$cache = new WeakMap();
function $fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new ($5b160d28a433310d$export$c17fa47878dc55b6)(strings);
        $fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $fca6afa0e843324b$export$f12b703ca79dfbb1(strings) {
    let { locale: locale  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
    let dictionary = (useMemo)(()=>$fca6afa0e843324b$var$getCachedDictionary(strings), [
        strings
    ]);
    return (useMemo)(()=>new ($6db58dc88e78b024$export$2f817fcdc4b89ae0)(locale, dictionary), [
        locale,
        dictionary
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
let $325a3faab7a68acd$var$cache = new Map();
function $325a3faab7a68acd$export$a16aca283550c30d(options) {
    let { locale: locale  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($325a3faab7a68acd$var$cache.has(cacheKey)) return $325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $bb77f239b46e8c72$export$3274cf84b703fff(options) {
    let collator = ($325a3faab7a68acd$export$a16aca283550c30d)({
        usage: "search",
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    return {
        startsWith (string, substring) {
            if (substring.length === 0) return true;
            // Normalize both strings so we can slice safely
            // TODO: take into account the ignorePunctuation option as well...
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            return collator.compare(string.slice(0, substring.length), substring) === 0;
        },
        endsWith (string, substring) {
            if (substring.length === 0) return true;
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            return collator.compare(string.slice(-substring.length), substring) === 0;
        },
        contains (string, substring) {
            if (substring.length === 0) return true;
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            let scan = 0;
            let sliceLen = substring.length;
            for(; scan + sliceLen <= string.length; scan++){
                let slice = string.slice(scan, scan + sliceLen);
                if (collator.compare(substring, slice) === 0) return true;
            }
            return false;
        }
    };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$f = function() {
    __assign$f = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$f.apply(this, arguments);
};

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}

// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

// @generated from regex-gen.ts
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = __assign$f(__assign$f(__assign$f({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign$f(__assign$f({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = __assign$f(__assign$f(__assign$f({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign$f(__assign$f({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = __assign$f(__assign$f({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = __assign$f(__assign$f({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = __assign$f(__assign$f({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = __assign$f(__assign$f({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = __assign$f(__assign$f({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData['001'];
    return hourCycles[0];
}

var _a;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, __assign$f({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse$1(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = __assign$f({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}

//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    __extends(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));
var InvalidValueError = /** @class */ (function (_super) {
    __extends(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));
var InvalidValueTypeError = /** @class */ (function (_super) {
    __extends(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));
var MissingValueError = /** @class */ (function (_super) {
    __extends(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));

var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && isLiteralElement(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (isLiteralElement(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (isPoundElement(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if (isArgumentElement(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (isDateElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTimeElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isNumberElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : isNumberSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTagElement(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new InvalidValueTypeError(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if (isSelectElement(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if (isPluralElement(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return __assign$f(__assign$f(__assign$f({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = __assign$f(__assign$f({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, __assign$f({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: strategies.variadic,
        }),
        getDateTimeFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: strategies.variadic,
        }),
        getPluralRules: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: strategies.variadic,
        }),
    };
}
/** @class */ ((function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== PART_TYPE.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () {
            var _a;
            return ({
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) ||
                    Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
            });
        };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        if (typeof Intl.Locale === 'undefined') {
            return;
        }
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = parse$1;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
})());

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
    let { elementType: elementType = "button" , isDisabled: isDisabled , onPress: onPress , onPressStart: onPressStart , onPressEnd: onPressEnd , onPressChange: onPressChange , preventFocusOnPress: // @ts-ignore - undocumented
    preventFocusOnPress , allowFocusWhenDisabled: // @ts-ignore - undocumented
    allowFocusWhenDisabled , // @ts-ignore
    onClick: deprecatedOnClick , href: href , target: target , rel: rel , type: type = "button"  } = props;
    let additionalProps;
    if (elementType === "button") additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: "button",
        tabIndex: isDisabled ? undefined : 0,
        href: elementType === "a" && isDisabled ? undefined : href,
        target: elementType === "a" ? target : undefined,
        type: elementType === "input" ? type : undefined,
        disabled: elementType === "input" ? isDisabled : undefined,
        "aria-disabled": !isDisabled || elementType === "input" ? undefined : isDisabled,
        rel: elementType === "a" ? rel : undefined
    };
    let { pressProps: pressProps , isPressed: isPressed  } = ($f6c31cce2adf654f$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps  } = ($e6afbd83fe6ebbd2$export$4c014de7c8940b4c)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = ($3ef42575df84b30b$export$9d1611c77c2fe928)(focusableProps, pressProps, ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(additionalProps, buttonProps, {
            "aria-haspopup": props["aria-haspopup"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-pressed": props["aria-pressed"],
            onClick: (e)=>{
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn("onClick is deprecated, please use onPress");
                }
            }
        })
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7000;
let $319e236875307eab$var$liveAnnouncer = null;
function $319e236875307eab$export$a9b970dcc4ae71a9(message, assertiveness = "assertive", timeout = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    if (!$319e236875307eab$var$liveAnnouncer) $319e236875307eab$var$liveAnnouncer = new $319e236875307eab$var$LiveAnnouncer();
    $319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
class $319e236875307eab$var$LiveAnnouncer {
    createLog(ariaLive) {
        let node = document.createElement("div");
        node.setAttribute("role", "log");
        node.setAttribute("aria-live", ariaLive);
        node.setAttribute("aria-relevant", "additions");
        return node;
    }
    destroy() {
        if (!this.node) return;
        document.body.removeChild(this.node);
        this.node = null;
    }
    announce(message, assertiveness = "assertive", timeout = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
        if (!this.node) return;
        let node = document.createElement("div");
        node.textContent = message;
        if (assertiveness === "assertive") this.assertiveLog.appendChild(node);
        else this.politeLog.appendChild(node);
        if (message !== "") setTimeout(()=>{
            node.remove();
        }, timeout);
    }
    clear(assertiveness) {
        if (!this.node) return;
        if (!assertiveness || assertiveness === "assertive") this.assertiveLog.innerHTML = "";
        if (!assertiveness || assertiveness === "polite") this.politeLog.innerHTML = "";
    }
    constructor(){
        this.node = document.createElement("div");
        this.node.dataset.liveAnnouncer = "true";
        // copied from VisuallyHidden
        Object.assign(this.node.style, {
            border: 0,
            clip: "rect(0 0 0 0)",
            clipPath: "inset(50%)",
            height: 1,
            margin: "0 -1px -1px 0",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            width: 1,
            whiteSpace: "nowrap"
        });
        this.assertiveLog = this.createLog("assertive");
        this.node.appendChild(this.assertiveLog);
        this.politeLog = this.createLog("polite");
        this.node.appendChild(this.politeLog);
        document.body.prepend(this.node);
    }
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $d191a55c9702f145$export$8467354a121f1b9f(props) {
    let { id: id , label: label , "aria-labelledby": ariaLabelledby , "aria-label": ariaLabel , labelElementType: labelElementType = "label"  } = props;
    id = ($bdb11010cef70236$export$f680877a34711e37)(id);
    let labelId = ($bdb11010cef70236$export$f680877a34711e37)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${ariaLabelledby} ${labelId}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    let fieldProps = ($313b98861ee5dd6c$export$d6875122194c7b44)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}



function $2baaea4c71418dea$export$294aa081a6c6f55d(props) {
    let { description: description , errorMessage: errorMessage , validationState: validationState  } = props;
    let { labelProps: labelProps , fieldProps: fieldProps  } = ($d191a55c9702f145$export$8467354a121f1b9f)(props);
    let descriptionId = ($bdb11010cef70236$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        validationState
    ]);
    let errorMessageId = ($bdb11010cef70236$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        validationState
    ]);
    fieldProps = ($3ef42575df84b30b$export$9d1611c77c2fe928)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    margin: "0 -1px -1px 0",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: 1,
    whiteSpace: "nowrap"
};
function $5c3e21d68f1c4674$export$a966af930f325cab(props = {}) {
    let { style: style , isFocusable: isFocusable  } = props;
    let [isFocused, setFocused] = (useState)(false);
    let { focusWithinProps: focusWithinProps  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children , elementType: Element = "div" , isFocusable: isFocusable , style: style , ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps  } = $5c3e21d68f1c4674$export$a966af930f325cab(props);
    return /*#__PURE__*/ (React__default).createElement(Element, ($3ef42575df84b30b$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}

function $parcel$interopDefault$5(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $edcf132a9284368a$var$AXIS = {
    top: "top",
    bottom: "top",
    left: "left",
    right: "left"
};
const $edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
const $edcf132a9284368a$var$CROSS_AXIS = {
    top: "left",
    left: "top"
};
const $edcf132a9284368a$var$AXIS_SIZE = {
    top: "height",
    left: "width"
};
const $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
// @ts-ignore
let $edcf132a9284368a$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
function $edcf132a9284368a$var$getContainerDimensions(containerNode) {
    let width = 0, height = 0, top = 0, left = 0;
    let scroll = {};
    if (containerNode.tagName === "BODY") {
        let documentElement = document.documentElement;
        var _visualViewport_width;
        width = (_visualViewport_width = $edcf132a9284368a$var$visualViewport === null || $edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $edcf132a9284368a$var$visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : documentElement.clientWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = $edcf132a9284368a$var$visualViewport === null || $edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $edcf132a9284368a$var$visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : documentElement.clientHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
    } else {
        ({ width: width , height: height , top: top , left: left  } = $edcf132a9284368a$var$getOffset(containerNode));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
    }
    return {
        width: width,
        height: height,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
function $edcf132a9284368a$var$getDelta(axis, offset, size, containerDimensions, padding) {
    let containerScroll = containerDimensions.scroll[axis];
    let containerHeight = containerDimensions[$edcf132a9284368a$var$AXIS_SIZE[axis]];
    let startEdgeOffset = offset - padding - containerScroll;
    let endEdgeOffset = offset + padding - containerScroll + size;
    if (startEdgeOffset < 0) return -startEdgeOffset;
    else if (endEdgeOffset > containerHeight) return Math.max(containerHeight - endEdgeOffset, -startEdgeOffset);
    else return 0;
}
function $edcf132a9284368a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $edcf132a9284368a$var$parsePlacement(input) {
    if ($edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(" ");
    let axis = $edcf132a9284368a$var$AXIS[placement] || "right";
    let crossAxis = $edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = "center";
    let size = $edcf132a9284368a$var$AXIS_SIZE[axis];
    let crossSize = $edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned) {
    let { placement: placement , crossPlacement: crossPlacement , axis: axis , crossAxis: crossAxis , size: size , crossSize: crossSize  } = placementInfo;
    let position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === "center") //  + (button size / 2) - (overlay size / 2)
    // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) //  + (button size) - (overlay size)
    // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
     /* else {
    the overlay top should match the button top
  } */ 
    // add the crossOffset from props
    position[crossAxis] += crossOffset;
    // this is button center position - the overlay size + half of the button to align bottom of overlay with button center
    let minViablePosition = childOffset[crossAxis] + childOffset[crossSize] / 2 - overlaySize[crossSize];
    // this is button position of center, aligns top of overlay with button center
    let maxViablePosition = childOffset[crossAxis] + childOffset[crossSize] / 2;
    // clamp it into the range of the min/max positions
    position[crossAxis] = Math.min(Math.max(minViablePosition, position[crossAxis]), maxViablePosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[size];
        position[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding) {
    return position.top != null ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top // this is the bottom of the boundary
     - (containerOffsetWithBoundary.top + position.top // this is the top of the overlay
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    )) : Math.max(0, childOffset.top + containerOffsetWithBoundary.top // this is the top of the trigger
     - (boundaryDimensions.top + boundaryDimensions.scroll.top // this is the top of the boundary
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    ));
}
function $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement: placement , axis: axis , size: size  } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $edcf132a9284368a$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight) {
    let placementInfo = $edcf132a9284368a$var$parsePlacement(placementInput);
    let { size: size , crossAxis: crossAxis , crossSize: crossSize , placement: placement , crossPlacement: crossPlacement  } = placementInfo;
    let position = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
    let normalizedOffset = offset;
    let space = $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = $edcf132a9284368a$var$parsePlacement(`${$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
        let flippedSpace = $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    let delta = $edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
    position[crossAxis] += delta;
    let maxHeight = $edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
    delta = $edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
    position[crossAxis] += delta;
    let arrowPosition = {};
    arrowPosition[crossAxis] = childOffset[crossAxis] - position[crossAxis] + childOffset[crossSize] / 2;
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $edcf132a9284368a$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement , targetNode: targetNode , overlayNode: overlayNode , scrollNode: scrollNode , padding: padding , shouldFlip: shouldFlip , boundaryElement: boundaryElement , offset: offset , crossOffset: crossOffset , maxHeight: maxHeight  } = opts;
    let container = overlayNode instanceof HTMLElement && overlayNode.offsetParent || document.body;
    let isBodyContainer = container.tagName === "BODY";
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== "static";
    let childOffset = isBodyContainer ? $edcf132a9284368a$var$getOffset(targetNode) : $edcf132a9284368a$var$getPosition(targetNode, container);
    if (!isBodyContainer) {
        let { marginTop: marginTop , marginLeft: marginLeft  } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = $edcf132a9284368a$var$getOffset(overlayNode);
    let margins = $edcf132a9284368a$var$getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    let scrollSize = $edcf132a9284368a$var$getScroll(scrollNode);
    let boundaryDimensions = $edcf132a9284368a$var$getContainerDimensions(boundaryElement);
    let containerOffsetWithBoundary = boundaryElement.tagName === "BODY" ? $edcf132a9284368a$var$getOffset(container) : $edcf132a9284368a$var$getPosition(container, boundaryElement);
    return $edcf132a9284368a$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight);
}
function $edcf132a9284368a$var$getOffset(node) {
    let { top: top , left: left , width: width , height: height  } = node.getBoundingClientRect();
    let { scrollTop: scrollTop , scrollLeft: scrollLeft , clientTop: clientTop , clientLeft: clientLeft  } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $edcf132a9284368a$var$getPosition(node, parent) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === "fixed") {
        let { top: top , left: left , width: width , height: height  } = node.getBoundingClientRect();
        offset = {
            top: top,
            left: left,
            width: width,
            height: height
        };
    } else {
        offset = $edcf132a9284368a$var$getOffset(node);
        let parentOffset = $edcf132a9284368a$var$getOffset(parent);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $dd149f63282afbbf$export$f6211563215e3b37 = new WeakMap();
function $dd149f63282afbbf$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef , isOpen: isOpen , onClose: onClose  } = opts;
    (useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $dd149f63282afbbf$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener("scroll", onScroll, true);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}




// @ts-ignore
let $2a41e45df1593e64$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
function $2a41e45df1593e64$export$d39e1813b3bdd0e1(props) {
    let { direction: direction  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
    let { targetRef: targetRef , overlayRef: overlayRef , scrollRef: scrollRef = overlayRef , placement: placement = "bottom" , containerPadding: containerPadding = 12 , shouldFlip: shouldFlip = true , boundaryElement: boundaryElement = typeof document !== "undefined" ? document.body : null , offset: offset = 0 , crossOffset: crossOffset = 0 , shouldUpdatePosition: shouldUpdatePosition = true , isOpen: isOpen = true , onClose: onClose , maxHeight: maxHeight  } = props;
    let [position, setPosition] = (useState)({
        position: {},
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    });
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight
    ];
    let updatePosition = (useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        setPosition(($edcf132a9284368a$export$b3ceb0cbf1056d98)({
            placement: $2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // Update position when anything changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(updatePosition, deps);
    // Update position on window resize
    $2a41e45df1593e64$var$useResize(updatePosition);
    // Update position when the overlay changes size (might need to flip).
    ($9daab02d461809db$export$683480f191c0e3ea)({
        ref: overlayRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (useRef)(false);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.addEventListener("resize", onResize);
        return ()=>{
            $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.removeEventListener("resize", onResize);
        };
    }, [
        updatePosition
    ]);
    let close = (useCallback)(()=>{
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    // When scrolling a parent scrollable region of the trigger (other than the body),
    // we hide the popover. Otherwise, its position would be incorrect.
    ($dd149f63282afbbf$export$18fc8428861184da)({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    return {
        overlayProps: {
            style: {
                position: "absolute",
                zIndex: 100000,
                ...position.position,
                maxHeight: position.maxHeight
            }
        },
        placement: position.placement,
        arrowProps: {
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $2a41e45df1593e64$var$useResize(onResize) {
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        window.addEventListener("resize", onResize, false);
        return ()=>{
            window.removeEventListener("resize", onResize, false);
        };
    }, [
        onResize
    ]);
}
function $2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === "rtl") return position.replace("start", "right").replace("end", "left");
    return position.replace("start", "left").replace("end", "right");
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $a11501f3d1d39e6c$var$visibleOverlays = [];
function $a11501f3d1d39e6c$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose , shouldCloseOnBlur: shouldCloseOnBlur , isOpen: isOpen , isDismissable: isDismissable = false , isKeyboardDismissDisabled: isKeyboardDismissDisabled = false , shouldCloseOnInteractOutside: shouldCloseOnInteractOutside  } = props;
    // Add the overlay ref to the stack of visible overlays on mount, and remove on unmount.
    (useEffect)(()=>{
        if (isOpen) $a11501f3d1d39e6c$var$visibleOverlays.push(ref);
        return ()=>{
            let index = $a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
            if (index >= 0) $a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack.
    let onHide = ()=>{
        if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === "Escape" && !isKeyboardDismissDisabled) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    // Handle clicking outside the overlay to close it
    ($e0b6e0b68ec7f50f$export$872b660ac5a1ff98)({
        ref: ref,
        onInteractOutside: isDismissable ? onInteractOutside : null,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (e.relatedTarget && ($9bf71ea28793e738$export$1258395f99bf9cbf)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $628037886ba31236$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type  } = props;
    let { isOpen: isOpen  } = state;
    // Backward compatibility. Share state close function with useOverlayPosition so it can close on scroll
    // without forcing users to pass onClose.
    (useEffect)(()=>{
        if (ref && ref.current) ($dd149f63282afbbf$export$f6211563215e3b37).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === "menu") ariaHasPopup = true;
    else if (type === "listbox") ariaHasPopup = "listbox";
    let overlayId = ($bdb11010cef70236$export$f680877a34711e37)();
    return {
        triggerProps: {
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? overlayId : null,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
// @ts-ignore
const $49c51c25361d4cd2$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $49c51c25361d4cd2$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $49c51c25361d4cd2$var$preventScrollCount = 0;
let $49c51c25361d4cd2$var$restore;
function $49c51c25361d4cd2$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled  } = options;
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (isDisabled) return;
        $49c51c25361d4cd2$var$preventScrollCount++;
        if ($49c51c25361d4cd2$var$preventScrollCount === 1) {
            if (($c87311424ea30a05$export$fedb369cb70207f1)()) $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollMobileSafari();
            else $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollStandard();
        }
        return ()=>{
            $49c51c25361d4cd2$var$preventScrollCount--;
            if ($49c51c25361d4cd2$var$preventScrollCount === 0) $49c51c25361d4cd2$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $49c51c25361d4cd2$var$preventScrollStandard() {
    return ($ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Prevent default on `touchmove` events inside a scrollable element when the scroll position is at the
//    top or bottom. This avoids the whole page scrolling instead, but does prevent overscrolling.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $49c51c25361d4cd2$var$preventScrollMobileSafari() {
    let scrollable;
    let lastY = 0;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = ($62d8ded9296f3872$export$cfa2225e87938781)(e.target);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        lastY = e.changedTouches[0].pageY;
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead. Unfortunately, this disables bounce scrolling when at
        // the top but it's the best we can do.
        let y = e.changedTouches[0].pageY;
        let scrollTop = scrollable.scrollTop;
        let bottom = scrollable.scrollHeight - scrollable.clientHeight;
        if (scrollTop <= 0 && y > lastY || scrollTop >= bottom && y < lastY) e.preventDefault();
        lastY = y;
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($49c51c25361d4cd2$var$willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = "translateY(-2000px)";
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = "";
            });
        }
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($49c51c25361d4cd2$var$willOpenKeyboard(target)) {
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = "translateY(-2000px)";
            requestAnimationFrame(()=>{
                target.style.transform = "";
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($49c51c25361d4cd2$var$visualViewport) {
                    if ($49c51c25361d4cd2$var$visualViewport.height < window.innerHeight) // If the keyboard is already visible, do this after one additional frame
                    // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $49c51c25361d4cd2$var$scrollIntoView(target);
                    });
                    else // Otherwise, wait for the visual viewport to resize before scrolling so we can
                    // measure the correct position to scroll to.
                    $49c51c25361d4cd2$var$visualViewport.addEventListener("resize", ()=>$49c51c25361d4cd2$var$scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let onWindowScroll = ()=>{
        // Last resort. If the window scrolled, scroll it back to the top.
        // It should always be at the top because the body will have a negative margin (see below).
        window.scrollTo(0, 0);
    };
    // Record the original scroll position so we can restore it.
    // Then apply a negative margin to the body to offset it by the scroll position. This will
    // enable us to scroll the window to the top, which is required for the rest of this to work.
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    let restoreStyles = ($ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${scrollY}px`));
    // Scroll to the top. The negative margin on the body will make this appear the same.
    window.scrollTo(0, 0);
    let removeEvents = ($ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$addEvent(document, "touchstart", onTouchStart, {
        passive: false,
        capture: true
    }), $49c51c25361d4cd2$var$addEvent(document, "touchmove", onTouchMove, {
        passive: false,
        capture: true
    }), $49c51c25361d4cd2$var$addEvent(document, "touchend", onTouchEnd, {
        passive: false,
        capture: true
    }), $49c51c25361d4cd2$var$addEvent(document, "focus", onFocus, true), $49c51c25361d4cd2$var$addEvent(window, "scroll", onWindowScroll));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreStyles();
        removeEvents();
        window.scrollTo(scrollX, scrollY);
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $49c51c25361d4cd2$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return ()=>{
        target.removeEventListener(event, handler, options);
    };
}
function $49c51c25361d4cd2$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = ($62d8ded9296f3872$export$cfa2225e87938781)(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        target = scrollable.parentElement;
    }
}
function $49c51c25361d4cd2$var$willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $61fe14465afefc5e$exports = {};
var $773d5888b972f1cf$exports = {};
$773d5888b972f1cf$exports = {
    "dismiss": `تجاهل`
};


var $d11f19852b941573$exports = {};
$d11f19852b941573$exports = {
    "dismiss": `Отхвърляне`
};


var $b983974c2ee1efb3$exports = {};
$b983974c2ee1efb3$exports = {
    "dismiss": `Odstranit`
};


var $5809cc9d4e92de73$exports = {};
$5809cc9d4e92de73$exports = {
    "dismiss": `Luk`
};


var $c68c2e4fc74398d1$exports = {};
$c68c2e4fc74398d1$exports = {
    "dismiss": `Schließen`
};


var $0898b4c153db2b77$exports = {};
$0898b4c153db2b77$exports = {
    "dismiss": `Απόρριψη`
};


var $6d74810286a15183$exports = {};
$6d74810286a15183$exports = {
    "dismiss": `Dismiss`
};


var $309d73dc65f78055$exports = {};
$309d73dc65f78055$exports = {
    "dismiss": `Descartar`
};


var $44ad94f7205cf593$exports = {};
$44ad94f7205cf593$exports = {
    "dismiss": `Lõpeta`
};


var $7c28f5687f0779a9$exports = {};
$7c28f5687f0779a9$exports = {
    "dismiss": `Hylkää`
};


var $e6d75df4b68bd73a$exports = {};
$e6d75df4b68bd73a$exports = {
    "dismiss": `Rejeter`
};


var $87505c9dab186d0f$exports = {};
$87505c9dab186d0f$exports = {
    "dismiss": `התעלם`
};


var $553439c3ffb3e492$exports = {};
$553439c3ffb3e492$exports = {
    "dismiss": `Odbaci`
};


var $74cf411061b983a2$exports = {};
$74cf411061b983a2$exports = {
    "dismiss": `Elutasítás`
};


var $e933f298574dc435$exports = {};
$e933f298574dc435$exports = {
    "dismiss": `Ignora`
};


var $ac91fc9fe02f71f6$exports = {};
$ac91fc9fe02f71f6$exports = {
    "dismiss": `閉じる`
};


var $52b96f86422025af$exports = {};
$52b96f86422025af$exports = {
    "dismiss": `무시`
};


var $c0d724c3e51dafa6$exports = {};
$c0d724c3e51dafa6$exports = {
    "dismiss": `Atmesti`
};


var $c92899672a3fe72e$exports = {};
$c92899672a3fe72e$exports = {
    "dismiss": `Nerādīt`
};


var $9f576b39d8e7a9d6$exports = {};
$9f576b39d8e7a9d6$exports = {
    "dismiss": `Lukk`
};


var $9d025808aeec81a7$exports = {};
$9d025808aeec81a7$exports = {
    "dismiss": `Negeren`
};


var $fce709921e2c0fa6$exports = {};
$fce709921e2c0fa6$exports = {
    "dismiss": `Zignoruj`
};


var $2599cf0c4ab37f59$exports = {};
$2599cf0c4ab37f59$exports = {
    "dismiss": `Descartar`
};


var $3c220ae7ef8a35fd$exports = {};
$3c220ae7ef8a35fd$exports = {
    "dismiss": `Dispensar`
};


var $93562b5094072f54$exports = {};
$93562b5094072f54$exports = {
    "dismiss": `Revocare`
};


var $cd9e2abd0d06c7b4$exports = {};
$cd9e2abd0d06c7b4$exports = {
    "dismiss": `Пропустить`
};


var $45375701f409adf1$exports = {};
$45375701f409adf1$exports = {
    "dismiss": `Zrušiť`
};


var $27fab53a576de9dd$exports = {};
$27fab53a576de9dd$exports = {
    "dismiss": `Opusti`
};


var $4438748d9952e7c7$exports = {};
$4438748d9952e7c7$exports = {
    "dismiss": `Odbaci`
};


var $0936d7347ef4da4c$exports = {};
$0936d7347ef4da4c$exports = {
    "dismiss": `Avvisa`
};


var $29700c92185d38f8$exports = {};
$29700c92185d38f8$exports = {
    "dismiss": `Kapat`
};


var $662ccaf2be4c25b3$exports = {};
$662ccaf2be4c25b3$exports = {
    "dismiss": `Скасувати`
};


var $d80a27deda7cdb3c$exports = {};
$d80a27deda7cdb3c$exports = {
    "dismiss": `取消`
};


var $2b2734393847c884$exports = {};
$2b2734393847c884$exports = {
    "dismiss": `關閉`
};


$61fe14465afefc5e$exports = {
    "ar-AE": $773d5888b972f1cf$exports,
    "bg-BG": $d11f19852b941573$exports,
    "cs-CZ": $b983974c2ee1efb3$exports,
    "da-DK": $5809cc9d4e92de73$exports,
    "de-DE": $c68c2e4fc74398d1$exports,
    "el-GR": $0898b4c153db2b77$exports,
    "en-US": $6d74810286a15183$exports,
    "es-ES": $309d73dc65f78055$exports,
    "et-EE": $44ad94f7205cf593$exports,
    "fi-FI": $7c28f5687f0779a9$exports,
    "fr-FR": $e6d75df4b68bd73a$exports,
    "he-IL": $87505c9dab186d0f$exports,
    "hr-HR": $553439c3ffb3e492$exports,
    "hu-HU": $74cf411061b983a2$exports,
    "it-IT": $e933f298574dc435$exports,
    "ja-JP": $ac91fc9fe02f71f6$exports,
    "ko-KR": $52b96f86422025af$exports,
    "lt-LT": $c0d724c3e51dafa6$exports,
    "lv-LV": $c92899672a3fe72e$exports,
    "nb-NO": $9f576b39d8e7a9d6$exports,
    "nl-NL": $9d025808aeec81a7$exports,
    "pl-PL": $fce709921e2c0fa6$exports,
    "pt-BR": $2599cf0c4ab37f59$exports,
    "pt-PT": $3c220ae7ef8a35fd$exports,
    "ro-RO": $93562b5094072f54$exports,
    "ru-RU": $cd9e2abd0d06c7b4$exports,
    "sk-SK": $45375701f409adf1$exports,
    "sl-SI": $27fab53a576de9dd$exports,
    "sr-SP": $4438748d9952e7c7$exports,
    "sv-SE": $0936d7347ef4da4c$exports,
    "tr-TR": $29700c92185d38f8$exports,
    "uk-UA": $662ccaf2be4c25b3$exports,
    "zh-CN": $d80a27deda7cdb3c$exports,
    "zh-TW": $2b2734393847c884$exports
};






function $86ea4cb521eb2e37$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss , ...otherProps } = props;
    let stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(((/*@__PURE__*/$parcel$interopDefault$5($61fe14465afefc5e$exports))));
    let labels = ($313b98861ee5dd6c$export$d6875122194c7b44)(otherProps, stringFormatter.format("dismiss"));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return /*#__PURE__*/ (React__default).createElement(($5c3e21d68f1c4674$export$439d29a4e110a164), null, /*#__PURE__*/ (React__default).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick
    }));
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $5e3802645cc19319$var$refCountMap = new WeakMap();
let $5e3802645cc19319$var$observerStack = [];
function $5e3802645cc19319$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            // If this node is a live announcer, add it to the set of nodes to keep visible.
            if ((node instanceof HTMLElement || node instanceof SVGElement) && node.dataset.liveAnnouncer === "true") visibleNodes.add(node);
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            if (targets.some((target)=>node.contains(target))) return NodeFilter.FILTER_SKIP;
            return NodeFilter.FILTER_ACCEPT;
        }
    });
    let hide = (node)=>{
        var _refCountMap_get;
        let refCount = (_refCountMap_get = $5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        $5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($5e3802645cc19319$var$observerStack.length) $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].disconnect();
    let node = walker.nextNode();
    while(node != null){
        hide(node);
        node = walker.nextNode();
    }
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) for (let node of change.addedNodes){
                if ((node instanceof HTMLElement || node instanceof SVGElement) && node.dataset.liveAnnouncer === "true") visibleNodes.add(node);
                else if (node instanceof Element) hide(node);
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $5e3802645cc19319$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $5e3802645cc19319$var$refCountMap.get(node);
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                $5e3802645cc19319$var$refCountMap.delete(node);
            } else $5e3802645cc19319$var$refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1]) {
            $5e3802645cc19319$var$observerStack.pop();
            if ($5e3802645cc19319$var$observerStack.length) $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].observe();
        } else $5e3802645cc19319$var$observerStack.splice($5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
    };
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





function $f2f8a6077418541e$export$542a6fd13ac93354(props, state) {
    let { triggerRef: triggerRef , popoverRef: popoverRef , isNonModal: isNonModal , isKeyboardDismissDisabled: isKeyboardDismissDisabled , ...otherProps } = props;
    let { overlayProps: overlayProps , underlayProps: underlayProps  } = ($a11501f3d1d39e6c$export$ea8f71083e90600f)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled
    }, popoverRef);
    let { overlayProps: positionProps , arrowProps: arrowProps , placement: placement  } = ($2a41e45df1593e64$export$d39e1813b3bdd0e1)({
        ...otherProps,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: null
    });
    // Delay preventing scroll until popover is positioned to avoid extra scroll padding.
    // This requires a layout effect so that positioning has been committed to the DOM
    // by the time usePreventScroll measures the element.
    let [isPositioned, setPositioned] = (useState)(false);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (!isNonModal && placement) setPositioned(true);
    }, [
        isNonModal,
        placement
    ]);
    ($49c51c25361d4cd2$export$ee0f7cc6afcd1c18)({
        isDisabled: isNonModal || !isPositioned
    });
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (state.isOpen && !isNonModal && popoverRef.current) return ($5e3802645cc19319$export$1c3ebcada18427bf)([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




const $337b884510726a0d$export$a2200b96afd16271 = /*#__PURE__*/ (React__default).createContext(null);
function $337b884510726a0d$export$c6fdb837b070b4ff(props) {
    let isSSR = ($704cf1d3b684cc5c$export$535bd6ca7f90a273)();
    let { portalContainer: portalContainer = isSSR ? null : document.body  } = props;
    let [contain, setContain] = (useState)(false);
    let contextValue = (useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    if (!portalContainer) return null;
    let contents = /*#__PURE__*/ (React__default).createElement($337b884510726a0d$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (React__default).createElement(($9bf71ea28793e738$export$20e40289641fbbb6), {
        restoreFocus: true,
        contain: contain
    }, props.children));
    return /*#__PURE__*/ ($k7QOs$reactdom).createPortal(contents, portalContainer);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $feb5ffebff200149$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return ($c87311424ea30a05$export$e1865c3bedcd822b)() ? e.altKey : e.ctrlKey;
}
function $feb5ffebff200149$export$16792effe837dba3(e) {
    if (($c87311424ea30a05$export$9ac100e40613ea10)()) return e.metaKey;
    return e.ctrlKey;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $fb3050f43d946246$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate , selectionManager: selectionManager , onTypeSelect: onTypeSelect  } = options;
    let state = (useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, $fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}


function $ae20dd8cbca75726$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager , keyboardDelegate: delegate , ref: ref , autoFocus: autoFocus = false , shouldFocusWrap: shouldFocusWrap = false , disallowEmptySelection: disallowEmptySelection = false , disallowSelectAll: disallowSelectAll = false , selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace" , disallowTypeAhead: disallowTypeAhead = false , shouldUseVirtualFocus: shouldUseVirtualFocus , allowsTabNavigation: allowsTabNavigation = false , isVirtualized: isVirtualized , scrollRef: // If no scrollRef is provided, assume the collection ref is the scrollable region
    scrollRef = ref  } = options;
    let { direction: direction  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                manager.setFocusedKey(key, childFocus);
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !($feb5ffebff200149$export$d3e3bd3e26688c04)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey1 = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey1 == null && shouldFocusWrap) nextKey1 = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey1);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    e.preventDefault();
                    let nextKey2 = delegate.getKeyLeftOf(manager.focusedKey);
                    navigateToKey(nextKey2, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    e.preventDefault();
                    let nextKey3 = delegate.getKeyRightOf(manager.focusedKey);
                    navigateToKey(nextKey3, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, ($feb5ffebff200149$export$16792effe837dba3)(e));
                    manager.setFocusedKey(firstKey);
                    if (($feb5ffebff200149$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, ($feb5ffebff200149$export$16792effe837dba3)(e));
                    manager.setFocusedKey(lastKey);
                    if (($feb5ffebff200149$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey4 = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey4);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey5 = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey5);
                }
                break;
            case "a":
                if (($feb5ffebff200149$export$16792effe837dba3)(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                e.preventDefault();
                if (!disallowEmptySelection) manager.clearSelection();
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = ($9bf71ea28793e738$export$2d6ec8fc375ceafa)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) ($7215afc6de606d6b$export$de79e2c695e052f3)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (useRef)({
        top: 0,
        left: 0
    });
    ($e9faafb641e167db$export$90fc3a17d93f704c)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${manager.focusedKey}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection
                ($7215afc6de606d6b$export$de79e2c695e052f3)(element);
                ($2f04cbc44ee30ce0$export$53a0910f038337bd)(scrollRef.current, element);
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (useRef)(autoFocus);
    (useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) focusedKey = selectedKeys.values().next().value;
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) ($6a99195332edec8b$export$80f3e147d781571c)(ref.current);
        }
        autoFocusRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    (useEffect)(()=>{
        if (!isVirtualized && manager.focusedKey && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${manager.focusedKey}"]`);
            if (element) ($2f04cbc44ee30ce0$export$53a0910f038337bd)(scrollRef.current, element);
        }
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) // Prevent focus going to the collection when clicking on the scrollbar.
            e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps  } = ($fb3050f43d946246$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = ($3ef42575df84b30b$export$9d1611c77c2fe928)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




function $880e95eb8b93ba9a$export$ecf600387e221c37(options) {
    let { selectionManager: manager , key: key , ref: ref , shouldSelectOnPressUp: shouldSelectOnPressUp , isVirtualized: isVirtualized , shouldUseVirtualFocus: shouldUseVirtualFocus , focus: focus , isDisabled: isDisabled , onAction: onAction , allowsDifferentPressOrigin: allowsDifferentPressOrigin  } = options;
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && ($feb5ffebff200149$export$d3e3bd3e26688c04)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && (($feb5ffebff200149$export$16792effe837dba3)(e) || e.pointerType === "touch" || e.pointerType === "virtual")) // if touch or virtual (VO) then we just want to toggle, otherwise it's impossible to multi select because they don't have modifier keys
            manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    // Focus the associated DOM node when this item becomes the focusedKey
    (useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus && document.activeElement !== ref.current) {
            if (focus) focus();
            else ($6a99195332edec8b$export$80f3e147d781571c)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let allowsSelection = !isDisabled && manager.canSelectItem(key);
    let allowsActions = onAction && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (useRef)(false);
    let hadPrimaryActionOnPressStart = (useRef)(false);
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$880e95eb8b93ba9a$var$isActionKey()) return;
                onAction();
            } else if (e.pointerType !== "keyboard") onSelect(e);
        };
        else {
            itemPressProps.onPressUp = (e)=>{
                if (e.pointerType !== "keyboard") onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? ()=>onAction() : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!onAction || $880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) onAction();
                else onSelect(e);
            }
        };
    }
    if (!isVirtualized) itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps , isPressed: isPressed  } = ($f6c31cce2adf654f$export$45712eceda6fad21)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            onAction();
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps  } = ($8a26561d2877236e$export$c24ed0104d07eab9)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    return {
        itemProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $2a25aae57d74318e$export$a05409b8bb224a5a {
    getKeyBelow(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getKeyAbove(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${key}"]`);
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        let pageY = Math.max(0, item.offsetTop + item.offsetHeight - menu.offsetHeight);
        while(item && item.offsetTop > pageY){
            key = this.getKeyAbove(key);
            item = this.getItem(key);
        }
        return key;
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        let pageY = Math.min(menu.scrollHeight, item.offsetTop - item.offsetHeight + menu.offsetHeight);
        while(item && item.offsetTop < pageY){
            key = this.getKeyBelow(key);
            item = this.getItem(key);
        }
        return key;
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(collection, disabledKeys, ref, collator){
        this.collection = collection;
        this.disabledKeys = disabledKeys;
        this.ref = ref;
        this.collator = collator;
    }
}




function $982254629710d113$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager , collection: collection , disabledKeys: disabledKeys , ref: ref , keyboardDelegate: keyboardDelegate , autoFocus: autoFocus , shouldFocusWrap: shouldFocusWrap , isVirtualized: isVirtualized , disallowEmptySelection: disallowEmptySelection , selectOnFocus: selectOnFocus = selectionManager.selectionBehavior === "replace" , disallowTypeAhead: disallowTypeAhead , shouldUseVirtualFocus: shouldUseVirtualFocus , allowsTabNavigation: allowsTabNavigation  } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = ($325a3faab7a68acd$export$a16aca283550c30d)({
        usage: "search",
        sensitivity: "base"
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (useMemo)(()=>keyboardDelegate || new ($2a25aae57d74318e$export$a05409b8bb224a5a)(collection, disabledBehavior === "selection" ? new Set() : disabledKeys, ref, collator), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps  } = ($ae20dd8cbca75726$export$d6daf82dcd84e87c)({
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate,
        autoFocus: autoFocus,
        shouldFocusWrap: shouldFocusWrap,
        disallowEmptySelection: disallowEmptySelection,
        selectOnFocus: selectOnFocus,
        disallowTypeAhead: disallowTypeAhead,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        allowsTabNavigation: allowsTabNavigation,
        isVirtualized: isVirtualized,
        scrollRef: ref
    });
    return {
        listProps: collectionProps
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $c1d7fb2ec91bae71$var$Item(props) {
    return null;
}
$c1d7fb2ec91bae71$var$Item.getCollectionNode = function* getCollectionNode(props, context) {
    let { childItems: childItems , title: title , children: children  } = props;
    let rendered = props.title || props.children;
    let textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"] || "";
    // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
    if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning)) console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.");
    yield {
        type: "item",
        props: props,
        rendered: rendered,
        textValue: textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: $c1d7fb2ec91bae71$var$hasChildItems(props),
        *childNodes () {
            if (childItems) for (let child of childItems)yield {
                type: "item",
                value: child
            };
            else if (title) {
                let items = [];
                (React__default).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
function $c1d7fb2ec91bae71$var$hasChildItems(props) {
    if (props.hasChildItems != null) return props.hasChildItems;
    if (props.childItems) return true;
    if (props.title && (React__default).Children.count(props.children) > 0) return true;
    return false;
}
// We don't want getCollectionNode to show up in the type definition
let $c1d7fb2ec91bae71$export$6d08773d2e66f8f2 = $c1d7fb2ec91bae71$var$Item;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $9fc4852771d079eb$var$Section(props) {
    return null;
}
$9fc4852771d079eb$var$Section.getCollectionNode = function* getCollectionNode(props) {
    let { children: children , title: title , items: items  } = props;
    yield {
        type: "section",
        props: props,
        hasChildNodes: true,
        rendered: title,
        "aria-label": props["aria-label"],
        *childNodes () {
            if (typeof children === "function") {
                if (!items) throw new Error("props.children was a function but props.items is missing");
                for (let item of items)yield {
                    type: "item",
                    value: item,
                    renderer: children
                };
            } else {
                let items1 = [];
                (React__default).Children.forEach(children, (child)=>{
                    items1.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items1;
            }
        }
    };
};
// We don't want getCollectionNode to show up in the type definition
let $9fc4852771d079eb$export$6e2c8f0811a474ce = $9fc4852771d079eb$var$Section;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

class $eb2240fc39a57fa5$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children , items: items  } = props;
        if (typeof children === "function") {
            if (!items) throw new Error("props.children was a function but props.items is missing");
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items1 = [];
            (React__default).Children.forEach(children, (child)=>{
                items1.push(child);
            });
            let index = 0;
            for (let item1 of items1){
                let nodes = this.getFullNode({
                    element: item1,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === "cell" && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error("No key found for item");
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((React__default).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== "function" && typeof type.getCollectionNode !== "function") {
                let name = typeof element.type === "function" ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$eb2240fc39a57fa5$var$capitalize(parentNode.type)}>. Only <${$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node1 = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            "aria-label": partialNode["aria-label"],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: $eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // TODO: Remove this line entirely and enforce that users always provide unique keys.
                    // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node1.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node1.key, node1);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node1;
    }
    constructor(){
        (_defineProperty)(this, "cache", new WeakMap());
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item1 of iterable){
                cache.push(item1);
                yield item1;
            }
        }
    };
}
function $eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}



function $7613b1592d41b092$export$6cd28814d92fa9c9(props, factory, context, invalidators = []) {
    let builder = (useMemo)(()=>new ($eb2240fc39a57fa5$export$bf788dd355e3a401)(), []);
    let prev = (useRef)(null);
    return (useMemo)(()=>{
        let nodes = builder.build(props, context);
        prev.current = factory(nodes, prev.current);
        return prev.current;
    // Don't invalidate when any prop changes, just the two we care about.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        builder,
        props.children,
        props.items,
        context,
        ...invalidators
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $453cc9f0df89c0a5$var$cache = new WeakMap();
function $453cc9f0df89c0a5$export$77d5aafae4e095b2(collection) {
    let count = $453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    count = 0;
    for (let item of collection)if (item.type === "section") count += $453cc9f0df89c0a5$export$77d5aafae4e095b2(item.childNodes);
    else count++;
    $453cc9f0df89c0a5$var$cache.set(collection, count);
    return count;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b1f0cad8af73213b$export$3585ede4d035bf14 = new WeakMap();
function $b1f0cad8af73213b$var$normalizeKey(key) {
    if (typeof key === "string") return key.replace(/\s*/g, "");
    return "" + key;
}
function $b1f0cad8af73213b$export$9145995848b05025(state, itemKey) {
    let data = $b1f0cad8af73213b$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error("Unknown list");
    return `${data.id}-option-${$b1f0cad8af73213b$var$normalizeKey(itemKey)}`;
}






function $c132121280ec012d$export$50eacbbf140a3141(props, state, ref) {
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { listProps: listProps  } = ($982254629710d113$export$b95089534ab7c1fd)({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys
    });
    let { focusWithinProps: focusWithinProps  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = ($bdb11010cef70236$export$f680877a34711e37)(props.id);
    ($b1f0cad8af73213b$export$3585ede4d035bf14).set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction
    });
    let { labelProps: labelProps , fieldProps: fieldProps  } = ($d191a55c9702f145$export$8467354a121f1b9f)({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span"
    });
    return {
        labelProps: labelProps,
        listBoxProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, focusWithinProps, state.selectionManager.selectionMode === "multiple" ? {
            "aria-multiselectable": "true"
        } : {}, {
            role: "listbox",
            ...($3ef42575df84b30b$export$9d1611c77c2fe928)(fieldProps, listProps)
        })
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $af383d3bef1cfdc9$export$c3f9f39876e4bc7(props) {
    let { heading: heading , "aria-label": ariaLabel  } = props;
    let headingId = ($bdb11010cef70236$export$f680877a34711e37)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, and only use it
            // as a label for the nested group.
            id: headingId,
            "aria-hidden": true
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}

function $parcel$interopDefault$4(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $9bdd31893c9700c3$exports = {};
var $c0398ad35c3639b7$exports = {};
$c0398ad35c3639b7$exports = {
    "longPressMessage": `اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة`
};


var $7af657c4165927c3$exports = {};
$7af657c4165927c3$exports = {
    "longPressMessage": `Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто`
};


var $d95d4da6d531ab81$exports = {};
$d95d4da6d531ab81$exports = {
    "longPressMessage": `Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku`
};


var $24ebda9c775dca17$exports = {};
$24ebda9c775dca17$exports = {
    "longPressMessage": `Langt tryk eller tryk på Alt + pil ned for at åbne menuen`
};


var $743e0dfca6cab1e9$exports = {};
$743e0dfca6cab1e9$exports = {
    "longPressMessage": `Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen`
};


var $a2f41026e05f1c84$exports = {};
$a2f41026e05f1c84$exports = {
    "longPressMessage": `Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού`
};


var $43b800e97c901737$exports = {};
$43b800e97c901737$exports = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};


var $442f5f6ac211e29f$exports = {};
$442f5f6ac211e29f$exports = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú`
};


var $dff280acfeb2d8ac$exports = {};
$dff280acfeb2d8ac$exports = {
    "longPressMessage": `Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool`
};


var $51608325613944d7$exports = {};
$51608325613944d7$exports = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli`
};


var $c4a1b1eabeaa87be$exports = {};
$c4a1b1eabeaa87be$exports = {
    "longPressMessage": `Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu.`
};


var $8c74815cdee18d1b$exports = {};
$8c74815cdee18d1b$exports = {
    "longPressMessage": `לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט`
};


var $fd0e9ef6a7fe0ec9$exports = {};
$fd0e9ef6a7fe0ec9$exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};


var $a89a74a39eba465a$exports = {};
$a89a74a39eba465a$exports = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához`
};


var $edc7c66594a0ae8a$exports = {};
$edc7c66594a0ae8a$exports = {
    "longPressMessage": `Premere a lungo o premere Alt + Freccia giù per aprire il menu`
};


var $f1ab51510712db52$exports = {};
$f1ab51510712db52$exports = {
    "longPressMessage": `長押しまたは Alt+下矢印キーでメニューを開く`
};


var $f9b672d9b82fa3d6$exports = {};
$f9b672d9b82fa3d6$exports = {
    "longPressMessage": `길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기`
};


var $a385f3910feda499$exports = {};
$a385f3910feda499$exports = {
    "longPressMessage": `Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“.`
};


var $4f1bde932c441789$exports = {};
$4f1bde932c441789$exports = {
    "longPressMessage": `Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa`
};


var $914a51a8a594d5be$exports = {};
$914a51a8a594d5be$exports = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for å åpne menyen`
};


var $89aaf803103bb500$exports = {};
$89aaf803103bb500$exports = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};


var $c685891476dbaaca$exports = {};
$c685891476dbaaca$exports = {
    "longPressMessage": `Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu`
};


var $885879b9b10c2959$exports = {};
$885879b9b10c2959$exports = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};


var $6b39616688a51692$exports = {};
$6b39616688a51692$exports = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};


var $f26362aed63f47e2$exports = {};
$f26362aed63f47e2$exports = {
    "longPressMessage": `Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul`
};


var $06cbade644558bf0$exports = {};
$06cbade644558bf0$exports = {
    "longPressMessage": `Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню`
};


var $0a391ff68f9d59b1$exports = {};
$0a391ff68f9d59b1$exports = {
    "longPressMessage": `Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol`
};


var $8193cf0e649c7928$exports = {};
$8193cf0e649c7928$exports = {
    "longPressMessage": `Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol`
};


var $f398debcce5a5c55$exports = {};
$f398debcce5a5c55$exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};


var $9e9fef000aa4c013$exports = {};
$9e9fef000aa4c013$exports = {
    "longPressMessage": `Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn`
};


var $c016c8183bbe3d68$exports = {};
$c016c8183bbe3d68$exports = {
    "longPressMessage": `Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın`
};


var $ca4f6c8462244e62$exports = {};
$ca4f6c8462244e62$exports = {
    "longPressMessage": `Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню`
};


var $2d9960c02ccac927$exports = {};
$2d9960c02ccac927$exports = {
    "longPressMessage": `长按或按 Alt + 向下方向键以打开菜单`
};


var $f1b682a4c8c5631c$exports = {};
$f1b682a4c8c5631c$exports = {
    "longPressMessage": `長按或按 Alt+向下鍵以開啟功能表`
};


$9bdd31893c9700c3$exports = {
    "ar-AE": $c0398ad35c3639b7$exports,
    "bg-BG": $7af657c4165927c3$exports,
    "cs-CZ": $d95d4da6d531ab81$exports,
    "da-DK": $24ebda9c775dca17$exports,
    "de-DE": $743e0dfca6cab1e9$exports,
    "el-GR": $a2f41026e05f1c84$exports,
    "en-US": $43b800e97c901737$exports,
    "es-ES": $442f5f6ac211e29f$exports,
    "et-EE": $dff280acfeb2d8ac$exports,
    "fi-FI": $51608325613944d7$exports,
    "fr-FR": $c4a1b1eabeaa87be$exports,
    "he-IL": $8c74815cdee18d1b$exports,
    "hr-HR": $fd0e9ef6a7fe0ec9$exports,
    "hu-HU": $a89a74a39eba465a$exports,
    "it-IT": $edc7c66594a0ae8a$exports,
    "ja-JP": $f1ab51510712db52$exports,
    "ko-KR": $f9b672d9b82fa3d6$exports,
    "lt-LT": $a385f3910feda499$exports,
    "lv-LV": $4f1bde932c441789$exports,
    "nb-NO": $914a51a8a594d5be$exports,
    "nl-NL": $89aaf803103bb500$exports,
    "pl-PL": $c685891476dbaaca$exports,
    "pt-BR": $885879b9b10c2959$exports,
    "pt-PT": $6b39616688a51692$exports,
    "ro-RO": $f26362aed63f47e2$exports,
    "ru-RU": $06cbade644558bf0$exports,
    "sk-SK": $0a391ff68f9d59b1$exports,
    "sl-SI": $8193cf0e649c7928$exports,
    "sr-SP": $f398debcce5a5c55$exports,
    "sv-SE": $9e9fef000aa4c013$exports,
    "tr-TR": $c016c8183bbe3d68$exports,
    "uk-UA": $ca4f6c8462244e62$exports,
    "zh-CN": $2d9960c02ccac927$exports,
    "zh-TW": $f1b682a4c8c5631c$exports
};






function $168583247155ddda$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = "menu" , isDisabled: isDisabled , trigger: trigger = "press"  } = props;
    let menuTriggerId = ($bdb11010cef70236$export$f680877a34711e37)();
    let { triggerProps: triggerProps , overlayProps: overlayProps  } = ($628037886ba31236$export$f9d5c8beee7d008d)({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === "longPress" && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case "Enter":
            case " ":
                if (trigger === "longPress") return;
            // fallthrough
            case "ArrowDown":
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("first");
                break;
            case "ArrowUp":
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("last");
                break;
        }
    };
    let stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(((/*@__PURE__*/$parcel$interopDefault$4($9bdd31893c9700c3$exports))));
    let { longPressProps: longPressProps  } = ($8a26561d2877236e$export$c24ed0104d07eab9)({
        isDisabled: isDisabled || trigger !== "longPress",
        accessibilityDescription: stringFormatter.format("longPressMessage"),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open("first");
        }
    });
    let pressProps = {
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== "touch" && e.pointerType !== "keyboard" && !isDisabled) // If opened with a screen reader, auto focus the first item.
            // Otherwise, the menu itself will be focused.
            state.toggle(e.pointerType === "virtual" ? "first" : null);
        },
        onPress (e) {
            if (e.pointerType === "touch" && !isDisabled) state.toggle();
        }
    };
    // omit onPress from triggerProps since we override it above.
    delete triggerProps.onPress;
    return {
        menuTriggerProps: {
            ...triggerProps,
            ...trigger === "press" ? pressProps : longPressProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            "aria-labelledby": menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

const $d5336fe17ce95402$export$6f49b4016bfc8d56 = new WeakMap();
function $d5336fe17ce95402$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true , ...otherProps } = props;
    if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { listProps: listProps  } = ($982254629710d113$export$b95089534ab7c1fd)({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap
    });
    $d5336fe17ce95402$export$6f49b4016bfc8d56.set(state, {
        onClose: props.onClose,
        onAction: props.onAction
    });
    return {
        menuProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, {
            role: "menu",
            ...listProps
        })
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




function $a2e5df62f93c7633$export$9d32628fc2aea7da(props, state, ref) {
    let { key: key , closeOnSelect: closeOnSelect , isVirtualized: isVirtualized  } = props;
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.disabledKeys.has(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    let isFocused = state.selectionManager.focusedKey === key;
    let data = ($d5336fe17ce95402$export$6f49b4016bfc8d56).get(state);
    let onClose = props.onClose || data.onClose;
    let onAction = props.onAction || data.onAction;
    let role = "menuitem";
    if (state.selectionManager.selectionMode === "single") role = "menuitemradio";
    else if (state.selectionManager.selectionMode === "multiple") role = "menuitemcheckbox";
    let labelId = ($bdb11010cef70236$export$b4cc09c592e8fdb8)();
    let descriptionId = ($bdb11010cef70236$export$b4cc09c592e8fdb8)();
    let keyboardId = ($bdb11010cef70236$export$b4cc09c592e8fdb8)();
    let ariaProps = {
        "aria-disabled": isDisabled,
        role: role,
        "aria-label": props["aria-label"],
        "aria-labelledby": labelId,
        "aria-describedby": [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(" ") || undefined
    };
    if (state.selectionManager.selectionMode !== "none") ariaProps["aria-checked"] = isSelected;
    if (isVirtualized) {
        ariaProps["aria-posinset"] = state.collection.getItem(key).index;
        ariaProps["aria-setsize"] = ($453cc9f0df89c0a5$export$77d5aafae4e095b2)(state.collection);
    }
    let onKeyDown = (e)=>{
        // Ignore repeating events, which may have started on the menu trigger before moving
        // focus to the menu item. We want to wait for a second complete key press sequence.
        if (e.repeat) return;
        switch(e.key){
            case " ":
                if (!isDisabled && state.selectionManager.selectionMode === "none" && closeOnSelect !== false && onClose) onClose();
                break;
            case "Enter":
                // The Enter key should always close on select, except if overridden.
                if (!isDisabled && closeOnSelect !== false && onClose) onClose();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType === "keyboard" && onAction) onAction(key);
    };
    let onPressUp = (e)=>{
        if (e.pointerType !== "keyboard") {
            if (onAction) onAction(key);
            // Pressing a menu item should close by default in single selection mode but not multiple
            // selection mode, except if overridden by the closeOnSelect prop.
            if (onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : state.selectionManager.selectionMode !== "multiple")) onClose();
        }
    };
    let { itemProps: itemProps  } = ($880e95eb8b93ba9a$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true
    });
    let { pressProps: pressProps , isPressed: isPressed  } = ($f6c31cce2adf654f$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressUp: onPressUp,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps  } = ($6179b936705e76d3$export$ae780daf29e6d456)({
        isDisabled: isDisabled,
        onHoverStart () {
            if (!($507fabe10e71c6fb$export$b9b3dfddab17db27)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    return {
        menuItemProps: {
            ...ariaProps,
            ...($3ef42575df84b30b$export$9d1611c77c2fe928)(itemProps, pressProps, hoverProps, {
                onKeyDown: onKeyDown
            })
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isFocused: isFocused,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $2d73ec29415bd339$export$712718f7aec83d5(props, ref) {
    let { inputElementType: inputElementType = "input" , isDisabled: isDisabled = false , isRequired: isRequired = false , isReadOnly: isReadOnly = false , validationState: validationState , type: type = "text" , onChange: onChange = ()=>{}  } = props;
    let { focusableProps: focusableProps  } = ($e6afbd83fe6ebbd2$export$4c014de7c8940b4c)(props, ref);
    let { labelProps: labelProps , fieldProps: fieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($2baaea4c71418dea$export$294aa081a6c6f55d)(props);
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    const inputOnlyProps = {
        type: type,
        pattern: props.pattern
    };
    return {
        labelProps: labelProps,
        inputProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, inputElementType === "input" && inputOnlyProps, {
            disabled: isDisabled,
            readOnly: isReadOnly,
            "aria-required": isRequired || undefined,
            "aria-invalid": validationState === "invalid" || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-activedescendant": props["aria-activedescendant"],
            "aria-autocomplete": props["aria-autocomplete"],
            "aria-haspopup": props["aria-haspopup"],
            value: props.value,
            defaultValue: props.value ? undefined : props.defaultValue,
            onChange: (e)=>onChange(e.target.value),
            autoComplete: props.autoComplete,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            // Clipboard events
            onCopy: props.onCopy,
            onCut: props.onCut,
            onPaste: props.onPaste,
            // Composition events
            onCompositionEnd: props.onCompositionEnd,
            onCompositionStart: props.onCompositionStart,
            onCompositionUpdate: props.onCompositionUpdate,
            // Selection events
            onSelect: props.onSelect,
            // Input events
            onBeforeInput: props.onBeforeInput,
            onInput: props.onInput,
            ...focusableProps,
            ...fieldProps
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

function $parcel$interopDefault$3(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





var $2e84e748dc57e459$exports = {};
var $02cb4c75c506befe$exports = {};
$02cb4c75c506befe$exports = {
    "buttonLabel": `عرض المقترحات`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} خيار`,
            other: ()=>`${formatter.number(args.optionCount)} خيارات`
        })} متاحة.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`المجموعة المدخلة ${args.groupTitle}, مع ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} خيار`,
                    other: ()=>`${formatter.number(args.groupCount)} خيارات`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, محدد`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `مقترحات`,
    "selectedAnnouncement": (args)=>`${args.optionText}، محدد`
};


var $568b8163f1e56faf$exports = {};
$568b8163f1e56faf$exports = {
    "buttonLabel": `Покажи предложения`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} опция`,
            other: ()=>`${formatter.number(args.optionCount)} опции`
        })} на разположение.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Въведена група ${args.groupTitle}, с ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} опция`,
                    other: ()=>`${formatter.number(args.groupCount)} опции`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, избрани`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Предложения`,
    "selectedAnnouncement": (args)=>`${args.optionText}, избрани`
};


var $87581c0202d106b8$exports = {};
$87581c0202d106b8$exports = {
    "buttonLabel": `Zobrazit doporučení`,
    "countAnnouncement": (args, formatter)=>`K dispozici ${formatter.plural(args.optionCount, {
            one: ()=>`je ${formatter.number(args.optionCount)} možnost`,
            other: ()=>`jsou/je ${formatter.number(args.optionCount)} možnosti/-í`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadaná skupina „${args.groupTitle}“ ${formatter.plural(args.groupCount, {
                    one: ()=>`s ${formatter.number(args.groupCount)} možností`,
                    other: ()=>`se ${formatter.number(args.groupCount)} možnostmi`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: ` (vybráno)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Návrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybráno`
};


var $a10a0369f5433ed1$exports = {};
$a10a0369f5433ed1$exports = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} mulighed tilgængelig`,
            other: ()=>`${formatter.number(args.optionCount)} muligheder tilgængelige`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angivet gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} mulighed`,
                    other: ()=>`${formatter.number(args.groupCount)} muligheder`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};


var $bfd288727d5cb166$exports = {};
$bfd288727d5cb166$exports = {
    "buttonLabel": `Empfehlungen anzeigen`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} Option`,
            other: ()=>`${formatter.number(args.optionCount)} Optionen`
        })} verfügbar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Eingetretene Gruppe ${args.groupTitle}, mit ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} Option`,
                    other: ()=>`${formatter.number(args.groupCount)} Optionen`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, ausgewählt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Empfehlungen`,
    "selectedAnnouncement": (args)=>`${args.optionText}, ausgewählt`
};


var $ca177778f9a74e3c$exports = {};
$ca177778f9a74e3c$exports = {
    "buttonLabel": `Προβολή προτάσεων`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} επιλογή`,
            other: ()=>`${formatter.number(args.optionCount)} επιλογές `
        })} διαθέσιμες.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Εισαγμένη ομάδα ${args.groupTitle}, με ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} επιλογή`,
                    other: ()=>`${formatter.number(args.groupCount)} επιλογές`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, επιλεγμένο`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Προτάσεις`,
    "selectedAnnouncement": (args)=>`${args.optionText}, επιλέχθηκε`
};


var $9b5aa79ef84beb6c$exports = {};
$9b5aa79ef84beb6c$exports = {
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Entered group ${args.groupTitle}, with ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selected`,
            other: ``
        }, args.isSelected)}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} available.`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selected`,
    "buttonLabel": `Show suggestions`,
    "listboxLabel": `Suggestions`
};


var $57968e8209de2557$exports = {};
$57968e8209de2557$exports = {
    "buttonLabel": `Mostrar sugerencias`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opción`,
            other: ()=>`${formatter.number(args.optionCount)} opciones`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Se ha unido al grupo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opción`,
                    other: ()=>`${formatter.number(args.groupCount)} opciones`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, seleccionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugerencias`,
    "selectedAnnouncement": (args)=>`${args.optionText}, seleccionado`
};


var $60690790bf4c1c6a$exports = {};
$60690790bf4c1c6a$exports = {
    "buttonLabel": `Kuva soovitused`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} valik`,
            other: ()=>`${formatter.number(args.optionCount)} valikud`
        })} saadaval.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Sisestatud rühm ${args.groupTitle}, valikuga ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} valik`,
                    other: ()=>`${formatter.number(args.groupCount)} valikud`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valitud`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Soovitused`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valitud`
};


var $1101246e8c7d9357$exports = {};
$1101246e8c7d9357$exports = {
    "buttonLabel": `Näytä ehdotukset`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} vaihtoehto`,
            other: ()=>`${formatter.number(args.optionCount)} vaihtoehdot`
        })} saatavilla.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Mentiin ryhmään ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} vaihtoehdon`,
                    other: ()=>`${formatter.number(args.groupCount)} vaihtoehdon`
                })} kanssa.`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valittu`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ehdotukset`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valittu`
};


var $6404b5cb5b241730$exports = {};
$6404b5cb5b241730$exports = {
    "buttonLabel": `Afficher les suggestions`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groupe ${args.groupTitle} saisi, avec ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, sélectionné(s)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggestions`,
    "selectedAnnouncement": (args)=>`${args.optionText}, sélectionné`
};


var $dfeafa702e92e31f$exports = {};
$dfeafa702e92e31f$exports = {
    "buttonLabel": `הצג הצעות`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`אפשרות ${formatter.number(args.optionCount)}`,
            other: ()=>`${formatter.number(args.optionCount)} אפשרויות`
        })} במצב זמין.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`נכנס לקבוצה ${args.groupTitle}, עם ${formatter.plural(args.groupCount, {
                    one: ()=>`אפשרות ${formatter.number(args.groupCount)}`,
                    other: ()=>`${formatter.number(args.groupCount)} אפשרויות`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, נבחר`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `הצעות`,
    "selectedAnnouncement": (args)=>`${args.optionText}, נבחר`
};


var $2d125e0b34676352$exports = {};
$2d125e0b34676352$exports = {
    "buttonLabel": `Prikaži prijedloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno još: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, odabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Prijedlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, odabrano`
};


var $ea029611d7634059$exports = {};
$ea029611d7634059$exports = {
    "buttonLabel": `Javaslatok megjelenítése`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} lehetőség`,
            other: ()=>`${formatter.number(args.optionCount)} lehetőség`
        })} áll rendelkezésre.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Belépett a(z) ${args.groupTitle} csoportba, amely ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} lehetőséget`,
                    other: ()=>`${formatter.number(args.groupCount)} lehetőséget`
                })} tartalmaz. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, kijelölve`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Javaslatok`,
    "selectedAnnouncement": (args)=>`${args.optionText}, kijelölve`
};


var $77f075bb86ad7091$exports = {};
$77f075bb86ad7091$exports = {
    "buttonLabel": `Mostra suggerimenti`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opzione disponibile`,
            other: ()=>`${formatter.number(args.optionCount)} opzioni disponibili`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingresso nel gruppo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opzione`,
                    other: ()=>`${formatter.number(args.groupCount)} opzioni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selezionato`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggerimenti`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selezionato`
};


var $6e87462e84907983$exports = {};
$6e87462e84907983$exports = {
    "buttonLabel": `候補を表示`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} 個のオプション`,
            other: ()=>`${formatter.number(args.optionCount)} 個のオプション`
        })}を利用できます。`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`入力されたグループ ${args.groupTitle}、${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} 個のオプション`,
                    other: ()=>`${formatter.number(args.groupCount)} 個のオプション`
                })}を含む。`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `、選択済み`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `候補`,
    "selectedAnnouncement": (args)=>`${args.optionText}、選択済み`
};


var $9246f2c6edc6b232$exports = {};
$9246f2c6edc6b232$exports = {
    "buttonLabel": `제안 사항 표시`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)}개 옵션`,
            other: ()=>`${formatter.number(args.optionCount)}개 옵션`
        })}을 사용할 수 있습니다.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`입력한 그룹 ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)}개 옵션`,
                    other: ()=>`${formatter.number(args.groupCount)}개 옵션`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, 선택됨`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `제안`,
    "selectedAnnouncement": (args)=>`${args.optionText}, 선택됨`
};


var $e587accc6c0a434c$exports = {};
$e587accc6c0a434c$exports = {
    "buttonLabel": `Rodyti pasiūlymus`,
    "countAnnouncement": (args, formatter)=>`Yra ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} parinktis`,
            other: ()=>`${formatter.number(args.optionCount)} parinktys (-ių)`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Įvesta grupė ${args.groupTitle}, su ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} parinktimi`,
                    other: ()=>`${formatter.number(args.groupCount)} parinktimis (-ių)`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, pasirinkta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Pasiūlymai`,
    "selectedAnnouncement": (args)=>`${args.optionText}, pasirinkta`
};


var $03a1900e7400b5ab$exports = {};
$03a1900e7400b5ab$exports = {
    "buttonLabel": `Rādīt ieteikumus`,
    "countAnnouncement": (args, formatter)=>`Pieejamo opciju skaits: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcijas`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ievadīta grupa ${args.groupTitle}, ar ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opciju`,
                    other: ()=>`${formatter.number(args.groupCount)} opcijām`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, atlasīta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ieteikumi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, atlasīta`
};


var $1387676441be6cf6$exports = {};
$1387676441be6cf6$exports = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativer`
        })} finnes.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angitt gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativer`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};


var $17e82ebf0f8ab91f$exports = {};
$17e82ebf0f8ab91f$exports = {
    "buttonLabel": `Suggesties weergeven`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} optie`,
            other: ()=>`${formatter.number(args.optionCount)} opties`
        })} beschikbaar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groep ${args.groupTitle} ingevoerd met ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} optie`,
                    other: ()=>`${formatter.number(args.groupCount)} opties`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, geselecteerd`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggesties`,
    "selectedAnnouncement": (args)=>`${args.optionText}, geselecteerd`
};


var $2f5377d3471630e5$exports = {};
$2f5377d3471630e5$exports = {
    "buttonLabel": `Wyświetlaj sugestie`,
    "countAnnouncement": (args, formatter)=>`dostępna/dostępne(-nych) ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcja`,
            other: ()=>`${formatter.number(args.optionCount)} opcje(-i)`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Dołączono do grupy ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcją`,
                    other: ()=>`${formatter.number(args.groupCount)} opcjami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, wybrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestie`,
    "selectedAnnouncement": (args)=>`${args.optionText}, wybrano`
};


var $dee9868b6fa95ffe$exports = {};
$dee9868b6fa95ffe$exports = {
    "buttonLabel": `Mostrar sugestões`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opção`,
            other: ()=>`${formatter.number(args.optionCount)} opções`
        })} disponível.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo inserido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opção`,
                    other: ()=>`${formatter.number(args.groupCount)} opções`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestões`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};


var $f8b2e63637cbb5a6$exports = {};
$f8b2e63637cbb5a6$exports = {
    "buttonLabel": `Apresentar sugestões`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opção`,
            other: ()=>`${formatter.number(args.optionCount)} opções`
        })} disponível.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo introduzido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opção`,
                    other: ()=>`${formatter.number(args.groupCount)} opções`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestões`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};


var $46a885db3b44ea95$exports = {};
$46a885db3b44ea95$exports = {
    "buttonLabel": `Afișare sugestii`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opțiune`,
            other: ()=>`${formatter.number(args.optionCount)} opțiuni`
        })} disponibile.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grup ${args.groupTitle} introdus, cu ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opțiune`,
                    other: ()=>`${formatter.number(args.groupCount)} opțiuni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selectat`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestii`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selectat`
};


var $50d8a8f0afa9dee5$exports = {};
$50d8a8f0afa9dee5$exports = {
    "buttonLabel": `Показать предложения`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} параметр`,
            other: ()=>`${formatter.number(args.optionCount)} параметров`
        })} доступно.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Введенная группа ${args.groupTitle}, с ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} параметром`,
                    other: ()=>`${formatter.number(args.groupCount)} параметрами`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, выбранными`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Предложения`,
    "selectedAnnouncement": (args)=>`${args.optionText}, выбрано`
};


var $2867ee6173245507$exports = {};
$2867ee6173245507$exports = {
    "buttonLabel": `Zobraziť návrhy`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} možnosť`,
            other: ()=>`${formatter.number(args.optionCount)} možnosti/-í`
        })} k dispozícii.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadaná skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} možnosťou`,
                    other: ()=>`${formatter.number(args.groupCount)} možnosťami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, vybraté`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Návrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybraté`
};


var $0631b65beeb09b50$exports = {};
$0631b65beeb09b50$exports = {
    "buttonLabel": `Prikaži predloge`,
    "countAnnouncement": (args, formatter)=>`Na voljo je ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Vnesena skupina ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcija`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izbrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlogi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izbrano`
};


var $65fc749265dcd686$exports = {};
$65fc749265dcd686$exports = {
    "buttonLabel": `Prikaži predloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno još: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena grupa ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} optione/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izabrano`
};


var $69ba655c7853c08e$exports = {};
$69ba655c7853c08e$exports = {
    "buttonLabel": `Visa förslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativ`
        })} tillgängliga.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingick i gruppen ${args.groupTitle} med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativ`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valda`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Förslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valda`
};


var $a79794784d61577c$exports = {};
$a79794784d61577c$exports = {
    "buttonLabel": `Önerileri göster`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} seçenek`,
            other: ()=>`${formatter.number(args.optionCount)} seçenekler`
        })} kullanılabilir.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Girilen grup ${args.groupTitle}, ile ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} seçenek`,
                    other: ()=>`${formatter.number(args.groupCount)} seçenekler`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, seçildi`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Öneriler`,
    "selectedAnnouncement": (args)=>`${args.optionText}, seçildi`
};


var $c2845791417ebaf4$exports = {};
$c2845791417ebaf4$exports = {
    "buttonLabel": `Показати пропозиції`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} параметр`,
            other: ()=>`${formatter.number(args.optionCount)} параметри(-ів)`
        })} доступно.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Введена група ${args.groupTitle}, з ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} параметр`,
                    other: ()=>`${formatter.number(args.groupCount)} параметри(-ів)`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, вибрано`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Пропозиції`,
    "selectedAnnouncement": (args)=>`${args.optionText}, вибрано`
};


var $29b642d0025cc7a4$exports = {};
$29b642d0025cc7a4$exports = {
    "buttonLabel": `显示建议`,
    "countAnnouncement": (args, formatter)=>`有 ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} 个选项`,
            other: ()=>`${formatter.number(args.optionCount)} 个选项`
        })}可用。`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`进入了 ${args.groupTitle} 组，其中有 ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} 个选项`,
                    other: ()=>`${formatter.number(args.groupCount)} 个选项`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, 已选择`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `建议`,
    "selectedAnnouncement": (args)=>`${args.optionText}, 已选择`
};


var $cd36dd33f9d46936$exports = {};
$cd36dd33f9d46936$exports = {
    "buttonLabel": `顯示建議`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} 選項`,
            other: ()=>`${formatter.number(args.optionCount)} 選項`
        })} 可用。`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`輸入的群組 ${args.groupTitle}, 有 ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} 選項`,
                    other: ()=>`${formatter.number(args.groupCount)} 選項`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, 已選取`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `建議`,
    "selectedAnnouncement": (args)=>`${args.optionText}, 已選取`
};


$2e84e748dc57e459$exports = {
    "ar-AE": $02cb4c75c506befe$exports,
    "bg-BG": $568b8163f1e56faf$exports,
    "cs-CZ": $87581c0202d106b8$exports,
    "da-DK": $a10a0369f5433ed1$exports,
    "de-DE": $bfd288727d5cb166$exports,
    "el-GR": $ca177778f9a74e3c$exports,
    "en-US": $9b5aa79ef84beb6c$exports,
    "es-ES": $57968e8209de2557$exports,
    "et-EE": $60690790bf4c1c6a$exports,
    "fi-FI": $1101246e8c7d9357$exports,
    "fr-FR": $6404b5cb5b241730$exports,
    "he-IL": $dfeafa702e92e31f$exports,
    "hr-HR": $2d125e0b34676352$exports,
    "hu-HU": $ea029611d7634059$exports,
    "it-IT": $77f075bb86ad7091$exports,
    "ja-JP": $6e87462e84907983$exports,
    "ko-KR": $9246f2c6edc6b232$exports,
    "lt-LT": $e587accc6c0a434c$exports,
    "lv-LV": $03a1900e7400b5ab$exports,
    "nb-NO": $1387676441be6cf6$exports,
    "nl-NL": $17e82ebf0f8ab91f$exports,
    "pl-PL": $2f5377d3471630e5$exports,
    "pt-BR": $dee9868b6fa95ffe$exports,
    "pt-PT": $f8b2e63637cbb5a6$exports,
    "ro-RO": $46a885db3b44ea95$exports,
    "ru-RU": $50d8a8f0afa9dee5$exports,
    "sk-SK": $2867ee6173245507$exports,
    "sl-SI": $0631b65beeb09b50$exports,
    "sr-SP": $65fc749265dcd686$exports,
    "sv-SE": $69ba655c7853c08e$exports,
    "tr-TR": $a79794784d61577c$exports,
    "uk-UA": $c2845791417ebaf4$exports,
    "zh-CN": $29b642d0025cc7a4$exports,
    "zh-TW": $cd36dd33f9d46936$exports
};






function $c350ade66beef0af$export$8c18d1b4f7232bbf(props, state) {
    let { buttonRef: buttonRef , popoverRef: popoverRef , inputRef: inputRef , listBoxRef: listBoxRef , keyboardDelegate: keyboardDelegate , shouldFocusWrap: // completionMode = 'suggest',
    shouldFocusWrap , isReadOnly: isReadOnly , isDisabled: isDisabled  } = props;
    let stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(((/*@__PURE__*/$parcel$interopDefault$3($2e84e748dc57e459$exports))));
    let { menuTriggerProps: menuTriggerProps , menuProps: menuProps  } = ($168583247155ddda$export$dc9c12ed27dd1b49)({
        type: "listbox",
        isDisabled: isDisabled || isReadOnly
    }, state, buttonRef);
    // Set listbox id so it can be used when calling getItemId later
    ($b1f0cad8af73213b$export$3585ede4d035bf14).set(state, {
        id: menuProps.id
    });
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let delegate = (useMemo)(()=>keyboardDelegate || new ($2a25aae57d74318e$export$a05409b8bb224a5a)(state.collection, state.disabledKeys, listBoxRef), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        listBoxRef
    ]);
    // Use useSelectableCollection to get the keyboard handlers to apply to the textfield
    let { collectionProps: collectionProps  } = ($ae20dd8cbca75726$export$d6daf82dcd84e87c)({
        selectionManager: state.selectionManager,
        keyboardDelegate: delegate,
        disallowTypeAhead: true,
        disallowEmptySelection: true,
        shouldFocusWrap: shouldFocusWrap,
        ref: inputRef,
        // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
        isVirtualized: true
    });
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        switch(e.key){
            case "Enter":
            case "Tab":
                // Prevent form submission if menu is open since we may be selecting a option
                if (state.isOpen && e.key === "Enter") e.preventDefault();
                state.commit();
                break;
            case "Escape":
                if (state.selectedKey !== null || state.inputValue === "" || props.allowsCustomValue) e.continuePropagation();
                state.revert();
                break;
            case "ArrowDown":
                state.open("first", "manual");
                break;
            case "ArrowUp":
                state.open("last", "manual");
                break;
            case "ArrowLeft":
            case "ArrowRight":
                state.selectionManager.setFocusedKey(null);
                break;
        }
    };
    let onBlur = (e)=>{
        var _popoverRef_current;
        // Ignore blur if focused moved to the button or into the popover.
        if (e.relatedTarget === (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) || ((_popoverRef_current = popoverRef.current) === null || _popoverRef_current === void 0 ? void 0 : _popoverRef_current.contains(e.relatedTarget))) return;
        if (props.onBlur) props.onBlur(e);
        state.setFocused(false);
    };
    let onFocus = (e)=>{
        if (state.isFocused) return;
        if (props.onFocus) props.onFocus(e);
        state.setFocused(true);
    };
    let { labelProps: labelProps , inputProps: inputProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($2d73ec29415bd339$export$712718f7aec83d5)({
        ...props,
        onChange: state.setInputValue,
        onKeyDown: !isReadOnly && ($ff5963eb1fccf552$export$e08e3b67e392101e)(state.isOpen && collectionProps.onKeyDown, onKeyDown, props.onKeyDown),
        onBlur: onBlur,
        value: state.inputValue,
        onFocus: onFocus,
        autoComplete: "off"
    }, inputRef);
    // Press handlers for the ComboBox button
    let onPress = (e)=>{
        if (e.pointerType === "touch") {
            // Focus the input field in case it isn't focused yet
            inputRef.current.focus();
            state.toggle(null, "manual");
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType !== "touch") {
            inputRef.current.focus();
            state.toggle(e.pointerType === "keyboard" || e.pointerType === "virtual" ? "first" : null, "manual");
        }
    };
    let triggerLabelProps = ($313b98861ee5dd6c$export$d6875122194c7b44)({
        id: menuTriggerProps.id,
        "aria-label": stringFormatter.format("buttonLabel"),
        "aria-labelledby": props["aria-labelledby"] || labelProps.id
    });
    let listBoxProps = ($313b98861ee5dd6c$export$d6875122194c7b44)({
        id: menuProps.id,
        "aria-label": stringFormatter.format("listboxLabel"),
        "aria-labelledby": props["aria-labelledby"] || labelProps.id
    });
    // If a touch happens on direct center of ComboBox input, might be virtual click from iPad so open ComboBox menu
    let lastEventTime = (useRef)(0);
    let onTouchEnd = (e)=>{
        if (isDisabled || isReadOnly) return;
        // Sometimes VoiceOver on iOS fires two touchend events in quick succession. Ignore the second one.
        if (e.timeStamp - lastEventTime.current < 500) {
            e.preventDefault();
            inputRef.current.focus();
            return;
        }
        let rect = e.target.getBoundingClientRect();
        let touch = e.changedTouches[0];
        let centerX = Math.ceil(rect.left + .5 * rect.width);
        let centerY = Math.ceil(rect.top + .5 * rect.height);
        if (touch.clientX === centerX && touch.clientY === centerY) {
            e.preventDefault();
            inputRef.current.focus();
            state.toggle(null, "manual");
            lastEventTime.current = e.timeStamp;
        }
    };
    // VoiceOver has issues with announcing aria-activedescendant properly on change
    // (especially on iOS). We use a live region announcer to announce focus changes
    // manually. In addition, section titles are announced when navigating into a new section.
    let focusedItem = state.selectionManager.focusedKey != null && state.isOpen ? state.collection.getItem(state.selectionManager.focusedKey) : undefined;
    var _focusedItem_parentKey;
    let sectionKey = (_focusedItem_parentKey = focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.parentKey) !== null && _focusedItem_parentKey !== void 0 ? _focusedItem_parentKey : null;
    var _state_selectionManager_focusedKey;
    let itemKey = (_state_selectionManager_focusedKey = state.selectionManager.focusedKey) !== null && _state_selectionManager_focusedKey !== void 0 ? _state_selectionManager_focusedKey : null;
    let lastSection = (useRef)(sectionKey);
    let lastItem = (useRef)(itemKey);
    (useEffect)(()=>{
        if (($c87311424ea30a05$export$e1865c3bedcd822b)() && focusedItem != null && itemKey !== lastItem.current) {
            let isSelected = state.selectionManager.isSelected(itemKey);
            let section = sectionKey != null ? state.collection.getItem(sectionKey) : null;
            let sectionTitle = (section === null || section === void 0 ? void 0 : section["aria-label"]) || (typeof (section === null || section === void 0 ? void 0 : section.rendered) === "string" ? section.rendered : "") || "";
            let announcement = stringFormatter.format("focusAnnouncement", {
                isGroupChange: section && sectionKey !== lastSection.current,
                groupTitle: sectionTitle,
                groupCount: section ? [
                    ...section.childNodes
                ].length : 0,
                optionText: focusedItem["aria-label"] || focusedItem.textValue || "",
                isSelected: isSelected
            });
            ($319e236875307eab$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSection.current = sectionKey;
        lastItem.current = itemKey;
    });
    // Announce the number of available suggestions when it changes
    let optionCount = ($453cc9f0df89c0a5$export$77d5aafae4e095b2)(state.collection);
    let lastSize = (useRef)(optionCount);
    let lastOpen = (useRef)(state.isOpen);
    (useEffect)(()=>{
        // Only announce the number of options available when the menu opens if there is no
        // focused item, otherwise screen readers will typically read e.g. "1 of 6".
        // The exception is VoiceOver since this isn't included in the message above.
        let didOpenWithoutFocusedItem = state.isOpen !== lastOpen.current && (state.selectionManager.focusedKey == null || ($c87311424ea30a05$export$e1865c3bedcd822b)());
        if (state.isOpen && (didOpenWithoutFocusedItem || optionCount !== lastSize.current)) {
            let announcement = stringFormatter.format("countAnnouncement", {
                optionCount: optionCount
            });
            ($319e236875307eab$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSize.current = optionCount;
        lastOpen.current = state.isOpen;
    });
    // Announce when a selection occurs for VoiceOver. Other screen readers typically do this automatically.
    let lastSelectedKey = (useRef)(state.selectedKey);
    (useEffect)(()=>{
        if (($c87311424ea30a05$export$e1865c3bedcd822b)() && state.isFocused && state.selectedItem && state.selectedKey !== lastSelectedKey.current) {
            let optionText = state.selectedItem["aria-label"] || state.selectedItem.textValue || "";
            let announcement = stringFormatter.format("selectedAnnouncement", {
                optionText: optionText
            });
            ($319e236875307eab$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSelectedKey.current = state.selectedKey;
    });
    (useEffect)(()=>{
        if (state.isOpen) return ($5e3802645cc19319$export$1c3ebcada18427bf)([
            inputRef.current,
            popoverRef.current
        ]);
    }, [
        state.isOpen,
        inputRef,
        popoverRef
    ]);
    return {
        labelProps: labelProps,
        buttonProps: {
            ...menuTriggerProps,
            ...triggerLabelProps,
            excludeFromTabOrder: true,
            onPress: onPress,
            onPressStart: onPressStart,
            isDisabled: isDisabled || isReadOnly
        },
        inputProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(inputProps, {
            role: "combobox",
            "aria-expanded": menuTriggerProps["aria-expanded"],
            "aria-controls": state.isOpen ? menuProps.id : undefined,
            // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
            "aria-autocomplete": "list",
            "aria-activedescendant": focusedItem ? ($b1f0cad8af73213b$export$9145995848b05025)(state, focusedItem.key) : undefined,
            onTouchEnd: onTouchEnd,
            // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
            autoCorrect: "off",
            // This disable's the macOS Safari spell check auto corrections.
            spellCheck: "false"
        }),
        listBoxProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(menuProps, listBoxProps, {
            autoFocus: state.focusStrategy,
            shouldUseVirtualFocus: true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $103790afe9474d1c$export$60b7b4bcf3903d8e;
(function(DROP_OPERATION) {
    DROP_OPERATION[DROP_OPERATION["none"] = 0] = "none";
    DROP_OPERATION[DROP_OPERATION["cancel"] = 0] = "cancel";
    DROP_OPERATION[DROP_OPERATION["move"] = 1] = "move";
    DROP_OPERATION[DROP_OPERATION["copy"] = 2] = "copy";
    DROP_OPERATION[DROP_OPERATION["link"] = 4] = "link";
    DROP_OPERATION[DROP_OPERATION["all"] = 7] = "all";
})($103790afe9474d1c$export$60b7b4bcf3903d8e || ($103790afe9474d1c$export$60b7b4bcf3903d8e = {}));
const $103790afe9474d1c$export$9bbdfc78cf083e16 = {
    ...$103790afe9474d1c$export$60b7b4bcf3903d8e,
    copyMove: $103790afe9474d1c$export$60b7b4bcf3903d8e.copy | $103790afe9474d1c$export$60b7b4bcf3903d8e.move,
    copyLink: $103790afe9474d1c$export$60b7b4bcf3903d8e.copy | $103790afe9474d1c$export$60b7b4bcf3903d8e.link,
    linkMove: $103790afe9474d1c$export$60b7b4bcf3903d8e.link | $103790afe9474d1c$export$60b7b4bcf3903d8e.move,
    all: $103790afe9474d1c$export$60b7b4bcf3903d8e.all,
    uninitialized: $103790afe9474d1c$export$60b7b4bcf3903d8e.all
};
const $103790afe9474d1c$export$dd0165308d8bff45 = $103790afe9474d1c$var$invert($103790afe9474d1c$export$9bbdfc78cf083e16);
$103790afe9474d1c$export$dd0165308d8bff45[$103790afe9474d1c$export$60b7b4bcf3903d8e.all] = "all"; // ensure we don't map to 'uninitialized'.
$103790afe9474d1c$var$invert($103790afe9474d1c$export$60b7b4bcf3903d8e);
const $103790afe9474d1c$export$608ecc6f1b23c35d = {
    none: "cancel",
    link: "link",
    copy: "copy",
    move: "move"
};
$103790afe9474d1c$var$invert($103790afe9474d1c$export$608ecc6f1b23c35d);
function $103790afe9474d1c$var$invert(object) {
    let res = {};
    for(let key in object)res[object[key]] = key;
    return res;
}
($103790afe9474d1c$export$60b7b4bcf3903d8e).none;

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
// use high res timer if available
let $3eb131dcf37ad5f8$var$perf = typeof window !== "undefined" ? window.performance : null;
// @ts-ignore
let $3eb131dcf37ad5f8$var$perfNow = $3eb131dcf37ad5f8$var$perf && ($3eb131dcf37ad5f8$var$perf.now || $3eb131dcf37ad5f8$var$perf.webkitNow || $3eb131dcf37ad5f8$var$perf.msNow || $3eb131dcf37ad5f8$var$perf.mozNow);
$3eb131dcf37ad5f8$var$perfNow ? $3eb131dcf37ad5f8$var$perfNow.bind($3eb131dcf37ad5f8$var$perf) : function() {
    return Date.now ? Date.now() : new Date().getTime();
};

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $ad5aea03cc53c961$exports = {};
var $03c9a1a10de12f06$exports = {};
$03c9a1a10de12f06$exports = {
    "Clear search": `مسح البحث`
};


var $4da0c2ffa4ba4159$exports = {};
$4da0c2ffa4ba4159$exports = {
    "Clear search": `Изчистване на търсене`
};


var $8c59fd0c2c96821b$exports = {};
$8c59fd0c2c96821b$exports = {
    "Clear search": `Vymazat hledání`
};


var $0a371f9c1df8120f$exports = {};
$0a371f9c1df8120f$exports = {
    "Clear search": `Ryd søgning`
};


var $67f4d0b0de9f8a52$exports = {};
$67f4d0b0de9f8a52$exports = {
    "Clear search": `Suche zurücksetzen`
};


var $72a312d948f0214b$exports = {};
$72a312d948f0214b$exports = {
    "Clear search": `Απαλοιφή αναζήτησης`
};


var $5012d21d933388c1$exports = {};
$5012d21d933388c1$exports = {
    "Clear search": `Clear search`
};


var $0159854399308e2e$exports = {};
$0159854399308e2e$exports = {
    "Clear search": `Borrar búsqueda`
};


var $390613981d970276$exports = {};
$390613981d970276$exports = {
    "Clear search": `Tühjenda otsing`
};


var $961ae0833f811705$exports = {};
$961ae0833f811705$exports = {
    "Clear search": `Tyhjennä haku`
};


var $26d76742decfd829$exports = {};
$26d76742decfd829$exports = {
    "Clear search": `Effacer la recherche`
};


var $92ef254c82a5c769$exports = {};
$92ef254c82a5c769$exports = {
    "Clear search": `נקה חיפוש`
};


var $e0321b43bdefb8b3$exports = {};
$e0321b43bdefb8b3$exports = {
    "Clear search": `Obriši pretragu`
};


var $0c1ee0b8d50940d9$exports = {};
$0c1ee0b8d50940d9$exports = {
    "Clear search": `Keresés törlése`
};


var $b09198915a38946f$exports = {};
$b09198915a38946f$exports = {
    "Clear search": `Cancella ricerca`
};


var $3a9a3d180c3145c0$exports = {};
$3a9a3d180c3145c0$exports = {
    "Clear search": `検索をクリア`
};


var $b7a611726449f4a3$exports = {};
$b7a611726449f4a3$exports = {
    "Clear search": `검색 지우기`
};


var $d9a3d49db610dd5c$exports = {};
$d9a3d49db610dd5c$exports = {
    "Clear search": `Išvalyti iešką`
};


var $3ab64b73ea27c23a$exports = {};
$3ab64b73ea27c23a$exports = {
    "Clear search": `Notīrīt meklēšanu`
};


var $bf5cce1b47d23baf$exports = {};
$bf5cce1b47d23baf$exports = {
    "Clear search": `Tøm søk`
};


var $4e0c9a9a010e4598$exports = {};
$4e0c9a9a010e4598$exports = {
    "Clear search": `Zoekactie wissen`
};


var $63cf4a75ec270508$exports = {};
$63cf4a75ec270508$exports = {
    "Clear search": `Wyczyść zawartość wyszukiwania`
};


var $083b0cad27fdbd06$exports = {};
$083b0cad27fdbd06$exports = {
    "Clear search": `Limpar pesquisa`
};


var $1b7f0864d830ba6d$exports = {};
$1b7f0864d830ba6d$exports = {
    "Clear search": `Limpar pesquisa`
};


var $d6d2588377fc9718$exports = {};
$d6d2588377fc9718$exports = {
    "Clear search": `Ştergeţi căutarea`
};


var $701c918a4653e946$exports = {};
$701c918a4653e946$exports = {
    "Clear search": `Очистить поиск`
};


var $7cacc29a1e5f4fbe$exports = {};
$7cacc29a1e5f4fbe$exports = {
    "Clear search": `Vymazať vyhľadávanie`
};


var $c63231bcc300d0df$exports = {};
$c63231bcc300d0df$exports = {
    "Clear search": `Počisti iskanje`
};


var $b61510478bc0e6f6$exports = {};
$b61510478bc0e6f6$exports = {
    "Clear search": `Obriši pretragu`
};


var $ce325e6dd3f9c37a$exports = {};
$ce325e6dd3f9c37a$exports = {
    "Clear search": `Rensa sökning`
};


var $1f7e1cf2285af2b2$exports = {};
$1f7e1cf2285af2b2$exports = {
    "Clear search": `Aramayı temizle`
};


var $2d999353ca652e34$exports = {};
$2d999353ca652e34$exports = {
    "Clear search": `Очистити пошук`
};


var $117b536bfb1ae554$exports = {};
$117b536bfb1ae554$exports = {
    "Clear search": `清除搜索`
};


var $525f6fa4ac26e278$exports = {};
$525f6fa4ac26e278$exports = {
    "Clear search": `清除搜尋條件`
};


$ad5aea03cc53c961$exports = {
    "ar-AE": $03c9a1a10de12f06$exports,
    "bg-BG": $4da0c2ffa4ba4159$exports,
    "cs-CZ": $8c59fd0c2c96821b$exports,
    "da-DK": $0a371f9c1df8120f$exports,
    "de-DE": $67f4d0b0de9f8a52$exports,
    "el-GR": $72a312d948f0214b$exports,
    "en-US": $5012d21d933388c1$exports,
    "es-ES": $0159854399308e2e$exports,
    "et-EE": $390613981d970276$exports,
    "fi-FI": $961ae0833f811705$exports,
    "fr-FR": $26d76742decfd829$exports,
    "he-IL": $92ef254c82a5c769$exports,
    "hr-HR": $e0321b43bdefb8b3$exports,
    "hu-HU": $0c1ee0b8d50940d9$exports,
    "it-IT": $b09198915a38946f$exports,
    "ja-JP": $3a9a3d180c3145c0$exports,
    "ko-KR": $b7a611726449f4a3$exports,
    "lt-LT": $d9a3d49db610dd5c$exports,
    "lv-LV": $3ab64b73ea27c23a$exports,
    "nb-NO": $bf5cce1b47d23baf$exports,
    "nl-NL": $4e0c9a9a010e4598$exports,
    "pl-PL": $63cf4a75ec270508$exports,
    "pt-BR": $083b0cad27fdbd06$exports,
    "pt-PT": $1b7f0864d830ba6d$exports,
    "ro-RO": $d6d2588377fc9718$exports,
    "ru-RU": $701c918a4653e946$exports,
    "sk-SK": $7cacc29a1e5f4fbe$exports,
    "sl-SI": $c63231bcc300d0df$exports,
    "sr-SP": $b61510478bc0e6f6$exports,
    "sv-SE": $ce325e6dd3f9c37a$exports,
    "tr-TR": $1f7e1cf2285af2b2$exports,
    "uk-UA": $2d999353ca652e34$exports,
    "zh-CN": $117b536bfb1ae554$exports,
    "zh-TW": $525f6fa4ac26e278$exports
};




function $4d52238874b24f86$export$9bb30bbe003b82e0(props, state, inputRef) {
    let stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(((/*@__PURE__*/$parcel$interopDefault($ad5aea03cc53c961$exports))));
    let { isDisabled: isDisabled , isReadOnly: isReadOnly , onSubmit: onSubmit = ()=>{} , onClear: onClear , type: type = "search"  } = props;
    let onKeyDown = (e)=>{
        const key = e.key;
        if (key === "Enter" || key === "Escape") e.preventDefault();
        if (isDisabled || isReadOnly) return;
        if (key === "Enter") onSubmit(state.value);
        if (key === "Escape") {
            state.setValue("");
            if (onClear) onClear();
        }
    };
    let onClearButtonClick = ()=>{
        state.setValue("");
        if (onClear) onClear();
    };
    let onPressStart = ()=>{
        // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
        // the input and close the keyboard
        inputRef.current.focus();
    };
    let { labelProps: labelProps , inputProps: inputProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($2d73ec29415bd339$export$712718f7aec83d5)({
        ...props,
        value: state.value,
        onChange: state.setValue,
        onKeyDown: ($ff5963eb1fccf552$export$e08e3b67e392101e)(onKeyDown, props.onKeyDown),
        type: type
    }, inputRef);
    return {
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            // already handled by useSearchFieldState
            defaultValue: undefined
        },
        clearButtonProps: {
            "aria-label": stringFormatter.format("Clear search"),
            excludeFromTabOrder: true,
            // @ts-ignore
            preventFocusOnPress: true,
            isDisabled: isDisabled || isReadOnly,
            onPress: onClearButtonClick,
            onPressStart: onPressStart
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






function $58aed456727eb0f3$export$e64b2f635402ca43(props, state, ref) {
    let { keyboardDelegate: keyboardDelegate , isDisabled: isDisabled  } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = ($325a3faab7a68acd$export$a16aca283550c30d)({
        usage: "search",
        sensitivity: "base"
    });
    let delegate = (useMemo)(()=>keyboardDelegate || new ($2a25aae57d74318e$export$a05409b8bb224a5a)(state.collection, state.disabledKeys, null, collator), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        collator
    ]);
    let { menuTriggerProps: menuTriggerProps , menuProps: menuProps  } = ($168583247155ddda$export$dc9c12ed27dd1b49)({
        isDisabled: isDisabled,
        type: "listbox"
    }, state, ref);
    let onKeyDown = (e)=>{
        switch(e.key){
            case "ArrowLeft":
                {
                    // prevent scrolling containers
                    e.preventDefault();
                    let key = state.selectedKey != null ? delegate.getKeyAbove(state.selectedKey) : delegate.getFirstKey();
                    if (key) state.setSelectedKey(key);
                    break;
                }
            case "ArrowRight":
                {
                    // prevent scrolling containers
                    e.preventDefault();
                    let key1 = state.selectedKey != null ? delegate.getKeyBelow(state.selectedKey) : delegate.getFirstKey();
                    if (key1) state.setSelectedKey(key1);
                    break;
                }
        }
    };
    let { typeSelectProps: typeSelectProps  } = ($fb3050f43d946246$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: state.selectionManager,
        onTypeSelect (key) {
            state.setSelectedKey(key);
        }
    });
    let { labelProps: labelProps , fieldProps: fieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($2baaea4c71418dea$export$294aa081a6c6f55d)({
        ...props,
        labelElementType: "span"
    });
    typeSelectProps.onKeyDown = typeSelectProps.onKeyDownCapture;
    delete typeSelectProps.onKeyDownCapture;
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let triggerProps = ($3ef42575df84b30b$export$9d1611c77c2fe928)(typeSelectProps, menuTriggerProps, fieldProps);
    let valueId = ($bdb11010cef70236$export$f680877a34711e37)();
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                if (!props.isDisabled) {
                    ref.current.focus();
                    // Show the focus ring so the user knows where focus went
                    ($507fabe10e71c6fb$export$8397ddfc504fdb9a)("keyboard");
                }
            }
        },
        triggerProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, {
            ...triggerProps,
            isDisabled: isDisabled,
            onKeyDown: ($ff5963eb1fccf552$export$e08e3b67e392101e)(triggerProps.onKeyDown, onKeyDown, props.onKeyDown),
            onKeyUp: props.onKeyUp,
            "aria-labelledby": [
                triggerProps["aria-labelledby"],
                triggerProps["aria-label"] && !triggerProps["aria-labelledby"] ? triggerProps.id : null,
                valueId
            ].filter(Boolean).join(" "),
            onFocus (e) {
                if (state.isFocused) return;
                if (props.onFocus) props.onFocus(e);
                if (props.onFocusChange) props.onFocusChange(true);
                state.setFocused(true);
            },
            onBlur (e) {
                if (state.isOpen) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            }
        }),
        valueProps: {
            id: valueId
        },
        menuProps: {
            ...menuProps,
            autoFocus: state.focusStrategy || true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            disallowEmptySelection: true,
            onBlur: (e)=>{
                if (e.currentTarget.contains(e.relatedTarget)) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            },
            "aria-labelledby": [
                fieldProps["aria-labelledby"],
                triggerProps["aria-label"] && !fieldProps["aria-labelledby"] ? triggerProps.id : null
            ].filter(Boolean).join(" ")
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $bdd25dc72710631f$export$f809e80f58e251d1(props, state, triggerRef) {
    let { autoComplete: autoComplete , name: name , isDisabled: isDisabled  } = props;
    let modality = ($507fabe10e71c6fb$export$98e20ec92f614cfe)();
    let { visuallyHiddenProps: visuallyHiddenProps  } = ($5c3e21d68f1c4674$export$a966af930f325cab)();
    var _state_selectedKey;
    // In Safari, the <select> cannot have `display: none` or `hidden` for autofill to work.
    // In Firefox, there must be a <label> to identify the <select> whereas other browsers
    // seem to identify it just by surrounding text.
    // The solution is to use <VisuallyHidden> to hide the elements, which clips the elements to a
    // 1px rectangle. In addition, we hide from screen readers with aria-hidden, and make the <select>
    // non tabbable with tabIndex={-1}.
    //
    // In mobile browsers, there are next/previous buttons above the software keyboard for navigating
    // between fields in a form. These only support native form inputs that are tabbable. In order to
    // support those, an additional hidden input is used to marshall focus to the button. It is tabbable
    // except when the button is focused, so that shift tab works properly to go to the actual previous
    // input in the form. Using the <select> for this also works, but Safari on iOS briefly flashes
    // the native menu on focus, so this isn't ideal. A font-size of 16px or greater is required to
    // prevent Safari from zooming in on the input when it is focused.
    //
    // If the current interaction modality is null, then the user hasn't interacted with the page yet.
    // In this case, we set the tabIndex to -1 on the input element so that automated accessibility
    // checkers don't throw false-positives about focusable elements inside an aria-hidden parent.
    return {
        containerProps: {
            ...visuallyHiddenProps,
            "aria-hidden": true
        },
        inputProps: {
            type: "text",
            tabIndex: modality == null || state.isFocused || state.isOpen ? -1 : 0,
            style: {
                fontSize: 16
            },
            onFocus: ()=>triggerRef.current.focus(),
            disabled: isDisabled
        },
        selectProps: {
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            name: name,
            size: state.collection.size,
            value: (_state_selectedKey = state.selectedKey) !== null && _state_selectedKey !== void 0 ? _state_selectedKey : "",
            onChange: (e)=>state.setSelectedKey(e.target.value)
        }
    };
}
function $bdd25dc72710631f$export$cbd84cdb2e668835(props) {
    let { state: state , triggerRef: triggerRef , label: label , name: name , isDisabled: isDisabled  } = props;
    let { containerProps: containerProps , inputProps: inputProps , selectProps: selectProps  } = $bdd25dc72710631f$export$f809e80f58e251d1(props, state, triggerRef);
    // If used in a <form>, use a hidden input so the value can be submitted to a server.
    // If the collection isn't too big, use a hidden <select> element for this so that browser
    // autofill will work. Otherwise, use an <input type="hidden">.
    if (state.collection.size <= 300) return /*#__PURE__*/ (React__default).createElement("div", containerProps, /*#__PURE__*/ (React__default).createElement("input", inputProps), /*#__PURE__*/ (React__default).createElement("label", null, label, /*#__PURE__*/ (React__default).createElement("select", selectProps, /*#__PURE__*/ (React__default).createElement("option", null), [
        ...state.collection.getKeys()
    ].map((key)=>{
        let item = state.collection.getItem(key);
        if (item.type === "item") return /*#__PURE__*/ (React__default).createElement("option", {
            key: item.key,
            value: item.key
        }, item.textValue);
    }))));
    else if (name) return /*#__PURE__*/ (React__default).createElement("input", {
        type: "hidden",
        autoComplete: selectProps.autoComplete,
        name: name,
        disabled: isDisabled,
        value: state.selectedKey
    });
    return null;
}

const classnames$1 = (...classes) => classes.join(' ');

const StyledSpinner = styled.svg `
  animation: rotate 1s linear infinite;
  flex-shrink: 0;
  font-size: ${({ size }) => size}px;
  height: 1em;
  width: 1em;

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;
const Spinner = ({ color = Colors$1.ElectricBrand, size = 24 }) => {
    return (jsxs(StyledSpinner, { className: 'spinner', "data-testid": 'spinner-icon', role: 'img', size: size, viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', children: [jsx("title", { children: "Loading spinner" }), jsx("path", { fill: color, fillRule: 'evenodd', d: 'M12 19a7 7 0 100-14 7 7 0 000 14zm0 3c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z', clipRule: 'evenodd', opacity: '0.2' }), jsx("path", { fill: color, d: 'M2 12C2 6.477 6.477 2 12 2v3a7 7 0 00-7 7H2z' })] }));
};

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}

					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames));

var Ft = classnames.exports;

function getAlignment(placement) {
  return placement.split('-')[1];
}

function getLengthFromAxis(axis) {
  return axis === 'y' ? 'height' : 'width';
}

function getSide(placement) {
  return placement.split('-')[0];
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'x' : 'y';
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const mainAxis = getMainAxisFromPlacement(placement);
  const length = getLengthFromAxis(mainAxis);
  const commonAlign = reference[length] / 2 - floating[length] / 2;
  const side = getSide(placement);
  const isVertical = mainAxis === 'x';
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}

function getSideObjectFromPadding(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}

function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = options;
  const paddingObject = getSideObjectFromPadding(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

const min$1 = Math.min;
const max$1 = Math.max;

function within(min$1$1, value, max$1$1) {
  return max$1(min$1$1, min$1(value, max$1$1));
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = options || {};
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements
    } = state;
    if (element == null) {
      return {};
    }
    const paddingObject = getSideObjectFromPadding(padding);
    const coords = {
      x,
      y
    };
    const axis = getMainAxisFromPlacement(placement);
    const length = getLengthFromAxis(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min = paddingObject[minProp];
    const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = within(min, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. This stops `shift()` from taking action, but can
    // be worked around by calling it again after the `arrow()` if desired.
    const shouldAddOffset = getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min ? paddingObject[minProp] : paddingObject[maxProp]) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
    return {
      [axis]: coords[axis] - alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset
      }
    };
  }
});

const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}

function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const mainAxis = getMainAxisFromPlacement(placement);
  const length = getLengthFromAxis(mainAxis);
  let mainAlignmentSide = mainAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return {
    main: mainAlignmentSide,
    cross: getOppositePlacement(mainAlignmentSide)
  };
}

const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}

function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}

function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = options;
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const {
          main,
          cross
        } = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[main], overflow[cross]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

async function convertValueToCoords(state, value) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getMainAxisFromPlacement(placement) === 'x';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = typeof value === 'function' ? value(state) : value;

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (value) {
  if (value === void 0) {
    value = 0;
  }
  return {
    name: 'offset',
    options: value,
    async fn(state) {
      const {
        x,
        y
      } = state;
      const diffCoords = await convertValueToCoords(state, value);
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: diffCoords
      };
    }
  };
};

function getCrossAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = options;
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const mainAxis = getMainAxisFromPlacement(getSide(placement));
      const crossAxis = getCrossAxis(mainAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = within(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = within(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};

function getWindow(node) {
  var _node$ownerDocument;
  return ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isNode(value) {
  return value instanceof getWindow(value).Node;
}
function getNodeName(node) {
  return isNode(node) ? (node.nodeName || '').toLowerCase() : '';
}

let uaString;
function getUAString() {
  if (uaString) {
    return uaString;
  }
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    uaString = uaData.brands.map(item => item.brand + "/" + item.version).join(' ');
    return uaString;
  }
  return navigator.userAgent;
}

function isHTMLElement(value) {
  return value instanceof getWindow(value).HTMLElement;
}
function isElement(value) {
  return value instanceof getWindow(value).Element;
}
function isShadowRoot(node) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  const OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  // TODO: Try to use feature detection here instead.
  const isFirefox = /firefox/i.test(getUAString());
  const css = getComputedStyle$1(element);
  const backdropFilter = css.backdropFilter || css.WebkitBackdropFilter;

  // This is non-exhaustive but covers the most common CSS properties that
  // create a containing block.
  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (backdropFilter ? backdropFilter !== 'none' : false) || isFirefox && css.willChange === 'filter' || isFirefox && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective'].some(value => css.willChange.includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => {
    // Add type check for old browsers.
    const contain = css.contain;
    return contain != null ? contain.includes(value) : false;
  });
}

/**
 * Determines whether or not `.getBoundingClientRect()` is affected by visual
 * viewport offsets. In Safari, the `x`/`y` offsets are values relative to the
 * visual viewport, while in other engines, they are values relative to the
 * layout viewport.
 */
function isClientRectVisualViewportBased() {
  // TODO: Try to use feature detection here instead. Feature detection for
  // this can fail in various ways, making the userAgent check the most
  // reliable:
  // • Always-visible scrollbar or not
  // • Width of <html>

  // Is Safari.
  return /^((?!chrome|android).)*safari/i.test(getUAString());
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}

const min = Math.min;
const max = Math.max;
const round = Math.round;

function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width);
  let height = parseFloat(css.height);
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    fallback: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

const FALLBACK_SCALE = {
  x: 1,
  y: 1
};
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return FALLBACK_SCALE;
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    fallback
  } = getCssDimensions(domElement);
  let x = (fallback ? round(rect.width) : rect.width) / width;
  let y = (fallback ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  var _win$visualViewport, _win$visualViewport2;
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = FALLBACK_SCALE;
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const win = domElement ? getWindow(domElement) : window;
  const addVisualOffsets = isClientRectVisualViewportBased() && isFixedStrategy;
  let x = (clientRect.left + (addVisualOffsets ? ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0 : 0)) / scale.x;
  let y = (clientRect.top + (addVisualOffsets ? ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0 : 0)) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle(currentIFrame);
      iframeRect.x += (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      iframeRect.y += (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += iframeRect.x;
      y += iframeRect.y;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

function getDocumentElement(node) {
  return ((isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}

function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = {
    x: 1,
    y: 1
  };
  const offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}

function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    // `getParentNode` will never return a `Document` due to the fallback
    // check, so it's either the <html> or <body> element.
    return parentNode.ownerDocument.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}

function getOverflowAncestors(node, list) {
  var _node$ownerDocument;
  if (list === void 0) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor));
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isClientRectVisualViewportBased();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : {
    x: 1,
    y: 1
  };
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const mutableRect = {
      ...clippingAncestor
    };
    if (isClientRectVisualViewportBased()) {
      var _win$visualViewport, _win$visualViewport2;
      const win = getWindow(element);
      mutableRect.x -= ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0;
      mutableRect.y -= ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0;
    }
    rect = mutableRect;
  }
  return rectToClientRect(rect);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const containingBlock = isContainingBlock(currentNode);
    if (computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !containingBlock && !currentContainingBlockComputedStyle : !containingBlock && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  return getCssDimensions(element);
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow(element);
  if (!isHTMLElement(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const rect = getBoundingClientRect(element, true, strategy === 'fixed', offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

const platform = {
  getClippingRect,
  convertOffsetParentRelativeRectToViewportRelativeRect,
  isElement,
  getDimensions,
  getOffsetParent,
  getDocumentElement,
  getScale,
  async getElementRects(_ref) {
    let {
      reference,
      floating,
      strategy
    } = _ref;
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
      reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
      floating: {
        x: 0,
        y: 0,
        ...(await getDimensionsFn(floating))
      }
    };
  },
  getClientRects: element => Array.from(element.getClientRects()),
  isRTL: element => getComputedStyle$1(element).direction === 'rtl'
};

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

var Xt=(o,d,h)=>{let c=null;return function(...p){let E=()=>{c=null,h||o.apply(this,p);};c&&clearTimeout(c),c=setTimeout(E,d);}},Pt=Xt;var gt="DEFAULT_TOOLTIP_ID",Gt={anchorRefs:new Set,activeAnchor:{current:null},attach:()=>{},detach:()=>{},setActiveAnchor:()=>{}},Qt={getTooltipData:()=>Gt},Rt=createContext(Qt);function j(o=gt){return useContext(Rt).getTooltipData(o)}var ce=typeof window!="undefined"?useLayoutEffect:useEffect,$t=ce;var Mt=async({elementReference:o=null,tooltipReference:d=null,tooltipArrowReference:h=null,place:c="top",offset:m=10,strategy:p="absolute",middlewares:E=[offset(Number(m)),flip(),shift({padding:5})]})=>{if(!o)return {tooltipStyles:{},tooltipArrowStyles:{},place:c};if(d===null)return {tooltipStyles:{},tooltipArrowStyles:{},place:c};let v=E;return h?(v.push(arrow({element:h,padding:5})),computePosition(o,d,{placement:c,strategy:p,middleware:v}).then(({x:b,y:A,placement:r,middlewareData:a})=>{var M,R;let s={left:`${b}px`,top:`${A}px`},{x:n,y}=(M=a.arrow)!=null?M:{x:0,y:0},L=(R={top:"bottom",right:"left",bottom:"top",left:"right"}[r.split("-")[0]])!=null?R:"bottom",tt={left:n!=null?`${n}px`:"",top:y!=null?`${y}px`:"",right:"",bottom:"",[L]:"-4px"};return {tooltipStyles:s,tooltipArrowStyles:tt,place:r}})):computePosition(o,d,{placement:"bottom",strategy:p,middleware:v}).then(({x:b,y:A,placement:r})=>({tooltipStyles:{left:`${b}px`,top:`${A}px`},tooltipArrowStyles:{},place:r}))};var F={arrow:"react-tooltip__arrow_KtSkBq",clickable:"react-tooltip__clickable_KtSkBq",dark:"react-tooltip__dark_KtSkBq",error:"react-tooltip__error_KtSkBq",fixed:"react-tooltip__fixed_KtSkBq",info:"react-tooltip__info_KtSkBq",light:"react-tooltip__light_KtSkBq",noArrow:"react-tooltip__no-arrow_KtSkBq",show:"react-tooltip__show_KtSkBq",success:"react-tooltip__success_KtSkBq",tooltip:"react-tooltip__tooltip_KtSkBq",warning:"react-tooltip__warning_KtSkBq"};var Te=({id:o,className:d,classNameArrow:h,variant:c="dark",anchorId:m,anchorSelect:p,place:E="top",offset:v=10,events:b=["hover"],openOnClick:A=!1,positionStrategy:r="absolute",middlewares:a,wrapper:s,delayShow:n=0,delayHide:y=0,float:L=!1,noArrow:tt=!1,clickable:M=!1,closeOnEsc:R=!1,style:et,position:ot,afterShow:rt,afterHide:nt,content:J,contentWrapperRef:I,isOpen:U,setIsOpen:it,activeAnchor:H,setActiveAnchor:lt})=>{let S=useRef(null),z=useRef(null),B=useRef(null),q=useRef(null),[Lt,st]=useState(E),[Tt,dt]=useState({}),[kt,mt]=useState({}),[D,yt]=useState(!1),[ht,Y]=useState(!1),Et=useRef(!1),ct=useRef(null),{anchorRefs:_t,setActiveAnchor:xt}=j(o),at=useRef(!1),[$,pt]=useState([]),X=useRef(!1),P=A||b.includes("click");$t(()=>(X.current=!0,()=>{X.current=!1;}),[]),useEffect(()=>{if(!D){let t=setTimeout(()=>{Y(!1);},150);return ()=>{clearTimeout(t);}}return ()=>null},[D]);let O=t=>{X.current&&(t&&Y(!0),setTimeout(()=>{X.current&&(it==null||it(t),U===void 0&&yt(t));},10));};useEffect(()=>{if(U===void 0)return ()=>null;U&&Y(!0);let t=setTimeout(()=>{yt(U);},10);return ()=>{clearTimeout(t);}},[U]),useEffect(()=>{D!==Et.current&&(Et.current=D,D?rt==null||rt():nt==null||nt());},[D]);let wt=()=>{B.current&&clearTimeout(B.current),B.current=setTimeout(()=>{O(!0);},n);},G=(t=y)=>{q.current&&clearTimeout(q.current),q.current=setTimeout(()=>{at.current||O(!1);},t);},ut=t=>{var i;if(!t)return;n?wt():O(!0);let l=(i=t.currentTarget)!=null?i:t.target;lt(l),xt({current:l}),q.current&&clearTimeout(q.current);},ft=()=>{M?G(y||100):y?G():O(!1),B.current&&clearTimeout(B.current);},W=({x:t,y:l})=>{Mt({place:E,offset:v,elementReference:{getBoundingClientRect(){return {x:t,y:l,width:0,height:0,top:l,left:t,right:t,bottom:l}}},tooltipReference:S.current,tooltipArrowReference:z.current,strategy:r,middlewares:a}).then(f=>{Object.keys(f.tooltipStyles).length&&dt(f.tooltipStyles),Object.keys(f.tooltipArrowStyles).length&&mt(f.tooltipArrowStyles),st(f.place);});},bt=t=>{if(!t)return;let l=t,i={x:l.clientX,y:l.clientY};W(i),ct.current=i;},Dt=t=>{ut(t),y&&G();},T=t=>{var f;[document.querySelector(`[id='${m}']`),...$].some(g=>g==null?void 0:g.contains(t.target))||(f=S.current)!=null&&f.contains(t.target)||O(!1);},k=t=>{t.key==="Escape"&&O(!1);},e=Pt(ut,50),u=Pt(ft,50);useEffect(()=>{var _,x;let t=new Set(_t);$.forEach(w=>{t.add({current:w});});let l=document.querySelector(`[id='${m}']`);l&&t.add({current:l}),R&&window.addEventListener("keydown",k);let i=[];P?(window.addEventListener("click",T),i.push({event:"click",listener:Dt})):(i.push({event:"mouseenter",listener:e},{event:"mouseleave",listener:u},{event:"focus",listener:e},{event:"blur",listener:u}),L&&i.push({event:"mousemove",listener:bt}));let f=()=>{at.current=!0;},g=()=>{at.current=!1,ft();};return M&&!P&&((_=S.current)==null||_.addEventListener("mouseenter",f),(x=S.current)==null||x.addEventListener("mouseleave",g)),i.forEach(({event:w,listener:At})=>{t.forEach(Ct=>{var St;(St=Ct.current)==null||St.addEventListener(w,At);});}),()=>{var w,At;P&&window.removeEventListener("click",T),R&&window.removeEventListener("keydown",k),M&&!P&&((w=S.current)==null||w.removeEventListener("mouseenter",f),(At=S.current)==null||At.removeEventListener("mouseleave",g)),i.forEach(({event:Ct,listener:St})=>{t.forEach(Ut=>{var Kt;(Kt=Ut.current)==null||Kt.removeEventListener(Ct,St);});});}},[ht,_t,$,R,b]),useEffect(()=>{let t=p!=null?p:"";!t&&o&&(t=`[data-tooltip-id='${o}']`);let l=f=>{let g=[];f.forEach(_=>{if(_.type==="attributes"&&_.attributeName==="data-tooltip-id"&&_.target.getAttribute("data-tooltip-id")===o&&g.push(_.target),_.type==="childList"&&(H&&[..._.removedNodes].some(x=>{var w;return (w=x==null?void 0:x.contains)!=null&&w.call(x,H)?(Y(!1),O(!1),lt(null),!0):!1}),!!t))try{let x=[..._.addedNodes].filter(w=>w.nodeType===1);g.push(...x.filter(w=>w.matches(t))),g.push(...x.flatMap(w=>[...w.querySelectorAll(t)]));}catch(x){}}),g.length&&pt(_=>[..._,...g]);},i=new MutationObserver(l);return i.observe(document.body,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["data-tooltip-id"]}),()=>{i.disconnect();}},[o,p,H]);let K=()=>{if(ot){W(ot);return}if(L){ct.current&&W(ct.current);return}Mt({place:E,offset:v,elementReference:H,tooltipReference:S.current,tooltipArrowReference:z.current,strategy:r,middlewares:a}).then(t=>{X.current&&(Object.keys(t.tooltipStyles).length&&dt(t.tooltipStyles),Object.keys(t.tooltipArrowStyles).length&&mt(t.tooltipArrowStyles),st(t.place));});};useEffect(()=>{K();},[D,H,J,et,E,v,r,ot]),useEffect(()=>{if(!(I!=null&&I.current))return ()=>null;let t=new ResizeObserver(()=>{K();});return t.observe(I.current),()=>{t.disconnect();}},[J,I==null?void 0:I.current]),useEffect(()=>{var i;let t=document.querySelector(`[id='${m}']`),l=[...$,t];(!H||!l.includes(H))&&lt((i=$[0])!=null?i:t);},[m,$,H]),useEffect(()=>()=>{B.current&&clearTimeout(B.current),q.current&&clearTimeout(q.current);},[]),useEffect(()=>{let t=p;if(!t&&o&&(t=`[data-tooltip-id='${o}']`),!!t)try{let l=Array.from(document.querySelectorAll(t));pt(l);}catch(l){pt([]);}},[o,p]);let Q=J&&D&&Object.keys(Tt).length>0;return ht?jsxs(s,{id:o,role:"tooltip",className:Ft("react-tooltip",F.tooltip,F[c],d,`react-tooltip__place-${Lt}`,{[F.show]:Q,[F.fixed]:r==="fixed",[F.clickable]:M}),style:{...et,...Tt},ref:S,children:[J,jsx(s,{className:Ft("react-tooltip-arrow",F.arrow,h,{[F.noArrow]:tt}),style:kt,ref:z})]}):null},Ht=Te;var ye=({content:o})=>jsx("span",{dangerouslySetInnerHTML:{__html:o}}),Bt=ye;var _e=({id:o,anchorId:d,anchorSelect:h,content:c,html:m,render:p,className:E,classNameArrow:v,variant:b="dark",place:A="top",offset:r=10,wrapper:a="div",children:s=null,events:n=["hover"],openOnClick:y=!1,positionStrategy:L="absolute",middlewares:tt,delayShow:M=0,delayHide:R=0,float:et=!1,noArrow:ot=!1,clickable:rt=!1,closeOnEsc:nt=!1,style:J,position:I,isOpen:U,setIsOpen:it,afterShow:H,afterHide:lt})=>{let[S,z]=useState(c),[B,q]=useState(m),[Lt,st]=useState(A),[Tt,dt]=useState(b),[kt,mt]=useState(r),[D,yt]=useState(M),[ht,Y]=useState(R),[Et,ct]=useState(et),[_t,xt]=useState(a),[at,$]=useState(n),[pt,X]=useState(L),[P,O]=useState(null),{anchorRefs:wt,activeAnchor:G}=j(o),ut=T=>T==null?void 0:T.getAttributeNames().reduce((e,u)=>{var K;if(u.startsWith("data-tooltip-")){let Q=u.replace(/^data-tooltip-/,"");e[Q]=(K=T==null?void 0:T.getAttribute(u))!=null?K:null;}return e},{}),ft=T=>{let k={place:e=>{st(e!=null?e:A);},content:e=>{z(e!=null?e:c);},html:e=>{q(e!=null?e:m);},variant:e=>{dt(e!=null?e:b);},offset:e=>{mt(e===null?r:Number(e));},wrapper:e=>{xt(e!=null?e:a);},events:e=>{let u=e==null?void 0:e.split(" ");$(u!=null?u:n);},"position-strategy":e=>{X(e!=null?e:L);},"delay-show":e=>{yt(e===null?M:Number(e));},"delay-hide":e=>{Y(e===null?R:Number(e));},float:e=>{ct(e===null?et:e==="true");}};Object.values(k).forEach(e=>e(null)),Object.entries(T).forEach(([e,u])=>{var K;(K=k[e])==null||K.call(k,u);});};useEffect(()=>{z(c);},[c]),useEffect(()=>{q(m);},[m]),useEffect(()=>{st(A);},[A]),useEffect(()=>{var l;let T=new Set(wt),k=h;if(!k&&o&&(k=`[data-tooltip-id='${o}']`),k)try{document.querySelectorAll(k).forEach(f=>{T.add({current:f});});}catch(i){}let e=document.querySelector(`[id='${d}']`);if(e&&T.add({current:e}),!T.size)return ()=>null;let u=(l=P!=null?P:e)!=null?l:G.current,K=i=>{i.forEach(f=>{var _;if(!u||f.type!=="attributes"||!((_=f.attributeName)!=null&&_.startsWith("data-tooltip-")))return;let g=ut(u);ft(g);});},Q=new MutationObserver(K),t={attributes:!0,childList:!1,subtree:!1};if(u){let i=ut(u);ft(i),Q.observe(u,t);}return ()=>{Q.disconnect();}},[wt,G,P,d,h]);let W=s,bt=useRef(null);return p?W=jsx("div",{ref:bt,className:"react-tooltip-content-wrapper",children:p({content:S!=null?S:null,activeAnchor:P})}):S&&(W=S),B&&(W=jsx(Bt,{content:B})),jsx(Ht,{...{id:o,anchorId:d,anchorSelect:h,className:E,classNameArrow:v,content:W,contentWrapperRef:bt,place:Lt,variant:Tt,offset:kt,wrapper:_t,events:at,openOnClick:y,positionStrategy:pt,middlewares:tt,delayShow:D,delayHide:ht,float:Et,noArrow:ot,clickable:rt,closeOnEsc:nt,style:J,position:I,isOpen:U,setIsOpen:it,afterShow:H,afterHide:lt,activeAnchor:P,setActiveAnchor:T=>O(T)}})},Vt=_e;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "/* src/tokens.css */\n:root {\n  --rt-color-white: #fff;\n  --rt-color-dark: #222;\n  --rt-color-success: #8dc572;\n  --rt-color-error: #be6464;\n  --rt-color-warning: #f0ad4e;\n  --rt-color-info: #337ab7;\n  --rt-opacity: 0.9;\n}\n\n/* esbuild-css-modules-plugin-namespace:./src/components/Tooltip/styles.module.css?esbuild-css-modules-plugin-built */\n.react-tooltip__tooltip_KtSkBq {\n  visibility: hidden;\n  width: max-content;\n  pointer-events: none;\n  opacity: 0;\n  will-change: opacity, visibility;\n  border-radius: 3px;\n  padding: 8px 16px;\n  font-size: 90%;\n  transition: opacity .3s ease-out;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.react-tooltip__fixed_KtSkBq {\n  position: fixed;\n}\n.react-tooltip__arrow_KtSkBq {\n  background: inherit;\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  transform: rotate(45deg);\n}\n.react-tooltip__no-arrow_KtSkBq {\n  display: none;\n}\n.react-tooltip__clickable_KtSkBq {\n  pointer-events: auto;\n}\n.react-tooltip__show_KtSkBq {\n  visibility: visible;\n  opacity: var(--rt-opacity);\n}\n.react-tooltip__dark_KtSkBq {\n  background: var(--rt-color-dark);\n  color: var(--rt-color-white);\n}\n.react-tooltip__light_KtSkBq {\n  background-color: var(--rt-color-white);\n  color: var(--rt-color-dark);\n}\n.react-tooltip__success_KtSkBq {\n  background-color: var(--rt-color-success);\n  color: var(--rt-color-white);\n}\n.react-tooltip__warning_KtSkBq {\n  background-color: var(--rt-color-warning);\n  color: var(--rt-color-white);\n}\n.react-tooltip__error_KtSkBq {\n  background-color: var(--rt-color-error);\n  color: var(--rt-color-white);\n}\n.react-tooltip__info_KtSkBq {\n  background-color: var(--rt-color-info);\n  color: var(--rt-color-white);\n}\n";
styleInject(css_248z);

const useOnClickOutside = (ref, handler) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                handler(event);
            }
        };
        document?.addEventListener('click', handleClickOutside, true);
        document?.addEventListener('mousedown', handleClickOutside, true);
        document?.addEventListener('touchstart', handleClickOutside, true);
        return () => {
            document?.removeEventListener('click', handleClickOutside, true);
            document?.removeEventListener('mousedown', handleClickOutside, true);
            document?.removeEventListener('touchstart', handleClickOutside, true);
        };
    }, [ref, handler]);
};

const ZIndex = {
    /*
      LEVEL 0
      Turntable: Nothing, this is below the data table
    */
    level0: 0,
    /*
      LEVEL 100
      Spaces: ContentContainer (everything to the right of the sidebar), full screen page not found page, sidebar
    */
    level100: 100,
    /*
      LEVEL 200
      Turntable: Cells and cell outlines
      Spaces: Sidebar collapse/expand button
    */
    level200: 200,
    /*
      LEVEL 300
      Turntable: Cell tooltips
    */
    level300: 300,
    /*
      LEVEL 400
      Turntable: Cell inner
    */
    level400: 400,
    /*
      LEVEL 500
      Turntable: Cell editors
    */
    level500: 500,
    /*
      LEVEL 600
      Turntable: Pinned columns
    */
    level600: 600,
    /*
      LEVEL 700
      Turntable: Column Headers
    */
    level700: 700,
    /*
      LEVEL 800
      Turntable: Index corner cell
      Spaces: 'Add data' overlay for empty table
    */
    level800: 800,
    /*
      LEVEL 900
      Turntable: Toolbar
     */
    level900: 900,
    /*
      LEVEL 1000
      Turntable: nothing, this should be above the data table
      Spaces: Jobs panel, tooltips
      Design system: context menus, dropdowns, popovers,
     */
    level1000: 1000,
    /*
      LEVEL 1100
      Turntable: nothing, this should be above the data table
      Spaces: File upload overlay
     */
    level1100: 1100,
    /*
      LEVEL 1200
      Turntable: nothing, this should be above the data table
      Spaces: File => workbook flow (workbook selection, mapping etc), modals
     */
    level1200: 1200,
};

const AMP_TOOLTIP_ID = 'amp-tooltip-4242911';
// Props need to be declared explicitly outside of ITooltip
// or Storybook won't pick them up. For some reason it's also
// necessary to refresh the Storybook page to see changes to float
// For more props info see https://react-tooltip.com/docs/options
const tooltipStyles = css `
  ${getFont('b1')}

  overflow-wrap: break-word;
  white-space: pre-wrap;
  background-color: ${Colors$1.MidnightBrand};
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  z-index: ${ZIndex.level1200};
`;
styled(Vt) `
  ${tooltipStyles}
  max-width: ${({ $maxWidth }) => $maxWidth}px;
`;
const StyledActionsTooltip$1 = styled(Vt) `
  background-color: ${Colors$1.MidnightBrand};
  padding: 0;
`;
const TooltipContent = styled.div `
  ${tooltipStyles}
  max-width: ${({ $maxWidth }) => $maxWidth}px;
`;
const ActionsContainer = styled.div `
  display: flex;
  gap: 12px;

  .action-text {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;
const ActionsTooltip = ({ actions, children, text, $maxWidth = 296, ...otherProps }) => {
    const tooltipRef = useRef(null);
    const timeoutRef = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const closeTooltip = () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
        setIsOpen(false);
    };
    const openTooltip = () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
        setIsOpen(true);
        timeoutRef.current = setTimeout(closeTooltip, 3000);
    };
    const sharedId = `tooltip-${Math.random()}`;
    useOnClickOutside(tooltipRef, closeTooltip);
    return (jsxs("div", { "data-tooltip-id": sharedId, onMouseEnter: openTooltip, onClick: closeTooltip, ref: tooltipRef, children: [children, jsx(StyledActionsTooltip$1, { clickable: true, id: sharedId, isOpen: isOpen, ...otherProps, children: jsxs(TooltipContent, { "data-testid": 'actions-tooltip-content', "$maxWidth": $maxWidth, children: [text, jsx(ActionsContainer, { children: actions.map((action, i) => (jsx(Typography, { type: 'actionMd', color: Colors$1.Electric300, onClick: () => {
                                    action.onClick();
                                    closeTooltip();
                                }, className: 'action-text', children: action.text }, i))) })] }) })] }));
};

const getFocusOutline = (color) => {
    return css `
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 0px 0px 2px ${Colors$1.White},
      0px 0px 0px 4px ${color};
  `;
};

const getButtonStyles = ({ variant, isFocusVisible, isHovered, isPressed, }) => {
    switch (variant) {
        case 'primary':
            return css `
        background-color: ${Colors$1.Electric700};
        border: none;
        color: ${Colors$1.White};

        ${isHovered &&
                css `
            background-color: ${Colors$1.ElectricBrand};
          `}

        ${isPressed &&
                css `
            background-color: ${Colors$1.Electric900};
          `}

        ${isFocusVisible && getFocusOutline(Colors$1.Electric600)}}

        .button-text {
          color: ${Colors$1.White};
        }
      `;
        case 'secondary':
            return css `
        background-color: ${Colors$1.Electric100};
        border: none;
        color: ${Colors$1.ElectricBrand};

        ${isHovered &&
                css `
            background-color: ${Colors$1.Electric300};
          `}

        ${isPressed &&
                css `
            background-color: ${Colors$1.Electric400};
          `}

        ${isFocusVisible && getFocusOutline(Colors$1.Electric600)}}

        .button-text {
          color: ${Colors$1.ElectricBrand};
        }
      `;
        case 'tertiary':
            return css `
        background-color: transparent;
        border: none;
        color: ${Colors$1.Pigeon800};

        ${isHovered &&
                css `
            background-color: ${Colors$1.Pigeon100};
          `}

        ${isPressed &&
                css `
            background-color: ${Colors$1.Pigeon200};
          `}

        ${isFocusVisible && getFocusOutline(Colors$1.MidnightBrand)}}

        .button-text {
          color: ${Colors$1.Pigeon800};
        }
      `;
        case 'tertiary-border':
            return css `
          background-color: ${Colors$1.White};
          border: 1px solid ${Colors$1.Pigeon400};
  
          ${isHovered &&
                css `
              background-color: ${Colors$1.Pigeon100};
            `}
  
          ${isPressed &&
                css `
              background-color: ${Colors$1.Pigeon200};
            `}
  
          ${isFocusVisible && getFocusOutline(Colors$1.Electric600)}}
        `;
        case 'tertiary-border-green':
            return css `
            border-radius: 0;
            background-color: ${Colors$1.White};
            border: 1px solid ${Colors$1.Jade800};
            color: ${Colors$1.Jade800};
            & svg {
              fill: ${Colors$1.Jade800};
            }
            ${isHovered &&
                css `
                background-color: ${Colors$1.Jade100};
                border-color: ${Colors$1.Jade800};
              `}
    
            ${isPressed &&
                css `
                background-color: ${Colors$1.Jade200};
              `}
    
            ${isFocusVisible && getFocusOutline(Colors$1.Electric600)}}
          `;
        case 'ghost':
            return css `
        background-color: transparent;
        border: none;
        color: ${Colors$1.Electric700};

        ${isHovered &&
                css `
            background-color: ${Colors$1.Pigeon100};
          `}

        ${isPressed &&
                css `
            background-color: ${Colors$1.Pigeon200};
          `}

        ${isFocusVisible && getFocusOutline(Colors$1.Electric600)}}

        .button-text {
          color: ${Colors$1.Electric700};
        }
      `;
        case 'warning':
            return css `
        background-color: ${Colors$1.Pinata900};
        border: none;
        color: ${Colors$1.White};

        ${isHovered &&
                css `
          background-color: ${Colors$1.Pinata700};
        `}

        ${isPressed &&
                css `
          background-color: ${Colors$1.Pinata800};
        `}

          ${isFocusVisible && getFocusOutline(Colors$1.Pinata900)}

          .button-text {
          color: ${Colors$1.White};
        }
      `;
        case 'warning-ghost':
            return css `
            background-color: transparent;
            border: none;
            color: ${Colors$1.Pinata700};

            ${isHovered &&
                css `
                background-color: ${Colors$1.Pigeon100};
              `}

            ${isPressed &&
                css `
                background-color: ${Colors$1.Pigeon200};
              `}

            ${isFocusVisible && getFocusOutline(Colors$1.Pinata600)}}

            .button-text {
              color: ${Colors$1.Pinata700};
            }
          `;
        case 'confirm-ghost':
            return css `
                background-color: transparent;
                border: none;
                color: ${Colors$1.Jade800};

                ${isHovered &&
                css `
                    background-color: ${Colors$1.Pigeon100};
                  `}

                ${isPressed &&
                css `
                    background-color: ${Colors$1.Pigeon200};
                  `}

                ${isFocusVisible && getFocusOutline(Colors$1.Jade800)}}

                .button-text {
                  color: ${Colors$1.Jade800};
                }
              `;
        case 'code-snippet':
            return css `
        background-color: transparent;
        border: none;
        color: ${Colors$1.White};

        ${isHovered &&
                css `
            background-color: ${Colors$1.Midnight600};
          `}

        ${isPressed &&
                css `
            background-color: ${Colors$1.Midnight700};
          `}

        ${isFocusVisible && getFocusOutline(Colors$1.White)}}

        .button-text {
          color: ${Colors$1.White};
        }
      `;
    }
};
const getButtonSizing = (size) => {
    switch (size) {
        case 'xs':
            return css `
        height: 20px;
        min-width: 64px;
        padding: 2px 8px;
      `;
        case 'sm':
            return css `
        height: 32px;
        min-width: 80px;
        padding: 8px 12px;
      `;
        case 'md':
            return css `
        height: 40px;
        min-width: 96px;
        padding: 8px 12px;
      `;
        case 'lg':
            return css `
        height: 48px;
        min-width: 104px;
        padding: 8px 12px;
      `;
    }
};

const iconSizeLookup = {
    xs: 16,
    sm: 16,
    md: 24,
    lg: 32,
};
const typographyLookup = {
    xs: 'actionXs',
    sm: 'actionSm',
    md: 'actionMd',
    lg: 'actionLg',
};
const baseButtonStyles = css `
  align-items: center;
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  justify-content: center;
  max-width: 240px;
`;
const StyledButton$1 = styled.button `
  ${({ variant, isFocusVisible, isHovered, isPressed }) => getButtonStyles({ variant, isFocusVisible, isHovered, isPressed })}
  ${({ size }) => getButtonSizing(size)}

  ${baseButtonStyles}

  border-radius: 2px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.2s ease;

  ${({ fullWidth }) => fullWidth &&
    `
    max-width: none;
    width: 100%;
  `}

  ${({ isDisabled }) => isDisabled &&
    css `
      opacity: 50%;
      pointer-events: none;
    `}
`;
const Button = ({ variant = 'primary', isDisabled = false, iconLeft, iconRight, iconSize, label, fullWidth, loading = false, size = 'md', ...otherProps }) => {
    const ref = useRef(null);
    const isDisabledOrLoading = isDisabled || loading;
    const { buttonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3({ ...otherProps, isDisabled: isDisabledOrLoading }, ref);
    const { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
        ...otherProps,
        isDisabled,
        ref,
    });
    const { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({
        isDisabled: isDisabledOrLoading,
    });
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    const combinedProps = {
        ...buttonProps,
        ...focusProps,
        ...hoverProps,
        ...pressProps,
    };
    const buttonSize = size;
    const buttonIconSize = (iconSize ?? iconSizeLookup[buttonSize]);
    const tooltipContent = isDisabled
        ? otherProps?.tooltip?.disabled
        : otherProps?.tooltip?.active;
    const ButtonComponent = (jsxs(StyledButton$1, { className: classnames$1('styled-button', ...[variant]), variant: variant, isDisabled: isDisabledOrLoading, isFocusVisible: isFocusVisible, isHovered: isHovered, isPressed: isPressed, size: size, fullWidth: fullWidth, ...combinedProps, children: [!!iconLeft && (jsx(Icon, { name: iconLeft, size: buttonIconSize, "data-testid": 'icon-left' })), jsx(Typography, { className: 'button-text', truncate: true, type: typographyLookup[buttonSize], children: label }), !!iconRight && !loading && (jsx(Icon, { name: iconRight, size: buttonIconSize, "data-testid": 'icon-right' })), loading && (jsx(Spinner, { color: Colors$1.ElectricBrand, size: buttonIconSize }))] }));
    if (!tooltipContent) {
        return ButtonComponent;
    }
    return (jsx("div", { "data-tooltip-id": AMP_TOOLTIP_ID, "data-tooltip-content": tooltipContent, children: ButtonComponent }));
};

const ButtonRow$1 = styled.div `
  display: flex;
  gap: 4px;
  align-items: center;
  margin-bottom: 1em;

  ${({ centered }) => centered &&
    css `
      justify-content: center;
    `}
`;

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $e40ea825a81a3709$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $e40ea825a81a3709$export$52baac22726c72bf) {
            this.anchorKey = anchorKey || keys.anchorKey;
            this.currentKey = currentKey || keys.currentKey;
        } else {
            this.anchorKey = anchorKey;
            this.currentKey = currentKey;
        }
    }
}



function $7af3f5b51489e0b5$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $7af3f5b51489e0b5$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = "none" , disallowEmptySelection: disallowEmptySelection , allowDuplicateSelectionEvents: allowDuplicateSelectionEvents , selectionBehavior: selectionBehaviorProp = "toggle" , disabledBehavior: disabledBehavior = "all"  } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (useRef)(false);
    let [, setFocused] = (useState)(false);
    let focusedKeyRef = (useRef)(null);
    let childFocusStrategyRef = (useRef)(null);
    let [, setFocusedKey] = (useState)(null);
    let selectedKeysProp = (useMemo)(()=>$7af3f5b51489e0b5$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (useMemo)(()=>$7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new ($e40ea825a81a3709$export$52baac22726c72bf)()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === "replace" && selectionBehavior === "toggle" && typeof selectedKeys === "object" && selectedKeys.size === 0) setSelectionBehavior("replace");
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (useRef)(selectionBehaviorProp);
    (useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = "first") {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === "all" ? "all" : new ($e40ea825a81a3709$export$52baac22726c72bf)(selection);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
class $d496c0a20b6e58ec$export$6c8a5aaad13c9852 {
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === "none") return false;
        key = this.getKey(key);
        return this.state.selectedKeys === "all" ? this.canSelectItem(key) : this.state.selectedKeys.has(key);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === "all") return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || (item === null || item === void 0 ? void 0 : item.index) < first.index) first = item;
        }
        return first === null || first === void 0 ? void 0 : first.key;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || (item === null || item === void 0 ? void 0 : item.index) > last.index) last = item;
        }
        return last === null || last === void 0 ? void 0 : last.key;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            this.replaceSelection(toKey);
            return;
        }
        toKey = this.getKey(toKey);
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === "all") selection = new ($e40ea825a81a3709$export$52baac22726c72bf)([
            toKey
        ], toKey, toKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            let anchorKey = selectedKeys.anchorKey || toKey;
            selection = new ($e40ea825a81a3709$export$52baac22726c72bf)(selectedKeys, anchorKey, toKey);
            for (let key of this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey))selection.delete(key);
            for (let key1 of this.getKeyRange(toKey, anchorKey))if (this.canSelectItem(key1)) selection.add(key1);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if (fromItem.index <= toItem.index) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        let keys = [];
        let key = from;
        while(key){
            let item = this.collection.getItem(key);
            if (item && item.type === "item" || item.type === "cell" && this.allowsCellSelection) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) // ¯\_(ツ)_/¯
        return key;
        // If cell selection is allowed, just return the key.
        if (item.type === "cell" && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item.type !== "item" && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== "item") return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single" && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        key = this.getKey(key);
        if (key == null) return;
        let keys = new ($e40ea825a81a3709$export$52baac22726c72bf)(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(key)) keys.delete(key);
        else if (this.canSelectItem(key)) {
            keys.add(key);
            keys.anchorKey = key;
            keys.currentKey = key;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === "none") return;
        key = this.getKey(key);
        if (key == null) return;
        let selection = this.canSelectItem(key) ? new ($e40ea825a81a3709$export$52baac22726c72bf)([
            key
        ], key, key) : new ($e40ea825a81a3709$export$52baac22726c72bf)();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === "none") return;
        let selection = new ($e40ea825a81a3709$export$52baac22726c72bf)();
        for (let key of keys){
            key = this.getKey(key);
            if (key != null) {
                selection.add(key);
                if (this.selectionMode === "single") break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        let keys = [];
        let addKeys = (key)=>{
            while(key){
                if (this.canSelectItem(key)) {
                    let item = this.collection.getItem(key);
                    if (item.type === "item") keys.push(key);
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if (item.hasChildNodes && (this.allowsCellSelection || item.type !== "item")) addKeys([
                        ...item.childNodes
                    ][0].key);
                }
                key = this.collection.getKeyAfter(key);
            }
        };
        addKeys(this.collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (this.selectionMode === "multiple") this.state.setSelectedKeys("all");
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new ($e40ea825a81a3709$export$52baac22726c72bf)());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === "toggle" || e && (e.pointerType === "touch" || e.pointerType === "virtual")) // if touch or virtual (VO) then we just want to toggle, otherwise it's impossible to multi select because they don't have modifier keys
        this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key1 of selectedKeys){
            if (!selection.has(key1)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        if (this.state.selectionMode === "none" || this.state.disabledKeys.has(key)) return false;
        let item = this.collection.getItem(key);
        if (!item || item.type === "cell" && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        return this.state.disabledKeys.has(key) && this.state.disabledBehavior === "all";
    }
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        var _options_allowsCellSelection;
        this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
        this._isSelectAll = null;
    }
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
let $a02d57049d202695$var$_Symbol_iterator = Symbol.iterator;
class $a02d57049d202695$export$d085fb9e920b5ca7 {
    *[$a02d57049d202695$var$_Symbol_iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes){
        (_defineProperty)(this, "keyMap", new Map());
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === "section") for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node1] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node1.prevKey = last.key;
            } else {
                this.firstKey = key;
                node1.prevKey = undefined;
            }
            if (node1.type === "item") node1.index = index++;
            last = node1;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}




function $e72dd72e1c76a225$export$2f645645f7bca764(props) {
    let { filter: filter  } = props;
    let selectionState = ($7af3f5b51489e0b5$export$253fe78d46329472)(props);
    let disabledKeys = (useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (nodes)=>filter ? new ($a02d57049d202695$export$d085fb9e920b5ca7)(filter(nodes)) : new ($a02d57049d202695$export$d085fb9e920b5ca7)(nodes);
    let context = (useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = ($7613b1592d41b092$export$6cd28814d92fa9c9)(props, factory, context, [
        filter
    ]);
    // Reset focused key if that item is deleted from the collection.
    (useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collection,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: new ($d496c0a20b6e58ec$export$6c8a5aaad13c9852)(collection, selectionState)
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $a0d645289fe9b86b$export$e7f05e985daf4b5f(props) {
    var _props_defaultSelectedKey;
    let [selectedKey, setSelectedKey] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = (useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection: collection , disabledKeys: disabledKeys , selectionManager: selectionManager  } = ($e72dd72e1c76a225$export$2f645645f7bca764)({
        ...props,
        selectionMode: "single",
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            let key = keys.values().next().value;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $fc909762b330b746$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open () {
            setOpen(true);
        },
        close () {
            setOpen(false);
        },
        toggle () {
            setOpen(!isOpen);
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = ($fc909762b330b746$export$61c6a8c84e605fb6)(props);
    let [focusStrategy, setFocusStrategy] = (useState)(null);
    return {
        focusStrategy: focusStrategy,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



function $a9e7382a7d111cb5$export$b453a3bfd4a5fa9e(props) {
    var _collection_getItem;
    let { defaultFilter: defaultFilter , menuTrigger: menuTrigger = "input" , allowsEmptyCollection: allowsEmptyCollection = false , allowsCustomValue: allowsCustomValue , shouldCloseOnBlur: shouldCloseOnBlur = true  } = props;
    let [showAllItems, setShowAllItems] = (useState)(false);
    let [isFocused, setFocusedState] = (useState)(false);
    var _props_defaultInputValue;
    let [inputValue, setInputValue] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(props.inputValue, (_props_defaultInputValue = props.defaultInputValue) !== null && _props_defaultInputValue !== void 0 ? _props_defaultInputValue : "", props.onInputChange);
    let onSelectionChange = (key)=>{
        if (props.onSelectionChange) props.onSelectionChange(key);
        // If key is the same, reset the inputValue and close the menu
        // (scenario: user clicks on already selected option)
        if (key === selectedKey) {
            resetInputValue();
            triggerState.close();
        }
    };
    var _props_items;
    let { collection: collection , selectionManager: selectionManager , selectedKey: selectedKey , setSelectedKey: setSelectedKey , selectedItem: selectedItem , disabledKeys: disabledKeys  } = ($a0d645289fe9b86b$export$e7f05e985daf4b5f)({
        ...props,
        onSelectionChange: onSelectionChange,
        items: (_props_items = props.items) !== null && _props_items !== void 0 ? _props_items : props.defaultItems
    });
    // Preserve original collection so we can show all items on demand
    let originalCollection = collection;
    let filteredCollection = (useMemo)(()=>// No default filter if items are controlled.
        props.items != null || !defaultFilter ? collection : $a9e7382a7d111cb5$var$filterCollection(collection, inputValue, defaultFilter), [
        collection,
        inputValue,
        defaultFilter,
        props.items
    ]);
    // Track what action is attempting to open the menu
    let menuOpenTrigger = (useRef)("focus");
    let onOpenChange = (open)=>{
        if (props.onOpenChange) props.onOpenChange(open, open ? menuOpenTrigger.current : undefined);
    };
    let triggerState = ($a28c903ee9ad8dc5$export$79fefeb1c2091ac3)({
        ...props,
        onOpenChange: onOpenChange,
        isOpen: undefined,
        defaultOpen: undefined
    });
    let open = (focusStrategy, trigger)=>{
        let displayAllItems = trigger === "manual" || trigger === "focus" && menuTrigger === "focus";
        // Prevent open operations from triggering if there is nothing to display
        // Also prevent open operations from triggering if items are uncontrolled but defaultItems is empty, even if displayAllItems is true.
        // This is to prevent comboboxes with empty defaultItems from opening but allow controlled items comboboxes to open even if the inital list is empty (assumption is user will provide swap the empty list with a base list via onOpenChange returning `menuTrigger` manual)
        if (allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) {
            if (displayAllItems && !triggerState.isOpen && props.items === undefined) // Show all items if menu is manually opened. Only care about this if items are undefined
            setShowAllItems(true);
            menuOpenTrigger.current = trigger;
            triggerState.open(focusStrategy);
        }
    };
    let toggle = (focusStrategy, trigger)=>{
        let displayAllItems = trigger === "manual" || trigger === "focus" && menuTrigger === "focus";
        // If the menu is closed and there is nothing to display, early return so toggle isn't called to prevent extraneous onOpenChange
        if (!(allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) && !triggerState.isOpen) return;
        if (displayAllItems && !triggerState.isOpen && props.items === undefined) // Show all items if menu is toggled open. Only care about this if items are undefined
        setShowAllItems(true);
        // Only update the menuOpenTrigger if menu is currently closed
        if (!triggerState.isOpen) menuOpenTrigger.current = trigger;
        triggerState.toggle(focusStrategy);
    };
    let lastValue = (useRef)(inputValue);
    let resetInputValue = ()=>{
        var _collection_getItem;
        var _collection_getItem_textValue;
        let itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
        lastValue.current = itemText;
        setInputValue(itemText);
    };
    let isInitialRender = (useRef)(true);
    var _props_selectedKey, _ref;
    let lastSelectedKey = (useRef)((_ref = (_props_selectedKey = props.selectedKey) !== null && _props_selectedKey !== void 0 ? _props_selectedKey : props.defaultSelectedKey) !== null && _ref !== void 0 ? _ref : null);
    var _collection_getItem_textValue;
    let lastSelectedKeyText = (useRef)((_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "");
    // intentional omit dependency array, want this to happen on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (useEffect)(()=>{
        var _collection_getItem;
        // Open and close menu automatically when the input value changes if the input is focused,
        // and there are items in the collection or allowEmptyCollection is true.
        if (isFocused && (filteredCollection.size > 0 || allowsEmptyCollection) && !triggerState.isOpen && inputValue !== lastValue.current && menuTrigger !== "manual") open(null, "input");
        // Close the menu if the collection is empty. Don't close menu if filtered collection size is 0
        // but we are currently showing all items via button press
        if (!showAllItems && !allowsEmptyCollection && triggerState.isOpen && filteredCollection.size === 0) triggerState.close();
        // Close when an item is selected.
        if (selectedKey != null && selectedKey !== lastSelectedKey.current) triggerState.close();
        // Clear focused key when input value changes and display filtered collection again.
        if (inputValue !== lastValue.current) {
            selectionManager.setFocusedKey(null);
            setShowAllItems(false);
            // Set selectedKey to null when the user clears the input.
            // If controlled, this is the application developer's responsibility.
            if (inputValue === "" && (props.inputValue === undefined || props.selectedKey === undefined)) setSelectedKey(null);
        }
        // If it is the intial render and inputValue isn't controlled nor has an intial value, set input to match current selected key if any
        if (isInitialRender.current && props.inputValue === undefined && props.defaultInputValue === undefined) resetInputValue();
        // If the selectedKey changed, update the input value.
        // Do nothing if both inputValue and selectedKey are controlled.
        // In this case, it's the user's responsibility to update inputValue in onSelectionChange.
        if (selectedKey !== lastSelectedKey.current && (props.inputValue === undefined || props.selectedKey === undefined)) resetInputValue();
        else lastValue.current = inputValue;
        var _collection_getItem_textValue;
        // Update the inputValue if the selected item's text changes from its last tracked value.
        // This is to handle cases where a selectedKey is specified but the items aren't available (async loading) or the selected item's text value updates.
        // Only reset if the user isn't currently within the field so we don't erroneously modify user input.
        // If inputValue is controlled, it is the user's responsibility to update the inputValue when items change.
        let selectedItemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
        if (!isFocused && selectedKey != null && props.inputValue === undefined && selectedKey === lastSelectedKey.current) {
            if (lastSelectedKeyText.current !== selectedItemText) {
                lastValue.current = selectedItemText;
                setInputValue(selectedItemText);
            }
        }
        isInitialRender.current = false;
        lastSelectedKey.current = selectedKey;
        lastSelectedKeyText.current = selectedItemText;
    });
    (useEffect)(()=>{
        // Reset focused key when the menu closes
        if (!triggerState.isOpen) selectionManager.setFocusedKey(null);
    }, [
        triggerState.isOpen,
        selectionManager
    ]);
    // Revert input value and close menu
    let revert = ()=>{
        if (allowsCustomValue && selectedKey == null) commitCustomValue();
        else commitSelection();
    };
    let commitCustomValue = ()=>{
        lastSelectedKey.current = null;
        setSelectedKey(null);
        triggerState.close();
    };
    let commitSelection = ()=>{
        // If multiple things are controlled, call onSelectionChange
        if (props.selectedKey !== undefined && props.inputValue !== undefined) {
            var _collection_getItem;
            props.onSelectionChange(selectedKey);
            var _collection_getItem_textValue;
            // Stop menu from reopening from useEffect
            let itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
            lastValue.current = itemText;
            triggerState.close();
        } else {
            // If only a single aspect of combobox is controlled, reset input value and close menu for the user
            resetInputValue();
            triggerState.close();
        }
    };
    let commit = ()=>{
        if (triggerState.isOpen && selectionManager.focusedKey != null) {
            // Reset inputValue and close menu here if the selected key is already the focused key. Otherwise
            // fire onSelectionChange to allow the application to control the closing.
            if (selectedKey === selectionManager.focusedKey) commitSelection();
            else setSelectedKey(selectionManager.focusedKey);
        } else if (allowsCustomValue) commitCustomValue();
        else // Reset inputValue and close menu if no item is focused but user triggers a commit
        commitSelection();
    };
    let setFocused = (isFocused)=>{
        if (isFocused) {
            if (menuTrigger === "focus") open(null, "focus");
        } else if (shouldCloseOnBlur) {
            var _collection_getItem;
            var _collection_getItem_textValue;
            let itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
            if (allowsCustomValue && inputValue !== itemText) commitCustomValue();
            else commitSelection();
        }
        setFocusedState(isFocused);
    };
    return {
        ...triggerState,
        toggle: toggle,
        open: open,
        close: commit,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        disabledKeys: disabledKeys,
        isFocused: isFocused,
        setFocused: setFocused,
        selectedItem: selectedItem,
        collection: showAllItems ? originalCollection : filteredCollection,
        inputValue: inputValue,
        setInputValue: setInputValue,
        commit: commit,
        revert: revert
    };
}
function $a9e7382a7d111cb5$var$filterCollection(collection, inputValue, filter) {
    return new ($a02d57049d202695$export$d085fb9e920b5ca7)($a9e7382a7d111cb5$var$filterNodes(collection, inputValue, filter));
}
function $a9e7382a7d111cb5$var$filterNodes(nodes, inputValue, filter) {
    let filteredNode = [];
    for (let node of nodes){
        if (node.type === "section" && node.hasChildNodes) {
            let filtered = $a9e7382a7d111cb5$var$filterNodes(node.childNodes, inputValue, filter);
            if ([
                ...filtered
            ].length > 0) filteredNode.push({
                ...node,
                childNodes: filtered
            });
        } else if (node.type !== "section" && filter(node.textValue, inputValue)) filteredNode.push({
            ...node
        });
    }
    return filteredNode;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
// These placeholders are based on the strings used by the <input type="date">
// implementations in Chrome and Firefox. Additional languages are supported
// here than React Spectrum's typical translations.
new ($5b160d28a433310d$export$c17fa47878dc55b6)({
    ach: {
        year: "mwaka",
        month: "dwe",
        day: "nino"
    },
    af: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    am: {
        year: "ዓዓዓዓ",
        month: "ሚሜ",
        day: "ቀቀ"
    },
    an: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    ar: {
        year: "سنة",
        month: "شهر",
        day: "يوم"
    },
    ast: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    az: {
        year: "iiii",
        month: "aa",
        day: "gg"
    },
    be: {
        year: "гггг",
        month: "мм",
        day: "дд"
    },
    bg: {
        year: "гггг",
        month: "мм",
        day: "дд"
    },
    bn: {
        year: "yyyy",
        month: "মিমি",
        day: "dd"
    },
    br: {
        year: "bbbb",
        month: "mm",
        day: "dd"
    },
    bs: {
        year: "gggg",
        month: "mm",
        day: "dd"
    },
    ca: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    cak: {
        year: "jjjj",
        month: "ii",
        day: "q'q'"
    },
    ckb: {
        year: "ساڵ",
        month: "مانگ",
        day: "ڕۆژ"
    },
    cs: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    cy: {
        year: "bbbb",
        month: "mm",
        day: "dd"
    },
    da: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    de: {
        year: "jjjj",
        month: "mm",
        day: "tt"
    },
    dsb: {
        year: "llll",
        month: "mm",
        day: "źź"
    },
    el: {
        year: "εεεε",
        month: "μμ",
        day: "ηη"
    },
    en: {
        year: "yyyy",
        month: "mm",
        day: "dd"
    },
    eo: {
        year: "jjjj",
        month: "mm",
        day: "tt"
    },
    es: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    et: {
        year: "aaaa",
        month: "kk",
        day: "pp"
    },
    eu: {
        year: "uuuu",
        month: "hh",
        day: "ee"
    },
    fa: {
        year: "سال",
        month: "ماه",
        day: "روز"
    },
    ff: {
        year: "hhhh",
        month: "ll",
        day: "\xf1\xf1"
    },
    fi: {
        year: "vvvv",
        month: "kk",
        day: "pp"
    },
    fr: {
        year: "aaaa",
        month: "mm",
        day: "jj"
    },
    fy: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    ga: {
        year: "bbbb",
        month: "mm",
        day: "ll"
    },
    gd: {
        year: "bbbb",
        month: "mm",
        day: "ll"
    },
    gl: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    he: {
        year: "שנה",
        month: "חודש",
        day: "יום"
    },
    hr: {
        year: "gggg",
        month: "mm",
        day: "dd"
    },
    hsb: {
        year: "llll",
        month: "mm",
        day: "dd"
    },
    hu: {
        year: "\xe9\xe9\xe9\xe9",
        month: "hh",
        day: "nn"
    },
    ia: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    id: {
        year: "tttt",
        month: "bb",
        day: "hh"
    },
    it: {
        year: "aaaa",
        month: "mm",
        day: "gg"
    },
    ja: {
        year: " 年 ",
        month: "月",
        day: "日"
    },
    ka: {
        year: "წწწწ",
        month: "თთ",
        day: "რრ"
    },
    kk: {
        year: "жжжж",
        month: "аа",
        day: "кк"
    },
    kn: {
        year: "ವವವವ",
        month: "ಮಿಮೀ",
        day: "ದಿದಿ"
    },
    ko: {
        year: "연도",
        month: "월",
        day: "일"
    },
    lb: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    lo: {
        year: "ປປປປ",
        month: "ດດ",
        day: "ວວ"
    },
    lt: {
        year: "mmmm",
        month: "mm",
        day: "dd"
    },
    lv: {
        year: "gggg",
        month: "mm",
        day: "dd"
    },
    meh: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    ml: {
        year: "വർഷം",
        month: "മാസം",
        day: "തീയതി"
    },
    ms: {
        year: "tttt",
        month: "mm",
        day: "hh"
    },
    nl: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    nn: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    no: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    oc: {
        year: "aaaa",
        month: "mm",
        day: "jj"
    },
    pl: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    pt: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    rm: {
        year: "oooo",
        month: "mm",
        day: "dd"
    },
    ro: {
        year: "aaaa",
        month: "ll",
        day: "zz"
    },
    ru: {
        year: "гггг",
        month: "мм",
        day: "дд"
    },
    sc: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    scn: {
        year: "aaaa",
        month: "mm",
        day: "jj"
    },
    sk: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    sl: {
        year: "llll",
        month: "mm",
        day: "dd"
    },
    sr: {
        year: "гггг",
        month: "мм",
        day: "дд"
    },
    sv: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    szl: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    tg: {
        year: "сссс",
        month: "мм",
        day: "рр"
    },
    th: {
        year: "ปปปป",
        month: "ดด",
        day: "วว"
    },
    tr: {
        year: "yyyy",
        month: "aa",
        day: "gg"
    },
    uk: {
        year: "рррр",
        month: "мм",
        day: "дд"
    },
    "zh-CN": {
        year: "年",
        month: "月",
        day: "日"
    },
    "zh-TW": {
        year: "年",
        month: "月",
        day: "日"
    }
}, "en");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $0b2218c4e3fe7d7e$export$3f8be18b0f41eaf2(props) {
    let [value, setValue] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)($0b2218c4e3fe7d7e$var$toString(props.value), $0b2218c4e3fe7d7e$var$toString(props.defaultValue) || "", props.onChange);
    return {
        value: value,
        setValue: setValue
    };
}
function $0b2218c4e3fe7d7e$var$toString(val) {
    if (val == null) return;
    return val.toString();
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $2bc3a590c5373a4e$export$5159ec8b34d4ec12(props) {
    let triggerState = ($a28c903ee9ad8dc5$export$79fefeb1c2091ac3)(props);
    let listState = ($a0d645289fe9b86b$export$e7f05e985daf4b5f)({
        ...props,
        onSelectionChange: (key)=>{
            if (props.onSelectionChange != null) props.onSelectionChange(key);
            triggerState.close();
        }
    });
    let [isFocused, setFocused] = (useState)(false);
    return {
        ...listState,
        ...triggerState,
        open () {
            // Don't open if the collection is empty.
            if (listState.collection.size !== 0) triggerState.open();
        },
        toggle (focusStrategy) {
            if (listState.collection.size !== 0) triggerState.toggle(focusStrategy);
        },
        isFocused: isFocused,
        setFocused: setFocused
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

"row-header-column-" + Math.random().toString(36).slice(2);

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
let $05ca4cd7c4a5a999$var$_Symbol_iterator = Symbol.iterator;
class $05ca4cd7c4a5a999$export$863faf230ee2118a {
    *[$05ca4cd7c4a5a999$var$_Symbol_iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes, { expandedKeys: expandedKeys  } = {}){
        (_defineProperty)(this, "keyMap", new Map());
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && (node.type === "section" || expandedKeys.has(node.key))) for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node1] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node1.prevKey = last.key;
            } else {
                this.firstKey = key;
                node1.prevKey = undefined;
            }
            if (node1.type === "item") node1.index = index++;
            last = node1;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}




function $875d6693e12af071$export$728d6ba534403756(props) {
    let [expandedKeys, setExpandedKeys] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), props.onExpandedChange);
    let selectionState = ($7af3f5b51489e0b5$export$253fe78d46329472)(props);
    let disabledKeys = (useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let tree = ($7613b1592d41b092$export$6cd28814d92fa9c9)(props, (nodes)=>new ($05ca4cd7c4a5a999$export$863faf230ee2118a)(nodes, {
            expandedKeys: expandedKeys
        }), null, [
        expandedKeys
    ]);
    // Reset focused key if that item is deleted from the collection.
    (useEffect)(()=>{
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tree,
        selectionState.focusedKey
    ]);
    let onToggle = (key)=>{
        setExpandedKeys($875d6693e12af071$var$toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys: expandedKeys,
        disabledKeys: disabledKeys,
        toggleKey: onToggle,
        selectionManager: new ($d496c0a20b6e58ec$export$6c8a5aaad13c9852)(tree, selectionState)
    };
}
function $875d6693e12af071$var$toggleKey(set, key) {
    let res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}

const inputStyles = {
    sm: {
        height: '28px',
        font: 'b2',
        padding: '0px 6px',
    },
    md: {
        height: '32px',
        font: 'b1',
        padding: '0px 12px',
    },
    lg: {
        height: '40px',
        font: 'b1',
        padding: '9px 12px',
    },
};
const Container$3 = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${({ width }) => width !== undefined
    ? css `
          width: ${width}px;
        `
    : css `
          width: 100%;
        `}

  ${({ minWidth }) => minWidth !== undefined &&
    css `
      min-width: ${minWidth}px;
    `}
  ${({ maxWidth }) => maxWidth !== undefined &&
    css `
      max-width: ${maxWidth}px;
    `}

  * {
    box-sizing: border-box;
  }
`;
styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 40px;
  position: relative;

  ${({ width }) => width !== undefined
    ? css `
          width: ${width}px;
        `
    : css `
          width: 100%;
        `}

  ${({ minWidth }) => minWidth !== undefined &&
    css `
      min-width: ${minWidth}px;
    `}
  ${({ maxWidth }) => maxWidth !== undefined &&
    css `
      max-width: ${maxWidth}px;
    `}

  * {
    box-sizing: border-box;
  }
`;
styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1199;
`;
styled.div `
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: calc(100% - 2px);
  transform: translateX(1px);
  background-color: ${Colors$1.White};
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
`;
styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: ${Colors$1.White};
  width: 100%;
`;
styled.div `
  margin-top: 16px;
  background-color: rgba(246, 248, 252, 1);
  color: rgba(139, 147, 164, 1);
  font-size: 12px;
  padding: 12px 16px;
  border-radius: 0 0 2px 2px;
  border-top: 1px solid rgba(232, 237, 244, 1);
  width: 100%;
`;
const InputContainer = styled.div.attrs(({ className }) => ({
    className: ((className ? className + ' ' : '') +
        'amp-input-container'),
})) `
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 2px;
  border: 1px solid ${Colors$1.Pigeon400};
  background-color: ${Colors$1.White};
  gap: 8px;

  ${({ mono, size, isPrompt, expanded }) => {
    const styles = inputStyles[size];
    const fontType = mono ? styles.font + 'Mono' : styles.font;
    if (isPrompt) {
        return css `
        max-height: ${expanded ? undefined : '40px'};
        overflow: hidden;
        padding: 7px 12px;
        width: 100%;
        align-items: flex-start;
        textarea {
          ${getFont(fontType)}
        }
      `;
    }
    return css `
      height: ${styles.height};
      padding: ${styles.padding};

      input {
        ${getFont(fontType)}
      }
    `;
}}

  ${({ hug }) => hug &&
    css `
      ${hug === 'left' ? 'padding-left: 0;' : 'padding-right: 0;'}
    `}

  ${({ tint }) => tint &&
    css `
      background-color: ${Colors$1.Pigeon100};
      border-color: ${Colors$1.Pigeon100};
    `}

  ${({ disabled, canCopy }) => disabled &&
    css `
      background-color: ${Colors$1.Pigeon100};

      input {
        color: ${canCopy ? Colors$1.Pigeon700 : Colors$1.Pigeon600};
      }
    `}

  ${({ collapsed }) => collapsed &&
    css `
      background-color: ${Colors$1.Transparent};
      border-color: ${Colors$1.Transparent} !important;
      width: 0px;
    `}

  svg {
    color: ${({ tint, canCopy }) => tint && !canCopy ? Colors$1.Pigeon600 : Colors$1.Pigeon700};
  }

  button svg {
    color: ${Colors$1.Pigeon700};
  }

  ${({ error }) => error &&
    css `
      color: ${Colors$1.Pinata900};
      border-color: ${Colors$1.Pinata600};

      input {
        color: ${Colors$1.Pinata900};
      }
    `}

  ${({ error, isFocusVisible }) => isFocusVisible &&
    getFocusOutline(error ? Colors$1.Pinata900 : Colors$1.Electric600)}
`;
const SpinnerContainer = styled.div `
  display: flex;
  align-items: center;

  svg {
    color: ${Colors$1.Pigeon700};
  }

  .spinner {
    height: 16px;
    width: 16px;
  }
`;
const StyledInput$1 = styled.input `
  padding: ${({ padding }) => padding ?? '0'};
  background: inherit;
  outline: 2px solid transparent;
  outline-offset: 2px;
  height: 100%;
  border: none;
  width: 100%;
  border-radius: 2px;
  ${({ textAlign = 'left' }) => css `
    text-align: ${textAlign};
  `}

  ::placeholder {
    color: ${Colors$1.Pigeon600};
  }

  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
styled.textarea `
  padding: ${({ padding }) => padding ?? '0'};
  background: inherit;
  outline: 2px solid transparent;
  outline-offset: 2px;
  border: none;
  width: 100%;
  resize: none;
  border-radius: 2px;
  transform: translateY(2px);
  ${({ textAlign = 'left' }) => css `
    text-align: ${textAlign};
  `}

  ::placeholder {
    color: ${Colors$1.Pigeon600};
  }

  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
    margin: 0;
  }
  overflow-y: hidden;
`;
const IconContainer = styled.div `
  display: flex;
  align-items: center;

  ${({ weighted }) => weighted &&
    css `
      path {
        stroke: currentColor;
        stroke-width: 0.5px;
      }
    `}

  ${({ error }) => error &&
    css `
      svg {
        color: ${Colors$1.Pinata900};
      }

      path {
        stroke: ${Colors$1.Pinata900};
        stroke-width: 0.5px;
      }
    `}
`;
const IconButtonContainer = styled.div `
  display: flex;
  align-items: center;
  margin-right: -4px;

  ${({ weighted }) => weighted &&
    css `
      path {
        stroke: currentColor;
        stroke-width: 0.5px;
      }
    `}
  ${({ left }) => left &&
    css `
      margin-left: -4px;
    `}
  ${({ dark }) => dark &&
    css `
      svg {
        color: ${Colors$1.Pigeon700} !important;
      }
    `}
`;
const Label$1 = styled.label `
  ${getFont('actionMd')}
`;
const Description = ({ children }) => (jsx(Typography, { type: 'b1', color: Colors$1.Pigeon700, children: children }));
const CopyMessage = styled.div `
  ${getFont('b1')}
  color: ${Colors$1.Pigeon700};
  position: absolute;
  left: 100%;
  padding: 0px 12px;
  opacity: 0;
  transition: opacity ease-in-out 100ms;

  ${({ show }) => show &&
    css `
      opacity: 1;
    `}
`;
const getBorderStyles = (align) => {
    if (align === 'left') {
        return css `
      border-left: 0;
      border-right: 1px solid ${Colors$1.Pigeon400};
    `;
    }
    return css `
    border-left: 1px solid ${Colors$1.Pigeon400};
    border-right: 0;
  `;
};
styled.div.attrs({
    className: 'amp-input-decorator',
}) `
  display: flex;
  align-items: center;
  background-color: ${Colors$1.Pigeon100};
  border: 1px solid ${Colors$1.Pigeon400};
  ${({ align = 'right' }) => getBorderStyles(align)};
  border-radius: ${({ align }) => align === 'left' ? '2px 2px 0 0' : '0 0 2px 2px'};
  padding: 9px 12px;
  color: ${Colors$1.Pigeon700};
  max-width: min-content;
  height: 40px; // only supports large inputs currently
  ${getFont('b1')};
`;

styled.div `
  display: flex;
  flex-direction: column;
`;
styled.div `
  display: flex;
  margin: 4px 0;
`;
styled.label `
  display: flex;
  justify-content: center;
  ${getFont('actionMd')};
  transition: background-color 0.2s ease;
  padding: 9px 17px;
  min-width: ${({ $minWidth = 100 }) => $minWidth}px;
  z-index: ${({ isSelected }) => (isSelected ? 3 : 'auto')};

  background-color: ${({ isSelected }) => isSelected ? Colors$1.Electric700 : Colors$1.Pigeon100};
  color: ${({ isSelected }) => isSelected ? Colors$1.White : Colors$1.MidnightBrand};

  ${({ isHovered, isSelected }) => css `
    cursor: pointer;
    background-color: ${isHovered &&
    (isSelected ? Colors$1.Electric900 : Colors$1.Pigeon200)};
  `}

  ${({ isFocusVisible, isSelected }) => isFocusVisible &&
    getFocusOutline(isSelected ? Colors$1.Electric600 : Colors$1.Pigeon200)}

  &:first-child {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  &:last-child {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`;

createContext(null);

const IconButtonStyles = css `
  ${({ variant, $isFocusVisible, $isHovered, $isPressed }) => getButtonStyles({
    variant,
    isFocusVisible: $isFocusVisible,
    isHovered: $isHovered,
    isPressed: $isPressed,
})}

  align-items: center;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  height: ${({ size = 24 }) => `${size + 8}px`};
  justify-content: center;
  outline: none;
  transition: background-color 0.2s ease;
  width: ${({ size = 24 }) => `${size + 8}px`};

  ${({ $rotateIcon }) => $rotateIcon !== undefined &&
    css `
      svg {
        transition: ease-in-out transform 0.1s;
        transform: rotate(${$rotateIcon}deg);
      }
    `}

  ${({ $isDisabled }) => $isDisabled &&
    css `
      opacity: 50%;
      pointer-events: none;
    `}
`;
const ButtonContainer = styled.button `
  ${IconButtonStyles}
`;
const LinkContainer = styled(Link$1) `
  ${IconButtonStyles}
`;
const AnchorLinkContainer = styled.a `
  ${IconButtonStyles}
`;
const getContainer = (href, to) => {
    if (to)
        return LinkContainer;
    if (href)
        return AnchorLinkContainer;
    return ButtonContainer;
};
const IconButton = ({ variant = 'tertiary', name, rotateIcon, size = 24, isDisabled = false, color, ...otherProps }) => {
    const ref = useRef(null);
    const { buttonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3({ ...otherProps, isDisabled }, ref);
    const { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
        ...otherProps,
        isDisabled,
        ref,
    });
    const { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({ isDisabled });
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    const combinedProps = {
        ...buttonProps,
        ...focusProps,
        ...hoverProps,
        ...pressProps,
    };
    const Container = getContainer(otherProps.href, otherProps.to);
    return (
    // @ts-ignore
    jsx(Container, { className: classnames$1('styled-icon-button', ...[variant]), variant: variant, size: size, "$rotateIcon": rotateIcon, "$isDisabled": isDisabled, "$isFocusVisible": isFocusVisible, "$isHovered": isHovered, "$isPressed": isPressed, role: 'button', ...combinedProps, children: jsx(Icon, { name: name, size: size, color: color }) }));
};

var MenuTrigger;
(function (MenuTrigger) {
    MenuTrigger["click"] = "click";
    MenuTrigger["hover"] = "hover";
})(MenuTrigger || (MenuTrigger = {}));
var MenuPlacement;
(function (MenuPlacement) {
    MenuPlacement["none"] = "none";
    MenuPlacement["top"] = "top";
    MenuPlacement["bottom"] = "bottom";
    MenuPlacement["right"] = "right";
    MenuPlacement["left"] = "left";
    // TODO: flip = 'flip',
})(MenuPlacement || (MenuPlacement = {}));
var MenuAlignment;
(function (MenuAlignment) {
    MenuAlignment["start"] = "start";
    MenuAlignment["end"] = "end";
    MenuAlignment["center"] = "center";
})(MenuAlignment || (MenuAlignment = {}));
var MenuDirection;
(function (MenuDirection) {
    MenuDirection["up"] = "up";
    MenuDirection["down"] = "down";
})(MenuDirection || (MenuDirection = {}));
var MenuSize;
(function (MenuSize) {
    MenuSize["sm"] = "sm";
    MenuSize["md"] = "md";
    MenuSize["lg"] = "lg";
})(MenuSize || (MenuSize = {}));
var MenuType;
(function (MenuType) {
    MenuType["dropdown"] = "dropdown";
    MenuType["context"] = "context";
})(MenuType || (MenuType = {}));
var MenuSelectionMode;
(function (MenuSelectionMode) {
    MenuSelectionMode["multiple"] = "multiple";
    MenuSelectionMode["single"] = "single";
    MenuSelectionMode["none"] = "none";
})(MenuSelectionMode || (MenuSelectionMode = {}));

const isDropdownType = (props) => {
    return (props.type === MenuType.dropdown || props.borderType === MenuType.dropdown);
};
const getMenuBorderStyles = (props) => {
    const defaultColor = isDropdownType(props)
        ? Colors$1.Pigeon400
        : Colors$1.Pigeon200;
    return `1px solid ${props.error ? Colors$1.Pinata900 : defaultColor}`;
};
const getMenuBorderTopStyles = (props) => {
    if (props.type === MenuType.dropdown) {
        return getMenuBorderStyles(props);
    }
    return `1px solid ${Colors$1.Pigeon200}`;
};
const getMenuShadowStyles = (props) => {
    if (props.placement === MenuPlacement.top) {
        return `0px -10px 15px -3px rgba(0, 0, 0, 0.1),
    0px -4px 6px -2px rgba(0, 0, 0, 0.05)`;
    }
    return `0px 10px 15px -3px rgba(0, 0, 0, 0.1),
  0px 4px 6px -2px rgba(0, 0, 0, 0.05)`;
};
const getMenuTriggerStyles = ({ direction, error, size, isFocusVisible, isOpen, }) => {
    return css `
    &,
    input {
      ${getFont(size === MenuSize.sm ? 'b2' : 'b1')}
    }

    ${isFocusVisible &&
        getFocusOutline(error ? Colors$1.Pinata900 : Colors$1.Electric600)}

    align-items: center;
    background-color: ${Colors$1.White};
    border: ${getMenuBorderStyles({ error, type: MenuType.dropdown })};
    border-radius: ${isOpen
        ? direction === MenuDirection.down
            ? '2px 2px 0 0'
            : '0 0 2px 2px'
        : '2px'};
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: space-between;
    outline: none;
    padding: 8px 16px 8px 16px !important; // because of the global padding overrides
    width: 100%;
  `;
};
const getMenuPositioningStyles = (props) => {
    // TODO: handle alignment as well
    switch (props.placement) {
        case MenuPlacement.none:
            return css ``;
        case MenuPlacement.right:
            return css `
        position: absolute;
        left: 100%;
        top: 0px;
        margin-top: -1px;
      `;
        case MenuPlacement.left:
            return css `
        position: absolute;
        left: 0px;
        top: 0px;
        margin-top: -1px;
      `;
        case MenuPlacement.top:
            return css `
        position: absolute;
        bottom: 100%;
        margin-bottom: 4px;
      `;
        default:
            return css `
        position: absolute;
        right: 0px;
        margin-top: 4px;
      `;
    }
};
const MenuPopoverElement = styled.div.attrs(({ className }) => ({
    className: (className ? className + ' ' : '') + 'amp-menu-popover',
})) `
  border: ${(props) => getMenuBorderStyles(props)};
  border-radius: 2px;
  z-index: ${ZIndex.level1100};
  width: 100%;
  min-width: ${(props) => props.minWidth ?? 'max-content'};
  box-shadow: ${(props) => getMenuShadowStyles(props)};
  background: ${Colors$1.White};

  ${(props) => props.maxWidth
    ? `
    &, ul {
      max-width: ${props.maxWidth};
    }`
    : ''}

  ${(props) => getMenuPositioningStyles(props)}

  ${(props) => {
    if (props.type !== MenuType.dropdown)
        return '';
    if (props.placement === MenuPlacement.top) {
        return css `
        border-bottom: ${getMenuBorderTopStyles({ error: props.error })};
        margin-bottom: -1px;
        border-radius: 2px 2px 0 0;
      `;
    }
    return css `
      border-top: ${getMenuBorderTopStyles({ error: props.error })};
      margin-top: -1px;
      border-radius: 0 0 2px 2px;
    `;
}}
`;
const MenuInputContainer = styled.div `
  ${(props) => getMenuTriggerStyles(props)}

  ${({ $canClear }) => $canClear &&
    `
    padding-right: 8px !important;
  `}

  ${({ inner, error, direction }) => inner &&
    css `
      height: 33px;
      border-right: none;
      border-left: none;

      ${direction === MenuDirection.up
        ? css `
            border-bottom: none;
            border-top: ${getMenuBorderTopStyles({ error, direction })};
            border-top-right-radius: 0px;
            border-top-left-radius: 0px;
          `
        : css `
            border-top: none;
            border-bottom: ${getMenuBorderTopStyles({ error, direction })};
            border-bottom-right-radius: 0px;
            border-bottom-left-radius: 0px;
          `}
    `}
`;
const MenuInputElement = styled.input `
  flex-grow: 1;
  outline: none;
  border: none;
  padding: 0;

  &::placeholder {
    color: ${Colors$1.Pigeon600};
  }
`;
const MenuList = styled.ul `
  border-radius: 2px;
  margin: 0;
  list-style: none;
  padding: 8px 0 0 0;
  outline: ${({ isFocusVisible }) => isFocusVisible ? `2px solid ${Colors$1.Electric700}` : 'none'};

  ${({ size }) => size === MenuSize.sm &&
    css `
      input,
      li div,
      li span {
        font-size: 12px !important;
      }
    `}

  ${({ maxHeight }) => maxHeight &&
    css `
      max-height: ${maxHeight};
      overflow: auto;
    `}
`;
const MenuDivider = styled.div `
  width: 100%;
  height: 1px;
  background-color: ${Colors$1.Pigeon200};
  margin-top: 4px;
  margin-bottom: 4px;
`;
const MenuListItemElement = styled.li `
    background-color: ${({ isFocused }) => isFocused ? Colors$1.Pigeon100 : Colors$1.White}};
    color: ${({ isDisabled }) => isDisabled ? Colors$1.Pigeon400 : Colors$1.MidnightBrand};
    cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
    height: 32px;
    outline: none;
    overflow: visible;

    ${({ isPressed }) => isPressed &&
    css `
        background-color: ${Colors$1.Pigeon200};
      `}
  
  ${({ isSelected, isCheckbox }) => css `
    ${MenuItemText} {
      ${getFont(isSelected && !isCheckbox ? 'actionMd' : 'b1')}
    }
  `}

  &:first-of-type {
    margin-top: 4px;
  }

  &:last-of-type {
    margin-bottom: 4px;
  }
`;
const MenuGroup = styled.li `
  > ul {
    margin: 0;
    list-style: none;
    padding: 0;
  }
`;
const MenuGroupText = styled.span `
  ${truncated}
  ${getFont('b2')}
  color: ${Colors$1.Pigeon600};
  flex-grow: 1;
  text-align: left;
  padding: 8px 16px;
`;
const MenuItemContent = styled.div `
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 16px;
  gap: 12px;
`;
const MenuEmptyContent = styled.div `
  ${getFont('b1')}
  color: ${Colors$1.Pigeon600};
  padding: 6px 16px;
  background-color: ${Colors$1.Pigeon100};
`;
const MenuMessage = styled(MenuEmptyContent) `
  border-bottom: 1px solid ${Colors$1.Pigeon200};
  position: sticky;
  top: 0;
`;
const MenuItemText = styled.span `
  ${truncated}
  flex-grow: 1;
  text-align: left;
`;
const MenuItemBadge = styled.span `
  ${getFont('actionSm')}
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 4px;
  border-radius: 4px;
  color: ${Colors$1.Pinata900};
  background-color: ${Colors$1.Pinata100};
  line-height: 12px;
  font-size: 11px !important;
`;
const MenuItemIcon = styled.span `
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ChevronRight = styled(Icon).attrs({
    name: 'chevronDown',
    size: 12,
}) `
  transform: rotate(-90deg);
  color: ${Colors$1.MidnightBrand};

  path {
    stroke: currentColor;
    stroke-width: 2px;
  }
`;
const Checkmark = styled(Icon).attrs({ name: 'checkmark', size: 16 }) `
  color: ${Colors$1.MidnightBrand};
`;

const MenuInput = ({ autoFocus, inputRef, placeholder, onChange, onClear, onClick, onFocus, onKeyDown, size, value, ...props }) => {
    return (jsxs(MenuInputContainer, { ...props, size: size, "$canClear": !!onClear, "data-testid": 'menu-input-container', children: [jsx(MenuInputElement, { ...props, ref: inputRef, autoFocus: autoFocus, placeholder: placeholder, value: value, role: 'input', onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown }), onClear ? (jsx(IconButton, { "aria-label": 'clear input', "data-testid": 'menu-input-clear', onPress: onClear, name: 'cross', size: 16 })) : null] }));
};

/*
  When utilizing Dropdowns and Menus from the Design System, it is essential that
  any keys used are encoded/decoded appropriately. We URI encode the key because the
  react-aria logic will throw errors when attempting to perform some DOM functions on
  keys containing special characters.

  The helpers below should be leveraged when constructing options lists and managing selections
*/
const decodeKey = (key) => {
    return typeof key === 'string' ? decodeURIComponent(key) : key;
};
const decodeKeys = (keys) => {
    const decoded = [];
    keys.forEach((key) => decoded.push(decodeKey(key)));
    return decoded;
};

const FilteredDropdownMenu = (props) => {
    const ref = useRef(null);
    const { listBoxRef = ref, state, filter, optionsMap } = props;
    const { contains } = $bb77f239b46e8c72$export$3274cf84b703fff({ sensitivity: 'base' });
    const { menuProps } = $d5336fe17ce95402$export$38eaa17faae8f579({
        ...props,
        'aria-label': 'dropdown-menu-list',
    }, state, ref);
    const collection = useMemo(() => {
        if (!filter)
            return [...state.collection];
        return [...state.collection].filter((item) => {
            const matchString = `${(item.rendered ?? '').toString()} ${(item.key ?? '').toString()}`;
            return contains(matchString, filter);
        });
    }, [filter, state.collection]);
    return (jsx(MenuList, { ...menuProps, size: props.size, isEmpty: props.loading || !collection.length, maxHeight: props.maxHeight ?? '12em', ref: listBoxRef, children: props.loading ? (jsx(MenuEmptyContent, { children: "Loading options..." })) : collection.length ? (jsxs(Fragment, { children: [props.message && jsx(MenuMessage, { children: props.message }), collection.map((item) => (jsx(MenuItem, { "data-testId": `option-${item.key}`, option: optionsMap[item.key], item: item, state: state, onClose: state.close, checkbox: props.selectionMode === MenuSelectionMode.multiple }, item.key)))] })) : (props.searchable && (jsx(MenuEmptyContent, { children: "No matches found" }))) }));
};
const GroupedMenuItems = ({ section, optionsMap, state, selectionMode, }) => {
    let { itemProps, headingProps, groupProps } = $af383d3bef1cfdc9$export$c3f9f39876e4bc7({
        heading: section.rendered,
        'aria-label': section['aria-label'],
    });
    return (jsxs(MenuGroup, { ...itemProps, children: [section.rendered && (jsx(MenuGroupText, { ...headingProps, children: section.rendered.toUpperCase() })), jsx("ul", { ...groupProps, children: [...section.childNodes].map((node) => (jsx(MenuItem, { "data-testId": `henry-${node.key}`, option: optionsMap[node.key], item: node, state: state, onClose: state.close, checkbox: selectionMode === MenuSelectionMode.multiple }, node.key))) })] }));
};
const DropdownMenu = (props) => {
    const ref = useRef(null);
    const { listBoxRef = ref, state, optionsMap } = props;
    const { listBoxProps } = $c132121280ec012d$export$50eacbbf140a3141(props, state, listBoxRef);
    const collection = [...state.collection];
    if (!collection.length) {
        return jsx(MenuEmptyContent, { children: "No matches found" });
    }
    return (jsx(MenuList, { ...listBoxProps, size: props.size, maxHeight: props.maxHeight ?? '12em', ref: listBoxRef, children: collection.map((item) => {
            return item.type === 'section' ? (jsx(GroupedMenuItems, { section: item, state: state, optionsMap: optionsMap, selectionMode: props.selectionMode }, item.key)) : (jsx(MenuItem, { "data-testId": `option-${item.key}`, option: optionsMap[item.key], item: item, state: state, onClose: state.close, checkbox: props.selectionMode === MenuSelectionMode.multiple }, item.key));
        }) }));
};

const AnchorContainer = styled.div `
  position: relative;
`;
const DropdownTriggerContainer = styled.div `
  display: flex;
  flex: 1;
  position: relative;
  gap: 12px;
  svg {
    stroke: var(--color-pigeon-600);
  }
  span {
    max-width: 100%;
    overflow: hidden;
    white-space: pre;
  }
`;
const StyledButton = styled.button.attrs({
    className: 'amp-dropdown-button',
}) `
  ${(props) => getMenuTriggerStyles(props)}

  color: ${({ hasSelection }) => !hasSelection && Colors$1.Pigeon600};
  justify-content: flex-start;
`;
const StyledTrigger = styled.div.attrs({
    className: 'amp-dropdown-trigger',
}) `
  ${(props) => getMenuTriggerStyles(props)}

  color: ${({ hasSelection }) => !hasSelection && Colors$1.Pigeon600};
  justify-content: flex-start;
`;
styled(Typography).attrs({
    type: 'b1',
    color: Colors$1.Pigeon600,
}) `
  padding: 6px 16px;
  background-color: ${Colors$1.Pigeon100};
`;
const CustomTriggerButton = styled.button `
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  display: block;
  font-size: inherit;
  margin: 0;
  padding: 0;
  width: 100%;
  border-radius: 2px;

  ${({ isFocusVisible }) => isFocusVisible && getFocusOutline(Colors$1.Electric600)}
`;
const IconsContainer = styled.div `
  align-items: center;
  background-color: ${Colors$1.White};
  display: flex;
  gap: 8px;
  padding-left: 8px;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
`;

const DropdownTriggerIcons = ({ loading, error, hideArrow, triggerProps, }) => {
    return (jsx(IconsContainer, { children: loading ? (jsx(Spinner, {})) : (jsxs(Fragment, { children: [error && (jsx(Icon, { name: 'alertCircle', size: 16, "aria-label": 'error-icon', color: Colors$1.Pinata900 })), !hideArrow &&
                    (triggerProps ? (jsx(IconButton, { ...triggerProps, name: 'chevronDown', size: 16, "aria-label": 'dropdown-arrows-icon' })) : (jsx(Icon, { name: 'chevronDown', size: 16, "aria-label": 'dropdown-arrows-icon' })))] })) }));
};
const DropdownTrigger = ({ loading, error, direction, icon, buttonProps, buttonRef, label, isOpen, isFocusVisible, valueProps = {}, triggerProps, }) => {
    const TriggerElement = (buttonProps ? StyledButton : StyledTrigger);
    return (jsxs(DropdownTriggerContainer, { children: [jsxs(TriggerElement, { ...(buttonProps ?? {}), ref: buttonRef, error: error, hasSelection: !!label, isOpen: !!isOpen, direction: direction, isFocusVisible: isFocusVisible, "data-testid": 'dropdown-trigger-element', children: [icon, jsx("span", { ...valueProps, children: label ?? 'Select an option' })] }), jsx(DropdownTriggerIcons, { loading: loading, error: error, triggerProps: triggerProps })] }));
};

const useDropdownHover = ({ isDisabled }) => {
    const [isHovering, setIsHovering] = useState(false);
    const { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({ isDisabled });
    const handleTriggerEnter = () => {
        if (!isDisabled) {
            setIsHovering(true);
        }
    };
    useEffect(() => {
        if (isHovered) {
            setIsHovering(isHovered);
        }
    }, [isHovered]);
    return {
        isHovering,
        setIsHovering,
        hoverProps,
        triggerProps: { onMouseEnter: handleTriggerEnter },
    };
};

const MultiSelectDropdown = (props) => {
    const { error, loading, searchable, defaultOpen, customButton, minWidth, maxWidth, initializeEmptyInput, trigger, onDropdownClose, onBeforeOpen, onSearchChange, isDisabled, isFocused, isClickOutsideDisabled, } = props;
    const buttonRef = useRef(null);
    const inputRef = useRef(null);
    const containerRef = useRef(null);
    const state = $875d6693e12af071$export$728d6ba534403756(props);
    const [isOpen, setIsOpen] = useState(defaultOpen ?? false);
    const [inputValue, setInputValue] = useState('');
    const { isHovering, setIsHovering, hoverProps, triggerProps } = useDropdownHover({ isDisabled });
    const openDropdown = () => {
        if (isOpen) {
            return;
        }
        if (onBeforeOpen) {
            onBeforeOpen();
        }
        setIsOpen(true);
    };
    const closeDropdown = () => {
        if (!isOpen) {
            return;
        }
        setIsOpen(false);
        setIsHovering(false);
        if (onDropdownClose) {
            onDropdownClose(decodeKeys(state.selectionManager.selectedKeys));
        }
    };
    const toggleDropdown = () => {
        if (isOpen) {
            closeDropdown();
        }
        else {
            openDropdown();
        }
    };
    const focusInput = () => {
        inputRef?.current?.focus();
    };
    const blurInput = () => {
        inputRef?.current?.blur();
    };
    const { buttonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3({ onPress: toggleDropdown, isDisabled }, buttonRef);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    useEffect(() => {
        if (isOpen && initializeEmptyInput) {
            setInputValue('');
            focusInput();
        }
    }, [isOpen]);
    useEffect(() => {
        if (isOpen && !loading) {
            focusInput();
        }
    }, [loading]);
    useEffect(() => {
        if (trigger !== 'hover')
            return;
        if (isHovering) {
            openDropdown();
        }
    }, [isHovering, trigger]);
    useEffect(() => {
        if (trigger !== 'hover')
            return;
        if (isFocused === false) {
            closeDropdown();
        }
    }, [isFocused, trigger]);
    const handleKeyDown = (e) => {
        if (trigger !== 'hover' || !isFocused || isDisabled) {
            return;
        }
        if (e.key === 'ArrowRight' && !isOpen) {
            e.preventDefault();
            e.stopPropagation();
            openDropdown();
        }
    };
    const handleInputChange = (e) => {
        const value = e?.target.value ?? '';
        setInputValue(value);
        if (onSearchChange) {
            onSearchChange(value);
        }
    };
    const handleClearInput = () => {
        handleInputChange();
    };
    const handleInputClick = () => {
        focusInput();
    };
    const handleClickOutside = () => {
        if (isClickOutsideDisabled || !isOpen)
            return;
        blurInput();
        closeDropdown();
    };
    useEffect(() => {
        if (trigger === 'hover' && isFocused) {
            document.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isFocused, isOpen]);
    useOnClickOutside(containerRef, handleClickOutside);
    const DropdownPopoverInput = searchable ? (jsxs(DropdownTriggerContainer, { children: [jsx(MenuInput, { "aria-label": 'dropdown-search-input', autoFocus: props.autoFocus ?? true, value: inputValue, onChange: handleInputChange, onClick: handleInputClick, onClear: inputValue ? handleClearInput : undefined, inputRef: inputRef, error: error, inner: true, isOpen: isOpen, placeholder: props.placeholder || 'Search or select...', direction: props.direction }), jsx(DropdownTriggerIcons, { loading: loading, error: error, hideArrow: true, triggerProps: {} })] })) : null;
    return (jsxs(Container$3, { minWidth: minWidth, maxWidth: maxWidth, children: [props.label ? jsx(Label$1, { children: props.label }) : null, jsxs(AnchorContainer, { ...hoverProps, ref: containerRef, children: [customButton ? (jsx(CustomTriggerButton, { ...$3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, focusProps), ...triggerProps, isFocusVisible: isFocusVisible, ref: buttonRef, "data-testid": 'dropdown-trigger', children: customButton })) : (jsx(DropdownTrigger, { error: error, direction: props.direction, isOpen: isOpen, isFocusVisible: isFocusVisible, buttonRef: buttonRef, buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, focusProps), label: 'Select options', icon: props.leftIcon, valueProps: {}, triggerProps: triggerProps })), isOpen && (jsx(MenuPopover, { error: error, isOpen: isOpen, onClose: () => null, direction: props.direction, placement: props.placement, type: customButton ? MenuType.context : MenuType.dropdown, borderType: props.borderType, minWidth: props.minPopoverWidth, maxWidth: props.maxPopoverWidth, children: jsxs($9bf71ea28793e738$export$20e40289641fbbb6, { contain: true, restoreFocus: true, autoFocus: true, children: [props.direction !== MenuDirection.up && DropdownPopoverInput, jsx(FilteredDropdownMenu, { optionsMap: props.optionsMap, maxHeight: props.maxPopoverHeight, selectionMode: props.selectionMode, size: props.size, filter: inputValue, searchable: searchable, loading: loading, message: props.message, state: {
                                        ...state,
                                        isOpen,
                                        open: openDropdown,
                                        close: closeDropdown,
                                    } }), props.direction === MenuDirection.up && DropdownPopoverInput] }) }))] }), props.description ? (jsx(Description, { children: props.description })) : null] }));
};

const SearchableDropdown = (props) => {
    const { error, loading, defaultOpen, customButton, minWidth, maxWidth, maxPopoverWidth, initializeEmptyInput, hideArrow, trigger, isDisabled, isClickOutsideDisabled, } = props;
    const { contains } = $bb77f239b46e8c72$export$3274cf84b703fff({ sensitivity: 'base' });
    const onSelectionChange = (key) => {
        props.onSelectionChange?.(decodeKey(key));
    };
    const state = $a9e7382a7d111cb5$export$b453a3bfd4a5fa9e({
        ...props,
        onSelectionChange,
        defaultFilter: contains,
    });
    const buttonRef = useRef(null);
    const inputRef = useRef(null);
    const listBoxRef = useRef(null);
    const popoverRef = useRef(null);
    const containerRef = useRef(null);
    const { inputProps, buttonProps, listBoxProps, labelProps } = $c350ade66beef0af$export$8c18d1b4f7232bbf({
        ...props,
        onSelectionChange,
        inputRef,
        buttonRef,
        listBoxRef,
        popoverRef,
    }, state);
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const { isHovering, setIsHovering, hoverProps, triggerProps } = useDropdownHover({ isDisabled });
    const openDropdown = () => {
        setIsOpen(true);
        state.open();
    };
    const closeDropdown = () => {
        setIsOpen(false);
        state.setOpen(false);
        setIsHovering(false);
    };
    const toggleDropdown = () => {
        if (isOpen) {
            closeDropdown();
        }
        else {
            openDropdown();
        }
    };
    const { buttonProps: customButtonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3({ onPress: toggleDropdown, isDisabled }, buttonRef);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f(customButton
        ? undefined
        : {
            within: true,
            isTextInput: true,
        });
    useEffect(() => {
        if (customButton)
            return;
        if (defaultOpen) {
            openDropdown();
        }
        if (initializeEmptyInput) {
            state.setInputValue('');
        }
    }, []);
    useEffect(() => {
        if (customButton && isOpen && initializeEmptyInput) {
            state.setInputValue('');
        }
    }, [isOpen]);
    useEffect(() => {
        if (customButton) {
            closeDropdown();
        }
    }, [state.selectedKey]);
    useEffect(() => {
        if (trigger !== 'hover')
            return;
        if (isHovering) {
            openDropdown();
        }
        else {
            closeDropdown();
        }
    }, [isHovering, trigger]);
    const onInputChange = (e) => {
        if (!customButton) {
            openDropdown();
        }
        if (inputProps.onChange) {
            inputProps.onChange(e);
        }
    };
    const onInputFocus = (e) => {
        if (inputProps.disabled) {
            return;
        }
        if (inputProps.onFocus) {
            inputProps.onFocus(e);
        }
    };
    const onInputClick = (e) => {
        if (!customButton && !state.isOpen) {
            buttonProps?.onPressStart?.(e);
        }
    };
    const showDropdown = customButton ? isOpen : state.isOpen && !loading;
    const onClickOutside = () => {
        if (isClickOutsideDisabled)
            return;
        inputRef?.current?.blur();
        closeDropdown();
    };
    useOnClickOutside(containerRef, onClickOutside);
    const InputContainer = (jsxs(DropdownTriggerContainer, { children: [jsx(MenuInput, { ...(customButton ? inputProps : $3ef42575df84b30b$export$9d1611c77c2fe928(inputProps, focusProps)), size: undefined, autoFocus: props.autoFocus || !!customButton, onChange: onInputChange, onFocus: onInputFocus, onClick: onInputClick, inputRef: inputRef, error: error, inner: !!customButton, isOpen: !!showDropdown, placeholder: props.placeholder || 'Search or select...', direction: props.direction, isFocusVisible: isFocusVisible }), jsx(DropdownTriggerIcons, { loading: loading, error: error, hideArrow: !!(hideArrow || customButton), triggerProps: buttonProps })] }));
    const DropdownPopoverInput = customButton ? InputContainer : null;
    return (jsxs(Container$3, { minWidth: minWidth, maxWidth: maxWidth, children: [props.label ? jsx(Label$1, { ...labelProps, children: props.label }) : null, jsxs(AnchorContainer, { ...hoverProps, ref: containerRef, children: [customButton ? (jsx(CustomTriggerButton, { ...$3ef42575df84b30b$export$9d1611c77c2fe928(customButtonProps, focusProps), ...triggerProps, isFocusVisible: isFocusVisible, ref: buttonRef, "data-testid": 'dropdown-trigger', children: customButton })) : (InputContainer), showDropdown && (jsxs(MenuPopover, { popoverRef: popoverRef, error: error, isOpen: showDropdown, onClose: () => (customButton ? null : closeDropdown()), direction: props.direction, placement: props.placement, type: customButton ? MenuType.context : MenuType.dropdown, borderType: props.borderType, maxWidth: maxPopoverWidth, children: [props.direction !== MenuDirection.up && DropdownPopoverInput, jsx(DropdownMenu, { ...listBoxProps, optionsMap: props.optionsMap, listBoxRef: listBoxRef, maxHeight: props.maxPopoverHeight, selectionMode: props.selectionMode, size: props.size, state: {
                                    ...state,
                                    open: openDropdown,
                                    isOpen: showDropdown,
                                    close: () => (customButton ? null : closeDropdown()),
                                } }), props.direction === MenuDirection.up && DropdownPopoverInput] }))] }), props.description ? (jsx(Description, { children: props.description })) : null] }));
};

function DropdownPopover({ children, state, offset = 0, ...props }) {
    let popoverRef = useRef(null);
    let { popoverProps, underlayProps, arrowProps, placement } = $f2f8a6077418541e$export$542a6fd13ac93354({
        ...props,
        offset,
        popoverRef,
    }, state);
    return (jsx($337b884510726a0d$export$c6fdb837b070b4ff, { children: jsxs("div", { children: [jsx("div", { ...underlayProps, className: 'underlay' }), jsxs("div", { ...popoverProps, ref: popoverRef, className: 'popover', children: [jsx($86ea4cb521eb2e37$export$2317d149ed6f78c4, { onDismiss: state.close }), children, jsx($86ea4cb521eb2e37$export$2317d149ed6f78c4, { onDismiss: state.close })] })] }) }));
}

const SelectDropdown = (props) => {
    const { error, loading, customButton, minWidth, maxWidth, leftIcon } = props;
    const onSelectionChange = (key) => {
        props.onSelectionChange?.(decodeKey(key));
    };
    const state = $2bc3a590c5373a4e$export$5159ec8b34d4ec12({ ...props, onSelectionChange });
    const triggerRef = useRef(null);
    const { labelProps, triggerProps, valueProps, menuProps } = $58aed456727eb0f3$export$e64b2f635402ca43({ ...props, onSelectionChange }, state, triggerRef);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    const { buttonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3(triggerProps, triggerRef);
    const maxPopoverWidth = props.maxPopoverWidth ?? maxWidth ? maxWidth + 'px' : undefined;
    let triggerState = $fc909762b330b746$export$61c6a8c84e605fb6(props);
    $628037886ba31236$export$f9d5c8beee7d008d({ type: 'dialog' }, triggerState, triggerRef);
    return (jsxs(Container$3, { minWidth: minWidth, maxWidth: maxWidth, children: [props.label ? jsx(Label$1, { ...labelProps, children: props.label }) : null, jsxs(AnchorContainer, { children: [jsx($bdd25dc72710631f$export$cbd84cdb2e668835, { state: state, triggerRef: triggerRef, label: props.label, name: props.name }), customButton ? (jsx(CustomTriggerButton, { ...$3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, focusProps), isFocusVisible: isFocusVisible, ref: triggerRef, "data-testid": 'dropdown-trigger', children: customButton })) : (jsx(DropdownTrigger, { loading: loading, error: error, direction: props.direction, isOpen: props.isOpen, isFocusVisible: isFocusVisible, buttonRef: triggerRef, buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, focusProps), label: state.selectedItem?.rendered, icon: leftIcon, valueProps: valueProps, triggerProps: triggerProps })), state.isOpen && !loading && (jsx(DropdownPopover, { ...props, placement: 'bottom', triggerRef: triggerRef, state: state, children: jsx(MenuPopoverElement, { minWidth: minWidth + 'px', error: error, type: customButton ? MenuType.context : MenuType.dropdown, borderType: props.borderType, direction: props.direction, placement: MenuPlacement.none /* placement is handled by the DropdownPopover */, maxWidth: maxPopoverWidth, children: jsx(DropdownMenu, { ...menuProps, selectionMode: props.selectionMode, optionsMap: props.optionsMap, state: state, size: props.size, maxHeight: props.maxPopoverHeight }) }) }))] }), props.description ? (jsx(Description, { children: props.description })) : null] }));
};

const Dropdown = ({ direction = MenuDirection.down, placement = MenuPlacement.bottom, grouped = false, searchable, minWidth = 320, maxWidth = 320, selectionMode = MenuSelectionMode.single, ...props }) => {
    const DropdownComponent = selectionMode === MenuSelectionMode.multiple
        ? MultiSelectDropdown
        : searchable
            ? SearchableDropdown
            : SelectDropdown;
    const { disabledKeys, selectedKeys, children, optionsMap } = useMemo(() => grouped
        ? buildMenuGroups(props.optionsList)
        : buildMenuOptions(props.optionsList), [props.optionsList]);
    return (jsx(DropdownComponent, { className: 'ff-ds', direction: direction, placement: direction === MenuDirection.up ? MenuPlacement.top : placement, minWidth: minWidth, maxWidth: maxWidth, disabledKeys: disabledKeys, defaultSelectedKeys: selectedKeys, selectionMode: selectionMode, searchable: searchable, "aria-label": searchable ? 'searchable-dropdown' : 'select-dropdown', ...props, optionsMap: optionsMap, children: children }));
};

const DAY = 24 * 60 * 60 * 1000;
const getDateFromPast = (days, time) => {
    const date = new Date(Date.now() - days * DAY);
    const [startHour, startMinute, startSecond, startMillisecond] = time === 'start' ? [0, 0, 0, 0] : [23, 59, 59, 999];
    date.setUTCHours(startHour, startMinute, startSecond, startMillisecond);
    return date.toISOString();
};
const dateDropdownOptions = [
    {
        label: 'All time',
        key: 'all',
        interval: { start: undefined, end: undefined },
    },
    {
        label: 'Today',
        key: 'today',
        interval: {
            start: getDateFromPast(0, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
    {
        label: 'Yesterday',
        key: 'yesterday',
        interval: {
            start: getDateFromPast(1, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
    {
        label: 'Last 7 days',
        key: '7-days',
        interval: {
            start: getDateFromPast(7, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
    {
        label: 'Last 30 days',
        key: '30-days',
        interval: {
            start: getDateFromPast(30, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
    {
        label: 'Last 3 months',
        key: '3-months',
        interval: {
            start: getDateFromPast(90, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
    {
        label: 'Last 12 months',
        key: '12-months',
        interval: {
            start: getDateFromPast(365, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
];
const CalIcon = styled(Icon) `
  fill: none !important;
  margin-right: 8px;
  transform: scale(0.6);
  color: ${Colors$1.Pigeon600} !important;
`;
const DateDropdown = ({ onChange, loading, }) => {
    return (jsx(Dropdown, { "aria-label": 'Date filter', optionsList: dateDropdownOptions, onSelectionChange: onChange, leftIcon: jsx(CalIcon, { name: 'calendarLight', height: '14', width: '14', viewBox: '0 0 14 14' }), loading: loading }));
};

const IconNames = Object.keys(Icons);

const CheckboxContainer = styled.span `
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;

  label {
    ${({ smallLabel }) => getFont(smallLabel ? 'b2' : 'b1')}
  }

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    margin: 0;
    appearance: none;
    border-radius: ${({ borderRadius }) => borderRadius ?? `4px`};
    border: ${`1px solid ${Colors$1.Pigeon600}`};
    background-color: ${Colors$1.White};

    ${({ borderColor }) => borderColor &&
    css `
        border-color: ${borderColor} !important;
      `}

    &:checked {
      background-color: ${({ color }) => color ?? Colors$1.ElectricBrand};
    }
  }

  .checkmark {
    position: absolute;
    display: block;
    color: ${Colors$1.White};
    align-self: center;
    justify-self: center;
    top: 2px;
    left: 2px;
    path {
      stroke: currentColor;
      stroke-width: 2px;
    }
  }
`;
const PartialIcon = styled.div `
  background: ${Colors$1.Pigeon600};
  height: 2px;
  width: 8px;
  position: absolute;
  border-radius: 2px;
  margin-left: 4px;
  align-self: center;
`;
const CheckboxInput = ({ color, partial, smallLabel, borderColor, ...props }) => {
    const onChange = props.disabled
        ? undefined
        : (e) => props.onChange(e);
    const onClick = props.disabled
        ? undefined
        : (e) => {
            if (props.onChange) {
                const fakeEvent = {
                    target: { checked: !props.checked },
                    currentTarget: { checked: !props.checked },
                };
                props.onChange(fakeEvent);
            }
        };
    return (jsxs(CheckboxContainer, { color: color, smallLabel: smallLabel, borderColor: borderColor, "data-testid": 'amp-checkbox', children: [jsx("input", { ...props, onChange: onChange, type: 'checkbox', role: 'checkbox', id: 'amp-checkbox' }), partial && jsx(PartialIcon, { onClick: onClick }), props.label ? jsx("label", { onClick: onClick, children: props.label }) : null, props.checked && (jsx(Icon, { onClick: onClick, name: 'checkmark', size: 12, className: 'checkmark' }))] }));
};

const noop$1 = () => { };

const initialContext = {
    getTransformedValue: () => '',
    insertFragment: noop$1,
    setValue: noop$1,
    activeSearch: '',
    inputElement: null,
    setInputElement: noop$1,
    selectItem: noop$1,
    executeActionCallback: noop$1,
    setActiveItemIndex: noop$1,
    opened: null,
    index: 0,
    loading: false,
    results: [],
    closeAutocomplete: noop$1,
    openAutocomplete: noop$1,
    onBeforeChanges: noop$1,
    onKeyDown: noop$1,
    onChanges: noop$1,
    fixed: true,
    setPositionFixed: noop$1,
};
createContext(initialContext);

(jsxs("svg", { width: '12', height: '12', viewBox: '0 0 12 12', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: [jsx("g", { clipPath: 'url(#clip0_3766_118549)', children: jsx("path", { d: 'M11.25 1.125C11.25 0.91875 11.4187 0.75 11.625 0.75C11.8312 0.75 12 0.91875 12 1.125V5.25C12 6.28594 11.1609 7.125 10.125 7.125H1.27968L3.63983 9.48516C3.78514 9.63047 3.78514 9.86953 3.63983 10.0148C3.49452 10.1602 3.25546 10.1602 3.11014 10.0148L0.110144 7.01484C-0.0351685 6.86953 -0.0351685 6.63047 0.110144 6.48516L3.11014 3.48516C3.25546 3.33984 3.49452 3.33984 3.63983 3.48516C3.78514 3.63047 3.78514 3.86953 3.63983 4.01484L1.27968 6.375H10.125C10.7461 6.375 11.25 5.87109 11.25 5.25V1.125Z', fill: 'white' }) }), jsx("defs", { children: jsx("clipPath", { id: 'clip0_3766_118549', children: jsx("rect", { width: '12', height: '12', fill: 'white' }) }) })] }));
(jsx("svg", { width: '15', height: '9', viewBox: '0 0 15 9', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: jsx("path", { d: 'M7.5 7.125C8.4375 7.125 9.28125 6.63281 9.75 5.8125C10.2422 5.01562 10.2422 4.00781 9.75 3.1875C9.28125 2.39062 8.4375 1.875 7.5 1.875C6.53906 1.875 5.69531 2.39062 5.22656 3.1875C4.73438 4.00781 4.73438 5.01562 5.22656 5.8125C5.69531 6.63281 6.53906 7.125 7.5 7.125ZM11.2031 5.0625C10.9219 6.86719 9.375 8.25 7.5 8.25C5.60156 8.25 4.05469 6.86719 3.77344 5.0625H0.5625C0.234375 5.0625 0 4.82812 0 4.5C0 4.19531 0.234375 3.9375 0.5625 3.9375H3.77344C4.05469 2.13281 5.60156 0.75 7.5 0.75C9.375 0.75 10.9219 2.13281 11.2031 3.9375H14.4375C14.7422 3.9375 15 4.19531 15 4.5C15 4.82812 14.7422 5.0625 14.4375 5.0625H11.2031Z', fill: '#8B93A4' }) }));
styled.div `
  background: #fff;
  padding: 9px;
  font-size: 11px;
  color: rgba(59, 47, 201, 1);
  cursor: pointer;
  border-radius: 2px;
`;
styled.div `
  font-size: 12px;
  color: rgba(97, 106, 125, 1);
  font-weight: 500;
  padding: 12px 16px 6px;
`;
styled.div `
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  padding: 0 16px;
`;
styled.div `
  background: ${({ warning }) => warning ? '#FFE9E8' : 'rgba(236, 238, 255, 1)'};
  padding: 8px;
  font-size: 12px;
  color: ${({ warning }) => (warning ? '#920D0D' : 'rgba(59, 47, 201, 1)')};
  cursor: pointer;
  border-radius: 2px;
`;
styled.div `
  position: relative;
  font-size: 14px;

  [contenteditable='true']:empty:before {
    content: attr(placeholder);
    display: block;
    color: ${Colors$1.Pigeon600};
  }

  & > div[contenteditable='true'] {
    border: 1px solid rgba(202, 208, 220, 1);
    outline: none;
    padding: 10px 16px;
    padding-right: 30px;
    cursor: text;
    background: white;
    max-height: 150px;
    overflow-y: auto;

    &:focus {
      border: 1px solid rgba(139, 147, 164, 1);
    }
  }
`;
styled.div `
  svg path {
    fill: white;
  }
`;
styled.div `
  .autocomplete {
    z-index: 99999999;
    font-family: 'Proxima Nova', 'Helvetica', sans-serif;
  }

  .autocomplete-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px 0px;
    background-color: #fff;
    border: 1px solid rgba(202, 208, 220, 1);
    min-width: 200px;
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 4px 6px -2px rgba(0, 0, 0, 0.05);
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    max-height: 200px;
    overflow: scroll;
  }

  .autocomplete-item {
    padding: 4px 12px;
    outline: none;
    border: none;
    text-align: left;
    background-color: #fff;
    cursor: pointer;
    color: rgba(64, 72, 87, 1);
    font-size: 14px;
    display: flex;
    justify-content: space-between;
  }

  .autocomplete-item-ref {
    color: ${Colors$1.Pigeon600};
    padding-left: 4px;
  }

  .autocomplete-item-selected {
    background-color: rgba(246, 248, 252, 1);
    color: rgba(64, 72, 87, 1);
  }

  .autocomplete-item-action {
    color: rgba(76, 72, 239, 1);
  }

  .autocomplete-item:hover {
    background-color: rgba(246, 248, 252, 1);
  }

  .final {
    background-color: rgba(232, 237, 244, 1);
    color: rgba(9, 11, 43, 1);
    padding: 2px 2px;
  }

  .pending {
    background-color: rgba(236, 238, 255, 1);
    color: rgba(139, 147, 164, 1);
    padding: 2px 2px;
  }

  .autocomplete-group-name {
    font-size: 12px;
    font-weight: 500;
    color: rgba(139, 147, 164, 1);
    padding: 0px 12px;
  }
`;
styled.ul `
  display: flex;
  flex-direction: column;
  margin: 0;
  list-style: none;
  padding: 0;

  > li {
    cursor: pointer;
    padding: 6px 0;

    &:hover,
    :focus {
      background-color: ${Colors$1.Pigeon200};
    }
  }
`;
styled.div `
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

const defaultProps$1 = {
    placeholder: 'Search...',
    type: 'search',
    'aria-label': 'Search',
};
const SearchInput = forwardRef(({ disabled, onClear, onClickIcon, onExpand, size = 'lg', tint, minWidth = 320, collapsed, width, expandTooltip, ...props }, ref) => {
    const combinedProps = { ...defaultProps$1, isDisabled: disabled, ...props };
    const state = $0b2218c4e3fe7d7e$export$3f8be18b0f41eaf2(combinedProps);
    const { inputProps, clearButtonProps } = $4d52238874b24f86$export$9bb30bbe003b82e0(combinedProps, state, ref);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f({
        within: true,
        isTextInput: true,
    });
    const handleClearSearch = () => {
        state.setValue('');
        if (onClear) {
            onClear();
        }
    };
    return (jsx(Container$3, { width: width, minWidth: collapsed ? 0 : minWidth, "data-testid": 'search-field', children: jsxs(InputContainer, { ...focusProps, size: size, error: props.error, disabled: combinedProps.isDisabled, collapsed: collapsed, className: 'search-input-container', isFocusVisible: isFocusVisible, children: [onClickIcon ? (jsx(IconButtonContainer, { left: true, weighted: true, children: jsx(IconButton, { onPress: onClickIcon, name: 'search', size: 16 }) })) : (jsx(IconContainer, { weighted: true, children: jsx(Icon, { name: 'search', size: 16 }) })), jsx(StyledInput$1, { defaultValue: '', ...inputProps, autoFocus: false, ref: ref }), combinedProps.loading ? (jsx(SpinnerContainer, { children: jsx(Spinner, {}) })) : (state.value !== '' && (jsx(IconButtonContainer, { dark: true, weighted: true, children: jsx(IconButton, { ...clearButtonProps, name: 'cross', size: 16, onPress: handleClearSearch }) }))), onExpand && (jsx(IconButtonContainer, { dark: true, weighted: true, "data-tooltip-id": expandTooltip ? AMP_TOOLTIP_ID : undefined, "data-tooltip-content": expandTooltip, children: jsx(IconButton, { name: 'arrowsMaximize', onPress: onExpand, size: 16 }) }))] }) }));
});
SearchInput.displayName = 'SearchInput';

const defaultProps = {
    placeholder: '',
    type: 'text',
    'aria-label': 'Text Field',
};
const TextInput = ({ disabled, size = 'lg', tint, mono, minWidth = 320, width, ...props }) => {
    const combinedProps = { ...defaultProps, isDisabled: disabled, ...props };
    const inputRef = useRef(null);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [showCopyMessage, setShowCopyMessage] = useState(false);
    const { inputProps, labelProps, descriptionProps } = $2d73ec29415bd339$export$712718f7aec83d5(combinedProps, inputRef);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f({
        within: true,
        isTextInput: true,
    });
    const onCopySuccess = () => {
        setShowCopyMessage(true);
        setTimeout(() => setShowCopyMessage(false), 1200);
    };
    const togglePasswordVisible = useCallback(() => {
        setPasswordVisible(!passwordVisible);
    }, [passwordVisible, setPasswordVisible]);
    const copyToClipboard = useCallback(async () => {
        if (inputRef.current) {
            await navigator.clipboard.writeText(inputRef.current.value);
            onCopySuccess();
        }
    }, []);
    return (jsxs(Container$3, { className: 'ff-ds', "data-testid": 'text-field', minWidth: minWidth, width: width, children: [props.label ? (jsx(Label$1, { className: 'ff-ds', ...labelProps, children: props.label })) : null, jsxs(InputContainer, { ...focusProps, size: size, tint: tint, mono: mono, canCopy: props.canCopy, error: props.error, disabled: combinedProps.isDisabled, isFocusVisible: isFocusVisible, children: [jsx(StyledInput$1, { ...inputProps, ref: inputRef, type: passwordVisible ? 'text' : props.type }), props.error && props.type !== 'password' && (jsx(IconContainer, { error: true, children: jsx(Icon, { name: 'alertCircle', "aria-label": 'error-icon', size: 16 }) })), props.type === 'password' && (jsx(IconButtonContainer, { children: jsx(IconButton, { "data-testid": 'text-field-password-toggle', onPress: togglePasswordVisible, name: passwordVisible ? 'eyeSlash' : 'eye', size: 16 }) })), props.canCopy && (jsxs(Fragment, { children: [jsx(IconButtonContainer, { children: jsx(IconButton, { onPress: copyToClipboard, name: 'documentCopy', "data-testid": 'copy-icon', size: 16 }) }), jsx(CopyMessage, { show: showCopyMessage, children: "Copied!" })] }))] }), props.description ? (jsx(Description, { ...descriptionProps, children: props.description })) : null] }));
};

const noop = () => null;
const getTooltipContent = (props) => {
    if (props.disabled)
        return props.tooltip?.disabled;
    return props.tooltip?.active;
};
const MenuListItem = (props) => {
    const ref = useRef(null);
    const { icon, badge, label, menu, disabled, selected, focused, pressed, itemRef = ref, checkbox, onPress, divider, ...otherProps } = props;
    const { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({ isDisabled: disabled });
    const { focusProps, isFocusVisible } = $f7dceffc5ad7768b$export$4e328f61c538687f({ within: true });
    const { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
        onPress,
        isDisabled: disabled,
        ref: itemRef,
    });
    const validIcon = icon && IconNames.find((n) => n === icon);
    const isFocused = focused || isHovered || isFocusVisible;
    const combinedProps = $3ef42575df84b30b$export$9d1611c77c2fe928(otherProps, focusProps, hoverProps, pressProps);
    const content = (jsxs(MenuItemContent, { children: [checkbox && (jsx(CheckboxInput, { checked: selected, disabled: disabled, onChange: noop })), jsx(MenuItemText, { children: label }), badge && jsx(MenuItemBadge, { children: badge }), !checkbox && selected && jsx(Checkmark, { "aria-hidden": 'true' }), icon && validIcon && (jsx(MenuItemIcon, { children: jsx(Icon, { name: icon, color: Colors$1.Pigeon400, size: 16 }) })), menu && jsx(ChevronRight, {})] }));
    return (jsxs(Fragment, { children: [jsx(MenuListItemElement, { role: 'menuitem', ...combinedProps, "aria-haspopup": menu ? 'menu' : undefined, "data-testid": `option-${label?.toString()}`, "data-tooltip-id": AMP_TOOLTIP_ID, "data-tooltip-content": getTooltipContent(props), "data-tooltip-place": 'right', ref: itemRef, isDisabled: disabled, isSelected: selected, isFocused: isFocused, isPressed: pressed || isPressed, isCheckbox: checkbox, children: menu ? (jsx(Dropdown, { ...menu, trigger: MenuTrigger.hover, placement: MenuPlacement.right, customButton: content, initializeEmptyInput: true, isFocused: isFocused })) : (content) }), divider && jsx(MenuDivider, {}, `divider:${combinedProps['data-key']}`)] }));
};
const MenuItem = ({ item, option, state, checkbox, onClose, }) => {
    const ref = useRef(null);
    const shouldCloseOnSelect = checkbox || option?.menu ? false : option?.shouldCloseOnSelect ?? true;
    const { menuItemProps, isDisabled, isSelected, isFocused, isPressed } = $a2e5df62f93c7633$export$9d32628fc2aea7da({
        key: item.key,
        'aria-label': 'menu-item',
        closeOnSelect: shouldCloseOnSelect,
        isDisabled: option?.disabled,
        isSelected: option?.selected,
        onClose,
        onAction: option?.onAction ?? noop,
    }, state, ref);
    let selected = isSelected;
    /*
      In the multi-select state, the built-in logic for isSelected is not reliable
      for certain characters like '' and '('. To get around this, we check the set
      of selectedKeys directly.
    */
    const selectedKeys = state?.selectionManager?.selectedKeys;
    if (selectedKeys) {
        selected = selectedKeys.has(item.key);
    }
    return (jsx(MenuListItem, { ...item, ...menuItemProps, itemRef: ref, checkbox: checkbox, icon: option?.icon, menu: option?.menu, badge: option?.badge, divider: option?.divider, tooltip: option?.tooltip, label: item.rendered, disabled: isDisabled, selected: selected, pressed: isPressed, focused: isFocused }));
};

const MenuPopover = (props) => {
    const ref = useRef(null);
    const { direction, placement, alignment, type, borderType, popoverRef = ref, isDismissable, isOpen, onClose, children, error, minWidth, maxWidth, restoreFocus = true, shouldCloseOnInteractOutside, shouldCloseOnBlur = true, } = props;
    const { overlayProps } = $a11501f3d1d39e6c$export$ea8f71083e90600f({
        isOpen,
        isDismissable,
        onClose,
        shouldCloseOnInteractOutside,
        shouldCloseOnBlur,
    }, popoverRef);
    return (jsx($9bf71ea28793e738$export$20e40289641fbbb6, { restoreFocus: restoreFocus, children: jsxs(MenuPopoverElement, { ...overlayProps, error: error, type: type, borderType: borderType, direction: direction, placement: placement, alignment: alignment, minWidth: minWidth, maxWidth: maxWidth, ref: popoverRef, children: [children, jsx($86ea4cb521eb2e37$export$2317d149ed6f78c4, { onDismiss: onClose })] }) }));
};

const buildMenuOptions = (options, encode = true) => {
    /* Iterate only once through the menu options to build the options metadata */
    const disabledKeys = [];
    const selectedKeys = [];
    const children = [];
    const optionsMap = {};
    options.forEach((option) => {
        /*
          We URI encode the key because the react-aria logic will throw errors when
          attempting to perform some DOM functions on keys containing special characters.
        */
        const encodedKey = encode
            ? typeof option.key === 'string'
                ? encodeURIComponent(option.key ?? '')
                : option.key
            : option.key;
        /* Provides an array of disabled keys for the react-aria combobox logic */
        if (option.disabled) {
            disabledKeys.push(encodedKey);
        }
        /* Provides an array of default selected keys for the react-aria combobox logic */
        if (option.selected) {
            selectedKeys.push(encodedKey);
        }
        /* Provides an array of items for the react-stately item collection logic */
        if (!option.hidden) {
            children.push(jsx($c1d7fb2ec91bae71$export$6d08773d2e66f8f2, { textValue: option.label, children: option.label }, encodedKey));
        }
        /*
          Creates a map of option data so that the individual options can access it
          when rendering, without having to re-iterate through the list of options
        */
        optionsMap[option.key] = option;
    });
    return { disabledKeys, selectedKeys, children, optionsMap };
};
const buildMenuGroups = (groups, encode = true) => {
    const disabledKeys = [];
    const selectedKeys = [];
    const children = [];
    let optionsMap = {};
    groups.forEach((group) => {
        const { disabledKeys: groupDisabledKeys, selectedKeys: groupSelectedKeys, children: groupChildren, optionsMap: groupOptionsMap, } = buildMenuOptions(group.options);
        const groupKey = encode ? encodeURIComponent(group.name ?? '') : group.name;
        disabledKeys.push(...groupDisabledKeys);
        selectedKeys.push(...groupSelectedKeys);
        optionsMap = { ...optionsMap, ...groupOptionsMap };
        children.push(jsx($9fc4852771d079eb$export$6e2c8f0811a474ce, { title: group.name, children: groupChildren }, groupKey));
    });
    return { disabledKeys, selectedKeys, children, optionsMap };
};

const ContextMenuPopover = (props) => {
    const { children, optionsMap } = useMemo(() => buildMenuOptions(props.options, false), [props.options]);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    const state = $875d6693e12af071$export$728d6ba534403756({
        ...props,
        children,
        selectionMode: 'none',
    });
    // Get props for the menu element
    const ref = React__default.useRef(null);
    const { menuProps } = $d5336fe17ce95402$export$38eaa17faae8f579(props, state, ref);
    return (jsx(MenuPopover, { placement: props.placement, isOpen: true, isDismissable: true, onClose: props.onClose, shouldCloseOnInteractOutside: props.onInteractOutside, children: jsx(MenuList, { ...$3ef42575df84b30b$export$9d1611c77c2fe928(menuProps, focusProps), ref: ref, isFocusVisible: isFocusVisible && props.showFocus, children: [...state.collection].map((item) => (jsx(MenuItem, { item: item, state: state, option: optionsMap[item.key], onClose: props.onClose }, item.key))) }) }));
};

const Container$2 = styled.span `
  display: inline-block;
  position: relative;
  width: fit-content;
`;
const ContextMenu = (props) => {
    const state = $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(props);
    const ref = React__default.useRef(null);
    const { menuProps } = $168583247155ddda$export$dc9c12ed27dd1b49({}, state, ref);
    const { index, onMenuStateChange } = props;
    useEffect(() => {
        if (onMenuStateChange) {
            onMenuStateChange({ isOpen: state.isOpen, index: index ?? undefined });
        }
    }, [onMenuStateChange, state.isOpen, index]);
    const onClose = useCallback(() => {
        state.close();
        props.onClose?.();
    }, [props, state]);
    const onPress = useCallback(() => !props.rightClick && state.open(), [props, state]);
    const onContextMenu = useCallback((e) => {
        if (props.rightClick) {
            e.preventDefault();
            state.open();
        }
    }, [props, state]);
    const combinedMenuProps = { ...props, ...menuProps };
    return (jsxs(Container$2, { children: [jsx("span", { onContextMenu: onContextMenu, children: props.children ? (props.children(state.open)) : (jsx(IconButton, { onPress: onPress, size: props.size === MenuSize.sm ? 16 : 24, name: 'dotsVertical', "data-testid": 'context-menu-trigger', isDisabled: props.isDisabled })) }), state.isOpen && (jsx(ContextMenuPopover, { ...combinedMenuProps, options: props.options, onClose: onClose }))] }));
};

const TitleBarContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;
const TitleBarTitle = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const TitleBarDescription = styled(Typography) `
  margin-top: 8px;
`;
const RightContent = styled.span `
  display: inline-flex;
  gap: 8px;
  align-items: center;
`;
const StyledActionsTooltip = styled(ActionsTooltip) `
  display: flex;
`;
const IconFlex = styled.div `
  display: flex;
`;
const TitleBar = ({ title, type, description, button, icon, }) => {
    const TitleContent = () => {
        if (!title)
            return null;
        if (typeof title === 'string') {
            return jsx(Typography, { type: type ?? 'h4Serif', children: title });
        }
        return title;
    };
    return (jsxs(TitleBarContainer, { "data-testid": 'list-title-bar', children: [jsxs(TitleBarTitle, { children: [jsx(TitleContent, {}), jsxs(RightContent, { children: [icon && (jsx(StyledActionsTooltip, { text: icon.tooltip.text, actions: [
                                    {
                                        text: 'Learn more',
                                        onClick: () => window.open(icon.tooltip.url, '_blank'),
                                    },
                                ], children: jsx(IconFlex, { children: jsx(Icon, { name: icon.name, color: icon.color, "data-testid": 'alert-icon' }) }) })), button && jsx(Button, { ...button })] })] }), description ? (jsx(TitleBarDescription, { type: 'b1', color: Colors$1.Pigeon700, children: description })) : null] }));
};

const SearchBarContainer = styled.div `
  ${({ width }) => width !== undefined
    ? css `
          width: ${width}px;
        `
    : css `
          width: 100%;
        `}
`;
const SearchBar = ({ loading, disabled, placeholder, onSearch, width, }) => {
    return (jsx(SearchBarContainer, { width: width, children: jsx(SearchInput, { tint: true, placeholder: placeholder, loading: loading, disabled: disabled, onChange: onSearch, width: width }) }));
};

const ActionBar = ({ actions }) => {
    return (jsx(ButtonRow$1, { children: actions.map((action) => {
            const { label, disabled, onClick, icon } = action;
            return (jsx(Button, { variant: 'tertiary', iconLeft: icon.name, onPress: onClick, label: label, isDisabled: disabled, size: 'sm', "data-testid": `action-button-${label}` }, action.label));
        }) }));
};

/* Styled HTML table elements that can be used outside of the List if desired. */
const cellPadding = '0.75em';
const Table = styled.table `
  color: ${Colors$1.MidnightBrand};
  border-collapse: collapse;
  width: 100%;

  ${({ fixed }) => (fixed ? 'table-layout: fixed;' : '')}

  ${({ condensed }) => condensed
    ? css `
          ${getFont('b2')}

          td,
          th {
            padding-top: 0;
            padding-bottom: 0;
          }
        `
    : getFont('b1')}
`;
const TableBody = styled.tbody ``;
const TableRow = styled.tr `
  width: 100%;

  ${({ height }) => height
    ? `
    td, th {
      padding-top: 0;
      padding-bottom: 0;
    }
  `
    : ''}
  ${({ condensed }) => !condensed && `border-bottom: 1px solid ${Colors$1.Pigeon200};`}

  ${({ odd }) => odd && `background-color: ${Colors$1.Pigeon100};`}
  ${({ disabled }) => disabled && `opacity: 0.5;`}

  .show-on-hover {
    opacity: 0;
  }

  &:hover {
    .show-on-hover {
      opacity: 1;
    }
    ${({ hoverable }) => hoverable &&
    `
    background-color: ${Colors$1.Pigeon100};
    `}
    ${({ clickable }) => clickable &&
    `
    cursor: pointer;
    `}
  }

  ${({ isFooter }) => isFooter && `border-top: none;`}
  ${({ hasFooter }) => hasFooter && `border-bottom: none;`}
`;
const TableHeader = styled.thead `
  tr {
    border-bottom: 1px solid ${Colors$1.Pigeon400};
  }
`;
const CellStyles = css `
  ${({ colWidth }) => {
    if (colWidth === undefined)
        return '';
    return `
      width: ${typeof colWidth === 'number' ? colWidth + 'px' : colWidth};
    `;
}}
  text-align: left;
  padding: ${cellPadding};
  ${({ verticalAlign }) => {
    if (verticalAlign !== 'middle')
        return `vertical-align: ${verticalAlign};`;
}}
`;
const TableHeaderCell = styled.th `
  ${CellStyles}
  font-weight: 600;
  color: ${Colors$1.MidnightBrand};

  div {
    font-weight: 600;
    color: ${Colors$1.MidnightBrand};
  }
`;
const TableCell = styled.td `
  ${CellStyles}
`;
const FooterTableCell = styled.td `
  ${CellStyles}
  padding-top: 0;
`;

const CONDENSED_ROW_HEIGHT = 28;
const cellKey = (row, column) => `cell-${row}-${column}`;
const rowKey = (row) => `row-${row}`;
const isOdd = (row) => !!(row % 2);
const CellContent = styled.div `
  ${({ height }) => height
    ? `
    height: ${height}px;
    max-height: ${height}px;
    display: flex;
    align-items: center;
    overflow: hidden;
  `
    : ''}
  ${({ condensed, height }) => (condensed || !!height) &&
    css `
      div,
      span {
        max-width: 100%;
        ${truncated}
      }
    `}
`;
const TableWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 100%;
  min-height: 100px;
  padding: 24px;

  .spinner {
    height: 40px;
    width: 40px;
  }
`;
const ListWrapper = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  ${getFont('b1')}
  overflow: visible;
`;
const FiltersWrapper = styled.div `
  display: flex;
  gap: 24px;
  width: 100%;

  > * {
    margin-top: 8px;
    margin-bottom: 16px;
  }
`;
const StyledTypography = styled(Typography) `
  ${({ width }) => width && `word-break: break-all;`}
`;
const DefaultEmptyComponent = () => {
    return jsx("div", {});
};
const ListEmpty = ({ component }) => {
    return jsx(TableWrapper, { children: component ?? jsx(DefaultEmptyComponent, {}) });
};
const ListError = ({ component }) => {
    return jsx(TableWrapper, { "data-testid": 'list-table-error', children: component });
};
const ListLoading = ({ component }) => {
    return jsx(TableWrapper, { children: component ?? jsx(Spinner, {}) });
};
const Header = ({ header, condensed, verticalAlign, }) => {
    return (jsx(Cell, { header: true, width: header.width, height: condensed ? CONDENSED_ROW_HEIGHT : undefined, condensed: condensed, cell: header.content, verticalAlign: verticalAlign }));
};
const SelectAllHeader = ({ condensed, selectOptions, verticalAlign, }) => {
    const { selectedItems, setSelectedItems, allItems } = selectOptions;
    const selectAllItems = () => {
        setSelectedItems(allItems);
    };
    const clearAllSelectedItems = () => {
        setSelectedItems([]);
    };
    const numSelectedItems = selectedItems.length;
    const allSelected = numSelectedItems > 0 && numSelectedItems === allItems.length;
    const someSelected = numSelectedItems > 0 && !allSelected;
    const onToggleSelectAll = () => {
        if (allSelected || someSelected) {
            clearAllSelectedItems();
        }
        else {
            selectAllItems();
        }
    };
    return (jsx(Cell, { header: true, width: '37px', height: condensed ? CONDENSED_ROW_HEIGHT : undefined, condensed: condensed, verticalAlign: verticalAlign, cell: jsx(CheckboxInput, { checked: allSelected, onChange: onToggleSelectAll, partial: someSelected, disabled: !allItems.length, "data-testid": 'select-all-checkbox' }) }));
};
const Cell = ({ cell, height, width, condensed, header, verticalAlign, }) => {
    const CellComponent = header ? TableHeaderCell : TableCell;
    const cellContent = typeof cell === 'string' ? (jsx(StyledTypography, { type: condensed ? 'b2' : 'b1', truncate: !!height || condensed, width: width, className: 'ff-ds', children: cell })) : (cell);
    return (jsx(CellComponent, { colWidth: width, verticalAlign: verticalAlign, "data-testid": 'list-cell-id', children: jsx(CellContent, { height: height, condensed: condensed, children: cellContent }) }));
};
const SelectCell = ({ selectOptions, selectKey, width, height, condensed, verticalAlign, toggleSelected, }) => {
    const isSelected = selectOptions?.selectedItems.includes(selectKey);
    return (jsx(Cell, { cell: jsx(CheckboxInput, { onChange: toggleSelected, checked: isSelected, "data-testid": `select-checkbox-${selectKey}` }), height: height, condensed: condensed, verticalAlign: verticalAlign, width: width }));
};
const Row = ({ headers, row, index, condensed, selectOptions, toggleSelected, verticalAlign, }) => {
    const height = row.height ?? (condensed ? CONDENSED_ROW_HEIGHT : undefined);
    const classNames = `${row.className}, amp-table-row`;
    /*
      We wrap each individual cell in the context menu instead of the entire row
      because the context menu wraps its children in a span, which would interfere
      with the HTML table structure.
    */
    const getCellContent = (cell, key) => {
        if (row.onRightClick && key !== 'menu' && !condensed) {
            return (jsx(ContextMenu, { "data-testid": 'list-row-context-menu', rightClick: true, placement: MenuPlacement.right, options: row.onRightClick, children: (onOpen) => jsx(Fragment, { children: cell }) }));
        }
        return cell;
    };
    /*
      If the table has headers, assign cell order based on the headers. Otherwise,
      simply iterate through the cells.
    */
    const cells = headers.length > 0
        ? headers.map((header, columnIndex) => (jsx(Cell, { cell: getCellContent(row.data[header.key], header.key), width: header.width, height: height, condensed: condensed, verticalAlign: verticalAlign }, cellKey(index, columnIndex))))
        : Object.keys(row.data).map((key, columnIndex) => (jsx(Cell, { cell: getCellContent(row.data[key]), height: height, condensed: condensed, verticalAlign: verticalAlign }, cellKey(index, columnIndex))));
    return (jsxs(Fragment, { children: [jsx(TableRow, { height: height, condensed: condensed, odd: condensed && isOdd(index), hoverable: row.hoverable, clickable: !!row.onClick, onClick: row.onClick, className: classNames, disabled: row.disabled, hasFooter: !!row.footer, "data-testid": row.testId, "data-tooltip-id": row['data-tooltip-id'], "data-tooltip-content": row['data-tooltip-content'], "data-tooltip-float": row['data-tooltip-float'], children: selectOptions ? (jsxs(Fragment, { children: [jsx(SelectCell, { selectOptions: selectOptions, selectKey: row.key, width: 30, height: height, condensed: condensed, verticalAlign: verticalAlign, toggleSelected: toggleSelected }, row.key), cells] })) : (cells) }), row.footer && (jsx(TableRow, { height: height, condensed: condensed, odd: condensed && isOdd(index), hoverable: row.hoverable, clickable: !!row.onClick, onClick: row.onClick, className: row.className, "data-testid": row.testId + '-footer', disabled: row.disabled, isFooter: true, children: jsx(FooterTableCell, { colSpan: cells.length, children: row.footer }) }))] }));
};
const TableHeaders = ({ headers, condensed, selectOptions, verticalAlign, }) => {
    if (!headers.length) {
        return null;
    }
    const headerCells = headers.map((header) => (jsx(Header, { header: header, condensed: condensed, verticalAlign: verticalAlign }, header.key)));
    return (jsx(TableHeader, { "data-testid": 'list-header-row', className: 'amp-table-header', children: jsx(TableRow, { children: selectOptions ? (jsxs(Fragment, { children: [jsx(SelectAllHeader, { condensed: condensed, verticalAlign: verticalAlign, selectOptions: selectOptions }), headerCells] })) : (headerCells) }) }));
};
const TableBodyContent = ({ data, headers, condensed, selectOptions, verticalAlign, }) => {
    const lastCheckedRef = useRef(null);
    if (!data.length) {
        return null;
    }
    const selectedItems = selectOptions?.selectedItems;
    const setSelectedItems = selectOptions?.setSelectedItems;
    const toggleSelected = useCallback((index, selectKey) => (e) => {
        if (selectedItems && setSelectedItems) {
            const isSelected = selectedItems.includes(selectKey);
            const isShiftKey = e.nativeEvent instanceof MouseEvent && e.nativeEvent.shiftKey;
            if (isShiftKey && !isSelected && lastCheckedRef.current !== null) {
                const start = Math.min(lastCheckedRef.current, index);
                const end = Math.max(lastCheckedRef.current, index);
                const newSelectedItems = [...selectedItems];
                for (let i = start; i <= end; i++) {
                    const itemKey = data[i].key;
                    if (!newSelectedItems.includes(itemKey)) {
                        newSelectedItems.push(itemKey);
                    }
                }
                setSelectedItems(newSelectedItems);
            }
            else {
                if (isSelected) {
                    setSelectedItems(selectedItems.filter((item) => item !== selectKey));
                    lastCheckedRef.current = null;
                }
                else {
                    setSelectedItems([...selectedItems, selectKey]);
                    lastCheckedRef.current = index;
                }
            }
        }
    }, [selectedItems, setSelectedItems, lastCheckedRef, data]);
    return (jsx(TableBody, { children: data.map((row, index) => (jsx(Row, { index: index, row: row, headers: headers, condensed: condensed, verticalAlign: verticalAlign, selectOptions: selectOptions, toggleSelected: toggleSelected(index, row.key) }, rowKey(index)))) }));
};
const getTableIsFixed = (props) => {
    if (props.condensed || props.fixed)
        return true;
    return props.headers.some((header) => header.width !== undefined);
};
const ListTable = (props) => {
    const { data, headers, condensed, components, selectOptions } = props;
    const noSearchResults = props.isSearching && !data.length;
    /*
      We render the empty component outside of the table structure so that it is
      not forced to obey table styles.
    */
    return (jsxs(Fragment, { children: [jsxs(Table, { condensed: condensed, fixed: getTableIsFixed(props), className: 'ff-ds', children: [jsx(TableHeaders, { headers: headers, condensed: condensed, verticalAlign: props.verticalAlign, selectOptions: selectOptions }), !noSearchResults && (jsx(TableBodyContent, { data: data, headers: headers, condensed: condensed, verticalAlign: props.verticalAlign, selectOptions: selectOptions }))] }), (noSearchResults || (!data.length && !props.isSearching)) && (jsx(ListEmpty, { component: noSearchResults ? components?.noSeachResults : components?.empty }))] }));
};
const ListContent = ({ loading, error, data, headers, fixed, condensed, components, isSearching, selectOptions, verticalAlign, }) => {
    if (loading) {
        return jsx(ListLoading, { component: components?.loading });
    }
    if (error) {
        return jsx(ListError, { component: components?.error });
    }
    if (!data.length && !headers.length && !isSearching) {
        return jsx(ListEmpty, { component: components?.empty });
    }
    return (jsx(ListTable, { data: data, headers: headers, fixed: fixed, condensed: condensed, components: components, isSearching: isSearching, selectOptions: selectOptions, verticalAlign: verticalAlign }));
};
const Content = styled.div `
  display: block;
  width: 100%;
  ${({ minHeight }) => minHeight &&
    `
    min-height: ${minHeight}px;
  `}
`;
const List = ({ title, search, filters, actions, minHeight, dateDropdown, dropdownFilter, verticalAlign, ...props }) => {
    /* Disable the search bar if data is loading or errored */
    const disableSearch = !!(search?.disabled ?? props.loading ?? props.error);
    return (jsxs(ListWrapper, { "data-testid": 'table-list', className: 'ff-ds', children: [title && jsx(TitleBar, { ...title }), jsxs(FiltersWrapper, { children: [search && jsx(SearchBar, { ...search, disabled: disableSearch }), dropdownFilter && jsx(Dropdown, { ...dropdownFilter }), dateDropdown && jsx(DateDropdown, { ...dateDropdown }), filters && filters] }), actions && jsx(ActionBar, { actions: actions }), jsx(Content, { minHeight: minHeight, children: jsx(ListContent, { verticalAlign: verticalAlign ?? 'middle', ...props }) })] }));
};

styled.div `
  display: flex;
  justify-content: flex-end;
  margin-right: -0.75em;

  svg {
    color: ${Colors$1.Pigeon700};
  }
`;

styled.div `
  font-weight: 600;
`;

var ESortOptions$1;
(function (ESortOptions) {
    ESortOptions[ESortOptions["None"] = 0] = "None";
    ESortOptions[ESortOptions["Asc"] = 1] = "Asc";
    ESortOptions[ESortOptions["Desc"] = 2] = "Desc";
})(ESortOptions$1 || (ESortOptions$1 = {}));
styled(IconButton) `
  ${({ active }) => (active ? 'opacity: 1' : 'opacity: 0')};

  &:hover,
  &:focus {
    opacity: 1;
  }
`;

styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;

  &:hover {
    .sort-button {
      opacity: 1;
    }
  }
`;

var ESortOptions;
(function (ESortOptions) {
    ESortOptions[ESortOptions["None"] = 0] = "None";
    ESortOptions[ESortOptions["Asc"] = 1] = "Asc";
    ESortOptions[ESortOptions["Desc"] = 2] = "Desc";
})(ESortOptions || (ESortOptions = {}));

const innerModalStyles = (size) => css `
  background-color: ${Colors$1.White};
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: ${size === 'sm' ? '512px' : '800px'};
  min-height: 136px;
  padding: 24px;
  position: relative;
  width: 100%;
`;
const overlayBackground = css `
  background-color: rgb(64 72 87 / 0.2);
`;
const Overlay = styled.div `
  > * {
    box-sizing: border-box;
  }

  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0px;
  position: fixed;
  top: 0px;
  right: 0px;
  width: 100%;
  z-index: 1200;

  ${({ hasOpaqueOverlay }) => hasOpaqueOverlay
    ? css `
          background-color: ${Colors$1.White};
        `
    : overlayBackground}
`;
const Container$1 = styled.div `
  ${({ size }) => innerModalStyles(size)}

  ${({ hasOpaqueOverlay }) => !hasOpaqueOverlay &&
    css `
      box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
        0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    `}

  max-height: calc(100vh - 64px);
  overflow-y: auto;
`;
const LimitedOverlay = styled.div `
  > * {
    box-sizing: border-box;
  }

  ${overlayBackground}

  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: ${ZIndex.level900};
`;
const ButtonRow = styled.div `
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
  width: 100%;
`;
styled(Typography) `
  margin-top: 24px;
`;
const ModalHeader = ({ children }) => {
    return (jsx(Typography, { type: 'h5', className: 'ff-ds', children: children }));
};
const ModalButtonRow = ({ children }) => {
    return jsx(ButtonRow, { children: children });
};
const ModalCloseButton = ({ onClose, ...props }) => (jsx(Button, { "data-testid": props['data-testid'], variant: props.variant || 'tertiary-border', onPress: onClose, label: props?.label || 'Close' }));
const Modal = ({ content, overlayType = 'default', size = 'sm', ...props }) => {
    if (overlayType === 'limited') {
        return (jsx(LimitedOverlay, { "data-testid": 'limited-outer-modal-wrapper', children: jsx(Container$1, { size: size, children: content }) }));
    }
    else {
        return (jsx(Overlay, { hasOpaqueOverlay: overlayType === 'opaque', "data-testid": props['data-testid'], children: jsx(Container$1, { "data-testid": 'modal-inner-wrapper', className: 'amp-modal', hasOpaqueOverlay: overlayType === 'opaque', size: size, children: content }) }));
    }
};

const PAGINATION_STYLES = {
    border: {
        sm: '',
        lg: `border-top: 1px solid ${Colors$1.Pigeon400};`,
    },
    height: {
        sm: 24,
        lg: 32,
    },
    width: {
        sm: 24,
        lg: 32,
    },
    fontSize: {
        sm: '12px',
        lg: '14px',
    },
    paddingTop: {
        sm: 12,
        lg: 12,
    },
    activeBorderColor: {
        sm: Colors$1.Transparent,
        lg: Colors$1.Electric700,
    },
};
styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: -1px;
  box-sizing: content-box;
  flex-shrink: 0;

  .styled-button.tertiary,
  .styled-button.tertiary .button-text {
    color: ${Colors$1.Pigeon700};
  }

  ${({ size }) => css `
    height: ${PAGINATION_STYLES.height[size]};
    padding-top: ${PAGINATION_STYLES.paddingTop[size]}px;
    ${PAGINATION_STYLES.border[size]}

    .styled-button .button-text {
      font-size: ${PAGINATION_STYLES.fontSize[size]};
    }

    .styled-button,
    .icon-button {
      height: ${PAGINATION_STYLES.height[size]}px;
      border-radius: 6px;
    }

    .icon-button {
      width: ${PAGINATION_STYLES.width[size]}px;
    }
  `}
`;
styled.div `
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: center;
  gap: 4px;

  .styled-button.tertiary .button-text {
    font-weight: 400;
  }

  .styled-button:disabled {
    opacity: 1;
  }

  ${({ size }) => css `
    .styled-button {
      min-width: ${PAGINATION_STYLES.width[size]}px;
      padding: 8px;
      position: relative;
      transition: background-color 0ms ease;

      // Remove the background color animation because it can cause an unwanted
      // flash when changing pages.
    }

    .styled-button::before {
      content: '';
      position: absolute;
      height: 2px;
      background-color: transparent;
      width: 100%;
      top: -${PAGINATION_STYLES.paddingTop[size] + 1}px;
    }

    .styled-button.secondary::before {
      background-color: ${PAGINATION_STYLES.activeBorderColor[size]};
    }
  `}
`;

const Pill = styled.div `
  ${getFont('actionSm')}
  ${({ $truncate }) => ($truncate ? truncated : '')}
  line-height: 16px;
  color: ${Colors$1.MidnightBrand};
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${Colors$1.Pigeon200};
  max-width: 150px;
`;
styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
`;

var PopoverAnimation;
(function (PopoverAnimation) {
    PopoverAnimation[PopoverAnimation["SlideUp"] = 0] = "SlideUp";
})(PopoverAnimation || (PopoverAnimation = {}));
const slideUpAnimation = keyframes `
  from {
    transform: translate(-50%, 300%)
  }
  to {
    transform: translate(-50%, -50%)
  }
`;
const slideUpStyle$1 = css `
  animation: ${slideUpAnimation} 0.3s linear;
`;
const PopoverContainer = styled.div `
  background-color: ${Colors$1.MidnightBrand};
  border-radius: 2px;
  box-shadow: 0 0 0 1px #0000000d, 0 4px 6px -2px #0000000d,
    0px 10px 15px -3px #0000001a;
  font-family: 'Proxima Nova', sans-serif;
  display: flex;
  max-width: 100%;
  width: 600px;
  position: fixed;
  left: 50%;
  bottom: 40px;
  transform: translate(-50%);
  z-index: ${ZIndex.level1000};
  flex-direction: column;
  transition: max-height 300ms ease-in, transform 300ms ease-in;
  max-height: ${(props) => props.maxHeight}px;
  ${(props) => {
    switch (props.animation) {
        case PopoverAnimation.SlideUp:
            return slideUpStyle$1;
        default:
            return;
    }
}};
`;
const PopoverSection = styled.div `
  justify-content: space-between;
  align-items: start;
  gap: 16px;
  flex-direction: row;
  display: flex;
  padding: 16px;
  color: white;
  font-size: 16px;

  ${({ expanded }) => expanded &&
    css `
      border-bottom: 1px solid ${Colors$1.Midnight500};
    `}
`;
const MessageContainer$1 = styled.div `
  display: flex;
  gap: 16px;
  align-items: center;
`;
const FlexIconContainer = styled.div `
  display: inline-flex;
`;
const ActionContainer$1 = styled.div `
  display: flex;
  align-items: start;
  gap: 21px;
`;
const Action = styled.span `
  text-decoration: underline;
  cursor: pointer;
`;
const CursorIcon = styled(Icon) `
  cursor: pointer;
`;
const RightContainer = styled.div `
  display: flex;
  gap: 8px;
  align-items: center;
`;
const ExpandToggle = styled(CursorIcon) `
  transform: ${(props) => !props.expanded && 'rotate(180deg)'};
`;
const ExpandContainer = styled.div `
  max-height: 300px;
  scrollbar-width: thin;
  scrollbar-color: ${Colors$1.Midnight300} ${Colors$1.Midnight700};
  overflow-y: scroll;
  padding-right: ${(props) => (props.scrollable ? '12px' : '0')};
`;
const PopoverAction = ({ action }) => {
    if (!action)
        return null;
    return jsx(Action, { onClick: action.onClick, children: action.label });
};
const PopoverIcon = ({ icon }) => (jsx(FlexIconContainer, { children: icon }));
const PopoverContent = ({ icon, message, action, }) => (jsxs(Fragment, { children: [jsxs(MessageContainer$1, { children: [icon && jsx(PopoverIcon, { icon: icon }), message] }), jsx(ActionContainer$1, { children: jsx(PopoverAction, { action: action }) })] }));
const Popover = ({ icon, message, action, onClose, animation, expandedContent, }) => {
    const [expanded, setExpanded] = useState(false);
    const [scrollable, setScrollable] = useState(false);
    const expandable = expandedContent?.length;
    const [maxHeight, setMaxHeight] = useState(0);
    const expandContainerRef = useRef(null);
    const topRef = useRef(null);
    useEffect(() => {
        if (expandContainerRef.current) {
            const containerHeight = expandContainerRef.current.scrollHeight;
            const isScrollable = containerHeight > maxHeight;
            setScrollable(isScrollable);
        }
    }, [expandedContent]);
    useEffect(() => {
        if (topRef.current) {
            const topHeight = topRef?.current?.offsetHeight;
            const expandedHeight = topHeight + 300;
            setMaxHeight(expanded ? expandedHeight : topHeight);
        }
    }, [expanded]);
    const toggleExpand = useCallback(() => setExpanded((prev) => !prev), [expanded]);
    return (jsxs(PopoverContainer, { animation: animation, "data-testid": 'popover', className: 'amp-popover', expanded: expanded, maxHeight: maxHeight, children: [jsxs(PopoverSection, { expanded: expanded, ref: topRef, children: [jsx(PopoverContent, { icon: icon, message: message }), jsxs(RightContainer, { children: [expandable ? (jsx(ExpandToggle, { name: 'chevronDown', onClick: toggleExpand, expanded: expanded })) : (jsx(PopoverAction, { action: action })), onClose && (jsx(CursorIcon, { name: 'xCircle', onClick: onClose, "data-testid": 'close-popover' }))] })] }), expandable && (jsx(ExpandContainer, { scrollable: scrollable, ref: expandContainerRef, children: expandedContent.map((item, index) => {
                    return (jsx(PopoverSection, { children: jsx(PopoverContent, { icon: item.icon, message: item.message, action: item.action }) }, index));
                }) }))] }));
};

styled.div `
  min-width: 320px;
  width: 100%;
  background-color: ${Colors$1.Electric200};
  border-radius: 30px;
  padding: 4px;
  position: relative;
  height: 21px;
`;
styled.div `
  width: ${({ progress }) => `${progress}%`};
  background-color: ${Colors$1.Electric700};
  border-radius: inherit;
  height: 13px;
  transition: 1s width;
`;
styled.div `
  width: 100%;
  height: 100%;
  position: relative;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: inherit;
`;
styled.div `
  @keyframes bounceEffect {
    0% {
      left: 0%;
      right: 100%;
      width: 0%;
    }
    25% {
      left: 0%;
      right: 50%;
      width: 50%;
    }
    75% {
      right: 0%;
      left: 50%;
      width: 50%;
    }
    100% {
      left: 100%;
      right: 0%;
      width: 0%;
    }
  }
  position: absolute;
  animation: bounceEffect 1s linear infinite;
  background-color: ${Colors$1.Electric700};
  border-radius: inherit;
  height: 13px;
  margin: 0 auto;
`;

styled.div `
  position: relative;

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 1px;
    background-color: var(--color-border);
  }
`;
styled.div `
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  gap: 0.75em;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;

  a {
    border-bottom: 2px solid transparent;
    cursor: pointer;
    color: var(--color-text-light);
    padding: 0.5em 0.75em;
    text-decoration: none;
    font-weight: 400;
    flex-shrink: 0;
    position: relative;
    max-width: 25%;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  a:hover {
    color: ${Colors$1.Pigeon800};
    border-color: ${Colors$1.Pigeon600};
  }

  a.active {
    border-color: 2px solid var(--color-action);
    color: var(--color-action);
    font-weight: 500;
  }
`;
styled.a `
  ${getFont('b1')}
  font-weight: 400 !important;
  padding: 0px 4px 16px 4px !important;
`;

var ToastAnimation;
(function (ToastAnimation) {
    ToastAnimation[ToastAnimation["SlideIn"] = 0] = "SlideIn";
})(ToastAnimation || (ToastAnimation = {}));
const slideInAnimation = keyframes `
  from {
    transform: translate(300% , 0)
  }
  to {
    transform: translate(0, 0)
  }
`;
const slideUpStyle = css `
  animation: ${slideInAnimation} 0.3s linear;
`;
const ToastContainer = styled.div `
  background-color: ${Colors$1.MidnightBrand};
  border-radius: 2px;
  box-shadow: 0 0 0 1px #0000000d, 0 4px 6px -2px #0000000d,
    0px 10px 15px -3px #0000001a;
  color: white;
  line-height: 1.5;
  font-size: 16px;
  font-family: 'Proxima Nova', sans-serif;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 350px;
  position: fixed;
  right: 42px;
  top: 90px;
  padding: 16px;
  z-index: ${ZIndex.level1000};

  ${(props) => {
    switch (props.animation) {
        case ToastAnimation.SlideIn:
            return slideUpStyle;
        default:
            return;
    }
}}
`;
const MessageContainer = styled.div `
  display: flex;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  overflow-wrap: break-word;
`;
const SubMessageContainer = styled.div `
  display: flex;
  color: ${Colors$1.Pigeon400};
  font-size: 14px;
  font-weight: 400;
  overflow-wrap: break-word;
`;
const ActionContainer = styled.div `
  display: flex;
  font-size: 14px;
  font-weight: 400;
  a {
    color: white;
  }
`;
const CloseIcon = styled(Icon) `
  cursor: pointer;
`;
const HeadingContainer = styled.div `
  display: flex;
  justify-content: space-between;
`;
const Toast = ({ heading, message, action, onClose, animation, }) => {
    return (jsxs(ToastContainer, { animation: animation, "data-testid": 'toast', children: [jsxs(HeadingContainer, { children: [jsx(MessageContainer, { children: heading }), jsx(ActionContainer, { children: onClose && (jsx(CloseIcon, { name: 'cross', size: 16, onClick: onClose, "data-testid": 'close-toast' })) })] }), message && jsx(SubMessageContainer, { children: message }), action && jsx(ActionContainer, { children: action })] }));
};

const Checkbox = styled.input.attrs({ type: 'checkbox' }) `
  height: 0;
  width: 0;
  visibility: hidden;
`;
const Label = styled.label `
  cursor: pointer;
  top: 0;
  left: 0;
  text-indent: -9999px;
  width: 30px;
  height: 16px;
  background: ${Colors$1.Pigeon400};
  display: block;
  border-radius: 100px;
  position: absolute;
  transition: background-color 0.3s;

  ::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 1px;
    width: 14px;
    height: 14px;
    border-radius: 45px;
    transition: 0.3s;
    background: #ffffff;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
  }
`;
styled.div `
  display: inline-block;
  height: 16px;
  position: relative;
  width: 30px;

  ${Checkbox}:checked + ${Label} {
    background: ${({ checkedColor = Colors$1.Pinata800 }) => checkedColor};

    ::after {
      left: calc(100% - 1px);
      transform: translateX(-100%);
    }
  }

  ${Label}:active::after {
    width: 20px;
  }
`;

var lodash_isequal = {exports: {}};

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);

	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;

	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;

	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}

	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}

	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);

	  this.size = data.size;
	  return result;
	}

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}

	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}

	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);

	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;

	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;

	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;

	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;

	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

	  stack.set(array, other);
	  stack.set(other, array);

	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}

	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;

	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;

	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);

	    case errorTag:
	      return object.name == other.name && object.message == other.message;

	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');

	    case mapTag:
	      var convert = mapToArray;

	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);

	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;

	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;

	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}

	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);

	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;

	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];

	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}

	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;

	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	  return value === proto;
	}

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}

	module.exports = isEqual;
} (lodash_isequal, lodash_isequal.exports));

lodash_isequal.exports;

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

var __create$1 = Object.create;
var __defProp$2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames$2 = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf$1 = Object.getPrototypeOf;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames$2(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export$2 = (target, all) => {
  for (var name in all)
    __defProp$2(target, name, { get: all[name], enumerable: true });
};
var __copyProps$2 = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames$2(from))
      if (!__hasOwnProp$2.call(to, key) && key !== except)
        __defProp$2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc$2(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM$1 = (mod, isNodeMode, target) => (target = mod != null ? __create$1(__getProtoOf$1(mod)) : {}, __copyProps$2(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp$2(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js
var require_prism = __commonJS({
  "../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js"(exports, module) {
    var Prism2 = function() {
      var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
      var uniqueId = 0;
      var plainTextGrammar = {};
      var _ = {
        /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */
        util: {
          encode: function encode(tokens) {
            if (tokens instanceof Token) {
              return new Token(tokens.type, encode(tokens.content), tokens.alias);
            } else if (Array.isArray(tokens)) {
              return tokens.map(encode);
            } else {
              return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            }
          },
          /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */
          type: function(o) {
            return Object.prototype.toString.call(o).slice(8, -1);
          },
          /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */
          objId: function(obj) {
            if (!obj["__id"]) {
              Object.defineProperty(obj, "__id", { value: ++uniqueId });
            }
            return obj["__id"];
          },
          /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */
          clone: function deepClone(o, visited) {
            visited = visited || {};
            var clone;
            var id;
            switch (_.util.type(o)) {
              case "Object":
                id = _.util.objId(o);
                if (visited[id]) {
                  return visited[id];
                }
                clone = /** @type {Record<string, any>} */
                {};
                visited[id] = clone;
                for (var key in o) {
                  if (o.hasOwnProperty(key)) {
                    clone[key] = deepClone(o[key], visited);
                  }
                }
                return (
                  /** @type {any} */
                  clone
                );
              case "Array":
                id = _.util.objId(o);
                if (visited[id]) {
                  return visited[id];
                }
                clone = [];
                visited[id] = clone;
                /** @type {Array} */
                /** @type {any} */
                o.forEach(function(v, i) {
                  clone[i] = deepClone(v, visited);
                });
                return (
                  /** @type {any} */
                  clone
                );
              default:
                return o;
            }
          },
          /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */
          getLanguage: function(element) {
            while (element) {
              var m = lang.exec(element.className);
              if (m) {
                return m[1].toLowerCase();
              }
              element = element.parentElement;
            }
            return "none";
          },
          /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */
          setLanguage: function(element, language) {
            element.className = element.className.replace(RegExp(lang, "gi"), "");
            element.classList.add("language-" + language);
          },
          /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */
          isActive: function(element, className, defaultActivation) {
            var no = "no-" + className;
            while (element) {
              var classList = element.classList;
              if (classList.contains(className)) {
                return true;
              }
              if (classList.contains(no)) {
                return false;
              }
              element = element.parentElement;
            }
            return !!defaultActivation;
          }
        },
        /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */
        languages: {
          /**
           * The grammar for plain, unformatted text.
           */
          plain: plainTextGrammar,
          plaintext: plainTextGrammar,
          text: plainTextGrammar,
          txt: plainTextGrammar,
          /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */
          extend: function(id, redef) {
            var lang2 = _.util.clone(_.languages[id]);
            for (var key in redef) {
              lang2[key] = redef[key];
            }
            return lang2;
          },
          /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */
          insertBefore: function(inside, before, insert, root) {
            root = root || /** @type {any} */
            _.languages;
            var grammar = root[inside];
            var ret = {};
            for (var token in grammar) {
              if (grammar.hasOwnProperty(token)) {
                if (token == before) {
                  for (var newToken in insert) {
                    if (insert.hasOwnProperty(newToken)) {
                      ret[newToken] = insert[newToken];
                    }
                  }
                }
                if (!insert.hasOwnProperty(token)) {
                  ret[token] = grammar[token];
                }
              }
            }
            var old = root[inside];
            root[inside] = ret;
            _.languages.DFS(_.languages, function(key, value) {
              if (value === old && key != inside) {
                this[key] = ret;
              }
            });
            return ret;
          },
          // Traverse a language definition with Depth First Search
          DFS: function DFS(o, callback, type, visited) {
            visited = visited || {};
            var objId = _.util.objId;
            for (var i in o) {
              if (o.hasOwnProperty(i)) {
                callback.call(o, i, o[i], type || i);
                var property = o[i];
                var propertyType = _.util.type(property);
                if (propertyType === "Object" && !visited[objId(property)]) {
                  visited[objId(property)] = true;
                  DFS(property, callback, null, visited);
                } else if (propertyType === "Array" && !visited[objId(property)]) {
                  visited[objId(property)] = true;
                  DFS(property, callback, i, visited);
                }
              }
            }
          }
        },
        plugins: {},
        /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */
        highlight: function(text, grammar, language) {
          var env = {
            code: text,
            grammar,
            language
          };
          _.hooks.run("before-tokenize", env);
          if (!env.grammar) {
            throw new Error('The language "' + env.language + '" has no grammar.');
          }
          env.tokens = _.tokenize(env.code, env.grammar);
          _.hooks.run("after-tokenize", env);
          return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */
        tokenize: function(text, grammar) {
          var rest = grammar.rest;
          if (rest) {
            for (var token in rest) {
              grammar[token] = rest[token];
            }
            delete grammar.rest;
          }
          var tokenList = new LinkedList();
          addAfter(tokenList, tokenList.head, text);
          matchGrammar(text, tokenList, grammar, tokenList.head, 0);
          return toArray(tokenList);
        },
        /**
         * @namespace
         * @memberof Prism
         * @public
         */
        hooks: {
          all: {},
          /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */
          add: function(name, callback) {
            var hooks2 = _.hooks.all;
            hooks2[name] = hooks2[name] || [];
            hooks2[name].push(callback);
          },
          /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */
          run: function(name, env) {
            var callbacks = _.hooks.all[name];
            if (!callbacks || !callbacks.length) {
              return;
            }
            for (var i = 0, callback; callback = callbacks[i++]; ) {
              callback(env);
            }
          }
        },
        Token
      };
      function Token(type, content, alias, matchedStr) {
        this.type = type;
        this.content = content;
        this.alias = alias;
        this.length = (matchedStr || "").length | 0;
      }
      Token.stringify = function stringify(o, language) {
        if (typeof o == "string") {
          return o;
        }
        if (Array.isArray(o)) {
          var s = "";
          o.forEach(function(e) {
            s += stringify(e, language);
          });
          return s;
        }
        var env = {
          type: o.type,
          content: stringify(o.content, language),
          tag: "span",
          classes: ["token", o.type],
          attributes: {},
          language
        };
        var aliases = o.alias;
        if (aliases) {
          if (Array.isArray(aliases)) {
            Array.prototype.push.apply(env.classes, aliases);
          } else {
            env.classes.push(aliases);
          }
        }
        _.hooks.run("wrap", env);
        var attributes = "";
        for (var name in env.attributes) {
          attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
        }
        return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
      };
      function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
          var lookbehindLength = match[1].length;
          match.index += lookbehindLength;
          match[0] = match[0].slice(lookbehindLength);
        }
        return match;
      }
      function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for (var token in grammar) {
          if (!grammar.hasOwnProperty(token) || !grammar[token]) {
            continue;
          }
          var patterns = grammar[token];
          patterns = Array.isArray(patterns) ? patterns : [patterns];
          for (var j = 0; j < patterns.length; ++j) {
            if (rematch && rematch.cause == token + "," + j) {
              return;
            }
            var patternObj = patterns[j];
            var inside = patternObj.inside;
            var lookbehind = !!patternObj.lookbehind;
            var greedy = !!patternObj.greedy;
            var alias = patternObj.alias;
            if (greedy && !patternObj.pattern.global) {
              var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
              patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
            }
            var pattern = patternObj.pattern || patternObj;
            for (var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next) {
              if (rematch && pos >= rematch.reach) {
                break;
              }
              var str = currentNode.value;
              if (tokenList.length > text.length) {
                return;
              }
              if (str instanceof Token) {
                continue;
              }
              var removeCount = 1;
              var match;
              if (greedy) {
                match = matchPattern(pattern, pos, text, lookbehind);
                if (!match || match.index >= text.length) {
                  break;
                }
                var from = match.index;
                var to = match.index + match[0].length;
                var p = pos;
                p += currentNode.value.length;
                while (from >= p) {
                  currentNode = currentNode.next;
                  p += currentNode.value.length;
                }
                p -= currentNode.value.length;
                pos = p;
                if (currentNode.value instanceof Token) {
                  continue;
                }
                for (var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next) {
                  removeCount++;
                  p += k.value.length;
                }
                removeCount--;
                str = text.slice(pos, p);
                match.index -= pos;
              } else {
                match = matchPattern(pattern, 0, str, lookbehind);
                if (!match) {
                  continue;
                }
              }
              var from = match.index;
              var matchStr = match[0];
              var before = str.slice(0, from);
              var after = str.slice(from + matchStr.length);
              var reach = pos + str.length;
              if (rematch && reach > rematch.reach) {
                rematch.reach = reach;
              }
              var removeFrom = currentNode.prev;
              if (before) {
                removeFrom = addAfter(tokenList, removeFrom, before);
                pos += before.length;
              }
              removeRange(tokenList, removeFrom, removeCount);
              var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
              currentNode = addAfter(tokenList, removeFrom, wrapped);
              if (after) {
                addAfter(tokenList, currentNode, after);
              }
              if (removeCount > 1) {
                var nestedRematch = {
                  cause: token + "," + j,
                  reach
                };
                matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                if (rematch && nestedRematch.reach > rematch.reach) {
                  rematch.reach = nestedRematch.reach;
                }
              }
            }
          }
        }
      }
      function LinkedList() {
        var head = { value: null, prev: null, next: null };
        var tail = { value: null, prev: head, next: null };
        head.next = tail;
        this.head = head;
        this.tail = tail;
        this.length = 0;
      }
      function addAfter(list, node, value) {
        var next = node.next;
        var newNode = { value, prev: node, next };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
      }
      function removeRange(list, node, count) {
        var next = node.next;
        for (var i = 0; i < count && next !== list.tail; i++) {
          next = next.next;
        }
        node.next = next;
        next.prev = node;
        list.length -= i;
      }
      function toArray(list) {
        var array = [];
        var node = list.head.next;
        while (node !== list.tail) {
          array.push(node.value);
          node = node.next;
        }
        return array;
      }
      return _;
    }();
    module.exports = Prism2;
    Prism2.default = Prism2;
  }
});

// src/prism-langs.ts
var Prism = __toESM$1(require_prism());
!function(e) {
  var n = { pattern: /\\[\\(){}[\]^$+*?|.]/, alias: "escape" }, t = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, a = "(?:[^\\\\-]|" + t.source + ")", a = RegExp(a + "-" + a), r = { pattern: /(<|')[^<>']+(?=[>']$)/, lookbehind: true, alias: "variable" };
  e.languages.regex = { "char-class": { pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/, lookbehind: true, inside: { "char-class-negation": { pattern: /(^\[)\^/, lookbehind: true, alias: "operator" }, "char-class-punctuation": { pattern: /^\[|\]$/, alias: "punctuation" }, range: { pattern: a, inside: { escape: t, "range-punctuation": { pattern: /-/, alias: "operator" } } }, "special-escape": n, "char-set": { pattern: /\\[wsd]|\\p\{[^{}]+\}/i, alias: "class-name" }, escape: t } }, "special-escape": n, "char-set": { pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i, alias: "class-name" }, backreference: [{ pattern: /\\(?![123][0-7]{2})[1-9]/, alias: "keyword" }, { pattern: /\\k<[^<>']+>/, alias: "keyword", inside: { "group-name": r } }], anchor: { pattern: /[$^]|\\[ABbGZz]/, alias: "function" }, escape: t, group: [{ pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/, alias: "punctuation", inside: { "group-name": r } }, { pattern: /\)/, alias: "punctuation" }], quantifier: { pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/, alias: "number" }, alternation: { pattern: /\|/, alias: "keyword" } };
}(Prism), Prism.languages.clike = { comment: [{ pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/, lookbehind: true, greedy: true }, { pattern: /(^|[^\\:])\/\/.*/, lookbehind: true, greedy: true }], string: { pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, greedy: true }, "class-name": { pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i, lookbehind: true, inside: { punctuation: /[.\\]/ } }, keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/, boolean: /\b(?:false|true)\b/, function: /\b\w+(?=\()/, number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i, operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/, punctuation: /[{}[\];(),.:]/ }, Prism.languages.javascript = Prism.languages.extend("clike", { "class-name": [Prism.languages.clike["class-name"], { pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/, lookbehind: true }], keyword: [{ pattern: /((?:^|\})\s*)catch\b/, lookbehind: true }, { pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/, lookbehind: true }], function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/, number: { pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source), lookbehind: true }, operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/ }), Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, Prism.languages.insertBefore("javascript", "keyword", { regex: { pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source), lookbehind: true, greedy: true, inside: { "regex-source": { pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/, lookbehind: true, alias: "language-regex", inside: Prism.languages.regex }, "regex-delimiter": /^\/|\/$/, "regex-flags": /^[a-z]+$/ } }, "function-variable": { pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/, alias: "function" }, parameter: [{ pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/, lookbehind: true, inside: Prism.languages.javascript }, { pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i, lookbehind: true, inside: Prism.languages.javascript }, { pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/, lookbehind: true, inside: Prism.languages.javascript }, { pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/, lookbehind: true, inside: Prism.languages.javascript }], constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/ }), Prism.languages.insertBefore("javascript", "string", { hashbang: { pattern: /^#!.*/, greedy: true, alias: "comment" }, "template-string": { pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/, greedy: true, inside: { "template-punctuation": { pattern: /^`|`$/, alias: "string" }, interpolation: { pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/, lookbehind: true, inside: { "interpolation-punctuation": { pattern: /^\$\{|\}$/, alias: "punctuation" }, rest: Prism.languages.javascript } }, string: /[\s\S]+/ } }, "string-property": { pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m, lookbehind: true, greedy: true, alias: "property" } }), Prism.languages.insertBefore("javascript", "operator", { "literal-property": { pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m, lookbehind: true, alias: "property" } }), Prism.languages.markup && (Prism.languages.markup.tag.addInlined("script", "javascript"), Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), Prism.languages.js = Prism.languages.javascript, Prism.languages.actionscript = Prism.languages.extend("javascript", { keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/, operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/ }), Prism.languages.actionscript["class-name"].alias = "function", delete Prism.languages.actionscript.parameter, delete Prism.languages.actionscript["literal-property"], Prism.languages.markup && Prism.languages.insertBefore("actionscript", "string", { xml: { pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/, lookbehind: true, inside: Prism.languages.markup } }), function(e) {
  var n = /#(?!\{).+/, t = { pattern: /#\{[^}]+\}/, alias: "variable" };
  e.languages.coffeescript = e.languages.extend("javascript", { comment: n, string: [{ pattern: /'(?:\\[\s\S]|[^\\'])*'/, greedy: true }, { pattern: /"(?:\\[\s\S]|[^\\"])*"/, greedy: true, inside: { interpolation: t } }], keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/, "class-member": { pattern: /@(?!\d)\w+/, alias: "variable" } }), e.languages.insertBefore("coffeescript", "comment", { "multiline-comment": { pattern: /###[\s\S]+?###/, alias: "comment" }, "block-regex": { pattern: /\/{3}[\s\S]*?\/{3}/, alias: "regex", inside: { comment: n, interpolation: t } } }), e.languages.insertBefore("coffeescript", "string", { "inline-javascript": { pattern: /`(?:\\[\s\S]|[^\\`])*`/, inside: { delimiter: { pattern: /^`|`$/, alias: "punctuation" }, script: { pattern: /[\s\S]+/, alias: "language-javascript", inside: e.languages.javascript } } }, "multiline-string": [{ pattern: /'''[\s\S]*?'''/, greedy: true, alias: "string" }, { pattern: /"""[\s\S]*?"""/, greedy: true, alias: "string", inside: { interpolation: t } }] }), e.languages.insertBefore("coffeescript", "keyword", { property: /(?!\d)\w+(?=\s*:(?!:))/ }), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
}(Prism), function(l) {
  var e = l.languages.javadoclike = { parameter: { pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m, lookbehind: true }, keyword: { pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m, lookbehind: true }, punctuation: /[{}]/ };
  Object.defineProperty(e, "addSupport", { value: function(e2, o) {
    (e2 = "string" == typeof e2 ? [e2] : e2).forEach(function(e3) {
      var n = function(e4) {
        e4.inside || (e4.inside = {}), e4.inside.rest = o;
      }, t = "doc-comment";
      if (a = l.languages[e3]) {
        var a, r = a[t];
        if ((r = r ? r : (a = l.languages.insertBefore(e3, "comment", { "doc-comment": { pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/, lookbehind: true, alias: "comment" } }))[t]) instanceof RegExp && (r = a[t] = { pattern: r }), Array.isArray(r))
          for (var s = 0, i = r.length; s < i; s++)
            r[s] instanceof RegExp && (r[s] = { pattern: r[s] }), n(r[s]);
        else
          n(r);
      }
    });
  } }), e.addSupport(["java", "javascript", "php"], e);
}(Prism), function(e) {
  var n = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/, n = (e.languages.css = { comment: /\/\*[\s\S]*?\*\//, atrule: { pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + n.source + ")*?" + /(?:;|(?=\s*\{))/.source), inside: { rule: /^@[\w-]+/, "selector-function-argument": { pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/, lookbehind: true, alias: "selector" }, keyword: { pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/, lookbehind: true } } }, url: { pattern: RegExp("\\burl\\((?:" + n.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"), greedy: true, inside: { function: /^url/i, punctuation: /^\(|\)$/, string: { pattern: RegExp("^" + n.source + "$"), alias: "url" } } }, selector: { pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + n.source + ")*(?=\\s*\\{)"), lookbehind: true }, string: { pattern: n, greedy: true }, property: { pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i, lookbehind: true }, important: /!important\b/i, function: { pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i, lookbehind: true }, punctuation: /[(){};:,]/ }, e.languages.css.atrule.inside.rest = e.languages.css, e.languages.markup);
  n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
}(Prism), function(e) {
  var n = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, n = (e.languages.css.selector = { pattern: e.languages.css.selector.pattern, lookbehind: true, inside: n = { "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/, "pseudo-class": /:[-\w]+/, class: /\.[-\w]+/, id: /#[-\w]+/, attribute: { pattern: RegExp(`\\[(?:[^[\\]"']|` + n.source + ")*\\]"), greedy: true, inside: { punctuation: /^\[|\]$/, "case-sensitivity": { pattern: /(\s)[si]$/i, lookbehind: true, alias: "keyword" }, namespace: { pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/, lookbehind: true, inside: { punctuation: /\|$/ } }, "attr-name": { pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/, lookbehind: true }, "attr-value": [n, { pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/, lookbehind: true }], operator: /[|~*^$]?=/ } }, "n-th": [{ pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/, lookbehind: true, inside: { number: /[\dn]+/, operator: /[+-]/ } }, { pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i, lookbehind: true }], combinator: />|\+|~|\|\|/, punctuation: /[(),]/ } }, e.languages.css.atrule.inside["selector-function-argument"].inside = n, e.languages.insertBefore("css", "property", { variable: { pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i, lookbehind: true } }), { pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/, lookbehind: true }), t = { pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/, lookbehind: true };
  e.languages.insertBefore("css", "function", { operator: { pattern: /(\s)[+\-*\/](?=\s)/, lookbehind: true }, hexcode: { pattern: /\B#[\da-f]{3,8}\b/i, alias: "color" }, color: [{ pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i, lookbehind: true }, { pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i, inside: { unit: n, number: t, function: /[\w-]+(?=\()/, punctuation: /[(),]/ } }], entity: /\\[\da-f]{1,8}/i, unit: n, number: t });
}(Prism), function(e) {
  var n = /[*&][^\s[\]{},]+/, t = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, a = "(?:" + t.source + "(?:[ 	]+" + n.source + ")?|" + n.source + "(?:[ 	]+" + t.source + ")?)", r = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
    return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
  }), s = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
  function i(e2, n2) {
    n2 = (n2 || "").replace(/m/g, "") + "m";
    var t2 = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
      return a;
    }).replace(/<<value>>/g, function() {
      return e2;
    });
    return RegExp(t2, n2);
  }
  e.languages.yaml = { scalar: { pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
    return a;
  })), lookbehind: true, alias: "string" }, comment: /#.*/, key: { pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
    return a;
  }).replace(/<<key>>/g, function() {
    return "(?:" + r + "|" + s + ")";
  })), lookbehind: true, greedy: true, alias: "atrule" }, directive: { pattern: /(^[ \t]*)%.+/m, lookbehind: true, alias: "important" }, datetime: { pattern: i(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source), lookbehind: true, alias: "number" }, boolean: { pattern: i(/false|true/.source, "i"), lookbehind: true, alias: "important" }, null: { pattern: i(/null|~/.source, "i"), lookbehind: true, alias: "important" }, string: { pattern: i(s), lookbehind: true, greedy: true }, number: { pattern: i(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"), lookbehind: true }, tag: t, important: n, punctuation: /---|[:[\]{}\-,|>?]|\.\.\./ }, e.languages.yml = e.languages.yaml;
}(Prism), Prism.languages.markup = { comment: { pattern: /<!--(?:(?!<!--)[\s\S])*?-->/, greedy: true }, prolog: { pattern: /<\?[\s\S]+?\?>/, greedy: true }, doctype: { pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i, greedy: true, inside: { "internal-subset": { pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/, lookbehind: true, greedy: true, inside: null }, string: { pattern: /"[^"]*"|'[^']*'/, greedy: true }, punctuation: /^<!|>$|[[\]]/, "doctype-tag": /^DOCTYPE/i, name: /[^\s<>'"]+/ } }, cdata: { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, greedy: true }, tag: { pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/, greedy: true, inside: { tag: { pattern: /^<\/?[^\s>\/]+/, inside: { punctuation: /^<\/?/, namespace: /^[^\s>\/:]+:/ } }, "special-attr": [], "attr-value": { pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/, inside: { punctuation: [{ pattern: /^=/, alias: "attr-equals" }, { pattern: /^(\s*)["']|["']$/, lookbehind: true }] } }, punctuation: /\/?>/, "attr-name": { pattern: /[^\s>\/]+/, inside: { namespace: /^[^\s>\/:]+:/ } } } }, entity: [{ pattern: /&[\da-z]{1,8};/i, alias: "named-entity" }, /&#x?[\da-f]{1,8};/i] }, Prism.languages.markup.tag.inside["attr-value"].inside.entity = Prism.languages.markup.entity, Prism.languages.markup.doctype.inside["internal-subset"].inside = Prism.languages.markup, Prism.hooks.add("wrap", function(e) {
  "entity" === e.type && (e.attributes.title = e.content.replace(/&amp;/, "&"));
}), Object.defineProperty(Prism.languages.markup.tag, "addInlined", { value: function(e, n) {
  var t = {}, t = (t["language-" + n] = { pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i, lookbehind: true, inside: Prism.languages[n] }, t.cdata = /^<!\[CDATA\[|\]\]>$/i, { "included-cdata": { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, inside: t } }), n = (t["language-" + n] = { pattern: /[\s\S]+/, inside: Prism.languages[n] }, {});
  n[e] = { pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
    return e;
  }), "i"), lookbehind: true, greedy: true, inside: t }, Prism.languages.insertBefore("markup", "cdata", n);
} }), Object.defineProperty(Prism.languages.markup.tag, "addAttribute", { value: function(e, n) {
  Prism.languages.markup.tag.inside["special-attr"].push({ pattern: RegExp(/(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"), lookbehind: true, inside: { "attr-name": /^[^\s=]+/, "attr-value": { pattern: /=[\s\S]+/, inside: { value: { pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/, lookbehind: true, alias: [n, "language-" + n], inside: Prism.languages[n] }, punctuation: [{ pattern: /^=/, alias: "attr-equals" }, /"|'/] } } } });
} }), Prism.languages.html = Prism.languages.markup, Prism.languages.mathml = Prism.languages.markup, Prism.languages.svg = Prism.languages.markup, Prism.languages.xml = Prism.languages.extend("markup", {}), Prism.languages.ssml = Prism.languages.xml, Prism.languages.atom = Prism.languages.xml, Prism.languages.rss = Prism.languages.xml, function(o) {
  var n = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
  function e(e2) {
    return e2 = e2.replace(/<inner>/g, function() {
      return n;
    }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + e2 + ")");
  }
  var t = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, a = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
    return t;
  }), r = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source, l = (o.languages.markdown = o.languages.extend("markup", {}), o.languages.insertBefore("markdown", "prolog", { "front-matter-block": { pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/, lookbehind: true, greedy: true, inside: { punctuation: /^---|---$/, "front-matter": { pattern: /\S+(?:\s+\S+)*/, alias: ["yaml", "language-yaml"], inside: o.languages.yaml } } }, blockquote: { pattern: /^>(?:[\t ]*>)*/m, alias: "punctuation" }, table: { pattern: RegExp("^" + a + r + "(?:" + a + ")*", "m"), inside: { "table-data-rows": { pattern: RegExp("^(" + a + r + ")(?:" + a + ")*$"), lookbehind: true, inside: { "table-data": { pattern: RegExp(t), inside: o.languages.markdown }, punctuation: /\|/ } }, "table-line": { pattern: RegExp("^(" + a + ")" + r + "$"), lookbehind: true, inside: { punctuation: /\||:?-{3,}:?/ } }, "table-header-row": { pattern: RegExp("^" + a + "$"), inside: { "table-header": { pattern: RegExp(t), alias: "important", inside: o.languages.markdown }, punctuation: /\|/ } } } }, code: [{ pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/, lookbehind: true, alias: "keyword" }, { pattern: /^```[\s\S]*?^```$/m, greedy: true, inside: { "code-block": { pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m, lookbehind: true }, "code-language": { pattern: /^(```).+/, lookbehind: true }, punctuation: /```/ } }], title: [{ pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m, alias: "important", inside: { punctuation: /==+$|--+$/ } }, { pattern: /(^\s*)#.+/m, lookbehind: true, alias: "important", inside: { punctuation: /^#+|#+$/ } }], hr: { pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m, lookbehind: true, alias: "punctuation" }, list: { pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m, lookbehind: true, alias: "punctuation" }, "url-reference": { pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/, inside: { variable: { pattern: /^(!?\[)[^\]]+/, lookbehind: true }, string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/, punctuation: /^[\[\]!:]|[<>]/ }, alias: "url" }, bold: { pattern: e(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source), lookbehind: true, greedy: true, inside: { content: { pattern: /(^..)[\s\S]+(?=..$)/, lookbehind: true, inside: {} }, punctuation: /\*\*|__/ } }, italic: { pattern: e(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source), lookbehind: true, greedy: true, inside: { content: { pattern: /(^.)[\s\S]+(?=.$)/, lookbehind: true, inside: {} }, punctuation: /[*_]/ } }, strike: { pattern: e(/(~~?)(?:(?!~)<inner>)+\2/.source), lookbehind: true, greedy: true, inside: { content: { pattern: /(^~~?)[\s\S]+(?=\1$)/, lookbehind: true, inside: {} }, punctuation: /~~?/ } }, "code-snippet": { pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/, lookbehind: true, greedy: true, alias: ["code", "keyword"] }, url: { pattern: e(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source), lookbehind: true, greedy: true, inside: { operator: /^!/, content: { pattern: /(^\[)[^\]]+(?=\])/, lookbehind: true, inside: {} }, variable: { pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/, lookbehind: true }, url: { pattern: /(^\]\()[^\s)]+/, lookbehind: true }, string: { pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/, lookbehind: true } } } }), ["url", "bold", "italic", "strike"].forEach(function(n2) {
    ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(e2) {
      n2 !== e2 && (o.languages.markdown[n2].inside.content.inside[e2] = o.languages.markdown[e2]);
    });
  }), o.hooks.add("after-tokenize", function(e2) {
    "markdown" !== e2.language && "md" !== e2.language || !function e3(n2) {
      if (n2 && "string" != typeof n2)
        for (var t2 = 0, a2 = n2.length; t2 < a2; t2++) {
          var r2, s = n2[t2];
          "code" !== s.type ? e3(s.content) : (r2 = s.content[1], s = s.content[3], r2 && s && "code-language" === r2.type && "code-block" === s.type && "string" == typeof r2.content && (r2 = r2.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), r2 = "language-" + (r2 = (/[a-z][\w-]*/i.exec(r2) || [""])[0].toLowerCase()), s.alias ? "string" == typeof s.alias ? s.alias = [s.alias, r2] : s.alias.push(r2) : s.alias = [r2]));
        }
    }(e2.tokens);
  }), o.hooks.add("wrap", function(e2) {
    if ("code-block" === e2.type) {
      for (var n2 = "", t2 = 0, a2 = e2.classes.length; t2 < a2; t2++) {
        var r2 = e2.classes[t2], r2 = /language-(.+)/.exec(r2);
        if (r2) {
          n2 = r2[1];
          break;
        }
      }
      var s, i = o.languages[n2];
      i ? e2.content = o.highlight(function(e3) {
        e3 = e3.replace(l, "");
        return e3 = e3.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(e4, n3) {
          var t3;
          return "#" === (n3 = n3.toLowerCase())[0] ? (t3 = "x" === n3[1] ? parseInt(n3.slice(2), 16) : Number(n3.slice(1)), c(t3)) : u[n3] || e4;
        });
      }(e2.content), i, n2) : n2 && "none" !== n2 && o.plugins.autoloader && (s = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(1e16 * Math.random()), e2.attributes.id = s, o.plugins.autoloader.loadLanguages(n2, function() {
        var e3 = document.getElementById(s);
        e3 && (e3.innerHTML = o.highlight(e3.textContent, o.languages[n2], n2));
      }));
    }
  }), RegExp(o.languages.markup.tag.pattern.source, "gi")), u = { amp: "&", lt: "<", gt: ">", quot: '"' }, c = String.fromCodePoint || String.fromCharCode;
  o.languages.md = o.languages.markdown;
}(Prism), Prism.languages.graphql = { comment: /#.*/, description: { pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i, greedy: true, alias: "string", inside: { "language-markdown": { pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/, lookbehind: true, inside: Prism.languages.markdown } } }, string: { pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/, greedy: true }, number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i, boolean: /\b(?:false|true)\b/, variable: /\$[a-z_]\w*/i, directive: { pattern: /@[a-z_]\w*/i, alias: "function" }, "attr-name": { pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i, greedy: true }, "atom-input": { pattern: /\b[A-Z]\w*Input\b/, alias: "class-name" }, scalar: /\b(?:Boolean|Float|ID|Int|String)\b/, constant: /\b[A-Z][A-Z_\d]*\b/, "class-name": { pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/, lookbehind: true }, fragment: { pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/, lookbehind: true, alias: "function" }, "definition-mutation": { pattern: /(\bmutation\s+)[a-zA-Z_]\w*/, lookbehind: true, alias: "function" }, "definition-query": { pattern: /(\bquery\s+)[a-zA-Z_]\w*/, lookbehind: true, alias: "function" }, keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/, operator: /[!=|&]|\.{3}/, "property-query": /\w+(?=\s*\()/, object: /\w+(?=\s*\{)/, punctuation: /[!(){}\[\]:=,]/, property: /\w+/ }, Prism.hooks.add("after-tokenize", function(e) {
  if ("graphql" === e.language)
    for (var i = e.tokens.filter(function(e2) {
      return "string" != typeof e2 && "comment" !== e2.type && "scalar" !== e2.type;
    }), o = 0; o < i.length; ) {
      var n = i[o++];
      if ("keyword" === n.type && "mutation" === n.content) {
        var t = [];
        if (p(["definition-mutation", "punctuation"]) && "(" === c(1).content) {
          o += 2;
          var a = d(/^\($/, /^\)$/);
          if (-1 === a)
            continue;
          for (; o < a; o++) {
            var r = c(0);
            "variable" === r.type && (g(r, "variable-input"), t.push(r.content));
          }
          o = a + 1;
        }
        if (p(["punctuation", "property-query"]) && "{" === c(0).content && (o++, g(c(0), "property-mutation"), 0 < t.length)) {
          var s = d(/^\{$/, /^\}$/);
          if (-1 !== s)
            for (var l = o; l < s; l++) {
              var u = i[l];
              "variable" === u.type && 0 <= t.indexOf(u.content) && g(u, "variable-input");
            }
        }
      }
    }
  function c(e2) {
    return i[o + e2];
  }
  function p(e2, n2) {
    n2 = n2 || 0;
    for (var t2 = 0; t2 < e2.length; t2++) {
      var a2 = c(t2 + n2);
      if (!a2 || a2.type !== e2[t2])
        return;
    }
    return 1;
  }
  function d(e2, n2) {
    for (var t2 = 1, a2 = o; a2 < i.length; a2++) {
      var r2 = i[a2], s2 = r2.content;
      if ("punctuation" === r2.type && "string" == typeof s2) {
        if (e2.test(s2))
          t2++;
        else if (n2.test(s2) && 0 === --t2)
          return a2;
      }
    }
    return -1;
  }
  function g(e2, n2) {
    var t2 = e2.alias;
    t2 ? Array.isArray(t2) || (e2.alias = t2 = [t2]) : e2.alias = t2 = [], t2.push(n2);
  }
}), Prism.languages.sql = { comment: { pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/, lookbehind: true }, variable: [{ pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/, greedy: true }, /@[\w.$]+/], string: { pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/, greedy: true, lookbehind: true }, identifier: { pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/, greedy: true, lookbehind: true, inside: { punctuation: /^`|`$/ } }, function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i, keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i, boolean: /\b(?:FALSE|NULL|TRUE)\b/i, number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i, operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i, punctuation: /[;[\]()`,.]/ }, function(b) {
  var e = b.languages.javascript["template-string"], t = e.pattern.source, m = e.inside.interpolation, f = m.inside["interpolation-punctuation"], s = m.pattern.source;
  function n(e2, n2) {
    if (b.languages[e2])
      return { pattern: RegExp("((?:" + n2 + ")\\s*)" + t), lookbehind: true, greedy: true, inside: { "template-punctuation": { pattern: /^`|`$/, alias: "string" }, "embedded-code": { pattern: /[\s\S]+/, alias: e2 } } };
  }
  function h(e2, n2, t2) {
    e2 = { code: e2, grammar: n2, language: t2 };
    return b.hooks.run("before-tokenize", e2), e2.tokens = b.tokenize(e2.code, e2.grammar), b.hooks.run("after-tokenize", e2), e2.tokens;
  }
  function l(a2, e2, r) {
    var n2 = b.tokenize(a2, { interpolation: { pattern: RegExp(s), lookbehind: true } }), p = 0, d = {}, n2 = h(n2.map(function(e3) {
      if ("string" == typeof e3)
        return e3;
      for (var n3, t2, e3 = e3.content; -1 !== a2.indexOf((t2 = p++, n3 = "___" + r.toUpperCase() + "_" + t2 + "___")); )
        ;
      return d[n3] = e3, n3;
    }).join(""), e2, r), g = Object.keys(d);
    return p = 0, function e3(n3) {
      for (var t2 = 0; t2 < n3.length; t2++) {
        if (p >= g.length)
          return;
        var a3, r2, s2, i, o, l2, u2, c = n3[t2];
        "string" == typeof c || "string" == typeof c.content ? (a3 = g[p], -1 !== (u2 = (l2 = "string" == typeof c ? c : c.content).indexOf(a3)) && (++p, r2 = l2.substring(0, u2), o = d[a3], s2 = void 0, (i = {})["interpolation-punctuation"] = f, 3 === (i = b.tokenize(o, i)).length && ((s2 = [1, 1]).push.apply(s2, h(i[1], b.languages.javascript, "javascript")), i.splice.apply(i, s2)), s2 = new b.Token("interpolation", i, m.alias, o), i = l2.substring(u2 + a3.length), o = [], r2 && o.push(r2), o.push(s2), i && (e3(l2 = [i]), o.push.apply(o, l2)), "string" == typeof c ? (n3.splice.apply(n3, [t2, 1].concat(o)), t2 += o.length - 1) : c.content = o)) : (u2 = c.content, Array.isArray(u2) ? e3(u2) : e3([u2]));
      }
    }(n2), new b.Token(r, n2, "language-" + r, a2);
  }
  b.languages.javascript["template-string"] = [n("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source), n("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source), n("svg", /\bsvg/.source), n("markdown", /\b(?:markdown|md)/.source), n("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source), n("sql", /\bsql/.source), e].filter(Boolean);
  var a = { javascript: true, js: true, typescript: true, ts: true, jsx: true, tsx: true };
  function u(e2) {
    return "string" == typeof e2 ? e2 : Array.isArray(e2) ? e2.map(u).join("") : u(e2.content);
  }
  b.hooks.add("after-tokenize", function(e2) {
    e2.language in a && !function e3(n2) {
      for (var t2 = 0, a2 = n2.length; t2 < a2; t2++) {
        var r, s2, i, o = n2[t2];
        "string" != typeof o && (r = o.content, Array.isArray(r) ? "template-string" === o.type ? (o = r[1], 3 === r.length && "string" != typeof o && "embedded-code" === o.type && (s2 = u(o), o = o.alias, o = Array.isArray(o) ? o[0] : o, i = b.languages[o]) && (r[1] = l(s2, i, o))) : e3(r) : "string" != typeof r && e3([r]));
      }
    }(e2.tokens);
  });
}(Prism), function(e) {
  e.languages.typescript = e.languages.extend("javascript", { "class-name": { pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/, lookbehind: true, greedy: true, inside: null }, builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/ }), e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
  var n = e.languages.extend("typescript", {});
  delete n["class-name"], e.languages.typescript["class-name"].inside = n, e.languages.insertBefore("typescript", "function", { decorator: { pattern: /@[$\w\xA0-\uFFFF]+/, inside: { at: { pattern: /^@/, alias: "operator" }, function: /^[\s\S]+/ } }, "generic-function": { pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/, greedy: true, inside: { function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/, generic: { pattern: /<[\s\S]+/, alias: "class-name", inside: n } } } }), e.languages.ts = e.languages.typescript;
}(Prism), function(e) {
  var n = e.languages.javascript, t = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, a = "(@(?:arg|argument|param|property)\\s+(?:" + t + "\\s+)?)";
  e.languages.jsdoc = e.languages.extend("javadoclike", { parameter: { pattern: RegExp(a + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source), lookbehind: true, inside: { punctuation: /\./ } } }), e.languages.insertBefore("jsdoc", "keyword", { "optional-parameter": { pattern: RegExp(a + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source), lookbehind: true, inside: { parameter: { pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/, lookbehind: true, inside: { punctuation: /\./ } }, code: { pattern: /(=)[\s\S]*(?=\]$)/, lookbehind: true, inside: n, alias: "language-javascript" }, punctuation: /[=[\]]/ } }, "class-name": [{ pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
    return t;
  })), lookbehind: true, inside: { punctuation: /\./ } }, { pattern: RegExp("(@[a-z]+\\s+)" + t), lookbehind: true, inside: { string: n.string, number: n.number, boolean: n.boolean, keyword: e.languages.typescript.keyword, operator: /=>|\.\.\.|[&|?:*]/, punctuation: /[.,;=<>{}()[\]]/ } }], example: { pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/, lookbehind: true, inside: { code: { pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m, lookbehind: true, inside: n, alias: "language-javascript" } } } }), e.languages.javadoclike.addSupport("javascript", e.languages.jsdoc);
}(Prism), function(e) {
  e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", { type: [{ pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/, alias: "class-name" }] }), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", "operator", { "flow-punctuation": { pattern: /\{\||\|\}/, alias: "punctuation" } }), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [e.languages.flow.keyword]), e.languages.flow.keyword.unshift({ pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/, lookbehind: true }, { pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/, lookbehind: true });
}(Prism), Prism.languages.n4js = Prism.languages.extend("javascript", { keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/ }), Prism.languages.insertBefore("n4js", "constant", { annotation: { pattern: /@+\w+/, alias: "operator" } }), Prism.languages.n4jsd = Prism.languages.n4js, function(e) {
  function n(e2, n2) {
    return RegExp(e2.replace(/<ID>/g, function() {
      return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
    }), n2);
  }
  e.languages.insertBefore("javascript", "function-variable", { "method-variable": { pattern: RegExp("(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source), lookbehind: true, alias: ["function-variable", "method", "function", "property-access"] } }), e.languages.insertBefore("javascript", "function", { method: { pattern: RegExp("(\\.\\s*)" + e.languages.javascript.function.source), lookbehind: true, alias: ["function", "property-access"] } }), e.languages.insertBefore("javascript", "constant", { "known-class-name": [{ pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/, alias: "class-name" }, { pattern: /\b(?:[A-Z]\w*)Error\b/, alias: "class-name" }] }), e.languages.insertBefore("javascript", "keyword", { imports: { pattern: n(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source), lookbehind: true, inside: e.languages.javascript }, exports: { pattern: n(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source), lookbehind: true, inside: e.languages.javascript } }), e.languages.javascript.keyword.unshift({ pattern: /\b(?:as|default|export|from|import)\b/, alias: "module" }, { pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/, alias: "control-flow" }, { pattern: /\bnull\b/, alias: ["null", "nil"] }, { pattern: /\bundefined\b/, alias: "nil" }), e.languages.insertBefore("javascript", "operator", { spread: { pattern: /\.{3}/, alias: "operator" }, arrow: { pattern: /=>/, alias: "operator" } }), e.languages.insertBefore("javascript", "punctuation", { "property-access": { pattern: n(/(\.\s*)#?<ID>/.source), lookbehind: true }, "maybe-class-name": { pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/, lookbehind: true }, dom: { pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/, alias: "variable" }, console: { pattern: /\bconsole(?=\s*\.)/, alias: "class-name" } });
  for (var t = ["function", "function-variable", "method", "method-variable", "property-access"], a = 0; a < t.length; a++) {
    var r = t[a], s = e.languages.javascript[r], r = (s = "RegExp" === e.util.type(s) ? e.languages.javascript[r] = { pattern: s } : s).inside || {};
    (s.inside = r)["maybe-class-name"] = /^[A-Z][\s\S]*/;
  }
}(Prism), function(s) {
  var e = s.util.clone(s.languages.javascript), t = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, a = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, r = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
  function n(e2, n2) {
    return e2 = e2.replace(/<S>/g, function() {
      return t;
    }).replace(/<BRACES>/g, function() {
      return a;
    }).replace(/<SPREAD>/g, function() {
      return r;
    }), RegExp(e2, n2);
  }
  r = n(r).source, s.languages.jsx = s.languages.extend("markup", e), s.languages.jsx.tag.pattern = n(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), s.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, s.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, s.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, s.languages.jsx.tag.inside.comment = e.comment, s.languages.insertBefore("inside", "attr-name", { spread: { pattern: n(/<SPREAD>/.source), inside: s.languages.jsx } }, s.languages.jsx.tag), s.languages.insertBefore("inside", "special-attr", { script: { pattern: n(/=<BRACES>/.source), alias: "language-javascript", inside: { "script-punctuation": { pattern: /^=(?=\{)/, alias: "punctuation" }, rest: s.languages.jsx } } }, s.languages.jsx.tag);
  function i(e2) {
    for (var n2 = [], t2 = 0; t2 < e2.length; t2++) {
      var a2 = e2[t2], r2 = false;
      "string" != typeof a2 && ("tag" === a2.type && a2.content[0] && "tag" === a2.content[0].type ? "</" === a2.content[0].content[0].content ? 0 < n2.length && n2[n2.length - 1].tagName === o(a2.content[0].content[1]) && n2.pop() : "/>" !== a2.content[a2.content.length - 1].content && n2.push({ tagName: o(a2.content[0].content[1]), openedBraces: 0 }) : 0 < n2.length && "punctuation" === a2.type && "{" === a2.content ? n2[n2.length - 1].openedBraces++ : 0 < n2.length && 0 < n2[n2.length - 1].openedBraces && "punctuation" === a2.type && "}" === a2.content ? n2[n2.length - 1].openedBraces-- : r2 = true), (r2 || "string" == typeof a2) && 0 < n2.length && 0 === n2[n2.length - 1].openedBraces && (r2 = o(a2), t2 < e2.length - 1 && ("string" == typeof e2[t2 + 1] || "plain-text" === e2[t2 + 1].type) && (r2 += o(e2[t2 + 1]), e2.splice(t2 + 1, 1)), 0 < t2 && ("string" == typeof e2[t2 - 1] || "plain-text" === e2[t2 - 1].type) && (r2 = o(e2[t2 - 1]) + r2, e2.splice(t2 - 1, 1), t2--), e2[t2] = new s.Token("plain-text", r2, null, r2)), a2.content && "string" != typeof a2.content && i(a2.content);
    }
  }
  var o = function(e2) {
    return e2 ? "string" == typeof e2 ? e2 : "string" == typeof e2.content ? e2.content : e2.content.map(o).join("") : "";
  };
  s.hooks.add("after-tokenize", function(e2) {
    "jsx" !== e2.language && "tsx" !== e2.language || i(e2.tokens);
  });
}(Prism), function(e) {
  var n = e.util.clone(e.languages.typescript), n = (e.languages.tsx = e.languages.extend("jsx", n), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"], e.languages.tsx.tag);
  n.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + n.pattern.source + ")", n.pattern.flags), n.lookbehind = true;
}(Prism), Prism.languages.swift = { comment: { pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/, lookbehind: true, greedy: true }, "string-literal": [{ pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source), lookbehind: true, greedy: true, inside: { interpolation: { pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/, lookbehind: true, inside: null }, "interpolation-punctuation": { pattern: /^\)|\\\($/, alias: "punctuation" }, punctuation: /\\(?=[\r\n])/, string: /[\s\S]+/ } }, { pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"), lookbehind: true, greedy: true, inside: { interpolation: { pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/, lookbehind: true, inside: null }, "interpolation-punctuation": { pattern: /^\)|\\#+\($/, alias: "punctuation" }, string: /[\s\S]+/ } }], directive: { pattern: RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"), alias: "property", inside: { "directive-name": /^#\w+/, boolean: /\b(?:false|true)\b/, number: /\b\d+(?:\.\d+)*\b/, operator: /!|&&|\|\||[<>]=?/, punctuation: /[(),]/ } }, literal: { pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/, alias: "constant" }, "other-directive": { pattern: /#\w+\b/, alias: "property" }, attribute: { pattern: /@\w+/, alias: "atrule" }, "function-definition": { pattern: /(\bfunc\s+)\w+/, lookbehind: true, alias: "function" }, label: { pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/, lookbehind: true, alias: "important" }, keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/, boolean: /\b(?:false|true)\b/, nil: { pattern: /\bnil\b/, alias: "constant" }, "short-argument": /\$\d+\b/, omit: { pattern: /\b_\b/, alias: "keyword" }, number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i, "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/, function: /\b[a-z_]\w*(?=\s*\()/i, constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/, operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/, punctuation: /[{}[\]();,.:\\]/ }, Prism.languages.swift["string-literal"].forEach(function(e) {
  e.inside.interpolation.inside = Prism.languages.swift;
}), function(e) {
  e.languages.kotlin = e.languages.extend("clike", { keyword: { pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/, lookbehind: true }, function: [{ pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/, greedy: true }, { pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/, lookbehind: true, greedy: true }], number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/, operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/ }), delete e.languages.kotlin["class-name"];
  var n = { "interpolation-punctuation": { pattern: /^\$\{?|\}$/, alias: "punctuation" }, expression: { pattern: /[\s\S]+/, inside: e.languages.kotlin } };
  e.languages.insertBefore("kotlin", "string", { "string-literal": [{ pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/, alias: "multiline", inside: { interpolation: { pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i, inside: n }, string: /[\s\S]+/ } }, { pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/, alias: "singleline", inside: { interpolation: { pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i, lookbehind: true, inside: n }, string: /[\s\S]+/ } }], char: { pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/, greedy: true } }), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", { annotation: { pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/, alias: "builtin" } }), e.languages.insertBefore("kotlin", "function", { label: { pattern: /\b\w+@|@\w+\b/, alias: "symbol" } }), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
}(Prism), Prism.languages.c = Prism.languages.extend("clike", { comment: { pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/, greedy: true }, string: { pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/, greedy: true }, "class-name": { pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/, lookbehind: true }, keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/, function: /\b[a-z_]\w*(?=\s*\()/i, number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i, operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/ }), Prism.languages.insertBefore("c", "string", { char: { pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/, greedy: true } }), Prism.languages.insertBefore("c", "string", { macro: { pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im, lookbehind: true, greedy: true, alias: "property", inside: { string: [{ pattern: /^(#\s*include\s*)<[^>]+>/, lookbehind: true }, Prism.languages.c.string], char: Prism.languages.c.char, comment: Prism.languages.c.comment, "macro-name": [{ pattern: /(^#\s*define\s+)\w+\b(?!\()/i, lookbehind: true }, { pattern: /(^#\s*define\s+)\w+\b(?=\()/i, lookbehind: true, alias: "function" }], directive: { pattern: /^(#\s*)[a-z]+/, lookbehind: true, alias: "keyword" }, "directive-hash": /^#/, punctuation: /##|\\(?=[\r\n])/, expression: { pattern: /\S[\s\S]*/, inside: Prism.languages.c } } } }), Prism.languages.insertBefore("c", "function", { constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/ }), delete Prism.languages.c.boolean, Prism.languages.objectivec = Prism.languages.extend("c", { string: { pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/, greedy: true }, keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/, operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/ }), delete Prism.languages.objectivec["class-name"], Prism.languages.objc = Prism.languages.objectivec, Prism.languages.reason = Prism.languages.extend("clike", { string: { pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/, greedy: true }, "class-name": /\b[A-Z]\w*/, keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/, operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/ }), Prism.languages.insertBefore("reason", "class-name", { char: { pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/, greedy: true }, constructor: /\b[A-Z]\w*\b(?!\s*\.)/, label: { pattern: /\b[a-z]\w*(?=::)/, alias: "symbol" } }), delete Prism.languages.reason.function, function(e) {
  for (var n = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, t = 0; t < 2; t++)
    n = n.replace(/<self>/g, function() {
      return n;
    });
  n = n.replace(/<self>/g, function() {
    return /[^\s\S]/.source;
  }), e.languages.rust = { comment: [{ pattern: RegExp(/(^|[^\\])/.source + n), lookbehind: true, greedy: true }, { pattern: /(^|[^\\:])\/\/.*/, lookbehind: true, greedy: true }], string: { pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/, greedy: true }, char: { pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/, greedy: true }, attribute: { pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/, greedy: true, alias: "attr-name", inside: { string: null } }, "closure-params": { pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/, lookbehind: true, greedy: true, inside: { "closure-punctuation": { pattern: /^\||\|$/, alias: "punctuation" }, rest: null } }, "lifetime-annotation": { pattern: /'\w+/, alias: "symbol" }, "fragment-specifier": { pattern: /(\$\w+:)[a-z]+/, lookbehind: true, alias: "punctuation" }, variable: /\$\w+/, "function-definition": { pattern: /(\bfn\s+)\w+/, lookbehind: true, alias: "function" }, "type-definition": { pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/, lookbehind: true, alias: "class-name" }, "module-declaration": [{ pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/, lookbehind: true, alias: "namespace" }, { pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/, lookbehind: true, alias: "namespace", inside: { punctuation: /::/ } }], keyword: [/\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/, /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/], function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/, macro: { pattern: /\b\w+!/, alias: "property" }, constant: /\b[A-Z_][A-Z_\d]+\b/, "class-name": /\b[A-Z]\w*\b/, namespace: { pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/, inside: { punctuation: /::/ } }, number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/, boolean: /\b(?:false|true)\b/, punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/, operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/ }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
}(Prism), Prism.languages.go = Prism.languages.extend("clike", { string: { pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/, lookbehind: true, greedy: true }, keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/, boolean: /\b(?:_|false|iota|nil|true)\b/, number: [/\b0(?:b[01_]+|o[0-7_]+)i?\b/i, /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i, /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i], operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./, builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/ }), Prism.languages.insertBefore("go", "string", { char: { pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/, greedy: true } }), delete Prism.languages.go["class-name"], function(e) {
  var n = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, t = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
    return n.source;
  });
  e.languages.cpp = e.languages.extend("c", { "class-name": [{ pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
    return n.source;
  })), lookbehind: true }, /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/, /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i, /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/], keyword: n, number: { pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i, greedy: true }, operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/, boolean: /\b(?:false|true)\b/ }), e.languages.insertBefore("cpp", "string", { module: { pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
    return t;
  }) + ")"), lookbehind: true, greedy: true, inside: { string: /^[<"][\s\S]+/, operator: /:/, punctuation: /\./ } }, "raw-string": { pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/, alias: "string", greedy: true } }), e.languages.insertBefore("cpp", "keyword", { "generic-function": { pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i, inside: { function: /^\w+/, generic: { pattern: /<[\s\S]+/, alias: "class-name", inside: e.languages.cpp } } } }), e.languages.insertBefore("cpp", "operator", { "double-colon": { pattern: /::/, alias: "punctuation" } }), e.languages.insertBefore("cpp", "class-name", { "base-clause": { pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/, lookbehind: true, greedy: true, inside: e.languages.extend("cpp", {}) } }), e.languages.insertBefore("inside", "double-colon", { "class-name": /\b[a-z_]\w*\b(?!\s*::)/i }, e.languages.cpp["base-clause"]);
}(Prism);

// src/themes/index.ts
var themes_exports = {};
__export$2(themes_exports, {
  dracula: () => dracula_default,
  duotoneDark: () => duotoneDark_default,
  duotoneLight: () => duotoneLight_default,
  github: () => github_default,
  jettwaveDark: () => jettwaveDark_default,
  jettwaveLight: () => jettwaveLight_default,
  nightOwl: () => nightOwl_default,
  nightOwlLight: () => nightOwlLight_default,
  oceanicNext: () => oceanicNext_default,
  okaidia: () => okaidia_default,
  palenight: () => palenight_default,
  shadesOfPurple: () => shadesOfPurple_default,
  synthwave84: () => synthwave84_default,
  ultramin: () => ultramin_default,
  vsDark: () => vsDark_default,
  vsLight: () => vsLight_default
});

// src/themes/dracula.ts
var theme = {
  plain: {
    color: "#F8F8F2",
    backgroundColor: "#282A36"
  },
  styles: [
    {
      types: ["prolog", "constant", "builtin"],
      style: {
        color: "rgb(189, 147, 249)"
      }
    },
    {
      types: ["inserted", "function"],
      style: {
        color: "rgb(80, 250, 123)"
      }
    },
    {
      types: ["deleted"],
      style: {
        color: "rgb(255, 85, 85)"
      }
    },
    {
      types: ["changed"],
      style: {
        color: "rgb(255, 184, 108)"
      }
    },
    {
      types: ["punctuation", "symbol"],
      style: {
        color: "rgb(248, 248, 242)"
      }
    },
    {
      types: ["string", "char", "tag", "selector"],
      style: {
        color: "rgb(255, 121, 198)"
      }
    },
    {
      types: ["keyword", "variable"],
      style: {
        color: "rgb(189, 147, 249)",
        fontStyle: "italic"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "rgb(98, 114, 164)"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "rgb(241, 250, 140)"
      }
    }
  ]
};
var dracula_default = theme;

// src/themes/duotoneDark.ts
var theme2 = {
  plain: {
    backgroundColor: "#2a2734",
    color: "#9a86fd"
  },
  styles: [
    {
      types: ["comment", "prolog", "doctype", "cdata", "punctuation"],
      style: {
        color: "#6c6783"
      }
    },
    {
      types: ["namespace"],
      style: {
        opacity: 0.7
      }
    },
    {
      types: ["tag", "operator", "number"],
      style: {
        color: "#e09142"
      }
    },
    {
      types: ["property", "function"],
      style: {
        color: "#9a86fd"
      }
    },
    {
      types: ["tag-id", "selector", "atrule-id"],
      style: {
        color: "#eeebff"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "#c4b9fe"
      }
    },
    {
      types: [
        "boolean",
        "string",
        "entity",
        "url",
        "attr-value",
        "keyword",
        "control",
        "directive",
        "unit",
        "statement",
        "regex",
        "atrule",
        "placeholder",
        "variable"
      ],
      style: {
        color: "#ffcc99"
      }
    },
    {
      types: ["deleted"],
      style: {
        textDecorationLine: "line-through"
      }
    },
    {
      types: ["inserted"],
      style: {
        textDecorationLine: "underline"
      }
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["important", "bold"],
      style: {
        fontWeight: "bold"
      }
    },
    {
      types: ["important"],
      style: {
        color: "#c4b9fe"
      }
    }
  ]
};
var duotoneDark_default = theme2;

// src/themes/duotoneLight.ts
var theme3 = {
  plain: {
    backgroundColor: "#faf8f5",
    color: "#728fcb"
  },
  styles: [
    {
      types: ["comment", "prolog", "doctype", "cdata", "punctuation"],
      style: {
        color: "#b6ad9a"
      }
    },
    {
      types: ["namespace"],
      style: {
        opacity: 0.7
      }
    },
    {
      types: ["tag", "operator", "number"],
      style: {
        color: "#063289"
      }
    },
    {
      types: ["property", "function"],
      style: {
        color: "#b29762"
      }
    },
    {
      types: ["tag-id", "selector", "atrule-id"],
      style: {
        color: "#2d2006"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "#896724"
      }
    },
    {
      types: [
        "boolean",
        "string",
        "entity",
        "url",
        "attr-value",
        "keyword",
        "control",
        "directive",
        "unit",
        "statement",
        "regex",
        "atrule"
      ],
      style: {
        color: "#728fcb"
      }
    },
    {
      types: ["placeholder", "variable"],
      style: {
        color: "#93abdc"
      }
    },
    {
      types: ["deleted"],
      style: {
        textDecorationLine: "line-through"
      }
    },
    {
      types: ["inserted"],
      style: {
        textDecorationLine: "underline"
      }
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["important", "bold"],
      style: {
        fontWeight: "bold"
      }
    },
    {
      types: ["important"],
      style: {
        color: "#896724"
      }
    }
  ]
};
var duotoneLight_default = theme3;

// src/themes/github.ts
var theme4 = {
  plain: {
    color: "#393A34",
    backgroundColor: "#f6f8fa"
  },
  styles: [
    {
      types: ["comment", "prolog", "doctype", "cdata"],
      style: {
        color: "#999988",
        fontStyle: "italic"
      }
    },
    {
      types: ["namespace"],
      style: {
        opacity: 0.7
      }
    },
    {
      types: ["string", "attr-value"],
      style: {
        color: "#e3116c"
      }
    },
    {
      types: ["punctuation", "operator"],
      style: {
        color: "#393A34"
      }
    },
    {
      types: [
        "entity",
        "url",
        "symbol",
        "number",
        "boolean",
        "variable",
        "constant",
        "property",
        "regex",
        "inserted"
      ],
      style: {
        color: "#36acaa"
      }
    },
    {
      types: ["atrule", "keyword", "attr-name", "selector"],
      style: {
        color: "#00a4db"
      }
    },
    {
      types: ["function", "deleted", "tag"],
      style: {
        color: "#d73a49"
      }
    },
    {
      types: ["function-variable"],
      style: {
        color: "#6f42c1"
      }
    },
    {
      types: ["tag", "selector", "keyword"],
      style: {
        color: "#00009f"
      }
    }
  ]
};
var github_default = theme4;

// src/themes/nightOwl.ts
var theme5 = {
  plain: {
    color: "#d6deeb",
    backgroundColor: "#011627"
  },
  styles: [
    {
      types: ["changed"],
      style: {
        color: "rgb(162, 191, 252)",
        fontStyle: "italic"
      }
    },
    {
      types: ["deleted"],
      style: {
        color: "rgba(239, 83, 80, 0.56)",
        fontStyle: "italic"
      }
    },
    {
      types: ["inserted", "attr-name"],
      style: {
        color: "rgb(173, 219, 103)",
        fontStyle: "italic"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "rgb(99, 119, 119)",
        fontStyle: "italic"
      }
    },
    {
      types: ["string", "url"],
      style: {
        color: "rgb(173, 219, 103)"
      }
    },
    {
      types: ["variable"],
      style: {
        color: "rgb(214, 222, 235)"
      }
    },
    {
      types: ["number"],
      style: {
        color: "rgb(247, 140, 108)"
      }
    },
    {
      types: ["builtin", "char", "constant", "function"],
      style: {
        color: "rgb(130, 170, 255)"
      }
    },
    {
      // This was manually added after the auto-generation
      // so that punctuations are not italicised
      types: ["punctuation"],
      style: {
        color: "rgb(199, 146, 234)"
      }
    },
    {
      types: ["selector", "doctype"],
      style: {
        color: "rgb(199, 146, 234)",
        fontStyle: "italic"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "rgb(255, 203, 139)"
      }
    },
    {
      types: ["tag", "operator", "keyword"],
      style: {
        color: "rgb(127, 219, 202)"
      }
    },
    {
      types: ["boolean"],
      style: {
        color: "rgb(255, 88, 116)"
      }
    },
    {
      types: ["property"],
      style: {
        color: "rgb(128, 203, 196)"
      }
    },
    {
      types: ["namespace"],
      style: {
        color: "rgb(178, 204, 214)"
      }
    }
  ]
};
var nightOwl_default = theme5;

// src/themes/nightOwlLight.ts
var theme6 = {
  plain: {
    color: "#403f53",
    backgroundColor: "#FBFBFB"
  },
  styles: [
    {
      types: ["changed"],
      style: {
        color: "rgb(162, 191, 252)",
        fontStyle: "italic"
      }
    },
    {
      types: ["deleted"],
      style: {
        color: "rgba(239, 83, 80, 0.56)",
        fontStyle: "italic"
      }
    },
    {
      types: ["inserted", "attr-name"],
      style: {
        color: "rgb(72, 118, 214)",
        fontStyle: "italic"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "rgb(152, 159, 177)",
        fontStyle: "italic"
      }
    },
    {
      types: ["string", "builtin", "char", "constant", "url"],
      style: {
        color: "rgb(72, 118, 214)"
      }
    },
    {
      types: ["variable"],
      style: {
        color: "rgb(201, 103, 101)"
      }
    },
    {
      types: ["number"],
      style: {
        color: "rgb(170, 9, 130)"
      }
    },
    {
      // This was manually added after the auto-generation
      // so that punctuations are not italicised
      types: ["punctuation"],
      style: {
        color: "rgb(153, 76, 195)"
      }
    },
    {
      types: ["function", "selector", "doctype"],
      style: {
        color: "rgb(153, 76, 195)",
        fontStyle: "italic"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "rgb(17, 17, 17)"
      }
    },
    {
      types: ["tag"],
      style: {
        color: "rgb(153, 76, 195)"
      }
    },
    {
      types: ["operator", "property", "keyword", "namespace"],
      style: {
        color: "rgb(12, 150, 155)"
      }
    },
    {
      types: ["boolean"],
      style: {
        color: "rgb(188, 84, 84)"
      }
    }
  ]
};
var nightOwlLight_default = theme6;

// src/themes/oceanicNext.ts
var colors = {
  char: "#D8DEE9",
  comment: "#999999",
  keyword: "#c5a5c5",
  primitive: "#5a9bcf",
  string: "#8dc891",
  variable: "#d7deea",
  boolean: "#ff8b50",
  punctuation: "#5FB3B3",
  tag: "#fc929e",
  function: "#79b6f2",
  className: "#FAC863",
  method: "#6699CC",
  operator: "#fc929e"
};
var theme7 = {
  plain: {
    backgroundColor: "#282c34",
    color: "#ffffff"
  },
  styles: [
    {
      types: ["attr-name"],
      style: {
        color: colors.keyword
      }
    },
    {
      types: ["attr-value"],
      style: {
        color: colors.string
      }
    },
    {
      types: [
        "comment",
        "block-comment",
        "prolog",
        "doctype",
        "cdata",
        "shebang"
      ],
      style: {
        color: colors.comment
      }
    },
    {
      types: [
        "property",
        "number",
        "function-name",
        "constant",
        "symbol",
        "deleted"
      ],
      style: {
        color: colors.primitive
      }
    },
    {
      types: ["boolean"],
      style: {
        color: colors.boolean
      }
    },
    {
      types: ["tag"],
      style: {
        color: colors.tag
      }
    },
    {
      types: ["string"],
      style: {
        color: colors.string
      }
    },
    {
      types: ["punctuation"],
      style: {
        color: colors.string
      }
    },
    {
      types: ["selector", "char", "builtin", "inserted"],
      style: {
        color: colors.char
      }
    },
    {
      types: ["function"],
      style: {
        color: colors.function
      }
    },
    {
      types: ["operator", "entity", "url", "variable"],
      style: {
        color: colors.variable
      }
    },
    {
      types: ["keyword"],
      style: {
        color: colors.keyword
      }
    },
    {
      types: ["atrule", "class-name"],
      style: {
        color: colors.className
      }
    },
    {
      types: ["important"],
      style: {
        fontWeight: "400"
      }
    },
    {
      types: ["bold"],
      style: {
        fontWeight: "bold"
      }
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["namespace"],
      style: {
        opacity: 0.7
      }
    }
  ]
};
var oceanicNext_default = theme7;

// src/themes/okaidia.ts
var theme8 = {
  plain: {
    color: "#f8f8f2",
    backgroundColor: "#272822"
  },
  styles: [
    {
      types: ["changed"],
      style: {
        color: "rgb(162, 191, 252)",
        fontStyle: "italic"
      }
    },
    {
      types: ["deleted"],
      style: {
        color: "#f92672",
        fontStyle: "italic"
      }
    },
    {
      types: ["inserted"],
      style: {
        color: "rgb(173, 219, 103)",
        fontStyle: "italic"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "#8292a2",
        fontStyle: "italic"
      }
    },
    {
      types: ["string", "url"],
      style: {
        color: "#a6e22e"
      }
    },
    {
      types: ["variable"],
      style: {
        color: "#f8f8f2"
      }
    },
    {
      types: ["number"],
      style: {
        color: "#ae81ff"
      }
    },
    {
      types: ["builtin", "char", "constant", "function", "class-name"],
      style: {
        color: "#e6db74"
      }
    },
    {
      types: ["punctuation"],
      style: {
        color: "#f8f8f2"
      }
    },
    {
      types: ["selector", "doctype"],
      style: {
        color: "#a6e22e",
        fontStyle: "italic"
      }
    },
    {
      types: ["tag", "operator", "keyword"],
      style: {
        color: "#66d9ef"
      }
    },
    {
      types: ["boolean"],
      style: {
        color: "#ae81ff"
      }
    },
    {
      types: ["namespace"],
      style: {
        color: "rgb(178, 204, 214)",
        opacity: 0.7
      }
    },
    {
      types: ["tag", "property"],
      style: {
        color: "#f92672"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "#a6e22e !important"
      }
    },
    {
      types: ["doctype"],
      style: {
        color: "#8292a2"
      }
    },
    {
      types: ["rule"],
      style: {
        color: "#e6db74"
      }
    }
  ]
};
var okaidia_default = theme8;

// src/themes/palenight.ts
var theme9 = {
  plain: {
    color: "#bfc7d5",
    backgroundColor: "#292d3e"
  },
  styles: [
    {
      types: ["comment"],
      style: {
        color: "rgb(105, 112, 152)",
        fontStyle: "italic"
      }
    },
    {
      types: ["string", "inserted"],
      style: {
        color: "rgb(195, 232, 141)"
      }
    },
    {
      types: ["number"],
      style: {
        color: "rgb(247, 140, 108)"
      }
    },
    {
      types: ["builtin", "char", "constant", "function"],
      style: {
        color: "rgb(130, 170, 255)"
      }
    },
    {
      types: ["punctuation", "selector"],
      style: {
        color: "rgb(199, 146, 234)"
      }
    },
    {
      types: ["variable"],
      style: {
        color: "rgb(191, 199, 213)"
      }
    },
    {
      types: ["class-name", "attr-name"],
      style: {
        color: "rgb(255, 203, 107)"
      }
    },
    {
      types: ["tag", "deleted"],
      style: {
        color: "rgb(255, 85, 114)"
      }
    },
    {
      types: ["operator"],
      style: {
        color: "rgb(137, 221, 255)"
      }
    },
    {
      types: ["boolean"],
      style: {
        color: "rgb(255, 88, 116)"
      }
    },
    {
      types: ["keyword"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["doctype"],
      style: {
        color: "rgb(199, 146, 234)",
        fontStyle: "italic"
      }
    },
    {
      types: ["namespace"],
      style: {
        color: "rgb(178, 204, 214)"
      }
    },
    {
      types: ["url"],
      style: {
        color: "rgb(221, 221, 221)"
      }
    }
  ]
};
var palenight_default = theme9;

// src/themes/shadesOfPurple.ts
var theme10 = {
  plain: {
    color: "#9EFEFF",
    backgroundColor: "#2D2A55"
  },
  styles: [
    {
      types: ["changed"],
      style: {
        color: "rgb(255, 238, 128)"
      }
    },
    {
      types: ["deleted"],
      style: {
        color: "rgba(239, 83, 80, 0.56)"
      }
    },
    {
      types: ["inserted"],
      style: {
        color: "rgb(173, 219, 103)"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "rgb(179, 98, 255)",
        fontStyle: "italic"
      }
    },
    {
      types: ["punctuation"],
      style: {
        color: "rgb(255, 255, 255)"
      }
    },
    {
      types: ["constant"],
      style: {
        color: "rgb(255, 98, 140)"
      }
    },
    {
      types: ["string", "url"],
      style: {
        color: "rgb(165, 255, 144)"
      }
    },
    {
      types: ["variable"],
      style: {
        color: "rgb(255, 238, 128)"
      }
    },
    {
      types: ["number", "boolean"],
      style: {
        color: "rgb(255, 98, 140)"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "rgb(255, 180, 84)"
      }
    },
    {
      types: [
        "keyword",
        "operator",
        "property",
        "namespace",
        "tag",
        "selector",
        "doctype"
      ],
      style: {
        color: "rgb(255, 157, 0)"
      }
    },
    {
      types: ["builtin", "char", "constant", "function", "class-name"],
      style: {
        color: "rgb(250, 208, 0)"
      }
    }
  ]
};
var shadesOfPurple_default = theme10;

// src/themes/synthwave84.ts
var theme11 = {
  plain: {
    backgroundColor: "linear-gradient(to bottom, #2a2139 75%, #34294f)",
    backgroundImage: "#34294f",
    color: "#f92aad",
    textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
  },
  styles: [
    {
      types: ["comment", "block-comment", "prolog", "doctype", "cdata"],
      style: {
        color: "#495495",
        fontStyle: "italic"
      }
    },
    {
      types: ["punctuation"],
      style: {
        color: "#ccc"
      }
    },
    {
      types: [
        "tag",
        "attr-name",
        "namespace",
        "number",
        "unit",
        "hexcode",
        "deleted"
      ],
      style: {
        color: "#e2777a"
      }
    },
    {
      types: ["property", "selector"],
      style: {
        color: "#72f1b8",
        textShadow: "0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"
      }
    },
    {
      types: ["function-name"],
      style: {
        color: "#6196cc"
      }
    },
    {
      types: ["boolean", "selector-id", "function"],
      style: {
        color: "#fdfdfd",
        textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
      }
    },
    {
      types: ["class-name", "maybe-class-name", "builtin"],
      style: {
        color: "#fff5f6",
        textShadow: "0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"
      }
    },
    {
      types: ["constant", "symbol"],
      style: {
        color: "#f92aad",
        textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
      }
    },
    {
      types: ["important", "atrule", "keyword", "selector-class"],
      style: {
        color: "#f4eee4",
        textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
      }
    },
    {
      types: ["string", "char", "attr-value", "regex", "variable"],
      style: {
        color: "#f87c32"
      }
    },
    {
      types: ["parameter"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["entity", "url"],
      style: {
        color: "#67cdcc"
      }
    },
    {
      types: ["operator"],
      style: {
        color: "ffffffee"
      }
    },
    {
      types: ["important", "bold"],
      style: {
        fontWeight: "bold"
      }
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["entity"],
      style: {
        cursor: "help"
      }
    },
    {
      types: ["inserted"],
      style: {
        color: "green"
      }
    }
  ]
};
var synthwave84_default = theme11;

// src/themes/ultramin.ts
var theme12 = {
  plain: {
    color: "#282a2e",
    backgroundColor: "#ffffff"
  },
  styles: [
    {
      types: ["comment"],
      style: {
        color: "rgb(197, 200, 198)"
      }
    },
    {
      types: ["string", "number", "builtin", "variable"],
      style: {
        color: "rgb(150, 152, 150)"
      }
    },
    {
      types: ["class-name", "function", "tag", "attr-name"],
      style: {
        color: "rgb(40, 42, 46)"
      }
    }
  ]
};
var ultramin_default = theme12;

// src/themes/vsDark.ts
var theme13 = {
  plain: {
    color: "#9CDCFE",
    backgroundColor: "#1E1E1E"
  },
  styles: [
    {
      types: ["prolog"],
      style: {
        color: "rgb(0, 0, 128)"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "rgb(106, 153, 85)"
      }
    },
    {
      types: ["builtin", "changed", "keyword", "interpolation-punctuation"],
      style: {
        color: "rgb(86, 156, 214)"
      }
    },
    {
      types: ["number", "inserted"],
      style: {
        color: "rgb(181, 206, 168)"
      }
    },
    {
      types: ["constant"],
      style: {
        color: "rgb(100, 102, 149)"
      }
    },
    {
      types: ["attr-name", "variable"],
      style: {
        color: "rgb(156, 220, 254)"
      }
    },
    {
      types: ["deleted", "string", "attr-value", "template-punctuation"],
      style: {
        color: "rgb(206, 145, 120)"
      }
    },
    {
      types: ["selector"],
      style: {
        color: "rgb(215, 186, 125)"
      }
    },
    {
      // Fix tag color
      types: ["tag"],
      style: {
        color: "rgb(78, 201, 176)"
      }
    },
    {
      // Fix tag color for HTML
      types: ["tag"],
      languages: ["markup"],
      style: {
        color: "rgb(86, 156, 214)"
      }
    },
    {
      types: ["punctuation", "operator"],
      style: {
        color: "rgb(212, 212, 212)"
      }
    },
    {
      // Fix punctuation color for HTML
      types: ["punctuation"],
      languages: ["markup"],
      style: {
        color: "#808080"
      }
    },
    {
      types: ["function"],
      style: {
        color: "rgb(220, 220, 170)"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "rgb(78, 201, 176)"
      }
    },
    {
      types: ["char"],
      style: {
        color: "rgb(209, 105, 105)"
      }
    }
  ]
};
var vsDark_default = theme13;

// src/themes/vsLight.ts
var theme14 = {
  plain: {
    color: "#000000",
    backgroundColor: "#ffffff"
  },
  styles: [
    {
      types: ["comment"],
      style: {
        color: "rgb(0, 128, 0)"
      }
    },
    {
      types: ["builtin"],
      style: {
        color: "rgb(0, 112, 193)"
      }
    },
    {
      types: ["number", "variable", "inserted"],
      style: {
        color: "rgb(9, 134, 88)"
      }
    },
    {
      types: ["operator"],
      style: {
        color: "rgb(0, 0, 0)"
      }
    },
    {
      types: ["constant", "char"],
      style: {
        color: "rgb(129, 31, 63)"
      }
    },
    {
      types: ["tag"],
      style: {
        color: "rgb(128, 0, 0)"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "rgb(255, 0, 0)"
      }
    },
    {
      types: ["deleted", "string"],
      style: {
        color: "rgb(163, 21, 21)"
      }
    },
    {
      types: ["changed", "punctuation"],
      style: {
        color: "rgb(4, 81, 165)"
      }
    },
    {
      types: ["function", "keyword"],
      style: {
        color: "rgb(0, 0, 255)"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "rgb(38, 127, 153)"
      }
    }
  ]
};
var vsLight_default = theme14;

// src/themes/jettwaveDark.ts
var theme15 = {
  plain: {
    color: "#f8fafc",
    backgroundColor: "#011627"
  },
  styles: [
    {
      types: ["prolog"],
      style: {
        color: "#000080"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "#6A9955"
      }
    },
    {
      types: ["builtin", "changed", "keyword", "interpolation-punctuation"],
      style: {
        color: "#569CD6"
      }
    },
    {
      types: ["number", "inserted"],
      style: {
        color: "#B5CEA8"
      }
    },
    {
      types: ["constant"],
      style: {
        color: "#f8fafc"
      }
    },
    {
      types: ["attr-name", "variable"],
      style: {
        color: "#9CDCFE"
      }
    },
    {
      types: ["deleted", "string", "attr-value", "template-punctuation"],
      style: {
        color: "#cbd5e1"
      }
    },
    {
      types: ["selector"],
      style: {
        color: "#D7BA7D"
      }
    },
    {
      types: ["tag"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["tag"],
      languages: ["markup"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["punctuation", "operator"],
      style: {
        color: "#D4D4D4"
      }
    },
    {
      types: ["punctuation"],
      languages: ["markup"],
      style: {
        color: "#808080"
      }
    },
    {
      types: ["function"],
      style: {
        color: "#7dd3fc"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["char"],
      style: {
        color: "#D16969"
      }
    }
  ]
};
var jettwaveDark_default = theme15;

// src/themes/jettwaveLight.ts
var theme16 = {
  plain: {
    color: "#0f172a",
    backgroundColor: "#f1f5f9"
  },
  styles: [
    {
      types: ["prolog"],
      style: {
        color: "#000080"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "#6A9955"
      }
    },
    {
      types: ["builtin", "changed", "keyword", "interpolation-punctuation"],
      style: {
        color: "#0c4a6e"
      }
    },
    {
      types: ["number", "inserted"],
      style: {
        color: "#B5CEA8"
      }
    },
    {
      types: ["constant"],
      style: {
        color: "#0f172a"
      }
    },
    {
      types: ["attr-name", "variable"],
      style: {
        color: "#0c4a6e"
      }
    },
    {
      types: ["deleted", "string", "attr-value", "template-punctuation"],
      style: {
        color: "#64748b"
      }
    },
    {
      types: ["selector"],
      style: {
        color: "#D7BA7D"
      }
    },
    {
      types: ["tag"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["tag"],
      languages: ["markup"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["punctuation", "operator"],
      style: {
        color: "#475569"
      }
    },
    {
      types: ["punctuation"],
      languages: ["markup"],
      style: {
        color: "#808080"
      }
    },
    {
      types: ["function"],
      style: {
        color: "#0e7490"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["char"],
      style: {
        color: "#D16969"
      }
    }
  ]
};
var jettwaveLight_default = theme16;

// src/utils/themeToDict.ts
var themeToDict = (theme17, language) => {
  const { plain } = theme17;
  const themeDict = theme17.styles.reduce((acc, themeEntry) => {
    const { languages: languages2, style } = themeEntry;
    if (languages2 && !languages2.includes(language)) {
      return acc;
    }
    themeEntry.types.forEach((type) => {
      const accStyle = __spreadValues(__spreadValues({}, acc[type]), style);
      acc[type] = accStyle;
    });
    return acc;
  }, {});
  themeDict.root = plain;
  themeDict.plain = __spreadProps(__spreadValues({}, plain), { backgroundColor: void 0 });
  return themeDict;
};
var themeToDict_default = themeToDict;

// src/components/useThemeDictionary.ts
var useThemeDictionary = (language, theme17) => {
  const [themeDictionary, setThemeDictionary] = useState(
    themeToDict_default(theme17, language)
  );
  const previousTheme = useRef();
  const previousLanguage = useRef();
  useEffect(() => {
    if (theme17 !== previousTheme.current || language !== previousLanguage.current) {
      previousTheme.current = theme17;
      previousLanguage.current = language;
      setThemeDictionary(themeToDict_default(theme17, language));
    }
  }, [language, theme17]);
  return themeDictionary;
};
var useGetLineProps = (themeDictionary) => useCallback(
  (_a) => {
    var _b = _a, { className, style, line } = _b, rest = __objRest(_b, ["className", "style", "line"]);
    const output = __spreadProps(__spreadValues({}, rest), {
      className: clsx("token-line", className)
    });
    if (typeof themeDictionary === "object" && "plain" in themeDictionary)
      output.style = themeDictionary.plain;
    if (typeof style === "object")
      output.style = __spreadValues(__spreadValues({}, output.style || {}), style);
    return output;
  },
  [themeDictionary]
);
var useGetTokenProps = (themeDictionary) => {
  const styleForToken = useCallback(
    ({ types, empty }) => {
      if (themeDictionary == null)
        return void 0;
      else if (types.length === 1 && types[0] === "plain") {
        return empty != null ? { display: "inline-block" } : void 0;
      } else if (types.length === 1 && empty != null) {
        return themeDictionary[types[0]];
      }
      return Object.assign(
        empty != null ? { display: "inline-block" } : {},
        ...types.map((type) => themeDictionary[type])
      );
    },
    [themeDictionary]
  );
  return useCallback(
    (_a) => {
      var _b = _a, { token, className, style } = _b, rest = __objRest(_b, ["token", "className", "style"]);
      const output = __spreadProps(__spreadValues({}, rest), {
        className: clsx("token", ...token.types, className),
        children: token.content,
        style: styleForToken(token)
      });
      if (style != null) {
        output.style = __spreadValues(__spreadValues({}, output.style || {}), style);
      }
      return output;
    },
    [styleForToken]
  );
};

// src/utils/normalizeTokens.ts
var newlineRe = /\r\n|\r|\n/;
var normalizeEmptyLines = (line) => {
  if (line.length === 0) {
    line.push({
      types: ["plain"],
      content: "\n",
      empty: true
    });
  } else if (line.length === 1 && line[0].content === "") {
    line[0].content = "\n";
    line[0].empty = true;
  }
};
var appendTypes = (types, add) => {
  const typesSize = types.length;
  if (typesSize > 0 && types[typesSize - 1] === add) {
    return types;
  }
  return types.concat(add);
};
var normalizeTokens = (tokens) => {
  const typeArrStack = [[]];
  const tokenArrStack = [tokens];
  const tokenArrIndexStack = [0];
  const tokenArrSizeStack = [tokens.length];
  let i = 0;
  let stackIndex = 0;
  let currentLine = [];
  const acc = [currentLine];
  while (stackIndex > -1) {
    while ((i = tokenArrIndexStack[stackIndex]++) < tokenArrSizeStack[stackIndex]) {
      let content;
      let types = typeArrStack[stackIndex];
      const tokenArr = tokenArrStack[stackIndex];
      const token = tokenArr[i];
      if (typeof token === "string") {
        types = stackIndex > 0 ? types : ["plain"];
        content = token;
      } else {
        types = appendTypes(types, token.type);
        if (token.alias) {
          types = appendTypes(types, token.alias);
        }
        content = token.content;
      }
      if (typeof content !== "string") {
        stackIndex++;
        typeArrStack.push(types);
        tokenArrStack.push(content);
        tokenArrIndexStack.push(0);
        tokenArrSizeStack.push(content.length);
        continue;
      }
      const splitByNewlines = content.split(newlineRe);
      const newlineCount = splitByNewlines.length;
      currentLine.push({
        types,
        content: splitByNewlines[0]
      });
      for (let i2 = 1; i2 < newlineCount; i2++) {
        normalizeEmptyLines(currentLine);
        acc.push(currentLine = []);
        currentLine.push({
          types,
          content: splitByNewlines[i2]
        });
      }
    }
    stackIndex--;
    typeArrStack.pop();
    tokenArrStack.pop();
    tokenArrIndexStack.pop();
    tokenArrSizeStack.pop();
  }
  normalizeEmptyLines(currentLine);
  return acc;
};
var normalizeTokens_default = normalizeTokens;
var useTokenize = ({ prism, code, grammar, language }) => {
  const prismRef = useRef(prism);
  return useMemo(() => {
    if (grammar == null)
      return normalizeTokens_default([code]);
    const prismConfig = {
      code,
      grammar,
      language,
      tokens: []
    };
    prismRef.current.hooks.run("before-tokenize", prismConfig);
    prismConfig.tokens = prismRef.current.tokenize(code, grammar);
    prismRef.current.hooks.run("after-tokenize", prismConfig);
    return normalizeTokens_default(prismConfig.tokens);
  }, [code, grammar, language]);
};

// src/components/highlight.ts
var Highlight = ({
  children,
  language: _language,
  code,
  theme: theme17,
  prism
}) => {
  const language = _language.toLowerCase();
  const themeDictionary = useThemeDictionary(language, theme17);
  const getLineProps = useGetLineProps(themeDictionary);
  const getTokenProps = useGetTokenProps(themeDictionary);
  const grammar = prism.languages[language];
  const tokens = useTokenize({ prism, language, code, grammar });
  return children({
    tokens,
    className: `prism-code language-${language}`,
    style: themeDictionary != null ? themeDictionary.root : {},
    getLineProps,
    getTokenProps
  });
};

// src/index.ts
var Highlight2 = (props) => createElement(Highlight, __spreadProps(__spreadValues({}, props), {
  prism: props.prism || Prism,
  theme: props.theme || vsDark_default,
  code: props.code,
  language: props.language
}));
/*! Bundled license information:

prismjs/prism.js:
  (**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   *)
*/

const CopyButton = styled(IconButton) `
  position: absolute;
  top: 8px;
  right: 8px;
`;
// necessary to separate copy button and scroll
const Parent = styled.div `
  position: relative;
  background: ${Colors$1.Midnight700};
  max-width: 100%;
  overflow: scroll;
  padding: 0 16px;
`;
const SnippetWrap = styled.div `
  background: ${Colors$1.Midnight700};
  padding: 16px;
  ${({ $normalizeWhitespace }) => $normalizeWhitespace
    ? css `
          pre {
            white-space: normal;
          }
        `
    : null}
`;
const Container = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 24px;
`;
const CodeSnippet = ({ code, theme = themes_exports.nightOwl, onCopy, heading, language, normalizeWhitespace, }) => {
    const customStyles = {
        fontSize: '12px',
        backgroundColor: Colors$1.Midnight700,
    };
    const mergedTheme = {
        ...theme,
        plain: {
            ...theme.plain,
            ...customStyles,
        },
    };
    return (jsxs(Container, { children: [heading && jsx(Typography, { type: 'actionLg', children: heading }), jsx(Highlight2, { code: code, theme: mergedTheme, language: language || '', children: ({ style, tokens, getLineProps, getTokenProps }) => {
                    return (jsxs(Parent, { children: [onCopy && (jsx(CopyButton, { variant: 'code-snippet', onPress: () => onCopy(code), name: 'documentCopy', "data-testid": 'copy-snippet', size: 16 })), jsx(SnippetWrap, { "$normalizeWhitespace": normalizeWhitespace, children: jsx("pre", { style: style, "data-testid": 'snippet-pre', children: tokens.map((line, i) => (jsx("div", { ...getLineProps({ line }), children: line.map((token, key) => (jsx("span", { ...getTokenProps({ token }) }, `token-${key}-${token.content}`))) }, `line-${i}-${line.join('')}`))) }) })] }));
                } })] }));
};

const growFromLeft = (percentage) => keyframes `
  from {
    width: 0%;
  }
  to {
    width: ${percentage}%;
  }
`;
const DurationContainer = styled.div `
  max-width: 100px;
  height: 16px;
  opacity: 0.5;
  width: ${({ percentage }) => `${percentage}px`};

  background-color: ${(props) => props.percentage > 50 ? Colors$1.Sunflower800 : Colors$1.Jade700};
  ${({ percentage }) => css `
    animation: ${growFromLeft(percentage)} 1s ease-in-out forwards;
  `}
`;
const calculatePercentage = (duration) => {
    if (duration < 1500)
        return 10;
    if (duration > 30000)
        return 100;
    return ((duration - 1500) / (30000 - 1500)) * (100 - 10) + 10; // Linear interpolation
};
const DurationBar = ({ duration }) => {
    const [key, setKey] = React__default.useState(Math.random());
    // Re-trigger the animation by changing the key when duration changes
    React__default.useEffect(() => {
        setKey(Math.random());
    }, [duration]);
    const percentage = calculatePercentage(duration);
    return jsx(DurationContainer, { percentage: percentage }, key);
};

const Status = styled.div `
  height: 20px;
  width: 12px;
  border-radius: 100px;
  background: ${(props) => props.status === 'fail' ? Colors$1.Pinata800 : Colors$1.Pigeon300};
`;

// @todo: remove once wired up to api
const eventData = [
    {
        status: 'none',
        id: '17689',
        operation: 'space:added',
        percentage: 75,
    },
    {
        status: 'none',
        id: '17634',
        operation: 'space:updated',
        percentage: 50,
    },
    {
        status: 'none',
        id: '17689',
        operation: 'space:added',
        percentage: 75,
    },
    {
        status: 'none',
        id: '17634',
        operation: 'space:updated',
        percentage: 50,
    },
    {
        status: 'fail',
        id: '17689',
        operation: 'space:added',
        percentage: 75,
    },
    {
        status: 'none',
        id: '17634',
        operation: 'space:updated',
        percentage: 50,
    },
    {
        status: 'fail',
        id: '17689',
        operation: 'space:added',
        percentage: 75,
    },
];
eventData.map((event) => {
    return {
        data: {
            status: jsx(Status, { status: event.status }),
            id: jsx("div", { children: event.id }),
            operation: jsx(Pill, { children: event.operation }),
            timestamp: '00:00:00',
            durationPercentage: jsx(DurationBar, { duration: event.percentage }),
            durationTime: '30 sec',
        },
        key: event.id,
    };
});

const msToSeconds = (ms) => {
    if (ms === 0)
        return '0 seconds';
    if (ms < 1000)
        return 'Less than one second';
    let secondsTotal = Math.floor(ms / 1000);
    let minutes = Math.floor(secondsTotal / 60);
    let seconds = secondsTotal % 60;
    let minuteText = minutes > 0 ? `${minutes} min` + (minutes > 1 ? 's' : '') : '';
    let secondText = seconds > 0 ? `${seconds} second` + (seconds > 1 ? 's' : '') : '';
    // Combine the minuteText and secondText, but filter out empty strings and join with a space
    return [minuteText, secondText].filter(Boolean).join(' ');
};

const LogContainer = styled.div `
  display: flex;
  flex-direction: column;

  > div:first-of-type {
    margin-bottom: 8px;
  }
`;
const LogDetail = styled.div `
  display: grid;
  grid-template-columns: 54px 1fr;
  grid-column-gap: 16px;
  gap: 12px;
  margin-top: 8px;
  align-items: center;

  ${Pill} {
    max-width: fit-content;
  }
`;
const StatusWrap = styled.div `
  display: flex;
  gap: 8px;
  align-items: center;
`;
const dataRows = [
    {
        label: 'Status',
        value: 'success',
        render: (value) => (jsxs(StatusWrap, { children: [jsx(Status, { status: value ? 'success' : 'fail' }), jsx(Typography, { type: 'b2', children: value ? 'Success' : 'Failed' })] })),
    },
    // @ts-ignore
    { label: 'Topic', value: 'topic', render: (value) => jsx(Pill, { children: value }) },
    { label: 'Start time', value: 'createdAt' },
    {
        label: 'Duration',
        value: 'duration',
        render: (value) => (jsx(Typography, { type: 'b2', children: msToSeconds(value) })),
    },
];
const RenderRow = ({ row, value }) => (jsxs(React__default.Fragment, { children: [jsx(Typography, { type: 'actionSm', children: row.label }), row.render ? (row.render(value)) : (jsx(Typography, { type: 'b2', children: String(value) }))] }, row.label));
const EventLogDetail = (props) => {
    const { eventId, context, log: consoleLog } = props;
    return (jsxs(LogContainer, { children: [jsxs(Typography, { type: 'actionLg', children: ["Event ", eventId] }), jsx(LogDetail, { children: dataRows.map((row) => (jsx(RenderRow, { row: row, value: props[row.value] }, row.label))) }), context && (jsx(CodeSnippet, { onCopy: () => props.onCopy?.(JSON.stringify(context)), heading: 'Context', code: JSON.stringify(context, null, 2) })), jsx(CodeSnippet, { onCopy: consoleLog
                    ? () => props.onCopy?.(JSON.stringify(consoleLog))
                    : undefined, heading: 'Console log', code: consoleLog ?? 'No console logs to display', normalizeWhitespace: true })] }));
};

const HelloShared = () => {
    return jsx("div", { children: "Hello Shared" });
};

/**
 * Ensure test ids never have spaces
 */
const sanitizeTestId = (input) => {
    return input.replace(/\s+/g, '-').toLowerCase();
};

const fromMaybe = (value, defaultValue) => {
    if (value === undefined || value === null) {
        return defaultValue;
    }
    return value;
};

const PanelWrapper = styled.div `
  position: absolute;
  top: calc(var(--spacing-page-gutter) + 40px);
  right: var(--spacing-page-gutter);
  z-index: ${ZIndex.level1000};
  height: 85%;
  width: ${({ $width }) => ($width ? `${$width}px` : '400px')};
  background-color: var(--color-page);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  cursor: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: var(--color-text-dark);
`;
const PanelHeaderContainer = styled.div `
  display: flex;
  flex-direction: column;
  height: fit-content;
  padding: 20px 20px 16px;
  gap: 8px;
`;
const PanelHeaderRow = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const PanelHeader = styled.div `
  color: var(--color-title);
  ${getFont('h4')};
  font-family: var(--text-font);
`;
const PanelDescription = styled.div `
  ${getFont('b1')};
  font-family: var(--text-font);
`;
const PanelContent = styled.div `
  overflow-y: auto;
  height: 100%;
  padding: 0px 20px 20px;
`;
const PanelSectionHeader = styled.div `
  ${getFont('actionMd')}
  font-family: var(--text-font);
  ${({ $color }) => `color: ${fromMaybe($color, Colors$1.Pigeon800)};`}
  ${({ $borderColor }) => `border-bottom: 1px solid ${fromMaybe($borderColor, Colors$1.Pigeon200)};`}
  text-transform: uppercase;
  padding: 12px 16px 12px 24px;
`;
const PanelItem = styled.div `
  ${({ $borderColor }) => `border-bottom: 1px solid ${fromMaybe($borderColor, Colors$1.Pigeon200)};`}
  padding: 16px 0px;
`;

const Panel = ({ heading, description, onClose, children, $width, }) => {
    const ref = useRef(null);
    useOnClickOutside(ref, onClose);
    return (jsxs(PanelWrapper, { "data-testid": `${sanitizeTestId(heading)}-panel`, "$width": $width, ref: ref, className: 'shared-panel', children: [jsxs(PanelHeaderContainer, { children: [jsxs(PanelHeaderRow, { children: [jsx(PanelHeader, { children: heading }), jsx(IconButton, { "data-testid": 'close', name: 'cross', onPress: onClose })] }), description && jsx(PanelDescription, { children: description })] }), children] }));
};

const PopoverMessageWrapper = styled.div `
  width: 500px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;
const PopoverMessage = styled.span `
  white-space: nowrap;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;
const PopoverMessageFullWidth = styled.span ``;
const WarningIcon = styled(Icon) `
  align-self: center;
  color: var(--color-danger);
`;
const CheckmarkIcon = styled(Icon) `
  align-self: center;
  color: var(--color-success);
`;
const InfoIcon = styled(Icon) `
  align-self: center;
  color: var(--color-sky-600);
`;
const usePopover = () => {
    const [popoverContent, setPopoverContent] = useState();
    const hidePopover = useCallback(() => {
        setPopoverContent(undefined);
    }, [setPopoverContent]);
    const showPopover = useCallback((content, autoclose) => {
        setPopoverContent(content);
        if (autoclose)
            setTimeout(hidePopover, 8000);
    }, [setPopoverContent]);
    return { showPopover, hidePopover, popoverContent };
};

const InputCell = styled.div `
  margin-left: 0px;
`;
const ActionsCell = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 32px;
  min-width: 64px;
`;
const EmptyCell = styled.div `
  display: flex;
  align-items: center;
  height: 32px;
`;
const EmptyCellText = styled.div `
  width: 100%;
  display: inline-flex;
  position: absolute;

  a {
    margin-left: 4px;
    text-decoration: underline;
  }
`;
const ErrorMessage = styled.span `
  color: ${Colors$1.Pinata900};
`;

const secretsHeaders = [
    { key: 'name', content: 'Name', width: '41.8%' },
    { key: 'value', content: 'Secret Value', width: '41.8%' },
    { key: 'actions', content: '' },
];
const useKeyDown = (key, callback) => {
    const handleKeyDown = useCallback((e) => {
        if (e.key === key) {
            callback();
        }
    }, [key, callback]);
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};
const SecretsList = ({ title, description, secrets, overridingKeys = [], editable = false, deleteSecret, upsertSecret, emptyStatePhrase, error, loading, }) => {
    const { showPopover, hidePopover, popoverContent } = usePopover();
    const [rowToDelete, setRowToDelete] = useState(null);
    const [secretsData, setSecretsData] = useState(secrets);
    const [addRowData, setAddRowData] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const isCurrentlyEditing = editIndex !== null;
    const isCurrentlyAdding = addRowData !== null;
    const handleEditRow = (index) => () => {
        setEditIndex(index);
        setAddRowData({ ...secretsData[index], value: '' });
    };
    const [errors, setErrors] = useState([]);
    useEffect(() => {
        setSecretsData(secrets);
    }, [secrets]);
    const onError = (message, previousState) => (error) => {
        showPopover({
            icon: jsx(WarningIcon, { name: 'alertTriangle' }),
            message: jsx(PopoverMessage, { children: message }),
            onClose: hidePopover,
        }, true);
        setSecretsData(previousState);
    };
    const onSuccess = (message) => () => {
        showPopover({
            icon: jsx(CheckmarkIcon, { name: 'checkmark' }),
            message: jsx(PopoverMessage, { children: message }),
            onClose: hidePopover,
        }, true);
    };
    const preValidate = () => {
        let errors = [];
        if (!addRowData) {
            return errors;
        }
        const name = addRowData.name;
        if (!isCurrentlyEditing &&
            overridingKeys.concat(secretsData.map((x) => x.name)).includes(name)) {
            errors.push('A secret with this key already exists');
        }
        if (name && !name.match(/^[\s0-9a-zA-Z_-]+$/))
            errors.push('The secret name has to contain alphanumeric characters only');
        return errors;
    };
    const validate = () => {
        let errors = preValidate();
        if (addRowData) {
            const name = addRowData.name;
            if (name === '') {
                errors.push('Key cannot be empty');
            }
        }
        return errors;
    };
    const showAddRow = addRowData !== null;
    const handleAddRow = () => {
        setEditIndex(null);
        setAddRowData({
            name: '',
            value: '',
        });
    };
    useEffect(() => {
        setErrors(preValidate());
    }, [addRowData]);
    const handleSaveAddRow = async () => {
        if (!isCurrentlyEditing && !isCurrentlyAdding) {
            return;
        }
        const errors = validate();
        if (errors.length > 0) {
            setErrors(errors);
            return;
        }
        const name = addRowData.name;
        const value = addRowData.value;
        const previousState = [...secretsData];
        if (editIndex !== null) {
            const newData = [...secretsData];
            newData[editIndex] = {
                ...addRowData,
                resourceName: 'Wow Environment',
            };
            setSecretsData(newData);
            setEditIndex(null);
            setAddRowData(null);
        }
        else {
            setSecretsData([
                ...secretsData,
                { ...addRowData, resourceName: 'Wow Environment' },
            ]);
            setAddRowData(null);
        }
        await upsertSecret({ name: name, value: value }, {
            onError: onError(!isCurrentlyEditing
                ? `Failed to add secret ${name}`
                : `Failed to edit secret ${name}`, previousState),
            onSuccess: onSuccess(!isCurrentlyEditing
                ? `Successfully added secret ${name}`
                : `Sucessfully edited secret ${name}`),
        });
    };
    const handleCancelAddRow = () => {
        setAddRowData(null);
        setEditIndex(null);
    };
    const handleCancelDeleteRow = () => {
        setRowToDelete(null);
    };
    useKeyDown('Escape', handleCancelAddRow);
    useKeyDown('Enter', handleSaveAddRow);
    const deleteRow = (index) => {
        const newData = [...secretsData];
        newData.splice(index, 1);
        setSecretsData(newData);
    };
    const handleDeleteRow = async () => {
        if (rowToDelete !== null) {
            const rowIndex = rowToDelete;
            const name = secretsData[rowIndex].name;
            const id = secretsData[rowIndex].id;
            const previousState = [...secretsData];
            deleteRow(rowToDelete);
            setRowToDelete(null);
            await deleteSecret(id, {
                onError: onError(`Failed to delete secret ${name}`, previousState),
                onSuccess: onSuccess(`Successfully deleted secret ${name}`),
            });
        }
    };
    const onClickDeleteRow = (index) => () => {
        setRowToDelete(index);
    };
    const setKey = (n) => {
        setAddRowData({ ...addRowData, name: n });
    };
    const setValue = (n) => {
        setAddRowData({ ...addRowData, value: n });
    };
    const hasErrors = errors.length > 0;
    const newRow = {
        data: {
            name: (jsx(InputCell, { children: isCurrentlyEditing ? (addRowData?.name) : (jsx(TextInput, { "data-testid": 'key-input', size: 'md', minWidth: 10, error: hasErrors, value: addRowData?.name, placeholder: 'Enter key...', onChange: (n) => setKey(n) })) })),
            value: (jsx(InputCell, { children: jsx(TextInput, { "data-testid": 'value-input', size: 'md', minWidth: 10, error: hasErrors, value: addRowData?.value, placeholder: 'Enter value...', onChange: (n) => setValue(n) }) })),
            actions: (jsx("div", { children: editable && (jsxs(ActionsCell, { children: [jsx(IconButton, { variant: 'warning-ghost', onPress: handleCancelAddRow, "data-testid": 'cancel-button', name: 'xCircle' }), jsx(IconButton, { "data-testid": 'save-button', variant: 'confirm-ghost', onPress: handleSaveAddRow, isDisabled: hasErrors, name: 'checkmarkCircle' })] })) })),
        },
        key: 'add-secret',
        footer: hasErrors ? (jsx(ErrorMessage, { "data-testid": 'error-message', children: errors.join('\n') })) : undefined,
    };
    const displayData = secretsData.length == 0 && !showAddRow
        ? [
            {
                data: {
                    name: (jsx(EmptyCell, { children: jsx(EmptyCellText, { children: emptyStatePhrase }) })),
                    value: undefined,
                    actions: undefined,
                },
                key: '',
            },
        ]
        : secretsData.map((x, i) => {
            if (editIndex === i) {
                return newRow;
            }
            return {
                data: {
                    name: x.name,
                    value: jsx(Typography, { type: 'b2Mono', children: "\u25CF \u25CF \u25CF \u25CF \u25CF \u25CF \u25CF \u25CF \u25CF \u25CF" }),
                    actions: (jsx(ActionsCell, { className: 'show-on-hover', children: editable && !isCurrentlyEditing && !isCurrentlyAdding ? (jsxs(Fragment, { children: [jsx(IconButton, { "data-testid": 'edit', variant: 'tertiary', size: 16, onPress: handleEditRow(i), name: 'edit' }), jsx(IconButton, { "data-testid": 'delete', variant: 'warning-ghost', size: 16, onPress: onClickDeleteRow(i), name: 'trash' })] })) : null })),
                },
                key: x.name,
                // hoverable: !!editable && !isCurrentlyEditing && !isCurrentlyAdding,
                disabled: overridingKeys.includes(x.name),
            };
        });
    const placeholderRow = {
        data: {
            name: (jsx(EmptyCell, { children: jsx(IconButton, { "data-testid": 'add-secret', onPress: handleAddRow, name: 'plus', size: 16 }) })),
            value: jsx(Fragment, {}),
            actions: jsx(Fragment, {}),
        },
        key: 'placeholder-row',
        onClick: handleAddRow,
    };
    const secretsDataWithAdd = editable && !isCurrentlyEditing
        ? displayData.concat(showAddRow && editIndex == null ? [newRow] : [placeholderRow])
        : displayData;
    return (jsxs(Fragment, { children: [popoverContent && (jsx(Popover, { animation: PopoverAnimation.SlideUp, ...popoverContent })), rowToDelete !== null && (jsx(Modal, { "data-testid": 'delete-modal', onClose: handleCancelDeleteRow, content: jsxs(Fragment, { children: [jsxs(ModalHeader, { children: ["Delete ", secretsData[rowToDelete].name, "?"] }), jsxs(ModalButtonRow, { children: [jsx(ModalCloseButton, { "data-testid": 'cancel-delete', onClose: handleCancelDeleteRow, label: 'Cancel' }), jsx(Button, { variant: 'warning', loading: false, onPress: handleDeleteRow, "data-testid": 'delete-secret', label: 'Delete' })] })] }) })), jsx(List, { title: { title, description, type: 'actionLg' }, headers: secretsHeaders, data: secretsDataWithAdd, error: error, loading: loading, components: {
                    error: 'Could not get secrets, please try refreshing this page.',
                } })] }));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getAugmentedNamespace(n) {
  var f = n.default;
	if (typeof f == "function") {
		var a = function () {
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
freeGlobal$1 || freeSelf$1 || Function('return this')();

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
freeGlobal || freeSelf || Function('return this')();

function isDocumentVisible() {
  if (typeof document !== 'undefined' && typeof document.visibilityState !== 'undefined') {
    return document.visibilityState !== 'hidden';
  }

  return true;
}
function isOnline() {
  if (typeof navigator.onLine !== 'undefined') {
    return navigator.onLine;
  }

  return true;
}

var __read$e = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$e(arguments[i]));
  }

  return ar;
};

var __read$d = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$d(arguments[i]));
  }

  return ar;
};

// from swr
var listeners$1 = [];

var eventsBinded$1 = false;

if (typeof window !== 'undefined' && window.addEventListener && !eventsBinded$1) {
  var revalidate$1 = function revalidate() {
    if (!isDocumentVisible() || !isOnline()) return;

    for (var i = 0; i < listeners$1.length; i++) {
      var listener = listeners$1[i];
      listener();
    }
  };

  window.addEventListener('visibilitychange', revalidate$1, false);
  window.addEventListener('focus', revalidate$1, false); // only bind the events once

  eventsBinded$1 = true;
}

// from swr
var listeners = [];

var eventsBinded = false;

if (typeof window !== 'undefined' && window.addEventListener && !eventsBinded) {
  var revalidate = function revalidate() {
    if (!isDocumentVisible()) return;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }
  };

  window.addEventListener('visibilitychange', revalidate, false); // only bind the events once

  eventsBinded = true;
}

var __assign$e = undefined && undefined.__assign || function () {
  __assign$e = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$e.apply(this, arguments);
};

var __read$c = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$c(arguments[i]));
  }

  return ar;
};

var __assign$d = undefined && undefined.__assign || function () {
  __assign$d = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$d.apply(this, arguments);
};

undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read$b = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$b(arguments[i]));
  }

  return ar;
};

var __assign$c = undefined && undefined.__assign || function () {
  __assign$c = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$c.apply(this, arguments);
};

undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read$a = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$a(arguments[i]));
  }

  return ar;
};

var ConfigContext = /*#__PURE__*/React__default.createContext({});
ConfigContext.displayName = 'UseRequestConfigContext';

var __assign$b = undefined && undefined.__assign || function () {
  __assign$b = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$b.apply(this, arguments);
};

undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read$9 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$9(arguments[i]));
  }

  return ar;
};

ConfigContext.Provider; // UseAPIProvider 已经废弃，此处为了兼容 umijs 插件 plugin-request

var useUpdateEffect = function useUpdateEffect(effect, deps) {
  var isMounted = useRef(false);
  useEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      return effect();
    }
  }, deps);
};

var __read$8 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$8(arguments[i]));
  }

  return ar;
};

var __read$7 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$7(arguments[i]));
  }

  return ar;
};

undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

((function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver$1;
}))();

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __read$6 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

function isFunction(obj) {
  return typeof obj === 'function';
}

function createUseStorageState(nullishStorage) {
  function useStorageState(key, defaultValue) {
    var storage = nullishStorage;

    var _a = __read$6(useState(function () {
      return getStoredValue();
    }), 2),
        state = _a[0],
        setState = _a[1];

    useUpdateEffect(function () {
      setState(getStoredValue());
    }, [key]);

    function getStoredValue() {
      try {
        var raw = storage.getItem(key);

        if (raw) {
          return JSON.parse(raw);
        }
      } catch (e) {
        console.error(e);
      }

      if (isFunction(defaultValue)) {
        return defaultValue();
      }

      return defaultValue;
    }

    var updateState = useCallback(function (value) {
      if (typeof value === 'undefined') {
        storage.removeItem(key);
        setState(undefined);
      } else if (isFunction(value)) {
        var previousState = getStoredValue();
        var currentState = value(previousState);

        try {
          storage.setItem(key, JSON.stringify(currentState));
          setState(currentState);
        } catch (e) {
          console.error(e);
        }
      } else {
        try {
          storage.setItem(key, JSON.stringify(value));
          setState(value);
        } catch (e) {
          console.error(e);
        }
      }
    }, [key]);
    return [state, updateState];
  }

  if (!nullishStorage) {
    return function (_, defaultValue) {
      return [isFunction(defaultValue) ? defaultValue() : defaultValue, function () {}];
    };
  }

  return useStorageState;
}

var useLocalStorageState = createUseStorageState(typeof window === 'object' ? window.localStorage : null);

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __assign$a = undefined && undefined.__assign || function () {
  __assign$a = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$a.apply(this, arguments);
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __read$5 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$5(arguments[i]));
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __read$4 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$4(arguments[i]));
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var screenfull = {exports: {}};

/*!
* screenfull
* v5.2.0 - 2021-11-03
* (c) Sindre Sorhus; MIT License
*/

(function (module) {
	(function () {

		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = module.exports;

		var fn = (function () {
			var val;

			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'

				],
				// Old WebKit
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'

				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];

			var i = 0;
			var l = fnMap.length;
			var ret = {};

			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}

			return false;
		})();

		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};

		var screenfull = {
			request: function (element, options) {
				return new Promise(function (resolve, reject) {
					var onFullScreenEntered = function () {
						this.off('change', onFullScreenEntered);
						resolve();
					}.bind(this);

					this.on('change', onFullScreenEntered);

					element = element || document.documentElement;

					var returnPromise = element[fn.requestFullscreen](options);

					if (returnPromise instanceof Promise) {
						returnPromise.then(onFullScreenEntered).catch(reject);
					}
				}.bind(this));
			},
			exit: function () {
				return new Promise(function (resolve, reject) {
					if (!this.isFullscreen) {
						resolve();
						return;
					}

					var onFullScreenExit = function () {
						this.off('change', onFullScreenExit);
						resolve();
					}.bind(this);

					this.on('change', onFullScreenExit);

					var returnPromise = document[fn.exitFullscreen]();

					if (returnPromise instanceof Promise) {
						returnPromise.then(onFullScreenExit).catch(reject);
					}
				}.bind(this));
			},
			toggle: function (element, options) {
				return this.isFullscreen ? this.exit() : this.request(element, options);
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};

		if (!fn) {
			if (isCommonjs) {
				module.exports = {isEnabled: false};
			} else {
				window.screenfull = {isEnabled: false};
			}

			return;
		}

		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			isEnabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});

		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();
} (screenfull));

/* eslint no-empty: 0 */
undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * A local reference to the document.
 */
var document = window.document;


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  if (parent && parent.assignedSlot) {
    // If the parent is distributed in a <slot>, return the parent of a slot.
    return parent.assignedSlot.parentNode;
  }

  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __assign$9 = undefined && undefined.__assign || function () {
  __assign$9 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$9.apply(this, arguments);
};

undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read$3 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$3(arguments[i]));
  }

  return ar;
};

var __assign$8 = undefined && undefined.__assign || function () {
  __assign$8 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$8.apply(this, arguments);
};

var __assign$7 = undefined && undefined.__assign || function () {
  __assign$7 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$7.apply(this, arguments);
};

var __assign$6 = undefined && undefined.__assign || function () {
  __assign$6 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$6.apply(this, arguments);
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __assign$5 = undefined && undefined.__assign || function () {
  __assign$5 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$5.apply(this, arguments);
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __assign$4 = undefined && undefined.__assign || function () {
  __assign$4 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$4.apply(this, arguments);
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};
var initRect = {
  top: NaN,
  left: NaN,
  bottom: NaN,
  right: NaN,
  height: NaN,
  width: NaN
};

__assign$4({
  text: ''
}, initRect);

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __read$2 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$2(arguments[i]));
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var js_cookie = {exports: {}};

/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */

(function (module, exports) {
(function (factory) {
		var registeredInModuleLoader;
		{
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}

		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}

		function init (converter) {
			function api() {}

			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}

				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}

					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}

				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}

				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;

				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');

					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}

					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);

						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}

						jar[name] = cookie;

						if (key === name) {
							break;
						}
					} catch (e) {}
				}

				return key ? jar[key] : jar;
			}

			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};

			api.defaults = {};

			api.withConverter = init;

			return api;
		}

		return init(function () {});
	}));
} (js_cookie));

var __assign$3 = undefined && undefined.__assign || function () {
  __assign$3 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$3.apply(this, arguments);
};

undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __assign$2 = undefined && undefined.__assign || function () {
  __assign$2 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$2.apply(this, arguments);
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __assign$1 = undefined && undefined.__assign || function () {
  __assign$1 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$1.apply(this, arguments);
};

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var dayjs_min = {exports: {}};

(function (module, exports) {
	!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));
} (dayjs_min));

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};
var ReadyState;

(function (ReadyState) {
  ReadyState[ReadyState["Connecting"] = 0] = "Connecting";
  ReadyState[ReadyState["Open"] = 1] = "Open";
  ReadyState[ReadyState["Closing"] = 2] = "Closing";
  ReadyState[ReadyState["Closed"] = 3] = "Closed";
})(ReadyState || (ReadyState = {}));

undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read$1 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$1(arguments[i]));
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

const criticalBackground = Colors$1.Pinata100;
const criticalBorder = Colors$1.Pinata800;
const warningBackground = Colors$1.Sunflower100;
const warningBorder = Colors$1.Sunflower800;
const nominalBackground = Colors$1.Pigeon100;
const nominalBorder = Colors$1.Pigeon200;
const UsageBannerContainer = styled.div `
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 1rem;
  border: 1px solid
    ${(props) => props.severity == 'critical'
    ? criticalBorder
    : props.severity == 'nominal'
        ? nominalBorder
        : warningBorder};
  border-radius: 2px;
  margin-bottom: 1rem;
  background-color: ${(props) => props.severity == 'critical'
    ? criticalBackground
    : props.severity == 'nominal'
        ? nominalBackground
        : warningBackground};
`;
const Link = styled.a `
  color: var(--color-action);
`;
const UsageBanner = ({ filesUsageObject, pdvUsagePercentage, plan, billingUrl, }) => {
    const filesUsagePercentage = (filesUsageObject.used / filesUsageObject.limit) * 100;
    // the deciding metric is files unless there is a threshhold that pdv hits and files doesn't
    const decidingMetric = [50, 75, 90, 100]
        .map((threshold) => pdvUsagePercentage >= threshold &&
        !(filesUsagePercentage >= threshold))
        .indexOf(true) >= 0
        ? 'PDV'
        : 'files';
    const decidingPercentage = Math.round(decidingMetric == 'files' ? filesUsagePercentage : pdvUsagePercentage);
    const thresholdFn = (decidingPercentage) => decidingPercentage >= 100
        ? 100
        : decidingPercentage >= 90
            ? 90
            : decidingPercentage >= 75
                ? 75
                : 50;
    const threshold = thresholdFn(decidingPercentage);
    const displayUsageValue = decidingMetric == 'files'
        ? `${filesUsageObject.used} out of ${filesUsageObject.limit} files`
        : `${decidingPercentage}%`;
    if (plan == 'enterprise' || plan == 'pro-discount') {
        return null;
    }
    if (plan == 'pro') {
        return (jsx(PayGUsageBannerContent, { threshold: threshold, proPlan: true, billingUrl: billingUrl }));
    }
    if (plan == 'starter-payg') {
        return (jsx(PayGUsageBannerContent, { threshold: threshold, billingUrl: billingUrl }));
    }
    return (jsx(StarterUsageBannerContent, { threshold: threshold, displayUsageValue: displayUsageValue, decidingMetric: decidingMetric, billingUrl: billingUrl }));
};
const LinkToBilling = ({ text, billingUrl, }) => (jsx(Link, { href: billingUrl, target: '_blank', children: text }));
const PayGUsageBannerContent = ({ threshold, proPlan, billingUrl, }) => {
    const severity = 'nominal';
    const [dismissed, setDismissed] = useLocalStorageState('usage-banner-dismissed', false);
    const onDismiss = () => {
        setDismissed(true);
    };
    if (threshold !== 100) {
        return null;
    }
    if (dismissed) {
        return null;
    }
    return (jsxs(UsageBannerContainer, { "data-testid": 'usage-banner', severity: severity, children: [jsx("div", { children: proPlan ? (jsxs(Fragment, { children: ["You're currently on our standard, fixed-rate pay-as-you-go pricing. Want volume discounts?", ' ', jsx(LinkToBilling, { billingUrl: billingUrl, text: 'Choose one of our monthly volume usage plans and save.' })] })) : (jsxs(Fragment, { children: ["You're currently on our standard, fixed-rate pay-as-you-go pricing. Want volume discounts?", ' ', jsx(LinkToBilling, { billingUrl: billingUrl, text: 'Choose our Professional Plan and save' }), "."] })) }), jsx("div", { children: jsx(IconButton, { name: 'cross', "data-testid": 'dismiss-usage-banner', onPress: onDismiss }) })] }));
};
const StarterUsageBannerContent = ({ threshold, displayUsageValue, decidingMetric, billingUrl, }) => {
    const severity = threshold == 100
        ? 'critical'
        : threshold == 90
            ? 'warning'
            : threshold == 75
                ? 'warning'
                : 'nominal';
    const usageString = `You have utilized ${displayUsageValue} of your monthly free ${decidingMetric == 'files' ? 'file upload' : 'PDV'} allowance in your production environment`;
    const billingLinkString = (jsxs(Fragment, { children: [jsx(LinkToBilling, { billingUrl: billingUrl, text: 'enable pay-as-you-go' }), ' ', "billing or", ' ', jsx(LinkToBilling, { billingUrl: billingUrl, text: 'choose a subscription' }), ' ', "plan with volume discounts."] }));
    if (threshold == 50) {
        return (jsx(UsageBannerContainer, { severity: severity, children: jsxs("div", { children: [usageString, ". To increase the limit, ", billingLinkString] }) }));
    }
    if (threshold == 75) {
        return (jsx(UsageBannerContainer, { severity: severity, children: jsxs("div", { children: [usageString, ". Once you pass this limit you will no longer be able to process data. To increase the limit, ", billingLinkString] }) }));
    }
    if (threshold == 90) {
        return (jsx(UsageBannerContainer, { severity: severity, children: jsxs("div", { children: [usageString, ". Once you pass this limit you will no longer be able to process data. To continue to add data without interruptions,", ' ', billingLinkString] }) }));
    }
    return (jsx(UsageBannerContainer, { severity: severity, children: jsxs("div", { children: ["You've utilized all of your free allowance of ", decidingMetric, " for the month. Data imports will no longer be processed. To continue,", ' ', billingLinkString] }) }));
};

const PopoverContext = createContext({
    showPopover: () => { },
    hidePopover: () => { },
    showToast: () => { },
    hideToast: () => { },
});
const PopoverProvider = (props) => {
    const { showPopover, hidePopover, popoverContent } = usePopover();
    const { showPopover: showToast, hidePopover: hideToast, popoverContent: toastContent, } = usePopover();
    return (jsx(PopoverContext.Provider, { value: { hidePopover, showPopover, showToast, hideToast }, children: jsxs(Fragment, { children: [props.children, popoverContent && (jsx(Popover, { animation: PopoverAnimation.SlideUp, onClose: hidePopover, ...popoverContent })), toastContent && (jsx(Toast, { animation: ToastAnimation.SlideIn, onClose: hideToast, ...toastContent }))] }) }));
};

/**
 * @name useBillingAndUsageAccess
 * @description Custom hook to provide information about payments, usage
 * @returns
 */
// constants
const FREE_FILE_LIMIT = 50;
const FREE_PDV_LIMIT = 10_000_000;
// util methods
const getFilesUsageObject = (filesUsage, freeFileLimit) => ({
    used: filesUsage,
    limit: freeFileLimit,
});
const getPdvUsagePercentage = (pdvUsage, freePdvLimit) => (pdvUsage / freePdvLimit) * 100;
const getPlan = (plan) => plan.data?.plan;
const disabledLimitParams = {
    fileUploadLocked: false,
    sheetIsLocked: false,
    usageBannerProps: {
        filesUsageObject: { used: 0, limit: 0 },
        pdvUsagePercentage: 0,
        plan: 'pro-discount',
        billingUrl: `/billing`,
    },
    freeFileLimit: FREE_FILE_LIMIT,
    freePdvLimit: FREE_PDV_LIMIT,
};
const useBillingAndUsageAccess = ({ limitsData, planData, environment, isGuest, }) => {
    const isProduction = environment?.isProd || false;
    if (!limitsData || !planData || !isProduction) {
        // Return default response if data is still being fetched or if billing and limits are not enabled
        return {
            ...disabledLimitParams,
            fileUploadLocked: false,
            sheetIsLocked: false,
        };
    }
    // usage constants
    const filesUsage = fromMaybe(planData?.data?.files, 0);
    const pdvUsage = fromMaybe(planData?.data?.pdvs, 0);
    const fileUploadLocked = limitsData?.data?.fileUploadIsLockedUntilPayment ?? false;
    const sheetIsLocked = limitsData?.data?.sheetIsLockedUntilPayment ?? false;
    if (isGuest) {
        return { ...disabledLimitParams, fileUploadLocked, sheetIsLocked };
    }
    const plan = getPlan(planData);
    const baseResponse = {
        fileUploadLocked,
        sheetIsLocked,
        filesUsage,
        pdvUsage,
        freeFileLimit: FREE_FILE_LIMIT,
        freePdvLimit: FREE_PDV_LIMIT,
        usageBannerProps: {
            filesUsageObject: getFilesUsageObject(filesUsage, FREE_FILE_LIMIT),
            pdvUsagePercentage: getPdvUsagePercentage(pdvUsage, FREE_PDV_LIMIT),
            plan,
            billingUrl: '/billing',
        },
    };
    return baseResponse;
};

const copyToClipboard = async (text) => {
    if (text === undefined)
        return;
    await navigator.clipboard.writeText(text);
};

var ohm$1 = {};

Object.defineProperty(ohm$1, '__esModule', { value: true });

// --------------------------------------------------------------------

// --------------------------------------------------------------------
// Exports
// --------------------------------------------------------------------

function abstract(optMethodName) {
  const methodName = optMethodName || '';
  return function() {
    throw new Error(
        'this method ' +
        methodName +
        ' is abstract! ' +
        '(it has no implementation in class ' +
        this.constructor.name +
        ')',
    );
  };
}

function assert(cond, message) {
  if (!cond) {
    throw new Error(message || 'Assertion failed');
  }
}

// Define a lazily-computed, non-enumerable property named `propName`
// on the object `obj`. `getterFn` will be called to compute the value the
// first time the property is accessed.
function defineLazyProperty(obj, propName, getterFn) {
  let memo;
  Object.defineProperty(obj, propName, {
    get() {
      if (!memo) {
        memo = getterFn.call(this);
      }
      return memo;
    },
  });
}

function clone(obj) {
  if (obj) {
    return Object.assign({}, obj);
  }
  return obj;
}

function repeatFn(fn, n) {
  const arr = [];
  while (n-- > 0) {
    arr.push(fn());
  }
  return arr;
}

function repeatStr(str, n) {
  return new Array(n + 1).join(str);
}

function repeat(x, n) {
  return repeatFn(() => x, n);
}

function getDuplicates(array) {
  const duplicates = [];
  for (let idx = 0; idx < array.length; idx++) {
    const x = array[idx];
    if (array.lastIndexOf(x) !== idx && duplicates.indexOf(x) < 0) {
      duplicates.push(x);
    }
  }
  return duplicates;
}

function copyWithoutDuplicates(array) {
  const noDuplicates = [];
  array.forEach(entry => {
    if (noDuplicates.indexOf(entry) < 0) {
      noDuplicates.push(entry);
    }
  });
  return noDuplicates;
}

function isSyntactic(ruleName) {
  const firstChar = ruleName[0];
  return firstChar === firstChar.toUpperCase();
}

function isLexical(ruleName) {
  return !isSyntactic(ruleName);
}

function padLeft(str, len, optChar) {
  const ch = optChar || ' ';
  if (str.length < len) {
    return repeatStr(ch, len - str.length) + str;
  }
  return str;
}

// StringBuffer

function StringBuffer() {
  this.strings = [];
}

StringBuffer.prototype.append = function(str) {
  this.strings.push(str);
};

StringBuffer.prototype.contents = function() {
  return this.strings.join('');
};

const escapeUnicode = str => String.fromCodePoint(parseInt(str, 16));

function unescapeCodePoint(s) {
  if (s.charAt(0) === '\\') {
    switch (s.charAt(1)) {
      case 'b':
        return '\b';
      case 'f':
        return '\f';
      case 'n':
        return '\n';
      case 'r':
        return '\r';
      case 't':
        return '\t';
      case 'v':
        return '\v';
      case 'x':
        return escapeUnicode(s.slice(2, 4));
      case 'u':
        return s.charAt(2) === '{' ?
          escapeUnicode(s.slice(3, -1)) :
          escapeUnicode(s.slice(2, 6));
      default:
        return s.charAt(1);
    }
  } else {
    return s;
  }
}

// Helper for producing a description of an unknown object in a safe way.
// Especially useful for error messages where an unexpected type of object was encountered.
function unexpectedObjToString(obj) {
  if (obj == null) {
    return String(obj);
  }
  const baseToString = Object.prototype.toString.call(obj);
  try {
    let typeName;
    if (obj.constructor && obj.constructor.name) {
      typeName = obj.constructor.name;
    } else if (baseToString.indexOf('[object ') === 0) {
      typeName = baseToString.slice(8, -1); // Extract e.g. "Array" from "[object Array]".
    } else {
      typeName = typeof obj;
    }
    return typeName + ': ' + JSON.stringify(String(obj));
  } catch (e) {
    return baseToString;
  }
}

var common = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abstract: abstract,
  assert: assert,
  defineLazyProperty: defineLazyProperty,
  clone: clone,
  repeatFn: repeatFn,
  repeatStr: repeatStr,
  repeat: repeat,
  getDuplicates: getDuplicates,
  copyWithoutDuplicates: copyWithoutDuplicates,
  isSyntactic: isSyntactic,
  isLexical: isLexical,
  padLeft: padLeft,
  StringBuffer: StringBuffer,
  unescapeCodePoint: unescapeCodePoint,
  unexpectedObjToString: unexpectedObjToString
});

// These are just categories that are used in ES5/ES2015.
// The full list of Unicode categories is here: http://www.fileformat.info/info/unicode/category/index.htm.
const UnicodeCategories = {
  // Letters
  Lu: /\p{Lu}/u,
  Ll: /\p{Ll}/u,
  Lt: /\p{Lt}/u,
  Lm: /\p{Lm}/u,
  Lo: /\p{Lo}/u,

  // Numbers
  Nl: /\p{Nl}/u,
  Nd: /\p{Nd}/u,

  // Marks
  Mn: /\p{Mn}/u,
  Mc: /\p{Mc}/u,

  // Punctuation, Connector
  Pc: /\p{Pc}/u,

  // Separator, Space
  Zs: /\p{Zs}/u,

  // These two are not real Unicode categories, but our useful for Ohm.
  // L is a combination of all the letter categories.
  // Ltmo is a combination of Lt, Lm, and Lo.
  L: /\p{Letter}/u,
  Ltmo: /\p{Lt}|\p{Lm}|\p{Lo}/u,
};

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

// General stuff

class PExpr {
  constructor() {
    if (this.constructor === PExpr) {
      throw new Error("PExpr cannot be instantiated -- it's abstract");
    }
  }

  // Set the `source` property to the interval containing the source for this expression.
  withSource(interval) {
    if (interval) {
      this.source = interval.trimmed();
    }
    return this;
  }
}

// Any

const any = Object.create(PExpr.prototype);

// End

const end = Object.create(PExpr.prototype);

// Terminals

class Terminal extends PExpr {
  constructor(obj) {
    super();
    this.obj = obj;
  }
}

// Ranges

class Range extends PExpr {
  constructor(from, to) {
    super();
    this.from = from;
    this.to = to;
    // If either `from` or `to` is made up of multiple code units, then
    // the range should consume a full code point, not a single code unit.
    this.matchCodePoint = from.length > 1 || to.length > 1;
  }
}

// Parameters

class Param extends PExpr {
  constructor(index) {
    super();
    this.index = index;
  }
}

// Alternation

class Alt extends PExpr {
  constructor(terms) {
    super();
    this.terms = terms;
  }
}

// Extend is an implementation detail of rule extension

class Extend extends Alt {
  constructor(superGrammar, name, body) {
    const origBody = superGrammar.rules[name].body;
    super([body, origBody]);

    this.superGrammar = superGrammar;
    this.name = name;
    this.body = body;
  }
}

// Splice is an implementation detail of rule overriding with the `...` operator.
class Splice extends Alt {
  constructor(superGrammar, ruleName, beforeTerms, afterTerms) {
    const origBody = superGrammar.rules[ruleName].body;
    super([...beforeTerms, origBody, ...afterTerms]);

    this.superGrammar = superGrammar;
    this.ruleName = ruleName;
    this.expansionPos = beforeTerms.length;
  }
}

// Sequences

class Seq extends PExpr {
  constructor(factors) {
    super();
    this.factors = factors;
  }
}

// Iterators and optionals

class Iter extends PExpr {
  constructor(expr) {
    super();
    this.expr = expr;
  }
}

class Star extends Iter {}
class Plus extends Iter {}
class Opt extends Iter {}

Star.prototype.operator = '*';
Plus.prototype.operator = '+';
Opt.prototype.operator = '?';

Star.prototype.minNumMatches = 0;
Plus.prototype.minNumMatches = 1;
Opt.prototype.minNumMatches = 0;

Star.prototype.maxNumMatches = Number.POSITIVE_INFINITY;
Plus.prototype.maxNumMatches = Number.POSITIVE_INFINITY;
Opt.prototype.maxNumMatches = 1;

// Predicates

class Not extends PExpr {
  constructor(expr) {
    super();
    this.expr = expr;
  }
}

class Lookahead extends PExpr {
  constructor(expr) {
    super();
    this.expr = expr;
  }
}

// "Lexification"

class Lex extends PExpr {
  constructor(expr) {
    super();
    this.expr = expr;
  }
}

// Rule application

class Apply extends PExpr {
  constructor(ruleName, args = []) {
    super();
    this.ruleName = ruleName;
    this.args = args;
  }

  isSyntactic() {
    return isSyntactic(this.ruleName);
  }

  // This method just caches the result of `this.toString()` in a non-enumerable property.
  toMemoKey() {
    if (!this._memoKey) {
      Object.defineProperty(this, '_memoKey', {value: this.toString()});
    }
    return this._memoKey;
  }
}

// Unicode character

class UnicodeChar extends PExpr {
  constructor(category) {
    super();
    this.category = category;
    this.pattern = UnicodeCategories[category];
  }
}

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

function createError(message, optInterval) {
  let e;
  if (optInterval) {
    e = new Error(optInterval.getLineAndColumnMessage() + message);
    e.shortMessage = message;
    e.interval = optInterval;
  } else {
    e = new Error(message);
  }
  return e;
}

// ----------------- errors about intervals -----------------

function intervalSourcesDontMatch() {
  return createError("Interval sources don't match");
}

// ----------------- errors about grammars -----------------

// Grammar syntax error

function grammarSyntaxError(matchFailure) {
  const e = new Error();
  Object.defineProperty(e, 'message', {
    enumerable: true,
    get() {
      return matchFailure.message;
    },
  });
  Object.defineProperty(e, 'shortMessage', {
    enumerable: true,
    get() {
      return 'Expected ' + matchFailure.getExpectedText();
    },
  });
  e.interval = matchFailure.getInterval();
  return e;
}

// Undeclared grammar

function undeclaredGrammar(grammarName, namespace, interval) {
  const message = namespace ?
    `Grammar ${grammarName} is not declared in namespace '${namespace}'` :
    'Undeclared grammar ' + grammarName;
  return createError(message, interval);
}

// Duplicate grammar declaration

function duplicateGrammarDeclaration(grammar, namespace) {
  return createError('Grammar ' + grammar.name + ' is already declared in this namespace');
}

function grammarDoesNotSupportIncrementalParsing(grammar) {
  return createError(`Grammar '${grammar.name}' does not support incremental parsing`);
}

// ----------------- rules -----------------

// Undeclared rule

function undeclaredRule(ruleName, grammarName, optInterval) {
  return createError(
      'Rule ' + ruleName + ' is not declared in grammar ' + grammarName,
      optInterval,
  );
}

// Cannot override undeclared rule

function cannotOverrideUndeclaredRule(ruleName, grammarName, optSource) {
  return createError(
      'Cannot override rule ' + ruleName + ' because it is not declared in ' + grammarName,
      optSource,
  );
}

// Cannot extend undeclared rule

function cannotExtendUndeclaredRule(ruleName, grammarName, optSource) {
  return createError(
      'Cannot extend rule ' + ruleName + ' because it is not declared in ' + grammarName,
      optSource,
  );
}

// Duplicate rule declaration

function duplicateRuleDeclaration(ruleName, grammarName, declGrammarName, optSource) {
  let message =
    "Duplicate declaration for rule '" + ruleName + "' in grammar '" + grammarName + "'";
  if (grammarName !== declGrammarName) {
    message += " (originally declared in '" + declGrammarName + "')";
  }
  return createError(message, optSource);
}

// Wrong number of parameters

function wrongNumberOfParameters(ruleName, expected, actual, source) {
  return createError(
      'Wrong number of parameters for rule ' +
      ruleName +
      ' (expected ' +
      expected +
      ', got ' +
      actual +
      ')',
      source,
  );
}

// Wrong number of arguments

function wrongNumberOfArguments(ruleName, expected, actual, expr) {
  return createError(
      'Wrong number of arguments for rule ' +
      ruleName +
      ' (expected ' +
      expected +
      ', got ' +
      actual +
      ')',
      expr,
  );
}

// Duplicate parameter names

function duplicateParameterNames(ruleName, duplicates, source) {
  return createError(
      'Duplicate parameter names in rule ' + ruleName + ': ' + duplicates.join(', '),
      source,
  );
}

// Invalid parameter expression

function invalidParameter(ruleName, expr) {
  return createError(
      'Invalid parameter to rule ' +
      ruleName +
      ': ' +
      expr +
      ' has arity ' +
      expr.getArity() +
      ', but parameter expressions must have arity 1',
      expr.source,
  );
}

// Application of syntactic rule from lexical rule

const syntacticVsLexicalNote =
  'NOTE: A _syntactic rule_ is a rule whose name begins with a capital letter. ' +
  'See https://ohmjs.org/d/svl for more details.';

function applicationOfSyntacticRuleFromLexicalContext(ruleName, applyExpr) {
  return createError(
      'Cannot apply syntactic rule ' + ruleName + ' from here (inside a lexical context)',
      applyExpr.source,
  );
}

// Lexical rule application used with applySyntactic

function applySyntacticWithLexicalRuleApplication(applyExpr) {
  const {ruleName} = applyExpr;
  return createError(
      `applySyntactic is for syntactic rules, but '${ruleName}' is a lexical rule. ` +
      syntacticVsLexicalNote,
      applyExpr.source,
  );
}

// Application of applySyntactic in a syntactic context

function unnecessaryExperimentalApplySyntactic(applyExpr) {
  return createError(
      'applySyntactic is not required here (in a syntactic context)',
      applyExpr.source,
  );
}

// Incorrect argument type

function incorrectArgumentType(expectedType, expr) {
  return createError('Incorrect argument type: expected ' + expectedType, expr.source);
}

// Multiple instances of the super-splice operator (`...`) in the rule body.

function multipleSuperSplices(expr) {
  return createError("'...' can appear at most once in a rule body", expr.source);
}

// Unicode code point escapes

function invalidCodePoint(applyWrapper) {
  const node = applyWrapper._node;
  assert(node && node.isNonterminal() && node.ctorName === 'escapeChar_unicodeCodePoint');

  // Get an interval that covers all of the hex digits.
  const digitIntervals = applyWrapper.children.slice(1, -1).map(d => d.source);
  const fullInterval = digitIntervals[0].coverageWith(...digitIntervals.slice(1));
  return createError(
      `U+${fullInterval.contents} is not a valid Unicode code point`,
      fullInterval,
  );
}

// ----------------- Kleene operators -----------------

function kleeneExprHasNullableOperand(kleeneExpr, applicationStack) {
  const actuals =
    applicationStack.length > 0 ? applicationStack[applicationStack.length - 1].args : [];
  const expr = kleeneExpr.expr.substituteParams(actuals);
  let message =
    'Nullable expression ' +
    expr +
    " is not allowed inside '" +
    kleeneExpr.operator +
    "' (possible infinite loop)";
  if (applicationStack.length > 0) {
    const stackTrace = applicationStack
        .map(app => new Apply(app.ruleName, app.args))
        .join('\n');
    message += '\nApplication stack (most recent application last):\n' + stackTrace;
  }
  return createError(message, kleeneExpr.expr.source);
}

// ----------------- arity -----------------

function inconsistentArity(ruleName, expected, actual, expr) {
  return createError(
      'Rule ' +
      ruleName +
      ' involves an alternation which has inconsistent arity ' +
      '(expected ' +
      expected +
      ', got ' +
      actual +
      ')',
      expr.source,
  );
}

// ----------------- convenience -----------------

function multipleErrors(errors) {
  const messages = errors.map(e => e.message);
  return createError(['Errors:'].concat(messages).join('\n- '), errors[0].interval);
}

// ----------------- semantic -----------------

function missingSemanticAction(ctorName, name, type, stack) {
  let stackTrace = stack
      .slice(0, -1)
      .map(info => {
        const ans = '  ' + info[0].name + ' > ' + info[1];
        return info.length === 3 ? ans + " for '" + info[2] + "'" : ans;
      })
      .join('\n');
  stackTrace += '\n  ' + name + ' > ' + ctorName;

  let moreInfo = '';
  if (ctorName === '_iter') {
    moreInfo = [
      '\nNOTE: as of Ohm v16, there is no default action for iteration nodes — see ',
      '  https://ohmjs.org/d/dsa for details.',
    ].join('\n');
  }

  const message = [
    `Missing semantic action for '${ctorName}' in ${type} '${name}'.${moreInfo}`,
    'Action stack (most recent call last):',
    stackTrace,
  ].join('\n');

  const e = createError(message);
  e.name = 'missingSemanticAction';
  return e;
}

function throwErrors(errors) {
  if (errors.length === 1) {
    throw errors[0];
  }
  if (errors.length > 1) {
    throw multipleErrors(errors);
  }
}

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

// Given an array of numbers `arr`, return an array of the numbers as strings,
// right-justified and padded to the same length.
function padNumbersToEqualLength(arr) {
  let maxLen = 0;
  const strings = arr.map(n => {
    const str = n.toString();
    maxLen = Math.max(maxLen, str.length);
    return str;
  });
  return strings.map(s => padLeft(s, maxLen));
}

// Produce a new string that would be the result of copying the contents
// of the string `src` onto `dest` at offset `offest`.
function strcpy(dest, src, offset) {
  const origDestLen = dest.length;
  const start = dest.slice(0, offset);
  const end = dest.slice(offset + src.length);
  return (start + src + end).substr(0, origDestLen);
}

// Casts the underlying lineAndCol object to a formatted message string,
// highlighting `ranges`.
function lineAndColumnToMessage(...ranges) {
  const lineAndCol = this;
  const {offset} = lineAndCol;
  const {repeatStr} = common;

  const sb = new StringBuffer();
  sb.append('Line ' + lineAndCol.lineNum + ', col ' + lineAndCol.colNum + ':\n');

  // An array of the previous, current, and next line numbers as strings of equal length.
  const lineNumbers = padNumbersToEqualLength([
    lineAndCol.prevLine == null ? 0 : lineAndCol.lineNum - 1,
    lineAndCol.lineNum,
    lineAndCol.nextLine == null ? 0 : lineAndCol.lineNum + 1,
  ]);

  // Helper for appending formatting input lines to the buffer.
  const appendLine = (num, content, prefix) => {
    sb.append(prefix + lineNumbers[num] + ' | ' + content + '\n');
  };

  // Include the previous line for context if possible.
  if (lineAndCol.prevLine != null) {
    appendLine(0, lineAndCol.prevLine, '  ');
  }
  // Line that the error occurred on.
  appendLine(1, lineAndCol.line, '> ');

  // Build up the line that points to the offset and possible indicates one or more ranges.
  // Start with a blank line, and indicate each range by overlaying a string of `~` chars.
  const lineLen = lineAndCol.line.length;
  let indicationLine = repeatStr(' ', lineLen + 1);
  for (let i = 0; i < ranges.length; ++i) {
    let startIdx = ranges[i][0];
    let endIdx = ranges[i][1];
    assert(startIdx >= 0 && startIdx <= endIdx, 'range start must be >= 0 and <= end');

    const lineStartOffset = offset - lineAndCol.colNum + 1;
    startIdx = Math.max(0, startIdx - lineStartOffset);
    endIdx = Math.min(endIdx - lineStartOffset, lineLen);

    indicationLine = strcpy(indicationLine, repeatStr('~', endIdx - startIdx), startIdx);
  }
  const gutterWidth = 2 + lineNumbers[1].length + 3;
  sb.append(repeatStr(' ', gutterWidth));
  indicationLine = strcpy(indicationLine, '^', lineAndCol.colNum - 1);
  sb.append(indicationLine.replace(/ +$/, '') + '\n');

  // Include the next line for context if possible.
  if (lineAndCol.nextLine != null) {
    appendLine(2, lineAndCol.nextLine, '  ');
  }
  return sb.contents();
}

// --------------------------------------------------------------------
// Exports
// --------------------------------------------------------------------

let builtInRulesCallbacks = [];

// Since Grammar.BuiltInRules is bootstrapped, most of Ohm can't directly depend it.
// This function allows modules that do depend on the built-in rules to register a callback
// that will be called later in the initialization process.
function awaitBuiltInRules(cb) {
  builtInRulesCallbacks.push(cb);
}

function announceBuiltInRules(grammar) {
  builtInRulesCallbacks.forEach(cb => {
    cb(grammar);
  });
  builtInRulesCallbacks = null;
}

// Return an object with the line and column information for the given
// offset in `str`.
function getLineAndColumn(str, offset) {
  let lineNum = 1;
  let colNum = 1;

  let currOffset = 0;
  let lineStartOffset = 0;

  let nextLine = null;
  let prevLine = null;
  let prevLineStartOffset = -1;

  while (currOffset < offset) {
    const c = str.charAt(currOffset++);
    if (c === '\n') {
      lineNum++;
      colNum = 1;
      prevLineStartOffset = lineStartOffset;
      lineStartOffset = currOffset;
    } else if (c !== '\r') {
      colNum++;
    }
  }

  // Find the end of the target line.
  let lineEndOffset = str.indexOf('\n', lineStartOffset);
  if (lineEndOffset === -1) {
    lineEndOffset = str.length;
  } else {
    // Get the next line.
    const nextLineEndOffset = str.indexOf('\n', lineEndOffset + 1);
    nextLine =
      nextLineEndOffset === -1 ?
        str.slice(lineEndOffset) :
        str.slice(lineEndOffset, nextLineEndOffset);
    // Strip leading and trailing EOL char(s).
    nextLine = nextLine.replace(/^\r?\n/, '').replace(/\r$/, '');
  }

  // Get the previous line.
  if (prevLineStartOffset >= 0) {
    // Strip trailing EOL char(s).
    prevLine = str.slice(prevLineStartOffset, lineStartOffset).replace(/\r?\n$/, '');
  }

  // Get the target line, stripping a trailing carriage return if necessary.
  const line = str.slice(lineStartOffset, lineEndOffset).replace(/\r$/, '');

  return {
    offset,
    lineNum,
    colNum,
    line,
    prevLine,
    nextLine,
    toString: lineAndColumnToMessage,
  };
}

// Return a nicely-formatted string describing the line and column for the
// given offset in `str` highlighting `ranges`.
function getLineAndColumnMessage(str, offset, ...ranges) {
  return getLineAndColumn(str, offset).toString(...ranges);
}

const uniqueId = (() => {
  let idCounter = 0;
  return prefix => '' + prefix + idCounter++;
})();

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

class Interval {
  constructor(sourceString, startIdx, endIdx) {
    this.sourceString = sourceString;
    this.startIdx = startIdx;
    this.endIdx = endIdx;
  }

  get contents() {
    if (this._contents === undefined) {
      this._contents = this.sourceString.slice(this.startIdx, this.endIdx);
    }
    return this._contents;
  }

  get length() {
    return this.endIdx - this.startIdx;
  }

  coverageWith(...intervals) {
    return Interval.coverage(...intervals, this);
  }

  collapsedLeft() {
    return new Interval(this.sourceString, this.startIdx, this.startIdx);
  }

  collapsedRight() {
    return new Interval(this.sourceString, this.endIdx, this.endIdx);
  }

  getLineAndColumn() {
    return getLineAndColumn(this.sourceString, this.startIdx);
  }

  getLineAndColumnMessage() {
    const range = [this.startIdx, this.endIdx];
    return getLineAndColumnMessage(this.sourceString, this.startIdx, range);
  }

  // Returns an array of 0, 1, or 2 intervals that represents the result of the
  // interval difference operation.
  minus(that) {
    if (this.sourceString !== that.sourceString) {
      throw intervalSourcesDontMatch();
    } else if (this.startIdx === that.startIdx && this.endIdx === that.endIdx) {
      // `this` and `that` are the same interval!
      return [];
    } else if (this.startIdx < that.startIdx && that.endIdx < this.endIdx) {
      // `that` splits `this` into two intervals
      return [
        new Interval(this.sourceString, this.startIdx, that.startIdx),
        new Interval(this.sourceString, that.endIdx, this.endIdx),
      ];
    } else if (this.startIdx < that.endIdx && that.endIdx < this.endIdx) {
      // `that` contains a prefix of `this`
      return [new Interval(this.sourceString, that.endIdx, this.endIdx)];
    } else if (this.startIdx < that.startIdx && that.startIdx < this.endIdx) {
      // `that` contains a suffix of `this`
      return [new Interval(this.sourceString, this.startIdx, that.startIdx)];
    } else {
      // `that` and `this` do not overlap
      return [this];
    }
  }

  // Returns a new Interval that has the same extent as this one, but which is relative
  // to `that`, an Interval that fully covers this one.
  relativeTo(that) {
    if (this.sourceString !== that.sourceString) {
      throw intervalSourcesDontMatch();
    }
    assert(
        this.startIdx >= that.startIdx && this.endIdx <= that.endIdx,
        'other interval does not cover this one',
    );
    return new Interval(
        this.sourceString,
        this.startIdx - that.startIdx,
        this.endIdx - that.startIdx,
    );
  }

  // Returns a new Interval which contains the same contents as this one,
  // but with whitespace trimmed from both ends.
  trimmed() {
    const {contents} = this;
    const startIdx = this.startIdx + contents.match(/^\s*/)[0].length;
    const endIdx = this.endIdx - contents.match(/\s*$/)[0].length;
    return new Interval(this.sourceString, startIdx, endIdx);
  }

  subInterval(offset, len) {
    const newStartIdx = this.startIdx + offset;
    return new Interval(this.sourceString, newStartIdx, newStartIdx + len);
  }
}

Interval.coverage = function(firstInterval, ...intervals) {
  let {startIdx, endIdx} = firstInterval;
  for (const interval of intervals) {
    if (interval.sourceString !== firstInterval.sourceString) {
      throw intervalSourcesDontMatch();
    } else {
      startIdx = Math.min(startIdx, interval.startIdx);
      endIdx = Math.max(endIdx, interval.endIdx);
    }
  }
  return new Interval(firstInterval.sourceString, startIdx, endIdx);
};

const MAX_CHAR_CODE = 0xffff;

class InputStream {
  constructor(source) {
    this.source = source;
    this.pos = 0;
    this.examinedLength = 0;
  }

  atEnd() {
    const ans = this.pos >= this.source.length;
    this.examinedLength = Math.max(this.examinedLength, this.pos + 1);
    return ans;
  }

  next() {
    const ans = this.source[this.pos++];
    this.examinedLength = Math.max(this.examinedLength, this.pos);
    return ans;
  }

  nextCharCode() {
    const nextChar = this.next();
    return nextChar && nextChar.charCodeAt(0);
  }

  nextCodePoint() {
    const cp = this.source.slice(this.pos++).codePointAt(0);
    // If the code point is beyond plane 0, it takes up two characters.
    if (cp > MAX_CHAR_CODE) {
      this.pos += 1;
    }
    this.examinedLength = Math.max(this.examinedLength, this.pos);
    return cp;
  }

  matchString(s, optIgnoreCase) {
    let idx;
    if (optIgnoreCase) {
      /*
        Case-insensitive comparison is a tricky business. Some notable gotchas include the
        "Turkish I" problem (http://www.i18nguy.com/unicode/turkish-i18n.html) and the fact
        that the German Esszet (ß) turns into "SS" in upper case.

        This is intended to be a locale-invariant comparison, which means it may not obey
        locale-specific expectations (e.g. "i" => "İ").
       */
      for (idx = 0; idx < s.length; idx++) {
        const actual = this.next();
        const expected = s[idx];
        if (actual == null || actual.toUpperCase() !== expected.toUpperCase()) {
          return false;
        }
      }
      return true;
    }
    // Default is case-sensitive comparison.
    for (idx = 0; idx < s.length; idx++) {
      if (this.next() !== s[idx]) {
        return false;
      }
    }
    return true;
  }

  sourceSlice(startIdx, endIdx) {
    return this.source.slice(startIdx, endIdx);
  }

  interval(startIdx, optEndIdx) {
    return new Interval(this.source, startIdx, optEndIdx ? optEndIdx : this.pos);
  }
}

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

class MatchResult {
  constructor(
      matcher,
      input,
      startExpr,
      cst,
      cstOffset,
      rightmostFailurePosition,
      optRecordedFailures,
  ) {
    this.matcher = matcher;
    this.input = input;
    this.startExpr = startExpr;
    this._cst = cst;
    this._cstOffset = cstOffset;
    this._rightmostFailurePosition = rightmostFailurePosition;
    this._rightmostFailures = optRecordedFailures;

    if (this.failed()) {
      /* eslint-disable no-invalid-this */
      defineLazyProperty(this, 'message', function() {
        const detail = 'Expected ' + this.getExpectedText();
        return (
          getLineAndColumnMessage(this.input, this.getRightmostFailurePosition()) + detail
        );
      });
      defineLazyProperty(this, 'shortMessage', function() {
        const detail = 'expected ' + this.getExpectedText();
        const errorInfo = getLineAndColumn(
            this.input,
            this.getRightmostFailurePosition(),
        );
        return 'Line ' + errorInfo.lineNum + ', col ' + errorInfo.colNum + ': ' + detail;
      });
      /* eslint-enable no-invalid-this */
    }
  }

  succeeded() {
    return !!this._cst;
  }

  failed() {
    return !this.succeeded();
  }

  getRightmostFailurePosition() {
    return this._rightmostFailurePosition;
  }

  getRightmostFailures() {
    if (!this._rightmostFailures) {
      this.matcher.setInput(this.input);
      const matchResultWithFailures = this.matcher._match(this.startExpr, {
        tracing: false,
        positionToRecordFailures: this.getRightmostFailurePosition(),
      });
      this._rightmostFailures = matchResultWithFailures.getRightmostFailures();
    }
    return this._rightmostFailures;
  }

  toString() {
    return this.succeeded() ?
      '[match succeeded]' :
      '[match failed at position ' + this.getRightmostFailurePosition() + ']';
  }

  // Return a string summarizing the expected contents of the input stream when
  // the match failure occurred.
  getExpectedText() {
    if (this.succeeded()) {
      throw new Error('cannot get expected text of a successful MatchResult');
    }

    const sb = new StringBuffer();
    let failures = this.getRightmostFailures();

    // Filter out the fluffy failures to make the default error messages more useful
    failures = failures.filter(failure => !failure.isFluffy());

    for (let idx = 0; idx < failures.length; idx++) {
      if (idx > 0) {
        if (idx === failures.length - 1) {
          sb.append(failures.length > 2 ? ', or ' : ' or ');
        } else {
          sb.append(', ');
        }
      }
      sb.append(failures[idx].toString());
    }
    return sb.contents();
  }

  getInterval() {
    const pos = this.getRightmostFailurePosition();
    return new Interval(this.input, pos, pos);
  }
}

class PosInfo {
  constructor() {
    this.applicationMemoKeyStack = []; // active applications at this position
    this.memo = {};
    this.maxExaminedLength = 0;
    this.maxRightmostFailureOffset = -1;
    this.currentLeftRecursion = undefined;
  }

  isActive(application) {
    return this.applicationMemoKeyStack.indexOf(application.toMemoKey()) >= 0;
  }

  enter(application) {
    this.applicationMemoKeyStack.push(application.toMemoKey());
  }

  exit() {
    this.applicationMemoKeyStack.pop();
  }

  startLeftRecursion(headApplication, memoRec) {
    memoRec.isLeftRecursion = true;
    memoRec.headApplication = headApplication;
    memoRec.nextLeftRecursion = this.currentLeftRecursion;
    this.currentLeftRecursion = memoRec;

    const {applicationMemoKeyStack} = this;
    const indexOfFirstInvolvedRule =
      applicationMemoKeyStack.indexOf(headApplication.toMemoKey()) + 1;
    const involvedApplicationMemoKeys = applicationMemoKeyStack.slice(
        indexOfFirstInvolvedRule,
    );

    memoRec.isInvolved = function(applicationMemoKey) {
      return involvedApplicationMemoKeys.indexOf(applicationMemoKey) >= 0;
    };

    memoRec.updateInvolvedApplicationMemoKeys = function() {
      for (let idx = indexOfFirstInvolvedRule; idx < applicationMemoKeyStack.length; idx++) {
        const applicationMemoKey = applicationMemoKeyStack[idx];
        if (!this.isInvolved(applicationMemoKey)) {
          involvedApplicationMemoKeys.push(applicationMemoKey);
        }
      }
    };
  }

  endLeftRecursion() {
    this.currentLeftRecursion = this.currentLeftRecursion.nextLeftRecursion;
  }

  // Note: this method doesn't get called for the "head" of a left recursion -- for LR heads,
  // the memoized result (which starts out being a failure) is always used.
  shouldUseMemoizedResult(memoRec) {
    if (!memoRec.isLeftRecursion) {
      return true;
    }
    const {applicationMemoKeyStack} = this;
    for (let idx = 0; idx < applicationMemoKeyStack.length; idx++) {
      const applicationMemoKey = applicationMemoKeyStack[idx];
      if (memoRec.isInvolved(applicationMemoKey)) {
        return false;
      }
    }
    return true;
  }

  memoize(memoKey, memoRec) {
    this.memo[memoKey] = memoRec;
    this.maxExaminedLength = Math.max(this.maxExaminedLength, memoRec.examinedLength);
    this.maxRightmostFailureOffset = Math.max(
        this.maxRightmostFailureOffset,
        memoRec.rightmostFailureOffset,
    );
    return memoRec;
  }

  clearObsoleteEntries(pos, invalidatedIdx) {
    if (pos + this.maxExaminedLength <= invalidatedIdx) {
      // Optimization: none of the rule applications that were memoized here examined the
      // interval of the input that changed, so nothing has to be invalidated.
      return;
    }

    const {memo} = this;
    this.maxExaminedLength = 0;
    this.maxRightmostFailureOffset = -1;
    Object.keys(memo).forEach(k => {
      const memoRec = memo[k];
      if (pos + memoRec.examinedLength > invalidatedIdx) {
        delete memo[k];
      } else {
        this.maxExaminedLength = Math.max(this.maxExaminedLength, memoRec.examinedLength);
        this.maxRightmostFailureOffset = Math.max(
            this.maxRightmostFailureOffset,
            memoRec.rightmostFailureOffset,
        );
      }
    });
  }
}

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

// Unicode characters that are used in the `toString` output.
const BALLOT_X = '\u2717';
const CHECK_MARK = '\u2713';
const DOT_OPERATOR = '\u22C5';
const RIGHTWARDS_DOUBLE_ARROW = '\u21D2';
const SYMBOL_FOR_HORIZONTAL_TABULATION = '\u2409';
const SYMBOL_FOR_LINE_FEED = '\u240A';
const SYMBOL_FOR_CARRIAGE_RETURN = '\u240D';

const Flags = {
  succeeded: 1 << 0,
  isRootNode: 1 << 1,
  isImplicitSpaces: 1 << 2,
  isMemoized: 1 << 3,
  isHeadOfLeftRecursion: 1 << 4,
  terminatesLR: 1 << 5,
};

function spaces(n) {
  return repeat(' ', n).join('');
}

// Return a string representation of a portion of `input` at offset `pos`.
// The result will contain exactly `len` characters.
function getInputExcerpt(input, pos, len) {
  const excerpt = asEscapedString(input.slice(pos, pos + len));

  // Pad the output if necessary.
  if (excerpt.length < len) {
    return excerpt + repeat(' ', len - excerpt.length).join('');
  }
  return excerpt;
}

function asEscapedString(obj) {
  if (typeof obj === 'string') {
    // Replace non-printable characters with visible symbols.
    return obj
        .replace(/ /g, DOT_OPERATOR)
        .replace(/\t/g, SYMBOL_FOR_HORIZONTAL_TABULATION)
        .replace(/\n/g, SYMBOL_FOR_LINE_FEED)
        .replace(/\r/g, SYMBOL_FOR_CARRIAGE_RETURN);
  }
  return String(obj);
}

// ----------------- Trace -----------------

class Trace {
  constructor(input, pos1, pos2, expr, succeeded, bindings, optChildren) {
    this.input = input;
    this.pos = this.pos1 = pos1;
    this.pos2 = pos2;
    this.source = new Interval(input, pos1, pos2);
    this.expr = expr;
    this.bindings = bindings;
    this.children = optChildren || [];
    this.terminatingLREntry = null;

    this._flags = succeeded ? Flags.succeeded : 0;
  }

  get displayString() {
    return this.expr.toDisplayString();
  }

  clone() {
    return this.cloneWithExpr(this.expr);
  }

  cloneWithExpr(expr) {
    const ans = new Trace(
        this.input,
        this.pos,
        this.pos2,
        expr,
        this.succeeded,
        this.bindings,
        this.children,
    );

    ans.isHeadOfLeftRecursion = this.isHeadOfLeftRecursion;
    ans.isImplicitSpaces = this.isImplicitSpaces;
    ans.isMemoized = this.isMemoized;
    ans.isRootNode = this.isRootNode;
    ans.terminatesLR = this.terminatesLR;
    ans.terminatingLREntry = this.terminatingLREntry;
    return ans;
  }

  // Record the trace information for the terminating condition of the LR loop.
  recordLRTermination(ruleBodyTrace, value) {
    this.terminatingLREntry = new Trace(
        this.input,
        this.pos,
        this.pos2,
        this.expr,
        false,
        [value],
        [ruleBodyTrace],
    );
    this.terminatingLREntry.terminatesLR = true;
  }

  // Recursively traverse this trace node and all its descendents, calling a visitor function
  // for each node that is visited. If `vistorObjOrFn` is an object, then its 'enter' property
  // is a function to call before visiting the children of a node, and its 'exit' property is
  // a function to call afterwards. If `visitorObjOrFn` is a function, it represents the 'enter'
  // function.
  //
  // The functions are called with three arguments: the Trace node, its parent Trace, and a number
  // representing the depth of the node in the tree. (The root node has depth 0.) `optThisArg`, if
  // specified, is the value to use for `this` when executing the visitor functions.
  walk(visitorObjOrFn, optThisArg) {
    let visitor = visitorObjOrFn;
    if (typeof visitor === 'function') {
      visitor = {enter: visitor};
    }

    function _walk(node, parent, depth) {
      let recurse = true;
      if (visitor.enter) {
        if (visitor.enter.call(optThisArg, node, parent, depth) === Trace.prototype.SKIP) {
          recurse = false;
        }
      }
      if (recurse) {
        node.children.forEach(child => {
          _walk(child, node, depth + 1);
        });
        if (visitor.exit) {
          visitor.exit.call(optThisArg, node, parent, depth);
        }
      }
    }
    if (this.isRootNode) {
      // Don't visit the root node itself, only its children.
      this.children.forEach(c => {
        _walk(c, null, 0);
      });
    } else {
      _walk(this, null, 0);
    }
  }

  // Return a string representation of the trace.
  // Sample:
  //     12⋅+⋅2⋅*⋅3 ✓ exp ⇒  "12"
  //     12⋅+⋅2⋅*⋅3   ✓ addExp (LR) ⇒  "12"
  //     12⋅+⋅2⋅*⋅3       ✗ addExp_plus
  toString() {
    const sb = new StringBuffer();
    this.walk((node, parent, depth) => {
      if (!node) {
        return this.SKIP;
      }
      const ctorName = node.expr.constructor.name;
      // Don't print anything for Alt nodes.
      if (ctorName === 'Alt') {
        return; // eslint-disable-line consistent-return
      }
      sb.append(getInputExcerpt(node.input, node.pos, 10) + spaces(depth * 2 + 1));
      sb.append((node.succeeded ? CHECK_MARK : BALLOT_X) + ' ' + node.displayString);
      if (node.isHeadOfLeftRecursion) {
        sb.append(' (LR)');
      }
      if (node.succeeded) {
        const contents = asEscapedString(node.source.contents);
        sb.append(' ' + RIGHTWARDS_DOUBLE_ARROW + '  ');
        sb.append(typeof contents === 'string' ? '"' + contents + '"' : contents);
      }
      sb.append('\n');
    });
    return sb.contents();
  }
}

// A value that can be returned from visitor functions to indicate that a
// node should not be recursed into.
Trace.prototype.SKIP = {};

// For convenience, create a getter and setter for the boolean flags in `Flags`.
Object.keys(Flags).forEach(name => {
  const mask = Flags[name];
  Object.defineProperty(Trace.prototype, name, {
    get() {
      return (this._flags & mask) !== 0;
    },
    set(val) {
      if (val) {
        this._flags |= mask;
      } else {
        this._flags &= ~mask;
      }
    },
  });
});

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

/*
  Return true if we should skip spaces preceding this expression in a syntactic context.
*/
PExpr.prototype.allowsSkippingPrecedingSpace = abstract('allowsSkippingPrecedingSpace');

/*
  Generally, these are all first-order expressions and (with the exception of Apply)
  directly read from the input stream.
*/
any.allowsSkippingPrecedingSpace =
  end.allowsSkippingPrecedingSpace =
  Apply.prototype.allowsSkippingPrecedingSpace =
  Terminal.prototype.allowsSkippingPrecedingSpace =
  Range.prototype.allowsSkippingPrecedingSpace =
  UnicodeChar.prototype.allowsSkippingPrecedingSpace =
    function() {
      return true;
    };

/*
  Higher-order expressions that don't directly consume input.
*/
Alt.prototype.allowsSkippingPrecedingSpace =
  Iter.prototype.allowsSkippingPrecedingSpace =
  Lex.prototype.allowsSkippingPrecedingSpace =
  Lookahead.prototype.allowsSkippingPrecedingSpace =
  Not.prototype.allowsSkippingPrecedingSpace =
  Param.prototype.allowsSkippingPrecedingSpace =
  Seq.prototype.allowsSkippingPrecedingSpace =
    function() {
      return false;
    };

let BuiltInRules$1;

awaitBuiltInRules(g => {
  BuiltInRules$1 = g;
});

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

let lexifyCount;

PExpr.prototype.assertAllApplicationsAreValid = function(ruleName, grammar) {
  lexifyCount = 0;
  this._assertAllApplicationsAreValid(ruleName, grammar);
};

PExpr.prototype._assertAllApplicationsAreValid = abstract(
    '_assertAllApplicationsAreValid',
);

any._assertAllApplicationsAreValid =
  end._assertAllApplicationsAreValid =
  Terminal.prototype._assertAllApplicationsAreValid =
  Range.prototype._assertAllApplicationsAreValid =
  Param.prototype._assertAllApplicationsAreValid =
  UnicodeChar.prototype._assertAllApplicationsAreValid =
    function(ruleName, grammar) {
      // no-op
    };

Lex.prototype._assertAllApplicationsAreValid = function(ruleName, grammar) {
  lexifyCount++;
  this.expr._assertAllApplicationsAreValid(ruleName, grammar);
  lexifyCount--;
};

Alt.prototype._assertAllApplicationsAreValid = function(ruleName, grammar) {
  for (let idx = 0; idx < this.terms.length; idx++) {
    this.terms[idx]._assertAllApplicationsAreValid(ruleName, grammar);
  }
};

Seq.prototype._assertAllApplicationsAreValid = function(ruleName, grammar) {
  for (let idx = 0; idx < this.factors.length; idx++) {
    this.factors[idx]._assertAllApplicationsAreValid(ruleName, grammar);
  }
};

Iter.prototype._assertAllApplicationsAreValid =
  Not.prototype._assertAllApplicationsAreValid =
  Lookahead.prototype._assertAllApplicationsAreValid =
    function(ruleName, grammar) {
      this.expr._assertAllApplicationsAreValid(ruleName, grammar);
    };

Apply.prototype._assertAllApplicationsAreValid = function(
    ruleName,
    grammar,
    skipSyntacticCheck = false,
) {
  const ruleInfo = grammar.rules[this.ruleName];
  const isContextSyntactic = isSyntactic(ruleName) && lexifyCount === 0;

  // Make sure that the rule exists...
  if (!ruleInfo) {
    throw undeclaredRule(this.ruleName, grammar.name, this.source);
  }

  // ...and that this application is allowed
  if (!skipSyntacticCheck && isSyntactic(this.ruleName) && !isContextSyntactic) {
    throw applicationOfSyntacticRuleFromLexicalContext(this.ruleName, this);
  }

  // ...and that this application has the correct number of arguments.
  const actual = this.args.length;
  const expected = ruleInfo.formals.length;
  if (actual !== expected) {
    throw wrongNumberOfArguments(this.ruleName, expected, actual, this.source);
  }

  const isBuiltInApplySyntactic =
    BuiltInRules$1 && ruleInfo === BuiltInRules$1.rules.applySyntactic;
  const isBuiltInCaseInsensitive =
    BuiltInRules$1 && ruleInfo === BuiltInRules$1.rules.caseInsensitive;

  // If it's an application of 'caseInsensitive', ensure that the argument is a Terminal.
  if (isBuiltInCaseInsensitive) {
    if (!(this.args[0] instanceof Terminal)) {
      throw incorrectArgumentType('a Terminal (e.g. "abc")', this.args[0]);
    }
  }

  if (isBuiltInApplySyntactic) {
    const arg = this.args[0];
    if (!(arg instanceof Apply)) {
      throw incorrectArgumentType('a syntactic rule application', arg);
    }
    if (!isSyntactic(arg.ruleName)) {
      throw applySyntacticWithLexicalRuleApplication(arg);
    }
    if (isContextSyntactic) {
      throw unnecessaryExperimentalApplySyntactic(this);
    }
  }

  // ...and that all of the argument expressions only have valid applications and have arity 1.
  // If `this` is an application of the built-in applySyntactic rule, then its arg is
  // allowed (and expected) to be a syntactic rule, even if we're in a lexical context.
  this.args.forEach(arg => {
    arg._assertAllApplicationsAreValid(ruleName, grammar, isBuiltInApplySyntactic);
    if (arg.getArity() !== 1) {
      throw invalidParameter(this.ruleName, arg);
    }
  });
};

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

PExpr.prototype.assertChoicesHaveUniformArity = abstract(
    'assertChoicesHaveUniformArity',
);

any.assertChoicesHaveUniformArity =
  end.assertChoicesHaveUniformArity =
  Terminal.prototype.assertChoicesHaveUniformArity =
  Range.prototype.assertChoicesHaveUniformArity =
  Param.prototype.assertChoicesHaveUniformArity =
  Lex.prototype.assertChoicesHaveUniformArity =
  UnicodeChar.prototype.assertChoicesHaveUniformArity =
    function(ruleName) {
      // no-op
    };

Alt.prototype.assertChoicesHaveUniformArity = function(ruleName) {
  if (this.terms.length === 0) {
    return;
  }
  const arity = this.terms[0].getArity();
  for (let idx = 0; idx < this.terms.length; idx++) {
    const term = this.terms[idx];
    term.assertChoicesHaveUniformArity();
    const otherArity = term.getArity();
    if (arity !== otherArity) {
      throw inconsistentArity(ruleName, arity, otherArity, term);
    }
  }
};

Extend.prototype.assertChoicesHaveUniformArity = function(ruleName) {
  // Extend is a special case of Alt that's guaranteed to have exactly two
  // cases: [extensions, origBody].
  const actualArity = this.terms[0].getArity();
  const expectedArity = this.terms[1].getArity();
  if (actualArity !== expectedArity) {
    throw inconsistentArity(ruleName, expectedArity, actualArity, this.terms[0]);
  }
};

Seq.prototype.assertChoicesHaveUniformArity = function(ruleName) {
  for (let idx = 0; idx < this.factors.length; idx++) {
    this.factors[idx].assertChoicesHaveUniformArity(ruleName);
  }
};

Iter.prototype.assertChoicesHaveUniformArity = function(ruleName) {
  this.expr.assertChoicesHaveUniformArity(ruleName);
};

Not.prototype.assertChoicesHaveUniformArity = function(ruleName) {
  // no-op (not required b/c the nested expr doesn't show up in the CST)
};

Lookahead.prototype.assertChoicesHaveUniformArity = function(ruleName) {
  this.expr.assertChoicesHaveUniformArity(ruleName);
};

Apply.prototype.assertChoicesHaveUniformArity = function(ruleName) {
  // The arities of the parameter expressions is required to be 1 by
  // `assertAllApplicationsAreValid()`.
};

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

PExpr.prototype.assertIteratedExprsAreNotNullable = abstract(
    'assertIteratedExprsAreNotNullable',
);

any.assertIteratedExprsAreNotNullable =
  end.assertIteratedExprsAreNotNullable =
  Terminal.prototype.assertIteratedExprsAreNotNullable =
  Range.prototype.assertIteratedExprsAreNotNullable =
  Param.prototype.assertIteratedExprsAreNotNullable =
  UnicodeChar.prototype.assertIteratedExprsAreNotNullable =
    function(grammar) {
      // no-op
    };

Alt.prototype.assertIteratedExprsAreNotNullable = function(grammar) {
  for (let idx = 0; idx < this.terms.length; idx++) {
    this.terms[idx].assertIteratedExprsAreNotNullable(grammar);
  }
};

Seq.prototype.assertIteratedExprsAreNotNullable = function(grammar) {
  for (let idx = 0; idx < this.factors.length; idx++) {
    this.factors[idx].assertIteratedExprsAreNotNullable(grammar);
  }
};

Iter.prototype.assertIteratedExprsAreNotNullable = function(grammar) {
  // Note: this is the implementation of this method for `Star` and `Plus` expressions.
  // It is overridden for `Opt` below.
  this.expr.assertIteratedExprsAreNotNullable(grammar);
  if (this.expr.isNullable(grammar)) {
    throw kleeneExprHasNullableOperand(this, []);
  }
};

Opt.prototype.assertIteratedExprsAreNotNullable =
  Not.prototype.assertIteratedExprsAreNotNullable =
  Lookahead.prototype.assertIteratedExprsAreNotNullable =
  Lex.prototype.assertIteratedExprsAreNotNullable =
    function(grammar) {
      this.expr.assertIteratedExprsAreNotNullable(grammar);
    };

Apply.prototype.assertIteratedExprsAreNotNullable = function(grammar) {
  this.args.forEach(arg => {
    arg.assertIteratedExprsAreNotNullable(grammar);
  });
};

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

class Node$1 {
  constructor(matchLength) {
    this.matchLength = matchLength;
  }

  get ctorName() {
    throw new Error('subclass responsibility');
  }

  numChildren() {
    return this.children ? this.children.length : 0;
  }

  childAt(idx) {
    if (this.children) {
      return this.children[idx];
    }
  }

  indexOfChild(arg) {
    return this.children.indexOf(arg);
  }

  hasChildren() {
    return this.numChildren() > 0;
  }

  hasNoChildren() {
    return !this.hasChildren();
  }

  onlyChild() {
    if (this.numChildren() !== 1) {
      throw new Error(
          'cannot get only child of a node of type ' +
          this.ctorName +
          ' (it has ' +
          this.numChildren() +
          ' children)',
      );
    } else {
      return this.firstChild();
    }
  }

  firstChild() {
    if (this.hasNoChildren()) {
      throw new Error(
          'cannot get first child of a ' + this.ctorName + ' node, which has no children',
      );
    } else {
      return this.childAt(0);
    }
  }

  lastChild() {
    if (this.hasNoChildren()) {
      throw new Error(
          'cannot get last child of a ' + this.ctorName + ' node, which has no children',
      );
    } else {
      return this.childAt(this.numChildren() - 1);
    }
  }

  childBefore(child) {
    const childIdx = this.indexOfChild(child);
    if (childIdx < 0) {
      throw new Error('Node.childBefore() called w/ an argument that is not a child');
    } else if (childIdx === 0) {
      throw new Error('cannot get child before first child');
    } else {
      return this.childAt(childIdx - 1);
    }
  }

  childAfter(child) {
    const childIdx = this.indexOfChild(child);
    if (childIdx < 0) {
      throw new Error('Node.childAfter() called w/ an argument that is not a child');
    } else if (childIdx === this.numChildren() - 1) {
      throw new Error('cannot get child after last child');
    } else {
      return this.childAt(childIdx + 1);
    }
  }

  isTerminal() {
    return false;
  }

  isNonterminal() {
    return false;
  }

  isIteration() {
    return false;
  }

  isOptional() {
    return false;
  }
}

// Terminals

class TerminalNode extends Node$1 {
  get ctorName() {
    return '_terminal';
  }

  isTerminal() {
    return true;
  }

  get primitiveValue() {
    throw new Error('The `primitiveValue` property was removed in Ohm v17.');
  }
}

// Nonterminals

class NonterminalNode extends Node$1 {
  constructor(ruleName, children, childOffsets, matchLength) {
    super(matchLength);
    this.ruleName = ruleName;
    this.children = children;
    this.childOffsets = childOffsets;
  }

  get ctorName() {
    return this.ruleName;
  }

  isNonterminal() {
    return true;
  }

  isLexical() {
    return isLexical(this.ctorName);
  }

  isSyntactic() {
    return isSyntactic(this.ctorName);
  }
}

// Iterations

class IterationNode extends Node$1 {
  constructor(children, childOffsets, matchLength, isOptional) {
    super(matchLength);
    this.children = children;
    this.childOffsets = childOffsets;
    this.optional = isOptional;
  }

  get ctorName() {
    return '_iter';
  }

  isIteration() {
    return true;
  }

  isOptional() {
    return this.optional;
  }
}

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

/*
  Evaluate the expression and return `true` if it succeeds, `false` otherwise. This method should
  only be called directly by `State.prototype.eval(expr)`, which also updates the data structures
  that are used for tracing. (Making those updates in a method of `State` enables the trace-specific
  data structures to be "secrets" of that class, which is good for modularity.)

  The contract of this method is as follows:
  * When the return value is `true`,
    - the state object will have `expr.getArity()` more bindings than it did before the call.
  * When the return value is `false`,
    - the state object may have more bindings than it did before the call, and
    - its input stream's position may be anywhere.

  Note that `State.prototype.eval(expr)`, unlike this method, guarantees that neither the state
  object's bindings nor its input stream's position will change if the expression fails to match.
*/
PExpr.prototype.eval = abstract('eval'); // function(state) { ... }

any.eval = function(state) {
  const {inputStream} = state;
  const origPos = inputStream.pos;
  const cp = inputStream.nextCodePoint();
  if (cp !== undefined) {
    state.pushBinding(new TerminalNode(String.fromCodePoint(cp).length), origPos);
    return true;
  } else {
    state.processFailure(origPos, this);
    return false;
  }
};

end.eval = function(state) {
  const {inputStream} = state;
  const origPos = inputStream.pos;
  if (inputStream.atEnd()) {
    state.pushBinding(new TerminalNode(0), origPos);
    return true;
  } else {
    state.processFailure(origPos, this);
    return false;
  }
};

Terminal.prototype.eval = function(state) {
  const {inputStream} = state;
  const origPos = inputStream.pos;
  if (!inputStream.matchString(this.obj)) {
    state.processFailure(origPos, this);
    return false;
  } else {
    state.pushBinding(new TerminalNode(this.obj.length), origPos);
    return true;
  }
};

Range.prototype.eval = function(state) {
  const {inputStream} = state;
  const origPos = inputStream.pos;

  // A range can operate in one of two modes: matching a single, 16-bit _code unit_,
  // or matching a _code point_. (Code points over 0xFFFF take up two 16-bit code units.)
  const cp = this.matchCodePoint ? inputStream.nextCodePoint() : inputStream.nextCharCode();

  // Always compare by code point value to get the correct result in all scenarios.
  // Note that for strings of length 1, codePointAt(0) and charPointAt(0) are equivalent.
  if (cp !== undefined && this.from.codePointAt(0) <= cp && cp <= this.to.codePointAt(0)) {
    state.pushBinding(new TerminalNode(String.fromCodePoint(cp).length), origPos);
    return true;
  } else {
    state.processFailure(origPos, this);
    return false;
  }
};

Param.prototype.eval = function(state) {
  return state.eval(state.currentApplication().args[this.index]);
};

Lex.prototype.eval = function(state) {
  state.enterLexifiedContext();
  const ans = state.eval(this.expr);
  state.exitLexifiedContext();
  return ans;
};

Alt.prototype.eval = function(state) {
  for (let idx = 0; idx < this.terms.length; idx++) {
    if (state.eval(this.terms[idx])) {
      return true;
    }
  }
  return false;
};

Seq.prototype.eval = function(state) {
  for (let idx = 0; idx < this.factors.length; idx++) {
    const factor = this.factors[idx];
    if (!state.eval(factor)) {
      return false;
    }
  }
  return true;
};

Iter.prototype.eval = function(state) {
  const {inputStream} = state;
  const origPos = inputStream.pos;
  const arity = this.getArity();
  const cols = [];
  const colOffsets = [];
  while (cols.length < arity) {
    cols.push([]);
    colOffsets.push([]);
  }

  let numMatches = 0;
  let prevPos = origPos;
  let idx;
  while (numMatches < this.maxNumMatches && state.eval(this.expr)) {
    if (inputStream.pos === prevPos) {
      throw kleeneExprHasNullableOperand(this, state._applicationStack);
    }
    prevPos = inputStream.pos;
    numMatches++;
    const row = state._bindings.splice(state._bindings.length - arity, arity);
    const rowOffsets = state._bindingOffsets.splice(
        state._bindingOffsets.length - arity,
        arity,
    );
    for (idx = 0; idx < row.length; idx++) {
      cols[idx].push(row[idx]);
      colOffsets[idx].push(rowOffsets[idx]);
    }
  }
  if (numMatches < this.minNumMatches) {
    return false;
  }
  let offset = state.posToOffset(origPos);
  let matchLength = 0;
  if (numMatches > 0) {
    const lastCol = cols[arity - 1];
    const lastColOffsets = colOffsets[arity - 1];

    const endOffset =
      lastColOffsets[lastColOffsets.length - 1] + lastCol[lastCol.length - 1].matchLength;
    offset = colOffsets[0][0];
    matchLength = endOffset - offset;
  }
  const isOptional = this instanceof Opt;
  for (idx = 0; idx < cols.length; idx++) {
    state._bindings.push(
        new IterationNode(cols[idx], colOffsets[idx], matchLength, isOptional),
    );
    state._bindingOffsets.push(offset);
  }
  return true;
};

Not.prototype.eval = function(state) {
  /*
    TODO:
    - Right now we're just throwing away all of the failures that happen inside a `not`, and
      recording `this` as a failed expression.
    - Double negation should be equivalent to lookahead, but that's not the case right now wrt
      failures. E.g., ~~'foo' produces a failure for ~~'foo', but maybe it should produce
      a failure for 'foo' instead.
  */

  const {inputStream} = state;
  const origPos = inputStream.pos;
  state.pushFailuresInfo();

  const ans = state.eval(this.expr);

  state.popFailuresInfo();
  if (ans) {
    state.processFailure(origPos, this);
    return false;
  }

  inputStream.pos = origPos;
  return true;
};

Lookahead.prototype.eval = function(state) {
  const {inputStream} = state;
  const origPos = inputStream.pos;
  if (state.eval(this.expr)) {
    inputStream.pos = origPos;
    return true;
  } else {
    return false;
  }
};

Apply.prototype.eval = function(state) {
  const caller = state.currentApplication();
  const actuals = caller ? caller.args : [];
  const app = this.substituteParams(actuals);

  const posInfo = state.getCurrentPosInfo();
  if (posInfo.isActive(app)) {
    // This rule is already active at this position, i.e., it is left-recursive.
    return app.handleCycle(state);
  }

  const memoKey = app.toMemoKey();
  const memoRec = posInfo.memo[memoKey];

  if (memoRec && posInfo.shouldUseMemoizedResult(memoRec)) {
    if (state.hasNecessaryInfo(memoRec)) {
      return state.useMemoizedResult(state.inputStream.pos, memoRec);
    }
    delete posInfo.memo[memoKey];
  }
  return app.reallyEval(state);
};

Apply.prototype.handleCycle = function(state) {
  const posInfo = state.getCurrentPosInfo();
  const {currentLeftRecursion} = posInfo;
  const memoKey = this.toMemoKey();
  let memoRec = posInfo.memo[memoKey];

  if (currentLeftRecursion && currentLeftRecursion.headApplication.toMemoKey() === memoKey) {
    // We already know about this left recursion, but it's possible there are "involved
    // applications" that we don't already know about, so...
    memoRec.updateInvolvedApplicationMemoKeys();
  } else if (!memoRec) {
    // New left recursion detected! Memoize a failure to try to get a seed parse.
    memoRec = posInfo.memoize(memoKey, {
      matchLength: 0,
      examinedLength: 0,
      value: false,
      rightmostFailureOffset: -1,
    });
    posInfo.startLeftRecursion(this, memoRec);
  }
  return state.useMemoizedResult(state.inputStream.pos, memoRec);
};

Apply.prototype.reallyEval = function(state) {
  const {inputStream} = state;
  const origPos = inputStream.pos;
  const origPosInfo = state.getCurrentPosInfo();
  const ruleInfo = state.grammar.rules[this.ruleName];
  const {body} = ruleInfo;
  const {description} = ruleInfo;

  state.enterApplication(origPosInfo, this);

  if (description) {
    state.pushFailuresInfo();
  }

  // Reset the input stream's examinedLength property so that we can track
  // the examined length of this particular application.
  const origInputStreamExaminedLength = inputStream.examinedLength;
  inputStream.examinedLength = 0;

  let value = this.evalOnce(body, state);
  const currentLR = origPosInfo.currentLeftRecursion;
  const memoKey = this.toMemoKey();
  const isHeadOfLeftRecursion = currentLR && currentLR.headApplication.toMemoKey() === memoKey;
  let memoRec;

  if (state.doNotMemoize) {
    state.doNotMemoize = false;
  } else if (isHeadOfLeftRecursion) {
    value = this.growSeedResult(body, state, origPos, currentLR, value);
    origPosInfo.endLeftRecursion();
    memoRec = currentLR;
    memoRec.examinedLength = inputStream.examinedLength - origPos;
    memoRec.rightmostFailureOffset = state._getRightmostFailureOffset();
    origPosInfo.memoize(memoKey, memoRec); // updates origPosInfo's maxExaminedLength
  } else if (!currentLR || !currentLR.isInvolved(memoKey)) {
    // This application is not involved in left recursion, so it's ok to memoize it.
    memoRec = origPosInfo.memoize(memoKey, {
      matchLength: inputStream.pos - origPos,
      examinedLength: inputStream.examinedLength - origPos,
      value,
      failuresAtRightmostPosition: state.cloneRecordedFailures(),
      rightmostFailureOffset: state._getRightmostFailureOffset(),
    });
  }
  const succeeded = !!value;

  if (description) {
    state.popFailuresInfo();
    if (!succeeded) {
      state.processFailure(origPos, this);
    }
    if (memoRec) {
      memoRec.failuresAtRightmostPosition = state.cloneRecordedFailures();
    }
  }

  // Record trace information in the memo table, so that it is available if the memoized result
  // is used later.
  if (state.isTracing() && memoRec) {
    const entry = state.getTraceEntry(origPos, this, succeeded, succeeded ? [value] : []);
    if (isHeadOfLeftRecursion) {
      assert(entry.terminatingLREntry != null || !succeeded);
      entry.isHeadOfLeftRecursion = true;
    }
    memoRec.traceEntry = entry;
  }

  // Fix the input stream's examinedLength -- it should be the maximum examined length
  // across all applications, not just this one.
  inputStream.examinedLength = Math.max(
      inputStream.examinedLength,
      origInputStreamExaminedLength,
  );

  state.exitApplication(origPosInfo, value);

  return succeeded;
};

Apply.prototype.evalOnce = function(expr, state) {
  const {inputStream} = state;
  const origPos = inputStream.pos;

  if (state.eval(expr)) {
    const arity = expr.getArity();
    const bindings = state._bindings.splice(state._bindings.length - arity, arity);
    const offsets = state._bindingOffsets.splice(state._bindingOffsets.length - arity, arity);
    const matchLength = inputStream.pos - origPos;
    return new NonterminalNode(this.ruleName, bindings, offsets, matchLength);
  } else {
    return false;
  }
};

Apply.prototype.growSeedResult = function(body, state, origPos, lrMemoRec, newValue) {
  if (!newValue) {
    return false;
  }

  const {inputStream} = state;

  while (true) {
    lrMemoRec.matchLength = inputStream.pos - origPos;
    lrMemoRec.value = newValue;
    lrMemoRec.failuresAtRightmostPosition = state.cloneRecordedFailures();

    if (state.isTracing()) {
      // Before evaluating the body again, add a trace node for this application to the memo entry.
      // Its only child is a copy of the trace node from `newValue`, which will always be the last
      // element in `state.trace`.
      const seedTrace = state.trace[state.trace.length - 1];
      lrMemoRec.traceEntry = new Trace(
          state.input,
          origPos,
          inputStream.pos,
          this,
          true,
          [newValue],
          [seedTrace.clone()],
      );
    }
    inputStream.pos = origPos;
    newValue = this.evalOnce(body, state);
    if (inputStream.pos - origPos <= lrMemoRec.matchLength) {
      break;
    }
    if (state.isTracing()) {
      state.trace.splice(-2, 1); // Drop the trace for the old seed.
    }
  }
  if (state.isTracing()) {
    // The last entry is for an unused result -- pop it and save it in the "real" entry.
    lrMemoRec.traceEntry.recordLRTermination(state.trace.pop(), newValue);
  }
  inputStream.pos = origPos + lrMemoRec.matchLength;
  return lrMemoRec.value;
};

UnicodeChar.prototype.eval = function(state) {
  const {inputStream} = state;
  const origPos = inputStream.pos;
  const ch = inputStream.next();
  if (ch && this.pattern.test(ch)) {
    state.pushBinding(new TerminalNode(ch.length), origPos);
    return true;
  } else {
    state.processFailure(origPos, this);
    return false;
  }
};

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

PExpr.prototype.getArity = abstract('getArity');

any.getArity =
  end.getArity =
  Terminal.prototype.getArity =
  Range.prototype.getArity =
  Param.prototype.getArity =
  Apply.prototype.getArity =
  UnicodeChar.prototype.getArity =
    function() {
      return 1;
    };

Alt.prototype.getArity = function() {
  // This is ok b/c all terms must have the same arity -- this property is
  // checked by the Grammar constructor.
  return this.terms.length === 0 ? 0 : this.terms[0].getArity();
};

Seq.prototype.getArity = function() {
  let arity = 0;
  for (let idx = 0; idx < this.factors.length; idx++) {
    arity += this.factors[idx].getArity();
  }
  return arity;
};

Iter.prototype.getArity = function() {
  return this.expr.getArity();
};

Not.prototype.getArity = function() {
  return 0;
};

Lookahead.prototype.getArity = Lex.prototype.getArity = function() {
  return this.expr.getArity();
};

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

function getMetaInfo(expr, grammarInterval) {
  const metaInfo = {};
  if (expr.source && grammarInterval) {
    const adjusted = expr.source.relativeTo(grammarInterval);
    metaInfo.sourceInterval = [adjusted.startIdx, adjusted.endIdx];
  }
  return metaInfo;
}

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

PExpr.prototype.outputRecipe = abstract('outputRecipe');

any.outputRecipe = function(formals, grammarInterval) {
  return ['any', getMetaInfo(this, grammarInterval)];
};

end.outputRecipe = function(formals, grammarInterval) {
  return ['end', getMetaInfo(this, grammarInterval)];
};

Terminal.prototype.outputRecipe = function(formals, grammarInterval) {
  return ['terminal', getMetaInfo(this, grammarInterval), this.obj];
};

Range.prototype.outputRecipe = function(formals, grammarInterval) {
  return ['range', getMetaInfo(this, grammarInterval), this.from, this.to];
};

Param.prototype.outputRecipe = function(formals, grammarInterval) {
  return ['param', getMetaInfo(this, grammarInterval), this.index];
};

Alt.prototype.outputRecipe = function(formals, grammarInterval) {
  return ['alt', getMetaInfo(this, grammarInterval)].concat(
      this.terms.map(term => term.outputRecipe(formals, grammarInterval)),
  );
};

Extend.prototype.outputRecipe = function(formals, grammarInterval) {
  const extension = this.terms[0]; // [extension, original]
  return extension.outputRecipe(formals, grammarInterval);
};

Splice.prototype.outputRecipe = function(formals, grammarInterval) {
  const beforeTerms = this.terms.slice(0, this.expansionPos);
  const afterTerms = this.terms.slice(this.expansionPos + 1);
  return [
    'splice',
    getMetaInfo(this, grammarInterval),
    beforeTerms.map(term => term.outputRecipe(formals, grammarInterval)),
    afterTerms.map(term => term.outputRecipe(formals, grammarInterval)),
  ];
};

Seq.prototype.outputRecipe = function(formals, grammarInterval) {
  return ['seq', getMetaInfo(this, grammarInterval)].concat(
      this.factors.map(factor => factor.outputRecipe(formals, grammarInterval)),
  );
};

Star.prototype.outputRecipe =
  Plus.prototype.outputRecipe =
  Opt.prototype.outputRecipe =
  Not.prototype.outputRecipe =
  Lookahead.prototype.outputRecipe =
  Lex.prototype.outputRecipe =
    function(formals, grammarInterval) {
      return [
        this.constructor.name.toLowerCase(),
        getMetaInfo(this, grammarInterval),
        this.expr.outputRecipe(formals, grammarInterval),
      ];
    };

Apply.prototype.outputRecipe = function(formals, grammarInterval) {
  return [
    'app',
    getMetaInfo(this, grammarInterval),
    this.ruleName,
    this.args.map(arg => arg.outputRecipe(formals, grammarInterval)),
  ];
};

UnicodeChar.prototype.outputRecipe = function(formals, grammarInterval) {
  return ['unicodeChar', getMetaInfo(this, grammarInterval), this.category];
};

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

/*
  Called at grammar creation time to rewrite a rule body, replacing each reference to a formal
  parameter with a `Param` node. Returns a PExpr -- either a new one, or the original one if
  it was modified in place.
*/
PExpr.prototype.introduceParams = abstract('introduceParams');

any.introduceParams =
  end.introduceParams =
  Terminal.prototype.introduceParams =
  Range.prototype.introduceParams =
  Param.prototype.introduceParams =
  UnicodeChar.prototype.introduceParams =
    function(formals) {
      return this;
    };

Alt.prototype.introduceParams = function(formals) {
  this.terms.forEach((term, idx, terms) => {
    terms[idx] = term.introduceParams(formals);
  });
  return this;
};

Seq.prototype.introduceParams = function(formals) {
  this.factors.forEach((factor, idx, factors) => {
    factors[idx] = factor.introduceParams(formals);
  });
  return this;
};

Iter.prototype.introduceParams =
  Not.prototype.introduceParams =
  Lookahead.prototype.introduceParams =
  Lex.prototype.introduceParams =
    function(formals) {
      this.expr = this.expr.introduceParams(formals);
      return this;
    };

Apply.prototype.introduceParams = function(formals) {
  const index = formals.indexOf(this.ruleName);
  if (index >= 0) {
    if (this.args.length > 0) {
      // TODO: Should this be supported? See issue #64.
      throw new Error('Parameterized rules cannot be passed as arguments to another rule.');
    }
    return new Param(index).withSource(this.source);
  } else {
    this.args.forEach((arg, idx, args) => {
      args[idx] = arg.introduceParams(formals);
    });
    return this;
  }
};

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

// Returns `true` if this parsing expression may accept without consuming any input.
PExpr.prototype.isNullable = function(grammar) {
  return this._isNullable(grammar, Object.create(null));
};

PExpr.prototype._isNullable = abstract('_isNullable');

any._isNullable =
  Range.prototype._isNullable =
  Param.prototype._isNullable =
  Plus.prototype._isNullable =
  UnicodeChar.prototype._isNullable =
    function(grammar, memo) {
      return false;
    };

end._isNullable = function(grammar, memo) {
  return true;
};

Terminal.prototype._isNullable = function(grammar, memo) {
  if (typeof this.obj === 'string') {
    // This is an over-simplification: it's only correct if the input is a string. If it's an array
    // or an object, then the empty string parsing expression is not nullable.
    return this.obj === '';
  } else {
    return false;
  }
};

Alt.prototype._isNullable = function(grammar, memo) {
  return this.terms.length === 0 || this.terms.some(term => term._isNullable(grammar, memo));
};

Seq.prototype._isNullable = function(grammar, memo) {
  return this.factors.every(factor => factor._isNullable(grammar, memo));
};

Star.prototype._isNullable =
  Opt.prototype._isNullable =
  Not.prototype._isNullable =
  Lookahead.prototype._isNullable =
    function(grammar, memo) {
      return true;
    };

Lex.prototype._isNullable = function(grammar, memo) {
  return this.expr._isNullable(grammar, memo);
};

Apply.prototype._isNullable = function(grammar, memo) {
  const key = this.toMemoKey();
  if (!Object.prototype.hasOwnProperty.call(memo, key)) {
    const {body} = grammar.rules[this.ruleName];
    const inlined = body.substituteParams(this.args);
    memo[key] = false; // Prevent infinite recursion for recursive rules.
    memo[key] = inlined._isNullable(grammar, memo);
  }
  return memo[key];
};

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

/*
  Returns a PExpr that results from recursively replacing every formal parameter (i.e., instance
  of `Param`) inside this PExpr with its actual value from `actuals` (an Array).

  The receiver must not be modified; a new PExpr must be returned if any replacement is necessary.
*/
// function(actuals) { ... }
PExpr.prototype.substituteParams = abstract('substituteParams');

any.substituteParams =
  end.substituteParams =
  Terminal.prototype.substituteParams =
  Range.prototype.substituteParams =
  UnicodeChar.prototype.substituteParams =
    function(actuals) {
      return this;
    };

Param.prototype.substituteParams = function(actuals) {
  return actuals[this.index];
};

Alt.prototype.substituteParams = function(actuals) {
  return new Alt(this.terms.map(term => term.substituteParams(actuals)));
};

Seq.prototype.substituteParams = function(actuals) {
  return new Seq(this.factors.map(factor => factor.substituteParams(actuals)));
};

Iter.prototype.substituteParams =
  Not.prototype.substituteParams =
  Lookahead.prototype.substituteParams =
  Lex.prototype.substituteParams =
    function(actuals) {
      return new this.constructor(this.expr.substituteParams(actuals));
    };

Apply.prototype.substituteParams = function(actuals) {
  if (this.args.length === 0) {
    // Avoid making a copy of this application, as an optimization
    return this;
  } else {
    const args = this.args.map(arg => arg.substituteParams(actuals));
    return new Apply(this.ruleName, args);
  }
};

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

function isRestrictedJSIdentifier(str) {
  return /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(str);
}

function resolveDuplicatedNames(argumentNameList) {
  // `count` is used to record the number of times each argument name occurs in the list,
  // this is useful for checking duplicated argument name. It maps argument names to ints.
  const count = Object.create(null);
  argumentNameList.forEach(argName => {
    count[argName] = (count[argName] || 0) + 1;
  });

  // Append subscripts ('_1', '_2', ...) to duplicate argument names.
  Object.keys(count).forEach(dupArgName => {
    if (count[dupArgName] <= 1) {
      return;
    }

    // This name shows up more than once, so add subscripts.
    let subscript = 1;
    argumentNameList.forEach((argName, idx) => {
      if (argName === dupArgName) {
        argumentNameList[idx] = argName + '_' + subscript++;
      }
    });
  });
}

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

/*
  Returns a list of strings that will be used as the default argument names for its receiver
  (a pexpr) in a semantic action. This is used exclusively by the Semantics Editor.

  `firstArgIndex` is the 1-based index of the first argument name that will be generated for this
  pexpr. It enables us to name arguments positionally, e.g., if the second argument is a
  non-alphanumeric terminal like "+", it will be named '$2'.

  `noDupCheck` is true if the caller of `toArgumentNameList` is not a top level caller. It enables
  us to avoid nested duplication subscripts appending, e.g., '_1_1', '_1_2', by only checking
  duplicates at the top level.

  Here is a more elaborate example that illustrates how this method works:
  `(a "+" b).toArgumentNameList(1)` evaluates to `['a', '$2', 'b']` with the following recursive
  calls:

    (a).toArgumentNameList(1) -> ['a'],
    ("+").toArgumentNameList(2) -> ['$2'],
    (b).toArgumentNameList(3) -> ['b']

  Notes:
  * This method must only be called on well-formed expressions, e.g., the receiver must
    not have any Alt sub-expressions with inconsistent arities.
  * e.getArity() === e.toArgumentNameList(1).length
*/
// function(firstArgIndex, noDupCheck) { ... }
PExpr.prototype.toArgumentNameList = abstract('toArgumentNameList');

any.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  return ['any'];
};

end.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  return ['end'];
};

Terminal.prototype.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  if (typeof this.obj === 'string' && /^[_a-zA-Z0-9]+$/.test(this.obj)) {
    // If this terminal is a valid suffix for a JS identifier, just prepend it with '_'
    return ['_' + this.obj];
  } else {
    // Otherwise, name it positionally.
    return ['$' + firstArgIndex];
  }
};

Range.prototype.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  let argName = this.from + '_to_' + this.to;
  // If the `argName` is not valid then try to prepend a `_`.
  if (!isRestrictedJSIdentifier(argName)) {
    argName = '_' + argName;
  }
  // If the `argName` still not valid after prepending a `_`, then name it positionally.
  if (!isRestrictedJSIdentifier(argName)) {
    argName = '$' + firstArgIndex;
  }
  return [argName];
};

Alt.prototype.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  // `termArgNameLists` is an array of arrays where each row is the
  // argument name list that corresponds to a term in this alternation.
  const termArgNameLists = this.terms.map(term =>
    term.toArgumentNameList(firstArgIndex, true),
  );

  const argumentNameList = [];
  const numArgs = termArgNameLists[0].length;
  for (let colIdx = 0; colIdx < numArgs; colIdx++) {
    const col = [];
    for (let rowIdx = 0; rowIdx < this.terms.length; rowIdx++) {
      col.push(termArgNameLists[rowIdx][colIdx]);
    }
    const uniqueNames = copyWithoutDuplicates(col);
    argumentNameList.push(uniqueNames.join('_or_'));
  }

  if (!noDupCheck) {
    resolveDuplicatedNames(argumentNameList);
  }
  return argumentNameList;
};

Seq.prototype.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  // Generate the argument name list, without worrying about duplicates.
  let argumentNameList = [];
  this.factors.forEach(factor => {
    const factorArgumentNameList = factor.toArgumentNameList(firstArgIndex, true);
    argumentNameList = argumentNameList.concat(factorArgumentNameList);

    // Shift the firstArgIndex to take this factor's argument names into account.
    firstArgIndex += factorArgumentNameList.length;
  });
  if (!noDupCheck) {
    resolveDuplicatedNames(argumentNameList);
  }
  return argumentNameList;
};

Iter.prototype.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  const argumentNameList = this.expr
      .toArgumentNameList(firstArgIndex, noDupCheck)
      .map(exprArgumentString =>
      exprArgumentString[exprArgumentString.length - 1] === 's' ?
        exprArgumentString + 'es' :
        exprArgumentString + 's',
      );
  if (!noDupCheck) {
    resolveDuplicatedNames(argumentNameList);
  }
  return argumentNameList;
};

Opt.prototype.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  return this.expr.toArgumentNameList(firstArgIndex, noDupCheck).map(argName => {
    return 'opt' + argName[0].toUpperCase() + argName.slice(1);
  });
};

Not.prototype.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  return [];
};

Lookahead.prototype.toArgumentNameList = Lex.prototype.toArgumentNameList =
  function(firstArgIndex, noDupCheck) {
    return this.expr.toArgumentNameList(firstArgIndex, noDupCheck);
  };

Apply.prototype.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  return [this.ruleName];
};

UnicodeChar.prototype.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  return ['$' + firstArgIndex];
};

Param.prototype.toArgumentNameList = function(firstArgIndex, noDupCheck) {
  return ['param' + this.index];
};

// "Value pexprs" (Value, Str, Arr, Obj) are going away soon, so we don't worry about them here.

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

// Returns a string representing the PExpr, for use as a UI label, etc.
PExpr.prototype.toDisplayString = abstract('toDisplayString');

Alt.prototype.toDisplayString = Seq.prototype.toDisplayString = function() {
  if (this.source) {
    return this.source.trimmed().contents;
  }
  return '[' + this.constructor.name + ']';
};

any.toDisplayString =
  end.toDisplayString =
  Iter.prototype.toDisplayString =
  Not.prototype.toDisplayString =
  Lookahead.prototype.toDisplayString =
  Lex.prototype.toDisplayString =
  Terminal.prototype.toDisplayString =
  Range.prototype.toDisplayString =
  Param.prototype.toDisplayString =
    function() {
      return this.toString();
    };

Apply.prototype.toDisplayString = function() {
  if (this.args.length > 0) {
    const ps = this.args.map(arg => arg.toDisplayString());
    return this.ruleName + '<' + ps.join(',') + '>';
  } else {
    return this.ruleName;
  }
};

UnicodeChar.prototype.toDisplayString = function() {
  return 'Unicode [' + this.category + '] character';
};

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

/*
  `Failure`s represent expressions that weren't matched while parsing. They are used to generate
  error messages automatically. The interface of `Failure`s includes the collowing methods:

  - getText() : String
  - getType() : String  (one of {"description", "string", "code"})
  - isDescription() : bool
  - isStringTerminal() : bool
  - isCode() : bool
  - isFluffy() : bool
  - makeFluffy() : void
  - subsumes(Failure) : bool
*/

function isValidType(type) {
  return type === 'description' || type === 'string' || type === 'code';
}

class Failure {
  constructor(pexpr, text, type) {
    if (!isValidType(type)) {
      throw new Error('invalid Failure type: ' + type);
    }
    this.pexpr = pexpr;
    this.text = text;
    this.type = type;
    this.fluffy = false;
  }

  getPExpr() {
    return this.pexpr;
  }

  getText() {
    return this.text;
  }

  getType() {
    return this.type;
  }

  isDescription() {
    return this.type === 'description';
  }

  isStringTerminal() {
    return this.type === 'string';
  }

  isCode() {
    return this.type === 'code';
  }

  isFluffy() {
    return this.fluffy;
  }

  makeFluffy() {
    this.fluffy = true;
  }

  clearFluffy() {
    this.fluffy = false;
  }

  subsumes(that) {
    return (
      this.getText() === that.getText() &&
      this.type === that.type &&
      (!this.isFluffy() || (this.isFluffy() && that.isFluffy()))
    );
  }

  toString() {
    return this.type === 'string' ? JSON.stringify(this.getText()) : this.getText();
  }

  clone() {
    const failure = new Failure(this.pexpr, this.text, this.type);
    if (this.isFluffy()) {
      failure.makeFluffy();
    }
    return failure;
  }

  toKey() {
    return this.toString() + '#' + this.type;
  }
}

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

PExpr.prototype.toFailure = abstract('toFailure');

any.toFailure = function(grammar) {
  return new Failure(this, 'any object', 'description');
};

end.toFailure = function(grammar) {
  return new Failure(this, 'end of input', 'description');
};

Terminal.prototype.toFailure = function(grammar) {
  return new Failure(this, this.obj, 'string');
};

Range.prototype.toFailure = function(grammar) {
  // TODO: come up with something better
  return new Failure(this, JSON.stringify(this.from) + '..' + JSON.stringify(this.to), 'code');
};

Not.prototype.toFailure = function(grammar) {
  const description =
    this.expr === any ? 'nothing' : 'not ' + this.expr.toFailure(grammar);
  return new Failure(this, description, 'description');
};

Lookahead.prototype.toFailure = function(grammar) {
  return this.expr.toFailure(grammar);
};

Apply.prototype.toFailure = function(grammar) {
  let {description} = grammar.rules[this.ruleName];
  if (!description) {
    const article = /^[aeiouAEIOU]/.test(this.ruleName) ? 'an' : 'a';
    description = article + ' ' + this.ruleName;
  }
  return new Failure(this, description, 'description');
};

UnicodeChar.prototype.toFailure = function(grammar) {
  return new Failure(this, 'a Unicode [' + this.category + '] character', 'description');
};

Alt.prototype.toFailure = function(grammar) {
  const fs = this.terms.map(t => t.toFailure(grammar));
  const description = '(' + fs.join(' or ') + ')';
  return new Failure(this, description, 'description');
};

Seq.prototype.toFailure = function(grammar) {
  const fs = this.factors.map(f => f.toFailure(grammar));
  const description = '(' + fs.join(' ') + ')';
  return new Failure(this, description, 'description');
};

Iter.prototype.toFailure = function(grammar) {
  const description = '(' + this.expr.toFailure(grammar) + this.operator + ')';
  return new Failure(this, description, 'description');
};

// --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------

/*
  e1.toString() === e2.toString() ==> e1 and e2 are semantically equivalent.
  Note that this is not an iff (<==>): e.g.,
  (~"b" "a").toString() !== ("a").toString(), even though
  ~"b" "a" and "a" are interchangeable in any grammar,
  both in terms of the languages they accept and their arities.
*/
PExpr.prototype.toString = abstract('toString');

any.toString = function() {
  return 'any';
};

end.toString = function() {
  return 'end';
};

Terminal.prototype.toString = function() {
  return JSON.stringify(this.obj);
};

Range.prototype.toString = function() {
  return JSON.stringify(this.from) + '..' + JSON.stringify(this.to);
};

Param.prototype.toString = function() {
  return '$' + this.index;
};

Lex.prototype.toString = function() {
  return '#(' + this.expr.toString() + ')';
};

Alt.prototype.toString = function() {
  return this.terms.length === 1 ?
    this.terms[0].toString() :
    '(' + this.terms.map(term => term.toString()).join(' | ') + ')';
};

Seq.prototype.toString = function() {
  return this.factors.length === 1 ?
    this.factors[0].toString() :
    '(' + this.factors.map(factor => factor.toString()).join(' ') + ')';
};

Iter.prototype.toString = function() {
  return this.expr + this.operator;
};

Not.prototype.toString = function() {
  return '~' + this.expr;
};

Lookahead.prototype.toString = function() {
  return '&' + this.expr;
};

Apply.prototype.toString = function() {
  if (this.args.length > 0) {
    const ps = this.args.map(arg => arg.toString());
    return this.ruleName + '<' + ps.join(',') + '>';
  } else {
    return this.ruleName;
  }
};

UnicodeChar.prototype.toString = function() {
  return '\\p{' + this.category + '}';
};

class CaseInsensitiveTerminal extends PExpr {
  constructor(param) {
    super();
    this.obj = param;
  }

  _getString(state) {
    const terminal = state.currentApplication().args[this.obj.index];
    assert(terminal instanceof Terminal, 'expected a Terminal expression');
    return terminal.obj;
  }

  // Implementation of the PExpr API

  allowsSkippingPrecedingSpace() {
    return true;
  }

  eval(state) {
    const {inputStream} = state;
    const origPos = inputStream.pos;
    const matchStr = this._getString(state);
    if (!inputStream.matchString(matchStr, true)) {
      state.processFailure(origPos, this);
      return false;
    } else {
      state.pushBinding(new TerminalNode(matchStr.length), origPos);
      return true;
    }
  }

  getArity() {
    return 1;
  }

  substituteParams(actuals) {
    return new CaseInsensitiveTerminal(this.obj.substituteParams(actuals));
  }

  toDisplayString() {
    return this.obj.toDisplayString() + ' (case-insensitive)';
  }

  toFailure(grammar) {
    return new Failure(
        this,
        this.obj.toFailure(grammar) + ' (case-insensitive)',
        'description',
    );
  }

  _isNullable(grammar, memo) {
    return this.obj._isNullable(grammar, memo);
  }
}

// --------------------------------------------------------------------

var pexprs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CaseInsensitiveTerminal: CaseInsensitiveTerminal,
  PExpr: PExpr,
  any: any,
  end: end,
  Terminal: Terminal,
  Range: Range,
  Param: Param,
  Alt: Alt,
  Extend: Extend,
  Splice: Splice,
  Seq: Seq,
  Iter: Iter,
  Star: Star,
  Plus: Plus,
  Opt: Opt,
  Not: Not,
  Lookahead: Lookahead,
  Lex: Lex,
  Apply: Apply,
  UnicodeChar: UnicodeChar
});

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

let builtInApplySyntacticBody;

awaitBuiltInRules(builtInRules => {
  builtInApplySyntacticBody = builtInRules.rules.applySyntactic.body;
});

const applySpaces = new Apply('spaces');

class MatchState {
  constructor(matcher, startExpr, optPositionToRecordFailures) {
    this.matcher = matcher;
    this.startExpr = startExpr;

    this.grammar = matcher.grammar;
    this.input = matcher.getInput();
    this.inputStream = new InputStream(this.input);
    this.memoTable = matcher._memoTable;

    this.userData = undefined;
    this.doNotMemoize = false;

    this._bindings = [];
    this._bindingOffsets = [];
    this._applicationStack = [];
    this._posStack = [0];
    this.inLexifiedContextStack = [false];

    this.rightmostFailurePosition = -1;
    this._rightmostFailurePositionStack = [];
    this._recordedFailuresStack = [];

    if (optPositionToRecordFailures !== undefined) {
      this.positionToRecordFailures = optPositionToRecordFailures;
      this.recordedFailures = Object.create(null);
    }
  }

  posToOffset(pos) {
    return pos - this._posStack[this._posStack.length - 1];
  }

  enterApplication(posInfo, app) {
    this._posStack.push(this.inputStream.pos);
    this._applicationStack.push(app);
    this.inLexifiedContextStack.push(false);
    posInfo.enter(app);
    this._rightmostFailurePositionStack.push(this.rightmostFailurePosition);
    this.rightmostFailurePosition = -1;
  }

  exitApplication(posInfo, optNode) {
    const origPos = this._posStack.pop();
    this._applicationStack.pop();
    this.inLexifiedContextStack.pop();
    posInfo.exit();

    this.rightmostFailurePosition = Math.max(
        this.rightmostFailurePosition,
        this._rightmostFailurePositionStack.pop(),
    );

    if (optNode) {
      this.pushBinding(optNode, origPos);
    }
  }

  enterLexifiedContext() {
    this.inLexifiedContextStack.push(true);
  }

  exitLexifiedContext() {
    this.inLexifiedContextStack.pop();
  }

  currentApplication() {
    return this._applicationStack[this._applicationStack.length - 1];
  }

  inSyntacticContext() {
    const currentApplication = this.currentApplication();
    if (currentApplication) {
      return currentApplication.isSyntactic() && !this.inLexifiedContext();
    } else {
      // The top-level context is syntactic if the start application is.
      return this.startExpr.factors[0].isSyntactic();
    }
  }

  inLexifiedContext() {
    return this.inLexifiedContextStack[this.inLexifiedContextStack.length - 1];
  }

  skipSpaces() {
    this.pushFailuresInfo();
    this.eval(applySpaces);
    this.popBinding();
    this.popFailuresInfo();
    return this.inputStream.pos;
  }

  skipSpacesIfInSyntacticContext() {
    return this.inSyntacticContext() ? this.skipSpaces() : this.inputStream.pos;
  }

  maybeSkipSpacesBefore(expr) {
    if (expr.allowsSkippingPrecedingSpace() && expr !== applySpaces) {
      return this.skipSpacesIfInSyntacticContext();
    } else {
      return this.inputStream.pos;
    }
  }

  pushBinding(node, origPos) {
    this._bindings.push(node);
    this._bindingOffsets.push(this.posToOffset(origPos));
  }

  popBinding() {
    this._bindings.pop();
    this._bindingOffsets.pop();
  }

  numBindings() {
    return this._bindings.length;
  }

  truncateBindings(newLength) {
    // Yes, this is this really faster than setting the `length` property (tested with
    // bin/es5bench on Node v6.1.0).
    // Update 2021-10-25: still true on v14.15.5 — it's ~20% speedup on es5bench.
    while (this._bindings.length > newLength) {
      this.popBinding();
    }
  }

  getCurrentPosInfo() {
    return this.getPosInfo(this.inputStream.pos);
  }

  getPosInfo(pos) {
    let posInfo = this.memoTable[pos];
    if (!posInfo) {
      posInfo = this.memoTable[pos] = new PosInfo();
    }
    return posInfo;
  }

  processFailure(pos, expr) {
    this.rightmostFailurePosition = Math.max(this.rightmostFailurePosition, pos);

    if (this.recordedFailures && pos === this.positionToRecordFailures) {
      const app = this.currentApplication();
      if (app) {
        // Substitute parameters with the actual pexprs that were passed to
        // the current rule.
        expr = expr.substituteParams(app.args);
      }

      this.recordFailure(expr.toFailure(this.grammar), false);
    }
  }

  recordFailure(failure, shouldCloneIfNew) {
    const key = failure.toKey();
    if (!this.recordedFailures[key]) {
      this.recordedFailures[key] = shouldCloneIfNew ? failure.clone() : failure;
    } else if (this.recordedFailures[key].isFluffy() && !failure.isFluffy()) {
      this.recordedFailures[key].clearFluffy();
    }
  }

  recordFailures(failures, shouldCloneIfNew) {
    Object.keys(failures).forEach(key => {
      this.recordFailure(failures[key], shouldCloneIfNew);
    });
  }

  cloneRecordedFailures() {
    if (!this.recordedFailures) {
      return undefined;
    }

    const ans = Object.create(null);
    Object.keys(this.recordedFailures).forEach(key => {
      ans[key] = this.recordedFailures[key].clone();
    });
    return ans;
  }

  getRightmostFailurePosition() {
    return this.rightmostFailurePosition;
  }

  _getRightmostFailureOffset() {
    return this.rightmostFailurePosition >= 0 ?
      this.posToOffset(this.rightmostFailurePosition) :
      -1;
  }

  // Returns the memoized trace entry for `expr` at `pos`, if one exists, `null` otherwise.
  getMemoizedTraceEntry(pos, expr) {
    const posInfo = this.memoTable[pos];
    if (posInfo && expr instanceof Apply) {
      const memoRec = posInfo.memo[expr.toMemoKey()];
      if (memoRec && memoRec.traceEntry) {
        const entry = memoRec.traceEntry.cloneWithExpr(expr);
        entry.isMemoized = true;
        return entry;
      }
    }
    return null;
  }

  // Returns a new trace entry, with the currently active trace array as its children.
  getTraceEntry(pos, expr, succeeded, bindings) {
    if (expr instanceof Apply) {
      const app = this.currentApplication();
      const actuals = app ? app.args : [];
      expr = expr.substituteParams(actuals);
    }
    return (
      this.getMemoizedTraceEntry(pos, expr) ||
      new Trace(this.input, pos, this.inputStream.pos, expr, succeeded, bindings, this.trace)
    );
  }

  isTracing() {
    return !!this.trace;
  }

  hasNecessaryInfo(memoRec) {
    if (this.trace && !memoRec.traceEntry) {
      return false;
    }

    if (
      this.recordedFailures &&
      this.inputStream.pos + memoRec.rightmostFailureOffset === this.positionToRecordFailures
    ) {
      return !!memoRec.failuresAtRightmostPosition;
    }

    return true;
  }

  useMemoizedResult(origPos, memoRec) {
    if (this.trace) {
      this.trace.push(memoRec.traceEntry);
    }

    const memoRecRightmostFailurePosition =
      this.inputStream.pos + memoRec.rightmostFailureOffset;
    this.rightmostFailurePosition = Math.max(
        this.rightmostFailurePosition,
        memoRecRightmostFailurePosition,
    );
    if (
      this.recordedFailures &&
      this.positionToRecordFailures === memoRecRightmostFailurePosition &&
      memoRec.failuresAtRightmostPosition
    ) {
      this.recordFailures(memoRec.failuresAtRightmostPosition, true);
    }

    this.inputStream.examinedLength = Math.max(
        this.inputStream.examinedLength,
        memoRec.examinedLength + origPos,
    );

    if (memoRec.value) {
      this.inputStream.pos += memoRec.matchLength;
      this.pushBinding(memoRec.value, origPos);
      return true;
    }
    return false;
  }

  // Evaluate `expr` and return `true` if it succeeded, `false` otherwise. On success, `bindings`
  // will have `expr.getArity()` more elements than before, and the input stream's position may
  // have increased. On failure, `bindings` and position will be unchanged.
  eval(expr) {
    const {inputStream} = this;
    const origNumBindings = this._bindings.length;
    const origUserData = this.userData;

    let origRecordedFailures;
    if (this.recordedFailures) {
      origRecordedFailures = this.recordedFailures;
      this.recordedFailures = Object.create(null);
    }

    const origPos = inputStream.pos;
    const memoPos = this.maybeSkipSpacesBefore(expr);

    let origTrace;
    if (this.trace) {
      origTrace = this.trace;
      this.trace = [];
    }

    // Do the actual evaluation.
    const ans = expr.eval(this);

    if (this.trace) {
      const bindings = this._bindings.slice(origNumBindings);
      const traceEntry = this.getTraceEntry(memoPos, expr, ans, bindings);
      traceEntry.isImplicitSpaces = expr === applySpaces;
      traceEntry.isRootNode = expr === this.startExpr;
      origTrace.push(traceEntry);
      this.trace = origTrace;
    }

    if (ans) {
      if (this.recordedFailures && inputStream.pos === this.positionToRecordFailures) {
        Object.keys(this.recordedFailures).forEach(key => {
          this.recordedFailures[key].makeFluffy();
        });
      }
    } else {
      // Reset the position, bindings, and userData.
      inputStream.pos = origPos;
      this.truncateBindings(origNumBindings);
      this.userData = origUserData;
    }

    if (this.recordedFailures) {
      this.recordFailures(origRecordedFailures, false);
    }

    // The built-in applySyntactic rule needs special handling: we want to skip
    // trailing spaces, just as with the top-level application of a syntactic rule.
    if (expr === builtInApplySyntacticBody) {
      this.skipSpaces();
    }

    return ans;
  }

  getMatchResult() {
    this.grammar._setUpMatchState(this);
    this.eval(this.startExpr);
    let rightmostFailures;
    if (this.recordedFailures) {
      rightmostFailures = Object.keys(this.recordedFailures).map(
          key => this.recordedFailures[key],
      );
    }
    const cst = this._bindings[0];
    if (cst) {
      cst.grammar = this.grammar;
    }
    return new MatchResult(
        this.matcher,
        this.input,
        this.startExpr,
        cst,
        this._bindingOffsets[0],
        this.rightmostFailurePosition,
        rightmostFailures,
    );
  }

  getTrace() {
    this.trace = [];
    const matchResult = this.getMatchResult();

    // The trace node for the start rule is always the last entry. If it is a syntactic rule,
    // the first entry is for an application of 'spaces'.
    // TODO(pdubroy): Clean this up by introducing a special `Match<startAppl>` rule, which will
    // ensure that there is always a single root trace node.
    const rootTrace = this.trace[this.trace.length - 1];
    rootTrace.result = matchResult;
    return rootTrace;
  }

  pushFailuresInfo() {
    this._rightmostFailurePositionStack.push(this.rightmostFailurePosition);
    this._recordedFailuresStack.push(this.recordedFailures);
  }

  popFailuresInfo() {
    this.rightmostFailurePosition = this._rightmostFailurePositionStack.pop();
    this.recordedFailures = this._recordedFailuresStack.pop();
  }
}

class Matcher {
  constructor(grammar) {
    this.grammar = grammar;
    this._memoTable = [];
    this._input = '';
    this._isMemoTableStale = false;
  }

  _resetMemoTable() {
    this._memoTable = [];
    this._isMemoTableStale = false;
  }

  getInput() {
    return this._input;
  }

  setInput(str) {
    if (this._input !== str) {
      this.replaceInputRange(0, this._input.length, str);
    }
    return this;
  }

  replaceInputRange(startIdx, endIdx, str) {
    const prevInput = this._input;
    const memoTable = this._memoTable;
    if (
      startIdx < 0 ||
      startIdx > prevInput.length ||
      endIdx < 0 ||
      endIdx > prevInput.length ||
      startIdx > endIdx
    ) {
      throw new Error('Invalid indices: ' + startIdx + ' and ' + endIdx);
    }

    // update input
    this._input = prevInput.slice(0, startIdx) + str + prevInput.slice(endIdx);
    if (this._input !== prevInput && memoTable.length > 0) {
      this._isMemoTableStale = true;
    }

    // update memo table (similar to the above)
    const restOfMemoTable = memoTable.slice(endIdx);
    memoTable.length = startIdx;
    for (let idx = 0; idx < str.length; idx++) {
      memoTable.push(undefined);
    }
    for (const posInfo of restOfMemoTable) {
      memoTable.push(posInfo);
    }

    // Invalidate memoRecs
    for (let pos = 0; pos < startIdx; pos++) {
      const posInfo = memoTable[pos];
      if (posInfo) {
        posInfo.clearObsoleteEntries(pos, startIdx);
      }
    }

    return this;
  }

  match(optStartApplicationStr, options = {incremental: true}) {
    return this._match(this._getStartExpr(optStartApplicationStr), {
      incremental: options.incremental,
      tracing: false,
    });
  }

  trace(optStartApplicationStr, options = {incremental: true}) {
    return this._match(this._getStartExpr(optStartApplicationStr), {
      incremental: options.incremental,
      tracing: true,
    });
  }

  _match(startExpr, options = {}) {
    const opts = {
      tracing: false,
      incremental: true,
      positionToRecordFailures: undefined,
      ...options,
    };
    if (!opts.incremental) {
      this._resetMemoTable();
    } else if (this._isMemoTableStale && !this.grammar.supportsIncrementalParsing) {
      throw grammarDoesNotSupportIncrementalParsing(this.grammar);
    }

    const state = new MatchState(this, startExpr, opts.positionToRecordFailures);
    return opts.tracing ? state.getTrace() : state.getMatchResult();
  }

  /*
    Returns the starting expression for this Matcher's associated grammar. If
    `optStartApplicationStr` is specified, it is a string expressing a rule application in the
    grammar. If not specified, the grammar's default start rule will be used.
  */
  _getStartExpr(optStartApplicationStr) {
    const applicationStr = optStartApplicationStr || this.grammar.defaultStartRule;
    if (!applicationStr) {
      throw new Error('Missing start rule argument -- the grammar has no default start rule.');
    }

    const startApp = this.grammar.parseApplication(applicationStr);
    return new Seq([startApp, end]);
  }
}

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

const globalActionStack = [];

const hasOwnProperty = (x, prop) => Object.prototype.hasOwnProperty.call(x, prop);

// ----------------- Wrappers -----------------

// Wrappers decorate CST nodes with all of the functionality (i.e., operations and attributes)
// provided by a Semantics (see below). `Wrapper` is the abstract superclass of all wrappers. A
// `Wrapper` must have `_node` and `_semantics` instance variables, which refer to the CST node and
// Semantics (resp.) for which it was created, and a `_childWrappers` instance variable which is
// used to cache the wrapper instances that are created for its child nodes. Setting these instance
// variables is the responsibility of the constructor of each Semantics-specific subclass of
// `Wrapper`.
class Wrapper {
  constructor(node, sourceInterval, baseInterval) {
    this._node = node;
    this.source = sourceInterval;

    // The interval that the childOffsets of `node` are relative to. It should be the source
    // of the closest Nonterminal node.
    this._baseInterval = baseInterval;

    if (node.isNonterminal()) {
      assert(sourceInterval === baseInterval);
    }
    this._childWrappers = [];
  }

  _forgetMemoizedResultFor(attributeName) {
    // Remove the memoized attribute from the cstNode and all its children.
    delete this._node[this._semantics.attributeKeys[attributeName]];
    this.children.forEach(child => {
      child._forgetMemoizedResultFor(attributeName);
    });
  }

  // Returns the wrapper of the specified child node. Child wrappers are created lazily and
  // cached in the parent wrapper's `_childWrappers` instance variable.
  child(idx) {
    if (!(0 <= idx && idx < this._node.numChildren())) {
      // TODO: Consider throwing an exception here.
      return undefined;
    }
    let childWrapper = this._childWrappers[idx];
    if (!childWrapper) {
      const childNode = this._node.childAt(idx);
      const offset = this._node.childOffsets[idx];

      const source = this._baseInterval.subInterval(offset, childNode.matchLength);
      const base = childNode.isNonterminal() ? source : this._baseInterval;
      childWrapper = this._childWrappers[idx] = this._semantics.wrap(childNode, source, base);
    }
    return childWrapper;
  }

  // Returns an array containing the wrappers of all of the children of the node associated
  // with this wrapper.
  _children() {
    // Force the creation of all child wrappers
    for (let idx = 0; idx < this._node.numChildren(); idx++) {
      this.child(idx);
    }
    return this._childWrappers;
  }

  // Returns `true` if the CST node associated with this wrapper corresponds to an iteration
  // expression, i.e., a Kleene-*, Kleene-+, or an optional. Returns `false` otherwise.
  isIteration() {
    return this._node.isIteration();
  }

  // Returns `true` if the CST node associated with this wrapper is a terminal node, `false`
  // otherwise.
  isTerminal() {
    return this._node.isTerminal();
  }

  // Returns `true` if the CST node associated with this wrapper is a nonterminal node, `false`
  // otherwise.
  isNonterminal() {
    return this._node.isNonterminal();
  }

  // Returns `true` if the CST node associated with this wrapper is a nonterminal node
  // corresponding to a syntactic rule, `false` otherwise.
  isSyntactic() {
    return this.isNonterminal() && this._node.isSyntactic();
  }

  // Returns `true` if the CST node associated with this wrapper is a nonterminal node
  // corresponding to a lexical rule, `false` otherwise.
  isLexical() {
    return this.isNonterminal() && this._node.isLexical();
  }

  // Returns `true` if the CST node associated with this wrapper is an iterator node
  // having either one or no child (? operator), `false` otherwise.
  // Otherwise, throws an exception.
  isOptional() {
    return this._node.isOptional();
  }

  // Create a new _iter wrapper in the same semantics as this wrapper.
  iteration(optChildWrappers) {
    const childWrappers = optChildWrappers || [];

    const childNodes = childWrappers.map(c => c._node);
    const iter = new IterationNode(childNodes, [], -1, false);

    const wrapper = this._semantics.wrap(iter, null, null);
    wrapper._childWrappers = childWrappers;
    return wrapper;
  }

  // Returns an array containing the children of this CST node.
  get children() {
    return this._children();
  }

  // Returns the name of grammar rule that created this CST node.
  get ctorName() {
    return this._node.ctorName;
  }

  // Returns the number of children of this CST node.
  get numChildren() {
    return this._node.numChildren();
  }

  // Returns the contents of the input stream consumed by this CST node.
  get sourceString() {
    return this.source.contents;
  }
}

// ----------------- Semantics -----------------

// A Semantics is a container for a family of Operations and Attributes for a given grammar.
// Semantics enable modularity (different clients of a grammar can create their set of operations
// and attributes in isolation) and extensibility even when operations and attributes are mutually-
// recursive. This constructor should not be called directly except from
// `Semantics.createSemantics`. The normal ways to create a Semantics, given a grammar 'g', are
// `g.createSemantics()` and `g.extendSemantics(parentSemantics)`.
class Semantics {
  constructor(grammar, superSemantics) {
    const self = this;
    this.grammar = grammar;
    this.checkedActionDicts = false;

    // Constructor for wrapper instances, which are passed as the arguments to the semantic actions
    // of an operation or attribute. Operations and attributes require double dispatch: the semantic
    // action is chosen based on both the node's type and the semantics. Wrappers ensure that
    // the `execute` method is called with the correct (most specific) semantics object as an
    // argument.
    this.Wrapper = class extends (superSemantics ? superSemantics.Wrapper : Wrapper) {
      constructor(node, sourceInterval, baseInterval) {
        super(node, sourceInterval, baseInterval);
        self.checkActionDictsIfHaventAlready();
        this._semantics = self;
      }

      toString() {
        return '[semantics wrapper for ' + self.grammar.name + ']';
      }
    };

    this.super = superSemantics;
    if (superSemantics) {
      if (!(grammar.equals(this.super.grammar) || grammar._inheritsFrom(this.super.grammar))) {
        throw new Error(
            "Cannot extend a semantics for grammar '" +
            this.super.grammar.name +
            "' for use with grammar '" +
            grammar.name +
            "' (not a sub-grammar)",
        );
      }
      this.operations = Object.create(this.super.operations);
      this.attributes = Object.create(this.super.attributes);
      this.attributeKeys = Object.create(null);

      // Assign unique symbols for each of the attributes inherited from the super-semantics so that
      // they are memoized independently.
      // eslint-disable-next-line guard-for-in
      for (const attributeName in this.attributes) {
        Object.defineProperty(this.attributeKeys, attributeName, {
          value: uniqueId(attributeName),
        });
      }
    } else {
      this.operations = Object.create(null);
      this.attributes = Object.create(null);
      this.attributeKeys = Object.create(null);
    }
  }

  toString() {
    return '[semantics for ' + this.grammar.name + ']';
  }

  checkActionDictsIfHaventAlready() {
    if (!this.checkedActionDicts) {
      this.checkActionDicts();
      this.checkedActionDicts = true;
    }
  }

  // Checks that the action dictionaries for all operations and attributes in this semantics,
  // including the ones that were inherited from the super-semantics, agree with the grammar.
  // Throws an exception if one or more of them doesn't.
  checkActionDicts() {
    let name;
    // eslint-disable-next-line guard-for-in
    for (name in this.operations) {
      this.operations[name].checkActionDict(this.grammar);
    }
    // eslint-disable-next-line guard-for-in
    for (name in this.attributes) {
      this.attributes[name].checkActionDict(this.grammar);
    }
  }

  toRecipe(semanticsOnly) {
    function hasSuperSemantics(s) {
      return s.super !== Semantics.BuiltInSemantics._getSemantics();
    }

    let str = '(function(g) {\n';
    if (hasSuperSemantics(this)) {
      str += '  var semantics = ' + this.super.toRecipe(true) + '(g';

      const superSemanticsGrammar = this.super.grammar;
      let relatedGrammar = this.grammar;
      while (relatedGrammar !== superSemanticsGrammar) {
        str += '.superGrammar';
        relatedGrammar = relatedGrammar.superGrammar;
      }

      str += ');\n';
      str += '  return g.extendSemantics(semantics)';
    } else {
      str += '  return g.createSemantics()';
    }
    ['Operation', 'Attribute'].forEach(type => {
      const semanticOperations = this[type.toLowerCase() + 's'];
      Object.keys(semanticOperations).forEach(name => {
        const {actionDict, formals, builtInDefault} = semanticOperations[name];

        let signature = name;
        if (formals.length > 0) {
          signature += '(' + formals.join(', ') + ')';
        }

        let method;
        if (hasSuperSemantics(this) && this.super[type.toLowerCase() + 's'][name]) {
          method = 'extend' + type;
        } else {
          method = 'add' + type;
        }
        str += '\n    .' + method + '(' + JSON.stringify(signature) + ', {';

        const srcArray = [];
        Object.keys(actionDict).forEach(actionName => {
          if (actionDict[actionName] !== builtInDefault) {
            let source = actionDict[actionName].toString().trim();

            // Convert method shorthand to plain old function syntax.
            // https://github.com/ohmjs/ohm/issues/263
            source = source.replace(/^.*\(/, 'function(');

            srcArray.push('\n      ' + JSON.stringify(actionName) + ': ' + source);
          }
        });
        str += srcArray.join(',') + '\n    })';
      });
    });
    str += ';\n  })';

    if (!semanticsOnly) {
      str =
        '(function() {\n' +
        '  var grammar = this.fromRecipe(' +
        this.grammar.toRecipe() +
        ');\n' +
        '  var semantics = ' +
        str +
        '(grammar);\n' +
        '  return semantics;\n' +
        '});\n';
    }

    return str;
  }

  addOperationOrAttribute(type, signature, actionDict) {
    const typePlural = type + 's';

    const parsedNameAndFormalArgs = parseSignature(signature, type);
    const {name} = parsedNameAndFormalArgs;
    const {formals} = parsedNameAndFormalArgs;

    // TODO: check that there are no duplicate formal arguments

    this.assertNewName(name, type);

    // Create the action dictionary for this operation / attribute that contains a `_default` action
    // which defines the default behavior of iteration, terminal, and non-terminal nodes...
    const builtInDefault = newDefaultAction(type, name, doIt);
    const realActionDict = {_default: builtInDefault};
    // ... and add in the actions supplied by the programmer, which may override some or all of the
    // default ones.
    Object.keys(actionDict).forEach(name => {
      realActionDict[name] = actionDict[name];
    });

    const entry =
      type === 'operation' ?
        new Operation(name, formals, realActionDict, builtInDefault) :
        new Attribute(name, realActionDict, builtInDefault);

    // The following check is not strictly necessary (it will happen later anyway) but it's better
    // to catch errors early.
    entry.checkActionDict(this.grammar);

    this[typePlural][name] = entry;

    function doIt(...args) {
      // Dispatch to most specific version of this operation / attribute -- it may have been
      // overridden by a sub-semantics.
      const thisThing = this._semantics[typePlural][name];

      // Check that the caller passed the correct number of arguments.
      if (arguments.length !== thisThing.formals.length) {
        throw new Error(
            'Invalid number of arguments passed to ' +
            name +
            ' ' +
            type +
            ' (expected ' +
            thisThing.formals.length +
            ', got ' +
            arguments.length +
            ')',
        );
      }

      // Create an "arguments object" from the arguments that were passed to this
      // operation / attribute.
      const argsObj = Object.create(null);
      for (const [idx, val] of Object.entries(args)) {
        const formal = thisThing.formals[idx];
        argsObj[formal] = val;
      }

      const oldArgs = this.args;
      this.args = argsObj;
      const ans = thisThing.execute(this._semantics, this);
      this.args = oldArgs;
      return ans;
    }

    if (type === 'operation') {
      this.Wrapper.prototype[name] = doIt;
      this.Wrapper.prototype[name].toString = function() {
        return '[' + name + ' operation]';
      };
    } else {
      Object.defineProperty(this.Wrapper.prototype, name, {
        get: doIt,
        configurable: true, // So the property can be deleted.
      });
      Object.defineProperty(this.attributeKeys, name, {
        value: uniqueId(name),
      });
    }
  }

  extendOperationOrAttribute(type, name, actionDict) {
    const typePlural = type + 's';

    // Make sure that `name` really is just a name, i.e., that it doesn't also contain formals.
    parseSignature(name, 'attribute');

    if (!(this.super && name in this.super[typePlural])) {
      throw new Error(
          'Cannot extend ' +
          type +
          " '" +
          name +
          "': did not inherit an " +
          type +
          ' with that name',
      );
    }
    if (hasOwnProperty(this[typePlural], name)) {
      throw new Error('Cannot extend ' + type + " '" + name + "' again");
    }

    // Create a new operation / attribute whose actionDict delegates to the super operation /
    // attribute's actionDict, and which has all the keys from `inheritedActionDict`.
    const inheritedFormals = this[typePlural][name].formals;
    const inheritedActionDict = this[typePlural][name].actionDict;
    const newActionDict = Object.create(inheritedActionDict);
    Object.keys(actionDict).forEach(name => {
      newActionDict[name] = actionDict[name];
    });

    this[typePlural][name] =
      type === 'operation' ?
        new Operation(name, inheritedFormals, newActionDict) :
        new Attribute(name, newActionDict);

    // The following check is not strictly necessary (it will happen later anyway) but it's better
    // to catch errors early.
    this[typePlural][name].checkActionDict(this.grammar);
  }

  assertNewName(name, type) {
    if (hasOwnProperty(Wrapper.prototype, name)) {
      throw new Error('Cannot add ' + type + " '" + name + "': that's a reserved name");
    }
    if (name in this.operations) {
      throw new Error(
          'Cannot add ' + type + " '" + name + "': an operation with that name already exists",
      );
    }
    if (name in this.attributes) {
      throw new Error(
          'Cannot add ' + type + " '" + name + "': an attribute with that name already exists",
      );
    }
  }

  // Returns a wrapper for the given CST `node` in this semantics.
  // If `node` is already a wrapper, returns `node` itself.  // TODO: why is this needed?
  wrap(node, source, optBaseInterval) {
    const baseInterval = optBaseInterval || source;
    return node instanceof this.Wrapper ? node : new this.Wrapper(node, source, baseInterval);
  }
}

function parseSignature(signature, type) {
  if (!Semantics.prototypeGrammar) {
    // The Operations and Attributes grammar won't be available while Ohm is loading,
    // but we can get away the following simplification b/c none of the operations
    // that are used while loading take arguments.
    assert(signature.indexOf('(') === -1);
    return {
      name: signature,
      formals: [],
    };
  }

  const r = Semantics.prototypeGrammar.match(
      signature,
    type === 'operation' ? 'OperationSignature' : 'AttributeSignature',
  );
  if (r.failed()) {
    throw new Error(r.message);
  }

  return Semantics.prototypeGrammarSemantics(r).parse();
}

function newDefaultAction(type, name, doIt) {
  return function(...children) {
    const thisThing = this._semantics.operations[name] || this._semantics.attributes[name];
    const args = thisThing.formals.map(formal => this.args[formal]);

    if (!this.isIteration() && children.length === 1) {
      // This CST node corresponds to a non-terminal in the grammar (e.g., AddExpr). The fact that
      // we got here means that this action dictionary doesn't have an action for this particular
      // non-terminal or a generic `_nonterminal` action.
      // As a convenience, if this node only has one child, we just return the result of applying
      // this operation / attribute to the child node.
      return doIt.apply(children[0], args);
    } else {
      // Otherwise, we throw an exception to let the programmer know that we don't know what
      // to do with this node.
      throw missingSemanticAction(this.ctorName, name, type, globalActionStack);
    }
  };
}

// Creates a new Semantics instance for `grammar`, inheriting operations and attributes from
// `optSuperSemantics`, if it is specified. Returns a function that acts as a proxy for the new
// Semantics instance. When that function is invoked with a CST node as an argument, it returns
// a wrapper for that node which gives access to the operations and attributes provided by this
// semantics.
Semantics.createSemantics = function(grammar, optSuperSemantics) {
  const s = new Semantics(
      grammar,
    optSuperSemantics !== undefined ?
      optSuperSemantics :
      Semantics.BuiltInSemantics._getSemantics(),
  );

  // To enable clients to invoke a semantics like a function, return a function that acts as a proxy
  // for `s`, which is the real `Semantics` instance.
  const proxy = function ASemantics(matchResult) {
    if (!(matchResult instanceof MatchResult)) {
      throw new TypeError(
          'Semantics expected a MatchResult, but got ' +
          unexpectedObjToString(matchResult),
      );
    }
    if (matchResult.failed()) {
      throw new TypeError('cannot apply Semantics to ' + matchResult.toString());
    }

    const cst = matchResult._cst;
    if (cst.grammar !== grammar) {
      throw new Error(
          "Cannot use a MatchResult from grammar '" +
          cst.grammar.name +
          "' with a semantics for '" +
          grammar.name +
          "'",
      );
    }
    const inputStream = new InputStream(matchResult.input);
    return s.wrap(cst, inputStream.interval(matchResult._cstOffset, matchResult.input.length));
  };

  // Forward public methods from the proxy to the semantics instance.
  proxy.addOperation = function(signature, actionDict) {
    s.addOperationOrAttribute('operation', signature, actionDict);
    return proxy;
  };
  proxy.extendOperation = function(name, actionDict) {
    s.extendOperationOrAttribute('operation', name, actionDict);
    return proxy;
  };
  proxy.addAttribute = function(name, actionDict) {
    s.addOperationOrAttribute('attribute', name, actionDict);
    return proxy;
  };
  proxy.extendAttribute = function(name, actionDict) {
    s.extendOperationOrAttribute('attribute', name, actionDict);
    return proxy;
  };
  proxy._getActionDict = function(operationOrAttributeName) {
    const action =
      s.operations[operationOrAttributeName] || s.attributes[operationOrAttributeName];
    if (!action) {
      throw new Error(
          '"' +
          operationOrAttributeName +
          '" is not a valid operation or attribute ' +
          'name in this semantics for "' +
          grammar.name +
          '"',
      );
    }
    return action.actionDict;
  };
  proxy._remove = function(operationOrAttributeName) {
    let semantic;
    if (operationOrAttributeName in s.operations) {
      semantic = s.operations[operationOrAttributeName];
      delete s.operations[operationOrAttributeName];
    } else if (operationOrAttributeName in s.attributes) {
      semantic = s.attributes[operationOrAttributeName];
      delete s.attributes[operationOrAttributeName];
    }
    delete s.Wrapper.prototype[operationOrAttributeName];
    return semantic;
  };
  proxy.getOperationNames = function() {
    return Object.keys(s.operations);
  };
  proxy.getAttributeNames = function() {
    return Object.keys(s.attributes);
  };
  proxy.getGrammar = function() {
    return s.grammar;
  };
  proxy.toRecipe = function(semanticsOnly) {
    return s.toRecipe(semanticsOnly);
  };

  // Make the proxy's toString() work.
  proxy.toString = s.toString.bind(s);

  // Returns the semantics for the proxy.
  proxy._getSemantics = function() {
    return s;
  };

  return proxy;
};

// ----------------- Operation -----------------

// An Operation represents a function to be applied to a concrete syntax tree (CST) -- it's very
// similar to a Visitor (http://en.wikipedia.org/wiki/Visitor_pattern). An operation is executed by
// recursively walking the CST, and at each node, invoking the matching semantic action from
// `actionDict`. See `Operation.prototype.execute` for details of how a CST node's matching semantic
// action is found.
class Operation {
  constructor(name, formals, actionDict, builtInDefault) {
    this.name = name;
    this.formals = formals;
    this.actionDict = actionDict;
    this.builtInDefault = builtInDefault;
  }

  checkActionDict(grammar) {
    grammar._checkTopDownActionDict(this.typeName, this.name, this.actionDict);
  }

  // Execute this operation on the CST node associated with `nodeWrapper` in the context of the
  // given Semantics instance.
  execute(semantics, nodeWrapper) {
    try {
      // Look for a semantic action whose name matches the node's constructor name, which is either
      // the name of a rule in the grammar, or '_terminal' (for a terminal node), or '_iter' (for an
      // iteration node).
      const {ctorName} = nodeWrapper._node;
      let actionFn = this.actionDict[ctorName];
      if (actionFn) {
        globalActionStack.push([this, ctorName]);
        return actionFn.apply(nodeWrapper, nodeWrapper._children());
      }

      // The action dictionary does not contain a semantic action for this specific type of node.
      // If this is a nonterminal node and the programmer has provided a `_nonterminal` semantic
      // action, we invoke it:
      if (nodeWrapper.isNonterminal()) {
        actionFn = this.actionDict._nonterminal;
        if (actionFn) {
          globalActionStack.push([this, '_nonterminal', ctorName]);
          return actionFn.apply(nodeWrapper, nodeWrapper._children());
        }
      }

      // Otherwise, we invoke the '_default' semantic action.
      globalActionStack.push([this, 'default action', ctorName]);
      return this.actionDict._default.apply(nodeWrapper, nodeWrapper._children());
    } finally {
      globalActionStack.pop();
    }
  }
}

Operation.prototype.typeName = 'operation';

// ----------------- Attribute -----------------

// Attributes are Operations whose results are memoized. This means that, for any given semantics,
// the semantic action for a CST node will be invoked no more than once.
class Attribute extends Operation {
  constructor(name, actionDict, builtInDefault) {
    super(name, [], actionDict, builtInDefault);
  }

  execute(semantics, nodeWrapper) {
    const node = nodeWrapper._node;
    const key = semantics.attributeKeys[this.name];
    if (!hasOwnProperty(node, key)) {
      // The following is a super-send -- isn't JS beautiful? :/
      node[key] = Operation.prototype.execute.call(this, semantics, nodeWrapper);
    }
    return node[key];
  }
}

Attribute.prototype.typeName = 'attribute';

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

const SPECIAL_ACTION_NAMES = ['_iter', '_terminal', '_nonterminal', '_default'];

function getSortedRuleValues(grammar) {
  return Object.keys(grammar.rules)
      .sort()
      .map(name => grammar.rules[name]);
}

// Until ES2019, JSON was not a valid subset of JavaScript because U+2028 (line separator)
// and U+2029 (paragraph separator) are allowed in JSON string literals, but not in JS.
// This function properly encodes those two characters so that the resulting string is
// represents both valid JSON, and valid JavaScript (for ES2018 and below).
// See https://v8.dev/features/subsume-json for more details.
const jsonToJS = str => str.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');

let ohmGrammar$1;
let buildGrammar$1;

class Grammar {
  constructor(name, superGrammar, rules, optDefaultStartRule) {
    this.name = name;
    this.superGrammar = superGrammar;
    this.rules = rules;
    if (optDefaultStartRule) {
      if (!(optDefaultStartRule in rules)) {
        throw new Error(
            "Invalid start rule: '" +
            optDefaultStartRule +
            "' is not a rule in grammar '" +
            name +
            "'",
        );
      }
      this.defaultStartRule = optDefaultStartRule;
    }
    this._matchStateInitializer = undefined;
    this.supportsIncrementalParsing = true;
  }

  matcher() {
    return new Matcher(this);
  }

  // Return true if the grammar is a built-in grammar, otherwise false.
  // NOTE: This might give an unexpected result if called before BuiltInRules is defined!
  isBuiltIn() {
    return this === Grammar.ProtoBuiltInRules || this === Grammar.BuiltInRules;
  }

  equals(g) {
    if (this === g) {
      return true;
    }
    // Do the cheapest comparisons first.
    if (
      g == null ||
      this.name !== g.name ||
      this.defaultStartRule !== g.defaultStartRule ||
      !(this.superGrammar === g.superGrammar || this.superGrammar.equals(g.superGrammar))
    ) {
      return false;
    }
    const myRules = getSortedRuleValues(this);
    const otherRules = getSortedRuleValues(g);
    return (
      myRules.length === otherRules.length &&
      myRules.every((rule, i) => {
        return (
          rule.description === otherRules[i].description &&
          rule.formals.join(',') === otherRules[i].formals.join(',') &&
          rule.body.toString() === otherRules[i].body.toString()
        );
      })
    );
  }

  match(input, optStartApplication) {
    const m = this.matcher();
    m.replaceInputRange(0, 0, input);
    return m.match(optStartApplication);
  }

  trace(input, optStartApplication) {
    const m = this.matcher();
    m.replaceInputRange(0, 0, input);
    return m.trace(optStartApplication);
  }

  createSemantics() {
    return Semantics.createSemantics(this);
  }

  extendSemantics(superSemantics) {
    return Semantics.createSemantics(this, superSemantics._getSemantics());
  }

  // Check that every key in `actionDict` corresponds to a semantic action, and that it maps to
  // a function of the correct arity. If not, throw an exception.
  _checkTopDownActionDict(what, name, actionDict) {
    const problems = [];

    // eslint-disable-next-line guard-for-in
    for (const k in actionDict) {
      const v = actionDict[k];
      const isSpecialAction = SPECIAL_ACTION_NAMES.includes(k);

      if (!isSpecialAction && !(k in this.rules)) {
        problems.push(`'${k}' is not a valid semantic action for '${this.name}'`);
        continue;
      }
      if (typeof v !== 'function') {
        problems.push(`'${k}' must be a function in an action dictionary for '${this.name}'`);
        continue;
      }
      const actual = v.length;
      const expected = this._topDownActionArity(k);
      if (actual !== expected) {
        let details;
        if (k === '_iter' || k === '_nonterminal') {
          details =
            `it should use a rest parameter, e.g. \`${k}(...children) {}\`. ` +
            'NOTE: this is new in Ohm v16 — see https://ohmjs.org/d/ati for details.';
        } else {
          details = `expected ${expected}, got ${actual}`;
        }
        problems.push(`Semantic action '${k}' has the wrong arity: ${details}`);
      }
    }
    if (problems.length > 0) {
      const prettyProblems = problems.map(problem => '- ' + problem);
      const error = new Error(
          [
            `Found errors in the action dictionary of the '${name}' ${what}:`,
            ...prettyProblems,
          ].join('\n'),
      );
      error.problems = problems;
      throw error;
    }
  }

  // Return the expected arity for a semantic action named `actionName`, which
  // is either a rule name or a special action name like '_nonterminal'.
  _topDownActionArity(actionName) {
    // All special actions have an expected arity of 0, though all but _terminal
    // are expected to use the rest parameter syntax (e.g. `_iter(...children)`).
    // This is considered to have arity 0, i.e. `((...args) => {}).length` is 0.
    return SPECIAL_ACTION_NAMES.includes(actionName) ?
      0 :
      this.rules[actionName].body.getArity();
  }

  _inheritsFrom(grammar) {
    let g = this.superGrammar;
    while (g) {
      if (g.equals(grammar, true)) {
        return true;
      }
      g = g.superGrammar;
    }
    return false;
  }

  toRecipe(superGrammarExpr = undefined) {
    const metaInfo = {};
    // Include the grammar source if it is available.
    if (this.source) {
      metaInfo.source = this.source.contents;
    }

    let startRule = null;
    if (this.defaultStartRule) {
      startRule = this.defaultStartRule;
    }

    const rules = {};
    Object.keys(this.rules).forEach(ruleName => {
      const ruleInfo = this.rules[ruleName];
      const {body} = ruleInfo;
      const isDefinition = !this.superGrammar || !this.superGrammar.rules[ruleName];

      let operation;
      if (isDefinition) {
        operation = 'define';
      } else {
        operation = body instanceof Extend ? 'extend' : 'override';
      }

      const metaInfo = {};
      if (ruleInfo.source && this.source) {
        const adjusted = ruleInfo.source.relativeTo(this.source);
        metaInfo.sourceInterval = [adjusted.startIdx, adjusted.endIdx];
      }

      const description = isDefinition ? ruleInfo.description : null;
      const bodyRecipe = body.outputRecipe(ruleInfo.formals, this.source);

      rules[ruleName] = [
        operation, // "define"/"extend"/"override"
        metaInfo,
        description,
        ruleInfo.formals,
        bodyRecipe,
      ];
    });

    // If the caller provided an expression to use for the supergrammar, use that.
    // Otherwise, if the supergrammar is a user grammar, use its recipe inline.
    let superGrammarOutput = 'null';
    if (superGrammarExpr) {
      superGrammarOutput = superGrammarExpr;
    } else if (this.superGrammar && !this.superGrammar.isBuiltIn()) {
      superGrammarOutput = this.superGrammar.toRecipe();
    }

    const recipeElements = [
      ...['grammar', metaInfo, this.name].map(JSON.stringify),
      superGrammarOutput,
      ...[startRule, rules].map(JSON.stringify),
    ];
    return jsonToJS(`[${recipeElements.join(',')}]`);
  }

  // TODO: Come up with better names for these methods.
  // TODO: Write the analog of these methods for inherited attributes.
  toOperationActionDictionaryTemplate() {
    return this._toOperationOrAttributeActionDictionaryTemplate();
  }
  toAttributeActionDictionaryTemplate() {
    return this._toOperationOrAttributeActionDictionaryTemplate();
  }

  _toOperationOrAttributeActionDictionaryTemplate() {
    // TODO: add the super-grammar's templates at the right place, e.g., a case for AddExpr_plus
    // should appear next to other cases of AddExpr.

    const sb = new StringBuffer();
    sb.append('{');

    let first = true;
    // eslint-disable-next-line guard-for-in
    for (const ruleName in this.rules) {
      const {body} = this.rules[ruleName];
      if (first) {
        first = false;
      } else {
        sb.append(',');
      }
      sb.append('\n');
      sb.append('  ');
      this.addSemanticActionTemplate(ruleName, body, sb);
    }

    sb.append('\n}');
    return sb.contents();
  }

  addSemanticActionTemplate(ruleName, body, sb) {
    sb.append(ruleName);
    sb.append(': function(');
    const arity = this._topDownActionArity(ruleName);
    sb.append(repeat('_', arity).join(', '));
    sb.append(') {\n');
    sb.append('  }');
  }

  // Parse a string which expresses a rule application in this grammar, and return the
  // resulting Apply node.
  parseApplication(str) {
    let app;
    if (str.indexOf('<') === -1) {
      // simple application
      app = new Apply(str);
    } else {
      // parameterized application
      const cst = ohmGrammar$1.match(str, 'Base_application');
      app = buildGrammar$1(cst, {});
    }

    // Ensure that the application is valid.
    if (!(app.ruleName in this.rules)) {
      throw undeclaredRule(app.ruleName, this.name);
    }
    const {formals} = this.rules[app.ruleName];
    if (formals.length !== app.args.length) {
      const {source} = this.rules[app.ruleName];
      throw wrongNumberOfParameters(
          app.ruleName,
          formals.length,
          app.args.length,
          source,
      );
    }
    return app;
  }

  _setUpMatchState(state) {
    if (this._matchStateInitializer) {
      this._matchStateInitializer(state);
    }
  }
}

// The following grammar contains a few rules that couldn't be written  in "userland".
// At the bottom of src/main.js, we create a sub-grammar of this grammar that's called
// `BuiltInRules`. That grammar contains several convenience rules, e.g., `letter` and
// `digit`, and is implicitly the super-grammar of any grammar whose super-grammar
// isn't specified.
Grammar.ProtoBuiltInRules = new Grammar(
    'ProtoBuiltInRules', // name
    undefined, // supergrammar
    {
      any: {
        body: any,
        formals: [],
        description: 'any character',
        primitive: true,
      },
      end: {
        body: end,
        formals: [],
        description: 'end of input',
        primitive: true,
      },

      caseInsensitive: {
        body: new CaseInsensitiveTerminal(new Param(0)),
        formals: ['str'],
        primitive: true,
      },
      lower: {
        body: new UnicodeChar('Ll'),
        formals: [],
        description: 'a lowercase letter',
        primitive: true,
      },
      upper: {
        body: new UnicodeChar('Lu'),
        formals: [],
        description: 'an uppercase letter',
        primitive: true,
      },
      // Union of Lt (titlecase), Lm (modifier), and Lo (other), i.e. any letter not in Ll or Lu.
      unicodeLtmo: {
        body: new UnicodeChar('Ltmo'),
        formals: [],
        description: 'a Unicode character in Lt, Lm, or Lo',
        primitive: true,
      },

      // These rules are not truly primitive (they could be written in userland) but are defined
      // here for bootstrapping purposes.
      spaces: {
        body: new Star(new Apply('space')),
        formals: [],
      },
      space: {
        body: new Range('\x00', ' '),
        formals: [],
        description: 'a space',
      },
    },
);

// This method is called from main.js once Ohm has loaded.
Grammar.initApplicationParser = function(grammar, builderFn) {
  ohmGrammar$1 = grammar;
  buildGrammar$1 = builderFn;
};

// --------------------------------------------------------------------
// Private Stuff
// --------------------------------------------------------------------

// Constructors

class GrammarDecl {
  constructor(name) {
    this.name = name;
  }

  // Helpers

  sourceInterval(startIdx, endIdx) {
    return this.source.subInterval(startIdx, endIdx - startIdx);
  }

  ensureSuperGrammar() {
    if (!this.superGrammar) {
      this.withSuperGrammar(
        // TODO: The conditional expression below is an ugly hack. It's kind of ok because
        // I doubt anyone will ever try to declare a grammar called `BuiltInRules`. Still,
        // we should try to find a better way to do this.
        this.name === 'BuiltInRules' ? Grammar.ProtoBuiltInRules : Grammar.BuiltInRules,
      );
    }
    return this.superGrammar;
  }

  ensureSuperGrammarRuleForOverriding(name, source) {
    const ruleInfo = this.ensureSuperGrammar().rules[name];
    if (!ruleInfo) {
      throw cannotOverrideUndeclaredRule(name, this.superGrammar.name, source);
    }
    return ruleInfo;
  }

  installOverriddenOrExtendedRule(name, formals, body, source) {
    const duplicateParameterNames$1 = getDuplicates(formals);
    if (duplicateParameterNames$1.length > 0) {
      throw duplicateParameterNames(name, duplicateParameterNames$1, source);
    }
    const ruleInfo = this.ensureSuperGrammar().rules[name];
    const expectedFormals = ruleInfo.formals;
    const expectedNumFormals = expectedFormals ? expectedFormals.length : 0;
    if (formals.length !== expectedNumFormals) {
      throw wrongNumberOfParameters(name, expectedNumFormals, formals.length, source);
    }
    return this.install(name, formals, body, ruleInfo.description, source);
  }

  install(name, formals, body, description, source, primitive = false) {
    this.rules[name] = {
      body: body.introduceParams(formals),
      formals,
      description,
      source,
      primitive,
    };
    return this;
  }

  // Stuff that you should only do once

  withSuperGrammar(superGrammar) {
    if (this.superGrammar) {
      throw new Error('the super grammar of a GrammarDecl cannot be set more than once');
    }
    this.superGrammar = superGrammar;
    this.rules = Object.create(superGrammar.rules);

    // Grammars with an explicit supergrammar inherit a default start rule.
    if (!superGrammar.isBuiltIn()) {
      this.defaultStartRule = superGrammar.defaultStartRule;
    }
    return this;
  }

  withDefaultStartRule(ruleName) {
    this.defaultStartRule = ruleName;
    return this;
  }

  withSource(source) {
    this.source = new InputStream(source).interval(0, source.length);
    return this;
  }

  // Creates a Grammar instance, and if it passes the sanity checks, returns it.
  build() {
    const grammar = new Grammar(
        this.name,
        this.ensureSuperGrammar(),
        this.rules,
        this.defaultStartRule,
    );
    // Initialize internal props that are inherited from the super grammar.
    grammar._matchStateInitializer = grammar.superGrammar._matchStateInitializer;
    grammar.supportsIncrementalParsing = grammar.superGrammar.supportsIncrementalParsing;

    // TODO: change the pexpr.prototype.assert... methods to make them add
    // exceptions to an array that's provided as an arg. Then we'll be able to
    // show more than one error of the same type at a time.
    // TODO: include the offending pexpr in the errors, that way we can show
    // the part of the source that caused it.
    const grammarErrors = [];
    let grammarHasInvalidApplications = false;
    Object.keys(grammar.rules).forEach(ruleName => {
      const {body} = grammar.rules[ruleName];
      try {
        body.assertChoicesHaveUniformArity(ruleName);
      } catch (e) {
        grammarErrors.push(e);
      }
      try {
        body.assertAllApplicationsAreValid(ruleName, grammar);
      } catch (e) {
        grammarErrors.push(e);
        grammarHasInvalidApplications = true;
      }
    });
    if (!grammarHasInvalidApplications) {
      // The following check can only be done if the grammar has no invalid applications.
      Object.keys(grammar.rules).forEach(ruleName => {
        const {body} = grammar.rules[ruleName];
        try {
          body.assertIteratedExprsAreNotNullable(grammar, []);
        } catch (e) {
          grammarErrors.push(e);
        }
      });
    }
    if (grammarErrors.length > 0) {
      throwErrors(grammarErrors);
    }
    if (this.source) {
      grammar.source = this.source;
    }

    return grammar;
  }

  // Rule declarations

  define(name, formals, body, description, source, primitive) {
    this.ensureSuperGrammar();
    if (this.superGrammar.rules[name]) {
      throw duplicateRuleDeclaration(name, this.name, this.superGrammar.name, source);
    } else if (this.rules[name]) {
      throw duplicateRuleDeclaration(name, this.name, this.name, source);
    }
    const duplicateParameterNames$1 = getDuplicates(formals);
    if (duplicateParameterNames$1.length > 0) {
      throw duplicateParameterNames(name, duplicateParameterNames$1, source);
    }
    return this.install(name, formals, body, description, source, primitive);
  }

  override(name, formals, body, descIgnored, source) {
    this.ensureSuperGrammarRuleForOverriding(name, source);
    this.installOverriddenOrExtendedRule(name, formals, body, source);
    return this;
  }

  extend(name, formals, fragment, descIgnored, source) {
    const ruleInfo = this.ensureSuperGrammar().rules[name];
    if (!ruleInfo) {
      throw cannotExtendUndeclaredRule(name, this.superGrammar.name, source);
    }
    const body = new Extend(this.superGrammar, name, fragment);
    body.source = fragment.source;
    this.installOverriddenOrExtendedRule(name, formals, body, source);
    return this;
  }
}

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

class Builder {
  constructor() {
    this.currentDecl = null;
    this.currentRuleName = null;
  }

  newGrammar(name) {
    return new GrammarDecl(name);
  }

  grammar(metaInfo, name, superGrammar, defaultStartRule, rules) {
    const gDecl = new GrammarDecl(name);
    if (superGrammar) {
      // `superGrammar` may be a recipe (i.e. an Array), or an actual grammar instance.
      gDecl.withSuperGrammar(
        superGrammar instanceof Grammar ? superGrammar : this.fromRecipe(superGrammar),
      );
    }
    if (defaultStartRule) {
      gDecl.withDefaultStartRule(defaultStartRule);
    }
    if (metaInfo && metaInfo.source) {
      gDecl.withSource(metaInfo.source);
    }

    this.currentDecl = gDecl;
    Object.keys(rules).forEach(ruleName => {
      this.currentRuleName = ruleName;
      const ruleRecipe = rules[ruleName];

      const action = ruleRecipe[0]; // define/extend/override
      const metaInfo = ruleRecipe[1];
      const description = ruleRecipe[2];
      const formals = ruleRecipe[3];
      const body = this.fromRecipe(ruleRecipe[4]);

      let source;
      if (gDecl.source && metaInfo && metaInfo.sourceInterval) {
        source = gDecl.source.subInterval(
            metaInfo.sourceInterval[0],
            metaInfo.sourceInterval[1] - metaInfo.sourceInterval[0],
        );
      }
      gDecl[action](ruleName, formals, body, description, source);
    });
    this.currentRuleName = this.currentDecl = null;
    return gDecl.build();
  }

  terminal(x) {
    return new Terminal(x);
  }

  range(from, to) {
    return new Range(from, to);
  }

  param(index) {
    return new Param(index);
  }

  alt(...termArgs) {
    let terms = [];
    for (let arg of termArgs) {
      if (!(arg instanceof PExpr)) {
        arg = this.fromRecipe(arg);
      }
      if (arg instanceof Alt) {
        terms = terms.concat(arg.terms);
      } else {
        terms.push(arg);
      }
    }
    return terms.length === 1 ? terms[0] : new Alt(terms);
  }

  seq(...factorArgs) {
    let factors = [];
    for (let arg of factorArgs) {
      if (!(arg instanceof PExpr)) {
        arg = this.fromRecipe(arg);
      }
      if (arg instanceof Seq) {
        factors = factors.concat(arg.factors);
      } else {
        factors.push(arg);
      }
    }
    return factors.length === 1 ? factors[0] : new Seq(factors);
  }

  star(expr) {
    if (!(expr instanceof PExpr)) {
      expr = this.fromRecipe(expr);
    }
    return new Star(expr);
  }

  plus(expr) {
    if (!(expr instanceof PExpr)) {
      expr = this.fromRecipe(expr);
    }
    return new Plus(expr);
  }

  opt(expr) {
    if (!(expr instanceof PExpr)) {
      expr = this.fromRecipe(expr);
    }
    return new Opt(expr);
  }

  not(expr) {
    if (!(expr instanceof PExpr)) {
      expr = this.fromRecipe(expr);
    }
    return new Not(expr);
  }

  lookahead(expr) {
    if (!(expr instanceof PExpr)) {
      expr = this.fromRecipe(expr);
    }
    return new Lookahead(expr);
  }

  lex(expr) {
    if (!(expr instanceof PExpr)) {
      expr = this.fromRecipe(expr);
    }
    return new Lex(expr);
  }

  app(ruleName, optParams) {
    if (optParams && optParams.length > 0) {
      optParams = optParams.map(function(param) {
        return param instanceof PExpr ? param : this.fromRecipe(param);
      }, this);
    }
    return new Apply(ruleName, optParams);
  }

  // Note that unlike other methods in this class, this method cannot be used as a
  // convenience constructor. It only works with recipes, because it relies on
  // `this.currentDecl` and `this.currentRuleName` being set.
  splice(beforeTerms, afterTerms) {
    return new Splice(
        this.currentDecl.superGrammar,
        this.currentRuleName,
        beforeTerms.map(term => this.fromRecipe(term)),
        afterTerms.map(term => this.fromRecipe(term)),
    );
  }

  fromRecipe(recipe) {
    // the meta-info of 'grammar' is processed in Builder.grammar
    const args = recipe[0] === 'grammar' ? recipe.slice(1) : recipe.slice(2);
    const result = this[recipe[0]](...args);

    const metaInfo = recipe[1];
    if (metaInfo) {
      if (metaInfo.sourceInterval && this.currentDecl) {
        result.withSource(this.currentDecl.sourceInterval(...metaInfo.sourceInterval));
      }
    }
    return result;
  }
}

function makeRecipe(recipe) {
  if (typeof recipe === 'function') {
    return recipe.call(new Builder());
  } else {
    if (typeof recipe === 'string') {
      // stringified JSON recipe
      recipe = JSON.parse(recipe);
    }
    return new Builder().fromRecipe(recipe);
  }
}

var BuiltInRules = makeRecipe(["grammar",{"source":"BuiltInRules {\n\n  alnum  (an alpha-numeric character)\n    = letter\n    | digit\n\n  letter  (a letter)\n    = lower\n    | upper\n    | unicodeLtmo\n\n  digit  (a digit)\n    = \"0\"..\"9\"\n\n  hexDigit  (a hexadecimal digit)\n    = digit\n    | \"a\"..\"f\"\n    | \"A\"..\"F\"\n\n  ListOf<elem, sep>\n    = NonemptyListOf<elem, sep>\n    | EmptyListOf<elem, sep>\n\n  NonemptyListOf<elem, sep>\n    = elem (sep elem)*\n\n  EmptyListOf<elem, sep>\n    = /* nothing */\n\n  listOf<elem, sep>\n    = nonemptyListOf<elem, sep>\n    | emptyListOf<elem, sep>\n\n  nonemptyListOf<elem, sep>\n    = elem (sep elem)*\n\n  emptyListOf<elem, sep>\n    = /* nothing */\n\n  // Allows a syntactic rule application within a lexical context.\n  applySyntactic<app> = app\n}"},"BuiltInRules",null,null,{"alnum":["define",{"sourceInterval":[18,78]},"an alpha-numeric character",[],["alt",{"sourceInterval":[60,78]},["app",{"sourceInterval":[60,66]},"letter",[]],["app",{"sourceInterval":[73,78]},"digit",[]]]],"letter":["define",{"sourceInterval":[82,142]},"a letter",[],["alt",{"sourceInterval":[107,142]},["app",{"sourceInterval":[107,112]},"lower",[]],["app",{"sourceInterval":[119,124]},"upper",[]],["app",{"sourceInterval":[131,142]},"unicodeLtmo",[]]]],"digit":["define",{"sourceInterval":[146,177]},"a digit",[],["range",{"sourceInterval":[169,177]},"0","9"]],"hexDigit":["define",{"sourceInterval":[181,254]},"a hexadecimal digit",[],["alt",{"sourceInterval":[219,254]},["app",{"sourceInterval":[219,224]},"digit",[]],["range",{"sourceInterval":[231,239]},"a","f"],["range",{"sourceInterval":[246,254]},"A","F"]]],"ListOf":["define",{"sourceInterval":[258,336]},null,["elem","sep"],["alt",{"sourceInterval":[282,336]},["app",{"sourceInterval":[282,307]},"NonemptyListOf",[["param",{"sourceInterval":[297,301]},0],["param",{"sourceInterval":[303,306]},1]]],["app",{"sourceInterval":[314,336]},"EmptyListOf",[["param",{"sourceInterval":[326,330]},0],["param",{"sourceInterval":[332,335]},1]]]]],"NonemptyListOf":["define",{"sourceInterval":[340,388]},null,["elem","sep"],["seq",{"sourceInterval":[372,388]},["param",{"sourceInterval":[372,376]},0],["star",{"sourceInterval":[377,388]},["seq",{"sourceInterval":[378,386]},["param",{"sourceInterval":[378,381]},1],["param",{"sourceInterval":[382,386]},0]]]]],"EmptyListOf":["define",{"sourceInterval":[392,434]},null,["elem","sep"],["seq",{"sourceInterval":[438,438]}]],"listOf":["define",{"sourceInterval":[438,516]},null,["elem","sep"],["alt",{"sourceInterval":[462,516]},["app",{"sourceInterval":[462,487]},"nonemptyListOf",[["param",{"sourceInterval":[477,481]},0],["param",{"sourceInterval":[483,486]},1]]],["app",{"sourceInterval":[494,516]},"emptyListOf",[["param",{"sourceInterval":[506,510]},0],["param",{"sourceInterval":[512,515]},1]]]]],"nonemptyListOf":["define",{"sourceInterval":[520,568]},null,["elem","sep"],["seq",{"sourceInterval":[552,568]},["param",{"sourceInterval":[552,556]},0],["star",{"sourceInterval":[557,568]},["seq",{"sourceInterval":[558,566]},["param",{"sourceInterval":[558,561]},1],["param",{"sourceInterval":[562,566]},0]]]]],"emptyListOf":["define",{"sourceInterval":[572,682]},null,["elem","sep"],["seq",{"sourceInterval":[685,685]}]],"applySyntactic":["define",{"sourceInterval":[685,710]},null,["app"],["param",{"sourceInterval":[707,710]},0]]}]);

Grammar.BuiltInRules = BuiltInRules;
announceBuiltInRules(Grammar.BuiltInRules);

var ohmGrammar = makeRecipe(["grammar",{"source":"Ohm {\n\n  Grammars\n    = Grammar*\n\n  Grammar\n    = ident SuperGrammar? \"{\" Rule* \"}\"\n\n  SuperGrammar\n    = \"<:\" ident\n\n  Rule\n    = ident Formals? ruleDescr? \"=\"  RuleBody  -- define\n    | ident Formals?            \":=\" OverrideRuleBody  -- override\n    | ident Formals?            \"+=\" RuleBody  -- extend\n\n  RuleBody\n    = \"|\"? NonemptyListOf<TopLevelTerm, \"|\">\n\n  TopLevelTerm\n    = Seq caseName  -- inline\n    | Seq\n\n  OverrideRuleBody\n    = \"|\"? NonemptyListOf<OverrideTopLevelTerm, \"|\">\n\n  OverrideTopLevelTerm\n    = \"...\"  -- superSplice\n    | TopLevelTerm\n\n  Formals\n    = \"<\" ListOf<ident, \",\"> \">\"\n\n  Params\n    = \"<\" ListOf<Seq, \",\"> \">\"\n\n  Alt\n    = NonemptyListOf<Seq, \"|\">\n\n  Seq\n    = Iter*\n\n  Iter\n    = Pred \"*\"  -- star\n    | Pred \"+\"  -- plus\n    | Pred \"?\"  -- opt\n    | Pred\n\n  Pred\n    = \"~\" Lex  -- not\n    | \"&\" Lex  -- lookahead\n    | Lex\n\n  Lex\n    = \"#\" Base  -- lex\n    | Base\n\n  Base\n    = ident Params? ~(ruleDescr? \"=\" | \":=\" | \"+=\")  -- application\n    | oneCharTerminal \"..\" oneCharTerminal           -- range\n    | terminal                                       -- terminal\n    | \"(\" Alt \")\"                                    -- paren\n\n  ruleDescr  (a rule description)\n    = \"(\" ruleDescrText \")\"\n\n  ruleDescrText\n    = (~\")\" any)*\n\n  caseName\n    = \"--\" (~\"\\n\" space)* name (~\"\\n\" space)* (\"\\n\" | &\"}\")\n\n  name  (a name)\n    = nameFirst nameRest*\n\n  nameFirst\n    = \"_\"\n    | letter\n\n  nameRest\n    = \"_\"\n    | alnum\n\n  ident  (an identifier)\n    = name\n\n  terminal\n    = \"\\\"\" terminalChar* \"\\\"\"\n\n  oneCharTerminal\n    = \"\\\"\" terminalChar \"\\\"\"\n\n  terminalChar\n    = escapeChar\n      | ~\"\\\\\" ~\"\\\"\" ~\"\\n\" \"\\u{0}\"..\"\\u{10FFFF}\"\n\n  escapeChar  (an escape sequence)\n    = \"\\\\\\\\\"                                     -- backslash\n    | \"\\\\\\\"\"                                     -- doubleQuote\n    | \"\\\\\\'\"                                     -- singleQuote\n    | \"\\\\b\"                                      -- backspace\n    | \"\\\\n\"                                      -- lineFeed\n    | \"\\\\r\"                                      -- carriageReturn\n    | \"\\\\t\"                                      -- tab\n    | \"\\\\u{\" hexDigit hexDigit? hexDigit?\n             hexDigit? hexDigit? hexDigit? \"}\"   -- unicodeCodePoint\n    | \"\\\\u\" hexDigit hexDigit hexDigit hexDigit  -- unicodeEscape\n    | \"\\\\x\" hexDigit hexDigit                    -- hexEscape\n\n  space\n   += comment\n\n  comment\n    = \"//\" (~\"\\n\" any)* &(\"\\n\" | end)  -- singleLine\n    | \"/*\" (~\"*/\" any)* \"*/\"  -- multiLine\n\n  tokens = token*\n\n  token = caseName | comment | ident | operator | punctuation | terminal | any\n\n  operator = \"<:\" | \"=\" | \":=\" | \"+=\" | \"*\" | \"+\" | \"?\" | \"~\" | \"&\"\n\n  punctuation = \"<\" | \">\" | \",\" | \"--\"\n}"},"Ohm",null,"Grammars",{"Grammars":["define",{"sourceInterval":[9,32]},null,[],["star",{"sourceInterval":[24,32]},["app",{"sourceInterval":[24,31]},"Grammar",[]]]],"Grammar":["define",{"sourceInterval":[36,83]},null,[],["seq",{"sourceInterval":[50,83]},["app",{"sourceInterval":[50,55]},"ident",[]],["opt",{"sourceInterval":[56,69]},["app",{"sourceInterval":[56,68]},"SuperGrammar",[]]],["terminal",{"sourceInterval":[70,73]},"{"],["star",{"sourceInterval":[74,79]},["app",{"sourceInterval":[74,78]},"Rule",[]]],["terminal",{"sourceInterval":[80,83]},"}"]]],"SuperGrammar":["define",{"sourceInterval":[87,116]},null,[],["seq",{"sourceInterval":[106,116]},["terminal",{"sourceInterval":[106,110]},"<:"],["app",{"sourceInterval":[111,116]},"ident",[]]]],"Rule_define":["define",{"sourceInterval":[131,181]},null,[],["seq",{"sourceInterval":[131,170]},["app",{"sourceInterval":[131,136]},"ident",[]],["opt",{"sourceInterval":[137,145]},["app",{"sourceInterval":[137,144]},"Formals",[]]],["opt",{"sourceInterval":[146,156]},["app",{"sourceInterval":[146,155]},"ruleDescr",[]]],["terminal",{"sourceInterval":[157,160]},"="],["app",{"sourceInterval":[162,170]},"RuleBody",[]]]],"Rule_override":["define",{"sourceInterval":[188,248]},null,[],["seq",{"sourceInterval":[188,235]},["app",{"sourceInterval":[188,193]},"ident",[]],["opt",{"sourceInterval":[194,202]},["app",{"sourceInterval":[194,201]},"Formals",[]]],["terminal",{"sourceInterval":[214,218]},":="],["app",{"sourceInterval":[219,235]},"OverrideRuleBody",[]]]],"Rule_extend":["define",{"sourceInterval":[255,305]},null,[],["seq",{"sourceInterval":[255,294]},["app",{"sourceInterval":[255,260]},"ident",[]],["opt",{"sourceInterval":[261,269]},["app",{"sourceInterval":[261,268]},"Formals",[]]],["terminal",{"sourceInterval":[281,285]},"+="],["app",{"sourceInterval":[286,294]},"RuleBody",[]]]],"Rule":["define",{"sourceInterval":[120,305]},null,[],["alt",{"sourceInterval":[131,305]},["app",{"sourceInterval":[131,170]},"Rule_define",[]],["app",{"sourceInterval":[188,235]},"Rule_override",[]],["app",{"sourceInterval":[255,294]},"Rule_extend",[]]]],"RuleBody":["define",{"sourceInterval":[309,362]},null,[],["seq",{"sourceInterval":[324,362]},["opt",{"sourceInterval":[324,328]},["terminal",{"sourceInterval":[324,327]},"|"]],["app",{"sourceInterval":[329,362]},"NonemptyListOf",[["app",{"sourceInterval":[344,356]},"TopLevelTerm",[]],["terminal",{"sourceInterval":[358,361]},"|"]]]]],"TopLevelTerm_inline":["define",{"sourceInterval":[385,408]},null,[],["seq",{"sourceInterval":[385,397]},["app",{"sourceInterval":[385,388]},"Seq",[]],["app",{"sourceInterval":[389,397]},"caseName",[]]]],"TopLevelTerm":["define",{"sourceInterval":[366,418]},null,[],["alt",{"sourceInterval":[385,418]},["app",{"sourceInterval":[385,397]},"TopLevelTerm_inline",[]],["app",{"sourceInterval":[415,418]},"Seq",[]]]],"OverrideRuleBody":["define",{"sourceInterval":[422,491]},null,[],["seq",{"sourceInterval":[445,491]},["opt",{"sourceInterval":[445,449]},["terminal",{"sourceInterval":[445,448]},"|"]],["app",{"sourceInterval":[450,491]},"NonemptyListOf",[["app",{"sourceInterval":[465,485]},"OverrideTopLevelTerm",[]],["terminal",{"sourceInterval":[487,490]},"|"]]]]],"OverrideTopLevelTerm_superSplice":["define",{"sourceInterval":[522,543]},null,[],["terminal",{"sourceInterval":[522,527]},"..."]],"OverrideTopLevelTerm":["define",{"sourceInterval":[495,562]},null,[],["alt",{"sourceInterval":[522,562]},["app",{"sourceInterval":[522,527]},"OverrideTopLevelTerm_superSplice",[]],["app",{"sourceInterval":[550,562]},"TopLevelTerm",[]]]],"Formals":["define",{"sourceInterval":[566,606]},null,[],["seq",{"sourceInterval":[580,606]},["terminal",{"sourceInterval":[580,583]},"<"],["app",{"sourceInterval":[584,602]},"ListOf",[["app",{"sourceInterval":[591,596]},"ident",[]],["terminal",{"sourceInterval":[598,601]},","]]],["terminal",{"sourceInterval":[603,606]},">"]]],"Params":["define",{"sourceInterval":[610,647]},null,[],["seq",{"sourceInterval":[623,647]},["terminal",{"sourceInterval":[623,626]},"<"],["app",{"sourceInterval":[627,643]},"ListOf",[["app",{"sourceInterval":[634,637]},"Seq",[]],["terminal",{"sourceInterval":[639,642]},","]]],["terminal",{"sourceInterval":[644,647]},">"]]],"Alt":["define",{"sourceInterval":[651,685]},null,[],["app",{"sourceInterval":[661,685]},"NonemptyListOf",[["app",{"sourceInterval":[676,679]},"Seq",[]],["terminal",{"sourceInterval":[681,684]},"|"]]]],"Seq":["define",{"sourceInterval":[689,704]},null,[],["star",{"sourceInterval":[699,704]},["app",{"sourceInterval":[699,703]},"Iter",[]]]],"Iter_star":["define",{"sourceInterval":[719,736]},null,[],["seq",{"sourceInterval":[719,727]},["app",{"sourceInterval":[719,723]},"Pred",[]],["terminal",{"sourceInterval":[724,727]},"*"]]],"Iter_plus":["define",{"sourceInterval":[743,760]},null,[],["seq",{"sourceInterval":[743,751]},["app",{"sourceInterval":[743,747]},"Pred",[]],["terminal",{"sourceInterval":[748,751]},"+"]]],"Iter_opt":["define",{"sourceInterval":[767,783]},null,[],["seq",{"sourceInterval":[767,775]},["app",{"sourceInterval":[767,771]},"Pred",[]],["terminal",{"sourceInterval":[772,775]},"?"]]],"Iter":["define",{"sourceInterval":[708,794]},null,[],["alt",{"sourceInterval":[719,794]},["app",{"sourceInterval":[719,727]},"Iter_star",[]],["app",{"sourceInterval":[743,751]},"Iter_plus",[]],["app",{"sourceInterval":[767,775]},"Iter_opt",[]],["app",{"sourceInterval":[790,794]},"Pred",[]]]],"Pred_not":["define",{"sourceInterval":[809,824]},null,[],["seq",{"sourceInterval":[809,816]},["terminal",{"sourceInterval":[809,812]},"~"],["app",{"sourceInterval":[813,816]},"Lex",[]]]],"Pred_lookahead":["define",{"sourceInterval":[831,852]},null,[],["seq",{"sourceInterval":[831,838]},["terminal",{"sourceInterval":[831,834]},"&"],["app",{"sourceInterval":[835,838]},"Lex",[]]]],"Pred":["define",{"sourceInterval":[798,862]},null,[],["alt",{"sourceInterval":[809,862]},["app",{"sourceInterval":[809,816]},"Pred_not",[]],["app",{"sourceInterval":[831,838]},"Pred_lookahead",[]],["app",{"sourceInterval":[859,862]},"Lex",[]]]],"Lex_lex":["define",{"sourceInterval":[876,892]},null,[],["seq",{"sourceInterval":[876,884]},["terminal",{"sourceInterval":[876,879]},"#"],["app",{"sourceInterval":[880,884]},"Base",[]]]],"Lex":["define",{"sourceInterval":[866,903]},null,[],["alt",{"sourceInterval":[876,903]},["app",{"sourceInterval":[876,884]},"Lex_lex",[]],["app",{"sourceInterval":[899,903]},"Base",[]]]],"Base_application":["define",{"sourceInterval":[918,979]},null,[],["seq",{"sourceInterval":[918,963]},["app",{"sourceInterval":[918,923]},"ident",[]],["opt",{"sourceInterval":[924,931]},["app",{"sourceInterval":[924,930]},"Params",[]]],["not",{"sourceInterval":[932,963]},["alt",{"sourceInterval":[934,962]},["seq",{"sourceInterval":[934,948]},["opt",{"sourceInterval":[934,944]},["app",{"sourceInterval":[934,943]},"ruleDescr",[]]],["terminal",{"sourceInterval":[945,948]},"="]],["terminal",{"sourceInterval":[951,955]},":="],["terminal",{"sourceInterval":[958,962]},"+="]]]]],"Base_range":["define",{"sourceInterval":[986,1041]},null,[],["seq",{"sourceInterval":[986,1022]},["app",{"sourceInterval":[986,1001]},"oneCharTerminal",[]],["terminal",{"sourceInterval":[1002,1006]},".."],["app",{"sourceInterval":[1007,1022]},"oneCharTerminal",[]]]],"Base_terminal":["define",{"sourceInterval":[1048,1106]},null,[],["app",{"sourceInterval":[1048,1056]},"terminal",[]]],"Base_paren":["define",{"sourceInterval":[1113,1168]},null,[],["seq",{"sourceInterval":[1113,1124]},["terminal",{"sourceInterval":[1113,1116]},"("],["app",{"sourceInterval":[1117,1120]},"Alt",[]],["terminal",{"sourceInterval":[1121,1124]},")"]]],"Base":["define",{"sourceInterval":[907,1168]},null,[],["alt",{"sourceInterval":[918,1168]},["app",{"sourceInterval":[918,963]},"Base_application",[]],["app",{"sourceInterval":[986,1022]},"Base_range",[]],["app",{"sourceInterval":[1048,1056]},"Base_terminal",[]],["app",{"sourceInterval":[1113,1124]},"Base_paren",[]]]],"ruleDescr":["define",{"sourceInterval":[1172,1231]},"a rule description",[],["seq",{"sourceInterval":[1210,1231]},["terminal",{"sourceInterval":[1210,1213]},"("],["app",{"sourceInterval":[1214,1227]},"ruleDescrText",[]],["terminal",{"sourceInterval":[1228,1231]},")"]]],"ruleDescrText":["define",{"sourceInterval":[1235,1266]},null,[],["star",{"sourceInterval":[1255,1266]},["seq",{"sourceInterval":[1256,1264]},["not",{"sourceInterval":[1256,1260]},["terminal",{"sourceInterval":[1257,1260]},")"]],["app",{"sourceInterval":[1261,1264]},"any",[]]]]],"caseName":["define",{"sourceInterval":[1270,1338]},null,[],["seq",{"sourceInterval":[1285,1338]},["terminal",{"sourceInterval":[1285,1289]},"--"],["star",{"sourceInterval":[1290,1304]},["seq",{"sourceInterval":[1291,1302]},["not",{"sourceInterval":[1291,1296]},["terminal",{"sourceInterval":[1292,1296]},"\n"]],["app",{"sourceInterval":[1297,1302]},"space",[]]]],["app",{"sourceInterval":[1305,1309]},"name",[]],["star",{"sourceInterval":[1310,1324]},["seq",{"sourceInterval":[1311,1322]},["not",{"sourceInterval":[1311,1316]},["terminal",{"sourceInterval":[1312,1316]},"\n"]],["app",{"sourceInterval":[1317,1322]},"space",[]]]],["alt",{"sourceInterval":[1326,1337]},["terminal",{"sourceInterval":[1326,1330]},"\n"],["lookahead",{"sourceInterval":[1333,1337]},["terminal",{"sourceInterval":[1334,1337]},"}"]]]]],"name":["define",{"sourceInterval":[1342,1382]},"a name",[],["seq",{"sourceInterval":[1363,1382]},["app",{"sourceInterval":[1363,1372]},"nameFirst",[]],["star",{"sourceInterval":[1373,1382]},["app",{"sourceInterval":[1373,1381]},"nameRest",[]]]]],"nameFirst":["define",{"sourceInterval":[1386,1418]},null,[],["alt",{"sourceInterval":[1402,1418]},["terminal",{"sourceInterval":[1402,1405]},"_"],["app",{"sourceInterval":[1412,1418]},"letter",[]]]],"nameRest":["define",{"sourceInterval":[1422,1452]},null,[],["alt",{"sourceInterval":[1437,1452]},["terminal",{"sourceInterval":[1437,1440]},"_"],["app",{"sourceInterval":[1447,1452]},"alnum",[]]]],"ident":["define",{"sourceInterval":[1456,1489]},"an identifier",[],["app",{"sourceInterval":[1485,1489]},"name",[]]],"terminal":["define",{"sourceInterval":[1493,1531]},null,[],["seq",{"sourceInterval":[1508,1531]},["terminal",{"sourceInterval":[1508,1512]},"\""],["star",{"sourceInterval":[1513,1526]},["app",{"sourceInterval":[1513,1525]},"terminalChar",[]]],["terminal",{"sourceInterval":[1527,1531]},"\""]]],"oneCharTerminal":["define",{"sourceInterval":[1535,1579]},null,[],["seq",{"sourceInterval":[1557,1579]},["terminal",{"sourceInterval":[1557,1561]},"\""],["app",{"sourceInterval":[1562,1574]},"terminalChar",[]],["terminal",{"sourceInterval":[1575,1579]},"\""]]],"terminalChar":["define",{"sourceInterval":[1583,1660]},null,[],["alt",{"sourceInterval":[1602,1660]},["app",{"sourceInterval":[1602,1612]},"escapeChar",[]],["seq",{"sourceInterval":[1621,1660]},["not",{"sourceInterval":[1621,1626]},["terminal",{"sourceInterval":[1622,1626]},"\\"]],["not",{"sourceInterval":[1627,1632]},["terminal",{"sourceInterval":[1628,1632]},"\""]],["not",{"sourceInterval":[1633,1638]},["terminal",{"sourceInterval":[1634,1638]},"\n"]],["range",{"sourceInterval":[1639,1660]},"\u0000","􏿿"]]]],"escapeChar_backslash":["define",{"sourceInterval":[1703,1758]},null,[],["terminal",{"sourceInterval":[1703,1709]},"\\\\"]],"escapeChar_doubleQuote":["define",{"sourceInterval":[1765,1822]},null,[],["terminal",{"sourceInterval":[1765,1771]},"\\\""]],"escapeChar_singleQuote":["define",{"sourceInterval":[1829,1886]},null,[],["terminal",{"sourceInterval":[1829,1835]},"\\'"]],"escapeChar_backspace":["define",{"sourceInterval":[1893,1948]},null,[],["terminal",{"sourceInterval":[1893,1898]},"\\b"]],"escapeChar_lineFeed":["define",{"sourceInterval":[1955,2009]},null,[],["terminal",{"sourceInterval":[1955,1960]},"\\n"]],"escapeChar_carriageReturn":["define",{"sourceInterval":[2016,2076]},null,[],["terminal",{"sourceInterval":[2016,2021]},"\\r"]],"escapeChar_tab":["define",{"sourceInterval":[2083,2132]},null,[],["terminal",{"sourceInterval":[2083,2088]},"\\t"]],"escapeChar_unicodeCodePoint":["define",{"sourceInterval":[2139,2243]},null,[],["seq",{"sourceInterval":[2139,2221]},["terminal",{"sourceInterval":[2139,2145]},"\\u{"],["app",{"sourceInterval":[2146,2154]},"hexDigit",[]],["opt",{"sourceInterval":[2155,2164]},["app",{"sourceInterval":[2155,2163]},"hexDigit",[]]],["opt",{"sourceInterval":[2165,2174]},["app",{"sourceInterval":[2165,2173]},"hexDigit",[]]],["opt",{"sourceInterval":[2188,2197]},["app",{"sourceInterval":[2188,2196]},"hexDigit",[]]],["opt",{"sourceInterval":[2198,2207]},["app",{"sourceInterval":[2198,2206]},"hexDigit",[]]],["opt",{"sourceInterval":[2208,2217]},["app",{"sourceInterval":[2208,2216]},"hexDigit",[]]],["terminal",{"sourceInterval":[2218,2221]},"}"]]],"escapeChar_unicodeEscape":["define",{"sourceInterval":[2250,2309]},null,[],["seq",{"sourceInterval":[2250,2291]},["terminal",{"sourceInterval":[2250,2255]},"\\u"],["app",{"sourceInterval":[2256,2264]},"hexDigit",[]],["app",{"sourceInterval":[2265,2273]},"hexDigit",[]],["app",{"sourceInterval":[2274,2282]},"hexDigit",[]],["app",{"sourceInterval":[2283,2291]},"hexDigit",[]]]],"escapeChar_hexEscape":["define",{"sourceInterval":[2316,2371]},null,[],["seq",{"sourceInterval":[2316,2339]},["terminal",{"sourceInterval":[2316,2321]},"\\x"],["app",{"sourceInterval":[2322,2330]},"hexDigit",[]],["app",{"sourceInterval":[2331,2339]},"hexDigit",[]]]],"escapeChar":["define",{"sourceInterval":[1664,2371]},"an escape sequence",[],["alt",{"sourceInterval":[1703,2371]},["app",{"sourceInterval":[1703,1709]},"escapeChar_backslash",[]],["app",{"sourceInterval":[1765,1771]},"escapeChar_doubleQuote",[]],["app",{"sourceInterval":[1829,1835]},"escapeChar_singleQuote",[]],["app",{"sourceInterval":[1893,1898]},"escapeChar_backspace",[]],["app",{"sourceInterval":[1955,1960]},"escapeChar_lineFeed",[]],["app",{"sourceInterval":[2016,2021]},"escapeChar_carriageReturn",[]],["app",{"sourceInterval":[2083,2088]},"escapeChar_tab",[]],["app",{"sourceInterval":[2139,2221]},"escapeChar_unicodeCodePoint",[]],["app",{"sourceInterval":[2250,2291]},"escapeChar_unicodeEscape",[]],["app",{"sourceInterval":[2316,2339]},"escapeChar_hexEscape",[]]]],"space":["extend",{"sourceInterval":[2375,2394]},null,[],["app",{"sourceInterval":[2387,2394]},"comment",[]]],"comment_singleLine":["define",{"sourceInterval":[2412,2458]},null,[],["seq",{"sourceInterval":[2412,2443]},["terminal",{"sourceInterval":[2412,2416]},"//"],["star",{"sourceInterval":[2417,2429]},["seq",{"sourceInterval":[2418,2427]},["not",{"sourceInterval":[2418,2423]},["terminal",{"sourceInterval":[2419,2423]},"\n"]],["app",{"sourceInterval":[2424,2427]},"any",[]]]],["lookahead",{"sourceInterval":[2430,2443]},["alt",{"sourceInterval":[2432,2442]},["terminal",{"sourceInterval":[2432,2436]},"\n"],["app",{"sourceInterval":[2439,2442]},"end",[]]]]]],"comment_multiLine":["define",{"sourceInterval":[2465,2501]},null,[],["seq",{"sourceInterval":[2465,2487]},["terminal",{"sourceInterval":[2465,2469]},"/*"],["star",{"sourceInterval":[2470,2482]},["seq",{"sourceInterval":[2471,2480]},["not",{"sourceInterval":[2471,2476]},["terminal",{"sourceInterval":[2472,2476]},"*/"]],["app",{"sourceInterval":[2477,2480]},"any",[]]]],["terminal",{"sourceInterval":[2483,2487]},"*/"]]],"comment":["define",{"sourceInterval":[2398,2501]},null,[],["alt",{"sourceInterval":[2412,2501]},["app",{"sourceInterval":[2412,2443]},"comment_singleLine",[]],["app",{"sourceInterval":[2465,2487]},"comment_multiLine",[]]]],"tokens":["define",{"sourceInterval":[2505,2520]},null,[],["star",{"sourceInterval":[2514,2520]},["app",{"sourceInterval":[2514,2519]},"token",[]]]],"token":["define",{"sourceInterval":[2524,2600]},null,[],["alt",{"sourceInterval":[2532,2600]},["app",{"sourceInterval":[2532,2540]},"caseName",[]],["app",{"sourceInterval":[2543,2550]},"comment",[]],["app",{"sourceInterval":[2553,2558]},"ident",[]],["app",{"sourceInterval":[2561,2569]},"operator",[]],["app",{"sourceInterval":[2572,2583]},"punctuation",[]],["app",{"sourceInterval":[2586,2594]},"terminal",[]],["app",{"sourceInterval":[2597,2600]},"any",[]]]],"operator":["define",{"sourceInterval":[2604,2669]},null,[],["alt",{"sourceInterval":[2615,2669]},["terminal",{"sourceInterval":[2615,2619]},"<:"],["terminal",{"sourceInterval":[2622,2625]},"="],["terminal",{"sourceInterval":[2628,2632]},":="],["terminal",{"sourceInterval":[2635,2639]},"+="],["terminal",{"sourceInterval":[2642,2645]},"*"],["terminal",{"sourceInterval":[2648,2651]},"+"],["terminal",{"sourceInterval":[2654,2657]},"?"],["terminal",{"sourceInterval":[2660,2663]},"~"],["terminal",{"sourceInterval":[2666,2669]},"&"]]],"punctuation":["define",{"sourceInterval":[2673,2709]},null,[],["alt",{"sourceInterval":[2687,2709]},["terminal",{"sourceInterval":[2687,2690]},"<"],["terminal",{"sourceInterval":[2693,2696]},">"],["terminal",{"sourceInterval":[2699,2702]},","],["terminal",{"sourceInterval":[2705,2709]},"--"]]]}]);

const superSplicePlaceholder = Object.create(PExpr.prototype);

function namespaceHas(ns, name) {
  // Look for an enumerable property, anywhere in the prototype chain.
  for (const prop in ns) {
    if (prop === name) return true;
  }
  return false;
}

// Returns a Grammar instance (i.e., an object with a `match` method) for
// `tree`, which is the concrete syntax tree of a user-written grammar.
// The grammar will be assigned into `namespace` under the name of the grammar
// as specified in the source.
function buildGrammar(match, namespace, optOhmGrammarForTesting) {
  const builder = new Builder();
  let decl;
  let currentRuleName;
  let currentRuleFormals;
  let overriding = false;
  const metaGrammar = optOhmGrammarForTesting || ohmGrammar;

  // A visitor that produces a Grammar instance from the CST.
  const helpers = metaGrammar.createSemantics().addOperation('visit', {
    Grammars(grammarIter) {
      return grammarIter.children.map(c => c.visit());
    },
    Grammar(id, s, _open, rules, _close) {
      const grammarName = id.visit();
      decl = builder.newGrammar(grammarName);
      s.child(0) && s.child(0).visit();
      rules.children.map(c => c.visit());
      const g = decl.build();
      g.source = this.source.trimmed();
      if (namespaceHas(namespace, grammarName)) {
        throw duplicateGrammarDeclaration(g);
      }
      namespace[grammarName] = g;
      return g;
    },

    SuperGrammar(_, n) {
      const superGrammarName = n.visit();
      if (superGrammarName === 'null') {
        decl.withSuperGrammar(null);
      } else {
        if (!namespace || !namespaceHas(namespace, superGrammarName)) {
          throw undeclaredGrammar(superGrammarName, namespace, n.source);
        }
        decl.withSuperGrammar(namespace[superGrammarName]);
      }
    },

    Rule_define(n, fs, d, _, b) {
      currentRuleName = n.visit();
      currentRuleFormals = fs.children.map(c => c.visit())[0] || [];
      // If there is no default start rule yet, set it now. This must be done before visiting
      // the body, because it might contain an inline rule definition.
      if (!decl.defaultStartRule && decl.ensureSuperGrammar() !== Grammar.ProtoBuiltInRules) {
        decl.withDefaultStartRule(currentRuleName);
      }
      const body = b.visit();
      const description = d.children.map(c => c.visit())[0];
      const source = this.source.trimmed();
      return decl.define(currentRuleName, currentRuleFormals, body, description, source);
    },
    Rule_override(n, fs, _, b) {
      currentRuleName = n.visit();
      currentRuleFormals = fs.children.map(c => c.visit())[0] || [];

      const source = this.source.trimmed();
      decl.ensureSuperGrammarRuleForOverriding(currentRuleName, source);

      overriding = true;
      const body = b.visit();
      overriding = false;
      return decl.override(currentRuleName, currentRuleFormals, body, null, source);
    },
    Rule_extend(n, fs, _, b) {
      currentRuleName = n.visit();
      currentRuleFormals = fs.children.map(c => c.visit())[0] || [];
      const body = b.visit();
      const source = this.source.trimmed();
      return decl.extend(currentRuleName, currentRuleFormals, body, null, source);
    },
    RuleBody(_, terms) {
      return builder.alt(...terms.visit()).withSource(this.source);
    },
    OverrideRuleBody(_, terms) {
      const args = terms.visit();

      // Check if the super-splice operator (`...`) appears in the terms.
      const expansionPos = args.indexOf(superSplicePlaceholder);
      if (expansionPos >= 0) {
        const beforeTerms = args.slice(0, expansionPos);
        const afterTerms = args.slice(expansionPos + 1);

        // Ensure it appears no more than once.
        afterTerms.forEach(t => {
          if (t === superSplicePlaceholder) throw multipleSuperSplices(t);
        });

        return new Splice(
            decl.superGrammar,
            currentRuleName,
            beforeTerms,
            afterTerms,
        ).withSource(this.source);
      } else {
        return builder.alt(...args).withSource(this.source);
      }
    },
    Formals(opointy, fs, cpointy) {
      return fs.visit();
    },

    Params(opointy, ps, cpointy) {
      return ps.visit();
    },

    Alt(seqs) {
      return builder.alt(...seqs.visit()).withSource(this.source);
    },

    TopLevelTerm_inline(b, n) {
      const inlineRuleName = currentRuleName + '_' + n.visit();
      const body = b.visit();
      const source = this.source.trimmed();
      const isNewRuleDeclaration = !(
        decl.superGrammar && decl.superGrammar.rules[inlineRuleName]
      );
      if (overriding && !isNewRuleDeclaration) {
        decl.override(inlineRuleName, currentRuleFormals, body, null, source);
      } else {
        decl.define(inlineRuleName, currentRuleFormals, body, null, source);
      }
      const params = currentRuleFormals.map(formal => builder.app(formal));
      return builder.app(inlineRuleName, params).withSource(body.source);
    },
    OverrideTopLevelTerm_superSplice(_) {
      return superSplicePlaceholder;
    },

    Seq(expr) {
      return builder.seq(...expr.children.map(c => c.visit())).withSource(this.source);
    },

    Iter_star(x, _) {
      return builder.star(x.visit()).withSource(this.source);
    },
    Iter_plus(x, _) {
      return builder.plus(x.visit()).withSource(this.source);
    },
    Iter_opt(x, _) {
      return builder.opt(x.visit()).withSource(this.source);
    },

    Pred_not(_, x) {
      return builder.not(x.visit()).withSource(this.source);
    },
    Pred_lookahead(_, x) {
      return builder.lookahead(x.visit()).withSource(this.source);
    },

    Lex_lex(_, x) {
      return builder.lex(x.visit()).withSource(this.source);
    },

    Base_application(rule, ps) {
      const params = ps.children.map(c => c.visit())[0] || [];
      return builder.app(rule.visit(), params).withSource(this.source);
    },
    Base_range(from, _, to) {
      return builder.range(from.visit(), to.visit()).withSource(this.source);
    },
    Base_terminal(expr) {
      return builder.terminal(expr.visit()).withSource(this.source);
    },
    Base_paren(open, x, close) {
      return x.visit();
    },

    ruleDescr(open, t, close) {
      return t.visit();
    },
    ruleDescrText(_) {
      return this.sourceString.trim();
    },

    caseName(_, space1, n, space2, end) {
      return n.visit();
    },

    name(first, rest) {
      return this.sourceString;
    },
    nameFirst(expr) {},
    nameRest(expr) {},

    terminal(open, cs, close) {
      return cs.children.map(c => c.visit()).join('');
    },

    oneCharTerminal(open, c, close) {
      return c.visit();
    },

    escapeChar(c) {
      try {
        return unescapeCodePoint(this.sourceString);
      } catch (err) {
        if (err instanceof RangeError && err.message.startsWith('Invalid code point ')) {
          throw invalidCodePoint(c);
        }
        throw err; // Rethrow
      }
    },

    NonemptyListOf(x, _, xs) {
      return [x.visit()].concat(xs.children.map(c => c.visit()));
    },
    EmptyListOf() {
      return [];
    },

    _terminal() {
      return this.sourceString;
    },
  });
  return helpers(match).visit();
}

var operationsAndAttributesGrammar = makeRecipe(["grammar",{"source":"OperationsAndAttributes {\n\n  AttributeSignature =\n    name\n\n  OperationSignature =\n    name Formals?\n\n  Formals\n    = \"(\" ListOf<name, \",\"> \")\"\n\n  name  (a name)\n    = nameFirst nameRest*\n\n  nameFirst\n    = \"_\"\n    | letter\n\n  nameRest\n    = \"_\"\n    | alnum\n\n}"},"OperationsAndAttributes",null,"AttributeSignature",{"AttributeSignature":["define",{"sourceInterval":[29,58]},null,[],["app",{"sourceInterval":[54,58]},"name",[]]],"OperationSignature":["define",{"sourceInterval":[62,100]},null,[],["seq",{"sourceInterval":[87,100]},["app",{"sourceInterval":[87,91]},"name",[]],["opt",{"sourceInterval":[92,100]},["app",{"sourceInterval":[92,99]},"Formals",[]]]]],"Formals":["define",{"sourceInterval":[104,143]},null,[],["seq",{"sourceInterval":[118,143]},["terminal",{"sourceInterval":[118,121]},"("],["app",{"sourceInterval":[122,139]},"ListOf",[["app",{"sourceInterval":[129,133]},"name",[]],["terminal",{"sourceInterval":[135,138]},","]]],["terminal",{"sourceInterval":[140,143]},")"]]],"name":["define",{"sourceInterval":[147,187]},"a name",[],["seq",{"sourceInterval":[168,187]},["app",{"sourceInterval":[168,177]},"nameFirst",[]],["star",{"sourceInterval":[178,187]},["app",{"sourceInterval":[178,186]},"nameRest",[]]]]],"nameFirst":["define",{"sourceInterval":[191,223]},null,[],["alt",{"sourceInterval":[207,223]},["terminal",{"sourceInterval":[207,210]},"_"],["app",{"sourceInterval":[217,223]},"letter",[]]]],"nameRest":["define",{"sourceInterval":[227,257]},null,[],["alt",{"sourceInterval":[242,257]},["terminal",{"sourceInterval":[242,245]},"_"],["app",{"sourceInterval":[252,257]},"alnum",[]]]]}]);

initBuiltInSemantics(Grammar.BuiltInRules);
initPrototypeParser(operationsAndAttributesGrammar); // requires BuiltInSemantics

function initBuiltInSemantics(builtInRules) {
  const actions = {
    empty() {
      return this.iteration();
    },
    nonEmpty(first, _, rest) {
      return this.iteration([first].concat(rest.children));
    },
  };

  Semantics.BuiltInSemantics = Semantics.createSemantics(builtInRules, null).addOperation(
      'asIteration',
      {
        emptyListOf: actions.empty,
        nonemptyListOf: actions.nonEmpty,
        EmptyListOf: actions.empty,
        NonemptyListOf: actions.nonEmpty,
      },
  );
}

function initPrototypeParser(grammar) {
  Semantics.prototypeGrammarSemantics = grammar.createSemantics().addOperation('parse', {
    AttributeSignature(name) {
      return {
        name: name.parse(),
        formals: [],
      };
    },
    OperationSignature(name, optFormals) {
      return {
        name: name.parse(),
        formals: optFormals.children.map(c => c.parse())[0] || [],
      };
    },
    Formals(oparen, fs, cparen) {
      return fs.asIteration().children.map(c => c.parse());
    },
    name(first, rest) {
      return this.sourceString;
    },
  });
  Semantics.prototypeGrammar = grammar;
}

function findIndentation(input) {
  let pos = 0;
  const stack = [0];
  const topOfStack = () => stack[stack.length - 1];

  const result = {};

  const regex = /( *).*(?:$|\r?\n|\r)/g;
  let match;
  while ((match = regex.exec(input)) != null) {
    const [line, indent] = match;

    // The last match will always have length 0. In every other case, some
    // characters will be matched (possibly only the end of line chars).
    if (line.length === 0) break;

    const indentSize = indent.length;
    const prevSize = topOfStack();

    const indentPos = pos + indentSize;

    if (indentSize > prevSize) {
      // Indent -- always only 1.
      stack.push(indentSize);
      result[indentPos] = 1;
    } else if (indentSize < prevSize) {
      // Dedent -- can be multiple levels.
      const prevLength = stack.length;
      while (topOfStack() !== indentSize) {
        stack.pop();
      }
      result[indentPos] = -1 * (prevLength - stack.length);
    }
    pos += line.length;
  }
  // Ensure that there is a matching DEDENT for every remaining INDENT.
  if (stack.length > 1) {
    result[pos] = 1 - stack.length;
  }
  return result;
}

const INDENT_DESCRIPTION = 'an indented block';
const DEDENT_DESCRIPTION = 'a dedent';

// A sentinel value that is out of range for both charCodeAt() and codePointAt().
const INVALID_CODE_POINT = 0x10ffff + 1;

class InputStreamWithIndentation extends InputStream {
  constructor(state) {
    super(state.input);
    this.state = state;
  }

  _indentationAt(pos) {
    return this.state.userData[pos] || 0;
  }

  atEnd() {
    return super.atEnd() && this._indentationAt(this.pos) === 0;
  }

  next() {
    if (this._indentationAt(this.pos) !== 0) {
      this.examinedLength = Math.max(this.examinedLength, this.pos);
      return undefined;
    }
    return super.next();
  }

  nextCharCode() {
    if (this._indentationAt(this.pos) !== 0) {
      this.examinedLength = Math.max(this.examinedLength, this.pos);
      return INVALID_CODE_POINT;
    }
    return super.nextCharCode();
  }

  nextCodePoint() {
    if (this._indentationAt(this.pos) !== 0) {
      this.examinedLength = Math.max(this.examinedLength, this.pos);
      return INVALID_CODE_POINT;
    }
    return super.nextCodePoint();
  }
}

class Indentation extends PExpr {
  constructor(isIndent = true) {
    super();
    this.isIndent = isIndent;
  }

  allowsSkippingPrecedingSpace() {
    return true;
  }

  eval(state) {
    const {inputStream} = state;
    const pseudoTokens = state.userData;
    state.doNotMemoize = true;

    const origPos = inputStream.pos;

    const sign = this.isIndent ? 1 : -1;
    const count = (pseudoTokens[origPos] || 0) * sign;
    if (count > 0) {
      // Update the count to consume the pseudotoken.
      state.userData = Object.create(pseudoTokens);
      state.userData[origPos] -= sign;

      state.pushBinding(new TerminalNode(0), origPos);
      return true;
    } else {
      state.processFailure(origPos, this);
      return false;
    }
  }

  getArity() {
    return 1;
  }

  _assertAllApplicationsAreValid(ruleName, grammar) {}

  _isNullable(grammar, memo) {
    return false;
  }

  assertChoicesHaveUniformArity(ruleName) {}

  assertIteratedExprsAreNotNullable(grammar) {}

  introduceParams(formals) {
    return this;
  }

  substituteParams(actuals) {
    return this;
  }

  toString() {
    return this.isIndent ? 'indent' : 'dedent';
  }

  toDisplayString() {
    return this.toString();
  }

  toFailure(grammar) {
    const description = this.isIndent ? INDENT_DESCRIPTION : DEDENT_DESCRIPTION;
    return new Failure(this, description, 'description');
  }
}

// Create a new definition for `any` that can consume indent & dedent.
const applyIndent = new Apply('indent');
const applyDedent = new Apply('dedent');
const newAnyBody = new Splice(BuiltInRules, 'any', [applyIndent, applyDedent], []);

const IndentationSensitive = new Builder()
    .newGrammar('IndentationSensitive')
    .withSuperGrammar(BuiltInRules)
    .define('indent', [], new Indentation(true), INDENT_DESCRIPTION, undefined, true)
    .define('dedent', [], new Indentation(false), DEDENT_DESCRIPTION, undefined, true)
    .extend('any', [], newAnyBody, 'any character', undefined)
    .build();

Object.assign(IndentationSensitive, {
  _matchStateInitializer(state) {
    state.userData = findIndentation(state.input);
    state.inputStream = new InputStreamWithIndentation(state);
  },
  supportsIncrementalParsing: false,
});

// Generated by scripts/prebuild.js
const version$1 = '17.1.0';

Grammar.initApplicationParser(ohmGrammar, buildGrammar);

const isBuffer$1 = obj =>
  !!obj.constructor &&
  typeof obj.constructor.isBuffer === 'function' &&
  obj.constructor.isBuffer(obj);

function compileAndLoad(source, namespace) {
  const m = ohmGrammar.match(source, 'Grammars');
  if (m.failed()) {
    throw grammarSyntaxError(m);
  }
  return buildGrammar(m, namespace);
}

function grammar(source, optNamespace) {
  const ns = grammars(source, optNamespace);

  // Ensure that the source contained no more than one grammar definition.
  const grammarNames = Object.keys(ns);
  if (grammarNames.length === 0) {
    throw new Error('Missing grammar definition');
  } else if (grammarNames.length > 1) {
    const secondGrammar = ns[grammarNames[1]];
    const interval = secondGrammar.source;
    throw new Error(
        getLineAndColumnMessage(interval.sourceString, interval.startIdx) +
        'Found more than one grammar definition -- use ohm.grammars() instead.',
    );
  }
  return ns[grammarNames[0]]; // Return the one and only grammar.
}

function grammars(source, optNamespace) {
  const ns = Object.create(optNamespace || {});
  if (typeof source !== 'string') {
    // For convenience, detect Node.js Buffer objects and automatically call toString().
    if (isBuffer$1(source)) {
      source = source.toString();
    } else {
      throw new TypeError(
          'Expected string as first argument, got ' + unexpectedObjToString(source),
      );
    }
  }
  compileAndLoad(source, ns);
  return ns;
}

ohm$1.ExperimentalIndentationSensitive = IndentationSensitive;
ohm$1._buildGrammar = buildGrammar;
ohm$1.grammar = grammar;
ohm$1.grammars = grammars;
ohm$1.makeRecipe = makeRecipe;
ohm$1.ohmGrammar = ohmGrammar;
ohm$1.pexprs = pexprs;
ohm$1.version = version$1;

// build/runtime.ts
var BASE_PATH = "https://api.x.flatfile.com/v1".replace(/\/+$/, "");
var Configuration = class {
  constructor(configuration = {}) {
    this.configuration = configuration;
  }
  set config(configuration) {
    this.configuration = configuration;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || querystring;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const apiKey = this.configuration.apiKey;
    if (apiKey) {
      return typeof apiKey === "function" ? apiKey : () => apiKey;
    }
    return void 0;
  }
  get accessToken() {
    const accessToken = this.configuration.accessToken;
    if (accessToken) {
      return typeof accessToken === "function" ? accessToken : async () => accessToken;
    }
    return void 0;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
};
var DefaultConfig = new Configuration();
var BaseAPI = class {
  constructor(configuration = DefaultConfig) {
    this.configuration = configuration;
    this.middleware = configuration.middleware;
  }
  middleware;
  withMiddleware(...middlewares) {
    const next = this.clone();
    next.middleware = next.middleware.concat(...middlewares);
    return next;
  }
  withPreMiddleware(...preMiddlewares) {
    const middlewares = preMiddlewares.map((pre) => ({ pre }));
    return this.withMiddleware(...middlewares);
  }
  withPostMiddleware(...postMiddlewares) {
    const middlewares = postMiddlewares.map((post) => ({ post }));
    return this.withMiddleware(...middlewares);
  }
  async request(context, initOverrides) {
    const { url, init } = await this.createFetchParams(context, initOverrides);
    const response = await this.fetchApi(url, init);
    if (response && (response.status >= 200 && response.status < 300)) {
      return response;
    }
    throw new ResponseError(response, "Response returned an error code");
  }
  async createFetchParams(context, initOverrides) {
    let url = this.configuration.basePath + context.path;
    if (context.query !== void 0 && Object.keys(context.query).length !== 0) {
      url += "?" + this.configuration.queryParamsStringify(context.query);
    }
    const headers = Object.assign({}, this.configuration.headers, context.headers);
    Object.keys(headers).forEach((key) => headers[key] === void 0 ? delete headers[key] : {});
    const initOverrideFn = typeof initOverrides === "function" ? initOverrides : async () => initOverrides;
    const initParams = {
      method: context.method,
      headers,
      body: context.body,
      credentials: this.configuration.credentials
    };
    const overridedInit = {
      ...initParams,
      ...await initOverrideFn({
        init: initParams,
        context
      })
    };
    const init = {
      ...overridedInit,
      body: isFormData(overridedInit.body) || overridedInit.body instanceof URLSearchParams || isBlob(overridedInit.body) ? overridedInit.body : JSON.stringify(overridedInit.body)
    };
    return { url, init };
  }
  fetchApi = async (url, init) => {
    let fetchParams = { url, init };
    for (const middleware of this.middleware) {
      if (middleware.pre) {
        fetchParams = await middleware.pre({
          fetch: this.fetchApi,
          ...fetchParams
        }) || fetchParams;
      }
    }
    let response = void 0;
    try {
      response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
    } catch (e) {
      for (const middleware of this.middleware) {
        if (middleware.onError) {
          response = await middleware.onError({
            fetch: this.fetchApi,
            url: fetchParams.url,
            init: fetchParams.init,
            error: e,
            response: response ? response.clone() : void 0
          }) || response;
        }
      }
      if (response === void 0) {
        if (e instanceof Error) {
          throw new FetchError(e, "The request failed and the interceptors did not return an alternative response");
        } else {
          throw e;
        }
      }
    }
    for (const middleware of this.middleware) {
      if (middleware.post) {
        response = await middleware.post({
          fetch: this.fetchApi,
          url: fetchParams.url,
          init: fetchParams.init,
          response: response.clone()
        }) || response;
      }
    }
    return response;
  };
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const constructor = this.constructor;
    const next = new constructor(this.configuration);
    next.middleware = this.middleware.slice();
    return next;
  }
};
function isBlob(value) {
  return typeof Blob !== "undefined" && value instanceof Blob;
}
function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}
var ResponseError = class extends Error {
  constructor(response, msg) {
    super(msg);
    this.response = response;
  }
  name = "ResponseError";
};
var FetchError = class extends Error {
  constructor(cause, msg) {
    super(msg);
    this.cause = cause;
  }
  name = "FetchError";
};
var RequiredError = class extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
  }
  name = "RequiredError";
};
var COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
function exists(json, key) {
  const value = json[key];
  return value !== null && value !== void 0;
}
function querystring(params, prefix = "") {
  return Object.keys(params).map((key) => querystringSingleKey(key, params[key], prefix)).filter((part) => part.length > 0).join("&");
}
function querystringSingleKey(key, value, keyPrefix = "") {
  const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
  if (value instanceof Array) {
    const multiValue = value.map((singleValue) => encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
    return `${encodeURIComponent(fullKey)}=${multiValue}`;
  }
  if (value instanceof Set) {
    const valueAsArray = Array.from(value);
    return querystringSingleKey(key, valueAsArray, keyPrefix);
  }
  if (value instanceof Date) {
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
  }
  if (value instanceof Object) {
    return querystring(value, fullKey);
  }
  return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function mapValues(data, fn) {
  return Object.keys(data).reduce(
    (acc, key) => ({ ...acc, [key]: fn(data[key]) }),
    {}
  );
}
function canConsumeForm(consumes) {
  for (const consume of consumes) {
    if ("multipart/form-data" === consume.contentType) {
      return true;
    }
  }
  return false;
}
var JSONApiResponse = class {
  constructor(raw, transformer = (jsonValue) => jsonValue) {
    this.raw = raw;
    this.transformer = transformer;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
};
var VoidApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  async value() {
    return void 0;
  }
};
var BlobApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  async value() {
    return await this.raw.blob();
  }
};
var TextApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  async value() {
    return await this.raw.text();
  }
};

// build/models/AccessToken.ts
function instanceOfAccessToken(value) {
  let isInstance = true;
  isInstance = isInstance && "accessToken" in value;
  isInstance = isInstance && "expiresIn" in value;
  isInstance = isInstance && "expires" in value;
  return isInstance;
}
function AccessTokenFromJSON(json) {
  return AccessTokenFromJSONTyped(json);
}
function AccessTokenFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accessToken": json["accessToken"],
    "expiresIn": json["expiresIn"],
    "expires": json["expires"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "userId": !exists(json, "userId") ? void 0 : json["userId"],
    "accountId": !exists(json, "accountId") ? void 0 : json["accountId"]
  };
}
function AccessTokenToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "accessToken": value.accessToken,
    "expiresIn": value.expiresIn,
    "expires": value.expires,
    "email": value.email,
    "userId": value.userId,
    "accountId": value.accountId
  };
}

// build/models/AccessTokenResponse.ts
function instanceOfAccessTokenResponse(value) {
  let isInstance = true;
  return isInstance;
}
function AccessTokenResponseFromJSON(json) {
  return AccessTokenResponseFromJSONTyped(json);
}
function AccessTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : AccessTokenFromJSON(json["data"])
  };
}
function AccessTokenResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": AccessTokenToJSON(value.data)
  };
}

// build/models/Account.ts
function instanceOfAccount(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "createdAt" in value;
  return isInstance;
}
function AccountFromJSON(json) {
  return AccountFromJSONTyped(json);
}
function AccountFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "createdAt": new Date(json["createdAt"]),
    "subdomain": !exists(json, "subdomain") ? void 0 : json["subdomain"],
    "vanityDomainDashboard": !exists(json, "vanityDomainDashboard") ? void 0 : json["vanityDomainDashboard"],
    "vanityDomainSpaces": !exists(json, "vanityDomainSpaces") ? void 0 : json["vanityDomainSpaces"],
    "embeddedDomainWhitelist": !exists(json, "embeddedDomainWhitelist") ? void 0 : json["embeddedDomainWhitelist"],
    "customFromEmail": !exists(json, "customFromEmail") ? void 0 : json["customFromEmail"],
    "stripeCustomerId": !exists(json, "stripeCustomerId") ? void 0 : json["stripeCustomerId"],
    "defaultAppId": !exists(json, "defaultAppId") ? void 0 : json["defaultAppId"],
    "dashboard": !exists(json, "dashboard") ? void 0 : json["dashboard"]
  };
}
function AccountToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "createdAt": value.createdAt.toISOString(),
    "subdomain": value.subdomain,
    "vanityDomainDashboard": value.vanityDomainDashboard,
    "vanityDomainSpaces": value.vanityDomainSpaces,
    "embeddedDomainWhitelist": value.embeddedDomainWhitelist,
    "customFromEmail": value.customFromEmail,
    "stripeCustomerId": value.stripeCustomerId,
    "defaultAppId": value.defaultAppId,
    "dashboard": value.dashboard
  };
}

// build/models/AccountResponse.ts
function instanceOfAccountResponse(value) {
  let isInstance = true;
  return isInstance;
}
function AccountResponseFromJSON(json) {
  return AccountResponseFromJSONTyped(json);
}
function AccountResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : AccountFromJSON(json["data"])
  };
}
function AccountResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": AccountToJSON(value.data)
  };
}

// build/models/HasAllValidConstraint.ts
var HasAllValidConstraintTypeEnum = {
  HasAllValid: "hasAllValid"
};
function instanceOfHasAllValidConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function HasAllValidConstraintFromJSON(json) {
  return HasAllValidConstraintFromJSONTyped(json);
}
function HasAllValidConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function HasAllValidConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/HasDataConstraint.ts
var HasDataConstraintTypeEnum = {
  HasData: "hasData"
};
function instanceOfHasDataConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function HasDataConstraintFromJSON(json) {
  return HasDataConstraintFromJSONTyped(json);
}
function HasDataConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function HasDataConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/HasSelectionConstraint.ts
var HasSelectionConstraintTypeEnum = {
  HasSelection: "hasSelection"
};
function instanceOfHasSelectionConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function HasSelectionConstraintFromJSON(json) {
  return HasSelectionConstraintFromJSONTyped(json);
}
function HasSelectionConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function HasSelectionConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/ActionConstraint.ts
function ActionConstraintFromJSON(json) {
  return ActionConstraintFromJSONTyped(json);
}
function ActionConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "hasAllValid":
      return { ...HasAllValidConstraintFromJSONTyped(json), type: "hasAllValid" };
    case "hasData":
      return { ...HasDataConstraintFromJSONTyped(json), type: "hasData" };
    case "hasSelection":
      return { ...HasSelectionConstraintFromJSONTyped(json), type: "hasSelection" };
    default:
      throw new Error(`No variant of ActionConstraint exists with 'type=${json["type"]}'`);
  }
}
function ActionConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "hasAllValid":
      return HasAllValidConstraintToJSON(value);
    case "hasData":
      return HasDataConstraintToJSON(value);
    case "hasSelection":
      return HasSelectionConstraintToJSON(value);
    default:
      throw new Error(`No variant of ActionConstraint exists with 'type=${value["type"]}'`);
  }
}

// build/models/RequiredConstraint.ts
var RequiredConstraintTypeEnum = {
  Required: "required"
};
function instanceOfRequiredConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function RequiredConstraintFromJSON(json) {
  return RequiredConstraintFromJSONTyped(json);
}
function RequiredConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function RequiredConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/InputConstraint.ts
function InputConstraintFromJSON(json) {
  return InputConstraintFromJSONTyped(json);
}
function InputConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "required":
      return { ...RequiredConstraintFromJSONTyped(json), type: "required" };
    default:
      throw new Error(`No variant of InputConstraint exists with 'type=${json["type"]}'`);
  }
}
function InputConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "required":
      return RequiredConstraintToJSON(value);
    default:
      throw new Error(`No variant of InputConstraint exists with 'type=${value["type"]}'`);
  }
}

// build/models/EnumPropertyOptionValue.ts
function instanceOfEnumPropertyOptionValue(value) {
  let isInstance = true;
  return isInstance;
}
function EnumPropertyOptionValueFromJSON(json) {
  return EnumPropertyOptionValueFromJSONTyped(json);
}
function EnumPropertyOptionValueFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function EnumPropertyOptionValueToJSON(value) {
  return value;
}

// build/models/EnumPropertyOption.ts
function instanceOfEnumPropertyOption(value) {
  let isInstance = true;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function EnumPropertyOptionFromJSON(json) {
  return EnumPropertyOptionFromJSONTyped(json);
}
function EnumPropertyOptionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "value": EnumPropertyOptionValueFromJSON(json["value"]),
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "color": !exists(json, "color") ? void 0 : json["color"],
    "icon": !exists(json, "icon") ? void 0 : json["icon"],
    "meta": !exists(json, "meta") ? void 0 : json["meta"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"]
  };
}
function EnumPropertyOptionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "value": EnumPropertyOptionValueToJSON(value.value),
    "label": value.label,
    "description": value.description,
    "color": value.color,
    "icon": value.icon,
    "meta": value.meta,
    "alternativeNames": value.alternativeNames
  };
}

// build/models/InputFieldConfig.ts
function instanceOfInputFieldConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "options" in value;
  return isInstance;
}
function InputFieldConfigFromJSON(json) {
  return InputFieldConfigFromJSONTyped(json);
}
function InputFieldConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "options": json["options"].map(EnumPropertyOptionFromJSON)
  };
}
function InputFieldConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "options": value.options.map(EnumPropertyOptionToJSON)
  };
}

// build/models/InputFieldDefaultValue.ts
function instanceOfInputFieldDefaultValue(value) {
  let isInstance = true;
  return isInstance;
}
function InputFieldDefaultValueFromJSON(json) {
  return InputFieldDefaultValueFromJSONTyped(json);
}
function InputFieldDefaultValueFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function InputFieldDefaultValueToJSON(value) {
  return value;
}

// build/models/InputField.ts
var InputFieldTypeEnum = {
  String: "string",
  Textarea: "textarea",
  Number: "number",
  Boolean: "boolean",
  Enum: "enum"
};
function instanceOfInputField(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "label" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function InputFieldFromJSON(json) {
  return InputFieldFromJSONTyped(json);
}
function InputFieldFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "label": json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "type": json["type"],
    "defaultValue": !exists(json, "defaultValue") ? void 0 : InputFieldDefaultValueFromJSON(json["defaultValue"]),
    "config": !exists(json, "config") ? void 0 : InputFieldConfigFromJSON(json["config"]),
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(InputConstraintFromJSON)
  };
}
function InputFieldToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "label": value.label,
    "description": value.description,
    "type": value.type,
    "defaultValue": InputFieldDefaultValueToJSON(value.defaultValue),
    "config": InputFieldConfigToJSON(value.config),
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(InputConstraintToJSON)
  };
}

// build/models/ActionInputForm.ts
var ActionInputFormTypeEnum = {
  Simple: "simple"
};
function instanceOfActionInputForm(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "fields" in value;
  return isInstance;
}
function ActionInputFormFromJSON(json) {
  return ActionInputFormFromJSONTyped(json);
}
function ActionInputFormFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "fields": json["fields"].map(InputFieldFromJSON)
  };
}
function ActionInputFormToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "fields": value.fields.map(InputFieldToJSON)
  };
}

// build/models/ActionMessage.ts
var ActionMessageTypeEnum = {
  Error: "error",
  Info: "info"
};
function instanceOfActionMessage(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "content" in value;
  return isInstance;
}
function ActionMessageFromJSON(json) {
  return ActionMessageFromJSONTyped(json);
}
function ActionMessageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "content": json["content"]
  };
}
function ActionMessageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "content": value.content
  };
}

// build/models/Action.ts
var ActionScheduleEnum = {
  Weekly: "weekly",
  Daily: "daily",
  Hourly: "hourly"
};
var ActionModeEnum = {
  Foreground: "foreground",
  Background: "background",
  ToolbarBlocking: "toolbarBlocking"
};
function instanceOfAction(value) {
  let isInstance = true;
  isInstance = isInstance && "label" in value;
  return isInstance;
}
function ActionFromJSON(json) {
  return ActionFromJSONTyped(json);
}
function ActionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "slug": !exists(json, "slug") ? void 0 : json["slug"],
    "label": json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "tooltip": !exists(json, "tooltip") ? void 0 : json["tooltip"],
    "schedule": !exists(json, "schedule") ? void 0 : json["schedule"],
    "operation": !exists(json, "operation") ? void 0 : json["operation"],
    "mode": !exists(json, "mode") ? void 0 : json["mode"],
    "primary": !exists(json, "primary") ? void 0 : json["primary"],
    "confirm": !exists(json, "confirm") ? void 0 : json["confirm"],
    "requireAllValid": !exists(json, "requireAllValid") ? void 0 : json["requireAllValid"],
    "requireSelection": !exists(json, "requireSelection") ? void 0 : json["requireSelection"],
    "icon": !exists(json, "icon") ? void 0 : json["icon"],
    "messages": !exists(json, "messages") ? void 0 : json["messages"].map(ActionMessageFromJSON),
    "inputForm": !exists(json, "inputForm") ? void 0 : ActionInputFormFromJSON(json["inputForm"]),
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ActionConstraintFromJSON)
  };
}
function ActionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "slug": value.slug,
    "label": value.label,
    "description": value.description,
    "tooltip": value.tooltip,
    "schedule": value.schedule,
    "operation": value.operation,
    "mode": value.mode,
    "primary": value.primary,
    "confirm": value.confirm,
    "requireAllValid": value.requireAllValid,
    "requireSelection": value.requireSelection,
    "icon": value.icon,
    "messages": value.messages === void 0 ? void 0 : value.messages.map(ActionMessageToJSON),
    "inputForm": ActionInputFormToJSON(value.inputForm),
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ActionConstraintToJSON)
  };
}

// build/models/ActivityContextSlugs.ts
function instanceOfActivityContextSlugs(value) {
  let isInstance = true;
  return isInstance;
}
function ActivityContextSlugsFromJSON(json) {
  return ActivityContextSlugsFromJSONTyped(json);
}
function ActivityContextSlugsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "space": !exists(json, "space") ? void 0 : json["space"],
    "workbook": !exists(json, "workbook") ? void 0 : json["workbook"],
    "sheet": !exists(json, "sheet") ? void 0 : json["sheet"]
  };
}
function ActivityContextSlugsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "space": value.space,
    "workbook": value.workbook,
    "sheet": value.sheet
  };
}

// build/models/ActorId.ts
function instanceOfActorId(value) {
  let isInstance = true;
  return isInstance;
}
function ActorIdFromJSON(json) {
  return ActorIdFromJSONTyped(json);
}
function ActorIdFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ActorIdToJSON(value) {
  return value;
}

// build/models/ActivityContext.ts
function instanceOfActivityContext(value) {
  let isInstance = true;
  isInstance = isInstance && "accountId" in value;
  isInstance = isInstance && "environmentId" in value;
  return isInstance;
}
function ActivityContextFromJSON(json) {
  return ActivityContextFromJSONTyped(json);
}
function ActivityContextFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "namespaces": !exists(json, "namespaces") ? void 0 : json["namespaces"],
    "slugs": !exists(json, "slugs") ? void 0 : ActivityContextSlugsFromJSON(json["slugs"]),
    "actionName": !exists(json, "actionName") ? void 0 : json["actionName"],
    "accountId": json["accountId"],
    "environmentId": json["environmentId"],
    "spaceId": !exists(json, "spaceId") ? void 0 : json["spaceId"],
    "workbookId": !exists(json, "workbookId") ? void 0 : json["workbookId"],
    "sheetId": !exists(json, "sheetId") ? void 0 : json["sheetId"],
    "sheetSlug": !exists(json, "sheetSlug") ? void 0 : json["sheetSlug"],
    "snapshotId": !exists(json, "snapshotId") ? void 0 : json["snapshotId"],
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"],
    "jobId": !exists(json, "jobId") ? void 0 : json["jobId"],
    "programId": !exists(json, "programId") ? void 0 : json["programId"],
    "fileId": !exists(json, "fileId") ? void 0 : json["fileId"],
    "documentId": !exists(json, "documentId") ? void 0 : json["documentId"],
    "precedingEventId": !exists(json, "precedingEventId") ? void 0 : json["precedingEventId"],
    "actorId": !exists(json, "actorId") ? void 0 : ActorIdFromJSON(json["actorId"])
  };
}
function ActivityContextToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "namespaces": value.namespaces,
    "slugs": ActivityContextSlugsToJSON(value.slugs),
    "actionName": value.actionName,
    "accountId": value.accountId,
    "environmentId": value.environmentId,
    "spaceId": value.spaceId,
    "workbookId": value.workbookId,
    "sheetId": value.sheetId,
    "sheetSlug": value.sheetSlug,
    "snapshotId": value.snapshotId,
    "versionId": value.versionId,
    "commitId": value.commitId,
    "jobId": value.jobId,
    "programId": value.programId,
    "fileId": value.fileId,
    "documentId": value.documentId,
    "precedingEventId": value.precedingEventId,
    "actorId": ActorIdToJSON(value.actorId)
  };
}

// build/models/EventTopic.ts
var EventTopic = {
  Agentcreated: "agent:created",
  Agentupdated: "agent:updated",
  Agentdeleted: "agent:deleted",
  Spacecreated: "space:created",
  Spaceupdated: "space:updated",
  Spacedeleted: "space:deleted",
  Spacearchived: "space:archived",
  Spaceexpired: "space:expired",
  SpaceguestAdded: "space:guestAdded",
  SpaceguestRemoved: "space:guestRemoved",
  Documentcreated: "document:created",
  Documentupdated: "document:updated",
  Documentdeleted: "document:deleted",
  Workbookcreated: "workbook:created",
  Workbookupdated: "workbook:updated",
  Workbookdeleted: "workbook:deleted",
  Workbookexpired: "workbook:expired",
  Sheetcreated: "sheet:created",
  Sheetupdated: "sheet:updated",
  Sheetdeleted: "sheet:deleted",
  SheetcountsUpdated: "sheet:counts-updated",
  Snapshotcreated: "snapshot:created",
  Recordscreated: "records:created",
  Recordsupdated: "records:updated",
  Recordsdeleted: "records:deleted",
  Filecreated: "file:created",
  Fileupdated: "file:updated",
  Filedeleted: "file:deleted",
  Fileexpired: "file:expired",
  Jobcreated: "job:created",
  Jobupdated: "job:updated",
  Jobdeleted: "job:deleted",
  Jobready: "job:ready",
  Jobscheduled: "job:scheduled",
  Jobcompleted: "job:completed",
  Jobfailed: "job:failed",
  JoboutcomeAcknowledged: "job:outcome-acknowledged",
  JobpartsCompleted: "job:parts-completed",
  Programcreated: "program:created",
  Programupdated: "program:updated",
  Commitcreated: "commit:created",
  Commitupdated: "commit:updated",
  Commitcompleted: "commit:completed",
  Layercreated: "layer:created",
  Secretcreated: "secret:created",
  Secretupdated: "secret:updated",
  Secretdeleted: "secret:deleted",
  Cron5Minutes: "cron:5-minutes",
  Cronhourly: "cron:hourly",
  Crondaily: "cron:daily",
  Cronweekly: "cron:weekly",
  Environmentcreated: "environment:created",
  Environmentupdated: "environment:updated",
  Environmentdeleted: "environment:deleted"
};
function EventTopicFromJSON(json) {
  return EventTopicFromJSONTyped(json);
}
function EventTopicFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function EventTopicToJSON(value) {
  return value;
}

// build/models/Activity.ts
function instanceOfActivity(value) {
  let isInstance = true;
  return isInstance;
}
function ActivityFromJSON(json) {
  return ActivityFromJSONTyped(json);
}
function ActivityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "activity": !exists(json, "activity") ? void 0 : EventTopicFromJSON(json["activity"]),
    "resourceId": !exists(json, "resourceId") ? void 0 : json["resourceId"],
    "resourceType": !exists(json, "resourceType") ? void 0 : json["resourceType"],
    "resourceSlug": !exists(json, "resourceSlug") ? void 0 : json["resourceSlug"],
    "resourceName": !exists(json, "resourceName") ? void 0 : json["resourceName"],
    "actorId": !exists(json, "actorId") ? void 0 : json["actorId"],
    "actorType": !exists(json, "actorType") ? void 0 : json["actorType"],
    "actorName": !exists(json, "actorName") ? void 0 : json["actorName"],
    "context": !exists(json, "context") ? void 0 : ActivityContextFromJSON(json["context"]),
    "payload": !exists(json, "payload") ? void 0 : json["payload"],
    "activityTime": !exists(json, "activityTime") ? void 0 : new Date(json["activityTime"])
  };
}
function ActivityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "activity": EventTopicToJSON(value.activity),
    "resourceId": value.resourceId,
    "resourceType": value.resourceType,
    "resourceSlug": value.resourceSlug,
    "resourceName": value.resourceName,
    "actorId": value.actorId,
    "actorType": value.actorType,
    "actorName": value.actorName,
    "context": ActivityContextToJSON(value.context),
    "payload": value.payload,
    "activityTime": value.activityTime === void 0 ? void 0 : value.activityTime.toISOString()
  };
}

// build/models/Pagination.ts
function instanceOfPagination(value) {
  let isInstance = true;
  isInstance = isInstance && "currentPage" in value;
  isInstance = isInstance && "pageCount" in value;
  isInstance = isInstance && "totalCount" in value;
  return isInstance;
}
function PaginationFromJSON(json) {
  return PaginationFromJSONTyped(json);
}
function PaginationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "currentPage": json["currentPage"],
    "pageCount": json["pageCount"],
    "totalCount": json["totalCount"]
  };
}
function PaginationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "currentPage": value.currentPage,
    "pageCount": value.pageCount,
    "totalCount": value.totalCount
  };
}

// build/models/ActivitiesResponse.ts
function instanceOfActivitiesResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ActivitiesResponseFromJSON(json) {
  return ActivitiesResponseFromJSONTyped(json);
}
function ActivitiesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(ActivityFromJSON),
    "pagination": !exists(json, "pagination") ? void 0 : PaginationFromJSON(json["pagination"])
  };
}
function ActivitiesResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(ActivityToJSON),
    "pagination": PaginationToJSON(value.pagination)
  };
}

// build/models/ResourceId.ts
function instanceOfResourceId(value) {
  let isInstance = true;
  return isInstance;
}
function ResourceIdFromJSON(json) {
  return ResourceIdFromJSONTyped(json);
}
function ResourceIdFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ResourceIdToJSON(value) {
  return value;
}

// build/models/ActorResource.ts
function instanceOfActorResource(value) {
  let isInstance = true;
  isInstance = isInstance && "actorId" in value;
  isInstance = isInstance && "resourceId" in value;
  return isInstance;
}
function ActorResourceFromJSON(json) {
  return ActorResourceFromJSONTyped(json);
}
function ActorResourceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "actorId": ActorIdFromJSON(json["actorId"]),
    "resourceId": ResourceIdFromJSON(json["resourceId"])
  };
}
function ActorResourceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "actorId": ActorIdToJSON(value.actorId),
    "resourceId": ResourceIdToJSON(value.resourceId)
  };
}

// build/models/ActorRoleResponse.ts
function instanceOfActorRoleResponse(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "roleId" in value;
  isInstance = isInstance && "actorId" in value;
  isInstance = isInstance && "resourceId" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "updatedAt" in value;
  return isInstance;
}
function ActorRoleResponseFromJSON(json) {
  return ActorRoleResponseFromJSONTyped(json);
}
function ActorRoleResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "roleId": json["roleId"],
    "actorId": ActorIdFromJSON(json["actorId"]),
    "resourceId": ResourceIdFromJSON(json["resourceId"]),
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}
function ActorRoleResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "roleId": value.roleId,
    "actorId": ActorIdToJSON(value.actorId),
    "resourceId": ResourceIdToJSON(value.resourceId),
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString()
  };
}

// build/models/Agent.ts
var AgentCompilerEnum = {
  Js: "js"
};
function instanceOfAgent(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function AgentFromJSON(json) {
  return AgentFromJSONTyped(json);
}
function AgentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": !exists(json, "createdAt") ? void 0 : json["createdAt"],
    "deletedAt": !exists(json, "deletedAt") ? void 0 : json["deletedAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"],
    "accountId": !exists(json, "accountId") ? void 0 : json["accountId"],
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"],
    "topics": !exists(json, "topics") ? void 0 : json["topics"].map(EventTopicFromJSON),
    "compiler": !exists(json, "compiler") ? void 0 : json["compiler"],
    "source": !exists(json, "source") ? void 0 : json["source"],
    "sourceMap": !exists(json, "sourceMap") ? void 0 : json["sourceMap"],
    "slug": !exists(json, "slug") ? void 0 : json["slug"]
  };
}
function AgentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "createdAt": value.createdAt,
    "deletedAt": value.deletedAt,
    "updatedAt": value.updatedAt,
    "accountId": value.accountId,
    "environmentId": value.environmentId,
    "topics": value.topics === void 0 ? void 0 : value.topics.map(EventTopicToJSON),
    "compiler": value.compiler,
    "source": value.source,
    "sourceMap": value.sourceMap,
    "slug": value.slug
  };
}

// build/models/AgentConfig.ts
var AgentConfigCompilerEnum = {
  Js: "js"
};
function instanceOfAgentConfig(value) {
  let isInstance = true;
  return isInstance;
}
function AgentConfigFromJSON(json) {
  return AgentConfigFromJSONTyped(json);
}
function AgentConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "topics": !exists(json, "topics") ? void 0 : json["topics"].map(EventTopicFromJSON),
    "compiler": !exists(json, "compiler") ? void 0 : json["compiler"],
    "source": !exists(json, "source") ? void 0 : json["source"],
    "sourceMap": !exists(json, "sourceMap") ? void 0 : json["sourceMap"],
    "slug": !exists(json, "slug") ? void 0 : json["slug"]
  };
}
function AgentConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "topics": value.topics === void 0 ? void 0 : value.topics.map(EventTopicToJSON),
    "compiler": value.compiler,
    "source": value.source,
    "sourceMap": value.sourceMap,
    "slug": value.slug
  };
}

// build/models/AgentLog.ts
function instanceOfAgentLog(value) {
  let isInstance = true;
  isInstance = isInstance && "eventId" in value;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "completedAt" in value;
  return isInstance;
}
function AgentLogFromJSON(json) {
  return AgentLogFromJSONTyped(json);
}
function AgentLogFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "eventId": json["eventId"],
    "success": json["success"],
    "createdAt": json["createdAt"],
    "completedAt": json["completedAt"],
    "log": !exists(json, "log") ? void 0 : json["log"]
  };
}
function AgentLogToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "eventId": value.eventId,
    "success": value.success,
    "createdAt": value.createdAt,
    "completedAt": value.completedAt,
    "log": value.log
  };
}

// build/models/DetailedAgentLog.ts
function instanceOfDetailedAgentLog(value) {
  let isInstance = true;
  isInstance = isInstance && "eventId" in value;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "completedAt" in value;
  return isInstance;
}
function DetailedAgentLogFromJSON(json) {
  return DetailedAgentLogFromJSONTyped(json);
}
function DetailedAgentLogFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "eventId": json["eventId"],
    "success": json["success"],
    "createdAt": json["createdAt"],
    "completedAt": json["completedAt"],
    "duration": !exists(json, "duration") ? void 0 : json["duration"],
    "topic": !exists(json, "topic") ? void 0 : json["topic"],
    "context": !exists(json, "context") ? void 0 : json["context"],
    "log": !exists(json, "log") ? void 0 : json["log"]
  };
}
function DetailedAgentLogToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "eventId": value.eventId,
    "success": value.success,
    "createdAt": value.createdAt,
    "completedAt": value.completedAt,
    "duration": value.duration,
    "topic": value.topic,
    "context": value.context,
    "log": value.log
  };
}

// build/models/AgentLogResponse.ts
function instanceOfAgentLogResponse(value) {
  let isInstance = true;
  return isInstance;
}
function AgentLogResponseFromJSON(json) {
  return AgentLogResponseFromJSONTyped(json);
}
function AgentLogResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : DetailedAgentLogFromJSON(json["data"])
  };
}
function AgentLogResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": DetailedAgentLogToJSON(value.data)
  };
}

// build/models/AgentLogsResponse.ts
function instanceOfAgentLogsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function AgentLogsResponseFromJSON(json) {
  return AgentLogsResponseFromJSONTyped(json);
}
function AgentLogsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pagination": !exists(json, "pagination") ? void 0 : PaginationFromJSON(json["pagination"]),
    "data": !exists(json, "data") ? void 0 : json["data"].map(AgentLogFromJSON)
  };
}
function AgentLogsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pagination": PaginationToJSON(value.pagination),
    "data": value.data === void 0 ? void 0 : value.data.map(AgentLogToJSON)
  };
}

// build/models/AgentLogsResponse1.ts
function instanceOfAgentLogsResponse1(value) {
  let isInstance = true;
  return isInstance;
}
function AgentLogsResponse1FromJSON(json) {
  return AgentLogsResponse1FromJSONTyped(json);
}
function AgentLogsResponse1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pagination": !exists(json, "pagination") ? void 0 : PaginationFromJSON(json["pagination"]),
    "data": !exists(json, "data") ? void 0 : json["data"].map(DetailedAgentLogFromJSON)
  };
}
function AgentLogsResponse1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pagination": PaginationToJSON(value.pagination),
    "data": value.data === void 0 ? void 0 : value.data.map(DetailedAgentLogToJSON)
  };
}

// build/models/AgentResponse.ts
function instanceOfAgentResponse(value) {
  let isInstance = true;
  return isInstance;
}
function AgentResponseFromJSON(json) {
  return AgentResponseFromJSONTyped(json);
}
function AgentResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : AgentFromJSON(json["data"])
  };
}
function AgentResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": AgentToJSON(value.data)
  };
}

// build/models/AgentStats.ts
function instanceOfAgentStats(value) {
  let isInstance = true;
  return isInstance;
}
function AgentStatsFromJSON(json) {
  return AgentStatsFromJSONTyped(json);
}
function AgentStatsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "start": !exists(json, "start") ? void 0 : new Date(json["start"]),
    "end": !exists(json, "end") ? void 0 : new Date(json["end"]),
    "executions": !exists(json, "executions") ? void 0 : json["executions"],
    "succeeded": !exists(json, "succeeded") ? void 0 : json["succeeded"],
    "failed": !exists(json, "failed") ? void 0 : json["failed"]
  };
}
function AgentStatsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "start": value.start === void 0 ? void 0 : value.start.toISOString(),
    "end": value.end === void 0 ? void 0 : value.end.toISOString(),
    "executions": value.executions,
    "succeeded": value.succeeded,
    "failed": value.failed
  };
}

// build/models/AgentsResponse.ts
function instanceOfAgentsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function AgentsResponseFromJSON(json) {
  return AgentsResponseFromJSONTyped(json);
}
function AgentsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(AgentFromJSON)
  };
}
function AgentsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(AgentToJSON)
  };
}

// build/models/ApiCredentials.ts
function instanceOfApiCredentials(value) {
  let isInstance = true;
  isInstance = isInstance && "clientId" in value;
  isInstance = isInstance && "secret" in value;
  return isInstance;
}
function ApiCredentialsFromJSON(json) {
  return ApiCredentialsFromJSONTyped(json);
}
function ApiCredentialsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "clientId": json["clientId"],
    "secret": json["secret"]
  };
}
function ApiCredentialsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "clientId": value.clientId,
    "secret": value.secret
  };
}

// build/models/ApiKeyOperationsInner.ts
function instanceOfApiKeyOperationsInner(value) {
  let isInstance = true;
  isInstance = isInstance && "path" in value;
  isInstance = isInstance && "method" in value;
  return isInstance;
}
function ApiKeyOperationsInnerFromJSON(json) {
  return ApiKeyOperationsInnerFromJSONTyped(json);
}
function ApiKeyOperationsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "path": json["path"],
    "method": json["method"]
  };
}
function ApiKeyOperationsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "path": value.path,
    "method": value.method
  };
}

// build/models/ApiKey.ts
var ApiKeyTypeEnum = {
  Publishable: "PUBLISHABLE",
  Secret: "SECRET"
};
function instanceOfApiKey(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "operations" in value;
  isInstance = isInstance && "createdAt" in value;
  return isInstance;
}
function ApiKeyFromJSON(json) {
  return ApiKeyFromJSONTyped(json);
}
function ApiKeyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "rawKey": !exists(json, "rawKey") ? void 0 : json["rawKey"],
    "type": json["type"],
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"],
    "accountId": !exists(json, "accountId") ? void 0 : json["accountId"],
    "operations": json["operations"].map(ApiKeyOperationsInnerFromJSON),
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"]),
    "deletedAt": !exists(json, "deletedAt") ? void 0 : new Date(json["deletedAt"])
  };
}
function ApiKeyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "rawKey": value.rawKey,
    "type": value.type,
    "environmentId": value.environmentId,
    "accountId": value.accountId,
    "operations": value.operations.map(ApiKeyOperationsInnerToJSON),
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt.toISOString(),
    "deletedAt": value.deletedAt === void 0 ? void 0 : value.deletedAt.toISOString()
  };
}

// build/models/ApiKeysResponse.ts
function instanceOfApiKeysResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ApiKeysResponseFromJSON(json) {
  return ApiKeysResponseFromJSONTyped(json);
}
function ApiKeysResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(ApiKeyFromJSON)
  };
}
function ApiKeysResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(ApiKeyToJSON)
  };
}

// build/models/ApiToken.ts
function instanceOfApiToken(value) {
  let isInstance = true;
  isInstance = isInstance && "clientId" in value;
  isInstance = isInstance && "description" in value;
  isInstance = isInstance && "metadata" in value;
  isInstance = isInstance && "createdAt" in value;
  return isInstance;
}
function ApiTokenFromJSON(json) {
  return ApiTokenFromJSONTyped(json);
}
function ApiTokenFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "clientId": json["clientId"],
    "description": json["description"],
    "metadata": json["metadata"],
    "createdAt": json["createdAt"],
    "secret": !exists(json, "secret") ? void 0 : json["secret"]
  };
}
function ApiTokenToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "clientId": value.clientId,
    "description": value.description,
    "metadata": value.metadata,
    "createdAt": value.createdAt,
    "secret": value.secret
  };
}

// build/models/ApiTokenResponse.ts
function instanceOfApiTokenResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ApiTokenResponseFromJSON(json) {
  return ApiTokenResponseFromJSONTyped(json);
}
function ApiTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : ApiTokenFromJSON(json["data"])
  };
}
function ApiTokenResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": ApiTokenToJSON(value.data)
  };
}

// build/models/ApiTokensResponse.ts
function instanceOfApiTokensResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ApiTokensResponseFromJSON(json) {
  return ApiTokensResponseFromJSONTyped(json);
}
function ApiTokensResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pagination": !exists(json, "pagination") ? void 0 : PaginationFromJSON(json["pagination"]),
    "data": !exists(json, "data") ? void 0 : json["data"].map(ApiTokenFromJSON)
  };
}
function ApiTokensResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pagination": PaginationToJSON(value.pagination),
    "data": value.data === void 0 ? void 0 : value.data.map(ApiTokenToJSON)
  };
}

// build/models/AppVersionResponse.ts
function instanceOfAppVersionResponse(value) {
  let isInstance = true;
  return isInstance;
}
function AppVersionResponseFromJSON(json) {
  return AppVersionResponseFromJSONTyped(json);
}
function AppVersionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "commit": !exists(json, "commit") ? void 0 : json["commit"],
    "version": !exists(json, "version") ? void 0 : json["version"]
  };
}
function AppVersionResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "commit": value.commit,
    "version": value.version
  };
}

// build/models/ArrayableProperty.ts
function instanceOfArrayableProperty(value) {
  let isInstance = true;
  return isInstance;
}
function ArrayablePropertyFromJSON(json) {
  return ArrayablePropertyFromJSONTyped(json);
}
function ArrayablePropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "isArray": !exists(json, "isArray") ? void 0 : json["isArray"]
  };
}
function ArrayablePropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "isArray": value.isArray
  };
}

// build/models/AssignActorRoleRequest.ts
function instanceOfAssignActorRoleRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "roleId" in value;
  isInstance = isInstance && "resourceId" in value;
  return isInstance;
}
function AssignActorRoleRequestFromJSON(json) {
  return AssignActorRoleRequestFromJSONTyped(json);
}
function AssignActorRoleRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "roleId": json["roleId"],
    "resourceId": ResourceIdFromJSON(json["resourceId"])
  };
}
function AssignActorRoleRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "roleId": value.roleId,
    "resourceId": ResourceIdToJSON(value.resourceId)
  };
}

// build/models/AssignRoleResponse.ts
function instanceOfAssignRoleResponse(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function AssignRoleResponseFromJSON(json) {
  return AssignRoleResponseFromJSONTyped(json);
}
function AssignRoleResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": ActorRoleResponseFromJSON(json["data"])
  };
}
function AssignRoleResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": ActorRoleResponseToJSON(value.data)
  };
}

// build/models/AuditActivity.ts
var AuditActivity = {
  Agentcreated: "agent:created",
  Agentupdated: "agent:updated",
  Agentdeleted: "agent:deleted",
  Spacecreated: "space:created",
  Spaceupdated: "space:updated",
  Spacedeleted: "space:deleted",
  Spacearchived: "space:archived",
  Spaceexpired: "space:expired",
  SpaceguestAdded: "space:guestAdded",
  SpaceguestRemoved: "space:guestRemoved",
  Documentcreated: "document:created",
  Documentupdated: "document:updated",
  Documentdeleted: "document:deleted",
  Workbookcreated: "workbook:created",
  Workbookupdated: "workbook:updated",
  Workbookdeleted: "workbook:deleted",
  Workbookexpired: "workbook:expired",
  Sheetcreated: "sheet:created",
  Sheetupdated: "sheet:updated",
  Sheetdeleted: "sheet:deleted",
  Snapshotcreated: "snapshot:created",
  Filecreated: "file:created",
  Filedeleted: "file:deleted",
  Fileexpired: "file:expired",
  Jobcreated: "job:created",
  Jobdeleted: "job:deleted",
  Jobready: "job:ready",
  Jobscheduled: "job:scheduled",
  Jobcompleted: "job:completed",
  Jobfailed: "job:failed",
  JoboutcomeAcknowledged: "job:outcome-acknowledged",
  JobpartsCompleted: "job:parts-completed",
  Programcreated: "program:created",
  Programupdated: "program:updated",
  Commitcreated: "commit:created",
  Commitupdated: "commit:updated",
  Commitcompleted: "commit:completed",
  Layercreated: "layer:created",
  Secretcreated: "secret:created",
  Secretupdated: "secret:updated",
  Secretdeleted: "secret:deleted"
};
function AuditActivityFromJSON(json) {
  return AuditActivityFromJSONTyped(json);
}
function AuditActivityFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function AuditActivityToJSON(value) {
  return value;
}

// build/models/BaseActionConstraint.ts
var BaseActionConstraintTypeEnum = {
  HasAllValid: "hasAllValid",
  HasSelection: "hasSelection",
  HasData: "hasData"
};
function instanceOfBaseActionConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function BaseActionConstraintFromJSON(json) {
  return BaseActionConstraintFromJSONTyped(json);
}
function BaseActionConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function BaseActionConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/BaseConstraint.ts
var BaseConstraintTypeEnum = {
  Required: "required",
  Unique: "unique",
  Computed: "computed",
  External: "external"
};
function instanceOfBaseConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function BaseConstraintFromJSON(json) {
  return BaseConstraintFromJSONTyped(json);
}
function BaseConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function BaseConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/BasePropertyAppearance.ts
var BasePropertyAppearanceSizeEnum = {
  Xs: "xs",
  S: "s",
  M: "m",
  L: "l",
  Xl: "xl"
};
function instanceOfBasePropertyAppearance(value) {
  let isInstance = true;
  return isInstance;
}
function BasePropertyAppearanceFromJSON(json) {
  return BasePropertyAppearanceFromJSONTyped(json);
}
function BasePropertyAppearanceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "size": !exists(json, "size") ? void 0 : json["size"]
  };
}
function BasePropertyAppearanceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "size": value.size
  };
}

// build/models/ComputedConstraint.ts
var ComputedConstraintTypeEnum = {
  Computed: "computed"
};
function instanceOfComputedConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function ComputedConstraintFromJSON(json) {
  return ComputedConstraintFromJSONTyped(json);
}
function ComputedConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function ComputedConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/ExternalConstraint.ts
var ExternalConstraintTypeEnum = {
  External: "external"
};
function instanceOfExternalConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "validator" in value;
  return isInstance;
}
function ExternalConstraintFromJSON(json) {
  return ExternalConstraintFromJSONTyped(json);
}
function ExternalConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "validator": json["validator"],
    "config": !exists(json, "config") ? void 0 : json["config"]
  };
}
function ExternalConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "validator": value.validator,
    "config": value.config
  };
}

// build/models/UniqueConstraintAllOfConfig.ts
function instanceOfUniqueConstraintAllOfConfig(value) {
  let isInstance = true;
  return isInstance;
}
function UniqueConstraintAllOfConfigFromJSON(json) {
  return UniqueConstraintAllOfConfigFromJSONTyped(json);
}
function UniqueConstraintAllOfConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "caseSensitive": !exists(json, "caseSensitive") ? void 0 : json["caseSensitive"],
    "ignoreEmpty": !exists(json, "ignoreEmpty") ? void 0 : json["ignoreEmpty"]
  };
}
function UniqueConstraintAllOfConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "caseSensitive": value.caseSensitive,
    "ignoreEmpty": value.ignoreEmpty
  };
}

// build/models/UniqueConstraint.ts
var UniqueConstraintTypeEnum = {
  Unique: "unique"
};
function instanceOfUniqueConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function UniqueConstraintFromJSON(json) {
  return UniqueConstraintFromJSONTyped(json);
}
function UniqueConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "config": !exists(json, "config") ? void 0 : UniqueConstraintAllOfConfigFromJSON(json["config"])
  };
}
function UniqueConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "config": UniqueConstraintAllOfConfigToJSON(value.config)
  };
}

// build/models/Constraint.ts
function ConstraintFromJSON(json) {
  return ConstraintFromJSONTyped(json);
}
function ConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "computed":
      return { ...ComputedConstraintFromJSONTyped(json), type: "computed" };
    case "external":
      return { ...ExternalConstraintFromJSONTyped(json), type: "external" };
    case "required":
      return { ...RequiredConstraintFromJSONTyped(json), type: "required" };
    case "unique":
      return { ...UniqueConstraintFromJSONTyped(json), type: "unique" };
    default:
      throw new Error(`No variant of Constraint exists with 'type=${json["type"]}'`);
  }
}
function ConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "computed":
      return ComputedConstraintToJSON(value);
    case "external":
      return ExternalConstraintToJSON(value);
    case "required":
      return RequiredConstraintToJSON(value);
    case "unique":
      return UniqueConstraintToJSON(value);
    default:
      throw new Error(`No variant of Constraint exists with 'type=${value["type"]}'`);
  }
}

// build/models/BaseProperty.ts
var BasePropertyTypeEnum = {
  String: "string",
  StringList: "string-list",
  Number: "number",
  Boolean: "boolean",
  Date: "date",
  Enum: "enum",
  EnumList: "enum-list",
  Reference: "reference",
  ReferenceList: "reference-list"
};
function instanceOfBaseProperty(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function BasePropertyFromJSON(json) {
  return BasePropertyFromJSONTyped(json);
}
function BasePropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ConstraintFromJSON),
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "appearance": !exists(json, "appearance") ? void 0 : BasePropertyAppearanceFromJSON(json["appearance"]),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"]
  };
}
function BasePropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "type": value.type,
    "label": value.label,
    "description": value.description,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ConstraintToJSON),
    "readonly": value.readonly,
    "metadata": value.metadata,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "appearance": BasePropertyAppearanceToJSON(value.appearance),
    "treatments": value.treatments,
    "alternativeNames": value.alternativeNames
  };
}

// build/models/BaseSideBarConfig.ts
var BaseSideBarConfigTypeEnum = {
  Workbook: "workbook",
  Document: "document",
  Link: "link"
};
function instanceOfBaseSideBarConfig(value) {
  let isInstance = true;
  return isInstance;
}
function BaseSideBarConfigFromJSON(json) {
  return BaseSideBarConfigFromJSONTyped(json);
}
function BaseSideBarConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"]
  };
}
function BaseSideBarConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/BillingLimits.ts
function instanceOfBillingLimits(value) {
  let isInstance = true;
  isInstance = isInstance && "fromDate" in value;
  isInstance = isInstance && "toDate" in value;
  isInstance = isInstance && "fileUploadIsLockedUntilPayment" in value;
  isInstance = isInstance && "sheetIsLockedUntilPayment" in value;
  return isInstance;
}
function BillingLimitsFromJSON(json) {
  return BillingLimitsFromJSONTyped(json);
}
function BillingLimitsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fromDate": new Date(json["fromDate"]),
    "toDate": new Date(json["toDate"]),
    "fileUploadIsLockedUntilPayment": json["fileUploadIsLockedUntilPayment"],
    "sheetIsLockedUntilPayment": json["sheetIsLockedUntilPayment"]
  };
}
function BillingLimitsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fromDate": value.fromDate.toISOString(),
    "toDate": value.toDate.toISOString(),
    "fileUploadIsLockedUntilPayment": value.fileUploadIsLockedUntilPayment,
    "sheetIsLockedUntilPayment": value.sheetIsLockedUntilPayment
  };
}

// build/models/BillingLimitsResponse.ts
function instanceOfBillingLimitsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function BillingLimitsResponseFromJSON(json) {
  return BillingLimitsResponseFromJSONTyped(json);
}
function BillingLimitsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : BillingLimitsFromJSON(json["data"])
  };
}
function BillingLimitsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": BillingLimitsToJSON(value.data)
  };
}

// build/models/BillingPlanWithUsage.ts
function instanceOfBillingPlanWithUsage(value) {
  let isInstance = true;
  isInstance = isInstance && "accountId" in value;
  isInstance = isInstance && "plan" in value;
  isInstance = isInstance && "pdvs" in value;
  isInstance = isInstance && "files" in value;
  isInstance = isInstance && "fromDate" in value;
  isInstance = isInstance && "toDate" in value;
  isInstance = isInstance && "freeFileLimit" in value;
  isInstance = isInstance && "freePdvLimit" in value;
  return isInstance;
}
function BillingPlanWithUsageFromJSON(json) {
  return BillingPlanWithUsageFromJSONTyped(json);
}
function BillingPlanWithUsageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "plan": json["plan"],
    "pdvs": json["pdvs"],
    "files": json["files"],
    "fromDate": new Date(json["fromDate"]),
    "toDate": new Date(json["toDate"]),
    "freeFileLimit": json["freeFileLimit"],
    "freePdvLimit": json["freePdvLimit"]
  };
}
function BillingPlanWithUsageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "accountId": value.accountId,
    "plan": value.plan,
    "pdvs": value.pdvs,
    "files": value.files,
    "fromDate": value.fromDate.toISOString(),
    "toDate": value.toDate.toISOString(),
    "freeFileLimit": value.freeFileLimit,
    "freePdvLimit": value.freePdvLimit
  };
}

// build/models/BillingPlanWithUsageResponse.ts
function instanceOfBillingPlanWithUsageResponse(value) {
  let isInstance = true;
  return isInstance;
}
function BillingPlanWithUsageResponseFromJSON(json) {
  return BillingPlanWithUsageResponseFromJSONTyped(json);
}
function BillingPlanWithUsageResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : BillingPlanWithUsageFromJSON(json["data"])
  };
}
function BillingPlanWithUsageResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": BillingPlanWithUsageToJSON(value.data)
  };
}

// build/models/StripeMetadata.ts
function instanceOfStripeMetadata(value) {
  let isInstance = true;
  return isInstance;
}
function StripeMetadataFromJSON(json) {
  return StripeMetadataFromJSONTyped(json);
}
function StripeMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "canSelfServe": !exists(json, "canSelfServe") ? void 0 : json["canSelfServe"],
    "commitment": !exists(json, "commitment") ? void 0 : json["commitment"],
    "isDefaultSelection": !exists(json, "isDefaultSelection") ? void 0 : json["isDefaultSelection"],
    "interval": !exists(json, "interval") ? void 0 : json["interval"],
    "planType": !exists(json, "planType") ? void 0 : json["planType"],
    "platform": !exists(json, "platform") ? void 0 : json["platform"],
    "prepayId": !exists(json, "prepayId") ? void 0 : json["prepayId"],
    "proOnly": !exists(json, "proOnly") ? void 0 : json["proOnly"],
    "productType": !exists(json, "productType") ? void 0 : json["productType"],
    "unitLabel": !exists(json, "unitLabel") ? void 0 : json["unitLabel"],
    "usageType": !exists(json, "usageType") ? void 0 : json["usageType"]
  };
}
function StripeMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "canSelfServe": value.canSelfServe,
    "commitment": value.commitment,
    "isDefaultSelection": value.isDefaultSelection,
    "interval": value.interval,
    "planType": value.planType,
    "platform": value.platform,
    "prepayId": value.prepayId,
    "proOnly": value.proOnly,
    "productType": value.productType,
    "unitLabel": value.unitLabel,
    "usageType": value.usageType
  };
}

// build/models/StripePriceTier.ts
function instanceOfStripePriceTier(value) {
  let isInstance = true;
  isInstance = isInstance && "unitAmount" in value;
  isInstance = isInstance && "upTo" in value;
  return isInstance;
}
function StripePriceTierFromJSON(json) {
  return StripePriceTierFromJSONTyped(json);
}
function StripePriceTierFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "unitAmount": json["unitAmount"],
    "upTo": json["upTo"]
  };
}
function StripePriceTierToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "unitAmount": value.unitAmount,
    "upTo": value.upTo
  };
}

// build/models/StripePrice.ts
function instanceOfStripePrice(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function StripePriceFromJSON(json) {
  return StripePriceFromJSONTyped(json);
}
function StripePriceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "unitAmount": !exists(json, "unitAmount") ? void 0 : json["unitAmount"],
    "tiers": !exists(json, "tiers") ? void 0 : json["tiers"].map(StripePriceTierFromJSON)
  };
}
function StripePriceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "unitAmount": value.unitAmount,
    "tiers": value.tiers === void 0 ? void 0 : value.tiers.map(StripePriceTierToJSON)
  };
}

// build/models/Product.ts
function instanceOfProduct(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "defaultPrice" in value;
  isInstance = isInstance && "description" in value;
  isInstance = isInstance && "metadata" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function ProductFromJSON(json) {
  return ProductFromJSONTyped(json);
}
function ProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "defaultPrice": StripePriceFromJSON(json["defaultPrice"]),
    "description": json["description"],
    "metadata": StripeMetadataFromJSON(json["metadata"]),
    "name": json["name"]
  };
}
function ProductToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "defaultPrice": StripePriceToJSON(value.defaultPrice),
    "description": value.description,
    "metadata": StripeMetadataToJSON(value.metadata),
    "name": value.name
  };
}

// build/models/BillingSubscriptionItem.ts
function instanceOfBillingSubscriptionItem(value) {
  let isInstance = true;
  isInstance = isInstance && "price" in value;
  isInstance = isInstance && "product" in value;
  isInstance = isInstance && "quantity" in value;
  return isInstance;
}
function BillingSubscriptionItemFromJSON(json) {
  return BillingSubscriptionItemFromJSONTyped(json);
}
function BillingSubscriptionItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    ...json,
    "price": StripePriceFromJSON(json["price"]),
    "product": ProductFromJSON(json["product"]),
    "quantity": json["quantity"]
  };
}
function BillingSubscriptionItemToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    ...value,
    "price": StripePriceToJSON(value.price),
    "product": ProductToJSON(value.product),
    "quantity": value.quantity
  };
}

// build/models/BillingSubscription.ts
function instanceOfBillingSubscription(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "stripeSubscriptionId" in value;
  isInstance = isInstance && "status" in value;
  isInstance = isInstance && "accountId" in value;
  isInstance = isInstance && "items" in value;
  return isInstance;
}
function BillingSubscriptionFromJSON(json) {
  return BillingSubscriptionFromJSONTyped(json);
}
function BillingSubscriptionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    ...json,
    "id": json["id"],
    "stripeSubscriptionId": json["stripeSubscriptionId"],
    "status": json["status"],
    "accountId": json["accountId"],
    "items": json["items"].map(BillingSubscriptionItemFromJSON)
  };
}
function BillingSubscriptionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    ...value,
    "id": value.id,
    "stripeSubscriptionId": value.stripeSubscriptionId,
    "status": value.status,
    "accountId": value.accountId,
    "items": value.items.map(BillingSubscriptionItemToJSON)
  };
}

// build/models/BillingSubscriptionResponse.ts
function instanceOfBillingSubscriptionResponse(value) {
  let isInstance = true;
  return isInstance;
}
function BillingSubscriptionResponseFromJSON(json) {
  return BillingSubscriptionResponseFromJSONTyped(json);
}
function BillingSubscriptionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : BillingSubscriptionFromJSON(json["data"])
  };
}
function BillingSubscriptionResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": BillingSubscriptionToJSON(value.data)
  };
}

// build/models/BillingSubscriptionsResponse.ts
function instanceOfBillingSubscriptionsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function BillingSubscriptionsResponseFromJSON(json) {
  return BillingSubscriptionsResponseFromJSONTyped(json);
}
function BillingSubscriptionsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(BillingSubscriptionFromJSON)
  };
}
function BillingSubscriptionsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(BillingSubscriptionToJSON)
  };
}

// build/models/BooleanPropertyAllOfConfig.ts
function instanceOfBooleanPropertyAllOfConfig(value) {
  let isInstance = true;
  return isInstance;
}
function BooleanPropertyAllOfConfigFromJSON(json) {
  return BooleanPropertyAllOfConfigFromJSONTyped(json);
}
function BooleanPropertyAllOfConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "allowIndeterminate": !exists(json, "allowIndeterminate") ? void 0 : json["allowIndeterminate"]
  };
}
function BooleanPropertyAllOfConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "allowIndeterminate": value.allowIndeterminate
  };
}

// build/models/BooleanProperty.ts
var BooleanPropertyTypeEnum = {
  Boolean: "boolean"
};
function instanceOfBooleanProperty(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function BooleanPropertyFromJSON(json) {
  return BooleanPropertyFromJSONTyped(json);
}
function BooleanPropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ConstraintFromJSON),
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "appearance": !exists(json, "appearance") ? void 0 : BasePropertyAppearanceFromJSON(json["appearance"]),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"],
    "config": !exists(json, "config") ? void 0 : BooleanPropertyAllOfConfigFromJSON(json["config"])
  };
}
function BooleanPropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "type": value.type,
    "label": value.label,
    "description": value.description,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ConstraintToJSON),
    "readonly": value.readonly,
    "metadata": value.metadata,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "appearance": BasePropertyAppearanceToJSON(value.appearance),
    "treatments": value.treatments,
    "alternativeNames": value.alternativeNames,
    "config": BooleanPropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/DateProperty.ts
var DatePropertyTypeEnum = {
  Date: "date"
};
function instanceOfDateProperty(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function DatePropertyFromJSON(json) {
  return DatePropertyFromJSONTyped(json);
}
function DatePropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ConstraintFromJSON),
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "appearance": !exists(json, "appearance") ? void 0 : BasePropertyAppearanceFromJSON(json["appearance"]),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"]
  };
}
function DatePropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "type": value.type,
    "label": value.label,
    "description": value.description,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ConstraintToJSON),
    "readonly": value.readonly,
    "metadata": value.metadata,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "appearance": BasePropertyAppearanceToJSON(value.appearance),
    "treatments": value.treatments,
    "alternativeNames": value.alternativeNames
  };
}

// build/models/EnumPropertyAllOfConfig.ts
function instanceOfEnumPropertyAllOfConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "options" in value;
  return isInstance;
}
function EnumPropertyAllOfConfigFromJSON(json) {
  return EnumPropertyAllOfConfigFromJSONTyped(json);
}
function EnumPropertyAllOfConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "allowCustom": !exists(json, "allowCustom") ? void 0 : json["allowCustom"],
    "options": json["options"].map(EnumPropertyOptionFromJSON)
  };
}
function EnumPropertyAllOfConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "allowCustom": value.allowCustom,
    "options": value.options.map(EnumPropertyOptionToJSON)
  };
}

// build/models/EnumListProperty.ts
var EnumListPropertyTypeEnum = {
  EnumList: "enum-list"
};
function instanceOfEnumListProperty(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "config" in value;
  return isInstance;
}
function EnumListPropertyFromJSON(json) {
  return EnumListPropertyFromJSONTyped(json);
}
function EnumListPropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ConstraintFromJSON),
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "appearance": !exists(json, "appearance") ? void 0 : BasePropertyAppearanceFromJSON(json["appearance"]),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"],
    "config": EnumPropertyAllOfConfigFromJSON(json["config"])
  };
}
function EnumListPropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "type": value.type,
    "label": value.label,
    "description": value.description,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ConstraintToJSON),
    "readonly": value.readonly,
    "metadata": value.metadata,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "appearance": BasePropertyAppearanceToJSON(value.appearance),
    "treatments": value.treatments,
    "alternativeNames": value.alternativeNames,
    "config": EnumPropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/EnumProperty.ts
var EnumPropertyTypeEnum = {
  Enum: "enum"
};
function instanceOfEnumProperty(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "config" in value;
  return isInstance;
}
function EnumPropertyFromJSON(json) {
  return EnumPropertyFromJSONTyped(json);
}
function EnumPropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ConstraintFromJSON),
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "appearance": !exists(json, "appearance") ? void 0 : BasePropertyAppearanceFromJSON(json["appearance"]),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"],
    "isArray": !exists(json, "isArray") ? void 0 : json["isArray"],
    "config": EnumPropertyAllOfConfigFromJSON(json["config"])
  };
}
function EnumPropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "type": value.type,
    "label": value.label,
    "description": value.description,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ConstraintToJSON),
    "readonly": value.readonly,
    "metadata": value.metadata,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "appearance": BasePropertyAppearanceToJSON(value.appearance),
    "treatments": value.treatments,
    "alternativeNames": value.alternativeNames,
    "isArray": value.isArray,
    "config": EnumPropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/NumberPropertyAllOfConfig.ts
function instanceOfNumberPropertyAllOfConfig(value) {
  let isInstance = true;
  return isInstance;
}
function NumberPropertyAllOfConfigFromJSON(json) {
  return NumberPropertyAllOfConfigFromJSONTyped(json);
}
function NumberPropertyAllOfConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "decimalPlaces": !exists(json, "decimalPlaces") ? void 0 : json["decimalPlaces"]
  };
}
function NumberPropertyAllOfConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "decimalPlaces": value.decimalPlaces
  };
}

// build/models/NumberProperty.ts
var NumberPropertyTypeEnum = {
  Number: "number"
};
function instanceOfNumberProperty(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function NumberPropertyFromJSON(json) {
  return NumberPropertyFromJSONTyped(json);
}
function NumberPropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ConstraintFromJSON),
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "appearance": !exists(json, "appearance") ? void 0 : BasePropertyAppearanceFromJSON(json["appearance"]),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"],
    "isArray": !exists(json, "isArray") ? void 0 : json["isArray"],
    "config": !exists(json, "config") ? void 0 : NumberPropertyAllOfConfigFromJSON(json["config"])
  };
}
function NumberPropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "type": value.type,
    "label": value.label,
    "description": value.description,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ConstraintToJSON),
    "readonly": value.readonly,
    "metadata": value.metadata,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "appearance": BasePropertyAppearanceToJSON(value.appearance),
    "treatments": value.treatments,
    "alternativeNames": value.alternativeNames,
    "isArray": value.isArray,
    "config": NumberPropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/ReferenceListPropertyAllOfConfig.ts
function instanceOfReferenceListPropertyAllOfConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "ref" in value;
  isInstance = isInstance && "key" in value;
  return isInstance;
}
function ReferenceListPropertyAllOfConfigFromJSON(json) {
  return ReferenceListPropertyAllOfConfigFromJSONTyped(json);
}
function ReferenceListPropertyAllOfConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "ref": json["ref"],
    "key": json["key"]
  };
}
function ReferenceListPropertyAllOfConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "ref": value.ref,
    "key": value.key
  };
}

// build/models/ReferenceListProperty.ts
var ReferenceListPropertyTypeEnum = {
  ReferenceList: "reference-list"
};
function instanceOfReferenceListProperty(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "config" in value;
  return isInstance;
}
function ReferenceListPropertyFromJSON(json) {
  return ReferenceListPropertyFromJSONTyped(json);
}
function ReferenceListPropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ConstraintFromJSON),
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "appearance": !exists(json, "appearance") ? void 0 : BasePropertyAppearanceFromJSON(json["appearance"]),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"],
    "isArray": !exists(json, "isArray") ? void 0 : json["isArray"],
    "config": ReferenceListPropertyAllOfConfigFromJSON(json["config"])
  };
}
function ReferenceListPropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "type": value.type,
    "label": value.label,
    "description": value.description,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ConstraintToJSON),
    "readonly": value.readonly,
    "metadata": value.metadata,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "appearance": BasePropertyAppearanceToJSON(value.appearance),
    "treatments": value.treatments,
    "alternativeNames": value.alternativeNames,
    "isArray": value.isArray,
    "config": ReferenceListPropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/ReferencePropertyAllOfConfig.ts
var ReferencePropertyAllOfConfigRelationshipEnum = {
  One: "has-one",
  Many: "has-many"
};
function instanceOfReferencePropertyAllOfConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "ref" in value;
  isInstance = isInstance && "key" in value;
  return isInstance;
}
function ReferencePropertyAllOfConfigFromJSON(json) {
  return ReferencePropertyAllOfConfigFromJSONTyped(json);
}
function ReferencePropertyAllOfConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "ref": json["ref"],
    "key": json["key"],
    "relationship": !exists(json, "relationship") ? void 0 : json["relationship"]
  };
}
function ReferencePropertyAllOfConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "ref": value.ref,
    "key": value.key,
    "relationship": value.relationship
  };
}

// build/models/ReferenceProperty.ts
var ReferencePropertyTypeEnum = {
  Reference: "reference"
};
function instanceOfReferenceProperty(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "config" in value;
  return isInstance;
}
function ReferencePropertyFromJSON(json) {
  return ReferencePropertyFromJSONTyped(json);
}
function ReferencePropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ConstraintFromJSON),
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "appearance": !exists(json, "appearance") ? void 0 : BasePropertyAppearanceFromJSON(json["appearance"]),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"],
    "isArray": !exists(json, "isArray") ? void 0 : json["isArray"],
    "config": ReferencePropertyAllOfConfigFromJSON(json["config"])
  };
}
function ReferencePropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "type": value.type,
    "label": value.label,
    "description": value.description,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ConstraintToJSON),
    "readonly": value.readonly,
    "metadata": value.metadata,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "appearance": BasePropertyAppearanceToJSON(value.appearance),
    "treatments": value.treatments,
    "alternativeNames": value.alternativeNames,
    "isArray": value.isArray,
    "config": ReferencePropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/StringListProperty.ts
var StringListPropertyTypeEnum = {
  StringList: "string-list"
};
function instanceOfStringListProperty(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function StringListPropertyFromJSON(json) {
  return StringListPropertyFromJSONTyped(json);
}
function StringListPropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ConstraintFromJSON),
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "appearance": !exists(json, "appearance") ? void 0 : BasePropertyAppearanceFromJSON(json["appearance"]),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"]
  };
}
function StringListPropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "type": value.type,
    "label": value.label,
    "description": value.description,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ConstraintToJSON),
    "readonly": value.readonly,
    "metadata": value.metadata,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "appearance": BasePropertyAppearanceToJSON(value.appearance),
    "treatments": value.treatments,
    "alternativeNames": value.alternativeNames
  };
}

// build/models/StringProperty.ts
var StringPropertyTypeEnum = {
  String: "string"
};
function instanceOfStringProperty(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function StringPropertyFromJSON(json) {
  return StringPropertyFromJSONTyped(json);
}
function StringPropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(ConstraintFromJSON),
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "appearance": !exists(json, "appearance") ? void 0 : BasePropertyAppearanceFromJSON(json["appearance"]),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"],
    "alternativeNames": !exists(json, "alternativeNames") ? void 0 : json["alternativeNames"]
  };
}
function StringPropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "type": value.type,
    "label": value.label,
    "description": value.description,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(ConstraintToJSON),
    "readonly": value.readonly,
    "metadata": value.metadata,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "appearance": BasePropertyAppearanceToJSON(value.appearance),
    "treatments": value.treatments,
    "alternativeNames": value.alternativeNames
  };
}

// build/models/Property.ts
function PropertyFromJSON(json) {
  return PropertyFromJSONTyped(json);
}
function PropertyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "boolean":
      return { ...BooleanPropertyFromJSONTyped(json), type: "boolean" };
    case "date":
      return { ...DatePropertyFromJSONTyped(json), type: "date" };
    case "enum":
      return { ...EnumPropertyFromJSONTyped(json), type: "enum" };
    case "enum-list":
      return { ...EnumListPropertyFromJSONTyped(json), type: "enum-list" };
    case "number":
      return { ...NumberPropertyFromJSONTyped(json), type: "number" };
    case "reference":
      return { ...ReferencePropertyFromJSONTyped(json), type: "reference" };
    case "reference-list":
      return { ...ReferenceListPropertyFromJSONTyped(json), type: "reference-list" };
    case "string":
      return { ...StringPropertyFromJSONTyped(json), type: "string" };
    case "string-list":
      return { ...StringListPropertyFromJSONTyped(json), type: "string-list" };
    default:
      throw new Error(`No variant of Property exists with 'type=${json["type"]}'`);
  }
}
function PropertyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "boolean":
      return BooleanPropertyToJSON(value);
    case "date":
      return DatePropertyToJSON(value);
    case "enum":
      return EnumPropertyToJSON(value);
    case "enum-list":
      return EnumListPropertyToJSON(value);
    case "number":
      return NumberPropertyToJSON(value);
    case "reference":
      return ReferencePropertyToJSON(value);
    case "reference-list":
      return ReferenceListPropertyToJSON(value);
    case "string":
      return StringPropertyToJSON(value);
    case "string-list":
      return StringListPropertyToJSON(value);
    default:
      throw new Error(`No variant of Property exists with 'type=${value["type"]}'`);
  }
}

// build/models/SheetAccess.ts
var SheetAccess = {
  Star: "*",
  Add: "add",
  Edit: "edit",
  Delete: "delete",
  Import: "import"
};
function SheetAccessFromJSON(json) {
  return SheetAccessFromJSONTyped(json);
}
function SheetAccessFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function SheetAccessToJSON(value) {
  return value;
}

// build/models/CompositeUniqueConstraint.ts
var CompositeUniqueConstraintTypeEnum = {
  Unique: "unique"
};
var CompositeUniqueConstraintStrategyEnum = {
  Hash: "hash",
  Concat: "concat"
};
function instanceOfCompositeUniqueConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "fields" in value;
  return isInstance;
}
function CompositeUniqueConstraintFromJSON(json) {
  return CompositeUniqueConstraintFromJSONTyped(json);
}
function CompositeUniqueConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "name": json["name"],
    "fields": json["fields"],
    "requiredFields": !exists(json, "requiredFields") ? void 0 : json["requiredFields"],
    "strategy": !exists(json, "strategy") ? void 0 : json["strategy"]
  };
}
function CompositeUniqueConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "name": value.name,
    "fields": value.fields,
    "requiredFields": value.requiredFields,
    "strategy": value.strategy
  };
}

// build/models/ExternalSheetConstraint.ts
var ExternalSheetConstraintTypeEnum = {
  External: "external"
};
function instanceOfExternalSheetConstraint(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function ExternalSheetConstraintFromJSON(json) {
  return ExternalSheetConstraintFromJSONTyped(json);
}
function ExternalSheetConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "fields": !exists(json, "fields") ? void 0 : json["fields"],
    "config": !exists(json, "config") ? void 0 : json["config"],
    "validator": !exists(json, "validator") ? void 0 : json["validator"]
  };
}
function ExternalSheetConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "fields": value.fields,
    "config": value.config,
    "validator": value.validator
  };
}

// build/models/SheetConstraint.ts
function SheetConstraintFromJSON(json) {
  return SheetConstraintFromJSONTyped(json);
}
function SheetConstraintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "external":
      return { ...ExternalSheetConstraintFromJSONTyped(json), type: "external" };
    case "unique":
      return { ...CompositeUniqueConstraintFromJSONTyped(json), type: "unique" };
    default:
      throw new Error(`No variant of SheetConstraint exists with 'type=${json["type"]}'`);
  }
}
function SheetConstraintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "external":
      return ExternalSheetConstraintToJSON(value);
    case "unique":
      return CompositeUniqueConstraintToJSON(value);
    default:
      throw new Error(`No variant of SheetConstraint exists with 'type=${value["type"]}'`);
  }
}

// build/models/SheetConfig.ts
function instanceOfSheetConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "fields" in value;
  return isInstance;
}
function SheetConfigFromJSON(json) {
  return SheetConfigFromJSONTyped(json);
}
function SheetConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "slug": !exists(json, "slug") ? void 0 : json["slug"],
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "allowAdditionalFields": !exists(json, "allowAdditionalFields") ? void 0 : json["allowAdditionalFields"],
    "mappingConfidenceThreshold": !exists(json, "mappingConfidenceThreshold") ? void 0 : json["mappingConfidenceThreshold"],
    "access": !exists(json, "access") ? void 0 : json["access"].map(SheetAccessFromJSON),
    "fields": json["fields"].map(PropertyFromJSON),
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(SheetConstraintFromJSON)
  };
}
function SheetConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "slug": value.slug,
    "readonly": value.readonly,
    "allowAdditionalFields": value.allowAdditionalFields,
    "mappingConfidenceThreshold": value.mappingConfidenceThreshold,
    "access": value.access === void 0 ? void 0 : value.access.map(SheetAccessToJSON),
    "fields": value.fields.map(PropertyToJSON),
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "metadata": value.metadata,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(SheetConstraintToJSON)
  };
}

// build/models/Blueprint.ts
function instanceOfBlueprint(value) {
  let isInstance = true;
  isInstance = isInstance && "slug" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "sheets" in value;
  return isInstance;
}
function BlueprintFromJSON(json) {
  return BlueprintFromJSONTyped(json);
}
function BlueprintFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "slug": json["slug"],
    "name": json["name"],
    "primary": !exists(json, "primary") ? void 0 : json["primary"],
    "sheets": json["sheets"].map(SheetConfigFromJSON)
  };
}
function BlueprintToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "slug": value.slug,
    "name": value.name,
    "primary": value.primary,
    "sheets": value.sheets.map(SheetConfigToJSON)
  };
}

// build/models/BooleanPropertyAllOf.ts
var BooleanPropertyAllOfTypeEnum = {
  Boolean: "boolean"
};
function instanceOfBooleanPropertyAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function BooleanPropertyAllOfFromJSON(json) {
  return BooleanPropertyAllOfFromJSONTyped(json);
}
function BooleanPropertyAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"],
    "config": !exists(json, "config") ? void 0 : BooleanPropertyAllOfConfigFromJSON(json["config"])
  };
}
function BooleanPropertyAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "config": BooleanPropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/ValidationMessage.ts
var ValidationMessageTypeEnum = {
  Error: "error",
  Warn: "warn",
  Info: "info"
};
var ValidationMessageSourceEnum = {
  RequiredConstraint: "required-constraint",
  UniqueConstraint: "unique-constraint",
  CustomLogic: "custom-logic",
  Unlinked: "unlinked",
  InvalidOption: "invalid-option",
  IsArtifact: "is-artifact"
};
function instanceOfValidationMessage(value) {
  let isInstance = true;
  return isInstance;
}
function ValidationMessageFromJSON(json) {
  return ValidationMessageFromJSONTyped(json);
}
function ValidationMessageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "field": !exists(json, "field") ? void 0 : json["field"],
    "type": !exists(json, "type") ? void 0 : json["type"],
    "source": !exists(json, "source") ? void 0 : json["source"],
    "path": !exists(json, "path") ? void 0 : json["path"],
    "message": !exists(json, "message") ? void 0 : json["message"]
  };
}
function ValidationMessageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "field": value.field,
    "type": value.type,
    "source": value.source,
    "path": value.path,
    "message": value.message
  };
}

// build/models/Value.ts
function instanceOfValue(value) {
  let isInstance = true;
  return isInstance;
}
function ValueFromJSON(json) {
  return ValueFromJSONTyped(json);
}
function ValueFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ValueToJSON(value) {
  return value;
}

// build/models/CellValue.ts
function instanceOfCellValue(value) {
  let isInstance = true;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function CellValueFromJSON(json) {
  return CellValueFromJSONTyped(json);
}
function CellValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "value": ValueFromJSON(json["value"]),
    "valid": !exists(json, "valid") ? void 0 : json["valid"],
    "messages": !exists(json, "messages") ? void 0 : json["messages"].map(ValidationMessageFromJSON),
    "layer": !exists(json, "layer") ? void 0 : json["layer"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"] === null ? null : new Date(json["updatedAt"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"]
  };
}
function CellValueToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "value": ValueToJSON(value.value),
    "valid": value.valid,
    "messages": value.messages === void 0 ? void 0 : value.messages.map(ValidationMessageToJSON),
    "layer": value.layer,
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt === null ? null : value.updatedAt.toISOString(),
    "metadata": value.metadata
  };
}

// build/models/FieldRecordCounts.ts
function instanceOfFieldRecordCounts(value) {
  let isInstance = true;
  return isInstance;
}
function FieldRecordCountsFromJSON(json) {
  return FieldRecordCountsFromJSONTyped(json);
}
function FieldRecordCountsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total": !exists(json, "total") ? void 0 : json["total"],
    "valid": !exists(json, "valid") ? void 0 : json["valid"],
    "error": !exists(json, "error") ? void 0 : json["error"],
    "empty": !exists(json, "empty") ? void 0 : json["empty"]
  };
}
function FieldRecordCountsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total": value.total,
    "valid": value.valid,
    "error": value.error,
    "empty": value.empty
  };
}

// build/models/RecordCounts.ts
function instanceOfRecordCounts(value) {
  let isInstance = true;
  isInstance = isInstance && "total" in value;
  isInstance = isInstance && "valid" in value;
  isInstance = isInstance && "error" in value;
  return isInstance;
}
function RecordCountsFromJSON(json) {
  return RecordCountsFromJSONTyped(json);
}
function RecordCountsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total": json["total"],
    "valid": json["valid"],
    "error": json["error"],
    "errorsByField": !exists(json, "errorsByField") ? void 0 : json["errorsByField"],
    "byField": !exists(json, "byField") ? void 0 : mapValues(json["byField"], FieldRecordCountsFromJSON)
  };
}
function RecordCountsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total": value.total,
    "valid": value.valid,
    "error": value.error,
    "errorsByField": value.errorsByField,
    "byField": value.byField === void 0 ? void 0 : mapValues(value.byField, FieldRecordCountsToJSON)
  };
}

// build/models/CellValueWithCounts.ts
function instanceOfCellValueWithCounts(value) {
  let isInstance = true;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function CellValueWithCountsFromJSON(json) {
  return CellValueWithCountsFromJSONTyped(json);
}
function CellValueWithCountsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "value": ValueFromJSON(json["value"]),
    "valid": !exists(json, "valid") ? void 0 : json["valid"],
    "messages": !exists(json, "messages") ? void 0 : json["messages"].map(ValidationMessageFromJSON),
    "layer": !exists(json, "layer") ? void 0 : json["layer"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"] === null ? null : new Date(json["updatedAt"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "counts": !exists(json, "counts") ? void 0 : RecordCountsFromJSON(json["counts"])
  };
}
function CellValueWithCountsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "value": ValueToJSON(value.value),
    "valid": value.valid,
    "messages": value.messages === void 0 ? void 0 : value.messages.map(ValidationMessageToJSON),
    "layer": value.layer,
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt === null ? null : value.updatedAt.toISOString(),
    "metadata": value.metadata,
    "counts": RecordCountsToJSON(value.counts)
  };
}

// build/models/CellValueWithCountsAllOf.ts
function instanceOfCellValueWithCountsAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function CellValueWithCountsAllOfFromJSON(json) {
  return CellValueWithCountsAllOfFromJSONTyped(json);
}
function CellValueWithCountsAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "counts": !exists(json, "counts") ? void 0 : RecordCountsFromJSON(json["counts"])
  };
}
function CellValueWithCountsAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "counts": RecordCountsToJSON(value.counts)
  };
}

// build/models/Records.ts
function instanceOfRecords(value) {
  let isInstance = true;
  return isInstance;
}
function RecordsFromJSON(json) {
  return RecordsFromJSONTyped(json);
}
function RecordsFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function RecordsToJSON(value) {
  return value;
}

// build/models/CellValueWithLinks.ts
function instanceOfCellValueWithLinks(value) {
  let isInstance = true;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function CellValueWithLinksFromJSON(json) {
  return CellValueWithLinksFromJSONTyped(json);
}
function CellValueWithLinksFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "links": !exists(json, "links") ? void 0 : RecordsFromJSON(json["links"]),
    "value": ValueFromJSON(json["value"]),
    "valid": !exists(json, "valid") ? void 0 : json["valid"],
    "messages": !exists(json, "messages") ? void 0 : json["messages"].map(ValidationMessageFromJSON),
    "layer": !exists(json, "layer") ? void 0 : json["layer"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"] === null ? null : new Date(json["updatedAt"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"]
  };
}
function CellValueWithLinksToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "links": RecordsToJSON(value.links),
    "value": ValueToJSON(value.value),
    "valid": value.valid,
    "messages": value.messages === void 0 ? void 0 : value.messages.map(ValidationMessageToJSON),
    "layer": value.layer,
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt === null ? null : value.updatedAt.toISOString(),
    "metadata": value.metadata
  };
}

// build/models/CellsResponseData.ts
function instanceOfCellsResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function CellsResponseDataFromJSON(json) {
  return CellsResponseDataFromJSONTyped(json);
}
function CellsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CellsResponseDataToJSON(value) {
  return value;
}

// build/models/CellsResponse.ts
function instanceOfCellsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function CellsResponseFromJSON(json) {
  return CellsResponseFromJSONTyped(json);
}
function CellsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : CellsResponseDataFromJSON(json["data"])
  };
}
function CellsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": CellsResponseDataToJSON(value.data)
  };
}

// build/models/CheckoutSession.ts
function instanceOfCheckoutSession(value) {
  let isInstance = true;
  return isInstance;
}
function CheckoutSessionFromJSON(json) {
  return CheckoutSessionFromJSONTyped(json);
}
function CheckoutSessionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    ...json,
    "id": !exists(json, "id") ? void 0 : json["id"],
    "object": !exists(json, "object") ? void 0 : json["object"]
  };
}
function CheckoutSessionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    ...value,
    "id": value.id,
    "object": value.object
  };
}

// build/models/LineItem.ts
function instanceOfLineItem(value) {
  let isInstance = true;
  return isInstance;
}
function LineItemFromJSON(json) {
  return LineItemFromJSONTyped(json);
}
function LineItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "price": !exists(json, "price") ? void 0 : json["price"],
    "quantity": !exists(json, "quantity") ? void 0 : json["quantity"]
  };
}
function LineItemToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "price": value.price,
    "quantity": value.quantity
  };
}

// build/models/CheckoutSessionBody.ts
function instanceOfCheckoutSessionBody(value) {
  let isInstance = true;
  isInstance = isInstance && "lineItems" in value;
  isInstance = isInstance && "successUrl" in value;
  return isInstance;
}
function CheckoutSessionBodyFromJSON(json) {
  return CheckoutSessionBodyFromJSONTyped(json);
}
function CheckoutSessionBodyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "lineItems": json["lineItems"].map(LineItemFromJSON),
    "successUrl": json["successUrl"]
  };
}
function CheckoutSessionBodyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "lineItems": value.lineItems.map(LineItemToJSON),
    "successUrl": value.successUrl
  };
}

// build/models/JobSubjectType.ts
var JobSubjectType = {
  Resource: "resource",
  Collection: "collection"
};
function JobSubjectTypeFromJSON(json) {
  return JobSubjectTypeFromJSONTyped(json);
}
function JobSubjectTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function JobSubjectTypeToJSON(value) {
  return value;
}

// build/models/CollectionJobSubject.ts
function instanceOfCollectionJobSubject(value) {
  let isInstance = true;
  isInstance = isInstance && "resource" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CollectionJobSubjectFromJSON(json) {
  return CollectionJobSubjectFromJSONTyped(json);
}
function CollectionJobSubjectFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "resource": json["resource"],
    "type": JobSubjectTypeFromJSON(json["type"]),
    "query": !exists(json, "query") ? void 0 : json["query"],
    "params": !exists(json, "params") ? void 0 : json["params"]
  };
}
function CollectionJobSubjectToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "resource": value.resource,
    "type": JobSubjectTypeToJSON(value.type),
    "query": value.query,
    "params": value.params
  };
}

// build/models/Commit.ts
function instanceOfCommit(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "sheetId" in value;
  isInstance = isInstance && "createdBy" in value;
  isInstance = isInstance && "createdAt" in value;
  return isInstance;
}
function CommitFromJSON(json) {
  return CommitFromJSONTyped(json);
}
function CommitFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "sheetId": json["sheetId"],
    "createdBy": json["createdBy"],
    "completedBy": !exists(json, "completedBy") ? void 0 : json["completedBy"],
    "createdAt": new Date(json["createdAt"]),
    "completedAt": !exists(json, "completedAt") ? void 0 : new Date(json["completedAt"])
  };
}
function CommitToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "sheetId": value.sheetId,
    "createdBy": value.createdBy,
    "completedBy": value.completedBy,
    "createdAt": value.createdAt.toISOString(),
    "completedAt": value.completedAt === void 0 ? void 0 : value.completedAt.toISOString()
  };
}

// build/models/CompositeUniqueConstraintAllOf.ts
var CompositeUniqueConstraintAllOfTypeEnum = {
  Unique: "unique"
};
var CompositeUniqueConstraintAllOfStrategyEnum = {
  Hash: "hash",
  Concat: "concat"
};
function instanceOfCompositeUniqueConstraintAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "fields" in value;
  return isInstance;
}
function CompositeUniqueConstraintAllOfFromJSON(json) {
  return CompositeUniqueConstraintAllOfFromJSONTyped(json);
}
function CompositeUniqueConstraintAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "name": json["name"],
    "fields": json["fields"],
    "requiredFields": !exists(json, "requiredFields") ? void 0 : json["requiredFields"],
    "strategy": !exists(json, "strategy") ? void 0 : json["strategy"]
  };
}
function CompositeUniqueConstraintAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "name": value.name,
    "fields": value.fields,
    "requiredFields": value.requiredFields,
    "strategy": value.strategy
  };
}

// build/models/ComputedConstraintAllOf.ts
var ComputedConstraintAllOfTypeEnum = {
  Computed: "computed"
};
function instanceOfComputedConstraintAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function ComputedConstraintAllOfFromJSON(json) {
  return ComputedConstraintAllOfFromJSONTyped(json);
}
function ComputedConstraintAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"]
  };
}
function ComputedConstraintAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/ConnectionLink.ts
function instanceOfConnectionLink(value) {
  let isInstance = true;
  return isInstance;
}
function ConnectionLinkFromJSON(json) {
  return ConnectionLinkFromJSONTyped(json);
}
function ConnectionLinkFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    ...json,
    "token": !exists(json, "token") ? void 0 : json["token"]
  };
}
function ConnectionLinkToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    ...value,
    "token": value.token
  };
}

// build/models/ConnectionLinkBody.ts
function instanceOfConnectionLinkBody(value) {
  let isInstance = true;
  isInstance = isInstance && "endUserOriginId" in value;
  isInstance = isInstance && "endUserOrganizationName" in value;
  isInstance = isInstance && "endUserEmailAddress" in value;
  isInstance = isInstance && "categories" in value;
  return isInstance;
}
function ConnectionLinkBodyFromJSON(json) {
  return ConnectionLinkBodyFromJSONTyped(json);
}
function ConnectionLinkBodyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "endUserOriginId": json["endUserOriginId"],
    "endUserOrganizationName": json["endUserOrganizationName"],
    "endUserEmailAddress": json["endUserEmailAddress"],
    "categories": json["categories"],
    "integration": !exists(json, "integration") ? void 0 : json["integration"],
    "linkExpiryMins": !exists(json, "linkExpiryMins") ? void 0 : json["linkExpiryMins"],
    "shouldCreateMagicLinkUrl": !exists(json, "shouldCreateMagicLinkUrl") ? void 0 : json["shouldCreateMagicLinkUrl"]
  };
}
function ConnectionLinkBodyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "endUserOriginId": value.endUserOriginId,
    "endUserOrganizationName": value.endUserOrganizationName,
    "endUserEmailAddress": value.endUserEmailAddress,
    "categories": value.categories,
    "integration": value.integration,
    "linkExpiryMins": value.linkExpiryMins,
    "shouldCreateMagicLinkUrl": value.shouldCreateMagicLinkUrl
  };
}

// build/models/UserCredentials.ts
function instanceOfUserCredentials(value) {
  let isInstance = true;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "password" in value;
  return isInstance;
}
function UserCredentialsFromJSON(json) {
  return UserCredentialsFromJSONTyped(json);
}
function UserCredentialsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "email": json["email"],
    "password": json["password"]
  };
}
function UserCredentialsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email": value.email,
    "password": value.password
  };
}

// build/models/CreateAccessTokenRequest.ts
function CreateAccessTokenRequestFromJSON(json) {
  return CreateAccessTokenRequestFromJSONTyped(json);
}
function CreateAccessTokenRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return { ...ApiCredentialsFromJSONTyped(json), ...UserCredentialsFromJSONTyped(json) };
}
function CreateAccessTokenRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  if (instanceOfApiCredentials(value)) {
    return ApiCredentialsToJSON(value);
  }
  if (instanceOfUserCredentials(value)) {
    return UserCredentialsToJSON(value);
  }
  return {};
}

// build/models/CreateCheckoutSessionResponse.ts
function instanceOfCreateCheckoutSessionResponse(value) {
  let isInstance = true;
  return isInstance;
}
function CreateCheckoutSessionResponseFromJSON(json) {
  return CreateCheckoutSessionResponseFromJSONTyped(json);
}
function CreateCheckoutSessionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : CheckoutSessionFromJSON(json["data"])
  };
}
function CreateCheckoutSessionResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": CheckoutSessionToJSON(value.data)
  };
}

// build/models/CreateCommitIdRequest.ts
function instanceOfCreateCommitIdRequest(value) {
  let isInstance = true;
  return isInstance;
}
function CreateCommitIdRequestFromJSON(json) {
  return CreateCommitIdRequestFromJSONTyped(json);
}
function CreateCommitIdRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sheetId": !exists(json, "sheetId") ? void 0 : json["sheetId"],
    "parentCommitId": !exists(json, "parentCommitId") ? void 0 : json["parentCommitId"]
  };
}
function CreateCommitIdRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sheetId": value.sheetId,
    "parentCommitId": value.parentCommitId
  };
}

// build/models/CreateConnectionLinkResponse.ts
function instanceOfCreateConnectionLinkResponse(value) {
  let isInstance = true;
  return isInstance;
}
function CreateConnectionLinkResponseFromJSON(json) {
  return CreateConnectionLinkResponseFromJSONTyped(json);
}
function CreateConnectionLinkResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : ConnectionLinkFromJSON(json["data"])
  };
}
function CreateConnectionLinkResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": ConnectionLinkToJSON(value.data)
  };
}

// build/models/GuestAuthenticationEnum.ts
var GuestAuthenticationEnum = {
  SharedLink: "shared_link",
  MagicLink: "magic_link"
};
function GuestAuthenticationEnumFromJSON(json) {
  return GuestAuthenticationEnumFromJSONTyped(json);
}
function GuestAuthenticationEnumFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function GuestAuthenticationEnumToJSON(value) {
  return value;
}

// build/models/CreateEnvironmentRequest.ts
var CreateEnvironmentRequestDataRetentionPolicyEnum = {
  LastActivity: "lastActivity",
  SinceCreated: "sinceCreated"
};
function instanceOfCreateEnvironmentRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "isProd" in value;
  return isInstance;
}
function CreateEnvironmentRequestFromJSON(json) {
  return CreateEnvironmentRequestFromJSONTyped(json);
}
function CreateEnvironmentRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "isProd": json["isProd"],
    "guestAuthentication": !exists(json, "guestAuthentication") ? void 0 : json["guestAuthentication"].map(GuestAuthenticationEnumFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "translationsPath": !exists(json, "translationsPath") ? void 0 : json["translationsPath"],
    "namespaces": !exists(json, "namespaces") ? void 0 : json["namespaces"],
    "languageOverride": !exists(json, "languageOverride") ? void 0 : json["languageOverride"],
    "dataRetentionPolicy": !exists(json, "dataRetentionPolicy") ? void 0 : json["dataRetentionPolicy"]
  };
}
function CreateEnvironmentRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "isProd": value.isProd,
    "guestAuthentication": value.guestAuthentication === void 0 ? void 0 : value.guestAuthentication.map(GuestAuthenticationEnumToJSON),
    "metadata": value.metadata,
    "translationsPath": value.translationsPath,
    "namespaces": value.namespaces,
    "languageOverride": value.languageOverride,
    "dataRetentionPolicy": value.dataRetentionPolicy
  };
}

// build/models/CreateMappingRequest.ts
function instanceOfCreateMappingRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "source" in value;
  isInstance = isInstance && "destination" in value;
  return isInstance;
}
function CreateMappingRequestFromJSON(json) {
  return CreateMappingRequestFromJSONTyped(json);
}
function CreateMappingRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "source": SheetConfigFromJSON(json["source"]),
    "destination": SheetConfigFromJSON(json["destination"])
  };
}
function CreateMappingRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "source": SheetConfigToJSON(value.source),
    "destination": SheetConfigToJSON(value.destination)
  };
}

// build/models/CreateVersionIdRequest.ts
function instanceOfCreateVersionIdRequest(value) {
  let isInstance = true;
  return isInstance;
}
function CreateVersionIdRequestFromJSON(json) {
  return CreateVersionIdRequestFromJSONTyped(json);
}
function CreateVersionIdRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sheetId": !exists(json, "sheetId") ? void 0 : json["sheetId"],
    "parentVersionId": !exists(json, "parentVersionId") ? void 0 : json["parentVersionId"]
  };
}
function CreateVersionIdRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sheetId": value.sheetId,
    "parentVersionId": value.parentVersionId
  };
}

// build/models/Filter.ts
var Filter$1 = {
  Valid: "valid",
  Error: "error",
  All: "all",
  None: "none"
};
function FilterFromJSON(json) {
  return FilterFromJSONTyped(json);
}
function FilterFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function FilterToJSON(value) {
  return value;
}

// build/models/SortDirection.ts
var SortDirection = {
  Asc: "asc",
  Desc: "desc"
};
function SortDirectionFromJSON(json) {
  return SortDirectionFromJSONTyped(json);
}
function SortDirectionFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function SortDirectionToJSON(value) {
  return value;
}

// build/models/ViewConfig.ts
function instanceOfViewConfig(value) {
  let isInstance = true;
  return isInstance;
}
function ViewConfigFromJSON(json) {
  return ViewConfigFromJSONTyped(json);
}
function ViewConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"],
    "sinceVersionId": !exists(json, "sinceVersionId") ? void 0 : json["sinceVersionId"],
    "sinceCommitId": !exists(json, "sinceCommitId") ? void 0 : json["sinceCommitId"],
    "sortField": !exists(json, "sortField") ? void 0 : json["sortField"],
    "sortDirection": !exists(json, "sortDirection") ? void 0 : SortDirectionFromJSON(json["sortDirection"]),
    "filter": !exists(json, "filter") ? void 0 : FilterFromJSON(json["filter"]),
    "filterField": !exists(json, "filterField") ? void 0 : json["filterField"],
    "searchValue": !exists(json, "searchValue") ? void 0 : json["searchValue"],
    "searchField": !exists(json, "searchField") ? void 0 : json["searchField"],
    "ids": !exists(json, "ids") ? void 0 : json["ids"],
    "pageSize": !exists(json, "pageSize") ? void 0 : json["pageSize"],
    "pageNumber": !exists(json, "pageNumber") ? void 0 : json["pageNumber"],
    "includeLinks": !exists(json, "includeLinks") ? void 0 : json["includeLinks"],
    "includeMessages": !exists(json, "includeMessages") ? void 0 : json["includeMessages"],
    "_for": !exists(json, "for") ? void 0 : json["for"],
    "q": !exists(json, "q") ? void 0 : json["q"],
    "includeLength": !exists(json, "includeLength") ? void 0 : json["includeLength"],
    "includeCounts": !exists(json, "includeCounts") ? void 0 : json["includeCounts"]
  };
}
function ViewConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "versionId": value.versionId,
    "commitId": value.commitId,
    "sinceVersionId": value.sinceVersionId,
    "sinceCommitId": value.sinceCommitId,
    "sortField": value.sortField,
    "sortDirection": SortDirectionToJSON(value.sortDirection),
    "filter": FilterToJSON(value.filter),
    "filterField": value.filterField,
    "searchValue": value.searchValue,
    "searchField": value.searchField,
    "ids": value.ids,
    "pageSize": value.pageSize,
    "pageNumber": value.pageNumber,
    "includeLinks": value.includeLinks,
    "includeMessages": value.includeMessages,
    "for": value._for,
    "q": value.q,
    "includeLength": value.includeLength,
    "includeCounts": value.includeCounts
  };
}

// build/models/CreateViewRequest.ts
function instanceOfCreateViewRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "sheetId" in value;
  isInstance = isInstance && "config" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function CreateViewRequestFromJSON(json) {
  return CreateViewRequestFromJSONTyped(json);
}
function CreateViewRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sheetId": json["sheetId"],
    "config": ViewConfigFromJSON(json["config"]),
    "name": json["name"]
  };
}
function CreateViewRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sheetId": value.sheetId,
    "config": ViewConfigToJSON(value.config),
    "name": value.name
  };
}

// build/models/DBUser.ts
function instanceOfDBUser(value) {
  let isInstance = true;
  isInstance = isInstance && "username" in value;
  isInstance = isInstance && "password" in value;
  return isInstance;
}
function DBUserFromJSON(json) {
  return DBUserFromJSONTyped(json);
}
function DBUserFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "username": json["username"],
    "password": json["password"]
  };
}
function DBUserToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "username": value.username,
    "password": value.password
  };
}

// build/models/DataRetentionPolicyEnum.ts
var DataRetentionPolicyEnum = {
  LastActivity: "lastActivity",
  SinceCreated: "sinceCreated"
};
function DataRetentionPolicyEnumFromJSON(json) {
  return DataRetentionPolicyEnumFromJSONTyped(json);
}
function DataRetentionPolicyEnumFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function DataRetentionPolicyEnumToJSON(value) {
  return value;
}

// build/models/DataRetentionPolicy.ts
function instanceOfDataRetentionPolicy(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "updatedAt" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "period" in value;
  isInstance = isInstance && "environmentId" in value;
  return isInstance;
}
function DataRetentionPolicyFromJSON(json) {
  return DataRetentionPolicyFromJSONTyped(json);
}
function DataRetentionPolicyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "type": DataRetentionPolicyEnumFromJSON(json["type"]),
    "period": json["period"],
    "environmentId": json["environmentId"]
  };
}
function DataRetentionPolicyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString(),
    "type": DataRetentionPolicyEnumToJSON(value.type),
    "period": value.period,
    "environmentId": value.environmentId
  };
}

// build/models/DataRetentionPolicyConfig.ts
function instanceOfDataRetentionPolicyConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "period" in value;
  isInstance = isInstance && "environmentId" in value;
  return isInstance;
}
function DataRetentionPolicyConfigFromJSON(json) {
  return DataRetentionPolicyConfigFromJSONTyped(json);
}
function DataRetentionPolicyConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": DataRetentionPolicyEnumFromJSON(json["type"]),
    "period": json["period"],
    "environmentId": json["environmentId"]
  };
}
function DataRetentionPolicyConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": DataRetentionPolicyEnumToJSON(value.type),
    "period": value.period,
    "environmentId": value.environmentId
  };
}

// build/models/DataRetentionPolicyConfigUpdate.ts
function instanceOfDataRetentionPolicyConfigUpdate(value) {
  let isInstance = true;
  return isInstance;
}
function DataRetentionPolicyConfigUpdateFromJSON(json) {
  return DataRetentionPolicyConfigUpdateFromJSONTyped(json);
}
function DataRetentionPolicyConfigUpdateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : DataRetentionPolicyEnumFromJSON(json["type"]),
    "period": !exists(json, "period") ? void 0 : json["period"],
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"]
  };
}
function DataRetentionPolicyConfigUpdateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": DataRetentionPolicyEnumToJSON(value.type),
    "period": value.period,
    "environmentId": value.environmentId
  };
}

// build/models/DataRetentionPolicyResponse.ts
function instanceOfDataRetentionPolicyResponse(value) {
  let isInstance = true;
  return isInstance;
}
function DataRetentionPolicyResponseFromJSON(json) {
  return DataRetentionPolicyResponseFromJSONTyped(json);
}
function DataRetentionPolicyResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : DataRetentionPolicyFromJSON(json["data"])
  };
}
function DataRetentionPolicyResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": DataRetentionPolicyToJSON(value.data)
  };
}

// build/models/DatePropertyAllOf.ts
var DatePropertyAllOfTypeEnum = {
  Date: "date"
};
function instanceOfDatePropertyAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function DatePropertyAllOfFromJSON(json) {
  return DatePropertyAllOfFromJSONTyped(json);
}
function DatePropertyAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"]
  };
}
function DatePropertyAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/DeleteRecordsJobConfig.ts
function instanceOfDeleteRecordsJobConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "sheet" in value;
  return isInstance;
}
function DeleteRecordsJobConfigFromJSON(json) {
  return DeleteRecordsJobConfigFromJSONTyped(json);
}
function DeleteRecordsJobConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "filter": !exists(json, "filter") ? void 0 : FilterFromJSON(json["filter"]),
    "filterField": !exists(json, "filterField") ? void 0 : json["filterField"],
    "searchValue": !exists(json, "searchValue") ? void 0 : json["searchValue"],
    "searchField": !exists(json, "searchField") ? void 0 : json["searchField"],
    "q": !exists(json, "q") ? void 0 : json["q"],
    "sheet": json["sheet"],
    "exceptions": !exists(json, "exceptions") ? void 0 : json["exceptions"]
  };
}
function DeleteRecordsJobConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "filter": FilterToJSON(value.filter),
    "filterField": value.filterField,
    "searchValue": value.searchValue,
    "searchField": value.searchField,
    "q": value.q,
    "sheet": value.sheet,
    "exceptions": value.exceptions
  };
}

// build/models/DeleteRulesRequest.ts
function instanceOfDeleteRulesRequest(value) {
  let isInstance = true;
  return isInstance;
}
function DeleteRulesRequestFromJSON(json) {
  return DeleteRulesRequestFromJSONTyped(json);
}
function DeleteRulesRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "ruleIds": !exists(json, "ruleIds") ? void 0 : json["ruleIds"]
  };
}
function DeleteRulesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "ruleIds": value.ruleIds
  };
}

// build/models/FieldConfig.ts
function FieldConfigFromJSON(json) {
  return FieldConfigFromJSONTyped(json);
}
function FieldConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "boolean":
      return { ...BooleanPropertyFromJSONTyped(json), type: "boolean" };
    case "date":
      return { ...DatePropertyFromJSONTyped(json), type: "date" };
    case "enum":
      return { ...EnumPropertyFromJSONTyped(json), type: "enum" };
    case "enum-list":
      return { ...EnumListPropertyFromJSONTyped(json), type: "enum-list" };
    case "number":
      return { ...NumberPropertyFromJSONTyped(json), type: "number" };
    case "reference":
      return { ...ReferencePropertyFromJSONTyped(json), type: "reference" };
    case "reference-list":
      return { ...ReferenceListPropertyFromJSONTyped(json), type: "reference-list" };
    case "string":
      return { ...StringPropertyFromJSONTyped(json), type: "string" };
    case "string-list":
      return { ...StringListPropertyFromJSONTyped(json), type: "string-list" };
    default:
      throw new Error(`No variant of FieldConfig exists with 'type=${json["type"]}'`);
  }
}
function FieldConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "boolean":
      return BooleanPropertyToJSON(value);
    case "date":
      return DatePropertyToJSON(value);
    case "enum":
      return EnumPropertyToJSON(value);
    case "enum-list":
      return EnumListPropertyToJSON(value);
    case "number":
      return NumberPropertyToJSON(value);
    case "reference":
      return ReferencePropertyToJSON(value);
    case "reference-list":
      return ReferenceListPropertyToJSON(value);
    case "string":
      return StringPropertyToJSON(value);
    case "string-list":
      return StringListPropertyToJSON(value);
    default:
      throw new Error(`No variant of FieldConfig exists with 'type=${value["type"]}'`);
  }
}

// build/models/DestinationField.ts
function instanceOfDestinationField(value) {
  let isInstance = true;
  isInstance = isInstance && "destinationField" in value;
  return isInstance;
}
function DestinationFieldFromJSON(json) {
  return DestinationFieldFromJSONTyped(json);
}
function DestinationFieldFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "destinationField": FieldConfigFromJSON(json["destinationField"]),
    "preview": !exists(json, "preview") ? void 0 : json["preview"]
  };
}
function DestinationFieldToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "destinationField": FieldConfigToJSON(value.destinationField),
    "preview": value.preview
  };
}

// build/models/DiffData.ts
function instanceOfDiffData(value) {
  let isInstance = true;
  return isInstance;
}
function DiffDataFromJSON(json) {
  return DiffDataFromJSONTyped(json);
}
function DiffDataFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function DiffDataToJSON(value) {
  return value;
}

// build/models/DiffRecord.ts
function instanceOfDiffRecord(value) {
  let isInstance = true;
  isInstance = isInstance && "values" in value;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function DiffRecordFromJSON(json) {
  return DiffRecordFromJSONTyped(json);
}
function DiffRecordFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "values": DiffDataFromJSON(json["values"]),
    "id": json["id"],
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"],
    "valid": !exists(json, "valid") ? void 0 : json["valid"],
    "messages": !exists(json, "messages") ? void 0 : json["messages"].map(ValidationMessageFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "config": !exists(json, "config") ? void 0 : json["config"]
  };
}
function DiffRecordToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "values": DiffDataToJSON(value.values),
    "id": value.id,
    "versionId": value.versionId,
    "commitId": value.commitId,
    "valid": value.valid,
    "messages": value.messages === void 0 ? void 0 : value.messages.map(ValidationMessageToJSON),
    "metadata": value.metadata,
    "config": value.config
  };
}

// build/models/DiffRecordsResponseData.ts
function instanceOfDiffRecordsResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function DiffRecordsResponseDataFromJSON(json) {
  return DiffRecordsResponseDataFromJSONTyped(json);
}
function DiffRecordsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function DiffRecordsResponseDataToJSON(value) {
  return value;
}

// build/models/DiffRecordsResponse.ts
function instanceOfDiffRecordsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function DiffRecordsResponseFromJSON(json) {
  return DiffRecordsResponseFromJSONTyped(json);
}
function DiffRecordsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : DiffRecordsResponseDataFromJSON(json["data"])
  };
}
function DiffRecordsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": DiffRecordsResponseDataToJSON(value.data)
  };
}

// build/models/DiffValue.ts
function instanceOfDiffValue(value) {
  let isInstance = true;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function DiffValueFromJSON(json) {
  return DiffValueFromJSONTyped(json);
}
function DiffValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "snapshotValue": !exists(json, "snapshotValue") ? void 0 : ValueFromJSON(json["snapshotValue"]),
    "value": ValueFromJSON(json["value"]),
    "valid": !exists(json, "valid") ? void 0 : json["valid"],
    "messages": !exists(json, "messages") ? void 0 : json["messages"].map(ValidationMessageFromJSON),
    "layer": !exists(json, "layer") ? void 0 : json["layer"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"] === null ? null : new Date(json["updatedAt"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"]
  };
}
function DiffValueToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "snapshotValue": ValueToJSON(value.snapshotValue),
    "value": ValueToJSON(value.value),
    "valid": value.valid,
    "messages": value.messages === void 0 ? void 0 : value.messages.map(ValidationMessageToJSON),
    "layer": value.layer,
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt === null ? null : value.updatedAt.toISOString(),
    "metadata": value.metadata
  };
}

// build/models/Document.ts
function instanceOfDocument(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "updatedAt" in value;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "body" in value;
  return isInstance;
}
function DocumentFromJSON(json) {
  return DocumentFromJSONTyped(json);
}
function DocumentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "spaceId": !exists(json, "spaceId") ? void 0 : json["spaceId"],
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "title": json["title"],
    "body": json["body"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"]
  };
}
function DocumentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "spaceId": value.spaceId,
    "environmentId": value.environmentId,
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString(),
    "title": value.title,
    "body": value.body,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "treatments": value.treatments
  };
}

// build/models/DocumentConfig.ts
function instanceOfDocumentConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "body" in value;
  return isInstance;
}
function DocumentConfigFromJSON(json) {
  return DocumentConfigFromJSONTyped(json);
}
function DocumentConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "title": json["title"],
    "body": json["body"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"]
  };
}
function DocumentConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "title": value.title,
    "body": value.body,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "treatments": value.treatments
  };
}

// build/models/DocumentResponse.ts
function instanceOfDocumentResponse(value) {
  let isInstance = true;
  return isInstance;
}
function DocumentResponseFromJSON(json) {
  return DocumentResponseFromJSONTyped(json);
}
function DocumentResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : DocumentFromJSON(json["data"])
  };
}
function DocumentResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": DocumentToJSON(value.data)
  };
}

// build/models/DocumentSidebarConfig.ts
var DocumentSidebarConfigTypeEnum = {
  Workbook: "workbook",
  Document: "document",
  Link: "link"
};
function instanceOfDocumentSidebarConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "documentId" in value;
  return isInstance;
}
function DocumentSidebarConfigFromJSON(json) {
  return DocumentSidebarConfigFromJSONTyped(json);
}
function DocumentSidebarConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"],
    "documentId": json["documentId"]
  };
}
function DocumentSidebarConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "documentId": value.documentId
  };
}

// build/models/DocumentSidebarConfigAllOf.ts
function instanceOfDocumentSidebarConfigAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "documentId" in value;
  return isInstance;
}
function DocumentSidebarConfigAllOfFromJSON(json) {
  return DocumentSidebarConfigAllOfFromJSONTyped(json);
}
function DocumentSidebarConfigAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "documentId": json["documentId"]
  };
}
function DocumentSidebarConfigAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "documentId": value.documentId
  };
}

// build/models/DocumentsResponse.ts
function instanceOfDocumentsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function DocumentsResponseFromJSON(json) {
  return DocumentsResponseFromJSONTyped(json);
}
function DocumentsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(DocumentFromJSON)
  };
}
function DocumentsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(DocumentToJSON)
  };
}

// build/models/MappingCertainty.ts
var MappingCertainty = {
  Absolute: "absolute",
  Strong: "strong",
  Moderate: "moderate",
  Weak: "weak"
};
function MappingCertaintyFromJSON(json) {
  return MappingCertaintyFromJSONTyped(json);
}
function MappingCertaintyFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function MappingCertaintyToJSON(value) {
  return value;
}

// build/models/EdgeMetadata.ts
function instanceOfEdgeMetadata(value) {
  let isInstance = true;
  return isInstance;
}
function EdgeMetadataFromJSON(json) {
  return EdgeMetadataFromJSONTyped(json);
}
function EdgeMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "certainty": !exists(json, "certainty") ? void 0 : MappingCertaintyFromJSON(json["certainty"]),
    "confidence": !exists(json, "confidence") ? void 0 : json["confidence"],
    "source": !exists(json, "source") ? void 0 : json["source"]
  };
}
function EdgeMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "certainty": MappingCertaintyToJSON(value.certainty),
    "confidence": value.confidence,
    "source": value.source
  };
}

// build/models/EnumMappingField.ts
function instanceOfEnumMappingField(value) {
  let isInstance = true;
  return isInstance;
}
function EnumMappingFieldFromJSON(json) {
  return EnumMappingFieldFromJSONTyped(json);
}
function EnumMappingFieldFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sourceValue": !exists(json, "sourceValue") ? void 0 : ValueFromJSON(json["sourceValue"]),
    "destinationValue": !exists(json, "destinationValue") ? void 0 : ValueFromJSON(json["destinationValue"])
  };
}
function EnumMappingFieldToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sourceValue": ValueToJSON(value.sourceValue),
    "destinationValue": ValueToJSON(value.destinationValue)
  };
}

// build/models/EnumDetails.ts
function instanceOfEnumDetails(value) {
  let isInstance = true;
  isInstance = isInstance && "mapping" in value;
  isInstance = isInstance && "unusedSourceValues" in value;
  isInstance = isInstance && "unusedDestinationValues" in value;
  return isInstance;
}
function EnumDetailsFromJSON(json) {
  return EnumDetailsFromJSONTyped(json);
}
function EnumDetailsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "mapping": json["mapping"].map(EnumMappingFieldFromJSON),
    "unusedSourceValues": json["unusedSourceValues"].map(ValueFromJSON),
    "unusedDestinationValues": json["unusedDestinationValues"].map(ValueFromJSON)
  };
}
function EnumDetailsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "mapping": value.mapping.map(EnumMappingFieldToJSON),
    "unusedSourceValues": value.unusedSourceValues.map(ValueToJSON),
    "unusedDestinationValues": value.unusedDestinationValues.map(ValueToJSON)
  };
}

// build/models/Edge.ts
function instanceOfEdge(value) {
  let isInstance = true;
  isInstance = isInstance && "sourceField" in value;
  isInstance = isInstance && "destinationField" in value;
  return isInstance;
}
function EdgeFromJSON(json) {
  return EdgeFromJSONTyped(json);
}
function EdgeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sourceField": FieldConfigFromJSON(json["sourceField"]),
    "destinationField": FieldConfigFromJSON(json["destinationField"]),
    "preview": !exists(json, "preview") ? void 0 : json["preview"],
    "enumDetails": !exists(json, "enumDetails") ? void 0 : EnumDetailsFromJSON(json["enumDetails"]),
    "metadata": !exists(json, "metadata") ? void 0 : EdgeMetadataFromJSON(json["metadata"])
  };
}
function EdgeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sourceField": FieldConfigToJSON(value.sourceField),
    "destinationField": FieldConfigToJSON(value.destinationField),
    "preview": value.preview,
    "enumDetails": EnumDetailsToJSON(value.enumDetails),
    "metadata": EdgeMetadataToJSON(value.metadata)
  };
}

// build/models/Entitlement.ts
function instanceOfEntitlement(value) {
  let isInstance = true;
  isInstance = isInstance && "key" in value;
  return isInstance;
}
function EntitlementFromJSON(json) {
  return EntitlementFromJSONTyped(json);
}
function EntitlementFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": json["key"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"]
  };
}
function EntitlementToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "metadata": value.metadata
  };
}

// build/models/EntitlementsResponse.ts
function instanceOfEntitlementsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function EntitlementsResponseFromJSON(json) {
  return EntitlementsResponseFromJSONTyped(json);
}
function EntitlementsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(EntitlementFromJSON)
  };
}
function EntitlementsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(EntitlementToJSON)
  };
}

// build/models/EnumListPropertyAllOf.ts
var EnumListPropertyAllOfTypeEnum = {
  EnumList: "enum-list"
};
function instanceOfEnumListPropertyAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "config" in value;
  return isInstance;
}
function EnumListPropertyAllOfFromJSON(json) {
  return EnumListPropertyAllOfFromJSONTyped(json);
}
function EnumListPropertyAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"],
    "config": EnumPropertyAllOfConfigFromJSON(json["config"])
  };
}
function EnumListPropertyAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "config": EnumPropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/EnumPropertyAllOf.ts
var EnumPropertyAllOfTypeEnum = {
  Enum: "enum"
};
function instanceOfEnumPropertyAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "config" in value;
  return isInstance;
}
function EnumPropertyAllOfFromJSON(json) {
  return EnumPropertyAllOfFromJSONTyped(json);
}
function EnumPropertyAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"],
    "config": EnumPropertyAllOfConfigFromJSON(json["config"])
  };
}
function EnumPropertyAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "config": EnumPropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/Environment.ts
var EnvironmentDataRetentionPolicyEnum = {
  LastActivity: "lastActivity",
  SinceCreated: "sinceCreated"
};
function instanceOfEnvironment(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "accountId" in value;
  isInstance = isInstance && "features" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "isProd" in value;
  isInstance = isInstance && "guestAuthentication" in value;
  return isInstance;
}
function EnvironmentFromJSON(json) {
  return EnvironmentFromJSONTyped(json);
}
function EnvironmentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "accountId": json["accountId"],
    "features": json["features"],
    "name": json["name"],
    "isProd": json["isProd"],
    "guestAuthentication": json["guestAuthentication"].map(GuestAuthenticationEnumFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "translationsPath": !exists(json, "translationsPath") ? void 0 : json["translationsPath"],
    "namespaces": !exists(json, "namespaces") ? void 0 : json["namespaces"],
    "languageOverride": !exists(json, "languageOverride") ? void 0 : json["languageOverride"],
    "dataRetentionPolicy": !exists(json, "dataRetentionPolicy") ? void 0 : json["dataRetentionPolicy"]
  };
}
function EnvironmentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "accountId": value.accountId,
    "features": value.features,
    "name": value.name,
    "isProd": value.isProd,
    "guestAuthentication": value.guestAuthentication.map(GuestAuthenticationEnumToJSON),
    "metadata": value.metadata,
    "translationsPath": value.translationsPath,
    "namespaces": value.namespaces,
    "languageOverride": value.languageOverride,
    "dataRetentionPolicy": value.dataRetentionPolicy
  };
}

// build/models/EnvironmentConfig.ts
var EnvironmentConfigDataRetentionPolicyEnum = {
  LastActivity: "lastActivity",
  SinceCreated: "sinceCreated"
};
function instanceOfEnvironmentConfig(value) {
  let isInstance = true;
  return isInstance;
}
function EnvironmentConfigFromJSON(json) {
  return EnvironmentConfigFromJSONTyped(json);
}
function EnvironmentConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "isProd": !exists(json, "isProd") ? void 0 : json["isProd"],
    "guestAuthentication": !exists(json, "guestAuthentication") ? void 0 : json["guestAuthentication"].map(GuestAuthenticationEnumFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "translationsPath": !exists(json, "translationsPath") ? void 0 : json["translationsPath"],
    "namespaces": !exists(json, "namespaces") ? void 0 : json["namespaces"],
    "languageOverride": !exists(json, "languageOverride") ? void 0 : json["languageOverride"],
    "dataRetentionPolicy": !exists(json, "dataRetentionPolicy") ? void 0 : json["dataRetentionPolicy"]
  };
}
function EnvironmentConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "isProd": value.isProd,
    "guestAuthentication": value.guestAuthentication === void 0 ? void 0 : value.guestAuthentication.map(GuestAuthenticationEnumToJSON),
    "metadata": value.metadata,
    "translationsPath": value.translationsPath,
    "namespaces": value.namespaces,
    "languageOverride": value.languageOverride,
    "dataRetentionPolicy": value.dataRetentionPolicy
  };
}

// build/models/EnvironmentResponse.ts
function instanceOfEnvironmentResponse(value) {
  let isInstance = true;
  return isInstance;
}
function EnvironmentResponseFromJSON(json) {
  return EnvironmentResponseFromJSONTyped(json);
}
function EnvironmentResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : EnvironmentFromJSON(json["data"])
  };
}
function EnvironmentResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": EnvironmentToJSON(value.data)
  };
}

// build/models/EnvironmentStatsResponseData.ts
function instanceOfEnvironmentStatsResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function EnvironmentStatsResponseDataFromJSON(json) {
  return EnvironmentStatsResponseDataFromJSONTyped(json);
}
function EnvironmentStatsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "agentExecutions": !exists(json, "agentExecutions") ? void 0 : AgentStatsFromJSON(json["agentExecutions"])
  };
}
function EnvironmentStatsResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "agentExecutions": AgentStatsToJSON(value.agentExecutions)
  };
}

// build/models/EnvironmentStatsResponse.ts
function instanceOfEnvironmentStatsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function EnvironmentStatsResponseFromJSON(json) {
  return EnvironmentStatsResponseFromJSONTyped(json);
}
function EnvironmentStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : EnvironmentStatsResponseDataFromJSON(json["data"])
  };
}
function EnvironmentStatsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": EnvironmentStatsResponseDataToJSON(value.data)
  };
}

// build/models/EnvironmentsResponse.ts
function instanceOfEnvironmentsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function EnvironmentsResponseFromJSON(json) {
  return EnvironmentsResponseFromJSONTyped(json);
}
function EnvironmentsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(EnvironmentFromJSON),
    "pagination": !exists(json, "pagination") ? void 0 : PaginationFromJSON(json["pagination"])
  };
}
function EnvironmentsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(EnvironmentToJSON),
    "pagination": PaginationToJSON(value.pagination)
  };
}

// build/models/ErrorResponseErrorsInner.ts
function instanceOfErrorResponseErrorsInner(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  return isInstance;
}
function ErrorResponseErrorsInnerFromJSON(json) {
  return ErrorResponseErrorsInnerFromJSONTyped(json);
}
function ErrorResponseErrorsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "key": !exists(json, "key") ? void 0 : json["key"],
    "message": json["message"]
  };
}
function ErrorResponseErrorsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "key": value.key,
    "message": value.message
  };
}

// build/models/ErrorResponse.ts
function instanceOfErrorResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ErrorResponseFromJSON(json) {
  return ErrorResponseFromJSONTyped(json);
}
function ErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "errors": !exists(json, "errors") ? void 0 : json["errors"].map(ErrorResponseErrorsInnerFromJSON)
  };
}
function ErrorResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "errors": value.errors === void 0 ? void 0 : value.errors.map(ErrorResponseErrorsInnerToJSON)
  };
}

// build/models/EventConfigAttributesProgress.ts
function instanceOfEventConfigAttributesProgress(value) {
  let isInstance = true;
  return isInstance;
}
function EventConfigAttributesProgressFromJSON(json) {
  return EventConfigAttributesProgressFromJSONTyped(json);
}
function EventConfigAttributesProgressFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "current": !exists(json, "current") ? void 0 : json["current"],
    "total": !exists(json, "total") ? void 0 : json["total"],
    "percent": !exists(json, "percent") ? void 0 : json["percent"]
  };
}
function EventConfigAttributesProgressToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "current": value.current,
    "total": value.total,
    "percent": value.percent
  };
}

// build/models/EventConfigAttributes.ts
function instanceOfEventConfigAttributes(value) {
  let isInstance = true;
  return isInstance;
}
function EventConfigAttributesFromJSON(json) {
  return EventConfigAttributesFromJSONTyped(json);
}
function EventConfigAttributesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "targetUpdatedAt": !exists(json, "targetUpdatedAt") ? void 0 : new Date(json["targetUpdatedAt"]),
    "progress": !exists(json, "progress") ? void 0 : EventConfigAttributesProgressFromJSON(json["progress"])
  };
}
function EventConfigAttributesToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "targetUpdatedAt": value.targetUpdatedAt === void 0 ? void 0 : value.targetUpdatedAt.toISOString(),
    "progress": EventConfigAttributesProgressToJSON(value.progress)
  };
}

// build/models/EventConfigOrigin.ts
function instanceOfEventConfigOrigin(value) {
  let isInstance = true;
  return isInstance;
}
function EventConfigOriginFromJSON(json) {
  return EventConfigOriginFromJSONTyped(json);
}
function EventConfigOriginFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "slug": !exists(json, "slug") ? void 0 : json["slug"]
  };
}
function EventConfigOriginToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "slug": value.slug
  };
}

// build/models/Event.ts
var EventDomainEnum = {
  File: "file",
  Space: "space",
  Workbook: "workbook",
  Job: "job",
  Document: "document",
  Sheet: "sheet",
  Program: "program",
  Secret: "secret",
  Cron: "cron",
  Environment: "environment"
};
function instanceOfEvent(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "domain" in value;
  isInstance = isInstance && "topic" in value;
  isInstance = isInstance && "context" in value;
  isInstance = isInstance && "payload" in value;
  return isInstance;
}
function EventFromJSON(json) {
  return EventFromJSONTyped(json);
}
function EventFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "domain": json["domain"],
    "topic": EventTopicFromJSON(json["topic"]),
    "namespaces": !exists(json, "namespaces") ? void 0 : json["namespaces"],
    "context": ActivityContextFromJSON(json["context"]),
    "attributes": !exists(json, "attributes") ? void 0 : EventConfigAttributesFromJSON(json["attributes"]),
    "payload": json["payload"],
    "callbackUrl": !exists(json, "callbackUrl") ? void 0 : json["callbackUrl"],
    "dataUrl": !exists(json, "dataUrl") ? void 0 : json["dataUrl"],
    "deletedAt": !exists(json, "deletedAt") ? void 0 : new Date(json["deletedAt"]),
    "acknowledgedAt": !exists(json, "acknowledgedAt") ? void 0 : json["acknowledgedAt"] === null ? null : new Date(json["acknowledgedAt"]),
    "acknowledgedBy": !exists(json, "acknowledgedBy") ? void 0 : json["acknowledgedBy"],
    "target": !exists(json, "target") ? void 0 : json["target"],
    "origin": !exists(json, "origin") ? void 0 : EventConfigOriginFromJSON(json["origin"])
  };
}
function EventToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "createdAt": value.createdAt.toISOString(),
    "domain": value.domain,
    "topic": EventTopicToJSON(value.topic),
    "namespaces": value.namespaces,
    "context": ActivityContextToJSON(value.context),
    "attributes": EventConfigAttributesToJSON(value.attributes),
    "payload": value.payload,
    "callbackUrl": value.callbackUrl,
    "dataUrl": value.dataUrl,
    "deletedAt": value.deletedAt === void 0 ? void 0 : value.deletedAt.toISOString(),
    "acknowledgedAt": value.acknowledgedAt === void 0 ? void 0 : value.acknowledgedAt === null ? null : value.acknowledgedAt.toISOString(),
    "acknowledgedBy": value.acknowledgedBy,
    "target": value.target,
    "origin": EventConfigOriginToJSON(value.origin)
  };
}

// build/models/EventConfig.ts
var EventConfigDomainEnum = {
  File: "file",
  Space: "space",
  Workbook: "workbook",
  Job: "job",
  Document: "document",
  Sheet: "sheet",
  Program: "program",
  Secret: "secret",
  Cron: "cron",
  Environment: "environment"
};
function instanceOfEventConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "domain" in value;
  isInstance = isInstance && "topic" in value;
  isInstance = isInstance && "context" in value;
  isInstance = isInstance && "payload" in value;
  return isInstance;
}
function EventConfigFromJSON(json) {
  return EventConfigFromJSONTyped(json);
}
function EventConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "domain": json["domain"],
    "topic": EventTopicFromJSON(json["topic"]),
    "namespaces": !exists(json, "namespaces") ? void 0 : json["namespaces"],
    "context": ActivityContextFromJSON(json["context"]),
    "attributes": !exists(json, "attributes") ? void 0 : EventConfigAttributesFromJSON(json["attributes"]),
    "payload": json["payload"],
    "callbackUrl": !exists(json, "callbackUrl") ? void 0 : json["callbackUrl"],
    "dataUrl": !exists(json, "dataUrl") ? void 0 : json["dataUrl"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "deletedAt": !exists(json, "deletedAt") ? void 0 : new Date(json["deletedAt"]),
    "acknowledgedAt": !exists(json, "acknowledgedAt") ? void 0 : json["acknowledgedAt"] === null ? null : new Date(json["acknowledgedAt"]),
    "acknowledgedBy": !exists(json, "acknowledgedBy") ? void 0 : json["acknowledgedBy"],
    "target": !exists(json, "target") ? void 0 : json["target"],
    "origin": !exists(json, "origin") ? void 0 : EventConfigOriginFromJSON(json["origin"])
  };
}
function EventConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "domain": value.domain,
    "topic": EventTopicToJSON(value.topic),
    "namespaces": value.namespaces,
    "context": ActivityContextToJSON(value.context),
    "attributes": EventConfigAttributesToJSON(value.attributes),
    "payload": value.payload,
    "callbackUrl": value.callbackUrl,
    "dataUrl": value.dataUrl,
    "createdAt": value.createdAt === void 0 ? void 0 : value.createdAt.toISOString(),
    "deletedAt": value.deletedAt === void 0 ? void 0 : value.deletedAt.toISOString(),
    "acknowledgedAt": value.acknowledgedAt === void 0 ? void 0 : value.acknowledgedAt === null ? null : value.acknowledgedAt.toISOString(),
    "acknowledgedBy": value.acknowledgedBy,
    "target": value.target,
    "origin": EventConfigOriginToJSON(value.origin)
  };
}

// build/models/EventResponse.ts
function instanceOfEventResponse(value) {
  let isInstance = true;
  return isInstance;
}
function EventResponseFromJSON(json) {
  return EventResponseFromJSONTyped(json);
}
function EventResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : EventFromJSON(json["data"])
  };
}
function EventResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": EventToJSON(value.data)
  };
}

// build/models/EventToken.ts
function instanceOfEventToken(value) {
  let isInstance = true;
  return isInstance;
}
function EventTokenFromJSON(json) {
  return EventTokenFromJSONTyped(json);
}
function EventTokenFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": !exists(json, "accountId") ? void 0 : json["accountId"],
    "subscribeKey": !exists(json, "subscribeKey") ? void 0 : json["subscribeKey"],
    "ttl": !exists(json, "ttl") ? void 0 : json["ttl"],
    "token": !exists(json, "token") ? void 0 : json["token"]
  };
}
function EventTokenToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "accountId": value.accountId,
    "subscribeKey": value.subscribeKey,
    "ttl": value.ttl,
    "token": value.token
  };
}

// build/models/EventTokenResponse.ts
function instanceOfEventTokenResponse(value) {
  let isInstance = true;
  return isInstance;
}
function EventTokenResponseFromJSON(json) {
  return EventTokenResponseFromJSONTyped(json);
}
function EventTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : EventTokenFromJSON(json["data"])
  };
}
function EventTokenResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": EventTokenToJSON(value.data)
  };
}

// build/models/EventsResponse.ts
function instanceOfEventsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function EventsResponseFromJSON(json) {
  return EventsResponseFromJSONTyped(json);
}
function EventsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(EventFromJSON)
  };
}
function EventsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(EventToJSON)
  };
}

// build/models/ExchangeInvitationRequest.ts
function instanceOfExchangeInvitationRequest(value) {
  let isInstance = true;
  return isInstance;
}
function ExchangeInvitationRequestFromJSON(json) {
  return ExchangeInvitationRequestFromJSONTyped(json);
}
function ExchangeInvitationRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": !exists(json, "token") ? void 0 : json["token"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "spaceId": !exists(json, "spaceId") ? void 0 : json["spaceId"]
  };
}
function ExchangeInvitationRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "token": value.token,
    "email": value.email,
    "spaceId": value.spaceId
  };
}

// build/models/ExchangeTokenResponseData.ts
function instanceOfExchangeTokenResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "valid" in value;
  return isInstance;
}
function ExchangeTokenResponseDataFromJSON(json) {
  return ExchangeTokenResponseDataFromJSONTyped(json);
}
function ExchangeTokenResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "valid": json["valid"],
    "token": !exists(json, "token") ? void 0 : json["token"],
    "sentTo": !exists(json, "sentTo") ? void 0 : json["sentTo"]
  };
}
function ExchangeTokenResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "valid": value.valid,
    "token": value.token,
    "sentTo": value.sentTo
  };
}

// build/models/ExchangeTokenResponse.ts
function instanceOfExchangeTokenResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ExchangeTokenResponseFromJSON(json) {
  return ExchangeTokenResponseFromJSONTyped(json);
}
function ExchangeTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : ExchangeTokenResponseDataFromJSON(json["data"])
  };
}
function ExchangeTokenResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": ExchangeTokenResponseDataToJSON(value.data)
  };
}

// build/models/Execution.ts
function instanceOfExecution(value) {
  let isInstance = true;
  isInstance = isInstance && "eventId" in value;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "completedAt" in value;
  return isInstance;
}
function ExecutionFromJSON(json) {
  return ExecutionFromJSONTyped(json);
}
function ExecutionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "eventId": json["eventId"],
    "success": json["success"],
    "createdAt": json["createdAt"],
    "completedAt": json["completedAt"],
    "duration": !exists(json, "duration") ? void 0 : json["duration"],
    "topic": !exists(json, "topic") ? void 0 : json["topic"]
  };
}
function ExecutionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "eventId": value.eventId,
    "success": value.success,
    "createdAt": value.createdAt,
    "completedAt": value.completedAt,
    "duration": value.duration,
    "topic": value.topic
  };
}

// build/models/ExecutionsResponse.ts
function instanceOfExecutionsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ExecutionsResponseFromJSON(json) {
  return ExecutionsResponseFromJSONTyped(json);
}
function ExecutionsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pagination": !exists(json, "pagination") ? void 0 : PaginationFromJSON(json["pagination"]),
    "data": !exists(json, "data") ? void 0 : json["data"].map(ExecutionFromJSON)
  };
}
function ExecutionsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pagination": PaginationToJSON(value.pagination),
    "data": value.data === void 0 ? void 0 : value.data.map(ExecutionToJSON)
  };
}

// build/models/ExportOptions.ts
function instanceOfExportOptions(value) {
  let isInstance = true;
  return isInstance;
}
function ExportOptionsFromJSON(json) {
  return ExportOptionsFromJSONTyped(json);
}
function ExportOptionsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"],
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "sortField": !exists(json, "sortField") ? void 0 : json["sortField"],
    "sortDirection": !exists(json, "sortDirection") ? void 0 : SortDirectionFromJSON(json["sortDirection"]),
    "filter": !exists(json, "filter") ? void 0 : FilterFromJSON(json["filter"]),
    "filterField": !exists(json, "filterField") ? void 0 : json["filterField"],
    "searchValue": !exists(json, "searchValue") ? void 0 : json["searchValue"],
    "searchField": !exists(json, "searchField") ? void 0 : json["searchField"],
    "q": !exists(json, "q") ? void 0 : json["q"],
    "ids": !exists(json, "ids") ? void 0 : json["ids"]
  };
}
function ExportOptionsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "commitId": value.commitId,
    "versionId": value.versionId,
    "sortField": value.sortField,
    "sortDirection": SortDirectionToJSON(value.sortDirection),
    "filter": FilterToJSON(value.filter),
    "filterField": value.filterField,
    "searchValue": value.searchValue,
    "searchField": value.searchField,
    "q": value.q,
    "ids": value.ids
  };
}

// build/models/ExportJobConfig.ts
function instanceOfExportJobConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "options" in value;
  return isInstance;
}
function ExportJobConfigFromJSON(json) {
  return ExportJobConfigFromJSONTyped(json);
}
function ExportJobConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "options": ExportOptionsFromJSON(json["options"])
  };
}
function ExportJobConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "options": ExportOptionsToJSON(value.options)
  };
}

// build/models/ExternalConstraintAllOf.ts
var ExternalConstraintAllOfTypeEnum = {
  External: "external"
};
function instanceOfExternalConstraintAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "validator" in value;
  return isInstance;
}
function ExternalConstraintAllOfFromJSON(json) {
  return ExternalConstraintAllOfFromJSONTyped(json);
}
function ExternalConstraintAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "validator": json["validator"],
    "config": !exists(json, "config") ? void 0 : json["config"]
  };
}
function ExternalConstraintAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "validator": value.validator,
    "config": value.config
  };
}

// build/models/ExternalSheetConstraintAllOf.ts
var ExternalSheetConstraintAllOfTypeEnum = {
  External: "external"
};
function instanceOfExternalSheetConstraintAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function ExternalSheetConstraintAllOfFromJSON(json) {
  return ExternalSheetConstraintAllOfFromJSONTyped(json);
}
function ExternalSheetConstraintAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "fields": !exists(json, "fields") ? void 0 : json["fields"],
    "config": !exists(json, "config") ? void 0 : json["config"],
    "validator": !exists(json, "validator") ? void 0 : json["validator"]
  };
}
function ExternalSheetConstraintAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "fields": value.fields,
    "config": value.config,
    "validator": value.validator
  };
}

// build/models/FieldConfigResponse.ts
function instanceOfFieldConfigResponse(value) {
  let isInstance = true;
  return isInstance;
}
function FieldConfigResponseFromJSON(json) {
  return FieldConfigResponseFromJSONTyped(json);
}
function FieldConfigResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : FieldConfigFromJSON(json["data"])
  };
}
function FieldConfigResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": FieldConfigToJSON(value.data)
  };
}

// build/models/FileMode.ts
var FileMode = {
  Import: "import",
  Export: "export"
};
function FileModeFromJSON(json) {
  return FileModeFromJSONTyped(json);
}
function FileModeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function FileModeToJSON(value) {
  return value;
}

// build/models/ModelFileStatusEnum.ts
var ModelFileStatusEnum = {
  Partial: "partial",
  Complete: "complete",
  Archived: "archived",
  Purged: "purged",
  Failed: "failed"
};
function ModelFileStatusEnumFromJSON(json) {
  return ModelFileStatusEnumFromJSONTyped(json);
}
function ModelFileStatusEnumFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ModelFileStatusEnumToJSON(value) {
  return value;
}

// build/models/FileConfig.ts
function instanceOfFileConfig(value) {
  let isInstance = true;
  return isInstance;
}
function FileConfigFromJSON(json) {
  return FileConfigFromJSONTyped(json);
}
function FileConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workbookId": !exists(json, "workbookId") ? void 0 : json["workbookId"],
    "mode": !exists(json, "mode") ? void 0 : FileModeFromJSON(json["mode"]),
    "status": !exists(json, "status") ? void 0 : ModelFileStatusEnumFromJSON(json["status"]),
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "name": !exists(json, "name") ? void 0 : json["name"]
  };
}
function FileConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "workbookId": value.workbookId,
    "mode": FileModeToJSON(value.mode),
    "status": ModelFileStatusEnumToJSON(value.status),
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "name": value.name
  };
}

// build/models/FileJobConfig.ts
var FileJobConfigDriverEnum = {
  Csv: "csv"
};
function instanceOfFileJobConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "driver" in value;
  return isInstance;
}
function FileJobConfigFromJSON(json) {
  return FileJobConfigFromJSONTyped(json);
}
function FileJobConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "driver": json["driver"],
    "options": !exists(json, "options") ? void 0 : json["options"],
    "detectedHeaderRow": !exists(json, "detectedHeaderRow") ? void 0 : json["detectedHeaderRow"]
  };
}
function FileJobConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "driver": value.driver,
    "options": value.options,
    "detectedHeaderRow": value.detectedHeaderRow
  };
}

// build/models/FileOrigin.ts
var FileOrigin = {
  Filesystem: "filesystem",
  Googledrive: "googledrive",
  Box: "box",
  Onedrive: "onedrive"
};
function FileOriginFromJSON(json) {
  return FileOriginFromJSONTyped(json);
}
function FileOriginFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function FileOriginToJSON(value) {
  return value;
}

// build/models/FileResponse.ts
function instanceOfFileResponse(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FileResponseFromJSON(json) {
  return FileResponseFromJSONTyped(json);
}
function FileResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"]
  };
}
function FileResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data
  };
}

// build/models/FilesResponse.ts
function instanceOfFilesResponse(value) {
  let isInstance = true;
  return isInstance;
}
function FilesResponseFromJSON(json) {
  return FilesResponseFromJSONTyped(json);
}
function FilesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pagination": !exists(json, "pagination") ? void 0 : PaginationFromJSON(json["pagination"]),
    "data": !exists(json, "data") ? void 0 : json["data"]
  };
}
function FilesResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pagination": PaginationToJSON(value.pagination),
    "data": value.data
  };
}

// build/models/FindAndReplaceJobConfig.ts
function instanceOfFindAndReplaceJobConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "find" in value;
  isInstance = isInstance && "replace" in value;
  isInstance = isInstance && "fieldKey" in value;
  return isInstance;
}
function FindAndReplaceJobConfigFromJSON(json) {
  return FindAndReplaceJobConfigFromJSONTyped(json);
}
function FindAndReplaceJobConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "filter": !exists(json, "filter") ? void 0 : FilterFromJSON(json["filter"]),
    "filterField": !exists(json, "filterField") ? void 0 : json["filterField"],
    "q": !exists(json, "q") ? void 0 : json["q"],
    "searchValue": !exists(json, "searchValue") ? void 0 : json["searchValue"],
    "searchField": !exists(json, "searchField") ? void 0 : json["searchField"],
    "ids": !exists(json, "ids") ? void 0 : json["ids"],
    "find": ValueFromJSON(json["find"]),
    "replace": ValueFromJSON(json["replace"]),
    "fieldKey": json["fieldKey"]
  };
}
function FindAndReplaceJobConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "filter": FilterToJSON(value.filter),
    "filterField": value.filterField,
    "q": value.q,
    "searchValue": value.searchValue,
    "searchField": value.searchField,
    "ids": value.ids,
    "find": ValueToJSON(value.find),
    "replace": ValueToJSON(value.replace),
    "fieldKey": value.fieldKey
  };
}

// build/models/FindAndReplaceRequest.ts
function instanceOfFindAndReplaceRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "find" in value;
  isInstance = isInstance && "replace" in value;
  isInstance = isInstance && "fieldKey" in value;
  return isInstance;
}
function FindAndReplaceRequestFromJSON(json) {
  return FindAndReplaceRequestFromJSONTyped(json);
}
function FindAndReplaceRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "find": ValueFromJSON(json["find"]),
    "replace": ValueFromJSON(json["replace"]),
    "fieldKey": json["fieldKey"]
  };
}
function FindAndReplaceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "find": ValueToJSON(value.find),
    "replace": ValueToJSON(value.replace),
    "fieldKey": value.fieldKey
  };
}

// build/models/FronteggUser.ts
function instanceOfFronteggUser(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "tenantId" in value;
  return isInstance;
}
function FronteggUserFromJSON(json) {
  return FronteggUserFromJSONTyped(json);
}
function FronteggUserFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "email": json["email"],
    "verified": !exists(json, "verified") ? void 0 : json["verified"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "provider": !exists(json, "provider") ? void 0 : json["provider"],
    "tenantId": json["tenantId"],
    "tenantIds": !exists(json, "tenantIds") ? void 0 : json["tenantIds"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"]
  };
}
function FronteggUserToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "email": value.email,
    "verified": value.verified,
    "name": value.name,
    "provider": value.provider,
    "tenantId": value.tenantId,
    "tenantIds": value.tenantIds,
    "metadata": value.metadata
  };
}

// build/models/FronteggSignup.ts
function instanceOfFronteggSignup(value) {
  let isInstance = true;
  isInstance = isInstance && "user" in value;
  return isInstance;
}
function FronteggSignupFromJSON(json) {
  return FronteggSignupFromJSONTyped(json);
}
function FronteggSignupFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "user": FronteggUserFromJSON(json["user"])
  };
}
function FronteggSignupToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user": FronteggUserToJSON(value.user)
  };
}

// build/models/GenerateMutationConfig.ts
function instanceOfGenerateMutationConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "sheetId" in value;
  isInstance = isInstance && "command" in value;
  return isInstance;
}
function GenerateMutationConfigFromJSON(json) {
  return GenerateMutationConfigFromJSONTyped(json);
}
function GenerateMutationConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sheetId": json["sheetId"],
    "model": !exists(json, "model") ? void 0 : json["model"],
    "modelParams": !exists(json, "modelParams") ? void 0 : json["modelParams"],
    "command": json["command"],
    "templateVariables": !exists(json, "templateVariables") ? void 0 : json["templateVariables"]
  };
}
function GenerateMutationConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sheetId": value.sheetId,
    "model": value.model,
    "modelParams": value.modelParams,
    "command": value.command,
    "templateVariables": value.templateVariables
  };
}

// build/models/GenerateQueryConfig.ts
function instanceOfGenerateQueryConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "sheetId" in value;
  isInstance = isInstance && "command" in value;
  return isInstance;
}
function GenerateQueryConfigFromJSON(json) {
  return GenerateQueryConfigFromJSONTyped(json);
}
function GenerateQueryConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sheetId": json["sheetId"],
    "model": !exists(json, "model") ? void 0 : json["model"],
    "modelParams": !exists(json, "modelParams") ? void 0 : json["modelParams"],
    "command": json["command"],
    "queryType": !exists(json, "queryType") ? void 0 : json["queryType"],
    "templateVariables": !exists(json, "templateVariables") ? void 0 : json["templateVariables"]
  };
}
function GenerateQueryConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sheetId": value.sheetId,
    "model": value.model,
    "modelParams": value.modelParams,
    "command": value.command,
    "queryType": value.queryType,
    "templateVariables": value.templateVariables
  };
}

// build/models/GeneratedMutationMetadata.ts
function instanceOfGeneratedMutationMetadata(value) {
  let isInstance = true;
  isInstance = isInstance && "explain" in value;
  return isInstance;
}
function GeneratedMutationMetadataFromJSON(json) {
  return GeneratedMutationMetadataFromJSONTyped(json);
}
function GeneratedMutationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "explain": json["explain"]
  };
}
function GeneratedMutationMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "explain": value.explain
  };
}

// build/models/GeneratedMutation.ts
function instanceOfGeneratedMutation(value) {
  let isInstance = true;
  isInstance = isInstance && "mutateRecord" in value;
  isInstance = isInstance && "metadata" in value;
  isInstance = isInstance && "mutationId" in value;
  return isInstance;
}
function GeneratedMutationFromJSON(json) {
  return GeneratedMutationFromJSONTyped(json);
}
function GeneratedMutationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "mutateRecord": json["mutateRecord"],
    "metadata": GeneratedMutationMetadataFromJSON(json["metadata"]),
    "mutationId": json["mutationId"]
  };
}
function GeneratedMutationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "mutateRecord": value.mutateRecord,
    "metadata": GeneratedMutationMetadataToJSON(value.metadata),
    "mutationId": value.mutationId
  };
}

// build/models/GeneratedMutationResponse.ts
function instanceOfGeneratedMutationResponse(value) {
  let isInstance = true;
  return isInstance;
}
function GeneratedMutationResponseFromJSON(json) {
  return GeneratedMutationResponseFromJSONTyped(json);
}
function GeneratedMutationResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : GeneratedMutationFromJSON(json["data"])
  };
}
function GeneratedMutationResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": GeneratedMutationToJSON(value.data)
  };
}

// build/models/GeneratedQueryMetadata.ts
function instanceOfGeneratedQueryMetadata(value) {
  let isInstance = true;
  isInstance = isInstance && "explain" in value;
  return isInstance;
}
function GeneratedQueryMetadataFromJSON(json) {
  return GeneratedQueryMetadataFromJSONTyped(json);
}
function GeneratedQueryMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "explain": json["explain"]
  };
}
function GeneratedQueryMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "explain": value.explain
  };
}

// build/models/GeneratedQuery.ts
function instanceOfGeneratedQuery(value) {
  let isInstance = true;
  isInstance = isInstance && "query" in value;
  isInstance = isInstance && "queryType" in value;
  isInstance = isInstance && "metadata" in value;
  isInstance = isInstance && "queryId" in value;
  return isInstance;
}
function GeneratedQueryFromJSON(json) {
  return GeneratedQueryFromJSONTyped(json);
}
function GeneratedQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "query": json["query"],
    "queryType": json["queryType"],
    "metadata": GeneratedQueryMetadataFromJSON(json["metadata"]),
    "queryId": json["queryId"]
  };
}
function GeneratedQueryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "query": value.query,
    "queryType": value.queryType,
    "metadata": GeneratedQueryMetadataToJSON(value.metadata),
    "queryId": value.queryId
  };
}

// build/models/GeneratedQueryResponse.ts
function instanceOfGeneratedQueryResponse(value) {
  let isInstance = true;
  return isInstance;
}
function GeneratedQueryResponseFromJSON(json) {
  return GeneratedQueryResponseFromJSONTyped(json);
}
function GeneratedQueryResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : GeneratedQueryFromJSON(json["data"])
  };
}
function GeneratedQueryResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": GeneratedQueryToJSON(value.data)
  };
}

// build/models/GetCommitResponse.ts
function instanceOfGetCommitResponse(value) {
  let isInstance = true;
  return isInstance;
}
function GetCommitResponseFromJSON(json) {
  return GetCommitResponseFromJSONTyped(json);
}
function GetCommitResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : CommitFromJSON(json["data"])
  };
}
function GetCommitResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": CommitToJSON(value.data)
  };
}

// build/models/GetDatabaseDataTask.ts
function instanceOfGetDatabaseDataTask(value) {
  let isInstance = true;
  return isInstance;
}
function GetDatabaseDataTaskFromJSON(json) {
  return GetDatabaseDataTaskFromJSONTyped(json);
}
function GetDatabaseDataTaskFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "status": !exists(json, "status") ? void 0 : json["status"],
    "type": !exists(json, "type") ? void 0 : json["type"],
    "progress": !exists(json, "progress") ? void 0 : json["progress"]
  };
}
function GetDatabaseDataTaskToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "status": value.status,
    "type": value.type,
    "progress": value.progress
  };
}

// build/models/GetDatabaseData.ts
function instanceOfGetDatabaseData(value) {
  let isInstance = true;
  return isInstance;
}
function GetDatabaseDataFromJSON(json) {
  return GetDatabaseDataFromJSONTyped(json);
}
function GetDatabaseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "task": !exists(json, "task") ? void 0 : GetDatabaseDataTaskFromJSON(json["task"])
  };
}
function GetDatabaseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "task": GetDatabaseDataTaskToJSON(value.task)
  };
}

// build/models/GetDatabaseResponseResponse.ts
function instanceOfGetDatabaseResponseResponse(value) {
  let isInstance = true;
  return isInstance;
}
function GetDatabaseResponseResponseFromJSON(json) {
  return GetDatabaseResponseResponseFromJSONTyped(json);
}
function GetDatabaseResponseResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : GetDatabaseDataFromJSON(json["data"])
  };
}
function GetDatabaseResponseResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": GetDatabaseDataToJSON(value.data)
  };
}

// build/models/GetEnumWeightsRequest.ts
function instanceOfGetEnumWeightsRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "sourceField" in value;
  isInstance = isInstance && "sourceValues" in value;
  isInstance = isInstance && "destinationField" in value;
  isInstance = isInstance && "destinationValues" in value;
  return isInstance;
}
function GetEnumWeightsRequestFromJSON(json) {
  return GetEnumWeightsRequestFromJSONTyped(json);
}
function GetEnumWeightsRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sourceField": json["sourceField"],
    "sourceValues": json["sourceValues"],
    "destinationField": json["destinationField"],
    "destinationValues": json["destinationValues"]
  };
}
function GetEnumWeightsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sourceField": value.sourceField,
    "sourceValues": value.sourceValues,
    "destinationField": value.destinationField,
    "destinationValues": value.destinationValues
  };
}

// build/models/GetFieldWeightsRequest.ts
function instanceOfGetFieldWeightsRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "sourceFields" in value;
  isInstance = isInstance && "destinationFields" in value;
  return isInstance;
}
function GetFieldWeightsRequestFromJSON(json) {
  return GetFieldWeightsRequestFromJSONTyped(json);
}
function GetFieldWeightsRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sourceFields": json["sourceFields"],
    "destinationFields": json["destinationFields"]
  };
}
function GetFieldWeightsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sourceFields": value.sourceFields,
    "destinationFields": value.destinationFields
  };
}

// build/models/RecordsWithLinks.ts
function instanceOfRecordsWithLinks(value) {
  let isInstance = true;
  return isInstance;
}
function RecordsWithLinksFromJSON(json) {
  return RecordsWithLinksFromJSONTyped(json);
}
function RecordsWithLinksFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function RecordsWithLinksToJSON(value) {
  return value;
}

// build/models/GetRecordsResponseData.ts
function instanceOfGetRecordsResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "records" in value;
  return isInstance;
}
function GetRecordsResponseDataFromJSON(json) {
  return GetRecordsResponseDataFromJSONTyped(json);
}
function GetRecordsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "records": RecordsWithLinksFromJSON(json["records"]),
    "counts": !exists(json, "counts") ? void 0 : RecordCountsFromJSON(json["counts"]),
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"]
  };
}
function GetRecordsResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "records": RecordsWithLinksToJSON(value.records),
    "counts": RecordCountsToJSON(value.counts),
    "versionId": value.versionId,
    "commitId": value.commitId
  };
}

// build/models/GetRecordsResponse.ts
function instanceOfGetRecordsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function GetRecordsResponseFromJSON(json) {
  return GetRecordsResponseFromJSONTyped(json);
}
function GetRecordsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : GetRecordsResponseDataFromJSON(json["data"])
  };
}
function GetRecordsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": GetRecordsResponseDataToJSON(value.data)
  };
}

// build/models/GetRecordsResponseDataAllOf.ts
function instanceOfGetRecordsResponseDataAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "records" in value;
  return isInstance;
}
function GetRecordsResponseDataAllOfFromJSON(json) {
  return GetRecordsResponseDataAllOfFromJSONTyped(json);
}
function GetRecordsResponseDataAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "records": RecordsWithLinksFromJSON(json["records"]),
    "counts": !exists(json, "counts") ? void 0 : RecordCountsFromJSON(json["counts"]),
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"]
  };
}
function GetRecordsResponseDataAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "records": RecordsWithLinksToJSON(value.records),
    "counts": RecordCountsToJSON(value.counts),
    "versionId": value.versionId,
    "commitId": value.commitId
  };
}

// build/models/GetSheetCommitsResponse.ts
function instanceOfGetSheetCommitsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function GetSheetCommitsResponseFromJSON(json) {
  return GetSheetCommitsResponseFromJSONTyped(json);
}
function GetSheetCommitsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(CommitFromJSON)
  };
}
function GetSheetCommitsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(CommitToJSON)
  };
}

// build/models/GetSpaceActivitySortField.ts
var GetSpaceActivitySortField = {
  Activity: "activity",
  CreatedAt: "created_at"
};
function GetSpaceActivitySortFieldFromJSON(json) {
  return GetSpaceActivitySortFieldFromJSONTyped(json);
}
function GetSpaceActivitySortFieldFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function GetSpaceActivitySortFieldToJSON(value) {
  return value;
}

// build/models/GetSpacesSortField.ts
var GetSpacesSortField = {
  Name: "name",
  WorkbooksCount: "workbooksCount",
  FilesCount: "filesCount",
  EnvironmentId: "environmentId",
  CreatedByUserName: "createdByUserName",
  CreatedAt: "createdAt",
  LastActivityAt: "lastActivityAt"
};
function GetSpacesSortFieldFromJSON(json) {
  return GetSpacesSortFieldFromJSONTyped(json);
}
function GetSpacesSortFieldFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function GetSpacesSortFieldToJSON(value) {
  return value;
}

// build/models/GetUserResponse.ts
function instanceOfGetUserResponse(value) {
  let isInstance = true;
  return isInstance;
}
function GetUserResponseFromJSON(json) {
  return GetUserResponseFromJSONTyped(json);
}
function GetUserResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : DBUserFromJSON(json["data"])
  };
}
function GetUserResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": DBUserToJSON(value.data)
  };
}

// build/models/GetWorkbookCommitsResponse.ts
function instanceOfGetWorkbookCommitsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function GetWorkbookCommitsResponseFromJSON(json) {
  return GetWorkbookCommitsResponseFromJSONTyped(json);
}
function GetWorkbookCommitsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(CommitFromJSON)
  };
}
function GetWorkbookCommitsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(CommitToJSON)
  };
}

// build/models/GuestConfigSpacesInnerWorkbooksInner.ts
function instanceOfGuestConfigSpacesInnerWorkbooksInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function GuestConfigSpacesInnerWorkbooksInnerFromJSON(json) {
  return GuestConfigSpacesInnerWorkbooksInnerFromJSONTyped(json);
}
function GuestConfigSpacesInnerWorkbooksInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"]
  };
}
function GuestConfigSpacesInnerWorkbooksInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id
  };
}

// build/models/GuestConfigSpacesInner.ts
function instanceOfGuestConfigSpacesInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function GuestConfigSpacesInnerFromJSON(json) {
  return GuestConfigSpacesInnerFromJSONTyped(json);
}
function GuestConfigSpacesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "workbooks": !exists(json, "workbooks") ? void 0 : json["workbooks"].map(GuestConfigSpacesInnerWorkbooksInnerFromJSON),
    "lastAccessed": !exists(json, "lastAccessed") ? void 0 : new Date(json["lastAccessed"])
  };
}
function GuestConfigSpacesInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "workbooks": value.workbooks === void 0 ? void 0 : value.workbooks.map(GuestConfigSpacesInnerWorkbooksInnerToJSON),
    "lastAccessed": value.lastAccessed === void 0 ? void 0 : value.lastAccessed.toISOString()
  };
}

// build/models/Guest.ts
function instanceOfGuest(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "updatedAt" in value;
  isInstance = isInstance && "environmentId" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "spaces" in value;
  return isInstance;
}
function GuestFromJSON(json) {
  return GuestFromJSONTyped(json);
}
function GuestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "environmentId": json["environmentId"],
    "email": json["email"],
    "name": json["name"],
    "spaces": json["spaces"].map(GuestConfigSpacesInnerFromJSON)
  };
}
function GuestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString(),
    "environmentId": value.environmentId,
    "email": value.email,
    "name": value.name,
    "spaces": value.spaces.map(GuestConfigSpacesInnerToJSON)
  };
}

// build/models/GuestConfig.ts
function instanceOfGuestConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "environmentId" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "spaces" in value;
  return isInstance;
}
function GuestConfigFromJSON(json) {
  return GuestConfigFromJSONTyped(json);
}
function GuestConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "environmentId": json["environmentId"],
    "email": json["email"],
    "name": json["name"],
    "spaces": json["spaces"].map(GuestConfigSpacesInnerFromJSON)
  };
}
function GuestConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "environmentId": value.environmentId,
    "email": value.email,
    "name": value.name,
    "spaces": value.spaces.map(GuestConfigSpacesInnerToJSON)
  };
}

// build/models/GuestConfigUpdate.ts
function instanceOfGuestConfigUpdate(value) {
  let isInstance = true;
  return isInstance;
}
function GuestConfigUpdateFromJSON(json) {
  return GuestConfigUpdateFromJSONTyped(json);
}
function GuestConfigUpdateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "spaces": !exists(json, "spaces") ? void 0 : json["spaces"].map(GuestConfigSpacesInnerFromJSON)
  };
}
function GuestConfigUpdateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "environmentId": value.environmentId,
    "email": value.email,
    "name": value.name,
    "spaces": value.spaces === void 0 ? void 0 : value.spaces.map(GuestConfigSpacesInnerToJSON)
  };
}

// build/models/GuestResponse.ts
function instanceOfGuestResponse(value) {
  let isInstance = true;
  return isInstance;
}
function GuestResponseFromJSON(json) {
  return GuestResponseFromJSONTyped(json);
}
function GuestResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : GuestFromJSON(json["data"])
  };
}
function GuestResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": GuestToJSON(value.data)
  };
}

// build/models/GuestsResponse.ts
function instanceOfGuestsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function GuestsResponseFromJSON(json) {
  return GuestsResponseFromJSONTyped(json);
}
function GuestsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(GuestFromJSON)
  };
}
function GuestsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(GuestToJSON)
  };
}

// build/models/HasAllValidConstraintAllOf.ts
var HasAllValidConstraintAllOfTypeEnum = {
  HasAllValid: "hasAllValid"
};
function instanceOfHasAllValidConstraintAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function HasAllValidConstraintAllOfFromJSON(json) {
  return HasAllValidConstraintAllOfFromJSONTyped(json);
}
function HasAllValidConstraintAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"]
  };
}
function HasAllValidConstraintAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/HasDataConstraintAllOf.ts
var HasDataConstraintAllOfTypeEnum = {
  HasData: "hasData"
};
function instanceOfHasDataConstraintAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function HasDataConstraintAllOfFromJSON(json) {
  return HasDataConstraintAllOfFromJSONTyped(json);
}
function HasDataConstraintAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"]
  };
}
function HasDataConstraintAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/HasSelectionConstraintAllOf.ts
var HasSelectionConstraintAllOfTypeEnum = {
  HasSelection: "hasSelection"
};
function instanceOfHasSelectionConstraintAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function HasSelectionConstraintAllOfFromJSON(json) {
  return HasSelectionConstraintAllOfFromJSONTyped(json);
}
function HasSelectionConstraintAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"]
  };
}
function HasSelectionConstraintAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/HealthResponse.ts
function instanceOfHealthResponse(value) {
  let isInstance = true;
  return isInstance;
}
function HealthResponseFromJSON(json) {
  return HealthResponseFromJSONTyped(json);
}
function HealthResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "status": !exists(json, "status") ? void 0 : json["status"]
  };
}
function HealthResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "status": value.status
  };
}

// build/models/InviteGuestsRequestInner.ts
function instanceOfInviteGuestsRequestInner(value) {
  let isInstance = true;
  isInstance = isInstance && "guestId" in value;
  isInstance = isInstance && "spaceId" in value;
  return isInstance;
}
function InviteGuestsRequestInnerFromJSON(json) {
  return InviteGuestsRequestInnerFromJSONTyped(json);
}
function InviteGuestsRequestInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "guestId": json["guestId"],
    "spaceId": json["spaceId"],
    "fromName": !exists(json, "fromName") ? void 0 : json["fromName"],
    "message": !exists(json, "message") ? void 0 : json["message"]
  };
}
function InviteGuestsRequestInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "guestId": value.guestId,
    "spaceId": value.spaceId,
    "fromName": value.fromName,
    "message": value.message
  };
}

// build/models/MappingProgramJobConfig.ts
function instanceOfMappingProgramJobConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "sourceSheetId" in value;
  isInstance = isInstance && "destinationSheetId" in value;
  isInstance = isInstance && "mappingRules" in value;
  return isInstance;
}
function MappingProgramJobConfigFromJSON(json) {
  return MappingProgramJobConfigFromJSONTyped(json);
}
function MappingProgramJobConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sourceSheetId": json["sourceSheetId"],
    "destinationSheetId": json["destinationSheetId"],
    "mappingRules": json["mappingRules"]
  };
}
function MappingProgramJobConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sourceSheetId": value.sourceSheetId,
    "destinationSheetId": value.destinationSheetId,
    "mappingRules": value.mappingRules
  };
}

// build/models/MutateJobConfig.ts
function instanceOfMutateJobConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "sheetId" in value;
  isInstance = isInstance && "mutateRecord" in value;
  return isInstance;
}
function MutateJobConfigFromJSON(json) {
  return MutateJobConfigFromJSONTyped(json);
}
function MutateJobConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sheetId": json["sheetId"],
    "snapshotLabel": !exists(json, "snapshotLabel") ? void 0 : json["snapshotLabel"],
    "snapshotId": !exists(json, "snapshotId") ? void 0 : json["snapshotId"],
    "mutateRecord": json["mutateRecord"],
    "mutationId": !exists(json, "mutationId") ? void 0 : json["mutationId"],
    "filter": !exists(json, "filter") ? void 0 : FilterFromJSON(json["filter"]),
    "filterField": !exists(json, "filterField") ? void 0 : json["filterField"],
    "searchValue": !exists(json, "searchValue") ? void 0 : json["searchValue"],
    "searchField": !exists(json, "searchField") ? void 0 : json["searchField"],
    "q": !exists(json, "q") ? void 0 : json["q"],
    "ids": !exists(json, "ids") ? void 0 : json["ids"]
  };
}
function MutateJobConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sheetId": value.sheetId,
    "snapshotLabel": value.snapshotLabel,
    "snapshotId": value.snapshotId,
    "mutateRecord": value.mutateRecord,
    "mutationId": value.mutationId,
    "filter": FilterToJSON(value.filter),
    "filterField": value.filterField,
    "searchValue": value.searchValue,
    "searchField": value.searchField,
    "q": value.q,
    "ids": value.ids
  };
}

// build/models/PipelineJobConfig.ts
function instanceOfPipelineJobConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "sourceSheetId" in value;
  isInstance = isInstance && "destinationSheetId" in value;
  return isInstance;
}
function PipelineJobConfigFromJSON(json) {
  return PipelineJobConfigFromJSONTyped(json);
}
function PipelineJobConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sourceSheetId": json["sourceSheetId"],
    "destinationSheetId": json["destinationSheetId"]
  };
}
function PipelineJobConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sourceSheetId": value.sourceSheetId,
    "destinationSheetId": value.destinationSheetId
  };
}

// build/models/JobConfigConfig.ts
function JobConfigConfigFromJSON(json) {
  return JobConfigConfigFromJSONTyped(json);
}
function JobConfigConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return { ...DeleteRecordsJobConfigFromJSONTyped(json), ...ExportJobConfigFromJSONTyped(json), ...FileJobConfigFromJSONTyped(json), ...FindAndReplaceJobConfigFromJSONTyped(json), ...MappingProgramJobConfigFromJSONTyped(json), ...MutateJobConfigFromJSONTyped(json), ...PipelineJobConfigFromJSONTyped(json) };
}
function JobConfigConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  if (instanceOfDeleteRecordsJobConfig(value)) {
    return DeleteRecordsJobConfigToJSON(value);
  }
  if (instanceOfExportJobConfig(value)) {
    return ExportJobConfigToJSON(value);
  }
  if (instanceOfFileJobConfig(value)) {
    return FileJobConfigToJSON(value);
  }
  if (instanceOfFindAndReplaceJobConfig(value)) {
    return FindAndReplaceJobConfigToJSON(value);
  }
  if (instanceOfMappingProgramJobConfig(value)) {
    return MappingProgramJobConfigToJSON(value);
  }
  if (instanceOfMutateJobConfig(value)) {
    return MutateJobConfigToJSON(value);
  }
  if (instanceOfPipelineJobConfig(value)) {
    return PipelineJobConfigToJSON(value);
  }
  return {};
}

// build/models/JobOutcomeNextDownload.ts
var JobOutcomeNextDownloadTypeEnum = {
  Download: "download"
};
function instanceOfJobOutcomeNextDownload(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "url" in value;
  return isInstance;
}
function JobOutcomeNextDownloadFromJSON(json) {
  return JobOutcomeNextDownloadFromJSONTyped(json);
}
function JobOutcomeNextDownloadFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "url": json["url"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "fileName": !exists(json, "fileName") ? void 0 : json["fileName"]
  };
}
function JobOutcomeNextDownloadToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "url": value.url,
    "label": value.label,
    "fileName": value.fileName
  };
}

// build/models/JobOutcomeNextFilesFilesInner.ts
function instanceOfJobOutcomeNextFilesFilesInner(value) {
  let isInstance = true;
  isInstance = isInstance && "fileId" in value;
  return isInstance;
}
function JobOutcomeNextFilesFilesInnerFromJSON(json) {
  return JobOutcomeNextFilesFilesInnerFromJSONTyped(json);
}
function JobOutcomeNextFilesFilesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fileId": json["fileId"],
    "fileName": !exists(json, "fileName") ? void 0 : json["fileName"]
  };
}
function JobOutcomeNextFilesFilesInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fileId": value.fileId,
    "fileName": value.fileName
  };
}

// build/models/JobOutcomeNextFiles.ts
var JobOutcomeNextFilesTypeEnum = {
  Files: "files"
};
function instanceOfJobOutcomeNextFiles(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function JobOutcomeNextFilesFromJSON(json) {
  return JobOutcomeNextFilesFromJSONTyped(json);
}
function JobOutcomeNextFilesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "files": !exists(json, "files") ? void 0 : json["files"].map(JobOutcomeNextFilesFilesInnerFromJSON),
    "label": !exists(json, "label") ? void 0 : json["label"]
  };
}
function JobOutcomeNextFilesToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "files": value.files === void 0 ? void 0 : value.files.map(JobOutcomeNextFilesFilesInnerToJSON),
    "label": value.label
  };
}

// build/models/JobOutcomeNextId.ts
var JobOutcomeNextIdTypeEnum = {
  Id: "id"
};
function instanceOfJobOutcomeNextId(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function JobOutcomeNextIdFromJSON(json) {
  return JobOutcomeNextIdFromJSONTyped(json);
}
function JobOutcomeNextIdFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "id": json["id"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "path": !exists(json, "path") ? void 0 : json["path"],
    "query": !exists(json, "query") ? void 0 : json["query"]
  };
}
function JobOutcomeNextIdToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "id": value.id,
    "label": value.label,
    "path": value.path,
    "query": value.query
  };
}

// build/models/JobOutcomeNextRetry.ts
var JobOutcomeNextRetryTypeEnum = {
  Retry: "retry"
};
function instanceOfJobOutcomeNextRetry(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function JobOutcomeNextRetryFromJSON(json) {
  return JobOutcomeNextRetryFromJSONTyped(json);
}
function JobOutcomeNextRetryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"]
  };
}
function JobOutcomeNextRetryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "label": value.label
  };
}

// build/models/JobOutcomeNextSnapshot.ts
var JobOutcomeNextSnapshotTypeEnum = {
  Snapshot: "snapshot"
};
function instanceOfJobOutcomeNextSnapshot(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "snapshotId" in value;
  isInstance = isInstance && "sheetId" in value;
  return isInstance;
}
function JobOutcomeNextSnapshotFromJSON(json) {
  return JobOutcomeNextSnapshotFromJSONTyped(json);
}
function JobOutcomeNextSnapshotFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "snapshotId": json["snapshotId"],
    "sheetId": json["sheetId"]
  };
}
function JobOutcomeNextSnapshotToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "snapshotId": value.snapshotId,
    "sheetId": value.sheetId
  };
}

// build/models/JobOutcomeNextUrl.ts
var JobOutcomeNextUrlTypeEnum = {
  Url: "url"
};
function instanceOfJobOutcomeNextUrl(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "url" in value;
  return isInstance;
}
function JobOutcomeNextUrlFromJSON(json) {
  return JobOutcomeNextUrlFromJSONTyped(json);
}
function JobOutcomeNextUrlFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "url": json["url"],
    "label": !exists(json, "label") ? void 0 : json["label"]
  };
}
function JobOutcomeNextUrlToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "url": value.url,
    "label": value.label
  };
}

// build/models/JobOutcomeNextView.ts
var JobOutcomeNextViewTypeEnum = {
  View: "view"
};
function instanceOfJobOutcomeNextView(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "hiddenColumns" in value;
  isInstance = isInstance && "sheetId" in value;
  return isInstance;
}
function JobOutcomeNextViewFromJSON(json) {
  return JobOutcomeNextViewFromJSONTyped(json);
}
function JobOutcomeNextViewFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "hiddenColumns": json["hiddenColumns"],
    "sheetId": json["sheetId"]
  };
}
function JobOutcomeNextViewToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "label": value.label,
    "hiddenColumns": value.hiddenColumns,
    "sheetId": value.sheetId
  };
}

// build/models/JobOutcomeNextWait.ts
var JobOutcomeNextWaitTypeEnum = {
  Wait: "wait"
};
function instanceOfJobOutcomeNextWait(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function JobOutcomeNextWaitFromJSON(json) {
  return JobOutcomeNextWaitFromJSONTyped(json);
}
function JobOutcomeNextWaitFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function JobOutcomeNextWaitToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/JobOutcomeNext.ts
function JobOutcomeNextFromJSON(json) {
  return JobOutcomeNextFromJSONTyped(json);
}
function JobOutcomeNextFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return { ...JobOutcomeNextDownloadFromJSONTyped(json), ...JobOutcomeNextFilesFromJSONTyped(json), ...JobOutcomeNextIdFromJSONTyped(json), ...JobOutcomeNextRetryFromJSONTyped(json), ...JobOutcomeNextSnapshotFromJSONTyped(json), ...JobOutcomeNextUrlFromJSONTyped(json), ...JobOutcomeNextViewFromJSONTyped(json), ...JobOutcomeNextWaitFromJSONTyped(json) };
}
function JobOutcomeNextToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  if (instanceOfJobOutcomeNextDownload(value)) {
    return JobOutcomeNextDownloadToJSON(value);
  }
  if (instanceOfJobOutcomeNextFiles(value)) {
    return JobOutcomeNextFilesToJSON(value);
  }
  if (instanceOfJobOutcomeNextId(value)) {
    return JobOutcomeNextIdToJSON(value);
  }
  if (instanceOfJobOutcomeNextRetry(value)) {
    return JobOutcomeNextRetryToJSON(value);
  }
  if (instanceOfJobOutcomeNextSnapshot(value)) {
    return JobOutcomeNextSnapshotToJSON(value);
  }
  if (instanceOfJobOutcomeNextUrl(value)) {
    return JobOutcomeNextUrlToJSON(value);
  }
  if (instanceOfJobOutcomeNextView(value)) {
    return JobOutcomeNextViewToJSON(value);
  }
  if (instanceOfJobOutcomeNextWait(value)) {
    return JobOutcomeNextWaitToJSON(value);
  }
  return {};
}

// build/models/JobOutcomeTrigger.ts
var JobOutcomeTrigger = {
  Manual: "manual",
  Automatic: "automatic",
  AutomaticSilent: "automatic_silent"
};
function JobOutcomeTriggerFromJSON(json) {
  return JobOutcomeTriggerFromJSONTyped(json);
}
function JobOutcomeTriggerFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function JobOutcomeTriggerToJSON(value) {
  return value;
}

// build/models/JobOutcome.ts
function instanceOfJobOutcome(value) {
  let isInstance = true;
  return isInstance;
}
function JobOutcomeFromJSON(json) {
  return JobOutcomeFromJSONTyped(json);
}
function JobOutcomeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "heading": !exists(json, "heading") ? void 0 : json["heading"],
    "acknowledge": !exists(json, "acknowledge") ? void 0 : json["acknowledge"],
    "trigger": !exists(json, "trigger") ? void 0 : JobOutcomeTriggerFromJSON(json["trigger"]),
    "message": !exists(json, "message") ? void 0 : json["message"],
    "buttonText": !exists(json, "buttonText") ? void 0 : json["buttonText"],
    "hideDefaultButton": !exists(json, "hideDefaultButton") ? void 0 : json["hideDefaultButton"],
    "next": !exists(json, "next") ? void 0 : JobOutcomeNextFromJSON(json["next"])
  };
}
function JobOutcomeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "heading": value.heading,
    "acknowledge": value.acknowledge,
    "trigger": JobOutcomeTriggerToJSON(value.trigger),
    "message": value.message,
    "buttonText": value.buttonText,
    "hideDefaultButton": value.hideDefaultButton,
    "next": JobOutcomeNextToJSON(value.next)
  };
}

// build/models/ResourceJobSubject.ts
function instanceOfResourceJobSubject(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function ResourceJobSubjectFromJSON(json) {
  return ResourceJobSubjectFromJSONTyped(json);
}
function ResourceJobSubjectFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "type": JobSubjectTypeFromJSON(json["type"])
  };
}
function ResourceJobSubjectToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "type": JobSubjectTypeToJSON(value.type)
  };
}

// build/models/JobSubject.ts
function JobSubjectFromJSON(json) {
  return JobSubjectFromJSONTyped(json);
}
function JobSubjectFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "collection":
      return { ...CollectionJobSubjectFromJSONTyped(json), type: "collection" };
    case "resource":
      return { ...ResourceJobSubjectFromJSONTyped(json), type: "resource" };
    default:
      throw new Error(`No variant of JobSubject exists with 'type=${json["type"]}'`);
  }
}
function JobSubjectToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "collection":
      return CollectionJobSubjectToJSON(value);
    case "resource":
      return ResourceJobSubjectToJSON(value);
    default:
      throw new Error(`No variant of JobSubject exists with 'type=${value["type"]}'`);
  }
}

// build/models/Job.ts
var JobTypeEnum = {
  File: "file",
  Workbook: "workbook",
  Sheet: "sheet",
  Space: "space",
  Document: "document"
};
var JobTriggerEnum = {
  Manual: "manual",
  Immediate: "immediate"
};
var JobStatusEnum = {
  Created: "created",
  Planning: "planning",
  Scheduled: "scheduled",
  Ready: "ready",
  Executing: "executing",
  Complete: "complete",
  Failed: "failed",
  Canceled: "canceled",
  Waiting: "waiting"
};
var JobModeEnum = {
  Foreground: "foreground",
  Background: "background",
  ToolbarBlocking: "toolbarBlocking"
};
var JobPartExecutionEnum = {
  Sequential: "sequential",
  Parallel: "parallel"
};
function instanceOfJob(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "updatedAt" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "operation" in value;
  isInstance = isInstance && "source" in value;
  return isInstance;
}
function JobFromJSON(json) {
  return JobFromJSONTyped(json);
}
function JobFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "startedAt": !exists(json, "startedAt") ? void 0 : json["startedAt"] === null ? null : new Date(json["startedAt"]),
    "finishedAt": !exists(json, "finishedAt") ? void 0 : json["finishedAt"] === null ? null : new Date(json["finishedAt"]),
    "estimatedCompletionAt": !exists(json, "estimatedCompletionAt") ? void 0 : json["estimatedCompletionAt"] === null ? null : new Date(json["estimatedCompletionAt"]),
    "outcomeAcknowledgedAt": !exists(json, "outcomeAcknowledgedAt") ? void 0 : json["outcomeAcknowledgedAt"] === null ? null : new Date(json["outcomeAcknowledgedAt"]),
    "type": json["type"],
    "fromAction": !exists(json, "fromAction") ? void 0 : ActionFromJSON(json["fromAction"]),
    "operation": json["operation"],
    "source": json["source"],
    "destination": !exists(json, "destination") ? void 0 : json["destination"],
    "input": !exists(json, "input") ? void 0 : json["input"],
    "subject": !exists(json, "subject") ? void 0 : JobSubjectFromJSON(json["subject"]),
    "outcome": !exists(json, "outcome") ? void 0 : JobOutcomeFromJSON(json["outcome"]),
    "info": !exists(json, "info") ? void 0 : json["info"],
    "managed": !exists(json, "managed") ? void 0 : json["managed"],
    "config": !exists(json, "config") ? void 0 : JobConfigConfigFromJSON(json["config"]),
    "trigger": !exists(json, "trigger") ? void 0 : json["trigger"],
    "status": !exists(json, "status") ? void 0 : json["status"],
    "mode": !exists(json, "mode") ? void 0 : json["mode"],
    "progress": !exists(json, "progress") ? void 0 : json["progress"],
    "parentId": !exists(json, "parentId") ? void 0 : json["parentId"],
    "fileId": !exists(json, "fileId") ? void 0 : json["fileId"],
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"],
    "part": !exists(json, "part") ? void 0 : json["part"],
    "partData": !exists(json, "partData") ? void 0 : json["partData"],
    "partExecution": !exists(json, "partExecution") ? void 0 : json["partExecution"],
    "predecessorIds": !exists(json, "predecessorIds") ? void 0 : json["predecessorIds"]
  };
}
function JobToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString(),
    "startedAt": value.startedAt === void 0 ? void 0 : value.startedAt === null ? null : value.startedAt.toISOString(),
    "finishedAt": value.finishedAt === void 0 ? void 0 : value.finishedAt === null ? null : value.finishedAt.toISOString(),
    "estimatedCompletionAt": value.estimatedCompletionAt === void 0 ? void 0 : value.estimatedCompletionAt === null ? null : value.estimatedCompletionAt.toISOString(),
    "outcomeAcknowledgedAt": value.outcomeAcknowledgedAt === void 0 ? void 0 : value.outcomeAcknowledgedAt === null ? null : value.outcomeAcknowledgedAt.toISOString(),
    "type": value.type,
    "fromAction": ActionToJSON(value.fromAction),
    "operation": value.operation,
    "source": value.source,
    "destination": value.destination,
    "input": value.input,
    "subject": JobSubjectToJSON(value.subject),
    "outcome": JobOutcomeToJSON(value.outcome),
    "info": value.info,
    "managed": value.managed,
    "config": JobConfigConfigToJSON(value.config),
    "trigger": value.trigger,
    "status": value.status,
    "mode": value.mode,
    "progress": value.progress,
    "parentId": value.parentId,
    "fileId": value.fileId,
    "environmentId": value.environmentId,
    "part": value.part,
    "partData": value.partData,
    "partExecution": value.partExecution,
    "predecessorIds": value.predecessorIds
  };
}

// build/models/JobAckDetails.ts
function instanceOfJobAckDetails(value) {
  let isInstance = true;
  return isInstance;
}
function JobAckDetailsFromJSON(json) {
  return JobAckDetailsFromJSONTyped(json);
}
function JobAckDetailsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "info": !exists(json, "info") ? void 0 : json["info"],
    "progress": !exists(json, "progress") ? void 0 : json["progress"],
    "estimatedCompletionAt": !exists(json, "estimatedCompletionAt") ? void 0 : new Date(json["estimatedCompletionAt"])
  };
}
function JobAckDetailsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "info": value.info,
    "progress": value.progress,
    "estimatedCompletionAt": value.estimatedCompletionAt === void 0 ? void 0 : value.estimatedCompletionAt.toISOString()
  };
}

// build/models/JobCancelDetails.ts
function instanceOfJobCancelDetails(value) {
  let isInstance = true;
  return isInstance;
}
function JobCancelDetailsFromJSON(json) {
  return JobCancelDetailsFromJSONTyped(json);
}
function JobCancelDetailsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "info": !exists(json, "info") ? void 0 : json["info"]
  };
}
function JobCancelDetailsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "info": value.info
  };
}

// build/models/JobCompleteDetails.ts
function instanceOfJobCompleteDetails(value) {
  let isInstance = true;
  return isInstance;
}
function JobCompleteDetailsFromJSON(json) {
  return JobCompleteDetailsFromJSONTyped(json);
}
function JobCompleteDetailsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "outcome": !exists(json, "outcome") ? void 0 : JobOutcomeFromJSON(json["outcome"]),
    "info": !exists(json, "info") ? void 0 : json["info"]
  };
}
function JobCompleteDetailsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "outcome": JobOutcomeToJSON(value.outcome),
    "info": value.info
  };
}

// build/models/JobConfig.ts
var JobConfigTypeEnum = {
  File: "file",
  Workbook: "workbook",
  Sheet: "sheet",
  Space: "space",
  Document: "document"
};
var JobConfigTriggerEnum = {
  Manual: "manual",
  Immediate: "immediate"
};
var JobConfigStatusEnum = {
  Created: "created",
  Planning: "planning",
  Scheduled: "scheduled",
  Ready: "ready",
  Executing: "executing",
  Complete: "complete",
  Failed: "failed",
  Canceled: "canceled",
  Waiting: "waiting"
};
var JobConfigModeEnum = {
  Foreground: "foreground",
  Background: "background",
  ToolbarBlocking: "toolbarBlocking"
};
var JobConfigPartExecutionEnum = {
  Sequential: "sequential",
  Parallel: "parallel"
};
function instanceOfJobConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "operation" in value;
  isInstance = isInstance && "source" in value;
  return isInstance;
}
function JobConfigFromJSON(json) {
  return JobConfigFromJSONTyped(json);
}
function JobConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "fromAction": !exists(json, "fromAction") ? void 0 : ActionFromJSON(json["fromAction"]),
    "operation": json["operation"],
    "source": json["source"],
    "destination": !exists(json, "destination") ? void 0 : json["destination"],
    "input": !exists(json, "input") ? void 0 : json["input"],
    "subject": !exists(json, "subject") ? void 0 : JobSubjectFromJSON(json["subject"]),
    "outcome": !exists(json, "outcome") ? void 0 : JobOutcomeFromJSON(json["outcome"]),
    "info": !exists(json, "info") ? void 0 : json["info"],
    "managed": !exists(json, "managed") ? void 0 : json["managed"],
    "config": !exists(json, "config") ? void 0 : JobConfigConfigFromJSON(json["config"]),
    "trigger": !exists(json, "trigger") ? void 0 : json["trigger"],
    "status": !exists(json, "status") ? void 0 : json["status"],
    "mode": !exists(json, "mode") ? void 0 : json["mode"],
    "progress": !exists(json, "progress") ? void 0 : json["progress"],
    "parentId": !exists(json, "parentId") ? void 0 : json["parentId"],
    "fileId": !exists(json, "fileId") ? void 0 : json["fileId"],
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"],
    "part": !exists(json, "part") ? void 0 : json["part"],
    "partData": !exists(json, "partData") ? void 0 : json["partData"],
    "partExecution": !exists(json, "partExecution") ? void 0 : json["partExecution"],
    "predecessorIds": !exists(json, "predecessorIds") ? void 0 : json["predecessorIds"]
  };
}
function JobConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "fromAction": ActionToJSON(value.fromAction),
    "operation": value.operation,
    "source": value.source,
    "destination": value.destination,
    "input": value.input,
    "subject": JobSubjectToJSON(value.subject),
    "outcome": JobOutcomeToJSON(value.outcome),
    "info": value.info,
    "managed": value.managed,
    "config": JobConfigConfigToJSON(value.config),
    "trigger": value.trigger,
    "status": value.status,
    "mode": value.mode,
    "progress": value.progress,
    "parentId": value.parentId,
    "fileId": value.fileId,
    "environmentId": value.environmentId,
    "part": value.part,
    "partData": value.partData,
    "partExecution": value.partExecution,
    "predecessorIds": value.predecessorIds
  };
}

// build/models/JobOutcomeNextType.ts
var JobOutcomeNextType = {
  Id: "id",
  Url: "url",
  Download: "download",
  Files: "files",
  Wait: "wait",
  Snapshot: "snapshot",
  Retry: "retry",
  View: "view"
};
function JobOutcomeNextTypeFromJSON(json) {
  return JobOutcomeNextTypeFromJSONTyped(json);
}
function JobOutcomeNextTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function JobOutcomeNextTypeToJSON(value) {
  return value;
}

// build/models/SourceField.ts
function instanceOfSourceField(value) {
  let isInstance = true;
  isInstance = isInstance && "sourceField" in value;
  return isInstance;
}
function SourceFieldFromJSON(json) {
  return SourceFieldFromJSONTyped(json);
}
function SourceFieldFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sourceField": FieldConfigFromJSON(json["sourceField"]),
    "preview": !exists(json, "preview") ? void 0 : json["preview"]
  };
}
function SourceFieldToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sourceField": FieldConfigToJSON(value.sourceField),
    "preview": value.preview
  };
}

// build/models/Plan.ts
function instanceOfPlan(value) {
  let isInstance = true;
  isInstance = isInstance && "fieldMapping" in value;
  isInstance = isInstance && "unmappedSourceFields" in value;
  isInstance = isInstance && "unmappedDestinationFields" in value;
  return isInstance;
}
function PlanFromJSON(json) {
  return PlanFromJSONTyped(json);
}
function PlanFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fieldMapping": json["fieldMapping"].map(EdgeFromJSON),
    "unmappedSourceFields": json["unmappedSourceFields"].map(SourceFieldFromJSON),
    "unmappedDestinationFields": json["unmappedDestinationFields"].map(DestinationFieldFromJSON),
    "programId": !exists(json, "programId") ? void 0 : json["programId"]
  };
}
function PlanToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fieldMapping": value.fieldMapping.map(EdgeToJSON),
    "unmappedSourceFields": value.unmappedSourceFields.map(SourceFieldToJSON),
    "unmappedDestinationFields": value.unmappedDestinationFields.map(DestinationFieldToJSON),
    "programId": value.programId
  };
}

// build/models/JobPlan.ts
function instanceOfJobPlan(value) {
  let isInstance = true;
  isInstance = isInstance && "job" in value;
  isInstance = isInstance && "plan" in value;
  return isInstance;
}
function JobPlanFromJSON(json) {
  return JobPlanFromJSONTyped(json);
}
function JobPlanFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "job": JobFromJSON(json["job"]),
    "plan": PlanFromJSON(json["plan"])
  };
}
function JobPlanToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "job": JobToJSON(value.job),
    "plan": PlanToJSON(value.plan)
  };
}

// build/models/JobPlanResponse.ts
function instanceOfJobPlanResponse(value) {
  let isInstance = true;
  return isInstance;
}
function JobPlanResponseFromJSON(json) {
  return JobPlanResponseFromJSONTyped(json);
}
function JobPlanResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : JobPlanFromJSON(json["data"])
  };
}
function JobPlanResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": JobPlanToJSON(value.data)
  };
}

// build/models/JobResponse.ts
function instanceOfJobResponse(value) {
  let isInstance = true;
  return isInstance;
}
function JobResponseFromJSON(json) {
  return JobResponseFromJSONTyped(json);
}
function JobResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : JobFromJSON(json["data"])
  };
}
function JobResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": JobToJSON(value.data)
  };
}

// build/models/JobSplitDetailsParts.ts
function instanceOfJobSplitDetailsParts(value) {
  let isInstance = true;
  return isInstance;
}
function JobSplitDetailsPartsFromJSON(json) {
  return JobSplitDetailsPartsFromJSONTyped(json);
}
function JobSplitDetailsPartsFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function JobSplitDetailsPartsToJSON(value) {
  return value;
}

// build/models/JobSplitDetails.ts
function instanceOfJobSplitDetails(value) {
  let isInstance = true;
  isInstance = isInstance && "parts" in value;
  return isInstance;
}
function JobSplitDetailsFromJSON(json) {
  return JobSplitDetailsFromJSONTyped(json);
}
function JobSplitDetailsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "runInParallel": !exists(json, "runInParallel") ? void 0 : json["runInParallel"],
    "parts": JobSplitDetailsPartsFromJSON(json["parts"])
  };
}
function JobSplitDetailsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "runInParallel": value.runInParallel,
    "parts": JobSplitDetailsPartsToJSON(value.parts)
  };
}

// build/models/JobStatsAccounts.ts
function instanceOfJobStatsAccounts(value) {
  let isInstance = true;
  return isInstance;
}
function JobStatsAccountsFromJSON(json) {
  return JobStatsAccountsFromJSONTyped(json);
}
function JobStatsAccountsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fewestAbandonedJobs": !exists(json, "fewestAbandonedJobs") ? void 0 : json["fewestAbandonedJobs"],
    "mostAbandonedJobs": !exists(json, "mostAbandonedJobs") ? void 0 : json["mostAbandonedJobs"]
  };
}
function JobStatsAccountsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fewestAbandonedJobs": value.fewestAbandonedJobs,
    "mostAbandonedJobs": value.mostAbandonedJobs
  };
}

// build/models/JobStatsJobsMap.ts
function instanceOfJobStatsJobsMap(value) {
  let isInstance = true;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "completed" in value;
  isInstance = isInstance && "automated" in value;
  isInstance = isInstance && "failed" in value;
  isInstance = isInstance && "correctionsAverage" in value;
  return isInstance;
}
function JobStatsJobsMapFromJSON(json) {
  return JobStatsJobsMapFromJSONTyped(json);
}
function JobStatsJobsMapFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "created": json["created"],
    "completed": json["completed"],
    "automated": json["automated"],
    "failed": json["failed"],
    "correctionsAverage": json["correctionsAverage"]
  };
}
function JobStatsJobsMapToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "created": value.created,
    "completed": value.completed,
    "automated": value.automated,
    "failed": value.failed,
    "correctionsAverage": value.correctionsAverage
  };
}

// build/models/JobStatsJobs.ts
function instanceOfJobStatsJobs(value) {
  let isInstance = true;
  isInstance = isInstance && "map" in value;
  return isInstance;
}
function JobStatsJobsFromJSON(json) {
  return JobStatsJobsFromJSONTyped(json);
}
function JobStatsJobsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "map": JobStatsJobsMapFromJSON(json["map"])
  };
}
function JobStatsJobsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "map": JobStatsJobsMapToJSON(value.map)
  };
}

// build/models/JobStats.ts
function instanceOfJobStats(value) {
  let isInstance = true;
  return isInstance;
}
function JobStatsFromJSON(json) {
  return JobStatsFromJSONTyped(json);
}
function JobStatsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "start": !exists(json, "start") ? void 0 : new Date(json["start"]),
    "end": !exists(json, "end") ? void 0 : new Date(json["end"]),
    "jobs": !exists(json, "jobs") ? void 0 : JobStatsJobsFromJSON(json["jobs"]),
    "accounts": !exists(json, "accounts") ? void 0 : JobStatsAccountsFromJSON(json["accounts"])
  };
}
function JobStatsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "start": value.start === void 0 ? void 0 : value.start.toISOString(),
    "end": value.end === void 0 ? void 0 : value.end.toISOString(),
    "jobs": JobStatsJobsToJSON(value.jobs),
    "accounts": JobStatsAccountsToJSON(value.accounts)
  };
}

// build/models/JobStatsResponse.ts
function instanceOfJobStatsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function JobStatsResponseFromJSON(json) {
  return JobStatsResponseFromJSONTyped(json);
}
function JobStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : JobStatsFromJSON(json["data"])
  };
}
function JobStatsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": JobStatsToJSON(value.data)
  };
}

// build/models/JobUpdateConfig.ts
function JobUpdateConfigFromJSON(json) {
  return JobUpdateConfigFromJSONTyped(json);
}
function JobUpdateConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return { ...DeleteRecordsJobConfigFromJSONTyped(json), ...ExportJobConfigFromJSONTyped(json), ...FileJobConfigFromJSONTyped(json), ...FindAndReplaceJobConfigFromJSONTyped(json), ...MappingProgramJobConfigFromJSONTyped(json), ...MutateJobConfigFromJSONTyped(json), ...PipelineJobConfigFromJSONTyped(json) };
}
function JobUpdateConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  if (instanceOfDeleteRecordsJobConfig(value)) {
    return DeleteRecordsJobConfigToJSON(value);
  }
  if (instanceOfExportJobConfig(value)) {
    return ExportJobConfigToJSON(value);
  }
  if (instanceOfFileJobConfig(value)) {
    return FileJobConfigToJSON(value);
  }
  if (instanceOfFindAndReplaceJobConfig(value)) {
    return FindAndReplaceJobConfigToJSON(value);
  }
  if (instanceOfMappingProgramJobConfig(value)) {
    return MappingProgramJobConfigToJSON(value);
  }
  if (instanceOfMutateJobConfig(value)) {
    return MutateJobConfigToJSON(value);
  }
  if (instanceOfPipelineJobConfig(value)) {
    return PipelineJobConfigToJSON(value);
  }
  return {};
}

// build/models/JobUpdate.ts
var JobUpdateStatusEnum = {
  Created: "created",
  Planning: "planning",
  Ready: "ready",
  Executing: "executing",
  Complete: "complete",
  Failed: "failed",
  Waiting: "waiting"
};
function instanceOfJobUpdate(value) {
  let isInstance = true;
  return isInstance;
}
function JobUpdateFromJSON(json) {
  return JobUpdateFromJSONTyped(json);
}
function JobUpdateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "config": !exists(json, "config") ? void 0 : JobUpdateConfigFromJSON(json["config"]),
    "status": !exists(json, "status") ? void 0 : json["status"],
    "progress": !exists(json, "progress") ? void 0 : json["progress"],
    "outcomeAcknowledgedAt": !exists(json, "outcomeAcknowledgedAt") ? void 0 : json["outcomeAcknowledgedAt"] === null ? null : new Date(json["outcomeAcknowledgedAt"]),
    "info": !exists(json, "info") ? void 0 : json["info"]
  };
}
function JobUpdateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "config": JobUpdateConfigToJSON(value.config),
    "status": value.status,
    "progress": value.progress,
    "outcomeAcknowledgedAt": value.outcomeAcknowledgedAt === void 0 ? void 0 : value.outcomeAcknowledgedAt === null ? null : value.outcomeAcknowledgedAt.toISOString(),
    "info": value.info
  };
}

// build/models/JobsResponse.ts
function instanceOfJobsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function JobsResponseFromJSON(json) {
  return JobsResponseFromJSONTyped(json);
}
function JobsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pagination": !exists(json, "pagination") ? void 0 : PaginationFromJSON(json["pagination"]),
    "data": !exists(json, "data") ? void 0 : json["data"].map(JobFromJSON)
  };
}
function JobsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pagination": PaginationToJSON(value.pagination),
    "data": value.data === void 0 ? void 0 : value.data.map(JobToJSON)
  };
}

// build/models/LinkSidebarConfig.ts
var LinkSidebarConfigTypeEnum = {
  Workbook: "workbook",
  Document: "document",
  Link: "link"
};
function instanceOfLinkSidebarConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "href" in value;
  isInstance = isInstance && "title" in value;
  return isInstance;
}
function LinkSidebarConfigFromJSON(json) {
  return LinkSidebarConfigFromJSONTyped(json);
}
function LinkSidebarConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"],
    "href": json["href"],
    "title": json["title"]
  };
}
function LinkSidebarConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "href": value.href,
    "title": value.title
  };
}

// build/models/LinkSidebarConfigAllOf.ts
function instanceOfLinkSidebarConfigAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "href" in value;
  isInstance = isInstance && "title" in value;
  return isInstance;
}
function LinkSidebarConfigAllOfFromJSON(json) {
  return LinkSidebarConfigAllOfFromJSONTyped(json);
}
function LinkSidebarConfigAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "href": json["href"],
    "title": json["title"]
  };
}
function LinkSidebarConfigAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "href": value.href,
    "title": value.title
  };
}

// build/models/ListActorRolesResponse.ts
function instanceOfListActorRolesResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ListActorRolesResponseFromJSON(json) {
  return ListActorRolesResponseFromJSONTyped(json);
}
function ListActorRolesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(ActorRoleResponseFromJSON)
  };
}
function ListActorRolesResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(ActorRoleResponseToJSON)
  };
}

// build/models/RoleResponse.ts
function instanceOfRoleResponse(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "accountId" in value;
  return isInstance;
}
function RoleResponseFromJSON(json) {
  return RoleResponseFromJSONTyped(json);
}
function RoleResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "accountId": json["accountId"],
    "created_at": !exists(json, "created_at") ? void 0 : new Date(json["created_at"]),
    "updated_at": !exists(json, "updated_at") ? void 0 : new Date(json["updated_at"])
  };
}
function RoleResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "accountId": value.accountId,
    "created_at": value.created_at === void 0 ? void 0 : value.created_at.toISOString(),
    "updated_at": value.updated_at === void 0 ? void 0 : value.updated_at.toISOString()
  };
}

// build/models/ListRolesResponse.ts
function instanceOfListRolesResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ListRolesResponseFromJSON(json) {
  return ListRolesResponseFromJSONTyped(json);
}
function ListRolesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(RoleResponseFromJSON)
  };
}
function ListRolesResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(RoleResponseToJSON)
  };
}

// build/models/ListUsersSortField.ts
var ListUsersSortField = {
  Email: "email",
  Name: "name",
  Id: "id",
  Idp: "idp",
  IdpRef: "idp_ref",
  CreatedAt: "created_at",
  UpdatedAt: "updated_at",
  LastSeenAt: "last_seen_at",
  Dashboard: "dashboard"
};
function ListUsersSortFieldFromJSON(json) {
  return ListUsersSortFieldFromJSONTyped(json);
}
function ListUsersSortFieldFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ListUsersSortFieldToJSON(value) {
  return value;
}

// build/models/ManifestResponse.ts
function instanceOfManifestResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ManifestResponseFromJSON(json) {
  return ManifestResponseFromJSONTyped(json);
}
function ManifestResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "date_deployed": !exists(json, "date_deployed") ? void 0 : json["date_deployed"],
    "commit_sha": !exists(json, "commit_sha") ? void 0 : json["commit_sha"],
    "environment": !exists(json, "environment") ? void 0 : json["environment"]
  };
}
function ManifestResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "date_deployed": value.date_deployed,
    "commit_sha": value.commit_sha,
    "environment": value.environment
  };
}

// build/models/MappingProgramSummary.ts
function instanceOfMappingProgramSummary(value) {
  let isInstance = true;
  return isInstance;
}
function MappingProgramSummaryFromJSON(json) {
  return MappingProgramSummaryFromJSONTyped(json);
}
function MappingProgramSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "totalRuleCount": !exists(json, "totalRuleCount") ? void 0 : json["totalRuleCount"],
    "addedRuleCount": !exists(json, "addedRuleCount") ? void 0 : json["addedRuleCount"],
    "deletedRuleCount": !exists(json, "deletedRuleCount") ? void 0 : json["deletedRuleCount"]
  };
}
function MappingProgramSummaryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "totalRuleCount": value.totalRuleCount,
    "addedRuleCount": value.addedRuleCount,
    "deletedRuleCount": value.deletedRuleCount
  };
}

// build/models/MappingRule.ts
function instanceOfMappingRule(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function MappingRuleFromJSON(json) {
  return MappingRuleFromJSONTyped(json);
}
function MappingRuleFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "type": json["type"],
    "config": !exists(json, "config") ? void 0 : json["config"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "id": json["id"],
    "confidence": !exists(json, "confidence") ? void 0 : json["confidence"],
    "createdBy": !exists(json, "createdBy") ? void 0 : json["createdBy"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"]),
    "deletedAt": !exists(json, "deletedAt") ? void 0 : new Date(json["deletedAt"])
  };
}
function MappingRuleToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "type": value.type,
    "config": value.config,
    "metadata": value.metadata,
    "id": value.id,
    "confidence": value.confidence,
    "createdBy": value.createdBy,
    "createdAt": value.createdAt === void 0 ? void 0 : value.createdAt.toISOString(),
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt.toISOString(),
    "deletedAt": value.deletedAt === void 0 ? void 0 : value.deletedAt.toISOString()
  };
}

// build/models/MappingProgram.ts
function instanceOfMappingProgram(value) {
  let isInstance = true;
  return isInstance;
}
function MappingProgramFromJSON(json) {
  return MappingProgramFromJSONTyped(json);
}
function MappingProgramFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "createdBy": !exists(json, "createdBy") ? void 0 : json["createdBy"],
    "rules": !exists(json, "rules") ? void 0 : json["rules"].map(MappingRuleFromJSON),
    "sourceKeys": !exists(json, "sourceKeys") ? void 0 : json["sourceKeys"],
    "destinationKeys": !exists(json, "destinationKeys") ? void 0 : json["destinationKeys"],
    "summary": !exists(json, "summary") ? void 0 : MappingProgramSummaryFromJSON(json["summary"]),
    "accessToken": !exists(json, "accessToken") ? void 0 : json["accessToken"]
  };
}
function MappingProgramToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "createdAt": value.createdAt === void 0 ? void 0 : value.createdAt.toISOString(),
    "createdBy": value.createdBy,
    "rules": value.rules === void 0 ? void 0 : value.rules.map(MappingRuleToJSON),
    "sourceKeys": value.sourceKeys,
    "destinationKeys": value.destinationKeys,
    "summary": MappingProgramSummaryToJSON(value.summary),
    "accessToken": value.accessToken
  };
}

// build/models/MappingRuleBase.ts
function instanceOfMappingRuleBase(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function MappingRuleBaseFromJSON(json) {
  return MappingRuleBaseFromJSONTyped(json);
}
function MappingRuleBaseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "confidence": !exists(json, "confidence") ? void 0 : json["confidence"],
    "createdBy": !exists(json, "createdBy") ? void 0 : json["createdBy"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"]),
    "deletedAt": !exists(json, "deletedAt") ? void 0 : new Date(json["deletedAt"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"]
  };
}
function MappingRuleBaseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "confidence": value.confidence,
    "createdBy": value.createdBy,
    "createdAt": value.createdAt === void 0 ? void 0 : value.createdAt.toISOString(),
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt.toISOString(),
    "deletedAt": value.deletedAt === void 0 ? void 0 : value.deletedAt.toISOString(),
    "metadata": value.metadata
  };
}

// build/models/MappingRuleConfig.ts
function instanceOfMappingRuleConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function MappingRuleConfigFromJSON(json) {
  return MappingRuleConfigFromJSONTyped(json);
}
function MappingRuleConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "type": json["type"],
    "config": !exists(json, "config") ? void 0 : json["config"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"]
  };
}
function MappingRuleConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "type": value.type,
    "config": value.config,
    "metadata": value.metadata
  };
}

// build/models/ModelFile.ts
function instanceOfModelFile(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "ext" in value;
  isInstance = isInstance && "mimetype" in value;
  isInstance = isInstance && "encoding" in value;
  isInstance = isInstance && "status" in value;
  isInstance = isInstance && "size" in value;
  isInstance = isInstance && "bytesReceived" in value;
  isInstance = isInstance && "spaceId" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "updatedAt" in value;
  return isInstance;
}
function ModelFileFromJSON(json) {
  return ModelFileFromJSONTyped(json);
}
function ModelFileFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "ext": json["ext"],
    "mimetype": json["mimetype"],
    "encoding": json["encoding"],
    "status": ModelFileStatusEnumFromJSON(json["status"]),
    "mode": !exists(json, "mode") ? void 0 : FileModeFromJSON(json["mode"]),
    "size": json["size"],
    "bytesReceived": json["bytesReceived"],
    "spaceId": json["spaceId"],
    "workbookId": !exists(json, "workbookId") ? void 0 : json["workbookId"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "expiredAt": !exists(json, "expiredAt") ? void 0 : new Date(json["expiredAt"]),
    "sheetId": !exists(json, "sheetId") ? void 0 : json["sheetId"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "origin": !exists(json, "origin") ? void 0 : FileOriginFromJSON(json["origin"])
  };
}
function ModelFileToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "ext": value.ext,
    "mimetype": value.mimetype,
    "encoding": value.encoding,
    "status": ModelFileStatusEnumToJSON(value.status),
    "mode": FileModeToJSON(value.mode),
    "size": value.size,
    "bytesReceived": value.bytesReceived,
    "spaceId": value.spaceId,
    "workbookId": value.workbookId,
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString(),
    "expiredAt": value.expiredAt === void 0 ? void 0 : value.expiredAt.toISOString(),
    "sheetId": value.sheetId,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "origin": FileOriginToJSON(value.origin)
  };
}

// build/models/NumberPropertyAllOf.ts
var NumberPropertyAllOfTypeEnum = {
  Number: "number"
};
function instanceOfNumberPropertyAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function NumberPropertyAllOfFromJSON(json) {
  return NumberPropertyAllOfFromJSONTyped(json);
}
function NumberPropertyAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"],
    "config": !exists(json, "config") ? void 0 : NumberPropertyAllOfConfigFromJSON(json["config"])
  };
}
function NumberPropertyAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "config": NumberPropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/PlanConfig.ts
function instanceOfPlanConfig(value) {
  let isInstance = true;
  return isInstance;
}
function PlanConfigFromJSON(json) {
  return PlanConfigFromJSONTyped(json);
}
function PlanConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fieldMapping": !exists(json, "fieldMapping") ? void 0 : json["fieldMapping"].map(EdgeFromJSON),
    "unmappedSourceFields": !exists(json, "unmappedSourceFields") ? void 0 : json["unmappedSourceFields"].map(SourceFieldFromJSON),
    "unmappedDestinationFields": !exists(json, "unmappedDestinationFields") ? void 0 : json["unmappedDestinationFields"].map(DestinationFieldFromJSON),
    "programId": !exists(json, "programId") ? void 0 : json["programId"]
  };
}
function PlanConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fieldMapping": value.fieldMapping === void 0 ? void 0 : value.fieldMapping.map(EdgeToJSON),
    "unmappedSourceFields": value.unmappedSourceFields === void 0 ? void 0 : value.unmappedSourceFields.map(SourceFieldToJSON),
    "unmappedDestinationFields": value.unmappedDestinationFields === void 0 ? void 0 : value.unmappedDestinationFields.map(DestinationFieldToJSON),
    "programId": value.programId
  };
}

// build/models/ProductsResponse.ts
function instanceOfProductsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ProductsResponseFromJSON(json) {
  return ProductsResponseFromJSONTyped(json);
}
function ProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(ProductFromJSON)
  };
}
function ProductsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(ProductToJSON)
  };
}

// build/models/ProgramResponse.ts
function instanceOfProgramResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ProgramResponseFromJSON(json) {
  return ProgramResponseFromJSONTyped(json);
}
function ProgramResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : MappingProgramFromJSON(json["data"])
  };
}
function ProgramResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": MappingProgramToJSON(value.data)
  };
}

// build/models/ProgramsResponse.ts
function instanceOfProgramsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ProgramsResponseFromJSON(json) {
  return ProgramsResponseFromJSONTyped(json);
}
function ProgramsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(MappingProgramFromJSON)
  };
}
function ProgramsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(MappingProgramToJSON)
  };
}

// build/models/Prompt.ts
function instanceOfPrompt(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "accountId" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "updatedAt" in value;
  return isInstance;
}
function PromptFromJSON(json) {
  return PromptFromJSONTyped(json);
}
function PromptFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["createdById"],
    "accountId": json["accountId"],
    "prompt": !exists(json, "prompt") ? void 0 : json["prompt"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "deletedAt": !exists(json, "deletedAt") ? void 0 : new Date(json["deletedAt"])
  };
}
function PromptToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "createdById": value.createdById,
    "accountId": value.accountId,
    "prompt": value.prompt,
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString(),
    "deletedAt": value.deletedAt === void 0 ? void 0 : value.deletedAt.toISOString()
  };
}

// build/models/PromptConfig.ts
function instanceOfPromptConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "prompt" in value;
  isInstance = isInstance && "environmentId" in value;
  isInstance = isInstance && "spaceId" in value;
  return isInstance;
}
function PromptConfigFromJSON(json) {
  return PromptConfigFromJSONTyped(json);
}
function PromptConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "prompt": json["prompt"],
    "environmentId": json["environmentId"],
    "spaceId": json["spaceId"]
  };
}
function PromptConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "prompt": value.prompt,
    "environmentId": value.environmentId,
    "spaceId": value.spaceId
  };
}

// build/models/PromptResponse.ts
function instanceOfPromptResponse(value) {
  let isInstance = true;
  return isInstance;
}
function PromptResponseFromJSON(json) {
  return PromptResponseFromJSONTyped(json);
}
function PromptResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : PromptFromJSON(json["data"])
  };
}
function PromptResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": PromptToJSON(value.data)
  };
}

// build/models/PromptsResponse.ts
function instanceOfPromptsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function PromptsResponseFromJSON(json) {
  return PromptsResponseFromJSONTyped(json);
}
function PromptsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(PromptFromJSON)
  };
}
function PromptsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(PromptToJSON)
  };
}

// build/models/RecordData.ts
function instanceOfRecordData(value) {
  let isInstance = true;
  return isInstance;
}
function RecordDataFromJSON(json) {
  return RecordDataFromJSONTyped(json);
}
function RecordDataFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function RecordDataToJSON(value) {
  return value;
}

// build/models/Record.ts
function instanceOfRecord(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "values" in value;
  return isInstance;
}
function RecordFromJSON(json) {
  return RecordFromJSONTyped(json);
}
function RecordFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"],
    "values": RecordDataFromJSON(json["values"]),
    "valid": !exists(json, "valid") ? void 0 : json["valid"],
    "messages": !exists(json, "messages") ? void 0 : json["messages"].map(ValidationMessageFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "config": !exists(json, "config") ? void 0 : json["config"]
  };
}
function RecordToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "versionId": value.versionId,
    "commitId": value.commitId,
    "values": RecordDataToJSON(value.values),
    "valid": value.valid,
    "messages": value.messages === void 0 ? void 0 : value.messages.map(ValidationMessageToJSON),
    "metadata": value.metadata,
    "config": value.config
  };
}

// build/models/RecordCountsResponseData.ts
function instanceOfRecordCountsResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "counts" in value;
  return isInstance;
}
function RecordCountsResponseDataFromJSON(json) {
  return RecordCountsResponseDataFromJSONTyped(json);
}
function RecordCountsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "counts": RecordCountsFromJSON(json["counts"])
  };
}
function RecordCountsResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "counts": RecordCountsToJSON(value.counts)
  };
}

// build/models/RecordCountsResponse.ts
function instanceOfRecordCountsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function RecordCountsResponseFromJSON(json) {
  return RecordCountsResponseFromJSONTyped(json);
}
function RecordCountsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : RecordCountsResponseDataFromJSON(json["data"])
  };
}
function RecordCountsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": RecordCountsResponseDataToJSON(value.data)
  };
}

// build/models/RecordCountsResponseDataAllOf.ts
function instanceOfRecordCountsResponseDataAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "counts" in value;
  return isInstance;
}
function RecordCountsResponseDataAllOfFromJSON(json) {
  return RecordCountsResponseDataAllOfFromJSONTyped(json);
}
function RecordCountsResponseDataAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "counts": RecordCountsFromJSON(json["counts"])
  };
}
function RecordCountsResponseDataAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "counts": RecordCountsToJSON(value.counts)
  };
}

// build/models/RecordDataWithLinks.ts
function instanceOfRecordDataWithLinks(value) {
  let isInstance = true;
  return isInstance;
}
function RecordDataWithLinksFromJSON(json) {
  return RecordDataWithLinksFromJSONTyped(json);
}
function RecordDataWithLinksFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function RecordDataWithLinksToJSON(value) {
  return value;
}

// build/models/RecordUpdates.ts
function instanceOfRecordUpdates(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "values" in value;
  return isInstance;
}
function RecordUpdatesFromJSON(json) {
  return RecordUpdatesFromJSONTyped(json);
}
function RecordUpdatesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"],
    "id": json["id"],
    "values": RecordDataFromJSON(json["values"]),
    "valid": !exists(json, "valid") ? void 0 : json["valid"],
    "messages": !exists(json, "messages") ? void 0 : json["messages"].map(ValidationMessageFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "config": !exists(json, "config") ? void 0 : json["config"]
  };
}
function RecordUpdatesToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "versionId": value.versionId,
    "commitId": value.commitId,
    "id": value.id,
    "values": RecordDataToJSON(value.values),
    "valid": value.valid,
    "messages": value.messages === void 0 ? void 0 : value.messages.map(ValidationMessageToJSON),
    "metadata": value.metadata,
    "config": value.config
  };
}

// build/models/RecordUpdatesAllOf.ts
function instanceOfRecordUpdatesAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function RecordUpdatesAllOfFromJSON(json) {
  return RecordUpdatesAllOfFromJSONTyped(json);
}
function RecordUpdatesAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"]
  };
}
function RecordUpdatesAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "versionId": value.versionId,
    "commitId": value.commitId
  };
}

// build/models/RecordWithLinks.ts
function instanceOfRecordWithLinks(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "values" in value;
  return isInstance;
}
function RecordWithLinksFromJSON(json) {
  return RecordWithLinksFromJSONTyped(json);
}
function RecordWithLinksFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"],
    "values": RecordDataWithLinksFromJSON(json["values"]),
    "valid": !exists(json, "valid") ? void 0 : json["valid"],
    "messages": !exists(json, "messages") ? void 0 : json["messages"].map(ValidationMessageFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "config": !exists(json, "config") ? void 0 : json["config"]
  };
}
function RecordWithLinksToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "versionId": value.versionId,
    "commitId": value.commitId,
    "values": RecordDataWithLinksToJSON(value.values),
    "valid": value.valid,
    "messages": value.messages === void 0 ? void 0 : value.messages.map(ValidationMessageToJSON),
    "metadata": value.metadata,
    "config": value.config
  };
}

// build/models/RecordsData.ts
function instanceOfRecordsData(value) {
  let isInstance = true;
  return isInstance;
}
function RecordsDataFromJSON(json) {
  return RecordsDataFromJSONTyped(json);
}
function RecordsDataFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function RecordsDataToJSON(value) {
  return value;
}

// build/models/RecordsResponseData.ts
function instanceOfRecordsResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  return isInstance;
}
function RecordsResponseDataFromJSON(json) {
  return RecordsResponseDataFromJSONTyped(json);
}
function RecordsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "records": !exists(json, "records") ? void 0 : RecordsWithLinksFromJSON(json["records"]),
    "counts": !exists(json, "counts") ? void 0 : RecordCountsFromJSON(json["counts"]),
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"]
  };
}
function RecordsResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "records": RecordsWithLinksToJSON(value.records),
    "counts": RecordCountsToJSON(value.counts),
    "versionId": value.versionId,
    "commitId": value.commitId
  };
}

// build/models/RecordsResponse.ts
function instanceOfRecordsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function RecordsResponseFromJSON(json) {
  return RecordsResponseFromJSONTyped(json);
}
function RecordsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : RecordsResponseDataFromJSON(json["data"])
  };
}
function RecordsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": RecordsResponseDataToJSON(value.data)
  };
}

// build/models/RecordsResponseDataAllOf.ts
function instanceOfRecordsResponseDataAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function RecordsResponseDataAllOfFromJSON(json) {
  return RecordsResponseDataAllOfFromJSONTyped(json);
}
function RecordsResponseDataAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "records": !exists(json, "records") ? void 0 : RecordsWithLinksFromJSON(json["records"]),
    "counts": !exists(json, "counts") ? void 0 : RecordCountsFromJSON(json["counts"]),
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"]
  };
}
function RecordsResponseDataAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "records": RecordsWithLinksToJSON(value.records),
    "counts": RecordCountsToJSON(value.counts),
    "versionId": value.versionId,
    "commitId": value.commitId
  };
}

// build/models/RecordsUpdates.ts
function instanceOfRecordsUpdates(value) {
  let isInstance = true;
  return isInstance;
}
function RecordsUpdatesFromJSON(json) {
  return RecordsUpdatesFromJSONTyped(json);
}
function RecordsUpdatesFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function RecordsUpdatesToJSON(value) {
  return value;
}

// build/models/ReferenceListPropertyAllOf.ts
var ReferenceListPropertyAllOfTypeEnum = {
  ReferenceList: "reference-list"
};
function instanceOfReferenceListPropertyAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "config" in value;
  return isInstance;
}
function ReferenceListPropertyAllOfFromJSON(json) {
  return ReferenceListPropertyAllOfFromJSONTyped(json);
}
function ReferenceListPropertyAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"],
    "config": ReferenceListPropertyAllOfConfigFromJSON(json["config"])
  };
}
function ReferenceListPropertyAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "config": ReferenceListPropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/ReferencePropertyAllOf.ts
var ReferencePropertyAllOfTypeEnum = {
  Reference: "reference"
};
function instanceOfReferencePropertyAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "config" in value;
  return isInstance;
}
function ReferencePropertyAllOfFromJSON(json) {
  return ReferencePropertyAllOfFromJSONTyped(json);
}
function ReferencePropertyAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"],
    "config": ReferencePropertyAllOfConfigFromJSON(json["config"])
  };
}
function ReferencePropertyAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "config": ReferencePropertyAllOfConfigToJSON(value.config)
  };
}

// build/models/ReplaceRequest.ts
function instanceOfReplaceRequest(value) {
  let isInstance = true;
  return isInstance;
}
function ReplaceRequestFromJSON(json) {
  return ReplaceRequestFromJSONTyped(json);
}
function ReplaceRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "replaceValue": !exists(json, "replaceValue") ? void 0 : ValueFromJSON(json["replaceValue"])
  };
}
function ReplaceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "replaceValue": ValueToJSON(value.replaceValue)
  };
}

// build/models/RequiredConstraintAllOf.ts
var RequiredConstraintAllOfTypeEnum = {
  Required: "required"
};
function instanceOfRequiredConstraintAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function RequiredConstraintAllOfFromJSON(json) {
  return RequiredConstraintAllOfFromJSONTyped(json);
}
function RequiredConstraintAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"]
  };
}
function RequiredConstraintAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/Restore.ts
function instanceOfRestore(value) {
  let isInstance = true;
  isInstance = isInstance && "host" in value;
  isInstance = isInstance && "port" in value;
  isInstance = isInstance && "dbname" in value;
  return isInstance;
}
function RestoreFromJSON(json) {
  return RestoreFromJSONTyped(json);
}
function RestoreFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "host": json["host"],
    "port": json["port"],
    "dbname": json["dbname"]
  };
}
function RestoreToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "host": value.host,
    "port": value.port,
    "dbname": value.dbname
  };
}

// build/models/RestoreConfig.ts
function instanceOfRestoreConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "fileId" in value;
  return isInstance;
}
function RestoreConfigFromJSON(json) {
  return RestoreConfigFromJSONTyped(json);
}
function RestoreConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fileId": json["fileId"]
  };
}
function RestoreConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fileId": value.fileId
  };
}

// build/models/RestoreResponse.ts
function instanceOfRestoreResponse(value) {
  let isInstance = true;
  return isInstance;
}
function RestoreResponseFromJSON(json) {
  return RestoreResponseFromJSONTyped(json);
}
function RestoreResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : RestoreFromJSON(json["data"])
  };
}
function RestoreResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": RestoreToJSON(value.data)
  };
}

// build/models/RestoreSnapshotRequest.ts
function instanceOfRestoreSnapshotRequest(value) {
  let isInstance = true;
  return isInstance;
}
function RestoreSnapshotRequestFromJSON(json) {
  return RestoreSnapshotRequestFromJSONTyped(json);
}
function RestoreSnapshotRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "created": !exists(json, "created") ? void 0 : json["created"],
    "updated": !exists(json, "updated") ? void 0 : json["updated"],
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"]
  };
}
function RestoreSnapshotRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "created": value.created,
    "updated": value.updated,
    "deleted": value.deleted
  };
}

// build/models/RoleActorResource.ts
function instanceOfRoleActorResource(value) {
  let isInstance = true;
  isInstance = isInstance && "actorId" in value;
  isInstance = isInstance && "resourceId" in value;
  isInstance = isInstance && "roleId" in value;
  return isInstance;
}
function RoleActorResourceFromJSON(json) {
  return RoleActorResourceFromJSONTyped(json);
}
function RoleActorResourceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "actorId": ActorIdFromJSON(json["actorId"]),
    "resourceId": ResourceIdFromJSON(json["resourceId"]),
    "roleId": json["roleId"]
  };
}
function RoleActorResourceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "actorId": ActorIdToJSON(value.actorId),
    "resourceId": ResourceIdToJSON(value.resourceId),
    "roleId": value.roleId
  };
}

// build/models/RoleActorResourceAllOf.ts
function instanceOfRoleActorResourceAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "roleId" in value;
  return isInstance;
}
function RoleActorResourceAllOfFromJSON(json) {
  return RoleActorResourceAllOfFromJSONTyped(json);
}
function RoleActorResourceAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "roleId": json["roleId"]
  };
}
function RoleActorResourceAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "roleId": value.roleId
  };
}

// build/models/RuleResponse.ts
function instanceOfRuleResponse(value) {
  let isInstance = true;
  return isInstance;
}
function RuleResponseFromJSON(json) {
  return RuleResponseFromJSONTyped(json);
}
function RuleResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : MappingRuleFromJSON(json["data"])
  };
}
function RuleResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": MappingRuleToJSON(value.data)
  };
}

// build/models/RulesResponse.ts
function instanceOfRulesResponse(value) {
  let isInstance = true;
  return isInstance;
}
function RulesResponseFromJSON(json) {
  return RulesResponseFromJSONTyped(json);
}
function RulesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(MappingRuleFromJSON)
  };
}
function RulesResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(MappingRuleToJSON)
  };
}

// build/models/Secret.ts
function instanceOfSecret(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "value" in value;
  isInstance = isInstance && "environmentId" in value;
  return isInstance;
}
function SecretFromJSON(json) {
  return SecretFromJSONTyped(json);
}
function SecretFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "value": json["value"],
    "environmentId": json["environmentId"],
    "spaceId": !exists(json, "spaceId") ? void 0 : json["spaceId"]
  };
}
function SecretToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "value": value.value,
    "environmentId": value.environmentId,
    "spaceId": value.spaceId
  };
}

// build/models/Secrets.ts
function instanceOfSecrets(value) {
  let isInstance = true;
  return isInstance;
}
function SecretsFromJSON(json) {
  return SecretsFromJSONTyped(json);
}
function SecretsFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function SecretsToJSON(value) {
  return value;
}

// build/models/SecretsResponse.ts
function instanceOfSecretsResponse(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function SecretsResponseFromJSON(json) {
  return SecretsResponseFromJSONTyped(json);
}
function SecretsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": SecretsFromJSON(json["data"])
  };
}
function SecretsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": SecretsToJSON(value.data)
  };
}

// build/models/Sheet.ts
function instanceOfSheet(value) {
  let isInstance = true;
  isInstance = isInstance && "config" in value;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "workbookId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "updatedAt" in value;
  return isInstance;
}
function SheetFromJSON(json) {
  return SheetFromJSONTyped(json);
}
function SheetFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "config": SheetConfigFromJSON(json["config"]),
    "recordCounts": !exists(json, "recordCounts") ? void 0 : RecordCountsFromJSON(json["recordCounts"]),
    "id": json["id"],
    "workbookId": json["workbookId"],
    "name": json["name"],
    "slug": !exists(json, "slug") ? void 0 : json["slug"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "namespace": !exists(json, "namespace") ? void 0 : json["namespace"],
    "lockedBy": !exists(json, "lockedBy") ? void 0 : json["lockedBy"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "lockedAt": !exists(json, "lockedAt") ? void 0 : new Date(json["lockedAt"])
  };
}
function SheetToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "config": SheetConfigToJSON(value.config),
    "recordCounts": RecordCountsToJSON(value.recordCounts),
    "id": value.id,
    "workbookId": value.workbookId,
    "name": value.name,
    "slug": value.slug,
    "metadata": value.metadata,
    "namespace": value.namespace,
    "lockedBy": value.lockedBy,
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString(),
    "lockedAt": value.lockedAt === void 0 ? void 0 : value.lockedAt.toISOString()
  };
}

// build/models/SheetConfigOptions.ts
function instanceOfSheetConfigOptions(value) {
  let isInstance = true;
  return isInstance;
}
function SheetConfigOptionsFromJSON(json) {
  return SheetConfigOptionsFromJSONTyped(json);
}
function SheetConfigOptionsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "slug": !exists(json, "slug") ? void 0 : json["slug"],
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "allowAdditionalFields": !exists(json, "allowAdditionalFields") ? void 0 : json["allowAdditionalFields"],
    "mappingConfidenceThreshold": !exists(json, "mappingConfidenceThreshold") ? void 0 : json["mappingConfidenceThreshold"],
    "access": !exists(json, "access") ? void 0 : json["access"].map(SheetAccessFromJSON),
    "fields": !exists(json, "fields") ? void 0 : json["fields"].map(PropertyFromJSON),
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(SheetConstraintFromJSON)
  };
}
function SheetConfigOptionsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "slug": value.slug,
    "readonly": value.readonly,
    "allowAdditionalFields": value.allowAdditionalFields,
    "mappingConfidenceThreshold": value.mappingConfidenceThreshold,
    "access": value.access === void 0 ? void 0 : value.access.map(SheetAccessToJSON),
    "fields": value.fields === void 0 ? void 0 : value.fields.map(PropertyToJSON),
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "metadata": value.metadata,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(SheetConstraintToJSON)
  };
}

// build/models/SheetConfigUpdate.ts
function instanceOfSheetConfigUpdate(value) {
  let isInstance = true;
  return isInstance;
}
function SheetConfigUpdateFromJSON(json) {
  return SheetConfigUpdateFromJSONTyped(json);
}
function SheetConfigUpdateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "slug": !exists(json, "slug") ? void 0 : json["slug"],
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "allowAdditionalFields": !exists(json, "allowAdditionalFields") ? void 0 : json["allowAdditionalFields"],
    "mappingConfidenceThreshold": !exists(json, "mappingConfidenceThreshold") ? void 0 : json["mappingConfidenceThreshold"],
    "access": !exists(json, "access") ? void 0 : json["access"].map(SheetAccessFromJSON),
    "fields": !exists(json, "fields") ? void 0 : json["fields"].map(PropertyFromJSON),
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(SheetConstraintFromJSON)
  };
}
function SheetConfigUpdateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "slug": value.slug,
    "readonly": value.readonly,
    "allowAdditionalFields": value.allowAdditionalFields,
    "mappingConfidenceThreshold": value.mappingConfidenceThreshold,
    "access": value.access === void 0 ? void 0 : value.access.map(SheetAccessToJSON),
    "fields": value.fields === void 0 ? void 0 : value.fields.map(PropertyToJSON),
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "metadata": value.metadata,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(SheetConstraintToJSON)
  };
}

// build/models/SheetConfigOrUpdate.ts
function instanceOfSheetConfigOrUpdate(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "fields" in value;
  return isInstance;
}
function SheetConfigOrUpdateFromJSON(json) {
  return SheetConfigOrUpdateFromJSONTyped(json);
}
function SheetConfigOrUpdateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "slug": !exists(json, "slug") ? void 0 : json["slug"],
    "readonly": !exists(json, "readonly") ? void 0 : json["readonly"],
    "allowAdditionalFields": !exists(json, "allowAdditionalFields") ? void 0 : json["allowAdditionalFields"],
    "mappingConfidenceThreshold": !exists(json, "mappingConfidenceThreshold") ? void 0 : json["mappingConfidenceThreshold"],
    "access": !exists(json, "access") ? void 0 : json["access"].map(SheetAccessFromJSON),
    "fields": json["fields"].map(PropertyFromJSON),
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "constraints": !exists(json, "constraints") ? void 0 : json["constraints"].map(SheetConstraintFromJSON),
    "id": !exists(json, "id") ? void 0 : json["id"],
    "workbookId": !exists(json, "workbookId") ? void 0 : json["workbookId"],
    "config": !exists(json, "config") ? void 0 : SheetConfigUpdateFromJSON(json["config"]),
    "namespace": !exists(json, "namespace") ? void 0 : json["namespace"],
    "lockedBy": !exists(json, "lockedBy") ? void 0 : json["lockedBy"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"]),
    "lockedAt": !exists(json, "lockedAt") ? void 0 : new Date(json["lockedAt"])
  };
}
function SheetConfigOrUpdateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "slug": value.slug,
    "readonly": value.readonly,
    "allowAdditionalFields": value.allowAdditionalFields,
    "mappingConfidenceThreshold": value.mappingConfidenceThreshold,
    "access": value.access === void 0 ? void 0 : value.access.map(SheetAccessToJSON),
    "fields": value.fields.map(PropertyToJSON),
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "metadata": value.metadata,
    "constraints": value.constraints === void 0 ? void 0 : value.constraints.map(SheetConstraintToJSON),
    "id": value.id,
    "workbookId": value.workbookId,
    "config": SheetConfigUpdateToJSON(value.config),
    "namespace": value.namespace,
    "lockedBy": value.lockedBy,
    "createdAt": value.createdAt === void 0 ? void 0 : value.createdAt.toISOString(),
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt.toISOString(),
    "lockedAt": value.lockedAt === void 0 ? void 0 : value.lockedAt.toISOString()
  };
}

// build/models/SheetResponse.ts
function instanceOfSheetResponse(value) {
  let isInstance = true;
  return isInstance;
}
function SheetResponseFromJSON(json) {
  return SheetResponseFromJSONTyped(json);
}
function SheetResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : SheetFromJSON(json["data"])
  };
}
function SheetResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": SheetToJSON(value.data)
  };
}

// build/models/SheetUpdate.ts
function instanceOfSheetUpdate(value) {
  let isInstance = true;
  return isInstance;
}
function SheetUpdateFromJSON(json) {
  return SheetUpdateFromJSONTyped(json);
}
function SheetUpdateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "workbookId": !exists(json, "workbookId") ? void 0 : json["workbookId"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "slug": !exists(json, "slug") ? void 0 : json["slug"],
    "config": !exists(json, "config") ? void 0 : SheetConfigUpdateFromJSON(json["config"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "namespace": !exists(json, "namespace") ? void 0 : json["namespace"],
    "lockedBy": !exists(json, "lockedBy") ? void 0 : json["lockedBy"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"]),
    "lockedAt": !exists(json, "lockedAt") ? void 0 : new Date(json["lockedAt"])
  };
}
function SheetUpdateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "workbookId": value.workbookId,
    "name": value.name,
    "slug": value.slug,
    "config": SheetConfigUpdateToJSON(value.config),
    "metadata": value.metadata,
    "namespace": value.namespace,
    "lockedBy": value.lockedBy,
    "createdAt": value.createdAt === void 0 ? void 0 : value.createdAt.toISOString(),
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt.toISOString(),
    "lockedAt": value.lockedAt === void 0 ? void 0 : value.lockedAt.toISOString()
  };
}

// build/models/SheetUpdateRequest.ts
function instanceOfSheetUpdateRequest(value) {
  let isInstance = true;
  return isInstance;
}
function SheetUpdateRequestFromJSON(json) {
  return SheetUpdateRequestFromJSONTyped(json);
}
function SheetUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "slug": !exists(json, "slug") ? void 0 : json["slug"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"]
  };
}
function SheetUpdateRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "slug": value.slug,
    "metadata": value.metadata
  };
}

// build/models/SheetsResponse.ts
function instanceOfSheetsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function SheetsResponseFromJSON(json) {
  return SheetsResponseFromJSONTyped(json);
}
function SheetsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(SheetFromJSON)
  };
}
function SheetsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(SheetToJSON)
  };
}

// build/models/WorkbookSidebarConfig.ts
var WorkbookSidebarConfigTypeEnum = {
  Workbook: "workbook",
  Document: "document",
  Link: "link"
};
function instanceOfWorkbookSidebarConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "workbookId" in value;
  return isInstance;
}
function WorkbookSidebarConfigFromJSON(json) {
  return WorkbookSidebarConfigFromJSONTyped(json);
}
function WorkbookSidebarConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"],
    "workbookId": json["workbookId"]
  };
}
function WorkbookSidebarConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "workbookId": value.workbookId
  };
}

// build/models/SidebarConfig.ts
function SidebarConfigFromJSON(json) {
  return SidebarConfigFromJSONTyped(json);
}
function SidebarConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "document":
      return { ...DocumentSidebarConfigFromJSONTyped(json), type: "document" };
    case "link":
      return { ...LinkSidebarConfigFromJSONTyped(json), type: "link" };
    case "workbook":
      return { ...WorkbookSidebarConfigFromJSONTyped(json), type: "workbook" };
    default:
      throw new Error(`No variant of SidebarConfig exists with 'type=${json["type"]}'`);
  }
}
function SidebarConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "document":
      return DocumentSidebarConfigToJSON(value);
    case "link":
      return LinkSidebarConfigToJSON(value);
    case "workbook":
      return WorkbookSidebarConfigToJSON(value);
    default:
      throw new Error(`No variant of SidebarConfig exists with 'type=${value["type"]}'`);
  }
}

// build/models/SnapshotSummaryCreatedSince.ts
function instanceOfSnapshotSummaryCreatedSince(value) {
  let isInstance = true;
  isInstance = isInstance && "total" in value;
  return isInstance;
}
function SnapshotSummaryCreatedSinceFromJSON(json) {
  return SnapshotSummaryCreatedSinceFromJSONTyped(json);
}
function SnapshotSummaryCreatedSinceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total": json["total"]
  };
}
function SnapshotSummaryCreatedSinceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total": value.total
  };
}

// build/models/SnapshotSummaryUpdatedSince.ts
function instanceOfSnapshotSummaryUpdatedSince(value) {
  let isInstance = true;
  isInstance = isInstance && "total" in value;
  return isInstance;
}
function SnapshotSummaryUpdatedSinceFromJSON(json) {
  return SnapshotSummaryUpdatedSinceFromJSONTyped(json);
}
function SnapshotSummaryUpdatedSinceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total": json["total"],
    "byField": !exists(json, "byField") ? void 0 : json["byField"]
  };
}
function SnapshotSummaryUpdatedSinceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total": value.total,
    "byField": value.byField
  };
}

// build/models/SnapshotSummary.ts
function instanceOfSnapshotSummary(value) {
  let isInstance = true;
  isInstance = isInstance && "createdSince" in value;
  isInstance = isInstance && "deletedSince" in value;
  isInstance = isInstance && "updatedSince" in value;
  return isInstance;
}
function SnapshotSummaryFromJSON(json) {
  return SnapshotSummaryFromJSONTyped(json);
}
function SnapshotSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "createdSince": SnapshotSummaryCreatedSinceFromJSON(json["createdSince"]),
    "deletedSince": SnapshotSummaryCreatedSinceFromJSON(json["deletedSince"]),
    "updatedSince": SnapshotSummaryUpdatedSinceFromJSON(json["updatedSince"])
  };
}
function SnapshotSummaryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "createdSince": SnapshotSummaryCreatedSinceToJSON(value.createdSince),
    "deletedSince": SnapshotSummaryCreatedSinceToJSON(value.deletedSince),
    "updatedSince": SnapshotSummaryUpdatedSinceToJSON(value.updatedSince)
  };
}

// build/models/Snapshot.ts
function instanceOfSnapshot(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "sheetId" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "createdBy" in value;
  return isInstance;
}
function SnapshotFromJSON(json) {
  return SnapshotFromJSONTyped(json);
}
function SnapshotFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "sheetId": json["sheetId"],
    "label": !exists(json, "label") ? void 0 : json["label"],
    "summary": !exists(json, "summary") ? void 0 : SnapshotSummaryFromJSON(json["summary"]),
    "createdAt": new Date(json["createdAt"]),
    "createdBy": json["createdBy"]
  };
}
function SnapshotToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "sheetId": value.sheetId,
    "label": value.label,
    "summary": SnapshotSummaryToJSON(value.summary),
    "createdAt": value.createdAt.toISOString(),
    "createdBy": value.createdBy
  };
}

// build/models/SnapshotResponse.ts
function instanceOfSnapshotResponse(value) {
  let isInstance = true;
  return isInstance;
}
function SnapshotResponseFromJSON(json) {
  return SnapshotResponseFromJSONTyped(json);
}
function SnapshotResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : SnapshotFromJSON(json["data"])
  };
}
function SnapshotResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": SnapshotToJSON(value.data)
  };
}

// build/models/SnapshotSheetRequest.ts
function instanceOfSnapshotSheetRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "sheetId" in value;
  return isInstance;
}
function SnapshotSheetRequestFromJSON(json) {
  return SnapshotSheetRequestFromJSONTyped(json);
}
function SnapshotSheetRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "label": !exists(json, "label") ? void 0 : json["label"],
    "sheetId": json["sheetId"]
  };
}
function SnapshotSheetRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "label": value.label,
    "sheetId": value.sheetId
  };
}

// build/models/SnapshotsResponse.ts
function instanceOfSnapshotsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function SnapshotsResponseFromJSON(json) {
  return SnapshotsResponseFromJSONTyped(json);
}
function SnapshotsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(SnapshotFromJSON)
  };
}
function SnapshotsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(SnapshotToJSON)
  };
}

// build/models/SourceDestinationWeight.ts
function instanceOfSourceDestinationWeight(value) {
  let isInstance = true;
  return isInstance;
}
function SourceDestinationWeightFromJSON(json) {
  return SourceDestinationWeightFromJSONTyped(json);
}
function SourceDestinationWeightFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "source": !exists(json, "source") ? void 0 : json["source"],
    "destination": !exists(json, "destination") ? void 0 : json["destination"],
    "weight": !exists(json, "weight") ? void 0 : json["weight"]
  };
}
function SourceDestinationWeightToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "source": value.source,
    "destination": value.destination,
    "weight": value.weight
  };
}

// build/models/SourceDestinationWeightsResponseData.ts
function instanceOfSourceDestinationWeightsResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function SourceDestinationWeightsResponseDataFromJSON(json) {
  return SourceDestinationWeightsResponseDataFromJSONTyped(json);
}
function SourceDestinationWeightsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "weights": !exists(json, "weights") ? void 0 : json["weights"].map(SourceDestinationWeightFromJSON)
  };
}
function SourceDestinationWeightsResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "weights": value.weights === void 0 ? void 0 : value.weights.map(SourceDestinationWeightToJSON)
  };
}

// build/models/SourceDestinationWeightsResponse.ts
function instanceOfSourceDestinationWeightsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function SourceDestinationWeightsResponseFromJSON(json) {
  return SourceDestinationWeightsResponseFromJSONTyped(json);
}
function SourceDestinationWeightsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : SourceDestinationWeightsResponseDataFromJSON(json["data"])
  };
}
function SourceDestinationWeightsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": SourceDestinationWeightsResponseDataToJSON(value.data)
  };
}

// build/models/SpaceAccess.ts
var SpaceAccess = {
  Star: "*",
  Upload: "upload"
};
function SpaceAccessFromJSON(json) {
  return SpaceAccessFromJSONTyped(json);
}
function SpaceAccessFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function SpaceAccessToJSON(value) {
  return value;
}

// build/models/SpaceSidebarConfig.ts
function instanceOfSpaceSidebarConfig(value) {
  let isInstance = true;
  return isInstance;
}
function SpaceSidebarConfigFromJSON(json) {
  return SpaceSidebarConfigFromJSONTyped(json);
}
function SpaceSidebarConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workbookSidebarOrder": !exists(json, "workbookSidebarOrder") ? void 0 : json["workbookSidebarOrder"]
  };
}
function SpaceSidebarConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "workbookSidebarOrder": value.workbookSidebarOrder
  };
}

// build/models/SpaceSettings.ts
function instanceOfSpaceSettings(value) {
  let isInstance = true;
  return isInstance;
}
function SpaceSettingsFromJSON(json) {
  return SpaceSettingsFromJSONTyped(json);
}
function SpaceSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sidebarConfig": !exists(json, "sidebarConfig") ? void 0 : SpaceSidebarConfigFromJSON(json["sidebarConfig"])
  };
}
function SpaceSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "sidebarConfig": SpaceSidebarConfigToJSON(value.sidebarConfig)
  };
}

// build/models/SpaceSize.ts
function instanceOfSpaceSize(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "numUsers" in value;
  isInstance = isInstance && "pdv" in value;
  isInstance = isInstance && "numFiles" in value;
  return isInstance;
}
function SpaceSizeFromJSON(json) {
  return SpaceSizeFromJSONTyped(json);
}
function SpaceSizeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "id": json["id"],
    "numUsers": json["numUsers"],
    "pdv": json["pdv"],
    "numFiles": json["numFiles"]
  };
}
function SpaceSizeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "id": value.id,
    "numUsers": value.numUsers,
    "pdv": value.pdv,
    "numFiles": value.numFiles
  };
}

// build/models/Space.ts
function instanceOfSpace(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdAt" in value;
  isInstance = isInstance && "updatedAt" in value;
  isInstance = isInstance && "environmentId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "guestAuthentication" in value;
  return isInstance;
}
function SpaceFromJSON(json) {
  return SpaceFromJSONTyped(json);
}
function SpaceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "workbooksCount": !exists(json, "workbooksCount") ? void 0 : json["workbooksCount"],
    "filesCount": !exists(json, "filesCount") ? void 0 : json["filesCount"],
    "createdByUserId": !exists(json, "createdByUserId") ? void 0 : json["createdByUserId"],
    "createdByUserName": !exists(json, "createdByUserName") ? void 0 : json["createdByUserName"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "archivedAt": !exists(json, "archivedAt") ? void 0 : new Date(json["archivedAt"]),
    "expiredAt": !exists(json, "expiredAt") ? void 0 : new Date(json["expiredAt"]),
    "lastActivityAt": !exists(json, "lastActivityAt") ? void 0 : new Date(json["lastActivityAt"]),
    "guestLink": !exists(json, "guestLink") ? void 0 : json["guestLink"],
    "accessToken": !exists(json, "accessToken") ? void 0 : json["accessToken"],
    "isCollaborative": !exists(json, "isCollaborative") ? void 0 : json["isCollaborative"],
    "size": !exists(json, "size") ? void 0 : SpaceSizeFromJSON(json["size"]),
    "upgradedAt": !exists(json, "upgradedAt") ? void 0 : new Date(json["upgradedAt"]),
    "app": !exists(json, "app") ? void 0 : json["app"],
    "spaceConfigId": !exists(json, "spaceConfigId") ? void 0 : json["spaceConfigId"],
    "environmentId": json["environmentId"],
    "primaryWorkbookId": !exists(json, "primaryWorkbookId") ? void 0 : json["primaryWorkbookId"],
    "appId": !exists(json, "appId") ? void 0 : json["appId"],
    "name": json["name"],
    "displayOrder": !exists(json, "displayOrder") ? void 0 : json["displayOrder"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "settings": !exists(json, "settings") ? void 0 : SpaceSettingsFromJSON(json["settings"]),
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "guestAuthentication": json["guestAuthentication"].map(GuestAuthenticationEnumFromJSON),
    "access": !exists(json, "access") ? void 0 : json["access"].map(SpaceAccessFromJSON),
    "autoConfigure": !exists(json, "autoConfigure") ? void 0 : json["autoConfigure"],
    "namespace": !exists(json, "namespace") ? void 0 : json["namespace"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"],
    "translationsPath": !exists(json, "translationsPath") ? void 0 : json["translationsPath"],
    "languageOverride": !exists(json, "languageOverride") ? void 0 : json["languageOverride"]
  };
}
function SpaceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "workbooksCount": value.workbooksCount,
    "filesCount": value.filesCount,
    "createdByUserId": value.createdByUserId,
    "createdByUserName": value.createdByUserName,
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString(),
    "archivedAt": value.archivedAt === void 0 ? void 0 : value.archivedAt.toISOString(),
    "expiredAt": value.expiredAt === void 0 ? void 0 : value.expiredAt.toISOString(),
    "lastActivityAt": value.lastActivityAt === void 0 ? void 0 : value.lastActivityAt.toISOString().substr(0, 10),
    "guestLink": value.guestLink,
    "accessToken": value.accessToken,
    "isCollaborative": value.isCollaborative,
    "size": SpaceSizeToJSON(value.size),
    "upgradedAt": value.upgradedAt === void 0 ? void 0 : value.upgradedAt.toISOString(),
    "app": value.app,
    "spaceConfigId": value.spaceConfigId,
    "environmentId": value.environmentId,
    "primaryWorkbookId": value.primaryWorkbookId,
    "appId": value.appId,
    "name": value.name,
    "displayOrder": value.displayOrder,
    "metadata": value.metadata,
    "settings": SpaceSettingsToJSON(value.settings),
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "guestAuthentication": value.guestAuthentication.map(GuestAuthenticationEnumToJSON),
    "access": value.access === void 0 ? void 0 : value.access.map(SpaceAccessToJSON),
    "autoConfigure": value.autoConfigure,
    "namespace": value.namespace,
    "labels": value.labels,
    "translationsPath": value.translationsPath,
    "languageOverride": value.languageOverride
  };
}

// build/models/SpaceConfig.ts
function instanceOfSpaceConfig(value) {
  let isInstance = true;
  return isInstance;
}
function SpaceConfigFromJSON(json) {
  return SpaceConfigFromJSONTyped(json);
}
function SpaceConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "spaceConfigId": !exists(json, "spaceConfigId") ? void 0 : json["spaceConfigId"],
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"],
    "primaryWorkbookId": !exists(json, "primaryWorkbookId") ? void 0 : json["primaryWorkbookId"],
    "appId": !exists(json, "appId") ? void 0 : json["appId"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "displayOrder": !exists(json, "displayOrder") ? void 0 : json["displayOrder"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "settings": !exists(json, "settings") ? void 0 : SpaceSettingsFromJSON(json["settings"]),
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "guestAuthentication": !exists(json, "guestAuthentication") ? void 0 : json["guestAuthentication"].map(GuestAuthenticationEnumFromJSON),
    "access": !exists(json, "access") ? void 0 : json["access"].map(SpaceAccessFromJSON),
    "autoConfigure": !exists(json, "autoConfigure") ? void 0 : json["autoConfigure"],
    "namespace": !exists(json, "namespace") ? void 0 : json["namespace"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"],
    "translationsPath": !exists(json, "translationsPath") ? void 0 : json["translationsPath"],
    "languageOverride": !exists(json, "languageOverride") ? void 0 : json["languageOverride"],
    "archivedAt": !exists(json, "archivedAt") ? void 0 : json["archivedAt"] === null ? null : new Date(json["archivedAt"])
  };
}
function SpaceConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "spaceConfigId": value.spaceConfigId,
    "environmentId": value.environmentId,
    "primaryWorkbookId": value.primaryWorkbookId,
    "appId": value.appId,
    "name": value.name,
    "displayOrder": value.displayOrder,
    "metadata": value.metadata,
    "settings": SpaceSettingsToJSON(value.settings),
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "guestAuthentication": value.guestAuthentication === void 0 ? void 0 : value.guestAuthentication.map(GuestAuthenticationEnumToJSON),
    "access": value.access === void 0 ? void 0 : value.access.map(SpaceAccessToJSON),
    "autoConfigure": value.autoConfigure,
    "namespace": value.namespace,
    "labels": value.labels,
    "translationsPath": value.translationsPath,
    "languageOverride": value.languageOverride,
    "archivedAt": value.archivedAt === void 0 ? void 0 : value.archivedAt === null ? null : value.archivedAt.toISOString()
  };
}

// build/models/SpacePattern.ts
function instanceOfSpacePattern(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "slug" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "blueprints" in value;
  return isInstance;
}
function SpacePatternFromJSON(json) {
  return SpacePatternFromJSONTyped(json);
}
function SpacePatternFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "slug": json["slug"],
    "name": json["name"],
    "blueprints": json["blueprints"].map(BlueprintFromJSON),
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON)
  };
}
function SpacePatternToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "slug": value.slug,
    "name": value.name,
    "blueprints": value.blueprints.map(BlueprintToJSON),
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON)
  };
}

// build/models/SpaceConfigResponse.ts
function instanceOfSpaceConfigResponse(value) {
  let isInstance = true;
  return isInstance;
}
function SpaceConfigResponseFromJSON(json) {
  return SpaceConfigResponseFromJSONTyped(json);
}
function SpaceConfigResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : SpacePatternFromJSON(json["data"])
  };
}
function SpaceConfigResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": SpacePatternToJSON(value.data)
  };
}

// build/models/SpaceConfigsResponse.ts
function instanceOfSpaceConfigsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function SpaceConfigsResponseFromJSON(json) {
  return SpaceConfigsResponseFromJSONTyped(json);
}
function SpaceConfigsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(SpacePatternFromJSON)
  };
}
function SpaceConfigsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(SpacePatternToJSON)
  };
}

// build/models/SpacePatternConfig.ts
function instanceOfSpacePatternConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "slug" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "blueprints" in value;
  return isInstance;
}
function SpacePatternConfigFromJSON(json) {
  return SpacePatternConfigFromJSONTyped(json);
}
function SpacePatternConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "slug": json["slug"],
    "name": json["name"],
    "blueprints": json["blueprints"].map(BlueprintFromJSON),
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON)
  };
}
function SpacePatternConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "slug": value.slug,
    "name": value.name,
    "blueprints": value.blueprints.map(BlueprintToJSON),
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON)
  };
}

// build/models/SpaceResponse.ts
function instanceOfSpaceResponse(value) {
  let isInstance = true;
  return isInstance;
}
function SpaceResponseFromJSON(json) {
  return SpaceResponseFromJSONTyped(json);
}
function SpaceResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : SpaceFromJSON(json["data"])
  };
}
function SpaceResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": SpaceToJSON(value.data)
  };
}

// build/models/SpacesResponse.ts
function instanceOfSpacesResponse(value) {
  let isInstance = true;
  return isInstance;
}
function SpacesResponseFromJSON(json) {
  return SpacesResponseFromJSONTyped(json);
}
function SpacesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pagination": !exists(json, "pagination") ? void 0 : PaginationFromJSON(json["pagination"]),
    "data": !exists(json, "data") ? void 0 : json["data"].map(SpaceFromJSON)
  };
}
function SpacesResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pagination": PaginationToJSON(value.pagination),
    "data": value.data === void 0 ? void 0 : value.data.map(SpaceToJSON)
  };
}

// build/models/StringListPropertyAllOf.ts
var StringListPropertyAllOfTypeEnum = {
  StringList: "string-list"
};
function instanceOfStringListPropertyAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function StringListPropertyAllOfFromJSON(json) {
  return StringListPropertyAllOfFromJSONTyped(json);
}
function StringListPropertyAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"]
  };
}
function StringListPropertyAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/StringPropertyAllOf.ts
var StringPropertyAllOfTypeEnum = {
  String: "string"
};
function instanceOfStringPropertyAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function StringPropertyAllOfFromJSON(json) {
  return StringPropertyAllOfFromJSONTyped(json);
}
function StringPropertyAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"]
  };
}
function StringPropertyAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// build/models/StripeWebhookRequestBodyRequest.ts
function instanceOfStripeWebhookRequestBodyRequest(value) {
  let isInstance = true;
  return isInstance;
}
function StripeWebhookRequestBodyRequestFromJSON(json) {
  return StripeWebhookRequestBodyRequestFromJSONTyped(json);
}
function StripeWebhookRequestBodyRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "idempotency_key": !exists(json, "idempotency_key") ? void 0 : json["idempotency_key"]
  };
}
function StripeWebhookRequestBodyRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "idempotency_key": value.idempotency_key
  };
}

// build/models/StripeWebhookRequestBody.ts
function instanceOfStripeWebhookRequestBody(value) {
  let isInstance = true;
  return isInstance;
}
function StripeWebhookRequestBodyFromJSON(json) {
  return StripeWebhookRequestBodyFromJSONTyped(json);
}
function StripeWebhookRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "object": !exists(json, "object") ? void 0 : json["object"],
    "data": !exists(json, "data") ? void 0 : json["data"],
    "request": !exists(json, "request") ? void 0 : StripeWebhookRequestBodyRequestFromJSON(json["request"]),
    "type": !exists(json, "type") ? void 0 : json["type"]
  };
}
function StripeWebhookRequestBodyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "object": value.object,
    "data": value.data,
    "request": StripeWebhookRequestBodyRequestToJSON(value.request),
    "type": value.type
  };
}

// build/models/SubscriptionUpdatesBody.ts
function instanceOfSubscriptionUpdatesBody(value) {
  let isInstance = true;
  isInstance = isInstance && "lineItems" in value;
  return isInstance;
}
function SubscriptionUpdatesBodyFromJSON(json) {
  return SubscriptionUpdatesBodyFromJSONTyped(json);
}
function SubscriptionUpdatesBodyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "lineItems": json["lineItems"].map(LineItemFromJSON)
  };
}
function SubscriptionUpdatesBodyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "lineItems": value.lineItems.map(LineItemToJSON)
  };
}

// build/models/Success.ts
function instanceOfSuccess(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  return isInstance;
}
function SuccessFromJSON(json) {
  return SuccessFromJSONTyped(json);
}
function SuccessFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"]
  };
}
function SuccessToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success
  };
}

// build/models/SuccessResponse.ts
function instanceOfSuccessResponse(value) {
  let isInstance = true;
  return isInstance;
}
function SuccessResponseFromJSON(json) {
  return SuccessResponseFromJSONTyped(json);
}
function SuccessResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : SuccessFromJSON(json["data"])
  };
}
function SuccessResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": SuccessToJSON(value.data)
  };
}

// build/models/UniqueConstraintAllOf.ts
var UniqueConstraintAllOfTypeEnum = {
  Unique: "unique"
};
function instanceOfUniqueConstraintAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function UniqueConstraintAllOfFromJSON(json) {
  return UniqueConstraintAllOfFromJSONTyped(json);
}
function UniqueConstraintAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "config": !exists(json, "config") ? void 0 : UniqueConstraintAllOfConfigFromJSON(json["config"])
  };
}
function UniqueConstraintAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "config": UniqueConstraintAllOfConfigToJSON(value.config)
  };
}

// build/models/UpdateAccount.ts
function instanceOfUpdateAccount(value) {
  let isInstance = true;
  isInstance = isInstance && "defaultAppId" in value;
  return isInstance;
}
function UpdateAccountFromJSON(json) {
  return UpdateAccountFromJSONTyped(json);
}
function UpdateAccountFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "defaultAppId": json["defaultAppId"]
  };
}
function UpdateAccountToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "defaultAppId": value.defaultAppId
  };
}

// build/models/UpdateEnvironmentByIdRequest.ts
var UpdateEnvironmentByIdRequestDataRetentionPolicyEnum = {
  LastActivity: "lastActivity",
  SinceCreated: "sinceCreated"
};
function instanceOfUpdateEnvironmentByIdRequest(value) {
  let isInstance = true;
  return isInstance;
}
function UpdateEnvironmentByIdRequestFromJSON(json) {
  return UpdateEnvironmentByIdRequestFromJSONTyped(json);
}
function UpdateEnvironmentByIdRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "isProd": !exists(json, "isProd") ? void 0 : json["isProd"],
    "guestAuthentication": !exists(json, "guestAuthentication") ? void 0 : json["guestAuthentication"].map(GuestAuthenticationEnumFromJSON),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "translationsPath": !exists(json, "translationsPath") ? void 0 : json["translationsPath"],
    "namespaces": !exists(json, "namespaces") ? void 0 : json["namespaces"],
    "languageOverride": !exists(json, "languageOverride") ? void 0 : json["languageOverride"],
    "dataRetentionPolicy": !exists(json, "dataRetentionPolicy") ? void 0 : json["dataRetentionPolicy"]
  };
}
function UpdateEnvironmentByIdRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "isProd": value.isProd,
    "guestAuthentication": value.guestAuthentication === void 0 ? void 0 : value.guestAuthentication.map(GuestAuthenticationEnumToJSON),
    "metadata": value.metadata,
    "translationsPath": value.translationsPath,
    "namespaces": value.namespaces,
    "languageOverride": value.languageOverride,
    "dataRetentionPolicy": value.dataRetentionPolicy
  };
}

// build/models/UpdateJobExecutionPlanByIdRequest.ts
function instanceOfUpdateJobExecutionPlanByIdRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "fieldMapping" in value;
  isInstance = isInstance && "unmappedSourceFields" in value;
  isInstance = isInstance && "unmappedDestinationFields" in value;
  return isInstance;
}
function UpdateJobExecutionPlanByIdRequestFromJSON(json) {
  return UpdateJobExecutionPlanByIdRequestFromJSONTyped(json);
}
function UpdateJobExecutionPlanByIdRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fileId": !exists(json, "fileId") ? void 0 : json["fileId"],
    "jobId": !exists(json, "jobId") ? void 0 : json["jobId"],
    "fieldMapping": json["fieldMapping"].map(EdgeFromJSON),
    "unmappedSourceFields": json["unmappedSourceFields"].map(SourceFieldFromJSON),
    "unmappedDestinationFields": json["unmappedDestinationFields"].map(DestinationFieldFromJSON),
    "programId": !exists(json, "programId") ? void 0 : json["programId"]
  };
}
function UpdateJobExecutionPlanByIdRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fileId": value.fileId,
    "jobId": value.jobId,
    "fieldMapping": value.fieldMapping.map(EdgeToJSON),
    "unmappedSourceFields": value.unmappedSourceFields.map(SourceFieldToJSON),
    "unmappedDestinationFields": value.unmappedDestinationFields.map(DestinationFieldToJSON),
    "programId": value.programId
  };
}

// build/models/UpdateJobExecutionPlanFieldsRequest.ts
function instanceOfUpdateJobExecutionPlanFieldsRequest(value) {
  let isInstance = true;
  return isInstance;
}
function UpdateJobExecutionPlanFieldsRequestFromJSON(json) {
  return UpdateJobExecutionPlanFieldsRequestFromJSONTyped(json);
}
function UpdateJobExecutionPlanFieldsRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fileId": !exists(json, "fileId") ? void 0 : json["fileId"],
    "jobId": !exists(json, "jobId") ? void 0 : json["jobId"],
    "fieldMapping": !exists(json, "fieldMapping") ? void 0 : json["fieldMapping"].map(EdgeFromJSON),
    "unmappedSourceFields": !exists(json, "unmappedSourceFields") ? void 0 : json["unmappedSourceFields"].map(SourceFieldFromJSON),
    "unmappedDestinationFields": !exists(json, "unmappedDestinationFields") ? void 0 : json["unmappedDestinationFields"].map(DestinationFieldFromJSON),
    "programId": !exists(json, "programId") ? void 0 : json["programId"]
  };
}
function UpdateJobExecutionPlanFieldsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fileId": value.fileId,
    "jobId": value.jobId,
    "fieldMapping": value.fieldMapping === void 0 ? void 0 : value.fieldMapping.map(EdgeToJSON),
    "unmappedSourceFields": value.unmappedSourceFields === void 0 ? void 0 : value.unmappedSourceFields.map(SourceFieldToJSON),
    "unmappedDestinationFields": value.unmappedDestinationFields === void 0 ? void 0 : value.unmappedDestinationFields.map(DestinationFieldToJSON),
    "programId": value.programId
  };
}

// build/models/UpdateUserRequest.ts
function instanceOfUpdateUserRequest(value) {
  let isInstance = true;
  return isInstance;
}
function UpdateUserRequestFromJSON(json) {
  return UpdateUserRequestFromJSONTyped(json);
}
function UpdateUserRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "dashboard": !exists(json, "dashboard") ? void 0 : json["dashboard"]
  };
}
function UpdateUserRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "dashboard": value.dashboard
  };
}

// build/models/UpdateViewRequest.ts
function instanceOfUpdateViewRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "config" in value;
  return isInstance;
}
function UpdateViewRequestFromJSON(json) {
  return UpdateViewRequestFromJSONTyped(json);
}
function UpdateViewRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "config": ViewConfigFromJSON(json["config"]),
    "name": !exists(json, "name") ? void 0 : json["name"]
  };
}
function UpdateViewRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "config": ViewConfigToJSON(value.config),
    "name": value.name
  };
}

// build/models/UpgradeSpaceConfig.ts
function instanceOfUpgradeSpaceConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function UpgradeSpaceConfigFromJSON(json) {
  return UpgradeSpaceConfigFromJSONTyped(json);
}
function UpgradeSpaceConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"]
  };
}
function UpgradeSpaceConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id
  };
}

// build/models/UploadConfig.ts
function instanceOfUploadConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "fileId" in value;
  return isInstance;
}
function UploadConfigFromJSON(json) {
  return UploadConfigFromJSONTyped(json);
}
function UploadConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fileId": json["fileId"]
  };
}
function UploadConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fileId": value.fileId
  };
}

// build/models/User.ts
function instanceOfUser(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "accountId" in value;
  return isInstance;
}
function UserFromJSON(json) {
  return UserFromJSONTyped(json);
}
function UserFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "idp": !exists(json, "idp") ? void 0 : json["idp"],
    "idpRef": !exists(json, "idpRef") ? void 0 : json["idpRef"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"]),
    "lastSeenAt": !exists(json, "lastSeenAt") ? void 0 : new Date(json["lastSeenAt"]),
    "dashboard": !exists(json, "dashboard") ? void 0 : json["dashboard"],
    "email": json["email"],
    "name": json["name"],
    "accountId": json["accountId"]
  };
}
function UserToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "idp": value.idp,
    "idpRef": value.idpRef,
    "metadata": value.metadata,
    "createdAt": value.createdAt === void 0 ? void 0 : value.createdAt.toISOString(),
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt.toISOString(),
    "lastSeenAt": value.lastSeenAt === void 0 ? void 0 : value.lastSeenAt.toISOString(),
    "dashboard": value.dashboard,
    "email": value.email,
    "name": value.name,
    "accountId": value.accountId
  };
}

// build/models/UserConfig.ts
function instanceOfUserConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "accountId" in value;
  return isInstance;
}
function UserConfigFromJSON(json) {
  return UserConfigFromJSONTyped(json);
}
function UserConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "email": json["email"],
    "name": json["name"],
    "accountId": json["accountId"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"])
  };
}
function UserConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email": value.email,
    "name": value.name,
    "accountId": value.accountId,
    "createdAt": value.createdAt === void 0 ? void 0 : value.createdAt.toISOString(),
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt.toISOString()
  };
}

// build/models/UserCreateAndInviteBody.ts
function instanceOfUserCreateAndInviteBody(value) {
  let isInstance = true;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "actorRoles" in value;
  return isInstance;
}
function UserCreateAndInviteBodyFromJSON(json) {
  return UserCreateAndInviteBodyFromJSONTyped(json);
}
function UserCreateAndInviteBodyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "email": json["email"],
    "name": json["name"],
    "actorRoles": json["actorRoles"].map(AssignActorRoleRequestFromJSON)
  };
}
function UserCreateAndInviteBodyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email": value.email,
    "name": value.name,
    "actorRoles": value.actorRoles.map(AssignActorRoleRequestToJSON)
  };
}

// build/models/UserResponse.ts
function instanceOfUserResponse(value) {
  let isInstance = true;
  return isInstance;
}
function UserResponseFromJSON(json) {
  return UserResponseFromJSONTyped(json);
}
function UserResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : UserFromJSON(json["data"])
  };
}
function UserResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": UserToJSON(value.data)
  };
}

// build/models/UserWithRoles.ts
function instanceOfUserWithRoles(value) {
  let isInstance = true;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "accountId" in value;
  return isInstance;
}
function UserWithRolesFromJSON(json) {
  return UserWithRolesFromJSONTyped(json);
}
function UserWithRolesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "actorRoles": !exists(json, "actorRoles") ? void 0 : json["actorRoles"].map(ActorRoleResponseFromJSON),
    "email": json["email"],
    "name": json["name"],
    "accountId": json["accountId"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"])
  };
}
function UserWithRolesToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "actorRoles": value.actorRoles === void 0 ? void 0 : value.actorRoles.map(ActorRoleResponseToJSON),
    "email": value.email,
    "name": value.name,
    "accountId": value.accountId,
    "createdAt": value.createdAt === void 0 ? void 0 : value.createdAt.toISOString(),
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt.toISOString()
  };
}

// build/models/UsersResponse.ts
function instanceOfUsersResponse(value) {
  let isInstance = true;
  return isInstance;
}
function UsersResponseFromJSON(json) {
  return UsersResponseFromJSONTyped(json);
}
function UsersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(UserFromJSON)
  };
}
function UsersResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(UserToJSON)
  };
}

// build/models/Validation.ts
function instanceOfValidation(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  return isInstance;
}
function ValidationFromJSON(json) {
  return ValidationFromJSONTyped(json);
}
function ValidationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "errors": !exists(json, "errors") ? void 0 : json["errors"]
  };
}
function ValidationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "errors": value.errors
  };
}

// build/models/VersionResponseData.ts
function instanceOfVersionResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function VersionResponseDataFromJSON(json) {
  return VersionResponseDataFromJSONTyped(json);
}
function VersionResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "versionId": !exists(json, "versionId") ? void 0 : json["versionId"],
    "commitId": !exists(json, "commitId") ? void 0 : json["commitId"]
  };
}
function VersionResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "versionId": value.versionId,
    "commitId": value.commitId
  };
}

// build/models/VersionResponse.ts
function instanceOfVersionResponse(value) {
  let isInstance = true;
  return isInstance;
}
function VersionResponseFromJSON(json) {
  return VersionResponseFromJSONTyped(json);
}
function VersionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : VersionResponseDataFromJSON(json["data"])
  };
}
function VersionResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": VersionResponseDataToJSON(value.data)
  };
}

// build/models/View.ts
function instanceOfView(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "sheetId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "config" in value;
  isInstance = isInstance && "createdBy" in value;
  return isInstance;
}
function ViewFromJSON(json) {
  return ViewFromJSONTyped(json);
}
function ViewFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "sheetId": json["sheetId"],
    "name": json["name"],
    "config": ViewConfigFromJSON(json["config"]),
    "createdBy": json["createdBy"]
  };
}
function ViewToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "sheetId": value.sheetId,
    "name": value.name,
    "config": ViewConfigToJSON(value.config),
    "createdBy": value.createdBy
  };
}

// build/models/ViewResponse.ts
function instanceOfViewResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ViewResponseFromJSON(json) {
  return ViewResponseFromJSONTyped(json);
}
function ViewResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : ViewFromJSON(json["data"])
  };
}
function ViewResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": ViewToJSON(value.data)
  };
}

// build/models/ViewsResponse.ts
function instanceOfViewsResponse(value) {
  let isInstance = true;
  return isInstance;
}
function ViewsResponseFromJSON(json) {
  return ViewsResponseFromJSONTyped(json);
}
function ViewsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(ViewFromJSON)
  };
}
function ViewsResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(ViewToJSON)
  };
}

// build/models/WorkbookConfigSettings.ts
function instanceOfWorkbookConfigSettings(value) {
  let isInstance = true;
  return isInstance;
}
function WorkbookConfigSettingsFromJSON(json) {
  return WorkbookConfigSettingsFromJSONTyped(json);
}
function WorkbookConfigSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "trackChanges": !exists(json, "trackChanges") ? void 0 : json["trackChanges"]
  };
}
function WorkbookConfigSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "trackChanges": value.trackChanges
  };
}

// build/models/WorkbookTreatmentsEnum.ts
var WorkbookTreatmentsEnum = {
  ExtractedFromSource: "EXTRACTED_FROM_SOURCE"
};
function WorkbookTreatmentsEnumFromJSON(json) {
  return WorkbookTreatmentsEnumFromJSONTyped(json);
}
function WorkbookTreatmentsEnumFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function WorkbookTreatmentsEnumToJSON(value) {
  return value;
}

// build/models/Workbook.ts
function instanceOfWorkbook(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "spaceId" in value;
  isInstance = isInstance && "environmentId" in value;
  isInstance = isInstance && "updatedAt" in value;
  isInstance = isInstance && "createdAt" in value;
  return isInstance;
}
function WorkbookFromJSON(json) {
  return WorkbookFromJSONTyped(json);
}
function WorkbookFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"].map(WorkbookTreatmentsEnumFromJSON),
    "expiredAt": !exists(json, "expiredAt") ? void 0 : new Date(json["expiredAt"]),
    "sheets": !exists(json, "sheets") ? void 0 : json["sheets"].map(SheetFromJSON),
    "id": json["id"],
    "name": json["name"],
    "spaceId": json["spaceId"],
    "environmentId": json["environmentId"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "settings": !exists(json, "settings") ? void 0 : WorkbookConfigSettingsFromJSON(json["settings"]),
    "updatedAt": new Date(json["updatedAt"]),
    "createdAt": new Date(json["createdAt"]),
    "namespace": !exists(json, "namespace") ? void 0 : json["namespace"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"]
  };
}
function WorkbookToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "treatments": value.treatments === void 0 ? void 0 : value.treatments.map(WorkbookTreatmentsEnumToJSON),
    "expiredAt": value.expiredAt === void 0 ? void 0 : value.expiredAt.toISOString(),
    "sheets": value.sheets === void 0 ? void 0 : value.sheets.map(SheetToJSON),
    "id": value.id,
    "name": value.name,
    "spaceId": value.spaceId,
    "environmentId": value.environmentId,
    "labels": value.labels,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "settings": WorkbookConfigSettingsToJSON(value.settings),
    "updatedAt": value.updatedAt.toISOString(),
    "createdAt": value.createdAt.toISOString(),
    "namespace": value.namespace,
    "metadata": value.metadata
  };
}

// build/models/WorkbookConfig.ts
function instanceOfWorkbookConfig(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function WorkbookConfigFromJSON(json) {
  return WorkbookConfigFromJSONTyped(json);
}
function WorkbookConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "namespace": !exists(json, "namespace") ? void 0 : json["namespace"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"],
    "spaceId": !exists(json, "spaceId") ? void 0 : json["spaceId"],
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"],
    "sheets": !exists(json, "sheets") ? void 0 : json["sheets"].map(SheetConfigFromJSON),
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "settings": !exists(json, "settings") ? void 0 : WorkbookConfigSettingsFromJSON(json["settings"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "treatments": !exists(json, "treatments") ? void 0 : json["treatments"].map(WorkbookTreatmentsEnumFromJSON)
  };
}
function WorkbookConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "namespace": value.namespace,
    "labels": value.labels,
    "spaceId": value.spaceId,
    "environmentId": value.environmentId,
    "sheets": value.sheets === void 0 ? void 0 : value.sheets.map(SheetConfigToJSON),
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "settings": WorkbookConfigSettingsToJSON(value.settings),
    "metadata": value.metadata,
    "treatments": value.treatments === void 0 ? void 0 : value.treatments.map(WorkbookTreatmentsEnumToJSON)
  };
}

// build/models/WorkbookResponse.ts
function instanceOfWorkbookResponse(value) {
  let isInstance = true;
  return isInstance;
}
function WorkbookResponseFromJSON(json) {
  return WorkbookResponseFromJSONTyped(json);
}
function WorkbookResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : WorkbookFromJSON(json["data"])
  };
}
function WorkbookResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": WorkbookToJSON(value.data)
  };
}

// build/models/WorkbookSidebarConfigAllOf.ts
function instanceOfWorkbookSidebarConfigAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "workbookId" in value;
  return isInstance;
}
function WorkbookSidebarConfigAllOfFromJSON(json) {
  return WorkbookSidebarConfigAllOfFromJSONTyped(json);
}
function WorkbookSidebarConfigAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workbookId": json["workbookId"]
  };
}
function WorkbookSidebarConfigAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "workbookId": value.workbookId
  };
}

// build/models/WorkbookUpdate.ts
function instanceOfWorkbookUpdate(value) {
  let isInstance = true;
  return isInstance;
}
function WorkbookUpdateFromJSON(json) {
  return WorkbookUpdateFromJSONTyped(json);
}
function WorkbookUpdateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "spaceId": !exists(json, "spaceId") ? void 0 : json["spaceId"],
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"],
    "sheets": !exists(json, "sheets") ? void 0 : json["sheets"].map(SheetConfigOrUpdateFromJSON),
    "labels": !exists(json, "labels") ? void 0 : json["labels"],
    "actions": !exists(json, "actions") ? void 0 : json["actions"].map(ActionFromJSON),
    "settings": !exists(json, "settings") ? void 0 : WorkbookConfigSettingsFromJSON(json["settings"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"]),
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "namespace": !exists(json, "namespace") ? void 0 : json["namespace"],
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"]
  };
}
function WorkbookUpdateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "spaceId": value.spaceId,
    "environmentId": value.environmentId,
    "sheets": value.sheets === void 0 ? void 0 : value.sheets.map(SheetConfigOrUpdateToJSON),
    "labels": value.labels,
    "actions": value.actions === void 0 ? void 0 : value.actions.map(ActionToJSON),
    "settings": WorkbookConfigSettingsToJSON(value.settings),
    "updatedAt": value.updatedAt === void 0 ? void 0 : value.updatedAt.toISOString(),
    "createdAt": value.createdAt === void 0 ? void 0 : value.createdAt.toISOString(),
    "namespace": value.namespace,
    "metadata": value.metadata
  };
}

// build/models/WorkbooksResponse.ts
function instanceOfWorkbooksResponse(value) {
  let isInstance = true;
  return isInstance;
}
function WorkbooksResponseFromJSON(json) {
  return WorkbooksResponseFromJSONTyped(json);
}
function WorkbooksResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"].map(WorkbookFromJSON)
  };
}
function WorkbooksResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data === void 0 ? void 0 : value.data.map(WorkbookToJSON)
  };
}

// build/models/WriteSecret.ts
function instanceOfWriteSecret(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function WriteSecretFromJSON(json) {
  return WriteSecretFromJSONTyped(json);
}
function WriteSecretFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "value": json["value"],
    "environmentId": !exists(json, "environmentId") ? void 0 : json["environmentId"],
    "spaceId": !exists(json, "spaceId") ? void 0 : json["spaceId"]
  };
}
function WriteSecretToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "value": value.value,
    "environmentId": value.environmentId,
    "spaceId": value.spaceId
  };
}

// build/apis/DefaultApi.ts
var DefaultApi = class extends BaseAPI {
  /**
   * Acknowledge an event
   */
  async ackEventRaw(requestParameters, initOverrides) {
    if (requestParameters.eventId === null || requestParameters.eventId === void 0) {
      throw new RequiredError("eventId", "Required parameter requestParameters.eventId was null or undefined when calling ackEvent.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/events/{eventId}/ack`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Acknowledge an event
   */
  async ackEvent(requestParameters, initOverrides) {
    const response = await this.ackEventRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Acknowledge an event
   */
  async ackEventDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling ackEventDeprecated.");
    }
    if (requestParameters.eventId === null || requestParameters.eventId === void 0) {
      throw new RequiredError("eventId", "Required parameter requestParameters.eventId was null or undefined when calling ackEventDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}/events/{eventId}/ack`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Acknowledge an event
   */
  async ackEventDeprecated(requestParameters, initOverrides) {
    const response = await this.ackEventDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Acknowledge a job and return the job
   * Acknowledge a job
   */
  async ackJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling ackJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/ack`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: JobAckDetailsToJSON(requestParameters.jobAckDetails)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
  }
  /**
   * Acknowledge a job and return the job
   * Acknowledge a job
   */
  async ackJob(requestParameters, initOverrides) {
    const response = await this.ackJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Acknowledge a job outcome and return the job
   * Acknowledges a job outcome
   */
  async acknowledgeJobOutcomeRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling acknowledgeJobOutcome.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/outcome/ack`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
  }
  /**
   * Acknowledge a job outcome and return the job
   * Acknowledges a job outcome
   */
  async acknowledgeJobOutcome(requestParameters, initOverrides) {
    const response = await this.acknowledgeJobOutcomeRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Add a new document to the space
   * Create a document
   */
  async addDocumentToSpaceRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling addDocumentToSpace.");
    }
    if (requestParameters.documentConfig === null || requestParameters.documentConfig === void 0) {
      throw new RequiredError("documentConfig", "Required parameter requestParameters.documentConfig was null or undefined when calling addDocumentToSpace.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/documents`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: DocumentConfigToJSON(requestParameters.documentConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
  }
  /**
   * Add a new document to the space
   * Create a document
   */
  async addDocumentToSpace(requestParameters, initOverrides) {
    const response = await this.addDocumentToSpaceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Adds a new field to a sheet
   */
  async addFieldRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling addField.");
    }
    if (requestParameters.fieldConfig === null || requestParameters.fieldConfig === void 0) {
      throw new RequiredError("fieldConfig", "Required parameter requestParameters.fieldConfig was null or undefined when calling addField.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/fields`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: FieldConfigToJSON(requestParameters.fieldConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => FieldConfigResponseFromJSON(jsonValue));
  }
  /**
   * Adds a new field to a sheet
   */
  async addField(requestParameters, initOverrides) {
    const response = await this.addFieldRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Add a new guest to the space
   * Create a guest
   */
  async addGuestToSpaceRaw(requestParameters, initOverrides) {
    if (requestParameters.guestConfig === null || requestParameters.guestConfig === void 0) {
      throw new RequiredError("guestConfig", "Required parameter requestParameters.guestConfig was null or undefined when calling addGuestToSpace.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/guests`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters.guestConfig.map(GuestConfigToJSON)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GuestsResponseFromJSON(jsonValue));
  }
  /**
   * Add a new guest to the space
   * Create a guest
   */
  async addGuestToSpace(requestParameters, initOverrides) {
    const response = await this.addGuestToSpaceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Adds records to a workbook sheet
   * Insert records
   */
  async addRecordsRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling addRecords.");
    }
    if (requestParameters.recordsData === null || requestParameters.recordsData === void 0) {
      throw new RequiredError("recordsData", "Required parameter requestParameters.recordsData was null or undefined when calling addRecords.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/records`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RecordsDataToJSON(requestParameters.recordsData)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RecordsResponseFromJSON(jsonValue));
  }
  /**
   * Adds records to a workbook sheet
   * Insert records
   */
  async addRecords(requestParameters, initOverrides) {
    const response = await this.addRecordsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Adds records to a workbook sheet
   * Insert records
   */
  async addRecordsDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling addRecordsDeprecated.");
    }
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling addRecordsDeprecated.");
    }
    if (requestParameters.recordsData === null || requestParameters.recordsData === void 0) {
      throw new RequiredError("recordsData", "Required parameter requestParameters.recordsData was null or undefined when calling addRecordsDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}/sheets/{sheetId}/records`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))).replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RecordsDataToJSON(requestParameters.recordsData)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RecordsResponseFromJSON(jsonValue));
  }
  /**
   * Adds records to a workbook sheet
   * Insert records
   */
  async addRecordsDeprecated(requestParameters, initOverrides) {
    const response = await this.addRecordsDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a new space based on an existing Space Config
   * Create a space
   */
  async addSpaceRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceConfig === null || requestParameters.spaceConfig === void 0) {
      throw new RequiredError("spaceConfig", "Required parameter requestParameters.spaceConfig was null or undefined when calling addSpace.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SpaceConfigToJSON(requestParameters.spaceConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpaceResponseFromJSON(jsonValue));
  }
  /**
   * Creates a new space based on an existing Space Config
   * Create a space
   */
  async addSpace(requestParameters, initOverrides) {
    const response = await this.addSpaceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a new Space Config
   * Create a space config
   */
  async addSpaceConfigRaw(requestParameters, initOverrides) {
    if (requestParameters.spacePatternConfig === null || requestParameters.spacePatternConfig === void 0) {
      throw new RequiredError("spacePatternConfig", "Required parameter requestParameters.spacePatternConfig was null or undefined when calling addSpaceConfig.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/space-configs`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SpacePatternConfigToJSON(requestParameters.spacePatternConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpaceConfigResponseFromJSON(jsonValue));
  }
  /**
   * Creates a new Space Config
   * Create a space config
   */
  async addSpaceConfig(requestParameters, initOverrides) {
    const response = await this.addSpaceConfigRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a new Space Config
   * Create a space config
   */
  async addSpaceConfigDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.spacePatternConfig === null || requestParameters.spacePatternConfig === void 0) {
      throw new RequiredError("spacePatternConfig", "Required parameter requestParameters.spacePatternConfig was null or undefined when calling addSpaceConfigDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/configs`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SpacePatternConfigToJSON(requestParameters.spacePatternConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpaceConfigResponseFromJSON(jsonValue));
  }
  /**
   * Creates a new Space Config
   * Create a space config
   */
  async addSpaceConfigDeprecated(requestParameters, initOverrides) {
    const response = await this.addSpaceConfigDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a workbook and adds it to a space
   * Create a workbook
   */
  async addWorkbookRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookConfig === null || requestParameters.workbookConfig === void 0) {
      throw new RequiredError("workbookConfig", "Required parameter requestParameters.workbookConfig was null or undefined when calling addWorkbook.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WorkbookConfigToJSON(requestParameters.workbookConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => WorkbookResponseFromJSON(jsonValue));
  }
  /**
   * Creates a workbook and adds it to a space
   * Create a workbook
   */
  async addWorkbook(requestParameters, initOverrides) {
    const response = await this.addWorkbookRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get the AI assistant to write a mutateRecord function
   * AI generated mutateRecord
   */
  async aiAssistGenerateMutationRaw(requestParameters, initOverrides) {
    if (requestParameters.generateMutationConfig === null || requestParameters.generateMutationConfig === void 0) {
      throw new RequiredError("generateMutationConfig", "Required parameter requestParameters.generateMutationConfig was null or undefined when calling aiAssistGenerateMutation.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/assistant/generate-mutation`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: GenerateMutationConfigToJSON(requestParameters.generateMutationConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GeneratedMutationResponseFromJSON(jsonValue));
  }
  /**
   * Get the AI assistant to write a mutateRecord function
   * AI generated mutateRecord
   */
  async aiAssistGenerateMutation(requestParameters, initOverrides) {
    const response = await this.aiAssistGenerateMutationRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get the AI assistant to write a query function
   * AI generated query
   */
  async aiAssistGenerateQueryRaw(requestParameters, initOverrides) {
    if (requestParameters.generateQueryConfig === null || requestParameters.generateQueryConfig === void 0) {
      throw new RequiredError("generateQueryConfig", "Required parameter requestParameters.generateQueryConfig was null or undefined when calling aiAssistGenerateQuery.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/assistant/generate-query`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: GenerateQueryConfigToJSON(requestParameters.generateQueryConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GeneratedQueryResponseFromJSON(jsonValue));
  }
  /**
   * Get the AI assistant to write a query function
   * AI generated query
   */
  async aiAssistGenerateQuery(requestParameters, initOverrides) {
    const response = await this.aiAssistGenerateQueryRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Archives a space
   */
  async archiveSpaceRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling archiveSpace.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/archive`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Archives a space
   */
  async archiveSpace(requestParameters, initOverrides) {
    const response = await this.archiveSpaceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Assigns a role to an agent
   * Assign Role to Agent
   */
  async assignAgentRoleRaw(requestParameters, initOverrides) {
    if (requestParameters.agentId === null || requestParameters.agentId === void 0) {
      throw new RequiredError("agentId", "Required parameter requestParameters.agentId was null or undefined when calling assignAgentRole.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents/{agentId}/roles`.replace(`{${"agentId"}}`, encodeURIComponent(String(requestParameters.agentId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AssignActorRoleRequestToJSON(requestParameters.assignActorRoleRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AssignRoleResponseFromJSON(jsonValue));
  }
  /**
   * Assigns a role to an agent
   * Assign Role to Agent
   */
  async assignAgentRole(requestParameters, initOverrides) {
    const response = await this.assignAgentRoleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Assigns a role to a guest
   * Assign Role to Guest
   */
  async assignGuestRoleRaw(requestParameters, initOverrides) {
    if (requestParameters.guestId === null || requestParameters.guestId === void 0) {
      throw new RequiredError("guestId", "Required parameter requestParameters.guestId was null or undefined when calling assignGuestRole.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/guests/{guestId}/roles`.replace(`{${"guestId"}}`, encodeURIComponent(String(requestParameters.guestId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AssignActorRoleRequestToJSON(requestParameters.assignActorRoleRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AssignRoleResponseFromJSON(jsonValue));
  }
  /**
   * Assigns a role to a guest
   * Assign Role to Guest
   */
  async assignGuestRole(requestParameters, initOverrides) {
    const response = await this.assignGuestRoleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Assigns a role to a user
   * Assign Role to User
   */
  async assignUserRoleRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling assignUserRole.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}/roles`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AssignActorRoleRequestToJSON(requestParameters.assignActorRoleRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AssignRoleResponseFromJSON(jsonValue));
  }
  /**
   * Assigns a role to a user
   * Assign Role to User
   */
  async assignUserRole(requestParameters, initOverrides) {
    const response = await this.assignUserRoleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Cancel a job and return the job
   * Cancel a job
   */
  async cancelJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling cancelJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/cancel`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: JobCancelDetailsToJSON(requestParameters.jobCancelDetails)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
  }
  /**
   * Cancel a job and return the job
   * Cancel a job
   */
  async cancelJob(requestParameters, initOverrides) {
    const response = await this.cancelJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Cancels the given subscription
   */
  async cancelSubscriptionRaw(requestParameters, initOverrides) {
    if (requestParameters.subscriptionId === null || requestParameters.subscriptionId === void 0) {
      throw new RequiredError("subscriptionId", "Required parameter requestParameters.subscriptionId was null or undefined when calling cancelSubscription.");
    }
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/billing/subscription/{subscriptionId}`.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters.subscriptionId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Cancels the given subscription
   */
  async cancelSubscription(requestParameters, initOverrides) {
    const response = await this.cancelSubscriptionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Cancels all the subscriptions for the current user
   */
  async cancelSubscriptionsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/billing/subscriptions`,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Cancels all the subscriptions for the current user
   */
  async cancelSubscriptions(initOverrides) {
    const response = await this.cancelSubscriptionsRaw(initOverrides);
    return await response.value();
  }
  /**
   * Clone a workbook
   * Clone a workbook within a space
   */
  async cloneWorkbookRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling cloneWorkbook.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}/clone`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => WorkbookResponseFromJSON(jsonValue));
  }
  /**
   * Clone a workbook
   * Clone a workbook within a space
   */
  async cloneWorkbook(requestParameters, initOverrides) {
    const response = await this.cloneWorkbookRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Completes a commit version. This marks the commit as complete and acknowledges that the changes have been applied to the sheet.
   * Complete a commit version
   */
  async completeCommitRaw(requestParameters, initOverrides) {
    if (requestParameters.commitId === null || requestParameters.commitId === void 0) {
      throw new RequiredError("commitId", "Required parameter requestParameters.commitId was null or undefined when calling completeCommit.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/commits/{commitId}/complete`.replace(`{${"commitId"}}`, encodeURIComponent(String(requestParameters.commitId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Completes a commit version. This marks the commit as complete and acknowledges that the changes have been applied to the sheet.
   * Complete a commit version
   */
  async completeCommit(requestParameters, initOverrides) {
    const response = await this.completeCommitRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Complete a job and return the job
   * Complete a job
   */
  async completeJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling completeJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/complete`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: JobCompleteDetailsToJSON(requestParameters.jobCompleteDetails)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
  }
  /**
   * Complete a job and return the job
   * Complete a job
   */
  async completeJob(requestParameters, initOverrides) {
    const response = await this.completeJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Exchange credentials for an access token. Credentials can be a Client ID and Secret or an Email and Password
   * Create an access token
   */
  async createAccessTokenRaw(requestParameters, initOverrides) {
    if (requestParameters.createAccessTokenRequest === null || requestParameters.createAccessTokenRequest === void 0) {
      throw new RequiredError("createAccessTokenRequest", "Required parameter requestParameters.createAccessTokenRequest was null or undefined when calling createAccessToken.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/auth`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateAccessTokenRequestToJSON(requestParameters.createAccessTokenRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AccessTokenResponseFromJSON(jsonValue));
  }
  /**
   * Exchange credentials for an access token. Credentials can be a Client ID and Secret or an Email and Password
   * Create an access token
   */
  async createAccessToken(requestParameters, initOverrides) {
    const response = await this.createAccessTokenRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create an agent
   */
  async createAgentRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling createAgent.");
    }
    if (requestParameters.agentConfig === null || requestParameters.agentConfig === void 0) {
      throw new RequiredError("agentConfig", "Required parameter requestParameters.agentConfig was null or undefined when calling createAgent.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AgentConfigToJSON(requestParameters.agentConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AgentResponseFromJSON(jsonValue));
  }
  /**
   * Create an agent
   */
  async createAgent(requestParameters, initOverrides) {
    const response = await this.createAgentRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create an agent
   */
  async createAgentDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling createAgentDeprecated.");
    }
    if (requestParameters.agentConfig === null || requestParameters.agentConfig === void 0) {
      throw new RequiredError("agentConfig", "Required parameter requestParameters.agentConfig was null or undefined when calling createAgentDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}/agents`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AgentConfigToJSON(requestParameters.agentConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AgentResponseFromJSON(jsonValue));
  }
  /**
   * Create an agent
   */
  async createAgentDeprecated(requestParameters, initOverrides) {
    const response = await this.createAgentDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a user
   * Create a user
   */
  async createAndInviteUserRaw(requestParameters, initOverrides) {
    if (requestParameters.userCreateAndInviteBody === null || requestParameters.userCreateAndInviteBody === void 0) {
      throw new RequiredError("userCreateAndInviteBody", "Required parameter requestParameters.userCreateAndInviteBody was null or undefined when calling createAndInviteUser.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/invite`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UserCreateAndInviteBodyToJSON(requestParameters.userCreateAndInviteBody)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
  }
  /**
   * Creates a user
   * Create a user
   */
  async createAndInviteUser(requestParameters, initOverrides) {
    const response = await this.createAndInviteUserRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates an api token for authenticating against Flatfile APIs
   * Create an API token
   */
  async createApiTokenRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling createApiToken.");
    }
    if (requestParameters.tenantId === null || requestParameters.tenantId === void 0) {
      throw new RequiredError("tenantId", "Required parameter requestParameters.tenantId was null or undefined when calling createApiToken.");
    }
    const queryParameters = {};
    if (requestParameters.tenantId !== void 0) {
      queryParameters["tenantId"] = requestParameters.tenantId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}/api-token`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ApiTokenResponseFromJSON(jsonValue));
  }
  /**
   * Creates an api token for authenticating against Flatfile APIs
   * Create an API token
   */
  async createApiToken(requestParameters, initOverrides) {
    const response = await this.createApiTokenRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a checkout session
   */
  async createCheckoutSessionRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/billing/checkoutsession/create`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CheckoutSessionBodyToJSON(requestParameters.checkoutSessionBody)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateCheckoutSessionResponseFromJSON(jsonValue));
  }
  /**
   * Creates a checkout session
   */
  async createCheckoutSession(requestParameters = {}, initOverrides) {
    const response = await this.createCheckoutSessionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a new commit id that can be used to group record updates
   * Create a commit id
   */
  async createCommitIdRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/commits`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateCommitIdRequestToJSON(requestParameters.createCommitIdRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => VersionResponseFromJSON(jsonValue));
  }
  /**
   * Creates a new commit id that can be used to group record updates
   * Create a commit id
   */
  async createCommitId(requestParameters = {}, initOverrides) {
    const response = await this.createCommitIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a Merge Link
   */
  async createConnectionLinkRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling createConnectionLink.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/createLink`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ConnectionLinkBodyToJSON(requestParameters.connectionLinkBody)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateConnectionLinkResponseFromJSON(jsonValue));
  }
  /**
   * Creates a Merge Link
   */
  async createConnectionLink(requestParameters, initOverrides) {
    const response = await this.createConnectionLinkRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create a data retention policy on an environment
   * Create a data retention policy
   */
  async createDataRetentionPolicyRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/data-retention-policies`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: DataRetentionPolicyConfigToJSON(requestParameters.dataRetentionPolicyConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DataRetentionPolicyResponseFromJSON(jsonValue));
  }
  /**
   * Create a data retention policy on an environment
   * Create a data retention policy
   */
  async createDataRetentionPolicy(requestParameters = {}, initOverrides) {
    const response = await this.createDataRetentionPolicyRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create a new environment
   * Create an environment
   */
  async createEnvironmentRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateEnvironmentRequestToJSON(requestParameters.createEnvironmentRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EnvironmentResponseFromJSON(jsonValue));
  }
  /**
   * Create a new environment
   * Create an environment
   */
  async createEnvironment(requestParameters = {}, initOverrides) {
    const response = await this.createEnvironmentRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create an event
   */
  async createEventRaw(requestParameters, initOverrides) {
    if (requestParameters.eventConfig === null || requestParameters.eventConfig === void 0) {
      throw new RequiredError("eventConfig", "Required parameter requestParameters.eventConfig was null or undefined when calling createEvent.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/events`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: EventConfigToJSON(requestParameters.eventConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EventResponseFromJSON(jsonValue));
  }
  /**
   * Create an event
   */
  async createEvent(requestParameters, initOverrides) {
    const response = await this.createEventRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create an event
   */
  async createEventDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling createEventDeprecated.");
    }
    if (requestParameters.eventConfig === null || requestParameters.eventConfig === void 0) {
      throw new RequiredError("eventConfig", "Required parameter requestParameters.eventConfig was null or undefined when calling createEventDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}/events`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: EventConfigToJSON(requestParameters.eventConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EventResponseFromJSON(jsonValue));
  }
  /**
   * Create an event
   */
  async createEventDeprecated(requestParameters, initOverrides) {
    const response = await this.createEventDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Upload a file
   */
  async createFileRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const consumes = [
      { contentType: "multipart/form-data" }
    ];
    const canConsumeForm2 = canConsumeForm(consumes);
    let formParams;
    let useForm = false;
    useForm = canConsumeForm2;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }
    if (requestParameters.spaceId !== void 0) {
      formParams.append("spaceId", requestParameters.spaceId);
    }
    if (requestParameters.environmentId !== void 0) {
      formParams.append("environmentId", requestParameters.environmentId);
    }
    if (requestParameters.mode !== void 0) {
      formParams.append("mode", new Blob([JSON.stringify(FileModeToJSON(requestParameters.mode))], { type: "application/json" }));
    }
    if (requestParameters.origin !== void 0) {
      formParams.append("origin", new Blob([JSON.stringify(FileOriginToJSON(requestParameters.origin))], { type: "application/json" }));
    }
    if (requestParameters.file !== void 0) {
      formParams.append("file", requestParameters.file);
    }
    if (requestParameters.actions) {
      formParams.append("actions", requestParameters.actions.join(COLLECTION_FORMATS["csv"]));
    }
    const response = await this.request({
      path: `/files`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: formParams
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => FileResponseFromJSON(jsonValue));
  }
  /**
   * Upload a file
   */
  async createFile(requestParameters = {}, initOverrides) {
    const response = await this.createFileRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create a job
   */
  async createJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobConfig === null || requestParameters.jobConfig === void 0) {
      throw new RequiredError("jobConfig", "Required parameter requestParameters.jobConfig was null or undefined when calling createJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: JobConfigToJSON(requestParameters.jobConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
  }
  /**
   * Create a job
   */
  async createJob(requestParameters, initOverrides) {
    const response = await this.createJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create a mapping plan from two blueprints
   */
  async createMappingRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/mapping`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateMappingRequestToJSON(requestParameters.createMappingRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ProgramResponseFromJSON(jsonValue));
  }
  /**
   * Create a mapping plan from two blueprints
   */
  async createMapping(requestParameters = {}, initOverrides) {
    const response = await this.createMappingRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create a new API key of the specified type for the given environment
   */
  async createNewApiKeyRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling createNewApiKey.");
    }
    if (requestParameters.type === null || requestParameters.type === void 0) {
      throw new RequiredError("type", "Required parameter requestParameters.type was null or undefined when calling createNewApiKey.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.type !== void 0) {
      queryParameters["type"] = requestParameters.type;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/auth/api-key`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ApiKeysResponseFromJSON(jsonValue));
  }
  /**
   * Create a new API key of the specified type for the given environment
   */
  async createNewApiKey(requestParameters, initOverrides) {
    const response = await this.createNewApiKeyRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a prompt
   * Creates a prompt
   */
  async createPromptRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/prompts`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PromptConfigToJSON(requestParameters.promptConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => PromptResponseFromJSON(jsonValue));
  }
  /**
   * Creates a prompt
   * Creates a prompt
   */
  async createPrompt(requestParameters = {}, initOverrides) {
    const response = await this.createPromptRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createRuleRaw(requestParameters, initOverrides) {
    if (requestParameters.programId === null || requestParameters.programId === void 0) {
      throw new RequiredError("programId", "Required parameter requestParameters.programId was null or undefined when calling createRule.");
    }
    if (requestParameters.mappingRuleConfig === null || requestParameters.mappingRuleConfig === void 0) {
      throw new RequiredError("mappingRuleConfig", "Required parameter requestParameters.mappingRuleConfig was null or undefined when calling createRule.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/mapping/{programId}/rules`.replace(`{${"programId"}}`, encodeURIComponent(String(requestParameters.programId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters.mappingRuleConfig.map(MappingRuleConfigToJSON)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RulesResponseFromJSON(jsonValue));
  }
  /**
   */
  async createRule(requestParameters, initOverrides) {
    const response = await this.createRuleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a user
   * Create a user
   */
  async createUserRaw(requestParameters, initOverrides) {
    if (requestParameters.userConfig === null || requestParameters.userConfig === void 0) {
      throw new RequiredError("userConfig", "Required parameter requestParameters.userConfig was null or undefined when calling createUser.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UserConfigToJSON(requestParameters.userConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
  }
  /**
   * Creates a user
   * Create a user
   */
  async createUser(requestParameters, initOverrides) {
    const response = await this.createUserRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Creates a new version of a workbook sheet
   * Create a version
   */
  async createVersionDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling createVersionDeprecated.");
    }
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling createVersionDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}/sheets/{sheetId}/versions`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))).replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => VersionResponseFromJSON(jsonValue));
  }
  /**
   * Creates a new version of a workbook sheet
   * Create a version
   */
  async createVersionDeprecated(requestParameters, initOverrides) {
    const response = await this.createVersionDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deprecated. Use `/commits` endpoint instead.
   * Create a version id
   */
  async createVersionIdRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/versions`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateVersionIdRequestToJSON(requestParameters.createVersionIdRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => VersionResponseFromJSON(jsonValue));
  }
  /**
   * Deprecated. Use `/commits` endpoint instead.
   * Create a version id
   */
  async createVersionId(requestParameters = {}, initOverrides) {
    const response = await this.createVersionIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create a view
   * Create a view
   */
  async createViewRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/views`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateViewRequestToJSON(requestParameters.createViewRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ViewResponseFromJSON(jsonValue));
  }
  /**
   * Create a view
   * Create a view
   */
  async createView(requestParameters = {}, initOverrides) {
    const response = await this.createViewRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a single agent
   * Delete an agent
   */
  async deleteAgentRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling deleteAgent.");
    }
    if (requestParameters.agentId === null || requestParameters.agentId === void 0) {
      throw new RequiredError("agentId", "Required parameter requestParameters.agentId was null or undefined when calling deleteAgent.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents/{agentId}`.replace(`{${"agentId"}}`, encodeURIComponent(String(requestParameters.agentId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a single agent
   * Delete an agent
   */
  async deleteAgent(requestParameters, initOverrides) {
    const response = await this.deleteAgentRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Delete the specified API key
   */
  async deleteApiKeyRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling deleteApiKey.");
    }
    if (requestParameters.key === null || requestParameters.key === void 0) {
      throw new RequiredError("key", "Required parameter requestParameters.key was null or undefined when calling deleteApiKey.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.key !== void 0) {
      queryParameters["key"] = requestParameters.key;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/auth/api-key`,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Delete the specified API key
   */
  async deleteApiKey(requestParameters, initOverrides) {
    const response = await this.deleteApiKeyRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes the given data retention policy
   */
  async deleteDataRetentionPolicyRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling deleteDataRetentionPolicy.");
    }
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/data-retention-policies/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes the given data retention policy
   */
  async deleteDataRetentionPolicy(requestParameters, initOverrides) {
    const response = await this.deleteDataRetentionPolicyRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Delete the database
   * Delete the database
   */
  async deleteDatabaseRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling deleteDatabase.");
    }
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/foreigndb/{workbookId}`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Delete the database
   * Delete the database
   */
  async deleteDatabase(requestParameters, initOverrides) {
    const response = await this.deleteDatabaseRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a single document
   * Delete a document
   */
  async deleteDocumentRaw(requestParameters, initOverrides) {
    if (requestParameters.documentId === null || requestParameters.documentId === void 0) {
      throw new RequiredError("documentId", "Required parameter requestParameters.documentId was null or undefined when calling deleteDocument.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/documents/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a single document
   * Delete a document
   */
  async deleteDocument(requestParameters, initOverrides) {
    const response = await this.deleteDocumentRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a single environment
   * Delete an environment
   */
  async deleteEnvironmentByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling deleteEnvironmentById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a single environment
   * Delete an environment
   */
  async deleteEnvironmentById(requestParameters, initOverrides) {
    const response = await this.deleteEnvironmentByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Delete a file
   */
  async deleteFileRaw(requestParameters, initOverrides) {
    if (requestParameters.fileId === null || requestParameters.fileId === void 0) {
      throw new RequiredError("fileId", "Required parameter requestParameters.fileId was null or undefined when calling deleteFile.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/files/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Delete a file
   */
  async deleteFile(requestParameters, initOverrides) {
    const response = await this.deleteFileRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a single guest
   * Delete a guest
   */
  async deleteGuestRaw(requestParameters, initOverrides) {
    if (requestParameters.guestId === null || requestParameters.guestId === void 0) {
      throw new RequiredError("guestId", "Required parameter requestParameters.guestId was null or undefined when calling deleteGuest.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/guests/{guestId}`.replace(`{${"guestId"}}`, encodeURIComponent(String(requestParameters.guestId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a single guest
   * Delete a guest
   */
  async deleteGuest(requestParameters, initOverrides) {
    const response = await this.deleteGuestRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Removes a role from a guest
   * Remove Role from Guest
   */
  async deleteGuestRoleRaw(requestParameters, initOverrides) {
    if (requestParameters.guestId === null || requestParameters.guestId === void 0) {
      throw new RequiredError("guestId", "Required parameter requestParameters.guestId was null or undefined when calling deleteGuestRole.");
    }
    if (requestParameters.actorRoleId === null || requestParameters.actorRoleId === void 0) {
      throw new RequiredError("actorRoleId", "Required parameter requestParameters.actorRoleId was null or undefined when calling deleteGuestRole.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/guests/{guestId}/roles/{actorRoleId}`.replace(`{${"guestId"}}`, encodeURIComponent(String(requestParameters.guestId))).replace(`{${"actorRoleId"}}`, encodeURIComponent(String(requestParameters.actorRoleId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Removes a role from a guest
   * Remove Role from Guest
   */
  async deleteGuestRole(requestParameters, initOverrides) {
    const response = await this.deleteGuestRoleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Delete a job
   */
  async deleteJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling deleteJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Delete a job
   */
  async deleteJob(requestParameters, initOverrides) {
    const response = await this.deleteJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a prompts
   */
  async deletePromptRaw(requestParameters, initOverrides) {
    if (requestParameters.promptId === null || requestParameters.promptId === void 0) {
      throw new RequiredError("promptId", "Required parameter requestParameters.promptId was null or undefined when calling deletePrompt.");
    }
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/prompts/{promptId}`.replace(`{${"promptId"}}`, encodeURIComponent(String(requestParameters.promptId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a prompts
   */
  async deletePrompt(requestParameters, initOverrides) {
    const response = await this.deletePromptRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes records from a workbook sheet
   * Delete records
   */
  async deleteRecordsRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling deleteRecords.");
    }
    if (requestParameters.ids === null || requestParameters.ids === void 0) {
      throw new RequiredError("ids", "Required parameter requestParameters.ids was null or undefined when calling deleteRecords.");
    }
    const queryParameters = {};
    if (requestParameters.ids) {
      queryParameters["ids"] = requestParameters.ids;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/records`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes records from a workbook sheet
   * Delete records
   */
  async deleteRecords(requestParameters, initOverrides) {
    const response = await this.deleteRecordsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes records from a workbook sheet
   * Delete records
   */
  async deleteRecordsDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling deleteRecordsDeprecated.");
    }
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling deleteRecordsDeprecated.");
    }
    const queryParameters = {};
    if (requestParameters.ids) {
      queryParameters["ids"] = requestParameters.ids;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}/sheets/{sheetId}/records`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))).replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes records from a workbook sheet
   * Delete records
   */
  async deleteRecordsDeprecated(requestParameters, initOverrides) {
    const response = await this.deleteRecordsDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteRuleRaw(requestParameters, initOverrides) {
    if (requestParameters.programId === null || requestParameters.programId === void 0) {
      throw new RequiredError("programId", "Required parameter requestParameters.programId was null or undefined when calling deleteRule.");
    }
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling deleteRule.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/mapping/{programId}/rules/{id}`.replace(`{${"programId"}}`, encodeURIComponent(String(requestParameters.programId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteRule(requestParameters, initOverrides) {
    const response = await this.deleteRuleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteRulesRaw(requestParameters, initOverrides) {
    if (requestParameters.programId === null || requestParameters.programId === void 0) {
      throw new RequiredError("programId", "Required parameter requestParameters.programId was null or undefined when calling deleteRules.");
    }
    if (requestParameters.deleteRulesRequest === null || requestParameters.deleteRulesRequest === void 0) {
      throw new RequiredError("deleteRulesRequest", "Required parameter requestParameters.deleteRulesRequest was null or undefined when calling deleteRules.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/mapping/{programId}/rules`.replace(`{${"programId"}}`, encodeURIComponent(String(requestParameters.programId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
      body: DeleteRulesRequestToJSON(requestParameters.deleteRulesRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteRules(requestParameters, initOverrides) {
    const response = await this.deleteRulesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a specific Secret from the Environment or Space as is the case
   * Delete a Secret by ID
   */
  async deleteSecretsRaw(requestParameters, initOverrides) {
    if (requestParameters.secretId === null || requestParameters.secretId === void 0) {
      throw new RequiredError("secretId", "Required parameter requestParameters.secretId was null or undefined when calling deleteSecrets.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/secrets/{secretId}`.replace(`{${"secretId"}}`, encodeURIComponent(String(requestParameters.secretId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a specific Secret from the Environment or Space as is the case
   * Delete a Secret by ID
   */
  async deleteSecrets(requestParameters, initOverrides) {
    const response = await this.deleteSecretsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a specific sheet from a workbook
   * Delete a sheet
   */
  async deleteSheetRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling deleteSheet.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a specific sheet from a workbook
   * Delete a sheet
   */
  async deleteSheet(requestParameters, initOverrides) {
    const response = await this.deleteSheetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Delete a snapshot of a sheet
   * Delete snapshot
   */
  async deleteSnapshotRaw(requestParameters, initOverrides) {
    if (requestParameters.snapshotId === null || requestParameters.snapshotId === void 0) {
      throw new RequiredError("snapshotId", "Required parameter requestParameters.snapshotId was null or undefined when calling deleteSnapshot.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/snapshots/{snapshotId}`.replace(`{${"snapshotId"}}`, encodeURIComponent(String(requestParameters.snapshotId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Delete a snapshot of a sheet
   * Delete snapshot
   */
  async deleteSnapshot(requestParameters, initOverrides) {
    const response = await this.deleteSnapshotRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Delete a space
   * Delete a space
   */
  async deleteSpaceByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling deleteSpaceById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Delete a space
   * Delete a space
   */
  async deleteSpaceById(requestParameters, initOverrides) {
    const response = await this.deleteSpaceByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a single document
   * Delete a document
   */
  async deleteSpaceDocumentRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling deleteSpaceDocument.");
    }
    if (requestParameters.documentId === null || requestParameters.documentId === void 0) {
      throw new RequiredError("documentId", "Required parameter requestParameters.documentId was null or undefined when calling deleteSpaceDocument.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/documents/{documentId}`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a single document
   * Delete a document
   */
  async deleteSpaceDocument(requestParameters, initOverrides) {
    const response = await this.deleteSpaceDocumentRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Delete multiple Spaces from an Environment
   * Delete Spaces
   */
  async deleteSpacesByIdRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.spaceIds) {
      queryParameters["spaceIds"] = requestParameters.spaceIds;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces`,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Delete multiple Spaces from an Environment
   * Delete Spaces
   */
  async deleteSpacesById(requestParameters = {}, initOverrides) {
    const response = await this.deleteSpacesByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a user
   * Deletes a user
   */
  async deleteUserRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling deleteUser.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a user
   * Deletes a user
   */
  async deleteUser(requestParameters, initOverrides) {
    const response = await this.deleteUserRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Removes a role from a user
   * Remove Role from User
   */
  async deleteUserRoleRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling deleteUserRole.");
    }
    if (requestParameters.actorRoleId === null || requestParameters.actorRoleId === void 0) {
      throw new RequiredError("actorRoleId", "Required parameter requestParameters.actorRoleId was null or undefined when calling deleteUserRole.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}/roles/{actorRoleId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"actorRoleId"}}`, encodeURIComponent(String(requestParameters.actorRoleId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Removes a role from a user
   * Remove Role from User
   */
  async deleteUserRole(requestParameters, initOverrides) {
    const response = await this.deleteUserRoleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a view
   */
  async deleteViewRaw(requestParameters, initOverrides) {
    if (requestParameters.viewId === null || requestParameters.viewId === void 0) {
      throw new RequiredError("viewId", "Required parameter requestParameters.viewId was null or undefined when calling deleteView.");
    }
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/views/{viewId}`.replace(`{${"viewId"}}`, encodeURIComponent(String(requestParameters.viewId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a view
   */
  async deleteView(requestParameters, initOverrides) {
    const response = await this.deleteViewRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Deletes a workbook and all of its record data permanently
   * Delete a workbook
   */
  async deleteWorkbookByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling deleteWorkbookById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Deletes a workbook and all of its record data permanently
   * Delete a workbook
   */
  async deleteWorkbookById(requestParameters, initOverrides) {
    const response = await this.deleteWorkbookByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Download an agent
   */
  async downloadAgentRaw(requestParameters, initOverrides) {
    if (requestParameters.agentId === null || requestParameters.agentId === void 0) {
      throw new RequiredError("agentId", "Required parameter requestParameters.agentId was null or undefined when calling downloadAgent.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents/{agentId}/download`.replace(`{${"agentId"}}`, encodeURIComponent(String(requestParameters.agentId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new BlobApiResponse(response);
  }
  /**
   * Download an agent
   */
  async downloadAgent(requestParameters, initOverrides) {
    const response = await this.downloadAgentRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Download a file
   */
  async downloadFileRaw(requestParameters, initOverrides) {
    if (requestParameters.fileId === null || requestParameters.fileId === void 0) {
      throw new RequiredError("fileId", "Required parameter requestParameters.fileId was null or undefined when calling downloadFile.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/files/{fileId}/download`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new BlobApiResponse(response);
  }
  /**
   * Download a file
   */
  async downloadFile(requestParameters, initOverrides) {
    const response = await this.downloadFileRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Exchange an invitation for an access token
   * Exchange an invitation for an access token
   */
  async exchangeInvitationRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/invitations/exchange`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ExchangeInvitationRequestToJSON(requestParameters.exchangeInvitationRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ExchangeTokenResponseFromJSON(jsonValue));
  }
  /**
   * Exchange an invitation for an access token
   * Exchange an invitation for an access token
   */
  async exchangeInvitation(requestParameters = {}, initOverrides) {
    const response = await this.exchangeInvitationRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Execute a job and return the job
   * Execute a job
   */
  async executeJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling executeJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/execute`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Execute a job and return the job
   * Execute a job
   */
  async executeJob(requestParameters, initOverrides) {
    const response = await this.executeJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Expire a space
   * Expire a Space, its Workbooks and Files
   */
  async expireSpaceByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling expireSpaceById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/expire`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Expire a space
   * Expire a Space, its Workbooks and Files
   */
  async expireSpaceById(requestParameters, initOverrides) {
    const response = await this.expireSpaceByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Fail a job and return the job
   * Fail a job
   */
  async failJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling failJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/fail`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: JobCompleteDetailsToJSON(requestParameters.jobCompleteDetails)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
  }
  /**
   * Fail a job and return the job
   * Fail a job
   */
  async failJob(requestParameters, initOverrides) {
    const response = await this.failJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Searches for all values that match the \'find\' value (globally or for a specific field via \'fieldKey\') and replaces them with the \'replace\' value. Wrap \'find\' value in double quotes for exact match (\"\"). Returns a commitId for the updated records
   * Finds and replaces all field values matching search criteria with a given value
   */
  async findAndReplaceRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling findAndReplace.");
    }
    if (requestParameters.findAndReplaceRequest === null || requestParameters.findAndReplaceRequest === void 0) {
      throw new RequiredError("findAndReplaceRequest", "Required parameter requestParameters.findAndReplaceRequest was null or undefined when calling findAndReplace.");
    }
    const queryParameters = {};
    if (requestParameters.filter !== void 0) {
      queryParameters["filter"] = requestParameters.filter;
    }
    if (requestParameters.filterField !== void 0) {
      queryParameters["filterField"] = requestParameters.filterField;
    }
    if (requestParameters.searchValue !== void 0) {
      queryParameters["searchValue"] = requestParameters.searchValue;
    }
    if (requestParameters.searchField !== void 0) {
      queryParameters["searchField"] = requestParameters.searchField;
    }
    if (requestParameters.ids) {
      queryParameters["ids"] = requestParameters.ids;
    }
    if (requestParameters.q !== void 0) {
      queryParameters["q"] = requestParameters.q;
    }
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/find-replace`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: FindAndReplaceRequestToJSON(requestParameters.findAndReplaceRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => VersionResponseFromJSON(jsonValue));
  }
  /**
   * Searches for all values that match the \'find\' value (globally or for a specific field via \'fieldKey\') and replaces them with the \'replace\' value. Wrap \'find\' value in double quotes for exact match (\"\"). Returns a commitId for the updated records
   * Finds and replaces all field values matching search criteria with a given value
   */
  async findAndReplace(requestParameters, initOverrides) {
    const response = await this.findAndReplaceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Authenticate with secret and clientId
   * Authenticate with secret and clientId
   */
  async getAccessTokenRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/auth/access-token`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ApiCredentialsToJSON(requestParameters.apiCredentials)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AccessTokenResponseFromJSON(jsonValue));
  }
  /**
   * Authenticate with secret and clientId
   * Authenticate with secret and clientId
   */
  async getAccessToken(requestParameters = {}, initOverrides) {
    const response = await this.getAccessTokenRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get an agent
   */
  async getAgentRaw(requestParameters, initOverrides) {
    if (requestParameters.agentId === null || requestParameters.agentId === void 0) {
      throw new RequiredError("agentId", "Required parameter requestParameters.agentId was null or undefined when calling getAgent.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents/{agentId}`.replace(`{${"agentId"}}`, encodeURIComponent(String(requestParameters.agentId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AgentResponseFromJSON(jsonValue));
  }
  /**
   * Get an agent
   */
  async getAgent(requestParameters, initOverrides) {
    const response = await this.getAgentRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get an agent
   */
  async getAgentDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getAgentDeprecated.");
    }
    if (requestParameters.agentId === null || requestParameters.agentId === void 0) {
      throw new RequiredError("agentId", "Required parameter requestParameters.agentId was null or undefined when calling getAgentDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}/agents/{agentId}`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"agentId"}}`, encodeURIComponent(String(requestParameters.agentId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AgentResponseFromJSON(jsonValue));
  }
  /**
   * Get an agent
   */
  async getAgentDeprecated(requestParameters, initOverrides) {
    const response = await this.getAgentDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get agent logs
   */
  async getAgentLogsRaw(requestParameters, initOverrides) {
    if (requestParameters.agentId === null || requestParameters.agentId === void 0) {
      throw new RequiredError("agentId", "Required parameter requestParameters.agentId was null or undefined when calling getAgentLogs.");
    }
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getAgentLogs.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents/{agentId}/logs`.replace(`{${"agentId"}}`, encodeURIComponent(String(requestParameters.agentId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AgentLogsResponseFromJSON(jsonValue));
  }
  /**
   * Get agent logs
   */
  async getAgentLogs(requestParameters, initOverrides) {
    const response = await this.getAgentLogsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get logs for an agent
   */
  async getAgentLogsDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getAgentLogsDeprecated.");
    }
    if (requestParameters.agentId === null || requestParameters.agentId === void 0) {
      throw new RequiredError("agentId", "Required parameter requestParameters.agentId was null or undefined when calling getAgentLogsDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}/agents/{agentId}/logs`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"agentId"}}`, encodeURIComponent(String(requestParameters.agentId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AgentLogsResponseFromJSON(jsonValue));
  }
  /**
   * Get logs for an agent
   */
  async getAgentLogsDeprecated(requestParameters, initOverrides) {
    const response = await this.getAgentLogsDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get all agents
   */
  async getAgentsRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getAgents.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AgentsResponseFromJSON(jsonValue));
  }
  /**
   * Get all agents
   */
  async getAgents(requestParameters, initOverrides) {
    const response = await this.getAgentsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * List agents
   */
  async getAgentsDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getAgentsDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}/agents`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AgentsResponseFromJSON(jsonValue));
  }
  /**
   * List agents
   */
  async getAgentsDeprecated(requestParameters, initOverrides) {
    const response = await this.getAgentsDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns all space configs for an account
   * Get all space configs
   */
  async getAllSpaceConfigsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/space-configs`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpaceConfigsResponseFromJSON(jsonValue));
  }
  /**
   * Returns all space configs for an account
   * Get all space configs
   */
  async getAllSpaceConfigs(initOverrides) {
    const response = await this.getAllSpaceConfigsRaw(initOverrides);
    return await response.value();
  }
  /**
   * Returns all space configs for an account
   * List space configs
   */
  async getAllSpaceConfigsDeprecatedRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/configs`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpaceConfigsResponseFromJSON(jsonValue));
  }
  /**
   * Returns all space configs for an account
   * List space configs
   */
  async getAllSpaceConfigsDeprecated(requestParameters = {}, initOverrides) {
    const response = await this.getAllSpaceConfigsDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns all spaces for an account or environment
   * Get all spaces
   */
  async getAllSpacesRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.namespace !== void 0) {
      queryParameters["namespace"] = requestParameters.namespace;
    }
    if (requestParameters.app !== void 0) {
      queryParameters["app"] = requestParameters.app;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.sortField !== void 0) {
      queryParameters["sortField"] = requestParameters.sortField;
    }
    if (requestParameters.sortDirection !== void 0) {
      queryParameters["sortDirection"] = requestParameters.sortDirection;
    }
    if (requestParameters.archived !== void 0) {
      queryParameters["archived"] = requestParameters.archived;
    }
    if (requestParameters.isCollaborative !== void 0) {
      queryParameters["isCollaborative"] = requestParameters.isCollaborative;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpacesResponseFromJSON(jsonValue));
  }
  /**
   * Returns all spaces for an account or environment
   * Get all spaces
   */
  async getAllSpaces(requestParameters = {}, initOverrides) {
    const response = await this.getAllSpacesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns all workbooks matching a filter for an account or space
   * List workbooks
   */
  async getAllWorkbooksRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    if (requestParameters.name !== void 0) {
      queryParameters["name"] = requestParameters.name;
    }
    if (requestParameters.namespace !== void 0) {
      queryParameters["namespace"] = requestParameters.namespace;
    }
    if (requestParameters.label !== void 0) {
      queryParameters["label"] = requestParameters.label;
    }
    if (requestParameters.treatment !== void 0) {
      queryParameters["treatment"] = requestParameters.treatment;
    }
    if (requestParameters.includeSheets !== void 0) {
      queryParameters["includeSheets"] = requestParameters.includeSheets;
    }
    if (requestParameters.includeCounts !== void 0) {
      queryParameters["includeCounts"] = requestParameters.includeCounts;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => WorkbooksResponseFromJSON(jsonValue));
  }
  /**
   * Returns all workbooks matching a filter for an account or space
   * List workbooks
   */
  async getAllWorkbooks(requestParameters = {}, initOverrides) {
    const response = await this.getAllWorkbooksRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Obtain the API keys for a specific environment
   */
  async getApiKeysRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getApiKeys.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/auth/api-keys`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ApiKeysResponseFromJSON(jsonValue));
  }
  /**
   * Obtain the API keys for a specific environment
   */
  async getApiKeys(requestParameters, initOverrides) {
    const response = await this.getApiKeysRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Gets all the api tokens for a user
   * List all tokens
   */
  async getApiTokensRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling getApiTokens.");
    }
    if (requestParameters.tenantId === null || requestParameters.tenantId === void 0) {
      throw new RequiredError("tenantId", "Required parameter requestParameters.tenantId was null or undefined when calling getApiTokens.");
    }
    const queryParameters = {};
    if (requestParameters.tenantId !== void 0) {
      queryParameters["tenantId"] = requestParameters.tenantId;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}/api-token`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ApiTokensResponseFromJSON(jsonValue));
  }
  /**
   * Gets all the api tokens for a user
   * List all tokens
   */
  async getApiTokens(requestParameters, initOverrides) {
    const response = await this.getApiTokensRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Version details for the API
   */
  async getApiVersionDetailsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/version`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AppVersionResponseFromJSON(jsonValue));
  }
  /**
   * Version details for the API
   */
  async getApiVersionDetails(initOverrides) {
    const response = await this.getApiVersionDetailsRaw(initOverrides);
    return await response.value();
  }
  /**
   * Returns record cell values grouped by all fields in the sheet
   * Get record cells by field
   */
  async getCellValuesRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling getCellValues.");
    }
    if (requestParameters.distinct === null || requestParameters.distinct === void 0) {
      throw new RequiredError("distinct", "Required parameter requestParameters.distinct was null or undefined when calling getCellValues.");
    }
    const queryParameters = {};
    if (requestParameters.fieldKey !== void 0) {
      queryParameters["fieldKey"] = requestParameters.fieldKey;
    }
    if (requestParameters.sortField !== void 0) {
      queryParameters["sortField"] = requestParameters.sortField;
    }
    if (requestParameters.sortDirection !== void 0) {
      queryParameters["sortDirection"] = requestParameters.sortDirection;
    }
    if (requestParameters.filter !== void 0) {
      queryParameters["filter"] = requestParameters.filter;
    }
    if (requestParameters.filterField !== void 0) {
      queryParameters["filterField"] = requestParameters.filterField;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.distinct !== void 0) {
      queryParameters["distinct"] = requestParameters.distinct;
    }
    if (requestParameters.includeCounts !== void 0) {
      queryParameters["includeCounts"] = requestParameters.includeCounts;
    }
    if (requestParameters.searchValue !== void 0) {
      queryParameters["searchValue"] = requestParameters.searchValue;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/cells`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CellsResponseFromJSON(jsonValue));
  }
  /**
   * Returns record cell values grouped by all fields in the sheet
   * Get record cells by field
   */
  async getCellValues(requestParameters, initOverrides) {
    const response = await this.getCellValuesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns the details of a commit version
   */
  async getCommitRaw(requestParameters, initOverrides) {
    if (requestParameters.commitId === null || requestParameters.commitId === void 0) {
      throw new RequiredError("commitId", "Required parameter requestParameters.commitId was null or undefined when calling getCommit.");
    }
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/commits/{commitId}`.replace(`{${"commitId"}}`, encodeURIComponent(String(requestParameters.commitId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCommitResponseFromJSON(jsonValue));
  }
  /**
   * Returns the details of a commit version
   */
  async getCommit(requestParameters, initOverrides) {
    const response = await this.getCommitRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns counts of records from a sheet
   * Get record counts
   */
  async getCountsRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling getCounts.");
    }
    const queryParameters = {};
    if (requestParameters.versionId !== void 0) {
      queryParameters["versionId"] = requestParameters.versionId;
    }
    if (requestParameters.commitId !== void 0) {
      queryParameters["commitId"] = requestParameters.commitId;
    }
    if (requestParameters.sinceVersionId !== void 0) {
      queryParameters["sinceVersionId"] = requestParameters.sinceVersionId;
    }
    if (requestParameters.sinceCommitId !== void 0) {
      queryParameters["sinceCommitId"] = requestParameters.sinceCommitId;
    }
    if (requestParameters.filter !== void 0) {
      queryParameters["filter"] = requestParameters.filter;
    }
    if (requestParameters.filterField !== void 0) {
      queryParameters["filterField"] = requestParameters.filterField;
    }
    if (requestParameters.searchValue !== void 0) {
      queryParameters["searchValue"] = requestParameters.searchValue;
    }
    if (requestParameters.searchField !== void 0) {
      queryParameters["searchField"] = requestParameters.searchField;
    }
    if (requestParameters.byField !== void 0) {
      queryParameters["byField"] = requestParameters.byField;
    }
    if (requestParameters.q !== void 0) {
      queryParameters["q"] = requestParameters.q;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/counts`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RecordCountsResponseFromJSON(jsonValue));
  }
  /**
   * Returns counts of records from a sheet
   * Get record counts
   */
  async getCounts(requestParameters, initOverrides) {
    const response = await this.getCountsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get the account information for the currently authenticated user.
   * Get the current account
   */
  async getCurrentAccountRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/accounts/current`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AccountResponseFromJSON(jsonValue));
  }
  /**
   * Get the account information for the currently authenticated user.
   * Get the current account
   */
  async getCurrentAccount(initOverrides) {
    const response = await this.getCurrentAccountRaw(initOverrides);
    return await response.value();
  }
  /**
   * Get a data retention policy by account or filter by environment id
   * Get data retention policy by account or filter by environment id
   */
  async getDataRetentionPoliciesByAccountRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/data-retention-policies`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DataRetentionPolicyResponseFromJSON(jsonValue));
  }
  /**
   * Get a data retention policy by account or filter by environment id
   * Get data retention policy by account or filter by environment id
   */
  async getDataRetentionPoliciesByAccount(requestParameters = {}, initOverrides) {
    const response = await this.getDataRetentionPoliciesByAccountRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get a data retention policy on an environment
   * Get a data retention policy
   */
  async getDataRetentionPolicyRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getDataRetentionPolicy.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/data-retention-policies/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DataRetentionPolicyResponseFromJSON(jsonValue));
  }
  /**
   * Get a data retention policy on an environment
   * Get a data retention policy
   */
  async getDataRetentionPolicy(requestParameters, initOverrides) {
    const response = await this.getDataRetentionPolicyRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get the database information
   * Get the database information
   */
  async getDatabaseInfoRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling getDatabaseInfo.");
    }
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/foreigndb/{workbookId}`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetDatabaseResponseResponseFromJSON(jsonValue));
  }
  /**
   * Get the database information
   * Get the database information
   */
  async getDatabaseInfo(requestParameters, initOverrides) {
    const response = await this.getDatabaseInfoRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get the user of a database
   * Get database user
   */
  async getDatabaseUserRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling getDatabaseUser.");
    }
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/foreigndb/{workbookId}/user`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetUserResponseFromJSON(jsonValue));
  }
  /**
   * Get the user of a database
   * Get database user
   */
  async getDatabaseUser(requestParameters, initOverrides) {
    const response = await this.getDatabaseUserRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a single document
   * Get a document
   */
  async getDocumentByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.documentId === null || requestParameters.documentId === void 0) {
      throw new RequiredError("documentId", "Required parameter requestParameters.documentId was null or undefined when calling getDocumentById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/documents/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
  }
  /**
   * Returns a single document
   * Get a document
   */
  async getDocumentById(requestParameters, initOverrides) {
    const response = await this.getDocumentByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Gets all entitlements for a resource
   * Gets all entitlements for a resource
   */
  async getEntitlementsForResourceRaw(requestParameters, initOverrides) {
    if (requestParameters.resourceId === null || requestParameters.resourceId === void 0) {
      throw new RequiredError("resourceId", "Required parameter requestParameters.resourceId was null or undefined when calling getEntitlementsForResource.");
    }
    const queryParameters = {};
    if (requestParameters.resourceId !== void 0) {
      queryParameters["resourceId"] = requestParameters.resourceId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/entitlements`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EntitlementsResponseFromJSON(jsonValue));
  }
  /**
   * Gets all entitlements for a resource
   * Gets all entitlements for a resource
   */
  async getEntitlementsForResource(requestParameters, initOverrides) {
    const response = await this.getEntitlementsForResourceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getEnumWeightsRaw(requestParameters, initOverrides) {
    if (requestParameters.getEnumWeightsRequest === null || requestParameters.getEnumWeightsRequest === void 0) {
      throw new RequiredError("getEnumWeightsRequest", "Required parameter requestParameters.getEnumWeightsRequest was null or undefined when calling getEnumWeights.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/mapping/enum-weights`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: GetEnumWeightsRequestToJSON(requestParameters.getEnumWeightsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SourceDestinationWeightsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getEnumWeights(requestParameters, initOverrides) {
    const response = await this.getEnumWeightsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get all executions in your environment
   */
  async getEnvironmentAgentExecutionsRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getEnvironmentAgentExecutions.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    if (requestParameters.success !== void 0) {
      queryParameters["success"] = requestParameters.success;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents/executions`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ExecutionsResponseFromJSON(jsonValue));
  }
  /**
   * Get all executions in your environment
   */
  async getEnvironmentAgentExecutions(requestParameters, initOverrides) {
    const response = await this.getEnvironmentAgentExecutionsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get an agent log
   */
  async getEnvironmentAgentLogRaw(requestParameters, initOverrides) {
    if (requestParameters.eventId === null || requestParameters.eventId === void 0) {
      throw new RequiredError("eventId", "Required parameter requestParameters.eventId was null or undefined when calling getEnvironmentAgentLog.");
    }
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getEnvironmentAgentLog.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents/log/{eventId}`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AgentLogResponseFromJSON(jsonValue));
  }
  /**
   * Get an agent log
   */
  async getEnvironmentAgentLog(requestParameters, initOverrides) {
    const response = await this.getEnvironmentAgentLogRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get all agent logs in your environment
   */
  async getEnvironmentAgentLogsRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getEnvironmentAgentLogs.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    if (requestParameters.success !== void 0) {
      queryParameters["success"] = requestParameters.success;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents/logs`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AgentLogsResponse1FromJSON(jsonValue));
  }
  /**
   * Get all agent logs in your environment
   */
  async getEnvironmentAgentLogs(requestParameters, initOverrides) {
    const response = await this.getEnvironmentAgentLogsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a single environment
   * Get an environment
   */
  async getEnvironmentByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getEnvironmentById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EnvironmentResponseFromJSON(jsonValue));
  }
  /**
   * Returns a single environment
   * Get an environment
   */
  async getEnvironmentById(requestParameters, initOverrides) {
    const response = await this.getEnvironmentByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get a token which can be used to subscribe to events for this environment
   * Get environment subscription credentials
   */
  async getEnvironmentEventTokenRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getEnvironmentEventToken.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/subscription-token`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EventTokenResponseFromJSON(jsonValue));
  }
  /**
   * Get a token which can be used to subscribe to events for this environment
   * Get environment subscription credentials
   */
  async getEnvironmentEventToken(requestParameters, initOverrides) {
    const response = await this.getEnvironmentEventTokenRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns environment stats
   * Get environment stats
   */
  async getEnvironmentStatsRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getEnvironmentStats.");
    }
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.start !== void 0) {
      queryParameters["start"] = requestParameters.start.toISOString();
    }
    if (requestParameters.end !== void 0) {
      queryParameters["end"] = requestParameters.end.toISOString();
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/agents/stats`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EnvironmentStatsResponseFromJSON(jsonValue));
  }
  /**
   * Returns environment stats
   * Get environment stats
   */
  async getEnvironmentStats(requestParameters, initOverrides) {
    const response = await this.getEnvironmentStatsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get all environments
   * List environments
   */
  async getEnvironmentsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EnvironmentsResponseFromJSON(jsonValue));
  }
  /**
   * Get all environments
   * List environments
   */
  async getEnvironments(requestParameters = {}, initOverrides) {
    const response = await this.getEnvironmentsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get an event
   */
  async getEventRaw(requestParameters, initOverrides) {
    if (requestParameters.eventId === null || requestParameters.eventId === void 0) {
      throw new RequiredError("eventId", "Required parameter requestParameters.eventId was null or undefined when calling getEvent.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/events/{eventId}`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EventResponseFromJSON(jsonValue));
  }
  /**
   * Get an event
   */
  async getEvent(requestParameters, initOverrides) {
    const response = await this.getEventRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get an event
   */
  async getEventDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getEventDeprecated.");
    }
    if (requestParameters.eventId === null || requestParameters.eventId === void 0) {
      throw new RequiredError("eventId", "Required parameter requestParameters.eventId was null or undefined when calling getEventDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}/events/{eventId}`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EventResponseFromJSON(jsonValue));
  }
  /**
   * Get an event
   */
  async getEventDeprecated(requestParameters, initOverrides) {
    const response = await this.getEventDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get a token which can be used to subscribe to events for this space
   * Get subscription credentials
   */
  async getEventTokenRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    if (requestParameters.scope !== void 0) {
      queryParameters["scope"] = requestParameters.scope;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/subscription`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EventTokenResponseFromJSON(jsonValue));
  }
  /**
   * Get a token which can be used to subscribe to events for this space
   * Get subscription credentials
   */
  async getEventToken(requestParameters = {}, initOverrides) {
    const response = await this.getEventTokenRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get a token which can be used to subscribe to events for this space
   * Get subscription credentials
   */
  async getEventTokenDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling getEventTokenDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/subscription`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EventTokenResponseFromJSON(jsonValue));
  }
  /**
   * Get a token which can be used to subscribe to events for this space
   * Get subscription credentials
   */
  async getEventTokenDeprecated(requestParameters, initOverrides) {
    const response = await this.getEventTokenDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get all events
   */
  async getEventsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    if (requestParameters.domain !== void 0) {
      queryParameters["domain"] = requestParameters.domain;
    }
    if (requestParameters.topic !== void 0) {
      queryParameters["topic"] = requestParameters.topic;
    }
    if (requestParameters.since !== void 0) {
      queryParameters["since"] = requestParameters.since.toISOString();
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.includeAcknowledged !== void 0) {
      queryParameters["includeAcknowledged"] = requestParameters.includeAcknowledged;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/events`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EventsResponseFromJSON(jsonValue));
  }
  /**
   * Get all events
   */
  async getEvents(requestParameters = {}, initOverrides) {
    const response = await this.getEventsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * List events
   */
  async getEventsDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling getEventsDeprecated.");
    }
    const queryParameters = {};
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    if (requestParameters.domain !== void 0) {
      queryParameters["domain"] = requestParameters.domain;
    }
    if (requestParameters.topic !== void 0) {
      queryParameters["topic"] = requestParameters.topic;
    }
    if (requestParameters.since !== void 0) {
      queryParameters["since"] = requestParameters.since.toISOString();
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.includeAcknowledged !== void 0) {
      queryParameters["includeAcknowledged"] = requestParameters.includeAcknowledged;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}/events`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EventsResponseFromJSON(jsonValue));
  }
  /**
   * List events
   */
  async getEventsDeprecated(requestParameters, initOverrides) {
    const response = await this.getEventsDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getFieldWeightsRaw(requestParameters, initOverrides) {
    if (requestParameters.getFieldWeightsRequest === null || requestParameters.getFieldWeightsRequest === void 0) {
      throw new RequiredError("getFieldWeightsRequest", "Required parameter requestParameters.getFieldWeightsRequest was null or undefined when calling getFieldWeights.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/mapping/field-weights`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: GetFieldWeightsRequestToJSON(requestParameters.getFieldWeightsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SourceDestinationWeightsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getFieldWeights(requestParameters, initOverrides) {
    const response = await this.getFieldWeightsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get a file
   */
  async getFileRaw(requestParameters, initOverrides) {
    if (requestParameters.fileId === null || requestParameters.fileId === void 0) {
      throw new RequiredError("fileId", "Required parameter requestParameters.fileId was null or undefined when calling getFile.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/files/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => FileResponseFromJSON(jsonValue));
  }
  /**
   * Get a file
   */
  async getFile(requestParameters, initOverrides) {
    const response = await this.getFileRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * List files
   */
  async getFilesRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.mode !== void 0) {
      queryParameters["mode"] = requestParameters.mode;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/files`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => FilesResponseFromJSON(jsonValue));
  }
  /**
   * List files
   */
  async getFiles(requestParameters = {}, initOverrides) {
    const response = await this.getFilesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a single guest token
   * Get a guest token
   */
  async getGuestTokenRaw(requestParameters, initOverrides) {
    if (requestParameters.guestId === null || requestParameters.guestId === void 0) {
      throw new RequiredError("guestId", "Required parameter requestParameters.guestId was null or undefined when calling getGuestToken.");
    }
    const queryParameters = {};
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/guests/{guestId}/token`.replace(`{${"guestId"}}`, encodeURIComponent(String(requestParameters.guestId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ExchangeTokenResponseFromJSON(jsonValue));
  }
  /**
   * Returns a single guest token
   * Get a guest token
   */
  async getGuestToken(requestParameters, initOverrides) {
    const response = await this.getGuestTokenRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns all guests
   * List guests
   */
  async getGuestsRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling getGuests.");
    }
    const queryParameters = {};
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    if (requestParameters.email !== void 0) {
      queryParameters["email"] = requestParameters.email;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/guests`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GuestsResponseFromJSON(jsonValue));
  }
  /**
   * Returns all guests
   * List guests
   */
  async getGuests(requestParameters, initOverrides) {
    const response = await this.getGuestsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Health check
   */
  async getHealthCheckRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/health`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => HealthResponseFromJSON(jsonValue));
  }
  /**
   * Health check
   */
  async getHealthCheck(initOverrides) {
    const response = await this.getHealthCheckRaw(initOverrides);
    return await response.value();
  }
  /**
   * Get a job
   */
  async getJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling getJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
  }
  /**
   * Get a job
   */
  async getJob(requestParameters, initOverrides) {
    const response = await this.getJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a single job\'s execution plan
   * Get a job\'s execution plan
   */
  async getJobExecutionPlanRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling getJobExecutionPlan.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/plan`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobPlanResponseFromJSON(jsonValue));
  }
  /**
   * Returns a single job\'s execution plan
   * Get a job\'s execution plan
   */
  async getJobExecutionPlan(requestParameters, initOverrides) {
    const response = await this.getJobExecutionPlanRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns job performance report as a CSV
   * Get job performance report
   */
  async getJobPerformanceReportRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/report`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new TextApiResponse(response);
  }
  /**
   * Returns job performance report as a CSV
   * Get job performance report
   */
  async getJobPerformanceReport(initOverrides) {
    const response = await this.getJobPerformanceReportRaw(initOverrides);
    return await response.value();
  }
  /**
   * List jobs
   */
  async getJobsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    if (requestParameters.workbookId !== void 0) {
      queryParameters["workbookId"] = requestParameters.workbookId;
    }
    if (requestParameters.fileId !== void 0) {
      queryParameters["fileId"] = requestParameters.fileId;
    }
    if (requestParameters.parentId !== void 0) {
      queryParameters["parentId"] = requestParameters.parentId;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.sortDirection !== void 0) {
      queryParameters["sortDirection"] = requestParameters.sortDirection;
    }
    if (requestParameters.excludeChildJobs !== void 0) {
      queryParameters["excludeChildJobs"] = requestParameters.excludeChildJobs;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobsResponseFromJSON(jsonValue));
  }
  /**
   * List jobs
   */
  async getJobs(requestParameters = {}, initOverrides) {
    const response = await this.getJobsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns job stats
   * Get job stats
   */
  async getJobsStatsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.start !== void 0) {
      queryParameters["start"] = requestParameters.start.toISOString();
    }
    if (requestParameters.end !== void 0) {
      queryParameters["end"] = requestParameters.end.toISOString();
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/stats`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobStatsResponseFromJSON(jsonValue));
  }
  /**
   * Returns job stats
   * Get job stats
   */
  async getJobsStats(requestParameters = {}, initOverrides) {
    const response = await this.getJobsStatsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns the limits for the current user
   */
  async getLimitsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/billing/limits`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => BillingLimitsResponseFromJSON(jsonValue));
  }
  /**
   * Returns the limits for the current user
   */
  async getLimits(initOverrides) {
    const response = await this.getLimitsRaw(initOverrides);
    return await response.value();
  }
  /**
   * Returns the plan for the current user
   */
  async getPlanRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/billing/plan`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => BillingPlanWithUsageResponseFromJSON(jsonValue));
  }
  /**
   * Returns the plan for the current user
   */
  async getPlan(initOverrides) {
    const response = await this.getPlanRaw(initOverrides);
    return await response.value();
  }
  /**
   * List the available products
   */
  async getProductsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.filterMetadata !== void 0) {
      queryParameters["filterMetadata"] = requestParameters.filterMetadata;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/billing/products`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ProductsResponseFromJSON(jsonValue));
  }
  /**
   * List the available products
   */
  async getProducts(requestParameters = {}, initOverrides) {
    const response = await this.getProductsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getProgramRaw(requestParameters, initOverrides) {
    if (requestParameters.programId === null || requestParameters.programId === void 0) {
      throw new RequiredError("programId", "Required parameter requestParameters.programId was null or undefined when calling getProgram.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/mapping/{programId}`.replace(`{${"programId"}}`, encodeURIComponent(String(requestParameters.programId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ProgramResponseFromJSON(jsonValue));
  }
  /**
   */
  async getProgram(requestParameters, initOverrides) {
    const response = await this.getProgramRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a prompt
   * Returns a prompt
   */
  async getPromptRaw(requestParameters, initOverrides) {
    if (requestParameters.promptId === null || requestParameters.promptId === void 0) {
      throw new RequiredError("promptId", "Required parameter requestParameters.promptId was null or undefined when calling getPrompt.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/prompts/{promptId}`.replace(`{${"promptId"}}`, encodeURIComponent(String(requestParameters.promptId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => PromptResponseFromJSON(jsonValue));
  }
  /**
   * Returns a prompt
   * Returns a prompt
   */
  async getPrompt(requestParameters, initOverrides) {
    const response = await this.getPromptRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns prompts created by user
   * Returns prompts created by user
   */
  async getPromptsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/prompts`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => PromptsResponseFromJSON(jsonValue));
  }
  /**
   * Returns prompts created by user
   * Returns prompts created by user
   */
  async getPrompts(requestParameters = {}, initOverrides) {
    const response = await this.getPromptsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns records from a sheet in a workbook
   * Get records
   */
  async getRecordsRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling getRecords.");
    }
    const queryParameters = {};
    if (requestParameters.versionId !== void 0) {
      queryParameters["versionId"] = requestParameters.versionId;
    }
    if (requestParameters.commitId !== void 0) {
      queryParameters["commitId"] = requestParameters.commitId;
    }
    if (requestParameters.sinceVersionId !== void 0) {
      queryParameters["sinceVersionId"] = requestParameters.sinceVersionId;
    }
    if (requestParameters.sinceCommitId !== void 0) {
      queryParameters["sinceCommitId"] = requestParameters.sinceCommitId;
    }
    if (requestParameters.sortField !== void 0) {
      queryParameters["sortField"] = requestParameters.sortField;
    }
    if (requestParameters.sortDirection !== void 0) {
      queryParameters["sortDirection"] = requestParameters.sortDirection;
    }
    if (requestParameters.filter !== void 0) {
      queryParameters["filter"] = requestParameters.filter;
    }
    if (requestParameters.filterField !== void 0) {
      queryParameters["filterField"] = requestParameters.filterField;
    }
    if (requestParameters.searchValue !== void 0) {
      queryParameters["searchValue"] = requestParameters.searchValue;
    }
    if (requestParameters.searchField !== void 0) {
      queryParameters["searchField"] = requestParameters.searchField;
    }
    if (requestParameters.ids) {
      queryParameters["ids"] = requestParameters.ids;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.includeLinks !== void 0) {
      queryParameters["includeLinks"] = requestParameters.includeLinks;
    }
    if (requestParameters.includeMessages !== void 0) {
      queryParameters["includeMessages"] = requestParameters.includeMessages;
    }
    if (requestParameters._for !== void 0) {
      queryParameters["for"] = requestParameters._for;
    }
    if (requestParameters.q !== void 0) {
      queryParameters["q"] = requestParameters.q;
    }
    if (requestParameters.includeLength !== void 0) {
      queryParameters["includeLength"] = requestParameters.includeLength;
    }
    if (requestParameters.includeCounts !== void 0) {
      queryParameters["includeCounts"] = requestParameters.includeCounts;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/records`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetRecordsResponseFromJSON(jsonValue));
  }
  /**
   * Returns records from a sheet in a workbook
   * Get records
   */
  async getRecords(requestParameters, initOverrides) {
    const response = await this.getRecordsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns records from a sheet in a workbook as a csv file
   * Download records as a CSV file
   */
  async getRecordsCsvRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling getRecordsCsv.");
    }
    const queryParameters = {};
    if (requestParameters.versionId !== void 0) {
      queryParameters["versionId"] = requestParameters.versionId;
    }
    if (requestParameters.commitId !== void 0) {
      queryParameters["commitId"] = requestParameters.commitId;
    }
    if (requestParameters.sinceVersionId !== void 0) {
      queryParameters["sinceVersionId"] = requestParameters.sinceVersionId;
    }
    if (requestParameters.sinceCommitId !== void 0) {
      queryParameters["sinceCommitId"] = requestParameters.sinceCommitId;
    }
    if (requestParameters.sortField !== void 0) {
      queryParameters["sortField"] = requestParameters.sortField;
    }
    if (requestParameters.sortDirection !== void 0) {
      queryParameters["sortDirection"] = requestParameters.sortDirection;
    }
    if (requestParameters.filter !== void 0) {
      queryParameters["filter"] = requestParameters.filter;
    }
    if (requestParameters.filterField !== void 0) {
      queryParameters["filterField"] = requestParameters.filterField;
    }
    if (requestParameters.searchValue !== void 0) {
      queryParameters["searchValue"] = requestParameters.searchValue;
    }
    if (requestParameters.searchField !== void 0) {
      queryParameters["searchField"] = requestParameters.searchField;
    }
    if (requestParameters.ids) {
      queryParameters["ids"] = requestParameters.ids;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/download`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new BlobApiResponse(response);
  }
  /**
   * Returns records from a sheet in a workbook as a csv file
   * Download records as a CSV file
   */
  async getRecordsCsv(requestParameters, initOverrides) {
    const response = await this.getRecordsCsvRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns records from a sheet in a workbook
   * Get records
   */
  async getRecordsDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling getRecordsDeprecated.");
    }
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling getRecordsDeprecated.");
    }
    const queryParameters = {};
    if (requestParameters.versionId !== void 0) {
      queryParameters["versionId"] = requestParameters.versionId;
    }
    if (requestParameters.commitId !== void 0) {
      queryParameters["commitId"] = requestParameters.commitId;
    }
    if (requestParameters.untilVersionId !== void 0) {
      queryParameters["untilVersionId"] = requestParameters.untilVersionId;
    }
    if (requestParameters.untilCommitId !== void 0) {
      queryParameters["untilCommitId"] = requestParameters.untilCommitId;
    }
    if (requestParameters.sinceVersionId !== void 0) {
      queryParameters["sinceVersionId"] = requestParameters.sinceVersionId;
    }
    if (requestParameters.sinceCommitId !== void 0) {
      queryParameters["sinceCommitId"] = requestParameters.sinceCommitId;
    }
    if (requestParameters.sortField !== void 0) {
      queryParameters["sortField"] = requestParameters.sortField;
    }
    if (requestParameters.sortDirection !== void 0) {
      queryParameters["sortDirection"] = requestParameters.sortDirection;
    }
    if (requestParameters.filter !== void 0) {
      queryParameters["filter"] = requestParameters.filter;
    }
    if (requestParameters.filterField !== void 0) {
      queryParameters["filterField"] = requestParameters.filterField;
    }
    if (requestParameters.searchValue !== void 0) {
      queryParameters["searchValue"] = requestParameters.searchValue;
    }
    if (requestParameters.searchField !== void 0) {
      queryParameters["searchField"] = requestParameters.searchField;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.includeCounts !== void 0) {
      queryParameters["includeCounts"] = requestParameters.includeCounts;
    }
    if (requestParameters.includeLinks !== void 0) {
      queryParameters["includeLinks"] = requestParameters.includeLinks;
    }
    if (requestParameters.includeMessages !== void 0) {
      queryParameters["includeMessages"] = requestParameters.includeMessages;
    }
    if (requestParameters.fields) {
      queryParameters["fields"] = requestParameters.fields;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}/sheets/{sheetId}/records`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))).replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RecordsResponseFromJSON(jsonValue));
  }
  /**
   * Returns records from a sheet in a workbook
   * Get records
   */
  async getRecordsDeprecated(requestParameters, initOverrides) {
    const response = await this.getRecordsDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getRulesRaw(requestParameters, initOverrides) {
    if (requestParameters.programId === null || requestParameters.programId === void 0) {
      throw new RequiredError("programId", "Required parameter requestParameters.programId was null or undefined when calling getRules.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/mapping/{programId}/rules`.replace(`{${"programId"}}`, encodeURIComponent(String(requestParameters.programId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RulesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getRules(requestParameters, initOverrides) {
    const response = await this.getRulesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Fetch all secrets for a given environmentId and optionally apply space overrides
   * List all Secrets for an Environment or Environment + Space
   */
  async getSecretsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.spaceId !== void 0) {
      queryParameters["spaceId"] = requestParameters.spaceId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/secrets`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SecretsResponseFromJSON(jsonValue));
  }
  /**
   * Fetch all secrets for a given environmentId and optionally apply space overrides
   * List all Secrets for an Environment or Environment + Space
   */
  async getSecrets(requestParameters = {}, initOverrides) {
    const response = await this.getSecretsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a specific sheet from a workbook
   * Get a sheet
   */
  async getSheetRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling getSheet.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SheetResponseFromJSON(jsonValue));
  }
  /**
   * Returns a specific sheet from a workbook
   * Get a sheet
   */
  async getSheet(requestParameters, initOverrides) {
    const response = await this.getSheetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns the commit versions for a sheet
   */
  async getSheetCommitsRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling getSheetCommits.");
    }
    const queryParameters = {};
    if (requestParameters.completed !== void 0) {
      queryParameters["completed"] = requestParameters.completed;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/commits`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetSheetCommitsResponseFromJSON(jsonValue));
  }
  /**
   * Returns the commit versions for a sheet
   */
  async getSheetCommits(requestParameters, initOverrides) {
    const response = await this.getSheetCommitsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns sheets from a workbook
   * Get all sheets
   */
  async getSheetsRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling getSheets.");
    }
    const queryParameters = {};
    if (requestParameters.workbookId !== void 0) {
      queryParameters["workbookId"] = requestParameters.workbookId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SheetsResponseFromJSON(jsonValue));
  }
  /**
   * Returns sheets from a workbook
   * Get all sheets
   */
  async getSheets(requestParameters, initOverrides) {
    const response = await this.getSheetsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns sheets from a workbook
   */
  async getSheetsDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling getSheetsDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}/sheets`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SheetsResponseFromJSON(jsonValue));
  }
  /**
   * Returns sheets from a workbook
   */
  async getSheetsDeprecated(requestParameters, initOverrides) {
    const response = await this.getSheetsDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get a snapshot of a sheet
   * Get snapshot
   */
  async getSnapshotRaw(requestParameters, initOverrides) {
    if (requestParameters.snapshotId === null || requestParameters.snapshotId === void 0) {
      throw new RequiredError("snapshotId", "Required parameter requestParameters.snapshotId was null or undefined when calling getSnapshot.");
    }
    const queryParameters = {};
    if (requestParameters.includeSummary !== void 0) {
      queryParameters["includeSummary"] = requestParameters.includeSummary;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/snapshots/{snapshotId}`.replace(`{${"snapshotId"}}`, encodeURIComponent(String(requestParameters.snapshotId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SnapshotResponseFromJSON(jsonValue));
  }
  /**
   * Get a snapshot of a sheet
   * Get snapshot
   */
  async getSnapshot(requestParameters, initOverrides) {
    const response = await this.getSnapshotRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Get records from a time period
   * Get records
   */
  async getSnapshotRecordsRaw(requestParameters, initOverrides) {
    if (requestParameters.snapshotId === null || requestParameters.snapshotId === void 0) {
      throw new RequiredError("snapshotId", "Required parameter requestParameters.snapshotId was null or undefined when calling getSnapshotRecords.");
    }
    const queryParameters = {};
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.changeType !== void 0) {
      queryParameters["changeType"] = requestParameters.changeType;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/snapshots/{snapshotId}/records`.replace(`{${"snapshotId"}}`, encodeURIComponent(String(requestParameters.snapshotId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DiffRecordsResponseFromJSON(jsonValue));
  }
  /**
   * Get records from a time period
   * Get records
   */
  async getSnapshotRecords(requestParameters, initOverrides) {
    const response = await this.getSnapshotRecordsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * List all snapshots of a sheet
   * List snapshots
   */
  async getSnapshotsRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling getSnapshots.");
    }
    const queryParameters = {};
    if (requestParameters.sheetId !== void 0) {
      queryParameters["sheetId"] = requestParameters.sheetId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/snapshots`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SnapshotsResponseFromJSON(jsonValue));
  }
  /**
   * List all snapshots of a sheet
   * List snapshots
   */
  async getSnapshots(requestParameters, initOverrides) {
    const response = await this.getSnapshotsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns the contents of manifest.json
   */
  async getSoftwareManifestRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/manifest`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ManifestResponseFromJSON(jsonValue));
  }
  /**
   * Returns the contents of manifest.json
   */
  async getSoftwareManifest(initOverrides) {
    const response = await this.getSoftwareManifestRaw(initOverrides);
    return await response.value();
  }
  /**
   * Returns a list of activities that have occurred in a space and who initiated those activities
   * Get the activity for a Space
   */
  async getSpaceActivityRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling getSpaceActivity.");
    }
    const queryParameters = {};
    if (requestParameters.sortField !== void 0) {
      queryParameters["sortField"] = requestParameters.sortField;
    }
    if (requestParameters.sortDirection !== void 0) {
      queryParameters["sortDirection"] = requestParameters.sortDirection;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.activity !== void 0) {
      queryParameters["activity"] = requestParameters.activity;
    }
    if (requestParameters.since !== void 0) {
      queryParameters["since"] = requestParameters.since;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/activity`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ActivitiesResponseFromJSON(jsonValue));
  }
  /**
   * Returns a list of activities that have occurred in a space and who initiated those activities
   * Get the activity for a Space
   */
  async getSpaceActivity(requestParameters, initOverrides) {
    const response = await this.getSpaceActivityRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns an access token for this space
   * Generates a new access token scoped to only this space
   */
  async getSpaceAuthRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling getSpaceAuth.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/auth`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AccessTokenResponseFromJSON(jsonValue));
  }
  /**
   * Returns an access token for this space
   * Generates a new access token scoped to only this space
   */
  async getSpaceAuth(requestParameters, initOverrides) {
    const response = await this.getSpaceAuthRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a single space
   * Get a space
   */
  async getSpaceByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling getSpaceById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpaceResponseFromJSON(jsonValue));
  }
  /**
   * Returns a single space
   * Get a space
   */
  async getSpaceById(requestParameters, initOverrides) {
    const response = await this.getSpaceByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a single document
   * Get a document
   */
  async getSpaceDocumentByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling getSpaceDocumentById.");
    }
    if (requestParameters.documentId === null || requestParameters.documentId === void 0) {
      throw new RequiredError("documentId", "Required parameter requestParameters.documentId was null or undefined when calling getSpaceDocumentById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/documents/{documentId}`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
  }
  /**
   * Returns a single document
   * Get a document
   */
  async getSpaceDocumentById(requestParameters, initOverrides) {
    const response = await this.getSpaceDocumentByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns all documents for a space
   * List documents
   */
  async getSpaceDocumentsRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling getSpaceDocuments.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/documents`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DocumentsResponseFromJSON(jsonValue));
  }
  /**
   * Returns all documents for a space
   * List documents
   */
  async getSpaceDocuments(requestParameters, initOverrides) {
    const response = await this.getSpaceDocumentsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a single guest
   * Get a guest
   */
  async getSpaceGuestByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.guestId === null || requestParameters.guestId === void 0) {
      throw new RequiredError("guestId", "Required parameter requestParameters.guestId was null or undefined when calling getSpaceGuestById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/guests/{guestId}`.replace(`{${"guestId"}}`, encodeURIComponent(String(requestParameters.guestId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GuestResponseFromJSON(jsonValue));
  }
  /**
   * Returns a single guest
   * Get a guest
   */
  async getSpaceGuestById(requestParameters, initOverrides) {
    const response = await this.getSpaceGuestByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns the subscriptions for the current user
   */
  async getSubscriptionsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/billing/subscriptions`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => BillingSubscriptionsResponseFromJSON(jsonValue));
  }
  /**
   * Returns the subscriptions for the current user
   */
  async getSubscriptions(initOverrides) {
    const response = await this.getSubscriptionsRaw(initOverrides);
    return await response.value();
  }
  /**
   * Gets a user
   * Get a user
   */
  async getUserRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling getUser.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
  }
  /**
   * Gets a user
   * Get a user
   */
  async getUser(requestParameters, initOverrides) {
    const response = await this.getUserRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Lists roles assigned to a user
   * List User Roles
   */
  async getUserRolesRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling getUserRoles.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}/roles`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ListActorRolesResponseFromJSON(jsonValue));
  }
  /**
   * Lists roles assigned to a user
   * List User Roles
   */
  async getUserRoles(requestParameters, initOverrides) {
    const response = await this.getUserRolesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Gets a list of users
   * List users
   */
  async getUsersRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.email !== void 0) {
      queryParameters["email"] = requestParameters.email;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.sortField !== void 0) {
      queryParameters["sortField"] = requestParameters.sortField;
    }
    if (requestParameters.sortDirection !== void 0) {
      queryParameters["sortDirection"] = requestParameters.sortDirection;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UsersResponseFromJSON(jsonValue));
  }
  /**
   * Gets a list of users
   * List users
   */
  async getUsers(requestParameters = {}, initOverrides) {
    const response = await this.getUsersRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a single view
   * Returns a view
   */
  async getViewRaw(requestParameters, initOverrides) {
    if (requestParameters.viewId === null || requestParameters.viewId === void 0) {
      throw new RequiredError("viewId", "Required parameter requestParameters.viewId was null or undefined when calling getView.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/views/{viewId}`.replace(`{${"viewId"}}`, encodeURIComponent(String(requestParameters.viewId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ViewResponseFromJSON(jsonValue));
  }
  /**
   * Returns a single view
   * Returns a view
   */
  async getView(requestParameters, initOverrides) {
    const response = await this.getViewRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * List views by Sheet
   * Returns all views for the sheet
   */
  async getViewsRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling getViews.");
    }
    const queryParameters = {};
    if (requestParameters.sheetId !== void 0) {
      queryParameters["sheetId"] = requestParameters.sheetId;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/views`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ViewsResponseFromJSON(jsonValue));
  }
  /**
   * List views by Sheet
   * Returns all views for the sheet
   */
  async getViews(requestParameters, initOverrides) {
    const response = await this.getViewsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns a single workbook
   * Get a workbook
   */
  async getWorkbookByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling getWorkbookById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => WorkbookResponseFromJSON(jsonValue));
  }
  /**
   * Returns a single workbook
   * Get a workbook
   */
  async getWorkbookById(requestParameters, initOverrides) {
    const response = await this.getWorkbookByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Returns the sheet commits for an entire workbook
   */
  async getWorkbookCommitsRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling getWorkbookCommits.");
    }
    const queryParameters = {};
    if (requestParameters.completed !== void 0) {
      queryParameters["completed"] = requestParameters.completed;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}/commits`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetWorkbookCommitsResponseFromJSON(jsonValue));
  }
  /**
   * Returns the sheet commits for an entire workbook
   */
  async getWorkbookCommits(requestParameters, initOverrides) {
    const response = await this.getWorkbookCommitsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Receives data when a user accepted the invite with Frontegg
   * Handle accept invite webhooks
   */
  async handleAcceptInviteRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/frontegg/accept-invite`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: FronteggSignupToJSON(requestParameters.fronteggSignup)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
  }
  /**
   * Receives data when a user accepted the invite with Frontegg
   * Handle accept invite webhooks
   */
  async handleAcceptInvite(requestParameters = {}, initOverrides) {
    const response = await this.handleAcceptInviteRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Handles events coming from Stripe
   * Handle an incoming GET request from Stripe
   */
  async handleStripWebgetRaw(requestParameters, initOverrides) {
    if (requestParameters.sessionId === null || requestParameters.sessionId === void 0) {
      throw new RequiredError("sessionId", "Required parameter requestParameters.sessionId was null or undefined when calling handleStripWebget.");
    }
    const queryParameters = {};
    if (requestParameters.sessionId !== void 0) {
      queryParameters["session_id"] = requestParameters.sessionId;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/webhook/stripe`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Handles events coming from Stripe
   * Handle an incoming GET request from Stripe
   */
  async handleStripWebget(requestParameters, initOverrides) {
    const response = await this.handleStripWebgetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Handles events coming from Stripe
   * Handle an incoming Stripe webhook
   */
  async handleStripeWebhookRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/webhook/stripe`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: StripeWebhookRequestBodyToJSON(requestParameters.stripeWebhookRequestBody)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Handles events coming from Stripe
   * Handle an incoming Stripe webhook
   */
  async handleStripeWebhook(requestParameters = {}, initOverrides) {
    const response = await this.handleStripeWebhookRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Receives data when a user has activated their Frontegg account
   * Handle user activate webhooks
   */
  async handleUserActivateRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/frontegg/activate`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: FronteggSignupToJSON(requestParameters.fronteggSignup)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
  }
  /**
   * Receives data when a user has activated their Frontegg account
   * Handle user activate webhooks
   */
  async handleUserActivate(requestParameters = {}, initOverrides) {
    const response = await this.handleUserActivateRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Receives data when a user is invited with Frontegg
   * Handle user invite webhooks
   */
  async handleUserInviteRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/frontegg/invite`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: FronteggSignupToJSON(requestParameters.fronteggSignup)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
  }
  /**
   * Receives data when a user is invited with Frontegg
   * Handle user invite webhooks
   */
  async handleUserInvite(requestParameters = {}, initOverrides) {
    const response = await this.handleUserInviteRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Receives data when a user is signed up with Frontegg
   * Handle user sign up webhooks
   */
  async handleUserSignUpRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/frontegg/sign-up`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: FronteggSignupToJSON(requestParameters.fronteggSignup)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
  }
  /**
   * Receives data when a user is signed up with Frontegg
   * Handle user sign up webhooks
   */
  async handleUserSignUp(requestParameters = {}, initOverrides) {
    const response = await this.handleUserSignUpRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Sends an invite each guest
   * Invite guests
   */
  async inviteGuestsRaw(requestParameters, initOverrides) {
    if (requestParameters.inviteGuestsRequestInner === null || requestParameters.inviteGuestsRequestInner === void 0) {
      throw new RequiredError("inviteGuestsRequestInner", "Required parameter requestParameters.inviteGuestsRequestInner was null or undefined when calling inviteGuests.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invitations`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters.inviteGuestsRequestInner.map(InviteGuestsRequestInnerToJSON)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Sends an invite each guest
   * Invite guests
   */
  async inviteGuests(requestParameters, initOverrides) {
    const response = await this.inviteGuestsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Fetch a list of mapping programs
   */
  async listMappingProgramsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    if (requestParameters.createdBy !== void 0) {
      queryParameters["createdBy"] = requestParameters.createdBy;
    }
    if (requestParameters.createdAfter !== void 0) {
      queryParameters["createdAfter"] = requestParameters.createdAfter.toISOString();
    }
    if (requestParameters.createdBefore !== void 0) {
      queryParameters["createdBefore"] = requestParameters.createdBefore.toISOString();
    }
    if (requestParameters.environmentId !== void 0) {
      queryParameters["environmentId"] = requestParameters.environmentId;
    }
    if (requestParameters.sourceKeys !== void 0) {
      queryParameters["sourceKeys"] = requestParameters.sourceKeys;
    }
    if (requestParameters.destinationKeys !== void 0) {
      queryParameters["destinationKeys"] = requestParameters.destinationKeys;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/mapping`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ProgramsResponseFromJSON(jsonValue));
  }
  /**
   * Fetch a list of mapping programs
   */
  async listMappingPrograms(requestParameters = {}, initOverrides) {
    const response = await this.listMappingProgramsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * List all roles for an account
   * List Roles
   */
  async listRolesRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/roles`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ListRolesResponseFromJSON(jsonValue));
  }
  /**
   * List all roles for an account
   * List Roles
   */
  async listRoles(initOverrides) {
    const response = await this.listRolesRaw(initOverrides);
    return await response.value();
  }
  /**
   * Locks a sheet to prevent further changes
   * Lock a sheet
   */
  async lockSheetRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling lockSheet.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/lock`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Locks a sheet to prevent further changes
   * Lock a sheet
   */
  async lockSheet(requestParameters, initOverrides) {
    const response = await this.lockSheetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Preview a mutation
   * Preview a mutation
   */
  async previewMutationRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/preview-mutation`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: MutateJobConfigToJSON(requestParameters.mutateJobConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DiffRecordsResponseFromJSON(jsonValue));
  }
  /**
   * Preview a mutation
   * Preview a mutation
   */
  async previewMutation(requestParameters = {}, initOverrides) {
    const response = await this.previewMutationRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Restore a sheet to a previous snapshot
   * Restore snapshot
   */
  async putSnapshotRaw(requestParameters, initOverrides) {
    if (requestParameters.snapshotId === null || requestParameters.snapshotId === void 0) {
      throw new RequiredError("snapshotId", "Required parameter requestParameters.snapshotId was null or undefined when calling putSnapshot.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/snapshots/{snapshotId}`.replace(`{${"snapshotId"}}`, encodeURIComponent(String(requestParameters.snapshotId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SnapshotResponseFromJSON(jsonValue));
  }
  /**
   * Restore a sheet to a previous snapshot
   * Restore snapshot
   */
  async putSnapshot(requestParameters, initOverrides) {
    const response = await this.putSnapshotRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Rebuild a workbook
   * Rebuild a workbook
   */
  async rebuildWorkbookRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling rebuildWorkbook.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}/rebuild`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Rebuild a workbook
   * Rebuild a workbook
   */
  async rebuildWorkbook(requestParameters, initOverrides) {
    const response = await this.rebuildWorkbookRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * This endpoint handles an incoming GET request with query parameters from Google Drive and redirects the request to Paragon, preserving the original query parameters.
   * Handle an incoming GET request from Google Drive and redirects to Paragon
   */
  async redirectToParagonRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.query !== void 0) {
      queryParameters["query"] = requestParameters.query;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/webhook/paragon-redirect`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   * This endpoint handles an incoming GET request with query parameters from Google Drive and redirects the request to Paragon, preserving the original query parameters.
   * Handle an incoming GET request from Google Drive and redirects to Paragon
   */
  async redirectToParagon(requestParameters = {}, initOverrides) {
    await this.redirectToParagonRaw(requestParameters, initOverrides);
  }
  /**
   * Searches for all field values that match the \'searchValue\' and replaces them with the \'replaceValue\'. Wrap \'searchValue\' in double quotes for exact match (\"\"). Returns updated records.
   * Finds and replaces all field values matching search criteria with a given value
   */
  async replaceRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling replace.");
    }
    if (requestParameters.fieldKey === null || requestParameters.fieldKey === void 0) {
      throw new RequiredError("fieldKey", "Required parameter requestParameters.fieldKey was null or undefined when calling replace.");
    }
    if (requestParameters.searchValue === null || requestParameters.searchValue === void 0) {
      throw new RequiredError("searchValue", "Required parameter requestParameters.searchValue was null or undefined when calling replace.");
    }
    if (requestParameters.replaceRequest === null || requestParameters.replaceRequest === void 0) {
      throw new RequiredError("replaceRequest", "Required parameter requestParameters.replaceRequest was null or undefined when calling replace.");
    }
    const queryParameters = {};
    if (requestParameters.fieldKey !== void 0) {
      queryParameters["fieldKey"] = requestParameters.fieldKey;
    }
    if (requestParameters.searchValue !== void 0) {
      queryParameters["searchValue"] = requestParameters.searchValue;
    }
    if (requestParameters.filter !== void 0) {
      queryParameters["filter"] = requestParameters.filter;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.pageNumber !== void 0) {
      queryParameters["pageNumber"] = requestParameters.pageNumber;
    }
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/replace`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ReplaceRequestToJSON(requestParameters.replaceRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RecordsResponseFromJSON(jsonValue));
  }
  /**
   * Searches for all field values that match the \'searchValue\' and replaces them with the \'replaceValue\'. Wrap \'searchValue\' in double quotes for exact match (\"\"). Returns updated records.
   * Finds and replaces all field values matching search criteria with a given value
   */
  async replace(requestParameters, initOverrides) {
    const response = await this.replaceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Replaces an existing Space Config and optionally migrates all spaces using the config
   * Replace a space config
   */
  async replaceSpaceConfigDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.spacePatternConfig === null || requestParameters.spacePatternConfig === void 0) {
      throw new RequiredError("spacePatternConfig", "Required parameter requestParameters.spacePatternConfig was null or undefined when calling replaceSpaceConfigDeprecated.");
    }
    const queryParameters = {};
    if (requestParameters.migrate !== void 0) {
      queryParameters["migrate"] = requestParameters.migrate;
    }
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/configs`,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SpacePatternConfigToJSON(requestParameters.spacePatternConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpaceConfigResponseFromJSON(jsonValue));
  }
  /**
   * Replaces an existing Space Config and optionally migrates all spaces using the config
   * Replace a space config
   */
  async replaceSpaceConfigDeprecated(requestParameters, initOverrides) {
    const response = await this.replaceSpaceConfigDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Replays a commit:created event.
   * Replay a commit:created event
   */
  async replayCommitRaw(requestParameters, initOverrides) {
    if (requestParameters.commitId === null || requestParameters.commitId === void 0) {
      throw new RequiredError("commitId", "Required parameter requestParameters.commitId was null or undefined when calling replayCommit.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/commits/{commitId}/replay`.replace(`{${"commitId"}}`, encodeURIComponent(String(requestParameters.commitId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Replays a commit:created event.
   * Replay a commit:created event
   */
  async replayCommit(requestParameters, initOverrides) {
    const response = await this.replayCommitRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Resends a user invite
   * Resends a user invite
   */
  async resendUserInviteRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling resendUserInvite.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}/resend-invite`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Resends a user invite
   * Resends a user invite
   */
  async resendUserInvite(requestParameters, initOverrides) {
    const response = await this.resendUserInviteRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Restore a database from a backup
   * Restore a database
   */
  async restoreDatabaseRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling restoreDatabase.");
    }
    if (requestParameters.restoreConfig === null || requestParameters.restoreConfig === void 0) {
      throw new RequiredError("restoreConfig", "Required parameter requestParameters.restoreConfig was null or undefined when calling restoreDatabase.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/foreigndb/{workbookId}`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RestoreConfigToJSON(requestParameters.restoreConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RestoreResponseFromJSON(jsonValue));
  }
  /**
   * Restore a database from a backup
   * Restore a database
   */
  async restoreDatabase(requestParameters, initOverrides) {
    const response = await this.restoreDatabaseRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Restore a sheet to a previous snapshot
   * Restore snapshot
   */
  async restoreSnapshotRaw(requestParameters, initOverrides) {
    if (requestParameters.snapshotId === null || requestParameters.snapshotId === void 0) {
      throw new RequiredError("snapshotId", "Required parameter requestParameters.snapshotId was null or undefined when calling restoreSnapshot.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/snapshots/{snapshotId}/restore`.replace(`{${"snapshotId"}}`, encodeURIComponent(String(requestParameters.snapshotId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RestoreSnapshotRequestToJSON(requestParameters.restoreSnapshotRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SnapshotResponseFromJSON(jsonValue));
  }
  /**
   * Restore a sheet to a previous snapshot
   * Restore snapshot
   */
  async restoreSnapshot(requestParameters, initOverrides) {
    const response = await this.restoreSnapshotRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Retry a failed job and return the job
   * Retry a job
   */
  async retryJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling retryJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/retry`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
  }
  /**
   * Retry a failed job and return the job
   * Retry a job
   */
  async retryJob(requestParameters, initOverrides) {
    const response = await this.retryJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Create a snapshot of a sheet
   * Create snapshot
   */
  async snapshotSheetRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/snapshots`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SnapshotSheetRequestToJSON(requestParameters.snapshotSheetRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SnapshotResponseFromJSON(jsonValue));
  }
  /**
   * Create a snapshot of a sheet
   * Create snapshot
   */
  async snapshotSheet(requestParameters = {}, initOverrides) {
    const response = await this.snapshotSheetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Split a job and return the job
   * Split a job
   */
  async splitJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling splitJob.");
    }
    if (requestParameters.jobSplitDetails === null || requestParameters.jobSplitDetails === void 0) {
      throw new RequiredError("jobSplitDetails", "Required parameter requestParameters.jobSplitDetails was null or undefined when calling splitJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/split`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: JobSplitDetailsToJSON(requestParameters.jobSplitDetails)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
  }
  /**
   * Split a job and return the job
   * Split a job
   */
  async splitJob(requestParameters, initOverrides) {
    const response = await this.splitJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Removes a lock from a sheet
   * Unlock a sheet
   */
  async unlockSheetRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling unlockSheet.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/unlock`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Removes a lock from a sheet
   * Unlock a sheet
   */
  async unlockSheet(requestParameters, initOverrides) {
    const response = await this.unlockSheetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Update the default app for the account of the currently authenticated user.
   * Update the default app for the account
   */
  async updateAccountDefaultAppRaw(requestParameters, initOverrides) {
    if (requestParameters.updateAccount === null || requestParameters.updateAccount === void 0) {
      throw new RequiredError("updateAccount", "Required parameter requestParameters.updateAccount was null or undefined when calling updateAccountDefaultApp.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/accounts/current`,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateAccountToJSON(requestParameters.updateAccount)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AccountResponseFromJSON(jsonValue));
  }
  /**
   * Update the default app for the account of the currently authenticated user.
   * Update the default app for the account
   */
  async updateAccountDefaultApp(requestParameters, initOverrides) {
    const response = await this.updateAccountDefaultAppRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Update a Data Retention Policy, to change the type for example
   * Update a Data Retention Policy
   */
  async updateDataRetentionPolicyRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling updateDataRetentionPolicy.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/data-retention-policies/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: DataRetentionPolicyConfigUpdateToJSON(requestParameters.dataRetentionPolicyConfigUpdate)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DataRetentionPolicyResponseFromJSON(jsonValue));
  }
  /**
   * Update a Data Retention Policy, to change the type for example
   * Update a Data Retention Policy
   */
  async updateDataRetentionPolicy(requestParameters, initOverrides) {
    const response = await this.updateDataRetentionPolicyRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * updates a single document, for only the body and title
   * Update a document
   */
  async updateDocumentRaw(requestParameters, initOverrides) {
    if (requestParameters.documentId === null || requestParameters.documentId === void 0) {
      throw new RequiredError("documentId", "Required parameter requestParameters.documentId was null or undefined when calling updateDocument.");
    }
    if (requestParameters.documentConfig === null || requestParameters.documentConfig === void 0) {
      throw new RequiredError("documentConfig", "Required parameter requestParameters.documentConfig was null or undefined when calling updateDocument.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/documents/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: DocumentConfigToJSON(requestParameters.documentConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
  }
  /**
   * updates a single document, for only the body and title
   * Update a document
   */
  async updateDocument(requestParameters, initOverrides) {
    const response = await this.updateDocumentRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Updates a single environment, to change the name for example
   * Update an environment
   */
  async updateEnvironmentByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.environmentId === null || requestParameters.environmentId === void 0) {
      throw new RequiredError("environmentId", "Required parameter requestParameters.environmentId was null or undefined when calling updateEnvironmentById.");
    }
    if (requestParameters.updateEnvironmentByIdRequest === null || requestParameters.updateEnvironmentByIdRequest === void 0) {
      throw new RequiredError("updateEnvironmentByIdRequest", "Required parameter requestParameters.updateEnvironmentByIdRequest was null or undefined when calling updateEnvironmentById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/environments/{environmentId}`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateEnvironmentByIdRequestToJSON(requestParameters.updateEnvironmentByIdRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => EnvironmentResponseFromJSON(jsonValue));
  }
  /**
   * Updates a single environment, to change the name for example
   * Update an environment
   */
  async updateEnvironmentById(requestParameters, initOverrides) {
    const response = await this.updateEnvironmentByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Update a file, to change the workbook id for example
   * Update a File
   */
  async updateFileByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.fileId === null || requestParameters.fileId === void 0) {
      throw new RequiredError("fileId", "Required parameter requestParameters.fileId was null or undefined when calling updateFileById.");
    }
    if (requestParameters.fileConfig === null || requestParameters.fileConfig === void 0) {
      throw new RequiredError("fileConfig", "Required parameter requestParameters.fileConfig was null or undefined when calling updateFileById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/files/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: FileConfigToJSON(requestParameters.fileConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => FileResponseFromJSON(jsonValue));
  }
  /**
   * Update a file, to change the workbook id for example
   * Update a File
   */
  async updateFileById(requestParameters, initOverrides) {
    const response = await this.updateFileByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Updates a single guest, for example to change name or email
   * Update a guest
   */
  async updateGuestRaw(requestParameters, initOverrides) {
    if (requestParameters.guestId === null || requestParameters.guestId === void 0) {
      throw new RequiredError("guestId", "Required parameter requestParameters.guestId was null or undefined when calling updateGuest.");
    }
    if (requestParameters.guestConfigUpdate === null || requestParameters.guestConfigUpdate === void 0) {
      throw new RequiredError("guestConfigUpdate", "Required parameter requestParameters.guestConfigUpdate was null or undefined when calling updateGuest.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/guests/{guestId}`.replace(`{${"guestId"}}`, encodeURIComponent(String(requestParameters.guestId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: GuestConfigUpdateToJSON(requestParameters.guestConfigUpdate)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GuestResponseFromJSON(jsonValue));
  }
  /**
   * Updates a single guest, for example to change name or email
   * Update a guest
   */
  async updateGuest(requestParameters, initOverrides) {
    const response = await this.updateGuestRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Update a job
   */
  async updateJobRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling updateJob.");
    }
    if (requestParameters.jobUpdate === null || requestParameters.jobUpdate === void 0) {
      throw new RequiredError("jobUpdate", "Required parameter requestParameters.jobUpdate was null or undefined when calling updateJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: JobUpdateToJSON(requestParameters.jobUpdate)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
  }
  /**
   * Update a job
   */
  async updateJob(requestParameters, initOverrides) {
    const response = await this.updateJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Update a job\'s entire execution plan
   * Replace a job\'s plan
   */
  async updateJobExecutionPlanByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling updateJobExecutionPlanById.");
    }
    if (requestParameters.updateJobExecutionPlanByIdRequest === null || requestParameters.updateJobExecutionPlanByIdRequest === void 0) {
      throw new RequiredError("updateJobExecutionPlanByIdRequest", "Required parameter requestParameters.updateJobExecutionPlanByIdRequest was null or undefined when calling updateJobExecutionPlanById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/plan`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateJobExecutionPlanByIdRequestToJSON(requestParameters.updateJobExecutionPlanByIdRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobPlanResponseFromJSON(jsonValue));
  }
  /**
   * Update a job\'s entire execution plan
   * Replace a job\'s plan
   */
  async updateJobExecutionPlanById(requestParameters, initOverrides) {
    const response = await this.updateJobExecutionPlanByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Update a one or more individual fields on a job\'s execution plan
   * Update a job\'s plan
   */
  async updateJobExecutionPlanFieldsRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling updateJobExecutionPlanFields.");
    }
    if (requestParameters.updateJobExecutionPlanFieldsRequest === null || requestParameters.updateJobExecutionPlanFieldsRequest === void 0) {
      throw new RequiredError("updateJobExecutionPlanFieldsRequest", "Required parameter requestParameters.updateJobExecutionPlanFieldsRequest was null or undefined when calling updateJobExecutionPlanFields.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/plan`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateJobExecutionPlanFieldsRequestToJSON(requestParameters.updateJobExecutionPlanFieldsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => JobPlanResponseFromJSON(jsonValue));
  }
  /**
   * Update a one or more individual fields on a job\'s execution plan
   * Update a job\'s plan
   */
  async updateJobExecutionPlanFields(requestParameters, initOverrides) {
    const response = await this.updateJobExecutionPlanFieldsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Updates a prompt
   * Updates a prompt
   */
  async updatePromptRaw(requestParameters, initOverrides) {
    if (requestParameters.promptId === null || requestParameters.promptId === void 0) {
      throw new RequiredError("promptId", "Required parameter requestParameters.promptId was null or undefined when calling updatePrompt.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/prompts/{promptId}`.replace(`{${"promptId"}}`, encodeURIComponent(String(requestParameters.promptId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PromptConfigToJSON(requestParameters.promptConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => PromptResponseFromJSON(jsonValue));
  }
  /**
   * Updates a prompt
   * Updates a prompt
   */
  async updatePrompt(requestParameters, initOverrides) {
    const response = await this.updatePromptRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Updates existing records in a workbook sheet
   * Update records
   */
  async updateRecordsRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling updateRecords.");
    }
    if (requestParameters.recordsUpdates === null || requestParameters.recordsUpdates === void 0) {
      throw new RequiredError("recordsUpdates", "Required parameter requestParameters.recordsUpdates was null or undefined when calling updateRecords.");
    }
    const queryParameters = {};
    if (requestParameters._for !== void 0) {
      queryParameters["for"] = requestParameters._for;
    }
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/records`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RecordsUpdatesToJSON(requestParameters.recordsUpdates)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => VersionResponseFromJSON(jsonValue));
  }
  /**
   * Updates existing records in a workbook sheet
   * Update records
   */
  async updateRecords(requestParameters, initOverrides) {
    const response = await this.updateRecordsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Updates existing records in a workbook sheet
   * Update records
   */
  async updateRecordsDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling updateRecordsDeprecated.");
    }
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling updateRecordsDeprecated.");
    }
    if (requestParameters.recordsUpdates === null || requestParameters.recordsUpdates === void 0) {
      throw new RequiredError("recordsUpdates", "Required parameter requestParameters.recordsUpdates was null or undefined when calling updateRecordsDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}/sheets/{sheetId}/records`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))).replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RecordsUpdatesToJSON(requestParameters.recordsUpdates)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => VersionResponseFromJSON(jsonValue));
  }
  /**
   * Updates existing records in a workbook sheet
   * Update records
   */
  async updateRecordsDeprecated(requestParameters, initOverrides) {
    const response = await this.updateRecordsDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateRuleRaw(requestParameters, initOverrides) {
    if (requestParameters.programId === null || requestParameters.programId === void 0) {
      throw new RequiredError("programId", "Required parameter requestParameters.programId was null or undefined when calling updateRule.");
    }
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling updateRule.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/mapping/{programId}/rules/{id}`.replace(`{${"programId"}}`, encodeURIComponent(String(requestParameters.programId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: MappingRuleConfigToJSON(requestParameters.mappingRuleConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RuleResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateRule(requestParameters, initOverrides) {
    const response = await this.updateRuleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Update a sheet
   * Update a sheet
   */
  async updateSheetRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling updateSheet.");
    }
    if (requestParameters.sheetUpdateRequest === null || requestParameters.sheetUpdateRequest === void 0) {
      throw new RequiredError("sheetUpdateRequest", "Required parameter requestParameters.sheetUpdateRequest was null or undefined when calling updateSheet.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: SheetUpdateRequestToJSON(requestParameters.sheetUpdateRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SheetResponseFromJSON(jsonValue));
  }
  /**
   * Update a sheet
   * Update a sheet
   */
  async updateSheet(requestParameters, initOverrides) {
    const response = await this.updateSheetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Update a space, to change the name for example
   * Update a space
   */
  async updateSpaceByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling updateSpaceById.");
    }
    if (requestParameters.spaceConfig === null || requestParameters.spaceConfig === void 0) {
      throw new RequiredError("spaceConfig", "Required parameter requestParameters.spaceConfig was null or undefined when calling updateSpaceById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: SpaceConfigToJSON(requestParameters.spaceConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpaceResponseFromJSON(jsonValue));
  }
  /**
   * Update a space, to change the name for example
   * Update a space
   */
  async updateSpaceById(requestParameters, initOverrides) {
    const response = await this.updateSpaceByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Updates an existing Space Config and optionally migrates all spaces using the config
   * Update a space config
   */
  async updateSpaceConfigRaw(requestParameters, initOverrides) {
    if (requestParameters.spacePatternConfig === null || requestParameters.spacePatternConfig === void 0) {
      throw new RequiredError("spacePatternConfig", "Required parameter requestParameters.spacePatternConfig was null or undefined when calling updateSpaceConfig.");
    }
    const queryParameters = {};
    if (requestParameters.migrate !== void 0) {
      queryParameters["migrate"] = requestParameters.migrate;
    }
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/space-configs`,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SpacePatternConfigToJSON(requestParameters.spacePatternConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpaceConfigResponseFromJSON(jsonValue));
  }
  /**
   * Updates an existing Space Config and optionally migrates all spaces using the config
   * Update a space config
   */
  async updateSpaceConfig(requestParameters, initOverrides) {
    const response = await this.updateSpaceConfigRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * updates a single document, for only the body and title
   * Update a document
   */
  async updateSpaceDocumentRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling updateSpaceDocument.");
    }
    if (requestParameters.documentId === null || requestParameters.documentId === void 0) {
      throw new RequiredError("documentId", "Required parameter requestParameters.documentId was null or undefined when calling updateSpaceDocument.");
    }
    if (requestParameters.documentConfig === null || requestParameters.documentConfig === void 0) {
      throw new RequiredError("documentConfig", "Required parameter requestParameters.documentConfig was null or undefined when calling updateSpaceDocument.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/documents/{documentId}`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: DocumentConfigToJSON(requestParameters.documentConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
  }
  /**
   * updates a single document, for only the body and title
   * Update a document
   */
  async updateSpaceDocument(requestParameters, initOverrides) {
    const response = await this.updateSpaceDocumentRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Updates the given subscriptions line items
   */
  async updateSubscriptionRaw(requestParameters, initOverrides) {
    if (requestParameters.subscriptionId === null || requestParameters.subscriptionId === void 0) {
      throw new RequiredError("subscriptionId", "Required parameter requestParameters.subscriptionId was null or undefined when calling updateSubscription.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/billing/subscription/{subscriptionId}`.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters.subscriptionId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SubscriptionUpdatesBodyToJSON(requestParameters.subscriptionUpdatesBody)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => BillingSubscriptionResponseFromJSON(jsonValue));
  }
  /**
   * Updates the given subscriptions line items
   */
  async updateSubscription(requestParameters, initOverrides) {
    const response = await this.updateSubscriptionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Updates a user
   * Update a user
   */
  async updateUserRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling updateUser.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateUserRequestToJSON(requestParameters.updateUserRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
  }
  /**
   * Updates a user
   * Update a user
   */
  async updateUser(requestParameters, initOverrides) {
    const response = await this.updateUserRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Updates a view
   * Updates a view
   */
  async updateViewRaw(requestParameters, initOverrides) {
    if (requestParameters.viewId === null || requestParameters.viewId === void 0) {
      throw new RequiredError("viewId", "Required parameter requestParameters.viewId was null or undefined when calling updateView.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/views/{viewId}`.replace(`{${"viewId"}}`, encodeURIComponent(String(requestParameters.viewId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateViewRequestToJSON(requestParameters.updateViewRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ViewResponseFromJSON(jsonValue));
  }
  /**
   * Updates a view
   * Updates a view
   */
  async updateView(requestParameters, initOverrides) {
    const response = await this.updateViewRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Updates a workbook
   * Update a workbook
   */
  async updateWorkbookByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling updateWorkbookById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: WorkbookUpdateToJSON(requestParameters.workbookUpdate)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => WorkbookResponseFromJSON(jsonValue));
  }
  /**
   * Updates a workbook
   * Update a workbook
   */
  async updateWorkbookById(requestParameters, initOverrides) {
    const response = await this.updateWorkbookByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Upgrade a space
   * Upgrade a space
   */
  async upgradeSpaceByIdRaw(requestParameters, initOverrides) {
    if (requestParameters.spaceId === null || requestParameters.spaceId === void 0) {
      throw new RequiredError("spaceId", "Required parameter requestParameters.spaceId was null or undefined when calling upgradeSpaceById.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/spaces/{spaceId}/upgrade`.replace(`{${"spaceId"}}`, encodeURIComponent(String(requestParameters.spaceId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UpgradeSpaceConfigToJSON(requestParameters.upgradeSpaceConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SpaceResponseFromJSON(jsonValue));
  }
  /**
   * Upgrade a space
   * Upgrade a space
   */
  async upgradeSpaceById(requestParameters, initOverrides) {
    const response = await this.upgradeSpaceByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Upload a file to S3 storage
   * Upload a file
   */
  async uploadFileRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling uploadFile.");
    }
    if (requestParameters.uploadConfig === null || requestParameters.uploadConfig === void 0) {
      throw new RequiredError("uploadConfig", "Required parameter requestParameters.uploadConfig was null or undefined when calling uploadFile.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/foreigndb/{workbookId}/storage`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadConfigToJSON(requestParameters.uploadConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Upload a file to S3 storage
   * Upload a file
   */
  async uploadFile(requestParameters, initOverrides) {
    const response = await this.uploadFileRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Upserts a new field to a sheet
   */
  async upsertFieldRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling upsertField.");
    }
    if (requestParameters.fieldKey === null || requestParameters.fieldKey === void 0) {
      throw new RequiredError("fieldKey", "Required parameter requestParameters.fieldKey was null or undefined when calling upsertField.");
    }
    if (requestParameters.fieldConfig === null || requestParameters.fieldConfig === void 0) {
      throw new RequiredError("fieldConfig", "Required parameter requestParameters.fieldConfig was null or undefined when calling upsertField.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/fields/{fieldKey}`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))).replace(`{${"fieldKey"}}`, encodeURIComponent(String(requestParameters.fieldKey))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: FieldConfigToJSON(requestParameters.fieldConfig)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => FieldConfigResponseFromJSON(jsonValue));
  }
  /**
   * Upserts a new field to a sheet
   */
  async upsertField(requestParameters, initOverrides) {
    const response = await this.upsertFieldRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Insert or Update a Secret by name for environment or space
   * Upsert a Secret
   */
  async upsertSecretRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/secrets`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WriteSecretToJSON(requestParameters.writeSecret)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SecretsResponseFromJSON(jsonValue));
  }
  /**
   * Insert or Update a Secret by name for environment or space
   * Upsert a Secret
   */
  async upsertSecret(requestParameters = {}, initOverrides) {
    const response = await this.upsertSecretRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Trigger data hooks and validation to run on a sheet
   * Validate sheet
   */
  async validateSheetRaw(requestParameters, initOverrides) {
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling validateSheet.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/sheets/{sheetId}/validate`.replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Trigger data hooks and validation to run on a sheet
   * Validate sheet
   */
  async validateSheet(requestParameters, initOverrides) {
    const response = await this.validateSheetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * Trigger data hooks and validation to run on a sheet
   * Validate sheet
   */
  async validateSheetDeprecatedRaw(requestParameters, initOverrides) {
    if (requestParameters.workbookId === null || requestParameters.workbookId === void 0) {
      throw new RequiredError("workbookId", "Required parameter requestParameters.workbookId was null or undefined when calling validateSheetDeprecated.");
    }
    if (requestParameters.sheetId === null || requestParameters.sheetId === void 0) {
      throw new RequiredError("sheetId", "Required parameter requestParameters.sheetId was null or undefined when calling validateSheetDeprecated.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuth", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workbooks/{workbookId}/sheets/{sheetId}/validate`.replace(`{${"workbookId"}}`, encodeURIComponent(String(requestParameters.workbookId))).replace(`{${"sheetId"}}`, encodeURIComponent(String(requestParameters.sheetId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
  }
  /**
   * Trigger data hooks and validation to run on a sheet
   * Validate sheet
   */
  async validateSheetDeprecated(requestParameters, initOverrides) {
    const response = await this.validateSheetDeprecatedRaw(requestParameters, initOverrides);
    return await response.value();
  }
};
var CreateNewApiKeyTypeEnum = {
  Publishable: "PUBLISHABLE",
  Secret: "SECRET"
};
var GetSnapshotRecordsChangeTypeEnum = {
  CreatedSince: "createdSince",
  UpdatedSince: "updatedSince",
  DeletedSince: "deletedSince"
};

var src = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AccessTokenFromJSON: AccessTokenFromJSON,
  AccessTokenFromJSONTyped: AccessTokenFromJSONTyped,
  AccessTokenResponseFromJSON: AccessTokenResponseFromJSON,
  AccessTokenResponseFromJSONTyped: AccessTokenResponseFromJSONTyped,
  AccessTokenResponseToJSON: AccessTokenResponseToJSON,
  AccessTokenToJSON: AccessTokenToJSON,
  AccountFromJSON: AccountFromJSON,
  AccountFromJSONTyped: AccountFromJSONTyped,
  AccountResponseFromJSON: AccountResponseFromJSON,
  AccountResponseFromJSONTyped: AccountResponseFromJSONTyped,
  AccountResponseToJSON: AccountResponseToJSON,
  AccountToJSON: AccountToJSON,
  ActionConstraintFromJSON: ActionConstraintFromJSON,
  ActionConstraintFromJSONTyped: ActionConstraintFromJSONTyped,
  ActionConstraintToJSON: ActionConstraintToJSON,
  ActionFromJSON: ActionFromJSON,
  ActionFromJSONTyped: ActionFromJSONTyped,
  ActionInputFormFromJSON: ActionInputFormFromJSON,
  ActionInputFormFromJSONTyped: ActionInputFormFromJSONTyped,
  ActionInputFormToJSON: ActionInputFormToJSON,
  ActionInputFormTypeEnum: ActionInputFormTypeEnum,
  ActionMessageFromJSON: ActionMessageFromJSON,
  ActionMessageFromJSONTyped: ActionMessageFromJSONTyped,
  ActionMessageToJSON: ActionMessageToJSON,
  ActionMessageTypeEnum: ActionMessageTypeEnum,
  ActionModeEnum: ActionModeEnum,
  ActionScheduleEnum: ActionScheduleEnum,
  ActionToJSON: ActionToJSON,
  ActivitiesResponseFromJSON: ActivitiesResponseFromJSON,
  ActivitiesResponseFromJSONTyped: ActivitiesResponseFromJSONTyped,
  ActivitiesResponseToJSON: ActivitiesResponseToJSON,
  ActivityContextFromJSON: ActivityContextFromJSON,
  ActivityContextFromJSONTyped: ActivityContextFromJSONTyped,
  ActivityContextSlugsFromJSON: ActivityContextSlugsFromJSON,
  ActivityContextSlugsFromJSONTyped: ActivityContextSlugsFromJSONTyped,
  ActivityContextSlugsToJSON: ActivityContextSlugsToJSON,
  ActivityContextToJSON: ActivityContextToJSON,
  ActivityFromJSON: ActivityFromJSON,
  ActivityFromJSONTyped: ActivityFromJSONTyped,
  ActivityToJSON: ActivityToJSON,
  ActorIdFromJSON: ActorIdFromJSON,
  ActorIdFromJSONTyped: ActorIdFromJSONTyped,
  ActorIdToJSON: ActorIdToJSON,
  ActorResourceFromJSON: ActorResourceFromJSON,
  ActorResourceFromJSONTyped: ActorResourceFromJSONTyped,
  ActorResourceToJSON: ActorResourceToJSON,
  ActorRoleResponseFromJSON: ActorRoleResponseFromJSON,
  ActorRoleResponseFromJSONTyped: ActorRoleResponseFromJSONTyped,
  ActorRoleResponseToJSON: ActorRoleResponseToJSON,
  AgentCompilerEnum: AgentCompilerEnum,
  AgentConfigCompilerEnum: AgentConfigCompilerEnum,
  AgentConfigFromJSON: AgentConfigFromJSON,
  AgentConfigFromJSONTyped: AgentConfigFromJSONTyped,
  AgentConfigToJSON: AgentConfigToJSON,
  AgentFromJSON: AgentFromJSON,
  AgentFromJSONTyped: AgentFromJSONTyped,
  AgentLogFromJSON: AgentLogFromJSON,
  AgentLogFromJSONTyped: AgentLogFromJSONTyped,
  AgentLogResponseFromJSON: AgentLogResponseFromJSON,
  AgentLogResponseFromJSONTyped: AgentLogResponseFromJSONTyped,
  AgentLogResponseToJSON: AgentLogResponseToJSON,
  AgentLogToJSON: AgentLogToJSON,
  AgentLogsResponse1FromJSON: AgentLogsResponse1FromJSON,
  AgentLogsResponse1FromJSONTyped: AgentLogsResponse1FromJSONTyped,
  AgentLogsResponse1ToJSON: AgentLogsResponse1ToJSON,
  AgentLogsResponseFromJSON: AgentLogsResponseFromJSON,
  AgentLogsResponseFromJSONTyped: AgentLogsResponseFromJSONTyped,
  AgentLogsResponseToJSON: AgentLogsResponseToJSON,
  AgentResponseFromJSON: AgentResponseFromJSON,
  AgentResponseFromJSONTyped: AgentResponseFromJSONTyped,
  AgentResponseToJSON: AgentResponseToJSON,
  AgentStatsFromJSON: AgentStatsFromJSON,
  AgentStatsFromJSONTyped: AgentStatsFromJSONTyped,
  AgentStatsToJSON: AgentStatsToJSON,
  AgentToJSON: AgentToJSON,
  AgentsResponseFromJSON: AgentsResponseFromJSON,
  AgentsResponseFromJSONTyped: AgentsResponseFromJSONTyped,
  AgentsResponseToJSON: AgentsResponseToJSON,
  ApiCredentialsFromJSON: ApiCredentialsFromJSON,
  ApiCredentialsFromJSONTyped: ApiCredentialsFromJSONTyped,
  ApiCredentialsToJSON: ApiCredentialsToJSON,
  ApiKeyFromJSON: ApiKeyFromJSON,
  ApiKeyFromJSONTyped: ApiKeyFromJSONTyped,
  ApiKeyOperationsInnerFromJSON: ApiKeyOperationsInnerFromJSON,
  ApiKeyOperationsInnerFromJSONTyped: ApiKeyOperationsInnerFromJSONTyped,
  ApiKeyOperationsInnerToJSON: ApiKeyOperationsInnerToJSON,
  ApiKeyToJSON: ApiKeyToJSON,
  ApiKeyTypeEnum: ApiKeyTypeEnum,
  ApiKeysResponseFromJSON: ApiKeysResponseFromJSON,
  ApiKeysResponseFromJSONTyped: ApiKeysResponseFromJSONTyped,
  ApiKeysResponseToJSON: ApiKeysResponseToJSON,
  ApiTokenFromJSON: ApiTokenFromJSON,
  ApiTokenFromJSONTyped: ApiTokenFromJSONTyped,
  ApiTokenResponseFromJSON: ApiTokenResponseFromJSON,
  ApiTokenResponseFromJSONTyped: ApiTokenResponseFromJSONTyped,
  ApiTokenResponseToJSON: ApiTokenResponseToJSON,
  ApiTokenToJSON: ApiTokenToJSON,
  ApiTokensResponseFromJSON: ApiTokensResponseFromJSON,
  ApiTokensResponseFromJSONTyped: ApiTokensResponseFromJSONTyped,
  ApiTokensResponseToJSON: ApiTokensResponseToJSON,
  AppVersionResponseFromJSON: AppVersionResponseFromJSON,
  AppVersionResponseFromJSONTyped: AppVersionResponseFromJSONTyped,
  AppVersionResponseToJSON: AppVersionResponseToJSON,
  ArrayablePropertyFromJSON: ArrayablePropertyFromJSON,
  ArrayablePropertyFromJSONTyped: ArrayablePropertyFromJSONTyped,
  ArrayablePropertyToJSON: ArrayablePropertyToJSON,
  AssignActorRoleRequestFromJSON: AssignActorRoleRequestFromJSON,
  AssignActorRoleRequestFromJSONTyped: AssignActorRoleRequestFromJSONTyped,
  AssignActorRoleRequestToJSON: AssignActorRoleRequestToJSON,
  AssignRoleResponseFromJSON: AssignRoleResponseFromJSON,
  AssignRoleResponseFromJSONTyped: AssignRoleResponseFromJSONTyped,
  AssignRoleResponseToJSON: AssignRoleResponseToJSON,
  AuditActivity: AuditActivity,
  AuditActivityFromJSON: AuditActivityFromJSON,
  AuditActivityFromJSONTyped: AuditActivityFromJSONTyped,
  AuditActivityToJSON: AuditActivityToJSON,
  BASE_PATH: BASE_PATH,
  BaseAPI: BaseAPI,
  BaseActionConstraintFromJSON: BaseActionConstraintFromJSON,
  BaseActionConstraintFromJSONTyped: BaseActionConstraintFromJSONTyped,
  BaseActionConstraintToJSON: BaseActionConstraintToJSON,
  BaseActionConstraintTypeEnum: BaseActionConstraintTypeEnum,
  BaseConstraintFromJSON: BaseConstraintFromJSON,
  BaseConstraintFromJSONTyped: BaseConstraintFromJSONTyped,
  BaseConstraintToJSON: BaseConstraintToJSON,
  BaseConstraintTypeEnum: BaseConstraintTypeEnum,
  BasePropertyAppearanceFromJSON: BasePropertyAppearanceFromJSON,
  BasePropertyAppearanceFromJSONTyped: BasePropertyAppearanceFromJSONTyped,
  BasePropertyAppearanceSizeEnum: BasePropertyAppearanceSizeEnum,
  BasePropertyAppearanceToJSON: BasePropertyAppearanceToJSON,
  BasePropertyFromJSON: BasePropertyFromJSON,
  BasePropertyFromJSONTyped: BasePropertyFromJSONTyped,
  BasePropertyToJSON: BasePropertyToJSON,
  BasePropertyTypeEnum: BasePropertyTypeEnum,
  BaseSideBarConfigFromJSON: BaseSideBarConfigFromJSON,
  BaseSideBarConfigFromJSONTyped: BaseSideBarConfigFromJSONTyped,
  BaseSideBarConfigToJSON: BaseSideBarConfigToJSON,
  BaseSideBarConfigTypeEnum: BaseSideBarConfigTypeEnum,
  BillingLimitsFromJSON: BillingLimitsFromJSON,
  BillingLimitsFromJSONTyped: BillingLimitsFromJSONTyped,
  BillingLimitsResponseFromJSON: BillingLimitsResponseFromJSON,
  BillingLimitsResponseFromJSONTyped: BillingLimitsResponseFromJSONTyped,
  BillingLimitsResponseToJSON: BillingLimitsResponseToJSON,
  BillingLimitsToJSON: BillingLimitsToJSON,
  BillingPlanWithUsageFromJSON: BillingPlanWithUsageFromJSON,
  BillingPlanWithUsageFromJSONTyped: BillingPlanWithUsageFromJSONTyped,
  BillingPlanWithUsageResponseFromJSON: BillingPlanWithUsageResponseFromJSON,
  BillingPlanWithUsageResponseFromJSONTyped: BillingPlanWithUsageResponseFromJSONTyped,
  BillingPlanWithUsageResponseToJSON: BillingPlanWithUsageResponseToJSON,
  BillingPlanWithUsageToJSON: BillingPlanWithUsageToJSON,
  BillingSubscriptionFromJSON: BillingSubscriptionFromJSON,
  BillingSubscriptionFromJSONTyped: BillingSubscriptionFromJSONTyped,
  BillingSubscriptionItemFromJSON: BillingSubscriptionItemFromJSON,
  BillingSubscriptionItemFromJSONTyped: BillingSubscriptionItemFromJSONTyped,
  BillingSubscriptionItemToJSON: BillingSubscriptionItemToJSON,
  BillingSubscriptionResponseFromJSON: BillingSubscriptionResponseFromJSON,
  BillingSubscriptionResponseFromJSONTyped: BillingSubscriptionResponseFromJSONTyped,
  BillingSubscriptionResponseToJSON: BillingSubscriptionResponseToJSON,
  BillingSubscriptionToJSON: BillingSubscriptionToJSON,
  BillingSubscriptionsResponseFromJSON: BillingSubscriptionsResponseFromJSON,
  BillingSubscriptionsResponseFromJSONTyped: BillingSubscriptionsResponseFromJSONTyped,
  BillingSubscriptionsResponseToJSON: BillingSubscriptionsResponseToJSON,
  BlobApiResponse: BlobApiResponse,
  BlueprintFromJSON: BlueprintFromJSON,
  BlueprintFromJSONTyped: BlueprintFromJSONTyped,
  BlueprintToJSON: BlueprintToJSON,
  BooleanPropertyAllOfConfigFromJSON: BooleanPropertyAllOfConfigFromJSON,
  BooleanPropertyAllOfConfigFromJSONTyped: BooleanPropertyAllOfConfigFromJSONTyped,
  BooleanPropertyAllOfConfigToJSON: BooleanPropertyAllOfConfigToJSON,
  BooleanPropertyAllOfFromJSON: BooleanPropertyAllOfFromJSON,
  BooleanPropertyAllOfFromJSONTyped: BooleanPropertyAllOfFromJSONTyped,
  BooleanPropertyAllOfToJSON: BooleanPropertyAllOfToJSON,
  BooleanPropertyAllOfTypeEnum: BooleanPropertyAllOfTypeEnum,
  BooleanPropertyFromJSON: BooleanPropertyFromJSON,
  BooleanPropertyFromJSONTyped: BooleanPropertyFromJSONTyped,
  BooleanPropertyToJSON: BooleanPropertyToJSON,
  BooleanPropertyTypeEnum: BooleanPropertyTypeEnum,
  COLLECTION_FORMATS: COLLECTION_FORMATS,
  CellValueFromJSON: CellValueFromJSON,
  CellValueFromJSONTyped: CellValueFromJSONTyped,
  CellValueToJSON: CellValueToJSON,
  CellValueWithCountsAllOfFromJSON: CellValueWithCountsAllOfFromJSON,
  CellValueWithCountsAllOfFromJSONTyped: CellValueWithCountsAllOfFromJSONTyped,
  CellValueWithCountsAllOfToJSON: CellValueWithCountsAllOfToJSON,
  CellValueWithCountsFromJSON: CellValueWithCountsFromJSON,
  CellValueWithCountsFromJSONTyped: CellValueWithCountsFromJSONTyped,
  CellValueWithCountsToJSON: CellValueWithCountsToJSON,
  CellValueWithLinksFromJSON: CellValueWithLinksFromJSON,
  CellValueWithLinksFromJSONTyped: CellValueWithLinksFromJSONTyped,
  CellValueWithLinksToJSON: CellValueWithLinksToJSON,
  CellsResponseDataFromJSON: CellsResponseDataFromJSON,
  CellsResponseDataFromJSONTyped: CellsResponseDataFromJSONTyped,
  CellsResponseDataToJSON: CellsResponseDataToJSON,
  CellsResponseFromJSON: CellsResponseFromJSON,
  CellsResponseFromJSONTyped: CellsResponseFromJSONTyped,
  CellsResponseToJSON: CellsResponseToJSON,
  CheckoutSessionBodyFromJSON: CheckoutSessionBodyFromJSON,
  CheckoutSessionBodyFromJSONTyped: CheckoutSessionBodyFromJSONTyped,
  CheckoutSessionBodyToJSON: CheckoutSessionBodyToJSON,
  CheckoutSessionFromJSON: CheckoutSessionFromJSON,
  CheckoutSessionFromJSONTyped: CheckoutSessionFromJSONTyped,
  CheckoutSessionToJSON: CheckoutSessionToJSON,
  CollectionJobSubjectFromJSON: CollectionJobSubjectFromJSON,
  CollectionJobSubjectFromJSONTyped: CollectionJobSubjectFromJSONTyped,
  CollectionJobSubjectToJSON: CollectionJobSubjectToJSON,
  CommitFromJSON: CommitFromJSON,
  CommitFromJSONTyped: CommitFromJSONTyped,
  CommitToJSON: CommitToJSON,
  CompositeUniqueConstraintAllOfFromJSON: CompositeUniqueConstraintAllOfFromJSON,
  CompositeUniqueConstraintAllOfFromJSONTyped: CompositeUniqueConstraintAllOfFromJSONTyped,
  CompositeUniqueConstraintAllOfStrategyEnum: CompositeUniqueConstraintAllOfStrategyEnum,
  CompositeUniqueConstraintAllOfToJSON: CompositeUniqueConstraintAllOfToJSON,
  CompositeUniqueConstraintAllOfTypeEnum: CompositeUniqueConstraintAllOfTypeEnum,
  CompositeUniqueConstraintFromJSON: CompositeUniqueConstraintFromJSON,
  CompositeUniqueConstraintFromJSONTyped: CompositeUniqueConstraintFromJSONTyped,
  CompositeUniqueConstraintStrategyEnum: CompositeUniqueConstraintStrategyEnum,
  CompositeUniqueConstraintToJSON: CompositeUniqueConstraintToJSON,
  CompositeUniqueConstraintTypeEnum: CompositeUniqueConstraintTypeEnum,
  ComputedConstraintAllOfFromJSON: ComputedConstraintAllOfFromJSON,
  ComputedConstraintAllOfFromJSONTyped: ComputedConstraintAllOfFromJSONTyped,
  ComputedConstraintAllOfToJSON: ComputedConstraintAllOfToJSON,
  ComputedConstraintAllOfTypeEnum: ComputedConstraintAllOfTypeEnum,
  ComputedConstraintFromJSON: ComputedConstraintFromJSON,
  ComputedConstraintFromJSONTyped: ComputedConstraintFromJSONTyped,
  ComputedConstraintToJSON: ComputedConstraintToJSON,
  ComputedConstraintTypeEnum: ComputedConstraintTypeEnum,
  Configuration: Configuration,
  ConnectionLinkBodyFromJSON: ConnectionLinkBodyFromJSON,
  ConnectionLinkBodyFromJSONTyped: ConnectionLinkBodyFromJSONTyped,
  ConnectionLinkBodyToJSON: ConnectionLinkBodyToJSON,
  ConnectionLinkFromJSON: ConnectionLinkFromJSON,
  ConnectionLinkFromJSONTyped: ConnectionLinkFromJSONTyped,
  ConnectionLinkToJSON: ConnectionLinkToJSON,
  ConstraintFromJSON: ConstraintFromJSON,
  ConstraintFromJSONTyped: ConstraintFromJSONTyped,
  ConstraintToJSON: ConstraintToJSON,
  CreateAccessTokenRequestFromJSON: CreateAccessTokenRequestFromJSON,
  CreateAccessTokenRequestFromJSONTyped: CreateAccessTokenRequestFromJSONTyped,
  CreateAccessTokenRequestToJSON: CreateAccessTokenRequestToJSON,
  CreateCheckoutSessionResponseFromJSON: CreateCheckoutSessionResponseFromJSON,
  CreateCheckoutSessionResponseFromJSONTyped: CreateCheckoutSessionResponseFromJSONTyped,
  CreateCheckoutSessionResponseToJSON: CreateCheckoutSessionResponseToJSON,
  CreateCommitIdRequestFromJSON: CreateCommitIdRequestFromJSON,
  CreateCommitIdRequestFromJSONTyped: CreateCommitIdRequestFromJSONTyped,
  CreateCommitIdRequestToJSON: CreateCommitIdRequestToJSON,
  CreateConnectionLinkResponseFromJSON: CreateConnectionLinkResponseFromJSON,
  CreateConnectionLinkResponseFromJSONTyped: CreateConnectionLinkResponseFromJSONTyped,
  CreateConnectionLinkResponseToJSON: CreateConnectionLinkResponseToJSON,
  CreateEnvironmentRequestDataRetentionPolicyEnum: CreateEnvironmentRequestDataRetentionPolicyEnum,
  CreateEnvironmentRequestFromJSON: CreateEnvironmentRequestFromJSON,
  CreateEnvironmentRequestFromJSONTyped: CreateEnvironmentRequestFromJSONTyped,
  CreateEnvironmentRequestToJSON: CreateEnvironmentRequestToJSON,
  CreateMappingRequestFromJSON: CreateMappingRequestFromJSON,
  CreateMappingRequestFromJSONTyped: CreateMappingRequestFromJSONTyped,
  CreateMappingRequestToJSON: CreateMappingRequestToJSON,
  CreateNewApiKeyTypeEnum: CreateNewApiKeyTypeEnum,
  CreateVersionIdRequestFromJSON: CreateVersionIdRequestFromJSON,
  CreateVersionIdRequestFromJSONTyped: CreateVersionIdRequestFromJSONTyped,
  CreateVersionIdRequestToJSON: CreateVersionIdRequestToJSON,
  CreateViewRequestFromJSON: CreateViewRequestFromJSON,
  CreateViewRequestFromJSONTyped: CreateViewRequestFromJSONTyped,
  CreateViewRequestToJSON: CreateViewRequestToJSON,
  DBUserFromJSON: DBUserFromJSON,
  DBUserFromJSONTyped: DBUserFromJSONTyped,
  DBUserToJSON: DBUserToJSON,
  DataRetentionPolicyConfigFromJSON: DataRetentionPolicyConfigFromJSON,
  DataRetentionPolicyConfigFromJSONTyped: DataRetentionPolicyConfigFromJSONTyped,
  DataRetentionPolicyConfigToJSON: DataRetentionPolicyConfigToJSON,
  DataRetentionPolicyConfigUpdateFromJSON: DataRetentionPolicyConfigUpdateFromJSON,
  DataRetentionPolicyConfigUpdateFromJSONTyped: DataRetentionPolicyConfigUpdateFromJSONTyped,
  DataRetentionPolicyConfigUpdateToJSON: DataRetentionPolicyConfigUpdateToJSON,
  DataRetentionPolicyEnum: DataRetentionPolicyEnum,
  DataRetentionPolicyEnumFromJSON: DataRetentionPolicyEnumFromJSON,
  DataRetentionPolicyEnumFromJSONTyped: DataRetentionPolicyEnumFromJSONTyped,
  DataRetentionPolicyEnumToJSON: DataRetentionPolicyEnumToJSON,
  DataRetentionPolicyFromJSON: DataRetentionPolicyFromJSON,
  DataRetentionPolicyFromJSONTyped: DataRetentionPolicyFromJSONTyped,
  DataRetentionPolicyResponseFromJSON: DataRetentionPolicyResponseFromJSON,
  DataRetentionPolicyResponseFromJSONTyped: DataRetentionPolicyResponseFromJSONTyped,
  DataRetentionPolicyResponseToJSON: DataRetentionPolicyResponseToJSON,
  DataRetentionPolicyToJSON: DataRetentionPolicyToJSON,
  DatePropertyAllOfFromJSON: DatePropertyAllOfFromJSON,
  DatePropertyAllOfFromJSONTyped: DatePropertyAllOfFromJSONTyped,
  DatePropertyAllOfToJSON: DatePropertyAllOfToJSON,
  DatePropertyAllOfTypeEnum: DatePropertyAllOfTypeEnum,
  DatePropertyFromJSON: DatePropertyFromJSON,
  DatePropertyFromJSONTyped: DatePropertyFromJSONTyped,
  DatePropertyToJSON: DatePropertyToJSON,
  DatePropertyTypeEnum: DatePropertyTypeEnum,
  DefaultApi: DefaultApi,
  DefaultConfig: DefaultConfig,
  DeleteRecordsJobConfigFromJSON: DeleteRecordsJobConfigFromJSON,
  DeleteRecordsJobConfigFromJSONTyped: DeleteRecordsJobConfigFromJSONTyped,
  DeleteRecordsJobConfigToJSON: DeleteRecordsJobConfigToJSON,
  DeleteRulesRequestFromJSON: DeleteRulesRequestFromJSON,
  DeleteRulesRequestFromJSONTyped: DeleteRulesRequestFromJSONTyped,
  DeleteRulesRequestToJSON: DeleteRulesRequestToJSON,
  DestinationFieldFromJSON: DestinationFieldFromJSON,
  DestinationFieldFromJSONTyped: DestinationFieldFromJSONTyped,
  DestinationFieldToJSON: DestinationFieldToJSON,
  DetailedAgentLogFromJSON: DetailedAgentLogFromJSON,
  DetailedAgentLogFromJSONTyped: DetailedAgentLogFromJSONTyped,
  DetailedAgentLogToJSON: DetailedAgentLogToJSON,
  DiffDataFromJSON: DiffDataFromJSON,
  DiffDataFromJSONTyped: DiffDataFromJSONTyped,
  DiffDataToJSON: DiffDataToJSON,
  DiffRecordFromJSON: DiffRecordFromJSON,
  DiffRecordFromJSONTyped: DiffRecordFromJSONTyped,
  DiffRecordToJSON: DiffRecordToJSON,
  DiffRecordsResponseDataFromJSON: DiffRecordsResponseDataFromJSON,
  DiffRecordsResponseDataFromJSONTyped: DiffRecordsResponseDataFromJSONTyped,
  DiffRecordsResponseDataToJSON: DiffRecordsResponseDataToJSON,
  DiffRecordsResponseFromJSON: DiffRecordsResponseFromJSON,
  DiffRecordsResponseFromJSONTyped: DiffRecordsResponseFromJSONTyped,
  DiffRecordsResponseToJSON: DiffRecordsResponseToJSON,
  DiffValueFromJSON: DiffValueFromJSON,
  DiffValueFromJSONTyped: DiffValueFromJSONTyped,
  DiffValueToJSON: DiffValueToJSON,
  DocumentConfigFromJSON: DocumentConfigFromJSON,
  DocumentConfigFromJSONTyped: DocumentConfigFromJSONTyped,
  DocumentConfigToJSON: DocumentConfigToJSON,
  DocumentFromJSON: DocumentFromJSON,
  DocumentFromJSONTyped: DocumentFromJSONTyped,
  DocumentResponseFromJSON: DocumentResponseFromJSON,
  DocumentResponseFromJSONTyped: DocumentResponseFromJSONTyped,
  DocumentResponseToJSON: DocumentResponseToJSON,
  DocumentSidebarConfigAllOfFromJSON: DocumentSidebarConfigAllOfFromJSON,
  DocumentSidebarConfigAllOfFromJSONTyped: DocumentSidebarConfigAllOfFromJSONTyped,
  DocumentSidebarConfigAllOfToJSON: DocumentSidebarConfigAllOfToJSON,
  DocumentSidebarConfigFromJSON: DocumentSidebarConfigFromJSON,
  DocumentSidebarConfigFromJSONTyped: DocumentSidebarConfigFromJSONTyped,
  DocumentSidebarConfigToJSON: DocumentSidebarConfigToJSON,
  DocumentSidebarConfigTypeEnum: DocumentSidebarConfigTypeEnum,
  DocumentToJSON: DocumentToJSON,
  DocumentsResponseFromJSON: DocumentsResponseFromJSON,
  DocumentsResponseFromJSONTyped: DocumentsResponseFromJSONTyped,
  DocumentsResponseToJSON: DocumentsResponseToJSON,
  EdgeFromJSON: EdgeFromJSON,
  EdgeFromJSONTyped: EdgeFromJSONTyped,
  EdgeMetadataFromJSON: EdgeMetadataFromJSON,
  EdgeMetadataFromJSONTyped: EdgeMetadataFromJSONTyped,
  EdgeMetadataToJSON: EdgeMetadataToJSON,
  EdgeToJSON: EdgeToJSON,
  EntitlementFromJSON: EntitlementFromJSON,
  EntitlementFromJSONTyped: EntitlementFromJSONTyped,
  EntitlementToJSON: EntitlementToJSON,
  EntitlementsResponseFromJSON: EntitlementsResponseFromJSON,
  EntitlementsResponseFromJSONTyped: EntitlementsResponseFromJSONTyped,
  EntitlementsResponseToJSON: EntitlementsResponseToJSON,
  EnumDetailsFromJSON: EnumDetailsFromJSON,
  EnumDetailsFromJSONTyped: EnumDetailsFromJSONTyped,
  EnumDetailsToJSON: EnumDetailsToJSON,
  EnumListPropertyAllOfFromJSON: EnumListPropertyAllOfFromJSON,
  EnumListPropertyAllOfFromJSONTyped: EnumListPropertyAllOfFromJSONTyped,
  EnumListPropertyAllOfToJSON: EnumListPropertyAllOfToJSON,
  EnumListPropertyAllOfTypeEnum: EnumListPropertyAllOfTypeEnum,
  EnumListPropertyFromJSON: EnumListPropertyFromJSON,
  EnumListPropertyFromJSONTyped: EnumListPropertyFromJSONTyped,
  EnumListPropertyToJSON: EnumListPropertyToJSON,
  EnumListPropertyTypeEnum: EnumListPropertyTypeEnum,
  EnumMappingFieldFromJSON: EnumMappingFieldFromJSON,
  EnumMappingFieldFromJSONTyped: EnumMappingFieldFromJSONTyped,
  EnumMappingFieldToJSON: EnumMappingFieldToJSON,
  EnumPropertyAllOfConfigFromJSON: EnumPropertyAllOfConfigFromJSON,
  EnumPropertyAllOfConfigFromJSONTyped: EnumPropertyAllOfConfigFromJSONTyped,
  EnumPropertyAllOfConfigToJSON: EnumPropertyAllOfConfigToJSON,
  EnumPropertyAllOfFromJSON: EnumPropertyAllOfFromJSON,
  EnumPropertyAllOfFromJSONTyped: EnumPropertyAllOfFromJSONTyped,
  EnumPropertyAllOfToJSON: EnumPropertyAllOfToJSON,
  EnumPropertyAllOfTypeEnum: EnumPropertyAllOfTypeEnum,
  EnumPropertyFromJSON: EnumPropertyFromJSON,
  EnumPropertyFromJSONTyped: EnumPropertyFromJSONTyped,
  EnumPropertyOptionFromJSON: EnumPropertyOptionFromJSON,
  EnumPropertyOptionFromJSONTyped: EnumPropertyOptionFromJSONTyped,
  EnumPropertyOptionToJSON: EnumPropertyOptionToJSON,
  EnumPropertyOptionValueFromJSON: EnumPropertyOptionValueFromJSON,
  EnumPropertyOptionValueFromJSONTyped: EnumPropertyOptionValueFromJSONTyped,
  EnumPropertyOptionValueToJSON: EnumPropertyOptionValueToJSON,
  EnumPropertyToJSON: EnumPropertyToJSON,
  EnumPropertyTypeEnum: EnumPropertyTypeEnum,
  EnvironmentConfigDataRetentionPolicyEnum: EnvironmentConfigDataRetentionPolicyEnum,
  EnvironmentConfigFromJSON: EnvironmentConfigFromJSON,
  EnvironmentConfigFromJSONTyped: EnvironmentConfigFromJSONTyped,
  EnvironmentConfigToJSON: EnvironmentConfigToJSON,
  EnvironmentDataRetentionPolicyEnum: EnvironmentDataRetentionPolicyEnum,
  EnvironmentFromJSON: EnvironmentFromJSON,
  EnvironmentFromJSONTyped: EnvironmentFromJSONTyped,
  EnvironmentResponseFromJSON: EnvironmentResponseFromJSON,
  EnvironmentResponseFromJSONTyped: EnvironmentResponseFromJSONTyped,
  EnvironmentResponseToJSON: EnvironmentResponseToJSON,
  EnvironmentStatsResponseDataFromJSON: EnvironmentStatsResponseDataFromJSON,
  EnvironmentStatsResponseDataFromJSONTyped: EnvironmentStatsResponseDataFromJSONTyped,
  EnvironmentStatsResponseDataToJSON: EnvironmentStatsResponseDataToJSON,
  EnvironmentStatsResponseFromJSON: EnvironmentStatsResponseFromJSON,
  EnvironmentStatsResponseFromJSONTyped: EnvironmentStatsResponseFromJSONTyped,
  EnvironmentStatsResponseToJSON: EnvironmentStatsResponseToJSON,
  EnvironmentToJSON: EnvironmentToJSON,
  EnvironmentsResponseFromJSON: EnvironmentsResponseFromJSON,
  EnvironmentsResponseFromJSONTyped: EnvironmentsResponseFromJSONTyped,
  EnvironmentsResponseToJSON: EnvironmentsResponseToJSON,
  ErrorResponseErrorsInnerFromJSON: ErrorResponseErrorsInnerFromJSON,
  ErrorResponseErrorsInnerFromJSONTyped: ErrorResponseErrorsInnerFromJSONTyped,
  ErrorResponseErrorsInnerToJSON: ErrorResponseErrorsInnerToJSON,
  ErrorResponseFromJSON: ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped: ErrorResponseFromJSONTyped,
  ErrorResponseToJSON: ErrorResponseToJSON,
  EventConfigAttributesFromJSON: EventConfigAttributesFromJSON,
  EventConfigAttributesFromJSONTyped: EventConfigAttributesFromJSONTyped,
  EventConfigAttributesProgressFromJSON: EventConfigAttributesProgressFromJSON,
  EventConfigAttributesProgressFromJSONTyped: EventConfigAttributesProgressFromJSONTyped,
  EventConfigAttributesProgressToJSON: EventConfigAttributesProgressToJSON,
  EventConfigAttributesToJSON: EventConfigAttributesToJSON,
  EventConfigDomainEnum: EventConfigDomainEnum,
  EventConfigFromJSON: EventConfigFromJSON,
  EventConfigFromJSONTyped: EventConfigFromJSONTyped,
  EventConfigOriginFromJSON: EventConfigOriginFromJSON,
  EventConfigOriginFromJSONTyped: EventConfigOriginFromJSONTyped,
  EventConfigOriginToJSON: EventConfigOriginToJSON,
  EventConfigToJSON: EventConfigToJSON,
  EventDomainEnum: EventDomainEnum,
  EventFromJSON: EventFromJSON,
  EventFromJSONTyped: EventFromJSONTyped,
  EventResponseFromJSON: EventResponseFromJSON,
  EventResponseFromJSONTyped: EventResponseFromJSONTyped,
  EventResponseToJSON: EventResponseToJSON,
  EventToJSON: EventToJSON,
  EventTokenFromJSON: EventTokenFromJSON,
  EventTokenFromJSONTyped: EventTokenFromJSONTyped,
  EventTokenResponseFromJSON: EventTokenResponseFromJSON,
  EventTokenResponseFromJSONTyped: EventTokenResponseFromJSONTyped,
  EventTokenResponseToJSON: EventTokenResponseToJSON,
  EventTokenToJSON: EventTokenToJSON,
  EventTopic: EventTopic,
  EventTopicFromJSON: EventTopicFromJSON,
  EventTopicFromJSONTyped: EventTopicFromJSONTyped,
  EventTopicToJSON: EventTopicToJSON,
  EventsResponseFromJSON: EventsResponseFromJSON,
  EventsResponseFromJSONTyped: EventsResponseFromJSONTyped,
  EventsResponseToJSON: EventsResponseToJSON,
  ExchangeInvitationRequestFromJSON: ExchangeInvitationRequestFromJSON,
  ExchangeInvitationRequestFromJSONTyped: ExchangeInvitationRequestFromJSONTyped,
  ExchangeInvitationRequestToJSON: ExchangeInvitationRequestToJSON,
  ExchangeTokenResponseDataFromJSON: ExchangeTokenResponseDataFromJSON,
  ExchangeTokenResponseDataFromJSONTyped: ExchangeTokenResponseDataFromJSONTyped,
  ExchangeTokenResponseDataToJSON: ExchangeTokenResponseDataToJSON,
  ExchangeTokenResponseFromJSON: ExchangeTokenResponseFromJSON,
  ExchangeTokenResponseFromJSONTyped: ExchangeTokenResponseFromJSONTyped,
  ExchangeTokenResponseToJSON: ExchangeTokenResponseToJSON,
  ExecutionFromJSON: ExecutionFromJSON,
  ExecutionFromJSONTyped: ExecutionFromJSONTyped,
  ExecutionToJSON: ExecutionToJSON,
  ExecutionsResponseFromJSON: ExecutionsResponseFromJSON,
  ExecutionsResponseFromJSONTyped: ExecutionsResponseFromJSONTyped,
  ExecutionsResponseToJSON: ExecutionsResponseToJSON,
  ExportJobConfigFromJSON: ExportJobConfigFromJSON,
  ExportJobConfigFromJSONTyped: ExportJobConfigFromJSONTyped,
  ExportJobConfigToJSON: ExportJobConfigToJSON,
  ExportOptionsFromJSON: ExportOptionsFromJSON,
  ExportOptionsFromJSONTyped: ExportOptionsFromJSONTyped,
  ExportOptionsToJSON: ExportOptionsToJSON,
  ExternalConstraintAllOfFromJSON: ExternalConstraintAllOfFromJSON,
  ExternalConstraintAllOfFromJSONTyped: ExternalConstraintAllOfFromJSONTyped,
  ExternalConstraintAllOfToJSON: ExternalConstraintAllOfToJSON,
  ExternalConstraintAllOfTypeEnum: ExternalConstraintAllOfTypeEnum,
  ExternalConstraintFromJSON: ExternalConstraintFromJSON,
  ExternalConstraintFromJSONTyped: ExternalConstraintFromJSONTyped,
  ExternalConstraintToJSON: ExternalConstraintToJSON,
  ExternalConstraintTypeEnum: ExternalConstraintTypeEnum,
  ExternalSheetConstraintAllOfFromJSON: ExternalSheetConstraintAllOfFromJSON,
  ExternalSheetConstraintAllOfFromJSONTyped: ExternalSheetConstraintAllOfFromJSONTyped,
  ExternalSheetConstraintAllOfToJSON: ExternalSheetConstraintAllOfToJSON,
  ExternalSheetConstraintAllOfTypeEnum: ExternalSheetConstraintAllOfTypeEnum,
  ExternalSheetConstraintFromJSON: ExternalSheetConstraintFromJSON,
  ExternalSheetConstraintFromJSONTyped: ExternalSheetConstraintFromJSONTyped,
  ExternalSheetConstraintToJSON: ExternalSheetConstraintToJSON,
  ExternalSheetConstraintTypeEnum: ExternalSheetConstraintTypeEnum,
  FetchError: FetchError,
  FieldConfigFromJSON: FieldConfigFromJSON,
  FieldConfigFromJSONTyped: FieldConfigFromJSONTyped,
  FieldConfigResponseFromJSON: FieldConfigResponseFromJSON,
  FieldConfigResponseFromJSONTyped: FieldConfigResponseFromJSONTyped,
  FieldConfigResponseToJSON: FieldConfigResponseToJSON,
  FieldConfigToJSON: FieldConfigToJSON,
  FieldRecordCountsFromJSON: FieldRecordCountsFromJSON,
  FieldRecordCountsFromJSONTyped: FieldRecordCountsFromJSONTyped,
  FieldRecordCountsToJSON: FieldRecordCountsToJSON,
  FileConfigFromJSON: FileConfigFromJSON,
  FileConfigFromJSONTyped: FileConfigFromJSONTyped,
  FileConfigToJSON: FileConfigToJSON,
  FileJobConfigDriverEnum: FileJobConfigDriverEnum,
  FileJobConfigFromJSON: FileJobConfigFromJSON,
  FileJobConfigFromJSONTyped: FileJobConfigFromJSONTyped,
  FileJobConfigToJSON: FileJobConfigToJSON,
  FileMode: FileMode,
  FileModeFromJSON: FileModeFromJSON,
  FileModeFromJSONTyped: FileModeFromJSONTyped,
  FileModeToJSON: FileModeToJSON,
  FileOrigin: FileOrigin,
  FileOriginFromJSON: FileOriginFromJSON,
  FileOriginFromJSONTyped: FileOriginFromJSONTyped,
  FileOriginToJSON: FileOriginToJSON,
  FileResponseFromJSON: FileResponseFromJSON,
  FileResponseFromJSONTyped: FileResponseFromJSONTyped,
  FileResponseToJSON: FileResponseToJSON,
  FilesResponseFromJSON: FilesResponseFromJSON,
  FilesResponseFromJSONTyped: FilesResponseFromJSONTyped,
  FilesResponseToJSON: FilesResponseToJSON,
  Filter: Filter$1,
  FilterFromJSON: FilterFromJSON,
  FilterFromJSONTyped: FilterFromJSONTyped,
  FilterToJSON: FilterToJSON,
  FindAndReplaceJobConfigFromJSON: FindAndReplaceJobConfigFromJSON,
  FindAndReplaceJobConfigFromJSONTyped: FindAndReplaceJobConfigFromJSONTyped,
  FindAndReplaceJobConfigToJSON: FindAndReplaceJobConfigToJSON,
  FindAndReplaceRequestFromJSON: FindAndReplaceRequestFromJSON,
  FindAndReplaceRequestFromJSONTyped: FindAndReplaceRequestFromJSONTyped,
  FindAndReplaceRequestToJSON: FindAndReplaceRequestToJSON,
  FronteggSignupFromJSON: FronteggSignupFromJSON,
  FronteggSignupFromJSONTyped: FronteggSignupFromJSONTyped,
  FronteggSignupToJSON: FronteggSignupToJSON,
  FronteggUserFromJSON: FronteggUserFromJSON,
  FronteggUserFromJSONTyped: FronteggUserFromJSONTyped,
  FronteggUserToJSON: FronteggUserToJSON,
  GenerateMutationConfigFromJSON: GenerateMutationConfigFromJSON,
  GenerateMutationConfigFromJSONTyped: GenerateMutationConfigFromJSONTyped,
  GenerateMutationConfigToJSON: GenerateMutationConfigToJSON,
  GenerateQueryConfigFromJSON: GenerateQueryConfigFromJSON,
  GenerateQueryConfigFromJSONTyped: GenerateQueryConfigFromJSONTyped,
  GenerateQueryConfigToJSON: GenerateQueryConfigToJSON,
  GeneratedMutationFromJSON: GeneratedMutationFromJSON,
  GeneratedMutationFromJSONTyped: GeneratedMutationFromJSONTyped,
  GeneratedMutationMetadataFromJSON: GeneratedMutationMetadataFromJSON,
  GeneratedMutationMetadataFromJSONTyped: GeneratedMutationMetadataFromJSONTyped,
  GeneratedMutationMetadataToJSON: GeneratedMutationMetadataToJSON,
  GeneratedMutationResponseFromJSON: GeneratedMutationResponseFromJSON,
  GeneratedMutationResponseFromJSONTyped: GeneratedMutationResponseFromJSONTyped,
  GeneratedMutationResponseToJSON: GeneratedMutationResponseToJSON,
  GeneratedMutationToJSON: GeneratedMutationToJSON,
  GeneratedQueryFromJSON: GeneratedQueryFromJSON,
  GeneratedQueryFromJSONTyped: GeneratedQueryFromJSONTyped,
  GeneratedQueryMetadataFromJSON: GeneratedQueryMetadataFromJSON,
  GeneratedQueryMetadataFromJSONTyped: GeneratedQueryMetadataFromJSONTyped,
  GeneratedQueryMetadataToJSON: GeneratedQueryMetadataToJSON,
  GeneratedQueryResponseFromJSON: GeneratedQueryResponseFromJSON,
  GeneratedQueryResponseFromJSONTyped: GeneratedQueryResponseFromJSONTyped,
  GeneratedQueryResponseToJSON: GeneratedQueryResponseToJSON,
  GeneratedQueryToJSON: GeneratedQueryToJSON,
  GetCommitResponseFromJSON: GetCommitResponseFromJSON,
  GetCommitResponseFromJSONTyped: GetCommitResponseFromJSONTyped,
  GetCommitResponseToJSON: GetCommitResponseToJSON,
  GetDatabaseDataFromJSON: GetDatabaseDataFromJSON,
  GetDatabaseDataFromJSONTyped: GetDatabaseDataFromJSONTyped,
  GetDatabaseDataTaskFromJSON: GetDatabaseDataTaskFromJSON,
  GetDatabaseDataTaskFromJSONTyped: GetDatabaseDataTaskFromJSONTyped,
  GetDatabaseDataTaskToJSON: GetDatabaseDataTaskToJSON,
  GetDatabaseDataToJSON: GetDatabaseDataToJSON,
  GetDatabaseResponseResponseFromJSON: GetDatabaseResponseResponseFromJSON,
  GetDatabaseResponseResponseFromJSONTyped: GetDatabaseResponseResponseFromJSONTyped,
  GetDatabaseResponseResponseToJSON: GetDatabaseResponseResponseToJSON,
  GetEnumWeightsRequestFromJSON: GetEnumWeightsRequestFromJSON,
  GetEnumWeightsRequestFromJSONTyped: GetEnumWeightsRequestFromJSONTyped,
  GetEnumWeightsRequestToJSON: GetEnumWeightsRequestToJSON,
  GetFieldWeightsRequestFromJSON: GetFieldWeightsRequestFromJSON,
  GetFieldWeightsRequestFromJSONTyped: GetFieldWeightsRequestFromJSONTyped,
  GetFieldWeightsRequestToJSON: GetFieldWeightsRequestToJSON,
  GetRecordsResponseDataAllOfFromJSON: GetRecordsResponseDataAllOfFromJSON,
  GetRecordsResponseDataAllOfFromJSONTyped: GetRecordsResponseDataAllOfFromJSONTyped,
  GetRecordsResponseDataAllOfToJSON: GetRecordsResponseDataAllOfToJSON,
  GetRecordsResponseDataFromJSON: GetRecordsResponseDataFromJSON,
  GetRecordsResponseDataFromJSONTyped: GetRecordsResponseDataFromJSONTyped,
  GetRecordsResponseDataToJSON: GetRecordsResponseDataToJSON,
  GetRecordsResponseFromJSON: GetRecordsResponseFromJSON,
  GetRecordsResponseFromJSONTyped: GetRecordsResponseFromJSONTyped,
  GetRecordsResponseToJSON: GetRecordsResponseToJSON,
  GetSheetCommitsResponseFromJSON: GetSheetCommitsResponseFromJSON,
  GetSheetCommitsResponseFromJSONTyped: GetSheetCommitsResponseFromJSONTyped,
  GetSheetCommitsResponseToJSON: GetSheetCommitsResponseToJSON,
  GetSnapshotRecordsChangeTypeEnum: GetSnapshotRecordsChangeTypeEnum,
  GetSpaceActivitySortField: GetSpaceActivitySortField,
  GetSpaceActivitySortFieldFromJSON: GetSpaceActivitySortFieldFromJSON,
  GetSpaceActivitySortFieldFromJSONTyped: GetSpaceActivitySortFieldFromJSONTyped,
  GetSpaceActivitySortFieldToJSON: GetSpaceActivitySortFieldToJSON,
  GetSpacesSortField: GetSpacesSortField,
  GetSpacesSortFieldFromJSON: GetSpacesSortFieldFromJSON,
  GetSpacesSortFieldFromJSONTyped: GetSpacesSortFieldFromJSONTyped,
  GetSpacesSortFieldToJSON: GetSpacesSortFieldToJSON,
  GetUserResponseFromJSON: GetUserResponseFromJSON,
  GetUserResponseFromJSONTyped: GetUserResponseFromJSONTyped,
  GetUserResponseToJSON: GetUserResponseToJSON,
  GetWorkbookCommitsResponseFromJSON: GetWorkbookCommitsResponseFromJSON,
  GetWorkbookCommitsResponseFromJSONTyped: GetWorkbookCommitsResponseFromJSONTyped,
  GetWorkbookCommitsResponseToJSON: GetWorkbookCommitsResponseToJSON,
  GuestAuthenticationEnum: GuestAuthenticationEnum,
  GuestAuthenticationEnumFromJSON: GuestAuthenticationEnumFromJSON,
  GuestAuthenticationEnumFromJSONTyped: GuestAuthenticationEnumFromJSONTyped,
  GuestAuthenticationEnumToJSON: GuestAuthenticationEnumToJSON,
  GuestConfigFromJSON: GuestConfigFromJSON,
  GuestConfigFromJSONTyped: GuestConfigFromJSONTyped,
  GuestConfigSpacesInnerFromJSON: GuestConfigSpacesInnerFromJSON,
  GuestConfigSpacesInnerFromJSONTyped: GuestConfigSpacesInnerFromJSONTyped,
  GuestConfigSpacesInnerToJSON: GuestConfigSpacesInnerToJSON,
  GuestConfigSpacesInnerWorkbooksInnerFromJSON: GuestConfigSpacesInnerWorkbooksInnerFromJSON,
  GuestConfigSpacesInnerWorkbooksInnerFromJSONTyped: GuestConfigSpacesInnerWorkbooksInnerFromJSONTyped,
  GuestConfigSpacesInnerWorkbooksInnerToJSON: GuestConfigSpacesInnerWorkbooksInnerToJSON,
  GuestConfigToJSON: GuestConfigToJSON,
  GuestConfigUpdateFromJSON: GuestConfigUpdateFromJSON,
  GuestConfigUpdateFromJSONTyped: GuestConfigUpdateFromJSONTyped,
  GuestConfigUpdateToJSON: GuestConfigUpdateToJSON,
  GuestFromJSON: GuestFromJSON,
  GuestFromJSONTyped: GuestFromJSONTyped,
  GuestResponseFromJSON: GuestResponseFromJSON,
  GuestResponseFromJSONTyped: GuestResponseFromJSONTyped,
  GuestResponseToJSON: GuestResponseToJSON,
  GuestToJSON: GuestToJSON,
  GuestsResponseFromJSON: GuestsResponseFromJSON,
  GuestsResponseFromJSONTyped: GuestsResponseFromJSONTyped,
  GuestsResponseToJSON: GuestsResponseToJSON,
  HasAllValidConstraintAllOfFromJSON: HasAllValidConstraintAllOfFromJSON,
  HasAllValidConstraintAllOfFromJSONTyped: HasAllValidConstraintAllOfFromJSONTyped,
  HasAllValidConstraintAllOfToJSON: HasAllValidConstraintAllOfToJSON,
  HasAllValidConstraintAllOfTypeEnum: HasAllValidConstraintAllOfTypeEnum,
  HasAllValidConstraintFromJSON: HasAllValidConstraintFromJSON,
  HasAllValidConstraintFromJSONTyped: HasAllValidConstraintFromJSONTyped,
  HasAllValidConstraintToJSON: HasAllValidConstraintToJSON,
  HasAllValidConstraintTypeEnum: HasAllValidConstraintTypeEnum,
  HasDataConstraintAllOfFromJSON: HasDataConstraintAllOfFromJSON,
  HasDataConstraintAllOfFromJSONTyped: HasDataConstraintAllOfFromJSONTyped,
  HasDataConstraintAllOfToJSON: HasDataConstraintAllOfToJSON,
  HasDataConstraintAllOfTypeEnum: HasDataConstraintAllOfTypeEnum,
  HasDataConstraintFromJSON: HasDataConstraintFromJSON,
  HasDataConstraintFromJSONTyped: HasDataConstraintFromJSONTyped,
  HasDataConstraintToJSON: HasDataConstraintToJSON,
  HasDataConstraintTypeEnum: HasDataConstraintTypeEnum,
  HasSelectionConstraintAllOfFromJSON: HasSelectionConstraintAllOfFromJSON,
  HasSelectionConstraintAllOfFromJSONTyped: HasSelectionConstraintAllOfFromJSONTyped,
  HasSelectionConstraintAllOfToJSON: HasSelectionConstraintAllOfToJSON,
  HasSelectionConstraintAllOfTypeEnum: HasSelectionConstraintAllOfTypeEnum,
  HasSelectionConstraintFromJSON: HasSelectionConstraintFromJSON,
  HasSelectionConstraintFromJSONTyped: HasSelectionConstraintFromJSONTyped,
  HasSelectionConstraintToJSON: HasSelectionConstraintToJSON,
  HasSelectionConstraintTypeEnum: HasSelectionConstraintTypeEnum,
  HealthResponseFromJSON: HealthResponseFromJSON,
  HealthResponseFromJSONTyped: HealthResponseFromJSONTyped,
  HealthResponseToJSON: HealthResponseToJSON,
  InputConstraintFromJSON: InputConstraintFromJSON,
  InputConstraintFromJSONTyped: InputConstraintFromJSONTyped,
  InputConstraintToJSON: InputConstraintToJSON,
  InputFieldConfigFromJSON: InputFieldConfigFromJSON,
  InputFieldConfigFromJSONTyped: InputFieldConfigFromJSONTyped,
  InputFieldConfigToJSON: InputFieldConfigToJSON,
  InputFieldDefaultValueFromJSON: InputFieldDefaultValueFromJSON,
  InputFieldDefaultValueFromJSONTyped: InputFieldDefaultValueFromJSONTyped,
  InputFieldDefaultValueToJSON: InputFieldDefaultValueToJSON,
  InputFieldFromJSON: InputFieldFromJSON,
  InputFieldFromJSONTyped: InputFieldFromJSONTyped,
  InputFieldToJSON: InputFieldToJSON,
  InputFieldTypeEnum: InputFieldTypeEnum,
  InviteGuestsRequestInnerFromJSON: InviteGuestsRequestInnerFromJSON,
  InviteGuestsRequestInnerFromJSONTyped: InviteGuestsRequestInnerFromJSONTyped,
  InviteGuestsRequestInnerToJSON: InviteGuestsRequestInnerToJSON,
  JSONApiResponse: JSONApiResponse,
  JobAckDetailsFromJSON: JobAckDetailsFromJSON,
  JobAckDetailsFromJSONTyped: JobAckDetailsFromJSONTyped,
  JobAckDetailsToJSON: JobAckDetailsToJSON,
  JobCancelDetailsFromJSON: JobCancelDetailsFromJSON,
  JobCancelDetailsFromJSONTyped: JobCancelDetailsFromJSONTyped,
  JobCancelDetailsToJSON: JobCancelDetailsToJSON,
  JobCompleteDetailsFromJSON: JobCompleteDetailsFromJSON,
  JobCompleteDetailsFromJSONTyped: JobCompleteDetailsFromJSONTyped,
  JobCompleteDetailsToJSON: JobCompleteDetailsToJSON,
  JobConfigConfigFromJSON: JobConfigConfigFromJSON,
  JobConfigConfigFromJSONTyped: JobConfigConfigFromJSONTyped,
  JobConfigConfigToJSON: JobConfigConfigToJSON,
  JobConfigFromJSON: JobConfigFromJSON,
  JobConfigFromJSONTyped: JobConfigFromJSONTyped,
  JobConfigModeEnum: JobConfigModeEnum,
  JobConfigPartExecutionEnum: JobConfigPartExecutionEnum,
  JobConfigStatusEnum: JobConfigStatusEnum,
  JobConfigToJSON: JobConfigToJSON,
  JobConfigTriggerEnum: JobConfigTriggerEnum,
  JobConfigTypeEnum: JobConfigTypeEnum,
  JobFromJSON: JobFromJSON,
  JobFromJSONTyped: JobFromJSONTyped,
  JobModeEnum: JobModeEnum,
  JobOutcomeFromJSON: JobOutcomeFromJSON,
  JobOutcomeFromJSONTyped: JobOutcomeFromJSONTyped,
  JobOutcomeNextDownloadFromJSON: JobOutcomeNextDownloadFromJSON,
  JobOutcomeNextDownloadFromJSONTyped: JobOutcomeNextDownloadFromJSONTyped,
  JobOutcomeNextDownloadToJSON: JobOutcomeNextDownloadToJSON,
  JobOutcomeNextDownloadTypeEnum: JobOutcomeNextDownloadTypeEnum,
  JobOutcomeNextFilesFilesInnerFromJSON: JobOutcomeNextFilesFilesInnerFromJSON,
  JobOutcomeNextFilesFilesInnerFromJSONTyped: JobOutcomeNextFilesFilesInnerFromJSONTyped,
  JobOutcomeNextFilesFilesInnerToJSON: JobOutcomeNextFilesFilesInnerToJSON,
  JobOutcomeNextFilesFromJSON: JobOutcomeNextFilesFromJSON,
  JobOutcomeNextFilesFromJSONTyped: JobOutcomeNextFilesFromJSONTyped,
  JobOutcomeNextFilesToJSON: JobOutcomeNextFilesToJSON,
  JobOutcomeNextFilesTypeEnum: JobOutcomeNextFilesTypeEnum,
  JobOutcomeNextFromJSON: JobOutcomeNextFromJSON,
  JobOutcomeNextFromJSONTyped: JobOutcomeNextFromJSONTyped,
  JobOutcomeNextIdFromJSON: JobOutcomeNextIdFromJSON,
  JobOutcomeNextIdFromJSONTyped: JobOutcomeNextIdFromJSONTyped,
  JobOutcomeNextIdToJSON: JobOutcomeNextIdToJSON,
  JobOutcomeNextIdTypeEnum: JobOutcomeNextIdTypeEnum,
  JobOutcomeNextRetryFromJSON: JobOutcomeNextRetryFromJSON,
  JobOutcomeNextRetryFromJSONTyped: JobOutcomeNextRetryFromJSONTyped,
  JobOutcomeNextRetryToJSON: JobOutcomeNextRetryToJSON,
  JobOutcomeNextRetryTypeEnum: JobOutcomeNextRetryTypeEnum,
  JobOutcomeNextSnapshotFromJSON: JobOutcomeNextSnapshotFromJSON,
  JobOutcomeNextSnapshotFromJSONTyped: JobOutcomeNextSnapshotFromJSONTyped,
  JobOutcomeNextSnapshotToJSON: JobOutcomeNextSnapshotToJSON,
  JobOutcomeNextSnapshotTypeEnum: JobOutcomeNextSnapshotTypeEnum,
  JobOutcomeNextToJSON: JobOutcomeNextToJSON,
  JobOutcomeNextType: JobOutcomeNextType,
  JobOutcomeNextTypeFromJSON: JobOutcomeNextTypeFromJSON,
  JobOutcomeNextTypeFromJSONTyped: JobOutcomeNextTypeFromJSONTyped,
  JobOutcomeNextTypeToJSON: JobOutcomeNextTypeToJSON,
  JobOutcomeNextUrlFromJSON: JobOutcomeNextUrlFromJSON,
  JobOutcomeNextUrlFromJSONTyped: JobOutcomeNextUrlFromJSONTyped,
  JobOutcomeNextUrlToJSON: JobOutcomeNextUrlToJSON,
  JobOutcomeNextUrlTypeEnum: JobOutcomeNextUrlTypeEnum,
  JobOutcomeNextViewFromJSON: JobOutcomeNextViewFromJSON,
  JobOutcomeNextViewFromJSONTyped: JobOutcomeNextViewFromJSONTyped,
  JobOutcomeNextViewToJSON: JobOutcomeNextViewToJSON,
  JobOutcomeNextViewTypeEnum: JobOutcomeNextViewTypeEnum,
  JobOutcomeNextWaitFromJSON: JobOutcomeNextWaitFromJSON,
  JobOutcomeNextWaitFromJSONTyped: JobOutcomeNextWaitFromJSONTyped,
  JobOutcomeNextWaitToJSON: JobOutcomeNextWaitToJSON,
  JobOutcomeNextWaitTypeEnum: JobOutcomeNextWaitTypeEnum,
  JobOutcomeToJSON: JobOutcomeToJSON,
  JobOutcomeTrigger: JobOutcomeTrigger,
  JobOutcomeTriggerFromJSON: JobOutcomeTriggerFromJSON,
  JobOutcomeTriggerFromJSONTyped: JobOutcomeTriggerFromJSONTyped,
  JobOutcomeTriggerToJSON: JobOutcomeTriggerToJSON,
  JobPartExecutionEnum: JobPartExecutionEnum,
  JobPlanFromJSON: JobPlanFromJSON,
  JobPlanFromJSONTyped: JobPlanFromJSONTyped,
  JobPlanResponseFromJSON: JobPlanResponseFromJSON,
  JobPlanResponseFromJSONTyped: JobPlanResponseFromJSONTyped,
  JobPlanResponseToJSON: JobPlanResponseToJSON,
  JobPlanToJSON: JobPlanToJSON,
  JobResponseFromJSON: JobResponseFromJSON,
  JobResponseFromJSONTyped: JobResponseFromJSONTyped,
  JobResponseToJSON: JobResponseToJSON,
  JobSplitDetailsFromJSON: JobSplitDetailsFromJSON,
  JobSplitDetailsFromJSONTyped: JobSplitDetailsFromJSONTyped,
  JobSplitDetailsPartsFromJSON: JobSplitDetailsPartsFromJSON,
  JobSplitDetailsPartsFromJSONTyped: JobSplitDetailsPartsFromJSONTyped,
  JobSplitDetailsPartsToJSON: JobSplitDetailsPartsToJSON,
  JobSplitDetailsToJSON: JobSplitDetailsToJSON,
  JobStatsAccountsFromJSON: JobStatsAccountsFromJSON,
  JobStatsAccountsFromJSONTyped: JobStatsAccountsFromJSONTyped,
  JobStatsAccountsToJSON: JobStatsAccountsToJSON,
  JobStatsFromJSON: JobStatsFromJSON,
  JobStatsFromJSONTyped: JobStatsFromJSONTyped,
  JobStatsJobsFromJSON: JobStatsJobsFromJSON,
  JobStatsJobsFromJSONTyped: JobStatsJobsFromJSONTyped,
  JobStatsJobsMapFromJSON: JobStatsJobsMapFromJSON,
  JobStatsJobsMapFromJSONTyped: JobStatsJobsMapFromJSONTyped,
  JobStatsJobsMapToJSON: JobStatsJobsMapToJSON,
  JobStatsJobsToJSON: JobStatsJobsToJSON,
  JobStatsResponseFromJSON: JobStatsResponseFromJSON,
  JobStatsResponseFromJSONTyped: JobStatsResponseFromJSONTyped,
  JobStatsResponseToJSON: JobStatsResponseToJSON,
  JobStatsToJSON: JobStatsToJSON,
  JobStatusEnum: JobStatusEnum,
  JobSubjectFromJSON: JobSubjectFromJSON,
  JobSubjectFromJSONTyped: JobSubjectFromJSONTyped,
  JobSubjectToJSON: JobSubjectToJSON,
  JobSubjectType: JobSubjectType,
  JobSubjectTypeFromJSON: JobSubjectTypeFromJSON,
  JobSubjectTypeFromJSONTyped: JobSubjectTypeFromJSONTyped,
  JobSubjectTypeToJSON: JobSubjectTypeToJSON,
  JobToJSON: JobToJSON,
  JobTriggerEnum: JobTriggerEnum,
  JobTypeEnum: JobTypeEnum,
  JobUpdateConfigFromJSON: JobUpdateConfigFromJSON,
  JobUpdateConfigFromJSONTyped: JobUpdateConfigFromJSONTyped,
  JobUpdateConfigToJSON: JobUpdateConfigToJSON,
  JobUpdateFromJSON: JobUpdateFromJSON,
  JobUpdateFromJSONTyped: JobUpdateFromJSONTyped,
  JobUpdateStatusEnum: JobUpdateStatusEnum,
  JobUpdateToJSON: JobUpdateToJSON,
  JobsResponseFromJSON: JobsResponseFromJSON,
  JobsResponseFromJSONTyped: JobsResponseFromJSONTyped,
  JobsResponseToJSON: JobsResponseToJSON,
  LineItemFromJSON: LineItemFromJSON,
  LineItemFromJSONTyped: LineItemFromJSONTyped,
  LineItemToJSON: LineItemToJSON,
  LinkSidebarConfigAllOfFromJSON: LinkSidebarConfigAllOfFromJSON,
  LinkSidebarConfigAllOfFromJSONTyped: LinkSidebarConfigAllOfFromJSONTyped,
  LinkSidebarConfigAllOfToJSON: LinkSidebarConfigAllOfToJSON,
  LinkSidebarConfigFromJSON: LinkSidebarConfigFromJSON,
  LinkSidebarConfigFromJSONTyped: LinkSidebarConfigFromJSONTyped,
  LinkSidebarConfigToJSON: LinkSidebarConfigToJSON,
  LinkSidebarConfigTypeEnum: LinkSidebarConfigTypeEnum,
  ListActorRolesResponseFromJSON: ListActorRolesResponseFromJSON,
  ListActorRolesResponseFromJSONTyped: ListActorRolesResponseFromJSONTyped,
  ListActorRolesResponseToJSON: ListActorRolesResponseToJSON,
  ListRolesResponseFromJSON: ListRolesResponseFromJSON,
  ListRolesResponseFromJSONTyped: ListRolesResponseFromJSONTyped,
  ListRolesResponseToJSON: ListRolesResponseToJSON,
  ListUsersSortField: ListUsersSortField,
  ListUsersSortFieldFromJSON: ListUsersSortFieldFromJSON,
  ListUsersSortFieldFromJSONTyped: ListUsersSortFieldFromJSONTyped,
  ListUsersSortFieldToJSON: ListUsersSortFieldToJSON,
  ManifestResponseFromJSON: ManifestResponseFromJSON,
  ManifestResponseFromJSONTyped: ManifestResponseFromJSONTyped,
  ManifestResponseToJSON: ManifestResponseToJSON,
  MappingCertainty: MappingCertainty,
  MappingCertaintyFromJSON: MappingCertaintyFromJSON,
  MappingCertaintyFromJSONTyped: MappingCertaintyFromJSONTyped,
  MappingCertaintyToJSON: MappingCertaintyToJSON,
  MappingProgramFromJSON: MappingProgramFromJSON,
  MappingProgramFromJSONTyped: MappingProgramFromJSONTyped,
  MappingProgramJobConfigFromJSON: MappingProgramJobConfigFromJSON,
  MappingProgramJobConfigFromJSONTyped: MappingProgramJobConfigFromJSONTyped,
  MappingProgramJobConfigToJSON: MappingProgramJobConfigToJSON,
  MappingProgramSummaryFromJSON: MappingProgramSummaryFromJSON,
  MappingProgramSummaryFromJSONTyped: MappingProgramSummaryFromJSONTyped,
  MappingProgramSummaryToJSON: MappingProgramSummaryToJSON,
  MappingProgramToJSON: MappingProgramToJSON,
  MappingRuleBaseFromJSON: MappingRuleBaseFromJSON,
  MappingRuleBaseFromJSONTyped: MappingRuleBaseFromJSONTyped,
  MappingRuleBaseToJSON: MappingRuleBaseToJSON,
  MappingRuleConfigFromJSON: MappingRuleConfigFromJSON,
  MappingRuleConfigFromJSONTyped: MappingRuleConfigFromJSONTyped,
  MappingRuleConfigToJSON: MappingRuleConfigToJSON,
  MappingRuleFromJSON: MappingRuleFromJSON,
  MappingRuleFromJSONTyped: MappingRuleFromJSONTyped,
  MappingRuleToJSON: MappingRuleToJSON,
  ModelFileFromJSON: ModelFileFromJSON,
  ModelFileFromJSONTyped: ModelFileFromJSONTyped,
  ModelFileStatusEnum: ModelFileStatusEnum,
  ModelFileStatusEnumFromJSON: ModelFileStatusEnumFromJSON,
  ModelFileStatusEnumFromJSONTyped: ModelFileStatusEnumFromJSONTyped,
  ModelFileStatusEnumToJSON: ModelFileStatusEnumToJSON,
  ModelFileToJSON: ModelFileToJSON,
  MutateJobConfigFromJSON: MutateJobConfigFromJSON,
  MutateJobConfigFromJSONTyped: MutateJobConfigFromJSONTyped,
  MutateJobConfigToJSON: MutateJobConfigToJSON,
  NumberPropertyAllOfConfigFromJSON: NumberPropertyAllOfConfigFromJSON,
  NumberPropertyAllOfConfigFromJSONTyped: NumberPropertyAllOfConfigFromJSONTyped,
  NumberPropertyAllOfConfigToJSON: NumberPropertyAllOfConfigToJSON,
  NumberPropertyAllOfFromJSON: NumberPropertyAllOfFromJSON,
  NumberPropertyAllOfFromJSONTyped: NumberPropertyAllOfFromJSONTyped,
  NumberPropertyAllOfToJSON: NumberPropertyAllOfToJSON,
  NumberPropertyAllOfTypeEnum: NumberPropertyAllOfTypeEnum,
  NumberPropertyFromJSON: NumberPropertyFromJSON,
  NumberPropertyFromJSONTyped: NumberPropertyFromJSONTyped,
  NumberPropertyToJSON: NumberPropertyToJSON,
  NumberPropertyTypeEnum: NumberPropertyTypeEnum,
  PaginationFromJSON: PaginationFromJSON,
  PaginationFromJSONTyped: PaginationFromJSONTyped,
  PaginationToJSON: PaginationToJSON,
  PipelineJobConfigFromJSON: PipelineJobConfigFromJSON,
  PipelineJobConfigFromJSONTyped: PipelineJobConfigFromJSONTyped,
  PipelineJobConfigToJSON: PipelineJobConfigToJSON,
  PlanConfigFromJSON: PlanConfigFromJSON,
  PlanConfigFromJSONTyped: PlanConfigFromJSONTyped,
  PlanConfigToJSON: PlanConfigToJSON,
  PlanFromJSON: PlanFromJSON,
  PlanFromJSONTyped: PlanFromJSONTyped,
  PlanToJSON: PlanToJSON,
  ProductFromJSON: ProductFromJSON,
  ProductFromJSONTyped: ProductFromJSONTyped,
  ProductToJSON: ProductToJSON,
  ProductsResponseFromJSON: ProductsResponseFromJSON,
  ProductsResponseFromJSONTyped: ProductsResponseFromJSONTyped,
  ProductsResponseToJSON: ProductsResponseToJSON,
  ProgramResponseFromJSON: ProgramResponseFromJSON,
  ProgramResponseFromJSONTyped: ProgramResponseFromJSONTyped,
  ProgramResponseToJSON: ProgramResponseToJSON,
  ProgramsResponseFromJSON: ProgramsResponseFromJSON,
  ProgramsResponseFromJSONTyped: ProgramsResponseFromJSONTyped,
  ProgramsResponseToJSON: ProgramsResponseToJSON,
  PromptConfigFromJSON: PromptConfigFromJSON,
  PromptConfigFromJSONTyped: PromptConfigFromJSONTyped,
  PromptConfigToJSON: PromptConfigToJSON,
  PromptFromJSON: PromptFromJSON,
  PromptFromJSONTyped: PromptFromJSONTyped,
  PromptResponseFromJSON: PromptResponseFromJSON,
  PromptResponseFromJSONTyped: PromptResponseFromJSONTyped,
  PromptResponseToJSON: PromptResponseToJSON,
  PromptToJSON: PromptToJSON,
  PromptsResponseFromJSON: PromptsResponseFromJSON,
  PromptsResponseFromJSONTyped: PromptsResponseFromJSONTyped,
  PromptsResponseToJSON: PromptsResponseToJSON,
  PropertyFromJSON: PropertyFromJSON,
  PropertyFromJSONTyped: PropertyFromJSONTyped,
  PropertyToJSON: PropertyToJSON,
  RecordCountsFromJSON: RecordCountsFromJSON,
  RecordCountsFromJSONTyped: RecordCountsFromJSONTyped,
  RecordCountsResponseDataAllOfFromJSON: RecordCountsResponseDataAllOfFromJSON,
  RecordCountsResponseDataAllOfFromJSONTyped: RecordCountsResponseDataAllOfFromJSONTyped,
  RecordCountsResponseDataAllOfToJSON: RecordCountsResponseDataAllOfToJSON,
  RecordCountsResponseDataFromJSON: RecordCountsResponseDataFromJSON,
  RecordCountsResponseDataFromJSONTyped: RecordCountsResponseDataFromJSONTyped,
  RecordCountsResponseDataToJSON: RecordCountsResponseDataToJSON,
  RecordCountsResponseFromJSON: RecordCountsResponseFromJSON,
  RecordCountsResponseFromJSONTyped: RecordCountsResponseFromJSONTyped,
  RecordCountsResponseToJSON: RecordCountsResponseToJSON,
  RecordCountsToJSON: RecordCountsToJSON,
  RecordDataFromJSON: RecordDataFromJSON,
  RecordDataFromJSONTyped: RecordDataFromJSONTyped,
  RecordDataToJSON: RecordDataToJSON,
  RecordDataWithLinksFromJSON: RecordDataWithLinksFromJSON,
  RecordDataWithLinksFromJSONTyped: RecordDataWithLinksFromJSONTyped,
  RecordDataWithLinksToJSON: RecordDataWithLinksToJSON,
  RecordFromJSON: RecordFromJSON,
  RecordFromJSONTyped: RecordFromJSONTyped,
  RecordToJSON: RecordToJSON,
  RecordUpdatesAllOfFromJSON: RecordUpdatesAllOfFromJSON,
  RecordUpdatesAllOfFromJSONTyped: RecordUpdatesAllOfFromJSONTyped,
  RecordUpdatesAllOfToJSON: RecordUpdatesAllOfToJSON,
  RecordUpdatesFromJSON: RecordUpdatesFromJSON,
  RecordUpdatesFromJSONTyped: RecordUpdatesFromJSONTyped,
  RecordUpdatesToJSON: RecordUpdatesToJSON,
  RecordWithLinksFromJSON: RecordWithLinksFromJSON,
  RecordWithLinksFromJSONTyped: RecordWithLinksFromJSONTyped,
  RecordWithLinksToJSON: RecordWithLinksToJSON,
  RecordsDataFromJSON: RecordsDataFromJSON,
  RecordsDataFromJSONTyped: RecordsDataFromJSONTyped,
  RecordsDataToJSON: RecordsDataToJSON,
  RecordsFromJSON: RecordsFromJSON,
  RecordsFromJSONTyped: RecordsFromJSONTyped,
  RecordsResponseDataAllOfFromJSON: RecordsResponseDataAllOfFromJSON,
  RecordsResponseDataAllOfFromJSONTyped: RecordsResponseDataAllOfFromJSONTyped,
  RecordsResponseDataAllOfToJSON: RecordsResponseDataAllOfToJSON,
  RecordsResponseDataFromJSON: RecordsResponseDataFromJSON,
  RecordsResponseDataFromJSONTyped: RecordsResponseDataFromJSONTyped,
  RecordsResponseDataToJSON: RecordsResponseDataToJSON,
  RecordsResponseFromJSON: RecordsResponseFromJSON,
  RecordsResponseFromJSONTyped: RecordsResponseFromJSONTyped,
  RecordsResponseToJSON: RecordsResponseToJSON,
  RecordsToJSON: RecordsToJSON,
  RecordsUpdatesFromJSON: RecordsUpdatesFromJSON,
  RecordsUpdatesFromJSONTyped: RecordsUpdatesFromJSONTyped,
  RecordsUpdatesToJSON: RecordsUpdatesToJSON,
  RecordsWithLinksFromJSON: RecordsWithLinksFromJSON,
  RecordsWithLinksFromJSONTyped: RecordsWithLinksFromJSONTyped,
  RecordsWithLinksToJSON: RecordsWithLinksToJSON,
  ReferenceListPropertyAllOfConfigFromJSON: ReferenceListPropertyAllOfConfigFromJSON,
  ReferenceListPropertyAllOfConfigFromJSONTyped: ReferenceListPropertyAllOfConfigFromJSONTyped,
  ReferenceListPropertyAllOfConfigToJSON: ReferenceListPropertyAllOfConfigToJSON,
  ReferenceListPropertyAllOfFromJSON: ReferenceListPropertyAllOfFromJSON,
  ReferenceListPropertyAllOfFromJSONTyped: ReferenceListPropertyAllOfFromJSONTyped,
  ReferenceListPropertyAllOfToJSON: ReferenceListPropertyAllOfToJSON,
  ReferenceListPropertyAllOfTypeEnum: ReferenceListPropertyAllOfTypeEnum,
  ReferenceListPropertyFromJSON: ReferenceListPropertyFromJSON,
  ReferenceListPropertyFromJSONTyped: ReferenceListPropertyFromJSONTyped,
  ReferenceListPropertyToJSON: ReferenceListPropertyToJSON,
  ReferenceListPropertyTypeEnum: ReferenceListPropertyTypeEnum,
  ReferencePropertyAllOfConfigFromJSON: ReferencePropertyAllOfConfigFromJSON,
  ReferencePropertyAllOfConfigFromJSONTyped: ReferencePropertyAllOfConfigFromJSONTyped,
  ReferencePropertyAllOfConfigRelationshipEnum: ReferencePropertyAllOfConfigRelationshipEnum,
  ReferencePropertyAllOfConfigToJSON: ReferencePropertyAllOfConfigToJSON,
  ReferencePropertyAllOfFromJSON: ReferencePropertyAllOfFromJSON,
  ReferencePropertyAllOfFromJSONTyped: ReferencePropertyAllOfFromJSONTyped,
  ReferencePropertyAllOfToJSON: ReferencePropertyAllOfToJSON,
  ReferencePropertyAllOfTypeEnum: ReferencePropertyAllOfTypeEnum,
  ReferencePropertyFromJSON: ReferencePropertyFromJSON,
  ReferencePropertyFromJSONTyped: ReferencePropertyFromJSONTyped,
  ReferencePropertyToJSON: ReferencePropertyToJSON,
  ReferencePropertyTypeEnum: ReferencePropertyTypeEnum,
  ReplaceRequestFromJSON: ReplaceRequestFromJSON,
  ReplaceRequestFromJSONTyped: ReplaceRequestFromJSONTyped,
  ReplaceRequestToJSON: ReplaceRequestToJSON,
  RequiredConstraintAllOfFromJSON: RequiredConstraintAllOfFromJSON,
  RequiredConstraintAllOfFromJSONTyped: RequiredConstraintAllOfFromJSONTyped,
  RequiredConstraintAllOfToJSON: RequiredConstraintAllOfToJSON,
  RequiredConstraintAllOfTypeEnum: RequiredConstraintAllOfTypeEnum,
  RequiredConstraintFromJSON: RequiredConstraintFromJSON,
  RequiredConstraintFromJSONTyped: RequiredConstraintFromJSONTyped,
  RequiredConstraintToJSON: RequiredConstraintToJSON,
  RequiredConstraintTypeEnum: RequiredConstraintTypeEnum,
  RequiredError: RequiredError,
  ResourceIdFromJSON: ResourceIdFromJSON,
  ResourceIdFromJSONTyped: ResourceIdFromJSONTyped,
  ResourceIdToJSON: ResourceIdToJSON,
  ResourceJobSubjectFromJSON: ResourceJobSubjectFromJSON,
  ResourceJobSubjectFromJSONTyped: ResourceJobSubjectFromJSONTyped,
  ResourceJobSubjectToJSON: ResourceJobSubjectToJSON,
  ResponseError: ResponseError,
  RestoreConfigFromJSON: RestoreConfigFromJSON,
  RestoreConfigFromJSONTyped: RestoreConfigFromJSONTyped,
  RestoreConfigToJSON: RestoreConfigToJSON,
  RestoreFromJSON: RestoreFromJSON,
  RestoreFromJSONTyped: RestoreFromJSONTyped,
  RestoreResponseFromJSON: RestoreResponseFromJSON,
  RestoreResponseFromJSONTyped: RestoreResponseFromJSONTyped,
  RestoreResponseToJSON: RestoreResponseToJSON,
  RestoreSnapshotRequestFromJSON: RestoreSnapshotRequestFromJSON,
  RestoreSnapshotRequestFromJSONTyped: RestoreSnapshotRequestFromJSONTyped,
  RestoreSnapshotRequestToJSON: RestoreSnapshotRequestToJSON,
  RestoreToJSON: RestoreToJSON,
  RoleActorResourceAllOfFromJSON: RoleActorResourceAllOfFromJSON,
  RoleActorResourceAllOfFromJSONTyped: RoleActorResourceAllOfFromJSONTyped,
  RoleActorResourceAllOfToJSON: RoleActorResourceAllOfToJSON,
  RoleActorResourceFromJSON: RoleActorResourceFromJSON,
  RoleActorResourceFromJSONTyped: RoleActorResourceFromJSONTyped,
  RoleActorResourceToJSON: RoleActorResourceToJSON,
  RoleResponseFromJSON: RoleResponseFromJSON,
  RoleResponseFromJSONTyped: RoleResponseFromJSONTyped,
  RoleResponseToJSON: RoleResponseToJSON,
  RuleResponseFromJSON: RuleResponseFromJSON,
  RuleResponseFromJSONTyped: RuleResponseFromJSONTyped,
  RuleResponseToJSON: RuleResponseToJSON,
  RulesResponseFromJSON: RulesResponseFromJSON,
  RulesResponseFromJSONTyped: RulesResponseFromJSONTyped,
  RulesResponseToJSON: RulesResponseToJSON,
  SecretFromJSON: SecretFromJSON,
  SecretFromJSONTyped: SecretFromJSONTyped,
  SecretToJSON: SecretToJSON,
  SecretsFromJSON: SecretsFromJSON,
  SecretsFromJSONTyped: SecretsFromJSONTyped,
  SecretsResponseFromJSON: SecretsResponseFromJSON,
  SecretsResponseFromJSONTyped: SecretsResponseFromJSONTyped,
  SecretsResponseToJSON: SecretsResponseToJSON,
  SecretsToJSON: SecretsToJSON,
  SheetAccess: SheetAccess,
  SheetAccessFromJSON: SheetAccessFromJSON,
  SheetAccessFromJSONTyped: SheetAccessFromJSONTyped,
  SheetAccessToJSON: SheetAccessToJSON,
  SheetConfigFromJSON: SheetConfigFromJSON,
  SheetConfigFromJSONTyped: SheetConfigFromJSONTyped,
  SheetConfigOptionsFromJSON: SheetConfigOptionsFromJSON,
  SheetConfigOptionsFromJSONTyped: SheetConfigOptionsFromJSONTyped,
  SheetConfigOptionsToJSON: SheetConfigOptionsToJSON,
  SheetConfigOrUpdateFromJSON: SheetConfigOrUpdateFromJSON,
  SheetConfigOrUpdateFromJSONTyped: SheetConfigOrUpdateFromJSONTyped,
  SheetConfigOrUpdateToJSON: SheetConfigOrUpdateToJSON,
  SheetConfigToJSON: SheetConfigToJSON,
  SheetConfigUpdateFromJSON: SheetConfigUpdateFromJSON,
  SheetConfigUpdateFromJSONTyped: SheetConfigUpdateFromJSONTyped,
  SheetConfigUpdateToJSON: SheetConfigUpdateToJSON,
  SheetConstraintFromJSON: SheetConstraintFromJSON,
  SheetConstraintFromJSONTyped: SheetConstraintFromJSONTyped,
  SheetConstraintToJSON: SheetConstraintToJSON,
  SheetFromJSON: SheetFromJSON,
  SheetFromJSONTyped: SheetFromJSONTyped,
  SheetResponseFromJSON: SheetResponseFromJSON,
  SheetResponseFromJSONTyped: SheetResponseFromJSONTyped,
  SheetResponseToJSON: SheetResponseToJSON,
  SheetToJSON: SheetToJSON,
  SheetUpdateFromJSON: SheetUpdateFromJSON,
  SheetUpdateFromJSONTyped: SheetUpdateFromJSONTyped,
  SheetUpdateRequestFromJSON: SheetUpdateRequestFromJSON,
  SheetUpdateRequestFromJSONTyped: SheetUpdateRequestFromJSONTyped,
  SheetUpdateRequestToJSON: SheetUpdateRequestToJSON,
  SheetUpdateToJSON: SheetUpdateToJSON,
  SheetsResponseFromJSON: SheetsResponseFromJSON,
  SheetsResponseFromJSONTyped: SheetsResponseFromJSONTyped,
  SheetsResponseToJSON: SheetsResponseToJSON,
  SidebarConfigFromJSON: SidebarConfigFromJSON,
  SidebarConfigFromJSONTyped: SidebarConfigFromJSONTyped,
  SidebarConfigToJSON: SidebarConfigToJSON,
  SnapshotFromJSON: SnapshotFromJSON,
  SnapshotFromJSONTyped: SnapshotFromJSONTyped,
  SnapshotResponseFromJSON: SnapshotResponseFromJSON,
  SnapshotResponseFromJSONTyped: SnapshotResponseFromJSONTyped,
  SnapshotResponseToJSON: SnapshotResponseToJSON,
  SnapshotSheetRequestFromJSON: SnapshotSheetRequestFromJSON,
  SnapshotSheetRequestFromJSONTyped: SnapshotSheetRequestFromJSONTyped,
  SnapshotSheetRequestToJSON: SnapshotSheetRequestToJSON,
  SnapshotSummaryCreatedSinceFromJSON: SnapshotSummaryCreatedSinceFromJSON,
  SnapshotSummaryCreatedSinceFromJSONTyped: SnapshotSummaryCreatedSinceFromJSONTyped,
  SnapshotSummaryCreatedSinceToJSON: SnapshotSummaryCreatedSinceToJSON,
  SnapshotSummaryFromJSON: SnapshotSummaryFromJSON,
  SnapshotSummaryFromJSONTyped: SnapshotSummaryFromJSONTyped,
  SnapshotSummaryToJSON: SnapshotSummaryToJSON,
  SnapshotSummaryUpdatedSinceFromJSON: SnapshotSummaryUpdatedSinceFromJSON,
  SnapshotSummaryUpdatedSinceFromJSONTyped: SnapshotSummaryUpdatedSinceFromJSONTyped,
  SnapshotSummaryUpdatedSinceToJSON: SnapshotSummaryUpdatedSinceToJSON,
  SnapshotToJSON: SnapshotToJSON,
  SnapshotsResponseFromJSON: SnapshotsResponseFromJSON,
  SnapshotsResponseFromJSONTyped: SnapshotsResponseFromJSONTyped,
  SnapshotsResponseToJSON: SnapshotsResponseToJSON,
  SortDirection: SortDirection,
  SortDirectionFromJSON: SortDirectionFromJSON,
  SortDirectionFromJSONTyped: SortDirectionFromJSONTyped,
  SortDirectionToJSON: SortDirectionToJSON,
  SourceDestinationWeightFromJSON: SourceDestinationWeightFromJSON,
  SourceDestinationWeightFromJSONTyped: SourceDestinationWeightFromJSONTyped,
  SourceDestinationWeightToJSON: SourceDestinationWeightToJSON,
  SourceDestinationWeightsResponseDataFromJSON: SourceDestinationWeightsResponseDataFromJSON,
  SourceDestinationWeightsResponseDataFromJSONTyped: SourceDestinationWeightsResponseDataFromJSONTyped,
  SourceDestinationWeightsResponseDataToJSON: SourceDestinationWeightsResponseDataToJSON,
  SourceDestinationWeightsResponseFromJSON: SourceDestinationWeightsResponseFromJSON,
  SourceDestinationWeightsResponseFromJSONTyped: SourceDestinationWeightsResponseFromJSONTyped,
  SourceDestinationWeightsResponseToJSON: SourceDestinationWeightsResponseToJSON,
  SourceFieldFromJSON: SourceFieldFromJSON,
  SourceFieldFromJSONTyped: SourceFieldFromJSONTyped,
  SourceFieldToJSON: SourceFieldToJSON,
  SpaceAccess: SpaceAccess,
  SpaceAccessFromJSON: SpaceAccessFromJSON,
  SpaceAccessFromJSONTyped: SpaceAccessFromJSONTyped,
  SpaceAccessToJSON: SpaceAccessToJSON,
  SpaceConfigFromJSON: SpaceConfigFromJSON,
  SpaceConfigFromJSONTyped: SpaceConfigFromJSONTyped,
  SpaceConfigResponseFromJSON: SpaceConfigResponseFromJSON,
  SpaceConfigResponseFromJSONTyped: SpaceConfigResponseFromJSONTyped,
  SpaceConfigResponseToJSON: SpaceConfigResponseToJSON,
  SpaceConfigToJSON: SpaceConfigToJSON,
  SpaceConfigsResponseFromJSON: SpaceConfigsResponseFromJSON,
  SpaceConfigsResponseFromJSONTyped: SpaceConfigsResponseFromJSONTyped,
  SpaceConfigsResponseToJSON: SpaceConfigsResponseToJSON,
  SpaceFromJSON: SpaceFromJSON,
  SpaceFromJSONTyped: SpaceFromJSONTyped,
  SpacePatternConfigFromJSON: SpacePatternConfigFromJSON,
  SpacePatternConfigFromJSONTyped: SpacePatternConfigFromJSONTyped,
  SpacePatternConfigToJSON: SpacePatternConfigToJSON,
  SpacePatternFromJSON: SpacePatternFromJSON,
  SpacePatternFromJSONTyped: SpacePatternFromJSONTyped,
  SpacePatternToJSON: SpacePatternToJSON,
  SpaceResponseFromJSON: SpaceResponseFromJSON,
  SpaceResponseFromJSONTyped: SpaceResponseFromJSONTyped,
  SpaceResponseToJSON: SpaceResponseToJSON,
  SpaceSettingsFromJSON: SpaceSettingsFromJSON,
  SpaceSettingsFromJSONTyped: SpaceSettingsFromJSONTyped,
  SpaceSettingsToJSON: SpaceSettingsToJSON,
  SpaceSidebarConfigFromJSON: SpaceSidebarConfigFromJSON,
  SpaceSidebarConfigFromJSONTyped: SpaceSidebarConfigFromJSONTyped,
  SpaceSidebarConfigToJSON: SpaceSidebarConfigToJSON,
  SpaceSizeFromJSON: SpaceSizeFromJSON,
  SpaceSizeFromJSONTyped: SpaceSizeFromJSONTyped,
  SpaceSizeToJSON: SpaceSizeToJSON,
  SpaceToJSON: SpaceToJSON,
  SpacesResponseFromJSON: SpacesResponseFromJSON,
  SpacesResponseFromJSONTyped: SpacesResponseFromJSONTyped,
  SpacesResponseToJSON: SpacesResponseToJSON,
  StringListPropertyAllOfFromJSON: StringListPropertyAllOfFromJSON,
  StringListPropertyAllOfFromJSONTyped: StringListPropertyAllOfFromJSONTyped,
  StringListPropertyAllOfToJSON: StringListPropertyAllOfToJSON,
  StringListPropertyAllOfTypeEnum: StringListPropertyAllOfTypeEnum,
  StringListPropertyFromJSON: StringListPropertyFromJSON,
  StringListPropertyFromJSONTyped: StringListPropertyFromJSONTyped,
  StringListPropertyToJSON: StringListPropertyToJSON,
  StringListPropertyTypeEnum: StringListPropertyTypeEnum,
  StringPropertyAllOfFromJSON: StringPropertyAllOfFromJSON,
  StringPropertyAllOfFromJSONTyped: StringPropertyAllOfFromJSONTyped,
  StringPropertyAllOfToJSON: StringPropertyAllOfToJSON,
  StringPropertyAllOfTypeEnum: StringPropertyAllOfTypeEnum,
  StringPropertyFromJSON: StringPropertyFromJSON,
  StringPropertyFromJSONTyped: StringPropertyFromJSONTyped,
  StringPropertyToJSON: StringPropertyToJSON,
  StringPropertyTypeEnum: StringPropertyTypeEnum,
  StripeMetadataFromJSON: StripeMetadataFromJSON,
  StripeMetadataFromJSONTyped: StripeMetadataFromJSONTyped,
  StripeMetadataToJSON: StripeMetadataToJSON,
  StripePriceFromJSON: StripePriceFromJSON,
  StripePriceFromJSONTyped: StripePriceFromJSONTyped,
  StripePriceTierFromJSON: StripePriceTierFromJSON,
  StripePriceTierFromJSONTyped: StripePriceTierFromJSONTyped,
  StripePriceTierToJSON: StripePriceTierToJSON,
  StripePriceToJSON: StripePriceToJSON,
  StripeWebhookRequestBodyFromJSON: StripeWebhookRequestBodyFromJSON,
  StripeWebhookRequestBodyFromJSONTyped: StripeWebhookRequestBodyFromJSONTyped,
  StripeWebhookRequestBodyRequestFromJSON: StripeWebhookRequestBodyRequestFromJSON,
  StripeWebhookRequestBodyRequestFromJSONTyped: StripeWebhookRequestBodyRequestFromJSONTyped,
  StripeWebhookRequestBodyRequestToJSON: StripeWebhookRequestBodyRequestToJSON,
  StripeWebhookRequestBodyToJSON: StripeWebhookRequestBodyToJSON,
  SubscriptionUpdatesBodyFromJSON: SubscriptionUpdatesBodyFromJSON,
  SubscriptionUpdatesBodyFromJSONTyped: SubscriptionUpdatesBodyFromJSONTyped,
  SubscriptionUpdatesBodyToJSON: SubscriptionUpdatesBodyToJSON,
  SuccessFromJSON: SuccessFromJSON,
  SuccessFromJSONTyped: SuccessFromJSONTyped,
  SuccessResponseFromJSON: SuccessResponseFromJSON,
  SuccessResponseFromJSONTyped: SuccessResponseFromJSONTyped,
  SuccessResponseToJSON: SuccessResponseToJSON,
  SuccessToJSON: SuccessToJSON,
  TextApiResponse: TextApiResponse,
  UniqueConstraintAllOfConfigFromJSON: UniqueConstraintAllOfConfigFromJSON,
  UniqueConstraintAllOfConfigFromJSONTyped: UniqueConstraintAllOfConfigFromJSONTyped,
  UniqueConstraintAllOfConfigToJSON: UniqueConstraintAllOfConfigToJSON,
  UniqueConstraintAllOfFromJSON: UniqueConstraintAllOfFromJSON,
  UniqueConstraintAllOfFromJSONTyped: UniqueConstraintAllOfFromJSONTyped,
  UniqueConstraintAllOfToJSON: UniqueConstraintAllOfToJSON,
  UniqueConstraintAllOfTypeEnum: UniqueConstraintAllOfTypeEnum,
  UniqueConstraintFromJSON: UniqueConstraintFromJSON,
  UniqueConstraintFromJSONTyped: UniqueConstraintFromJSONTyped,
  UniqueConstraintToJSON: UniqueConstraintToJSON,
  UniqueConstraintTypeEnum: UniqueConstraintTypeEnum,
  UpdateAccountFromJSON: UpdateAccountFromJSON,
  UpdateAccountFromJSONTyped: UpdateAccountFromJSONTyped,
  UpdateAccountToJSON: UpdateAccountToJSON,
  UpdateEnvironmentByIdRequestDataRetentionPolicyEnum: UpdateEnvironmentByIdRequestDataRetentionPolicyEnum,
  UpdateEnvironmentByIdRequestFromJSON: UpdateEnvironmentByIdRequestFromJSON,
  UpdateEnvironmentByIdRequestFromJSONTyped: UpdateEnvironmentByIdRequestFromJSONTyped,
  UpdateEnvironmentByIdRequestToJSON: UpdateEnvironmentByIdRequestToJSON,
  UpdateJobExecutionPlanByIdRequestFromJSON: UpdateJobExecutionPlanByIdRequestFromJSON,
  UpdateJobExecutionPlanByIdRequestFromJSONTyped: UpdateJobExecutionPlanByIdRequestFromJSONTyped,
  UpdateJobExecutionPlanByIdRequestToJSON: UpdateJobExecutionPlanByIdRequestToJSON,
  UpdateJobExecutionPlanFieldsRequestFromJSON: UpdateJobExecutionPlanFieldsRequestFromJSON,
  UpdateJobExecutionPlanFieldsRequestFromJSONTyped: UpdateJobExecutionPlanFieldsRequestFromJSONTyped,
  UpdateJobExecutionPlanFieldsRequestToJSON: UpdateJobExecutionPlanFieldsRequestToJSON,
  UpdateUserRequestFromJSON: UpdateUserRequestFromJSON,
  UpdateUserRequestFromJSONTyped: UpdateUserRequestFromJSONTyped,
  UpdateUserRequestToJSON: UpdateUserRequestToJSON,
  UpdateViewRequestFromJSON: UpdateViewRequestFromJSON,
  UpdateViewRequestFromJSONTyped: UpdateViewRequestFromJSONTyped,
  UpdateViewRequestToJSON: UpdateViewRequestToJSON,
  UpgradeSpaceConfigFromJSON: UpgradeSpaceConfigFromJSON,
  UpgradeSpaceConfigFromJSONTyped: UpgradeSpaceConfigFromJSONTyped,
  UpgradeSpaceConfigToJSON: UpgradeSpaceConfigToJSON,
  UploadConfigFromJSON: UploadConfigFromJSON,
  UploadConfigFromJSONTyped: UploadConfigFromJSONTyped,
  UploadConfigToJSON: UploadConfigToJSON,
  UserConfigFromJSON: UserConfigFromJSON,
  UserConfigFromJSONTyped: UserConfigFromJSONTyped,
  UserConfigToJSON: UserConfigToJSON,
  UserCreateAndInviteBodyFromJSON: UserCreateAndInviteBodyFromJSON,
  UserCreateAndInviteBodyFromJSONTyped: UserCreateAndInviteBodyFromJSONTyped,
  UserCreateAndInviteBodyToJSON: UserCreateAndInviteBodyToJSON,
  UserCredentialsFromJSON: UserCredentialsFromJSON,
  UserCredentialsFromJSONTyped: UserCredentialsFromJSONTyped,
  UserCredentialsToJSON: UserCredentialsToJSON,
  UserFromJSON: UserFromJSON,
  UserFromJSONTyped: UserFromJSONTyped,
  UserResponseFromJSON: UserResponseFromJSON,
  UserResponseFromJSONTyped: UserResponseFromJSONTyped,
  UserResponseToJSON: UserResponseToJSON,
  UserToJSON: UserToJSON,
  UserWithRolesFromJSON: UserWithRolesFromJSON,
  UserWithRolesFromJSONTyped: UserWithRolesFromJSONTyped,
  UserWithRolesToJSON: UserWithRolesToJSON,
  UsersResponseFromJSON: UsersResponseFromJSON,
  UsersResponseFromJSONTyped: UsersResponseFromJSONTyped,
  UsersResponseToJSON: UsersResponseToJSON,
  ValidationFromJSON: ValidationFromJSON,
  ValidationFromJSONTyped: ValidationFromJSONTyped,
  ValidationMessageFromJSON: ValidationMessageFromJSON,
  ValidationMessageFromJSONTyped: ValidationMessageFromJSONTyped,
  ValidationMessageSourceEnum: ValidationMessageSourceEnum,
  ValidationMessageToJSON: ValidationMessageToJSON,
  ValidationMessageTypeEnum: ValidationMessageTypeEnum,
  ValidationToJSON: ValidationToJSON,
  ValueFromJSON: ValueFromJSON,
  ValueFromJSONTyped: ValueFromJSONTyped,
  ValueToJSON: ValueToJSON,
  VersionResponseDataFromJSON: VersionResponseDataFromJSON,
  VersionResponseDataFromJSONTyped: VersionResponseDataFromJSONTyped,
  VersionResponseDataToJSON: VersionResponseDataToJSON,
  VersionResponseFromJSON: VersionResponseFromJSON,
  VersionResponseFromJSONTyped: VersionResponseFromJSONTyped,
  VersionResponseToJSON: VersionResponseToJSON,
  ViewConfigFromJSON: ViewConfigFromJSON,
  ViewConfigFromJSONTyped: ViewConfigFromJSONTyped,
  ViewConfigToJSON: ViewConfigToJSON,
  ViewFromJSON: ViewFromJSON,
  ViewFromJSONTyped: ViewFromJSONTyped,
  ViewResponseFromJSON: ViewResponseFromJSON,
  ViewResponseFromJSONTyped: ViewResponseFromJSONTyped,
  ViewResponseToJSON: ViewResponseToJSON,
  ViewToJSON: ViewToJSON,
  ViewsResponseFromJSON: ViewsResponseFromJSON,
  ViewsResponseFromJSONTyped: ViewsResponseFromJSONTyped,
  ViewsResponseToJSON: ViewsResponseToJSON,
  VoidApiResponse: VoidApiResponse,
  WorkbookConfigFromJSON: WorkbookConfigFromJSON,
  WorkbookConfigFromJSONTyped: WorkbookConfigFromJSONTyped,
  WorkbookConfigSettingsFromJSON: WorkbookConfigSettingsFromJSON,
  WorkbookConfigSettingsFromJSONTyped: WorkbookConfigSettingsFromJSONTyped,
  WorkbookConfigSettingsToJSON: WorkbookConfigSettingsToJSON,
  WorkbookConfigToJSON: WorkbookConfigToJSON,
  WorkbookFromJSON: WorkbookFromJSON,
  WorkbookFromJSONTyped: WorkbookFromJSONTyped,
  WorkbookResponseFromJSON: WorkbookResponseFromJSON,
  WorkbookResponseFromJSONTyped: WorkbookResponseFromJSONTyped,
  WorkbookResponseToJSON: WorkbookResponseToJSON,
  WorkbookSidebarConfigAllOfFromJSON: WorkbookSidebarConfigAllOfFromJSON,
  WorkbookSidebarConfigAllOfFromJSONTyped: WorkbookSidebarConfigAllOfFromJSONTyped,
  WorkbookSidebarConfigAllOfToJSON: WorkbookSidebarConfigAllOfToJSON,
  WorkbookSidebarConfigFromJSON: WorkbookSidebarConfigFromJSON,
  WorkbookSidebarConfigFromJSONTyped: WorkbookSidebarConfigFromJSONTyped,
  WorkbookSidebarConfigToJSON: WorkbookSidebarConfigToJSON,
  WorkbookSidebarConfigTypeEnum: WorkbookSidebarConfigTypeEnum,
  WorkbookToJSON: WorkbookToJSON,
  WorkbookTreatmentsEnum: WorkbookTreatmentsEnum,
  WorkbookTreatmentsEnumFromJSON: WorkbookTreatmentsEnumFromJSON,
  WorkbookTreatmentsEnumFromJSONTyped: WorkbookTreatmentsEnumFromJSONTyped,
  WorkbookTreatmentsEnumToJSON: WorkbookTreatmentsEnumToJSON,
  WorkbookUpdateFromJSON: WorkbookUpdateFromJSON,
  WorkbookUpdateFromJSONTyped: WorkbookUpdateFromJSONTyped,
  WorkbookUpdateToJSON: WorkbookUpdateToJSON,
  WorkbooksResponseFromJSON: WorkbooksResponseFromJSON,
  WorkbooksResponseFromJSONTyped: WorkbooksResponseFromJSONTyped,
  WorkbooksResponseToJSON: WorkbooksResponseToJSON,
  WriteSecretFromJSON: WriteSecretFromJSON,
  WriteSecretFromJSONTyped: WriteSecretFromJSONTyped,
  WriteSecretToJSON: WriteSecretToJSON,
  canConsumeForm: canConsumeForm,
  exists: exists,
  instanceOfAccessToken: instanceOfAccessToken,
  instanceOfAccessTokenResponse: instanceOfAccessTokenResponse,
  instanceOfAccount: instanceOfAccount,
  instanceOfAccountResponse: instanceOfAccountResponse,
  instanceOfAction: instanceOfAction,
  instanceOfActionInputForm: instanceOfActionInputForm,
  instanceOfActionMessage: instanceOfActionMessage,
  instanceOfActivitiesResponse: instanceOfActivitiesResponse,
  instanceOfActivity: instanceOfActivity,
  instanceOfActivityContext: instanceOfActivityContext,
  instanceOfActivityContextSlugs: instanceOfActivityContextSlugs,
  instanceOfActorId: instanceOfActorId,
  instanceOfActorResource: instanceOfActorResource,
  instanceOfActorRoleResponse: instanceOfActorRoleResponse,
  instanceOfAgent: instanceOfAgent,
  instanceOfAgentConfig: instanceOfAgentConfig,
  instanceOfAgentLog: instanceOfAgentLog,
  instanceOfAgentLogResponse: instanceOfAgentLogResponse,
  instanceOfAgentLogsResponse: instanceOfAgentLogsResponse,
  instanceOfAgentLogsResponse1: instanceOfAgentLogsResponse1,
  instanceOfAgentResponse: instanceOfAgentResponse,
  instanceOfAgentStats: instanceOfAgentStats,
  instanceOfAgentsResponse: instanceOfAgentsResponse,
  instanceOfApiCredentials: instanceOfApiCredentials,
  instanceOfApiKey: instanceOfApiKey,
  instanceOfApiKeyOperationsInner: instanceOfApiKeyOperationsInner,
  instanceOfApiKeysResponse: instanceOfApiKeysResponse,
  instanceOfApiToken: instanceOfApiToken,
  instanceOfApiTokenResponse: instanceOfApiTokenResponse,
  instanceOfApiTokensResponse: instanceOfApiTokensResponse,
  instanceOfAppVersionResponse: instanceOfAppVersionResponse,
  instanceOfArrayableProperty: instanceOfArrayableProperty,
  instanceOfAssignActorRoleRequest: instanceOfAssignActorRoleRequest,
  instanceOfAssignRoleResponse: instanceOfAssignRoleResponse,
  instanceOfBaseActionConstraint: instanceOfBaseActionConstraint,
  instanceOfBaseConstraint: instanceOfBaseConstraint,
  instanceOfBaseProperty: instanceOfBaseProperty,
  instanceOfBasePropertyAppearance: instanceOfBasePropertyAppearance,
  instanceOfBaseSideBarConfig: instanceOfBaseSideBarConfig,
  instanceOfBillingLimits: instanceOfBillingLimits,
  instanceOfBillingLimitsResponse: instanceOfBillingLimitsResponse,
  instanceOfBillingPlanWithUsage: instanceOfBillingPlanWithUsage,
  instanceOfBillingPlanWithUsageResponse: instanceOfBillingPlanWithUsageResponse,
  instanceOfBillingSubscription: instanceOfBillingSubscription,
  instanceOfBillingSubscriptionItem: instanceOfBillingSubscriptionItem,
  instanceOfBillingSubscriptionResponse: instanceOfBillingSubscriptionResponse,
  instanceOfBillingSubscriptionsResponse: instanceOfBillingSubscriptionsResponse,
  instanceOfBlueprint: instanceOfBlueprint,
  instanceOfBooleanProperty: instanceOfBooleanProperty,
  instanceOfBooleanPropertyAllOf: instanceOfBooleanPropertyAllOf,
  instanceOfBooleanPropertyAllOfConfig: instanceOfBooleanPropertyAllOfConfig,
  instanceOfCellValue: instanceOfCellValue,
  instanceOfCellValueWithCounts: instanceOfCellValueWithCounts,
  instanceOfCellValueWithCountsAllOf: instanceOfCellValueWithCountsAllOf,
  instanceOfCellValueWithLinks: instanceOfCellValueWithLinks,
  instanceOfCellsResponse: instanceOfCellsResponse,
  instanceOfCellsResponseData: instanceOfCellsResponseData,
  instanceOfCheckoutSession: instanceOfCheckoutSession,
  instanceOfCheckoutSessionBody: instanceOfCheckoutSessionBody,
  instanceOfCollectionJobSubject: instanceOfCollectionJobSubject,
  instanceOfCommit: instanceOfCommit,
  instanceOfCompositeUniqueConstraint: instanceOfCompositeUniqueConstraint,
  instanceOfCompositeUniqueConstraintAllOf: instanceOfCompositeUniqueConstraintAllOf,
  instanceOfComputedConstraint: instanceOfComputedConstraint,
  instanceOfComputedConstraintAllOf: instanceOfComputedConstraintAllOf,
  instanceOfConnectionLink: instanceOfConnectionLink,
  instanceOfConnectionLinkBody: instanceOfConnectionLinkBody,
  instanceOfCreateCheckoutSessionResponse: instanceOfCreateCheckoutSessionResponse,
  instanceOfCreateCommitIdRequest: instanceOfCreateCommitIdRequest,
  instanceOfCreateConnectionLinkResponse: instanceOfCreateConnectionLinkResponse,
  instanceOfCreateEnvironmentRequest: instanceOfCreateEnvironmentRequest,
  instanceOfCreateMappingRequest: instanceOfCreateMappingRequest,
  instanceOfCreateVersionIdRequest: instanceOfCreateVersionIdRequest,
  instanceOfCreateViewRequest: instanceOfCreateViewRequest,
  instanceOfDBUser: instanceOfDBUser,
  instanceOfDataRetentionPolicy: instanceOfDataRetentionPolicy,
  instanceOfDataRetentionPolicyConfig: instanceOfDataRetentionPolicyConfig,
  instanceOfDataRetentionPolicyConfigUpdate: instanceOfDataRetentionPolicyConfigUpdate,
  instanceOfDataRetentionPolicyResponse: instanceOfDataRetentionPolicyResponse,
  instanceOfDateProperty: instanceOfDateProperty,
  instanceOfDatePropertyAllOf: instanceOfDatePropertyAllOf,
  instanceOfDeleteRecordsJobConfig: instanceOfDeleteRecordsJobConfig,
  instanceOfDeleteRulesRequest: instanceOfDeleteRulesRequest,
  instanceOfDestinationField: instanceOfDestinationField,
  instanceOfDetailedAgentLog: instanceOfDetailedAgentLog,
  instanceOfDiffData: instanceOfDiffData,
  instanceOfDiffRecord: instanceOfDiffRecord,
  instanceOfDiffRecordsResponse: instanceOfDiffRecordsResponse,
  instanceOfDiffRecordsResponseData: instanceOfDiffRecordsResponseData,
  instanceOfDiffValue: instanceOfDiffValue,
  instanceOfDocument: instanceOfDocument,
  instanceOfDocumentConfig: instanceOfDocumentConfig,
  instanceOfDocumentResponse: instanceOfDocumentResponse,
  instanceOfDocumentSidebarConfig: instanceOfDocumentSidebarConfig,
  instanceOfDocumentSidebarConfigAllOf: instanceOfDocumentSidebarConfigAllOf,
  instanceOfDocumentsResponse: instanceOfDocumentsResponse,
  instanceOfEdge: instanceOfEdge,
  instanceOfEdgeMetadata: instanceOfEdgeMetadata,
  instanceOfEntitlement: instanceOfEntitlement,
  instanceOfEntitlementsResponse: instanceOfEntitlementsResponse,
  instanceOfEnumDetails: instanceOfEnumDetails,
  instanceOfEnumListProperty: instanceOfEnumListProperty,
  instanceOfEnumListPropertyAllOf: instanceOfEnumListPropertyAllOf,
  instanceOfEnumMappingField: instanceOfEnumMappingField,
  instanceOfEnumProperty: instanceOfEnumProperty,
  instanceOfEnumPropertyAllOf: instanceOfEnumPropertyAllOf,
  instanceOfEnumPropertyAllOfConfig: instanceOfEnumPropertyAllOfConfig,
  instanceOfEnumPropertyOption: instanceOfEnumPropertyOption,
  instanceOfEnumPropertyOptionValue: instanceOfEnumPropertyOptionValue,
  instanceOfEnvironment: instanceOfEnvironment,
  instanceOfEnvironmentConfig: instanceOfEnvironmentConfig,
  instanceOfEnvironmentResponse: instanceOfEnvironmentResponse,
  instanceOfEnvironmentStatsResponse: instanceOfEnvironmentStatsResponse,
  instanceOfEnvironmentStatsResponseData: instanceOfEnvironmentStatsResponseData,
  instanceOfEnvironmentsResponse: instanceOfEnvironmentsResponse,
  instanceOfErrorResponse: instanceOfErrorResponse,
  instanceOfErrorResponseErrorsInner: instanceOfErrorResponseErrorsInner,
  instanceOfEvent: instanceOfEvent,
  instanceOfEventConfig: instanceOfEventConfig,
  instanceOfEventConfigAttributes: instanceOfEventConfigAttributes,
  instanceOfEventConfigAttributesProgress: instanceOfEventConfigAttributesProgress,
  instanceOfEventConfigOrigin: instanceOfEventConfigOrigin,
  instanceOfEventResponse: instanceOfEventResponse,
  instanceOfEventToken: instanceOfEventToken,
  instanceOfEventTokenResponse: instanceOfEventTokenResponse,
  instanceOfEventsResponse: instanceOfEventsResponse,
  instanceOfExchangeInvitationRequest: instanceOfExchangeInvitationRequest,
  instanceOfExchangeTokenResponse: instanceOfExchangeTokenResponse,
  instanceOfExchangeTokenResponseData: instanceOfExchangeTokenResponseData,
  instanceOfExecution: instanceOfExecution,
  instanceOfExecutionsResponse: instanceOfExecutionsResponse,
  instanceOfExportJobConfig: instanceOfExportJobConfig,
  instanceOfExportOptions: instanceOfExportOptions,
  instanceOfExternalConstraint: instanceOfExternalConstraint,
  instanceOfExternalConstraintAllOf: instanceOfExternalConstraintAllOf,
  instanceOfExternalSheetConstraint: instanceOfExternalSheetConstraint,
  instanceOfExternalSheetConstraintAllOf: instanceOfExternalSheetConstraintAllOf,
  instanceOfFieldConfigResponse: instanceOfFieldConfigResponse,
  instanceOfFieldRecordCounts: instanceOfFieldRecordCounts,
  instanceOfFileConfig: instanceOfFileConfig,
  instanceOfFileJobConfig: instanceOfFileJobConfig,
  instanceOfFileResponse: instanceOfFileResponse,
  instanceOfFilesResponse: instanceOfFilesResponse,
  instanceOfFindAndReplaceJobConfig: instanceOfFindAndReplaceJobConfig,
  instanceOfFindAndReplaceRequest: instanceOfFindAndReplaceRequest,
  instanceOfFronteggSignup: instanceOfFronteggSignup,
  instanceOfFronteggUser: instanceOfFronteggUser,
  instanceOfGenerateMutationConfig: instanceOfGenerateMutationConfig,
  instanceOfGenerateQueryConfig: instanceOfGenerateQueryConfig,
  instanceOfGeneratedMutation: instanceOfGeneratedMutation,
  instanceOfGeneratedMutationMetadata: instanceOfGeneratedMutationMetadata,
  instanceOfGeneratedMutationResponse: instanceOfGeneratedMutationResponse,
  instanceOfGeneratedQuery: instanceOfGeneratedQuery,
  instanceOfGeneratedQueryMetadata: instanceOfGeneratedQueryMetadata,
  instanceOfGeneratedQueryResponse: instanceOfGeneratedQueryResponse,
  instanceOfGetCommitResponse: instanceOfGetCommitResponse,
  instanceOfGetDatabaseData: instanceOfGetDatabaseData,
  instanceOfGetDatabaseDataTask: instanceOfGetDatabaseDataTask,
  instanceOfGetDatabaseResponseResponse: instanceOfGetDatabaseResponseResponse,
  instanceOfGetEnumWeightsRequest: instanceOfGetEnumWeightsRequest,
  instanceOfGetFieldWeightsRequest: instanceOfGetFieldWeightsRequest,
  instanceOfGetRecordsResponse: instanceOfGetRecordsResponse,
  instanceOfGetRecordsResponseData: instanceOfGetRecordsResponseData,
  instanceOfGetRecordsResponseDataAllOf: instanceOfGetRecordsResponseDataAllOf,
  instanceOfGetSheetCommitsResponse: instanceOfGetSheetCommitsResponse,
  instanceOfGetUserResponse: instanceOfGetUserResponse,
  instanceOfGetWorkbookCommitsResponse: instanceOfGetWorkbookCommitsResponse,
  instanceOfGuest: instanceOfGuest,
  instanceOfGuestConfig: instanceOfGuestConfig,
  instanceOfGuestConfigSpacesInner: instanceOfGuestConfigSpacesInner,
  instanceOfGuestConfigSpacesInnerWorkbooksInner: instanceOfGuestConfigSpacesInnerWorkbooksInner,
  instanceOfGuestConfigUpdate: instanceOfGuestConfigUpdate,
  instanceOfGuestResponse: instanceOfGuestResponse,
  instanceOfGuestsResponse: instanceOfGuestsResponse,
  instanceOfHasAllValidConstraint: instanceOfHasAllValidConstraint,
  instanceOfHasAllValidConstraintAllOf: instanceOfHasAllValidConstraintAllOf,
  instanceOfHasDataConstraint: instanceOfHasDataConstraint,
  instanceOfHasDataConstraintAllOf: instanceOfHasDataConstraintAllOf,
  instanceOfHasSelectionConstraint: instanceOfHasSelectionConstraint,
  instanceOfHasSelectionConstraintAllOf: instanceOfHasSelectionConstraintAllOf,
  instanceOfHealthResponse: instanceOfHealthResponse,
  instanceOfInputField: instanceOfInputField,
  instanceOfInputFieldConfig: instanceOfInputFieldConfig,
  instanceOfInputFieldDefaultValue: instanceOfInputFieldDefaultValue,
  instanceOfInviteGuestsRequestInner: instanceOfInviteGuestsRequestInner,
  instanceOfJob: instanceOfJob,
  instanceOfJobAckDetails: instanceOfJobAckDetails,
  instanceOfJobCancelDetails: instanceOfJobCancelDetails,
  instanceOfJobCompleteDetails: instanceOfJobCompleteDetails,
  instanceOfJobConfig: instanceOfJobConfig,
  instanceOfJobOutcome: instanceOfJobOutcome,
  instanceOfJobOutcomeNextDownload: instanceOfJobOutcomeNextDownload,
  instanceOfJobOutcomeNextFiles: instanceOfJobOutcomeNextFiles,
  instanceOfJobOutcomeNextFilesFilesInner: instanceOfJobOutcomeNextFilesFilesInner,
  instanceOfJobOutcomeNextId: instanceOfJobOutcomeNextId,
  instanceOfJobOutcomeNextRetry: instanceOfJobOutcomeNextRetry,
  instanceOfJobOutcomeNextSnapshot: instanceOfJobOutcomeNextSnapshot,
  instanceOfJobOutcomeNextUrl: instanceOfJobOutcomeNextUrl,
  instanceOfJobOutcomeNextView: instanceOfJobOutcomeNextView,
  instanceOfJobOutcomeNextWait: instanceOfJobOutcomeNextWait,
  instanceOfJobPlan: instanceOfJobPlan,
  instanceOfJobPlanResponse: instanceOfJobPlanResponse,
  instanceOfJobResponse: instanceOfJobResponse,
  instanceOfJobSplitDetails: instanceOfJobSplitDetails,
  instanceOfJobSplitDetailsParts: instanceOfJobSplitDetailsParts,
  instanceOfJobStats: instanceOfJobStats,
  instanceOfJobStatsAccounts: instanceOfJobStatsAccounts,
  instanceOfJobStatsJobs: instanceOfJobStatsJobs,
  instanceOfJobStatsJobsMap: instanceOfJobStatsJobsMap,
  instanceOfJobStatsResponse: instanceOfJobStatsResponse,
  instanceOfJobUpdate: instanceOfJobUpdate,
  instanceOfJobsResponse: instanceOfJobsResponse,
  instanceOfLineItem: instanceOfLineItem,
  instanceOfLinkSidebarConfig: instanceOfLinkSidebarConfig,
  instanceOfLinkSidebarConfigAllOf: instanceOfLinkSidebarConfigAllOf,
  instanceOfListActorRolesResponse: instanceOfListActorRolesResponse,
  instanceOfListRolesResponse: instanceOfListRolesResponse,
  instanceOfManifestResponse: instanceOfManifestResponse,
  instanceOfMappingProgram: instanceOfMappingProgram,
  instanceOfMappingProgramJobConfig: instanceOfMappingProgramJobConfig,
  instanceOfMappingProgramSummary: instanceOfMappingProgramSummary,
  instanceOfMappingRule: instanceOfMappingRule,
  instanceOfMappingRuleBase: instanceOfMappingRuleBase,
  instanceOfMappingRuleConfig: instanceOfMappingRuleConfig,
  instanceOfModelFile: instanceOfModelFile,
  instanceOfMutateJobConfig: instanceOfMutateJobConfig,
  instanceOfNumberProperty: instanceOfNumberProperty,
  instanceOfNumberPropertyAllOf: instanceOfNumberPropertyAllOf,
  instanceOfNumberPropertyAllOfConfig: instanceOfNumberPropertyAllOfConfig,
  instanceOfPagination: instanceOfPagination,
  instanceOfPipelineJobConfig: instanceOfPipelineJobConfig,
  instanceOfPlan: instanceOfPlan,
  instanceOfPlanConfig: instanceOfPlanConfig,
  instanceOfProduct: instanceOfProduct,
  instanceOfProductsResponse: instanceOfProductsResponse,
  instanceOfProgramResponse: instanceOfProgramResponse,
  instanceOfProgramsResponse: instanceOfProgramsResponse,
  instanceOfPrompt: instanceOfPrompt,
  instanceOfPromptConfig: instanceOfPromptConfig,
  instanceOfPromptResponse: instanceOfPromptResponse,
  instanceOfPromptsResponse: instanceOfPromptsResponse,
  instanceOfRecord: instanceOfRecord,
  instanceOfRecordCounts: instanceOfRecordCounts,
  instanceOfRecordCountsResponse: instanceOfRecordCountsResponse,
  instanceOfRecordCountsResponseData: instanceOfRecordCountsResponseData,
  instanceOfRecordCountsResponseDataAllOf: instanceOfRecordCountsResponseDataAllOf,
  instanceOfRecordData: instanceOfRecordData,
  instanceOfRecordDataWithLinks: instanceOfRecordDataWithLinks,
  instanceOfRecordUpdates: instanceOfRecordUpdates,
  instanceOfRecordUpdatesAllOf: instanceOfRecordUpdatesAllOf,
  instanceOfRecordWithLinks: instanceOfRecordWithLinks,
  instanceOfRecords: instanceOfRecords,
  instanceOfRecordsData: instanceOfRecordsData,
  instanceOfRecordsResponse: instanceOfRecordsResponse,
  instanceOfRecordsResponseData: instanceOfRecordsResponseData,
  instanceOfRecordsResponseDataAllOf: instanceOfRecordsResponseDataAllOf,
  instanceOfRecordsUpdates: instanceOfRecordsUpdates,
  instanceOfRecordsWithLinks: instanceOfRecordsWithLinks,
  instanceOfReferenceListProperty: instanceOfReferenceListProperty,
  instanceOfReferenceListPropertyAllOf: instanceOfReferenceListPropertyAllOf,
  instanceOfReferenceListPropertyAllOfConfig: instanceOfReferenceListPropertyAllOfConfig,
  instanceOfReferenceProperty: instanceOfReferenceProperty,
  instanceOfReferencePropertyAllOf: instanceOfReferencePropertyAllOf,
  instanceOfReferencePropertyAllOfConfig: instanceOfReferencePropertyAllOfConfig,
  instanceOfReplaceRequest: instanceOfReplaceRequest,
  instanceOfRequiredConstraint: instanceOfRequiredConstraint,
  instanceOfRequiredConstraintAllOf: instanceOfRequiredConstraintAllOf,
  instanceOfResourceId: instanceOfResourceId,
  instanceOfResourceJobSubject: instanceOfResourceJobSubject,
  instanceOfRestore: instanceOfRestore,
  instanceOfRestoreConfig: instanceOfRestoreConfig,
  instanceOfRestoreResponse: instanceOfRestoreResponse,
  instanceOfRestoreSnapshotRequest: instanceOfRestoreSnapshotRequest,
  instanceOfRoleActorResource: instanceOfRoleActorResource,
  instanceOfRoleActorResourceAllOf: instanceOfRoleActorResourceAllOf,
  instanceOfRoleResponse: instanceOfRoleResponse,
  instanceOfRuleResponse: instanceOfRuleResponse,
  instanceOfRulesResponse: instanceOfRulesResponse,
  instanceOfSecret: instanceOfSecret,
  instanceOfSecrets: instanceOfSecrets,
  instanceOfSecretsResponse: instanceOfSecretsResponse,
  instanceOfSheet: instanceOfSheet,
  instanceOfSheetConfig: instanceOfSheetConfig,
  instanceOfSheetConfigOptions: instanceOfSheetConfigOptions,
  instanceOfSheetConfigOrUpdate: instanceOfSheetConfigOrUpdate,
  instanceOfSheetConfigUpdate: instanceOfSheetConfigUpdate,
  instanceOfSheetResponse: instanceOfSheetResponse,
  instanceOfSheetUpdate: instanceOfSheetUpdate,
  instanceOfSheetUpdateRequest: instanceOfSheetUpdateRequest,
  instanceOfSheetsResponse: instanceOfSheetsResponse,
  instanceOfSnapshot: instanceOfSnapshot,
  instanceOfSnapshotResponse: instanceOfSnapshotResponse,
  instanceOfSnapshotSheetRequest: instanceOfSnapshotSheetRequest,
  instanceOfSnapshotSummary: instanceOfSnapshotSummary,
  instanceOfSnapshotSummaryCreatedSince: instanceOfSnapshotSummaryCreatedSince,
  instanceOfSnapshotSummaryUpdatedSince: instanceOfSnapshotSummaryUpdatedSince,
  instanceOfSnapshotsResponse: instanceOfSnapshotsResponse,
  instanceOfSourceDestinationWeight: instanceOfSourceDestinationWeight,
  instanceOfSourceDestinationWeightsResponse: instanceOfSourceDestinationWeightsResponse,
  instanceOfSourceDestinationWeightsResponseData: instanceOfSourceDestinationWeightsResponseData,
  instanceOfSourceField: instanceOfSourceField,
  instanceOfSpace: instanceOfSpace,
  instanceOfSpaceConfig: instanceOfSpaceConfig,
  instanceOfSpaceConfigResponse: instanceOfSpaceConfigResponse,
  instanceOfSpaceConfigsResponse: instanceOfSpaceConfigsResponse,
  instanceOfSpacePattern: instanceOfSpacePattern,
  instanceOfSpacePatternConfig: instanceOfSpacePatternConfig,
  instanceOfSpaceResponse: instanceOfSpaceResponse,
  instanceOfSpaceSettings: instanceOfSpaceSettings,
  instanceOfSpaceSidebarConfig: instanceOfSpaceSidebarConfig,
  instanceOfSpaceSize: instanceOfSpaceSize,
  instanceOfSpacesResponse: instanceOfSpacesResponse,
  instanceOfStringListProperty: instanceOfStringListProperty,
  instanceOfStringListPropertyAllOf: instanceOfStringListPropertyAllOf,
  instanceOfStringProperty: instanceOfStringProperty,
  instanceOfStringPropertyAllOf: instanceOfStringPropertyAllOf,
  instanceOfStripeMetadata: instanceOfStripeMetadata,
  instanceOfStripePrice: instanceOfStripePrice,
  instanceOfStripePriceTier: instanceOfStripePriceTier,
  instanceOfStripeWebhookRequestBody: instanceOfStripeWebhookRequestBody,
  instanceOfStripeWebhookRequestBodyRequest: instanceOfStripeWebhookRequestBodyRequest,
  instanceOfSubscriptionUpdatesBody: instanceOfSubscriptionUpdatesBody,
  instanceOfSuccess: instanceOfSuccess,
  instanceOfSuccessResponse: instanceOfSuccessResponse,
  instanceOfUniqueConstraint: instanceOfUniqueConstraint,
  instanceOfUniqueConstraintAllOf: instanceOfUniqueConstraintAllOf,
  instanceOfUniqueConstraintAllOfConfig: instanceOfUniqueConstraintAllOfConfig,
  instanceOfUpdateAccount: instanceOfUpdateAccount,
  instanceOfUpdateEnvironmentByIdRequest: instanceOfUpdateEnvironmentByIdRequest,
  instanceOfUpdateJobExecutionPlanByIdRequest: instanceOfUpdateJobExecutionPlanByIdRequest,
  instanceOfUpdateJobExecutionPlanFieldsRequest: instanceOfUpdateJobExecutionPlanFieldsRequest,
  instanceOfUpdateUserRequest: instanceOfUpdateUserRequest,
  instanceOfUpdateViewRequest: instanceOfUpdateViewRequest,
  instanceOfUpgradeSpaceConfig: instanceOfUpgradeSpaceConfig,
  instanceOfUploadConfig: instanceOfUploadConfig,
  instanceOfUser: instanceOfUser,
  instanceOfUserConfig: instanceOfUserConfig,
  instanceOfUserCreateAndInviteBody: instanceOfUserCreateAndInviteBody,
  instanceOfUserCredentials: instanceOfUserCredentials,
  instanceOfUserResponse: instanceOfUserResponse,
  instanceOfUserWithRoles: instanceOfUserWithRoles,
  instanceOfUsersResponse: instanceOfUsersResponse,
  instanceOfValidation: instanceOfValidation,
  instanceOfValidationMessage: instanceOfValidationMessage,
  instanceOfValue: instanceOfValue,
  instanceOfVersionResponse: instanceOfVersionResponse,
  instanceOfVersionResponseData: instanceOfVersionResponseData,
  instanceOfView: instanceOfView,
  instanceOfViewConfig: instanceOfViewConfig,
  instanceOfViewResponse: instanceOfViewResponse,
  instanceOfViewsResponse: instanceOfViewsResponse,
  instanceOfWorkbook: instanceOfWorkbook,
  instanceOfWorkbookConfig: instanceOfWorkbookConfig,
  instanceOfWorkbookConfigSettings: instanceOfWorkbookConfigSettings,
  instanceOfWorkbookResponse: instanceOfWorkbookResponse,
  instanceOfWorkbookSidebarConfig: instanceOfWorkbookSidebarConfig,
  instanceOfWorkbookSidebarConfigAllOf: instanceOfWorkbookSidebarConfigAllOf,
  instanceOfWorkbookUpdate: instanceOfWorkbookUpdate,
  instanceOfWorkbooksResponse: instanceOfWorkbooksResponse,
  instanceOfWriteSecret: instanceOfWriteSecret,
  mapValues: mapValues,
  querystring: querystring
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(src);

let urlAlphabet$1 =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
var urlAlphabet_1 = { urlAlphabet: urlAlphabet$1 };

let crypto$1 = require$$0;
let { urlAlphabet } = urlAlphabet_1;
const POOL_SIZE_MULTIPLIER = 128;
let pool, poolOffset;
let fillPool = bytes => {
  if (!pool || pool.length < bytes) {
    pool = Buffer.allocUnsafe(bytes * POOL_SIZE_MULTIPLIER);
    crypto$1.randomFillSync(pool);
    poolOffset = 0;
  } else if (poolOffset + bytes > pool.length) {
    crypto$1.randomFillSync(pool);
    poolOffset = 0;
  }
  poolOffset += bytes;
};
let random = bytes => {
  fillPool((bytes -= 0));
  return pool.subarray(poolOffset - bytes, poolOffset)
};
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << (31 - Math.clz32((alphabet.length - 1) | 1))) - 1;
  let step = Math.ceil((1.6 * mask * defaultSize) / alphabet.length);
  return (size = defaultSize) => {
    let id = '';
    while (true) {
      let bytes = getRandom(step);
      let i = step;
      while (i--) {
        id += alphabet[bytes[i] & mask] || '';
        if (id.length === size) return id
      }
    }
  }
};
let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random);
let nanoid = (size = 21) => {
  fillPool((size -= 0));
  let id = '';
  for (let i = poolOffset - size; i < poolOffset; i++) {
    id += urlAlphabet[pool[i] & 63];
  }
  return id
};
var nanoid_1 = { nanoid, customAlphabet, customRandom, urlAlphabet, random };

var lowercase$1 = 'abcdefghijklmnopqrstuvwxyz';

var uppercase$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

var numbers$1 = '0123456789';

var nolookalikes = '346789ABCDEFGHJKLMNPQRTUVWXYabcdefghijkmnpqrtwxyz';

var nolookalikesSafe = '6789BCDFGHJKLMNPQRTWbcdfghjkmnpqrtwz';

const numbers = numbers$1;
const lowercase = lowercase$1;
const uppercase = uppercase$1;

var alphanumeric = numbers + lowercase + uppercase;

var nanoidDictionary = {
  lowercase: lowercase$1,
  uppercase: uppercase$1,
  numbers: numbers$1,
  nolookalikes: nolookalikes,
  nolookalikesSafe: nolookalikesSafe,
  alphanumeric: alphanumeric,
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || rng)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || unsafeStringify(b);
}

function parse(uuid) {
  if (!validate(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;

    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = parse(namespace);
    }

    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return unsafeStringify(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5$1(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

const v3 = v35('v3', 0x30, md5$1);
var v3$1 = v3;

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

const v5 = v35('v5', 0x50, sha1);
var v5$1 = v5;

var nil = '00000000-0000-0000-0000-000000000000';

function version(uuid) {
  if (!validate(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.slice(14, 15), 16);
}

var esmBrowser = /*#__PURE__*/Object.freeze({
  __proto__: null,
  v1: v1,
  v3: v3$1,
  v4: v4,
  v5: v5$1,
  NIL: nil,
  version: version,
  validate: validate,
  stringify: stringify,
  parse: parse
});

var require$$2 = /*@__PURE__*/getAugmentedNamespace(esmBrowser);

var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __getOwnPropNames$1 = Object.getOwnPropertyNames;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __export$1 = (target, all) => {
  for (var name in all)
    __defProp$1(target, name, { get: all[name], enumerable: true });
};
var __copyProps$1 = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames$1(from))
      if (!__hasOwnProp$1.call(to, key) && key !== except)
        __defProp$1(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc$1(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS$1 = (mod) => __copyProps$1(__defProp$1({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports$1 = {};
__export$1(src_exports$1, {
  AccountId: () => AccountId,
  ActorRoleId: () => ActorRoleId,
  AgentId: () => AgentId,
  AgentLogId: () => AgentLogId,
  ApiKeyId: () => ApiKeyId,
  AppId: () => AppId,
  BillingSubscriptionId: () => BillingSubscriptionId,
  CellId: () => CellId,
  DEFAULT_LENGTH: () => DEFAULT_LENGTH,
  DataRetentionPolicyId: () => DataRetentionPolicyId,
  DocumentId: () => DocumentId,
  EmailId: () => EmailId,
  EnvironmentId: () => EnvironmentId,
  EphemeralDatabaseId: () => EphemeralDatabaseId,
  EventId: () => EventId,
  FieldId: () => FieldId,
  FileId: () => FileId,
  GenericId: () => GenericId,
  GuestId: () => GuestId,
  JobId: () => JobId,
  MAXIMUM_LENGTH: () => MAXIMUM_LENGTH,
  MINIMUM_LENGTH: () => MINIMUM_LENGTH,
  MappingFamilyId: () => MappingFamilyId,
  MappingProgramId: () => MappingProgramId,
  MappingRuleId: () => MappingRuleId,
  OAuthClientId: () => OAuthClientId,
  OAuthCodeId: () => OAuthCodeId,
  OAuthGrantId: () => OAuthGrantId,
  PermissionId: () => PermissionId,
  PlanId: () => PlanId,
  PromptId: () => PromptId,
  RecordId: () => RecordId,
  RoleId: () => RoleId,
  SecretId: () => SecretId,
  SheetId: () => SheetId,
  SnapshotId: () => SnapshotId,
  SpaceConfigId: () => SpaceConfigId,
  SpaceId: () => SpaceId,
  SubscriptionId: () => SubscriptionId,
  UserId: () => UserId,
  UserInviteId: () => UserInviteId,
  VersionId: () => VersionId,
  ViewId: () => ViewId,
  WorkbookConfigId: () => WorkbookConfigId,
  WorkbookId: () => WorkbookId,
  castIds: () => castIds,
  extractIdParts: () => extractIdParts,
  getId: () => getId,
  getValidLength: () => getValidLength,
  isActorId: () => isActorId,
  isId: () => isId,
  isResourceId: () => isResourceId,
  makeCompositeId: () => makeCompositeId,
  makeId: () => makeId
});
var dist$1 = __toCommonJS$1(src_exports$1);

// src/make.id.ts
var import_nanoid = nanoid_1;
var import_nanoid_dictionary = nanoidDictionary;
var import_uuid = require$$2;

// src/config.ts
var parseLength = (length) => {
  if (!length) {
    return void 0;
  }
  const parsed = parseInt(length, 10);
  if (isNaN(parsed)) {
    return void 0;
  }
  return parsed;
};
var safeGet$1 = (key) => {
  if (typeof process !== "undefined" && process.env) {
    return process.env[key];
  }
};
var config = {
  region: safeGet$1("REGION") || "dev",
  defaultLength: parseLength(safeGet$1("DEFAULT_ID_LENGTH"))
};

// src/make.id.ts
var MINIMUM_LENGTH = 8;
var DEFAULT_LENGTH = 8;
var MAXIMUM_LENGTH = 64;
var nanoidCache = /* @__PURE__ */ new Map();
function makeId(length) {
  const idLength = getValidLength(length);
  if (idLength === 32) {
    return (0, import_uuid.v4)().replace(/-/g, "");
  }
  if (!nanoidCache.has(idLength)) {
    nanoidCache.set(idLength, (0, import_nanoid.customAlphabet)(import_nanoid_dictionary.alphanumeric, idLength));
  }
  const nanoid = nanoidCache.get(idLength);
  return nanoid(idLength);
}
function extractIdParts(id) {
  if (!id) {
    throw new Error("You must provide a string");
  }
  if (!id.match(/^\w+$/)) {
    throw new Error(
      `You must provide an alphanumeric + underscore string. Provided ID: ${id}`
    );
  }
  const [key, resource, region] = id.split("_").reverse();
  return { key, resource, region };
}
function getValidLength(providedLength) {
  const length = providedLength ?? config.defaultLength ?? DEFAULT_LENGTH;
  if (length < MINIMUM_LENGTH) {
    throw new Error(`The id length must be >= ${MINIMUM_LENGTH}`);
  }
  if (length > MAXIMUM_LENGTH) {
    throw new Error(`The id length must be <= ${MAXIMUM_LENGTH}`);
  }
  return length;
}
function makeCompositeId(key, region, resource) {
  return `${region}_${resource}_${key}`;
}

// src/generic.id.ts
var GenericId = class {
  constructor() {
    this._region = config.region;
    /**
     * Internal reference to the current resource
     * @protected
     */
    this._resource = "unknown";
    /**
     * Internal reference to the current resource type
     * @protected
     */
    this._resourceType = "unknown";
    /**
     * Size of the generated ID
     */
    this.size = getValidLength();
  }
  get region() {
    return this._region;
  }
  /**
   * Return the configured resource.
   */
  get resource() {
    return this._resource;
  }
  /**
   * Return the configured resource type.
   */
  get resourceType() {
    return this._resourceType;
  }
  /**
   * Return the ref
   */
  get ref() {
    return this.constructor.name.replace(/^[A-Z]/, (a) => a.toLowerCase());
  }
  /**
   * Return or generate the key component of the ID
   * use this internally when storing/referring in the DB
   * we use this because it ought to be unique and we do not want the auto-incrementing integer
   * primary key to ever be exposed to the customer.
   * (exposing the next incrementing number leaks information to competitors and attackers)
   * additionally there is an optimization benefit to using a shorter indexed value when the first
   * several chars of .full are identical. (eg: "us_spa_" is identical for all space IDs in the US region)
   *
   */
  get key() {
    if (this._key)
      return this._key;
    else
      return this._key = makeId(this.size);
  }
  /**
   * Return or generate the full ID
   * use the full ID for anything a customer would ever see (via events or api)
   * same thing as `this.toString()`
   *
   * @example return "us_spa_tY8I9hjl"
   */
  get full() {
    return this.region + "_" + this.resource + "_" + this.key;
  }
  /**
   * Convert this ID to a string. Same thing as `this.full`
   */
  toString() {
    return this.full;
  }
  static from(id, fail = false) {
    if (!id) {
      if (fail) {
        throw new Error(`You must provide an ID to ${this.name}.from()`);
      } else {
        return void 0;
      }
    }
    const newId = new this();
    newId.setValuesFromIdString(id.toString());
    return newId;
  }
  static Key(input) {
    return this.from(input)?.key;
  }
  static Str(input) {
    return this.from(input)?.full;
  }
  static areEqual(a, b) {
    const forceId = (maybeId) => {
      if (typeof maybeId === "string") {
        const id = new this();
        try {
          id.setValuesFromIdString(maybeId);
        } catch (e) {
          return void 0;
        }
        return id;
      } else {
        return maybeId;
      }
    };
    const ida = forceId(a);
    const idb = forceId(b);
    if (!ida || !idb) {
      return false;
    } else {
      return ida.toString() === idb.toString();
    }
  }
  /**
   * This is used by the NestJS validation pipe to transform a string into an ID.
   * Not very useful for direct usage, but very useful for things like:
   *
   * @example
   * ```js
   *   @Param('fileId', FileId) id: FileId
   * ```
   *
   * @param value
   * @param metadata
   */
  transform(value, metadata) {
    if (!value) {
      throw new Error(`${metadata.data || this.constructor.name} is required.`);
    }
    return this.constructor.from(value, true);
  }
  /**
   * This is used by the NestJS validation pipe to transform a string into an ID.
   * Not very useful for direct usage, but very useful for things like:
   *
   * @example
   * ```js
   *   @Param('fileId', FileId.Optional) id?: FileId
   * ```
   */
  static get Optional() {
    const self = this;
    return class OptionalIdTransformer {
      transform(value, metadata) {
        return self.from(value);
      }
    };
  }
  static check(id) {
    if (!id) {
      return false;
    }
    if (id instanceof this) {
      return true;
    }
    if (typeof id !== "string") {
      return false;
    }
    const newId = new this();
    const { region, resource, key } = extractIdParts(id);
    if (newId.resource === "unknown") {
      return region === newId.region && !!resource && !!key;
    }
    if (!resource || !key || !region) {
      return false;
    }
    return resource === newId.resource && region === newId.region;
  }
  static make() {
    return new this().toString();
  }
  setValuesFromIdString(id) {
    const { key, resource, region } = extractIdParts(id);
    if (this.resource === "unknown") {
      if (resource) {
        this._resource = resource;
      }
      if (region) {
        this._region = region;
      }
    }
    if (resource && this.resource != resource || region && this.region != region) {
      throw new Error(
        `You are trying to initialize a ${this.constructor.name} but the ID ${id} is incompatible. Expecting a format like ${this.region}_${this.resource}_*`
      );
    }
    this._key = key;
  }
};

// src/ids.ts
var ids_exports = {};
__export$1(ids_exports, {
  AccountId: () => AccountId,
  ActorRoleId: () => ActorRoleId,
  AgentId: () => AgentId,
  AgentLogId: () => AgentLogId,
  ApiKeyId: () => ApiKeyId,
  AppId: () => AppId,
  BillingSubscriptionId: () => BillingSubscriptionId,
  CellId: () => CellId,
  DataRetentionPolicyId: () => DataRetentionPolicyId,
  DocumentId: () => DocumentId,
  EmailId: () => EmailId,
  EnvironmentId: () => EnvironmentId,
  EphemeralDatabaseId: () => EphemeralDatabaseId,
  EventId: () => EventId,
  FieldId: () => FieldId,
  FileId: () => FileId,
  GuestId: () => GuestId,
  JobId: () => JobId,
  MappingFamilyId: () => MappingFamilyId,
  MappingProgramId: () => MappingProgramId,
  MappingRuleId: () => MappingRuleId,
  OAuthClientId: () => OAuthClientId,
  OAuthCodeId: () => OAuthCodeId,
  OAuthGrantId: () => OAuthGrantId,
  PermissionId: () => PermissionId,
  PlanId: () => PlanId,
  PromptId: () => PromptId,
  RecordId: () => RecordId,
  RoleId: () => RoleId,
  SecretId: () => SecretId,
  SheetId: () => SheetId,
  SnapshotId: () => SnapshotId,
  SpaceConfigId: () => SpaceConfigId,
  SpaceId: () => SpaceId,
  SubscriptionId: () => SubscriptionId,
  UserId: () => UserId,
  UserInviteId: () => UserInviteId,
  VersionId: () => VersionId,
  ViewId: () => ViewId,
  WorkbookConfigId: () => WorkbookConfigId,
  WorkbookId: () => WorkbookId
});
var AccountId = class extends GenericId {
  get resource() {
    return "acc";
  }
  get resourceType() {
    return "account";
  }
};
var AppId = class extends GenericId {
  get resource() {
    return "app";
  }
  get resourceType() {
    return "application";
  }
};
var DocumentId = class extends GenericId {
  get resource() {
    return "dc";
  }
  get resourceType() {
    return "document";
  }
};
var EmailId = class extends GenericId {
  get resource() {
    return "em";
  }
  get resourceType() {
    return "email";
  }
};
var EnvironmentId = class extends GenericId {
  get resource() {
    return "env";
  }
  get resourceType() {
    return "environment";
  }
};
var EventId = class extends GenericId {
  constructor() {
    super(...arguments);
    this.size = 16;
  }
  get resource() {
    return "evt";
  }
  get resourceType() {
    return "event";
  }
};
var FileId = class extends GenericId {
  get resource() {
    return "fl";
  }
  get resourceType() {
    return "file";
  }
};
var GuestId = class extends GenericId {
  get resource() {
    return "g";
  }
  get resourceType() {
    return "guest";
  }
};
var JobId = class extends GenericId {
  get resource() {
    return "jb";
  }
  get resourceType() {
    return "job";
  }
};
var MappingFamilyId = class extends GenericId {
  get resource() {
    return "mf";
  }
  get resourceType() {
    return "mapping_family";
  }
};
var MappingProgramId = class extends GenericId {
  get resource() {
    return "mp";
  }
  get resourceType() {
    return "mapping_program";
  }
};
var MappingRuleId = class extends GenericId {
  get resource() {
    return "mr";
  }
  get resourceType() {
    return "mapping_rule";
  }
};
var PlanId = class extends GenericId {
  get resource() {
    return "pn";
  }
  get resourceType() {
    return "plan";
  }
};
var RecordId = class extends GenericId {
  constructor() {
    super(...arguments);
    this.size = 32;
  }
  get resource() {
    return "rc";
  }
  get resourceType() {
    return "record";
  }
};
var VersionId = class extends GenericId {
  get resource() {
    return "vr";
  }
  get resourceType() {
    return "commit";
  }
};
var SheetId = class extends GenericId {
  get resource() {
    return "sh";
  }
  get resourceType() {
    return "sheet";
  }
};
var SnapshotId = class extends GenericId {
  get resource() {
    return "ss";
  }
  get resourceType() {
    return "snapshot";
  }
};
var SpaceConfigId = class extends GenericId {
  get resource() {
    return "sc";
  }
  get resourceType() {
    return "space_config";
  }
};
var SpaceId = class extends GenericId {
  get resource() {
    return "sp";
  }
  get resourceType() {
    return "space";
  }
};
var SubscriptionId = class extends GenericId {
  get resource() {
    return "sb";
  }
  get resourceType() {
    return "subscription";
  }
};
var UserId = class extends GenericId {
  get resource() {
    return "usr";
  }
  get resourceType() {
    return "user";
  }
};
var WorkbookId = class extends GenericId {
  get resource() {
    return "wb";
  }
  get resourceType() {
    return "workbook";
  }
};
var AgentId = class extends GenericId {
  get resource() {
    return "ag";
  }
  get resourceType() {
    return "agent";
  }
};
var AgentLogId = class extends GenericId {
  constructor() {
    super(...arguments);
    this.size = 16;
  }
  get resource() {
    return "lg";
  }
  get resourceType() {
    return "agent_log";
  }
};
var FieldId = class extends GenericId {
  get resource() {
    return "fd";
  }
  get resourceType() {
    return "field";
  }
};
var CellId = class extends GenericId {
  constructor() {
    super(...arguments);
    this.size = 24;
  }
  get resource() {
    return "cl";
  }
  get resourceType() {
    return "cell";
  }
};
var WorkbookConfigId = class extends GenericId {
  get resource() {
    return "wc";
  }
  get resourceType() {
    return "workbook_config";
  }
};
var ApiKeyId = class extends GenericId {
  get resource() {
    return "key";
  }
  get resourceType() {
    return "api_key";
  }
};
var SecretId = class extends GenericId {
  get resource() {
    return "sec";
  }
  get resourceType() {
    return "secret";
  }
};
var BillingSubscriptionId = class extends GenericId {
  get resource() {
    return "bsb";
  }
  get resourceType() {
    return "billing_subscription";
  }
};
var RoleId = class extends GenericId {
  get resource() {
    return "rol";
  }
  get resourceType() {
    return "role";
  }
};
var ActorRoleId = class extends GenericId {
  get resource() {
    return "acr";
  }
  get resourceType() {
    return "actor_role";
  }
};
var PermissionId = class extends GenericId {
  get resource() {
    return "per";
  }
  get resourceType() {
    return "permission";
  }
};
var DataRetentionPolicyId = class extends GenericId {
  get resource() {
    return "drp";
  }
  get resourceType() {
    return "data_retention_policy";
  }
};
var OAuthClientId = class extends GenericId {
  get resource() {
    return "oac";
  }
  get resourceType() {
    return "oauth_client";
  }
};
var OAuthGrantId = class extends GenericId {
  get resource() {
    return "oag";
  }
  get resourceType() {
    return "oauth_grant";
  }
};
var OAuthCodeId = class extends GenericId {
  get resource() {
    return "oaa";
  }
  get resourceType() {
    return "oauth_code";
  }
};
var EphemeralDatabaseId = class extends GenericId {
  get resource() {
    return "edb";
  }
  get resourceType() {
    return "ephemeral_database";
  }
};
var UserInviteId = class extends GenericId {
  get resource() {
    return "ui";
  }
  get resourceType() {
    return "user_invite";
  }
};
var PromptId = class extends GenericId {
  get resource() {
    return "pr";
  }
  get resourceType() {
    return "prompt";
  }
};
var ViewId = class extends GenericId {
  get resource() {
    return "vi";
  }
  get resourceType() {
    return "view";
  }
};

// src/utils.ts
function castIds(rawIds) {
  const idMap = Object.keys(ids_exports).reduce((acc, k) => {
    return {
      ...acc,
      [k.toLowerCase().replace(/[^a-z]/, "")]: ids_exports[k]
    };
  }, {});
  const filteredIds = Object.keys(rawIds).filter(
    (r) => Object.keys(idMap).includes(r.toLowerCase().replace(/[^a-z]/, ""))
  );
  return filteredIds.reduce((acc, k) => {
    return {
      ...acc,
      [k]: rawIds[k] ? idMap[k.toLowerCase().replace(/[^a-z]/, "")].from(rawIds[k]) : void 0
    };
  }, {});
}
function getId(id) {
  const genId = GenericId.from(id, true);
  const resource = genId.resource;
  for (let idOption of Object.values(ids_exports)) {
    const foundId = new idOption();
    if (foundId.resource === resource) {
      return idOption.from(genId, true);
    }
  }
  throw new Error(`No id type found for "${id}"`);
}
function isActorId(id) {
  return id?.resource && (id.resource === new UserId().resource || id.resource === new GuestId().resource || id.resource === new AgentId().resource || id.resource === new ApiKeyId().resource);
}
function isResourceId(id) {
  return id?.resource && (id.resource === new AccountId().resource || id.resource === new EnvironmentId().resource || id.resource === new SpaceId().resource);
}
function isId(id) {
  try {
    getId(id);
    return true;
  } catch (e) {
    return false;
  }
}

var md5 = {exports: {}};

var crypt = {exports: {}};

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt$1 = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt$1.rotl(n, 8) & 0x00FF00FF | crypt$1.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt$1.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  crypt.exports = crypt$1;
})();

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

var charenc_1 = charenc;

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
var isBuffer_1 = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
};

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

(function(){
  var crypt$1 = crypt.exports,
      utf8 = charenc_1.utf8,
      isBuffer = isBuffer_1,
      bin = charenc_1.bin,

  // The core
  md5$1 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    // else, assume byte array already

    var m = crypt$1.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5$1._ff,
        GG = md5$1._gg,
        HH = md5$1._hh,
        II = md5$1._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt$1.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5$1._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5$1._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5$1._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5$1._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5$1._blocksize = 16;
  md5$1._digestsize = 16;

  md5.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt$1.wordsToBytes(md5$1(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt$1.bytesToHex(digestbytes);
  };

})();

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Filter: () => Filter,
  rangeOptionsToRangeQuery: () => rangeOptionsToRangeQuery,
  rangeQueryToRangeOptions: () => rangeQueryToRangeOptions
});
var dist = __toCommonJS(src_exports);

// src/interpreter.ts
var ohm = __toESM(ohm$1);
var InvalidSyntaxError = class extends Error {
  constructor(m) {
    super(`Invalid query syntax at '${m}'`);
  }
};
var grammar2 = ohm.grammar(`
  FFQL {
    ExpressionChain (an Expression, or a LogicalExpression, or an ExpressionChain)
      = ExpressionChain operator_logical LogicalExpression --logical
      | ExpressionChain operator_logical Expression --base
      | ExpressionChain operator_logical ExpressionChain --chained
      | Wrapped<ExpressionChain>
      | LogicalExpression
      | Expression
      
    LogicalExpression (two expressions with a logical operator in between)
      = Wrapped<LogicalExpression>
      | Expression operator_logical Expression --unwrapped
      
    Expression
      = Wrapped<Sequence>
      | Sequence
      
    Wrapped<Exp> = "(" Exp ")"
      
    Sequence (two terms with an operator in between, or just an operator followed by a term for keyless)
      = term operator_data term --unwrapped
      | operator_data term --keyless_term
      | term operator_message status --status
      | operator_message status --keyless_status
      
    operator (an operator)
      = ("eq" | "ne" | "gte" | "gt" | "lte" | "lt" | "like" | "ilike" | "contains") --data
      | ("and" | "or") --logical
      | "is" --message
      
    status (status options)
      = "error" | "valid"
      | quote status quote --quoted
      | quote_single status quote_single --quoted_single
  
    term (a word or multiple words wrapped in quotes)
      = character+
      | quote (character | space | "(" | ")" | "\\'")+ quote --quoted
      | quote_single (character | space | "(" | ")" | "\\"")+ quote_single --quoted_single
      | quote quote --empty
      | quote_single quote_single --empty_single

    quote 
      = "\\""
    quote_single
      = "\\'"
    
    character (allowed characters)
      = digit | letter | "!" | "#".."&" | "*".."/" | ":".."@" | "[".."_" | "{".."~" | "\xA1".."\xFF" | "\u0100".."\u017F" | "\u0180".."\u0233"
  }
`);
var semantics = grammar2.createSemantics();
semantics.addOperation("interpret", {
  Wrapped(_, exp, __) {
    return exp.interpret();
  },
  ExpressionChain_logical(expChain, op, expLogical) {
    return {
      type: "LOGICAL",
      operator: op.parse(),
      values: [expChain.interpret(), expLogical.interpret()]
    };
  },
  ExpressionChain_base(expChain, op, exp) {
    const f = expChain.interpret();
    const operator = op.parse();
    if (f.operator === operator) {
      f.values.push(exp.interpret());
      return f;
    }
    return {
      type: "LOGICAL",
      operator,
      values: [expChain.interpret(), exp.interpret()]
    };
  },
  ExpressionChain_chained(expChain1, op, expChain2) {
    return {
      type: "LOGICAL",
      operator: op.parse(),
      values: [expChain1.interpret(), expChain2.interpret()]
    };
  },
  LogicalExpression_unwrapped(exp1, op, exp2) {
    return {
      type: "LOGICAL",
      operator: op.parse(),
      values: [exp1.interpret(), exp2.interpret()]
    };
  },
  Sequence_unwrapped(t1, op, t2) {
    const [field, operator, value] = [t1, op, t2].map((a) => a.parse());
    return {
      type: "DATA",
      field,
      operator,
      value
    };
  },
  Sequence_status(t1, op, t2) {
    const [field, operator, status] = [t1, op, t2].map((a) => a.parse());
    return {
      type: "MESSAGE",
      field,
      operator,
      status
    };
  },
  Sequence_keyless_term(op, t2) {
    const [operator, value] = [op, t2].map((a) => a.parse());
    return {
      type: "DATA",
      operator,
      value
    };
  },
  Sequence_keyless_status(op, t2) {
    const [operator, status] = [op, t2].map((a) => a.parse());
    return {
      type: "MESSAGE",
      operator,
      status
    };
  }
});
var quotes = ['"', "'"];
semantics.addOperation("parse", {
  term_quoted(_, t, __) {
    return t.sourceString;
  },
  term_quoted_single(_, t, __) {
    return t.sourceString;
  },
  term_empty(_, __) {
    return null;
  },
  term_empty_single(_, __) {
    return null;
  },
  term(t) {
    return quotes.some((q) => t.sourceString.includes(q)) ? t.parse() : t.sourceString;
  },
  status_quoted(_, s, __) {
    return s.sourceString;
  },
  status_quoted_single(_, s, __) {
    return s.sourceString;
  },
  status(s) {
    return quotes.some((q) => s.sourceString.includes(q)) ? s.parse() : s.sourceString;
  },
  operator_data(o) {
    return o.sourceString;
  },
  operator_logical(o) {
    return o.sourceString;
  },
  operator_message(o) {
    return o.sourceString;
  }
});
var interpret = (query) => {
  const matchResult = grammar2.match(query);
  if (matchResult.failed()) {
    const failurePosition = matchResult.getRightmostFailurePosition();
    const failureString = query.slice(failurePosition);
    throw new InvalidSyntaxError(failureString);
  }
  return semantics(matchResult).interpret();
};

// src/sql/drivers/knex.ts
var import_api = require$$1;
var import_id = dist$1;
var import_md5 = __toESM(md5.exports);
function applyFilterToKnex(qb, f, args) {
  const { filter, sorts, version, range } = f;
  if (filter) {
    const filteringQuery = args.writer.queryBuilder();
    applyTFilterToKnex(filteringQuery, filter, args);
    qb.whereIn("id", filteringQuery);
  }
  if (sorts) {
    sorts.forEach((s) => {
      qb.orderBy(s.field, s.sort);
    });
  }
  if (version) {
    const versionId = import_id.VersionId.from(version.value);
    if (version.mode === "head") {
      switch (version.type) {
        case "branch":
          throw new Error("branch not implemented");
        case "commit":
          throw new Error("commit not implemented");
        case "legacy-version":
          if (versionId) {
            qb.where("version_id", "=", versionId.key);
          }
          break;
      }
    } else if (version.mode === "changes") {
      switch (version.type) {
        case "branch":
          throw new Error("branch not implemented");
        case "commit":
          throw new Error("commit not implemented");
        case "legacy-version":
          if (versionId) {
            qb.where("version_id", "=", versionId.key);
          }
          break;
      }
    }
  }
}
function applyTFilterToKnex(qb, f, args) {
  const {
    writer,
    schema,
    errorsQuery,
    getErroredRecordIdsQuery,
    getNumericValueOrNull
  } = args;
  if (f.type === "LOGICAL") {
    if (f.operator === "or") {
      const oq = writer.queryBuilder().select("id");
      for (let i = 0; i < f.values.length; i++) {
        const fq = writer.queryBuilder();
        applyTFilterToKnex(fq, f.values[i], args);
        oq.union(fq);
      }
      qb.select("id").fromRaw(
        writer.raw(oq).wrap("(", ") as _" + (0, import_md5.default)(oq.toString()))
      );
    } else if (f.operator === "and") {
      const oq = writer.queryBuilder().select("id");
      for (let i = 0; i < f.values.length; i++) {
        const fq = writer.queryBuilder();
        applyTFilterToKnex(fq, f.values[i], args);
        oq.intersect(fq);
      }
      qb.select("id").fromRaw(
        writer.raw(oq).wrap("(", ") as _" + (0, import_md5.default)(oq.toString()))
      );
    }
  } else if (f.type === "DATA") {
    qb.distinct("id").from("data");
    let fieldSchema;
    if (f.field && !schema) {
      qb.where("key", "=", f.field);
    } else if (f.field && schema) {
      const isKey = schema.find((s) => s.key === f.field);
      const isLabelFor = schema.find(
        (s) => s.label && s.label.toLowerCase() === f.field?.toLowerCase()
      );
      fieldSchema = isKey ?? isLabelFor;
      if (isKey) {
        qb.where("key", "=", f.field);
      } else if (isLabelFor) {
        qb.where("key", "=", isLabelFor.key);
      } else {
        qb.where("key", "=", f.field);
      }
    }
    let col = "value";
    let value = f.value;
    let emptyStringAllowed = true;
    if (fieldSchema && (fieldSchema.type === import_api.NumberPropertyTypeEnum.Number || fieldSchema.type === import_api.DatePropertyTypeEnum.Date)) {
      col = "numeric_value";
      value = getNumericValueOrNull(f.value, fieldSchema.type);
      emptyStringAllowed = false;
    }
    switch (f.operator) {
      case "eq":
        if (value === null) {
          if (emptyStringAllowed) {
            qb.where((qB) => qB.whereNull(col).orWhere(col, "=", ""));
          } else {
            qb.whereNull(col);
          }
        } else {
          qb.where(col, "=", value);
        }
        break;
      case "ne":
        if (value === null) {
          if (emptyStringAllowed) {
            qb.where((qB) => qB.whereNotNull(col).andWhere(col, "<>", ""));
          } else {
            qb.whereNotNull(col);
          }
        } else {
          qb.where((qB) => qB.whereNull(col).orWhere(col, "<>", value));
        }
        break;
      case "gte":
        qb.where(col, ">=", value);
        break;
      case "gt":
        qb.where(col, ">", value);
        break;
      case "lt":
        qb.where(col, "<", value);
        break;
      case "lte":
        qb.where(col, "<=", value);
        break;
      case "like":
        qb.where("value", "like", f.value);
        break;
      case "ilike":
        qb.where("value", "ilike", f.value);
        break;
    }
  } else if (f.type === "MESSAGE") {
    qb.distinct("id").from("data");
    const clonedErrorsQuery = errorsQuery.clone();
    if (f.field) {
      clonedErrorsQuery.where("key", "=", f.field);
    }
    const erroredRecords = getErroredRecordIdsQuery(writer, clonedErrorsQuery);
    switch (f.operator) {
      case "is":
        switch (f.status) {
          case "valid":
            if (f.operator === "is") {
              qb.whereNotIn("id", erroredRecords);
            }
            break;
          case "error":
            if (f.operator === "is") {
              qb.whereIn("id", erroredRecords);
            }
            break;
        }
        break;
    }
  }
}

// src/sql/sql.ts
function apply(driver, q, f, args) {
  switch (driver) {
    case "knex":
      applyFilterToKnex(q, f, args);
      break;
    default:
      throw new Error(`Could not find driver '${driver}'`);
  }
}

// src/filter.ts
var Filter = class {
  // Constructors
  constructor(params) {
    this._sorts = [];
    this._rangeOptions = {
      offset: 0,
      limit: 1e3
    };
    if (!params)
      return;
    if (params.filter) {
      this.setFilter(params.filter);
    }
    if (params.sorts) {
      params.sorts.forEach((sort) => {
        this.addSort(sort);
      });
    }
    if (params.version) {
      this.setVersion(params.version);
    }
    if (params.range) {
      this.setRange(params.range);
    }
  }
  static fromQuery(query, data) {
    const filter = interpret(query);
    return new Filter({
      ...data,
      filter
    });
  }
  // Setters - setters must always return 'this' to allow for method chaining
  setFilter(filter) {
    this._filter = filter;
    return this;
  }
  addSort(sort) {
    this._sorts.push(sort);
    return this;
  }
  setVersion(version) {
    this._versionQuery = version;
    return this;
  }
  setRange(range) {
    this._rangeOptions = rangeQueryToRangeOptions(range);
    return this;
  }
  // Getters
  get filter() {
    return this._filter;
  }
  get sorts() {
    return this._sorts;
  }
  get version() {
    return this._versionQuery;
  }
  get range() {
    return this._rangeOptions;
  }
  // Returns a unique list of field keys used in a filter
  get fields() {
    const fields = /* @__PURE__ */ new Set();
    const getFieldKeys = (filter) => {
      switch (filter.type) {
        case "DATA":
        case "MESSAGE":
          if (filter.field) {
            fields.add(filter.field);
          }
          break;
        case "LOGICAL":
          filter.values.forEach((value) => getFieldKeys(value));
          break;
      }
    };
    if (this._filter) {
      getFieldKeys(this._filter);
    }
    this._sorts.forEach((sort) => fields.add(sort.field));
    return [...fields];
  }
  // Presenters
  toSql(q, driver, args) {
    apply(driver, q, this, args);
  }
  // public toUrl(): string {
  //   const params: Array<{ key: string; value: string }> = []
  //
  //   const filterToUrl = (f: TFilter): string => {
  //     if (f.type === 'LOGICAL') {
  //       return `(${f.values.map(filterToUrl).join(` ${f.operator} `)})`
  //     } else if (f.type === 'DATA') {
  //       return `${f.field} ${f.operator} ${f.value}`
  //     } else if (f.type === 'MESSAGE') {
  //       return f.field
  //         ? `${f.field} ${f.operator} ${f.status}`
  //         : `${f.operator} ${f.status}`
  //     }
  //     return ''
  //   }
  //
  //   // Filter
  //   if (this.filter) {
  //     params.push({
  //       key: 'q',
  //       value: filterToUrl(this.filter),
  //     })
  //   }
  //
  //   // // Sorts
  //   // params.push(
  //   //   ...this.sorts.flatMap((f) => [
  //   //     { key: 'sort', value: `${f.field} ${f.sort}` },
  //   //   ])
  //   // )
  //   //
  //   // // Version
  //   // const versionKeyNames: {
  //   //   [x in VersionQueryType]: string
  //   // } = {
  //   //   branch: 'branchId',
  //   //   commit: 'commitId',
  //   //   'legacy-version': 'versionId',
  //   // }
  //   // if (this.version) {
  //   //   let versionKeyName = versionKeyNames[this.version.type]
  //   //   if (this.version.mode == 'changes') {
  //   //     versionKeyName =
  //   //       'since' + versionKeyName[0].toUpperCase() + versionKeyName.slice(1)
  //   //   }
  //   //   params.push({ key: versionKeyName, value: this.version.value })
  //   // }
  //   //
  //   // // Pagination
  //   // const paginationOptions = rangeOptionsToRangeQuery(this.range)
  //   // params.push(
  //   //   { key: 'pageSize', value: `${paginationOptions.pageSize}` },
  //   //   { key: 'pageNumber', value: `${paginationOptions.pageNumber}` }
  //   // )
  //
  //   // Encodes a URI component based on RFC3986. See https://datatracker.ietf.org/doc/html/rfc3986
  //   const encodeRFC3986URIComponent = (str: string): string => {
  //     return encodeURIComponent(str).replace(
  //       /[!'()*]/g,
  //       (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
  //     )
  //   }
  //
  //   return params
  //     .map((p) => `${p.key}=${encodeRFC3986URIComponent(p.value)}`)
  //     .join('&')
  // }
};
function rangeQueryToRangeOptions(query) {
  return {
    offset: query.pageNumber * query.pageSize - query.pageSize,
    limit: query.pageSize
  };
}
function rangeOptionsToRangeQuery(options) {
  return {
    pageSize: options.limit,
    pageNumber: Math.ceil(options.offset / options.limit) + 1
  };
}

const getQueryFields = async (query) => {
    try {
        return dist.Filter.fromQuery(query).fields;
    }
    catch (e) {
        return [];
    }
};
const isQueryValid = async (query) => {
    try {
        dist.Filter.fromQuery(query);
        return true;
    }
    catch (e) {
        return false;
    }
};

function safeGet(obj, path) {
    if (!obj) {
        return undefined;
    }
    for (const key of path) {
        if (Object.hasOwnProperty.call(obj, key) && !!obj[key]) {
            obj = obj[key];
        }
        else {
            return undefined;
        }
    }
    return obj;
}

const temporaryStorageData = {};
const temporaryStorage = {
    getItem(key) {
        if (key in temporaryStorageData) {
            return temporaryStorageData[key];
        }
        return undefined;
    },
    removeItem(key) {
        delete temporaryStorageData[key];
    },
    setItem(key, value) {
        temporaryStorageData[key] = value;
    },
};
/* c8 ignore start */
const getStorageEngine = () => {
    try {
        return typeof localStorage === 'object' ? localStorage : temporaryStorage;
    }
    catch (error) {
        console.error(error);
    }
    return temporaryStorage;
};
/* c8 ignore stop */
let storageEngine = getStorageEngine();
const storage = (key) => ({
    clear() {
        storageEngine.removeItem(key);
    },
    exists() {
        const data = storageEngine.getItem(key);
        return typeof data === 'string' && data.length > 0;
    },
    get() {
        const item = storageEngine.getItem(key);
        return item === null ? undefined : item;
    },
    set(data) {
        if (data === undefined) {
            return this.clear();
        }
        storageEngine.setItem(key, data);
    },
    useTemporaryStorage() {
        storageEngine = temporaryStorage;
    },
});

function isEmpty(arr) {
    return !arr || arr.length === 0;
}

function handleSpecialObjects(value) {
    if (value instanceof Response) {
        return extractResponse(value);
    }
    if (value instanceof Error) {
        return extractError(value);
    }
    if (value instanceof Map) {
        return extractMap(value);
    }
    if (value instanceof Set) {
        return extractSet(value);
    }
    if (value instanceof Promise) {
        return 'Promise';
    }
    return recursiveExtract(value);
}
function extractResponse(response) {
    return {
        status: response.status,
        statusText: response.statusText,
        url: response.url,
        headers: [...response.headers.entries()],
        bodyUsed: response.bodyUsed,
        ok: response.ok,
        redirected: response.redirected,
        type: response.type,
    };
}
function extractError(error) {
    return {
        message: error.message,
        stack: error.stack,
        name: error.name,
    };
}
function extractMap(map) {
    return {
        type: 'Map',
        entries: [...map.entries()],
    };
}
function extractSet(set) {
    return {
        type: 'Set',
        values: [...set.values()],
    };
}
function serializeObject(error) {
    return recursiveExtract(error);
}
function doNotExtract(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        typeof value === 'symbol' ||
        typeof value === 'bigint' ||
        typeof value === 'function' ||
        value === null ||
        value === undefined);
}
function recursiveExtract(error) {
    if (error === null || error === undefined) {
        return error;
    }
    try {
        if (Array.isArray(error)) {
            return error.map((item) => doNotExtract(item) ? item : recursiveExtract(item));
        }
        let extracted = {};
        const properties = Object.getOwnPropertyNames(error);
        for (const key of properties) {
            const value = error[key];
            if (doNotExtract(value)) {
                extracted[key] = value;
            }
            else if (typeof value === 'object') {
                extracted[key] =
                    Object.keys(value).length === 0 ? {} : handleSpecialObjects(value); //preserve empty objects
            }
        }
        return extracted;
    }
    catch (e) {
        return error;
    }
}
/**
 * Logger class for logging messages to console or Datadog.
 */
class Logger {
    isLocal;
    datadogLogger;
    /**
     * Creates an instance of Logger.
     * @param isLocal - Indicates if the logger should log to console (true) or Datadog (false).
     * @param datadogLogger - The datadogLogs instance to use for logging.
     */
    constructor(isLocal, datadogLogger) {
        this.isLocal = isLocal;
        this.datadogLogger = datadogLogger;
    }
    /**
     * Logs a message with a specified log level and optional object.
     * @param message - The message to log.
     * @param level - The log level ('info', 'warn', 'error').
     * @param object - Optional object to log.
     */
    log(message, level = 'info', object) {
        if (this.isLocal) {
            this.consoleLog(message, level, object);
        }
        else {
            this.datadogLog(message, level, object);
        }
    }
    /**
     * Logs an info message.
     * @param message - The message to log.
     * @param object - Optional object to log.
     */
    info(message, object) {
        this.log(message, 'info', object);
    }
    /**
     * Logs a warning message.
     * @param message - The message to log.
     * @param object - Optional object to log.
     */
    warn(message, object) {
        this.log(message, 'warn', object);
    }
    /**
     * Logs an error message.
     * @param message - The message to log.
     * @param object - Optional object to log.
     */
    error(message, object) {
        this.log(message, 'error', object);
    }
    /**
     * Sets the context for the Datadog logger.
     * @param context - The context to set.
     */
    setContext(context) {
        if (this.datadogLogger) {
            this.datadogLogger.setContext(context);
        }
        else {
            console.warn('Datadog logger instance is not defined');
        }
    }
    consoleLog(message, level, object) {
        if (object) {
            // eslint-disable-next-line no-console
            console[level](message, { logData: serializeObject(object) });
        }
        else {
            // eslint-disable-next-line no-console
            console[level](message);
        }
    }
    datadogLog(message, level, object) {
        if (this.datadogLogger) {
            const logData = object ? { logData: serializeObject(object) } : {};
            this.datadogLogger[level](message, logData);
        }
        else {
            console.warn('Datadog logs instance is not defined');
        }
    }
}

const logPaintMetrics = (posthog, name) => {
    const logPaintTime = (type, time) => {
        try {
            posthog.capture(`${name} ${type}`, {
                time: `${time}ms`,
                url: window.location.href,
            });
        }
        catch (error) {
            return;
        }
    };
    const paintObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
            if (entry.name === 'fcp' && !sessionStorage.getItem('fcpLogged')) {
                const duration = performance.measure('First Contentful Paint', 'app_start', 'fcp').duration;
                logPaintTime('First Contentful Paint', duration);
                sessionStorage.setItem('fcpLogged', 'true');
            }
            else if (entry.name === 'fmp' && !sessionStorage.getItem('fmpLogged')) {
                const duration = performance.measure('First Meaningful Paint', 'app_start', 'fmp').duration;
                logPaintTime('First Meaningful Paint', duration);
                sessionStorage.setItem('fmpLogged', 'true');
            }
            // Disconnect observer if both FCP and FMP have been logged
            if (sessionStorage.getItem('fcpLogged') &&
                sessionStorage.getItem('fmpLogged')) {
                paintObserver.disconnect();
            }
        }
    });
    // Start observing immediately
    paintObserver.observe({ type: 'mark', buffered: true });
    // Clean up the observer after 10 seconds if FCP and FMP haven't been logged (we should at least expect a loading state in this time)
    setTimeout(() => {
        if (!sessionStorage.getItem('fcpLogged') &&
            !sessionStorage.getItem('fmpLogged')) {
            paintObserver.disconnect();
        }
    }, 10000);
    // Clear the logged flags when the page is about to unload (refresh or close)
    window.addEventListener('beforeunload', () => {
        sessionStorage.removeItem('fcpLogged');
        sessionStorage.removeItem('fmpLogged');
    });
};

export { CheckmarkIcon, CodeSnippet, DurationBar, EventLogDetail, FREE_FILE_LIMIT, FREE_PDV_LIMIT, HelloShared, InfoIcon, Logger, Panel, PanelContent, PanelItem, PanelSectionHeader, PopoverContext, PopoverMessage, PopoverMessageFullWidth, PopoverMessageWrapper, PopoverProvider, SecretsList, Status, UsageBanner, WarningIcon, copyToClipboard, fromMaybe, getQueryFields, isEmpty, isQueryValid, logPaintMetrics, msToSeconds, safeGet, storage, useBillingAndUsageAccess, usePopover };
//# sourceMappingURL=index.esm.js.map
